webpackJsonp([1],[
/* 0 */,
/* 1 */,
/* 2 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export showError */
/* unused harmony export getModel */
/* unused harmony export extendData */
/* unused harmony export createDataStore */
/* unused harmony export commonAjax */
/* unused harmony export commonTableDateFetch */
/* unused harmony export mvcParamMatch */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(154);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(155);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify__ = __webpack_require__(329);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_jquery__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_common_mc_lib__ = __webpack_require__(78);




/**
 * 工具方法类
 */




/**
 * 显示错误提示文字
 * @version 1.0
 * @param {string} msg 提示文字
 */
var showError = function showError(msg) {
  if (msg.length > 100) {
    msg = '系统错误, 请稍后重试';
  }
  this.$message.error(msg);
};

/**
 * 获得纯净的数据模型
 * @version 1.0
 * @param {object} obj 待处理对象
 */
var getModel = function getModel(obj) {
  return JSON.parse(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify___default()(obj));
};

/**
 * 合并新数据到默认数据
 * @version 1.0
 * @param {*} defaultData 默认数据
 * @param {*} newData 新数据
 */
var extendData = function extendData(defaultData, newData) {
  return __WEBPACK_IMPORTED_MODULE_4_jquery___default.a.extend(true, defaultData, getModel(newData));
};

/**
 * 创建数据仓库
 * @version 1.0
 * @param {object} defaultData 默认数据
 */
var createDataStore = function createDataStore(defaultData) {
  var Store = function () {
    function Store() {
      var _this2 = this;

      __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, Store);

      this.data = defaultData;

      this.getDefaultData = function () {
        return __WEBPACK_IMPORTED_MODULE_4_jquery___default.a.extend(true, {}, typeof _this2.data === 'function' ? _this2.data() : _this2.data);
      };
    }

    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(Store, [{
      key: 'setDefaultData',
      value: function setDefaultData(data) {
        this.data = data;
      }
    }]);

    return Store;
  }();

  return new Store();
};

/**
 * 常用请求
 * @version 1.5
 * @param {boolean} hasLoading 是否有请求Loading
 * @param {string} url 请求地址
 * @param {object} data 请求数据
 */
var commonAjax = function commonAjax(hasLoading) {
  var url = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
  var data = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var hasFailTip = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : true;

  var _hasLoading = void 0,
      _loadingType = void 0;
  if (typeof hasLoading === 'boolean') {
    _hasLoading = !!hasLoading;
    _loadingType = 1;
  } else if (typeof hasLoading === 'number') {
    _hasLoading = true;
    _loadingType = hasLoading;
  }
  var _this = this;
  return __WEBPACK_IMPORTED_MODULE_5__components_common_mc_lib__["a" /* default */].Ajax({
    url: url,
    data: data,
    hasLoading: _hasLoading,
    loadingType: _loadingType,
    fail: function fail(response) {
      hasFailTip && showError.call(_this, response.description);
    },
    error: function error() {
      hasFailTip && showError.call(_this, '网络错误, 请稍后重试');
    }
  });
};

/**
 * 常用表格数据获取函数
 * @param {object} option 配置项
 */
var commonTableDateFetch = function commonTableDateFetch(option) {
  return function (pageIndex) {
    var _this = this;
    this.table.isLoading = true;
    return __WEBPACK_IMPORTED_MODULE_5__components_common_mc_lib__["a" /* default */].Ajax({
      url: option.url,
      data: __WEBPACK_IMPORTED_MODULE_4_jquery___default.a.extend({
        pageIndex: pageIndex || 1,
        pageSize: this.table.pageSize
      }, this.table && this.table.ajaxData, option.data && option.data.call(_this)),
      success: function success(response) {
        option.success && option.success.call(_this, response);
        _this.table.currentPage = pageIndex;
        _this.table.pageTotal = response.total;
        _this.table.isLoading = false;
      },
      fail: function fail(response) {
        option.fail && option.fail.call(_this, response);
        showError.call(_this, response.description);
        _this.table.isLoading = false;
      }
    });
  };
};

var mvcParamMatch = function () {
  var MvcParameterAdaptive = {};
  // 验证是否为数组
  MvcParameterAdaptive.isArray = Function.isArray || function (o) {
    return (typeof o === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(o)) === 'object' && Object.prototype.toString.call(o) === '[object Array]';
  };

  // 将数组转换为对象
  MvcParameterAdaptive.convertArrayToObject = function (arrName, array, saveOjb) {
    var obj = saveOjb || {};

    function func(name, arr) {
      for (var i in arr) {
        if (!MvcParameterAdaptive.isArray(arr[i]) && __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(arr[i]) === 'object') {
          for (var j in arr[i]) {
            if (MvcParameterAdaptive.isArray(arr[i][j])) {
              func(name + '[' + i + '].' + j, arr[i][j]);
            } else if (__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(arr[i][j]) === 'object') {
              MvcParameterAdaptive.convertObject(name + '[' + i + '].' + j + '.', arr[i][j], obj);
            } else {
              obj[name + '[' + i + '].' + j] = arr[i][j];
            }
          }
        } else {
          obj[name + '[' + i + ']'] = arr[i];
        }
      }
    }

    func(arrName, array);

    return obj;
  };

  MvcParameterAdaptive.convertObject = function (objName, turnObj, saveOjb) {
    var obj = saveOjb || {};

    function func(name, tobj) {
      for (var i in tobj) {
        if (MvcParameterAdaptive.isArray(tobj[i])) {
          MvcParameterAdaptive.convertArrayToObject(i, tobj[i], obj);
        } else if (__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(tobj[i]) === 'object') {
          func(name + i + '.', tobj[i]);
        } else {
          obj[name + i] = tobj[i];
        }
      }
    }

    func(objName, turnObj);
    return obj;
  };

  return function (json, arrName) {
    arrName = arrName || '';
    if ((typeof json === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(json)) !== 'object') throw new Error('请传入json对象');
    if (MvcParameterAdaptive.isArray(json) && !arrName) throw new Error('请指定数组名，对应Action中数组参数名称！');

    if (MvcParameterAdaptive.isArray(json)) {
      return MvcParameterAdaptive.convertArrayToObject(arrName, json);
    }
    return MvcParameterAdaptive.convertObject('', json);
  };
}();

/* harmony default export */ __webpack_exports__["a"] = ({
  getModel: getModel,
  extendData: extendData,
  createDataStore: createDataStore,
  commonAjax: commonAjax,
  commonTableDateFetch: commonTableDateFetch,
  mvcParamMatch: mvcParamMatch
});

/***/ }),
/* 3 */,
/* 4 */,
/* 5 */,
/* 6 */,
/* 7 */,
/* 8 */,
/* 9 */,
/* 10 */,
/* 11 */,
/* 12 */,
/* 13 */,
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(597)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(288),
  /* template */
  __webpack_require__(736),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 15 */,
/* 16 */,
/* 17 */,
/* 18 */,
/* 19 */,
/* 20 */,
/* 21 */,
/* 22 */,
/* 23 */,
/* 24 */,
/* 25 */,
/* 26 */,
/* 27 */,
/* 28 */,
/* 29 */,
/* 30 */,
/* 31 */,
/* 32 */,
/* 33 */,
/* 34 */,
/* 35 */,
/* 36 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export TreeCreate */
/* unused harmony export changeLRTreeToTreeData */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(154);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__(155);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_jquery__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_underscore__ = __webpack_require__(149);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_underscore___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_underscore__);





var TreeCreate = function () {
  function TreeCreate(treeNode, treeConfig) {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, TreeCreate);

    this.treeNode = treeNode;
    this.treeConfig = __WEBPACK_IMPORTED_MODULE_2_jquery___default.a.extend({
      FId: 'pid',
      Id: 'id',
      rootId: '0'
    }, treeConfig);
    this.treeData = []; // 树状的树数据
    this.flatTreeData = []; // 扁平的树数据
  }
  // 树生成, 递归调用


  __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(TreeCreate, [{
    key: 'createTree',
    value: function createTree(TreeNode, config, data, parent, _level, saveParent) {
      var treeData = void 0,
          flatTreeData = void 0,
          level = void 0,
          childLevel = void 0,
          pid = void 0;
      treeData = [];
      flatTreeData = [];
      level = _level;
      childLevel = _level + 1;
      var i, l, val;
      for (i = 0, l = data.length; i < l; i++) {
        val = data[i];
        if (parent === null) {
          pid = config.rootId;
        } else {
          pid = parent[config.Id];
        }
        if (val[config.FId] === pid) {
          var t = {
            _expanded: true,
            _show: true,
            _level: level
          };
          if (saveParent) {
            t['_parent'] = parent;
          }
          TreeNode.call(t, val);
          var child = this.createTree(TreeNode, config, data, __WEBPACK_IMPORTED_MODULE_2_jquery___default.a.extend(t, val), childLevel, saveParent);
          treeData.push(t);
          flatTreeData.push(t);
          if (child.treeData.length > 0) {
            treeData[treeData.length - 1].children = child.treeData;
            flatTreeData.push.apply(flatTreeData, child.flatTreeData);
          } else {
            treeData[treeData.length - 1].children = [];
          }
        }
      }
      return {
        treeData: treeData,
        flatTreeData: flatTreeData
      };
    }
    // 生成树

  }, {
    key: 'create',
    value: function create(data, saveParent) {
      var result = this.createTree(this.treeNode, this.treeConfig, data, null, 0, saveParent);
      this.treeData = result.treeData;
      this.flatTreeData = result.flatTreeData;
    }
    // 获取树状的树数据(深拷贝)

  }, {
    key: 'getTreeData',
    value: function getTreeData() {
      return __WEBPACK_IMPORTED_MODULE_2_jquery___default.a.extend(true, [], this.treeData);
    }
    // 获取树状的树数据(浅拷贝)

  }, {
    key: 'getTreeDataNoDeep',
    value: function getTreeDataNoDeep() {
      return __WEBPACK_IMPORTED_MODULE_2_jquery___default.a.extend([], this.treeData);
    }
    // 获取扁平的树数据(深拷贝)

  }, {
    key: 'getFlatTreeData',
    value: function getFlatTreeData() {
      return __WEBPACK_IMPORTED_MODULE_2_jquery___default.a.extend(true, [], this.flatTreeData);
    }
    // 获取扁平的树数据(浅拷贝)

  }, {
    key: 'getFlatTreeDataNoDeep',
    value: function getFlatTreeDataNoDeep() {
      return __WEBPACK_IMPORTED_MODULE_2_jquery___default.a.extend([], this.flatTreeData);
    }
  }]);

  return TreeCreate;
}();

// 转换左右值树数据为一父节点树的数据
var changeLRTreeToTreeData = function changeLRTreeToTreeData(data, codeName, layerStr) {
  layerStr = layerStr || 'OrganizationLayer';
  codeName = codeName || 'OgCode';
  var qq = __WEBPACK_IMPORTED_MODULE_3_underscore___default.a.toArray(__WEBPACK_IMPORTED_MODULE_3_underscore___default.a.groupBy(data, layerStr));
  // 如果没自己.slice(1),最后生成绑定到0
  qq.forEach(function (list, i) {
    if (i === qq.length - 1) return true;
    var nextList = qq[i + 1];
    list.forEach(function (item, k) {
      item.children = [];
      nextList.forEach(function (nextItem) {
        if (nextItem.LeftNum > item.LeftNum && nextItem.RightNum < item.RightNum) {
          nextItem.pid = item[codeName];
          item.children.push(nextItem);
        }
      });
    });
  });
  qq[qq.length - 1].forEach(function (item, i) {
    item.children = [];
  });

  var r = qq[0];
  r[0].pid = '';
  return r;
};

/* harmony default export */ __webpack_exports__["a"] = ({
  TreeCreate: TreeCreate,
  changeLRTreeToTreeData: changeLRTreeToTreeData
});

/***/ }),
/* 37 */,
/* 38 */,
/* 39 */,
/* 40 */,
/* 41 */,
/* 42 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(609)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(286),
  /* template */
  __webpack_require__(753),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 43 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(615)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(289),
  /* template */
  __webpack_require__(762),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 44 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var isProduction = "production" === 'production';

/**
 * 项目配置项
 */
/* harmony default export */ __webpack_exports__["a"] = ({
  ProjectName: 'common_web',
  AjaxUrl: isProduction ? '' : 'http://114.55.141.145:8304/',
  // 导航分组
  navGroup: [{
    groupCode: 0,
    label: 'Content Manage',
    href: '/Welcome'
  }, {
    groupCode: 1,
    label: 'System Manage',
    href: '/AdminUserInfo'
  }]
});

/***/ }),
/* 45 */,
/* 46 */,
/* 47 */,
/* 48 */,
/* 49 */,
/* 50 */,
/* 51 */,
/* 52 */,
/* 53 */,
/* 54 */,
/* 55 */,
/* 56 */,
/* 57 */,
/* 58 */,
/* 59 */,
/* 60 */,
/* 61 */,
/* 62 */,
/* 63 */,
/* 64 */,
/* 65 */,
/* 66 */,
/* 67 */,
/* 68 */,
/* 69 */,
/* 70 */,
/* 71 */,
/* 72 */,
/* 73 */,
/* 74 */,
/* 75 */,
/* 76 */,
/* 77 */,
/* 78 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Ajax */
/* unused harmony export Guid */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_common_config__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_common_user__ = __webpack_require__(80);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui__ = __webpack_require__(102);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_element_ui__);
/**
 * 通用库函数
 */




// import tools from '@/components/common/tools'


var isAjaxing = [];
/**
 * 通用请求函数
 * @version 2.0
 * @param {object} options 配置项
 */
var Ajax = function Ajax(options) {
  var $pageLoadingWrap = __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#page_loading_wrap');
  var ajaxDef = __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.Deferred();
  var settings = __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.extend({
    id: Guid(16), // ajax的id
    hasLoading: false, // 是否有loading
    loadingType: 0, // 0 - 全面loading, 1 - 页面内loading
    confirmTitle: false, // 是否有确认框
    api: true,
    url: '',
    data: {},
    type: 'post',
    async: true,
    timeout: 0,
    processData: true, // 序列化数据,formdata的时候需要false
    success: function success() {}, // 请求成功回调 [resultData, msg, textStatus]
    fail: function fail() {}, // 请求失败回调 [errorMsg, msg, textStatus]
    error: function error() {}, // 请求错误回调
    complete: function complete() {}, // 请求结束回调
    beforeSend: function beforeSend() {}
  }, options);
  var loadingTimeout = void 0,
      loadingInstance = void 0;
  var showLoading = function showLoading() {
    if (settings.hasLoading) {
      if (settings.loadingType === 0) {
        // 全屏loading
        loadingInstance = __WEBPACK_IMPORTED_MODULE_3_element_ui__["Loading"].service({
          fullscreen: true
        });
      } else if (settings.loadingType === 1) {
        // 页面内loading
        $pageLoadingWrap.show();
        loadingInstance = __WEBPACK_IMPORTED_MODULE_3_element_ui__["Loading"].service({
          target: $pageLoadingWrap[0],
          fullscreen: false
        });
      }
    }
  };
  var closeLoading = function closeLoading() {
    if (settings.hasLoading && loadingInstance) {
      loadingInstance.close();
      loadingInstance = null;
      if (settings.loadingType === 1) {
        // 页面内loading
        $pageLoadingWrap.hide();
      }
    }
  };
  var ajax = function ajax() {
    var ajaxStartTime = null;
    var isError = false;
    __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.ajax({
      url: settings.api ? __WEBPACK_IMPORTED_MODULE_1__components_common_config__["a" /* default */].AjaxUrl + settings.url : settings.url,
      data: __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.extend(settings.data, {
        token: __WEBPACK_IMPORTED_MODULE_2__components_common_user__["a" /* default */].getMemberToken()
      }),
      type: settings.type,
      async: settings.async,
      processData: settings.processData,
      success: function success(response, textStatus) {
        var def = __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.Deferred();
        if (typeof response === 'string') {
          try {
            response = JSON.parse(response);
          } catch (e) {}
        }
        if (settings.hasLoading && ajaxStartTime !== null) {
          // 有 loading 的情况下
          // 500ms 以内的请求不显示 loading, 超时显示 loading
          // loading 持续最少 300ms
          var ajaxTime = new Date().getTime() - ajaxStartTime;
          if (ajaxTime < 500) {
            clearTimeout(loadingTimeout);
            def.resolve();
          } else if (ajaxTime < 900) {
            setTimeout(function () {
              closeLoading();
              def.resolve();
            }, 900 - ajaxTime);
          } else {
            closeLoading();
            def.resolve();
          }
        } else {
          def.resolve();
        }
        def.then(function () {
          isAjaxing[settings.id] = false;
          if (response.issuccess === true) {
            // 返回数据
            settings.success.call(this, response, textStatus);
            ajaxDef.resolve(response);
          } else if (response.issuccess === false) {
            // 请求失败
            settings.fail.call(this, response, textStatus);
            ajaxDef.reject(response);
          } else {
            // response.issuccess 不存在
            settings.success.call(this, response, textStatus);
            ajaxDef.resolve(response);
          }
        });
      },
      error: function error(xhr) {
        isError = true;
        closeLoading();
        isAjaxing[settings.id] = false;
        settings.error.call(this, xhr);
      },
      complete: function complete(xhr) {
        isAjaxing[settings.id] = false;
        settings.complete.call(this, xhr);
      },
      beforeSend: function beforeSend() {
        if (settings.hasLoading) {
          ajaxStartTime = new Date().getTime();
          loadingTimeout = setTimeout(function () {
            if (!isError) {
              showLoading();
            }
          }, 550);
        }
        isAjaxing[settings.id] = true;
        settings.beforeSend.call(this);
      }
    });
  };
  isAjaxing[settings.id] || (isAjaxing[settings.id] = false);
  if (!isAjaxing[settings.id]) {
    ajax();
  }
  return ajaxDef;
};

/**
 * 生成uuid, 默认rfc4122规范
 * @version 1.0
 * @param {number} len 生成的uuid位数, 不传使用rfc4122定义的
 * @param {number} radix 生成范围
 */
var Guid = function Guid(len, radix) {
  var chars = void 0,
      uuid = void 0,
      i = void 0,
      r = void 0;
  chars = '0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz'.split('');
  uuid = [];
  radix = radix || chars.length;
  if (len) {
    // Compact form
    for (i = 0; i < len; i++) {
      uuid[i] = chars[0 | Math.random() * radix];
    }
  } else {
    // rfc4122, version 4 form
    // rfc4122 requires these characters
    uuid[8] = uuid[13] = uuid[18] = uuid[23] = '-';
    uuid[14] = '4';
    // Fill in random data.  At i==19 set the high bits of clock sequence as
    // per rfc4122, sec. 4.1.5
    for (i = 0; i < 36; i++) {
      if (!uuid[i]) {
        r = 0 | Math.random() * 16;
        uuid[i] = chars[i === 19 ? r & 0x3 | 0x8 : r];
      }
    }
  }
  return uuid.join('');
};

/* harmony default export */ __webpack_exports__["a"] = ({
  Ajax: Ajax,
  Guid: Guid
});

/***/ }),
/* 79 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export filter */
/* unused harmony export editorConfig */
/* unused harmony export mobileVerify */
/* unused harmony export addressConfig */
/* unused harmony export verify */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_common_mc_lib__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__assets_data_address_picker_data_js__ = __webpack_require__(240);
var isProduction = "production" === 'production';





var _dateFormat = function _dateFormat(dateStr, formatStr) {
  if (!dateStr || dateStr === '') return '-/-/-';
  var date = new Date(dateStr);
  var map = {
    'M': date.getMonth() + 1, // 月份
    'd': date.getDate(), // 日
    'h': date.getHours(), // 小时
    'm': date.getMinutes(), // 分
    's': date.getSeconds(), // 秒
    'q': Math.floor((date.getMonth() + 3) / 3), // 季度
    'S': date.getMilliseconds() // 毫秒
  };
  formatStr = formatStr.replace(/([yMdhmsqS])+/g, function (all, t) {
    var v = map[t];
    if (v !== undefined) {
      if (all.length > 1) {
        v = '0' + v;
        v = v.substr(v.length - 2);
      }
      return v;
    } else if (t === 'y') {
      return (date.getFullYear() + '').substr(4 - all.length);
    }
    return all;
  });
  return formatStr;
};

/**
 * 通用过滤函数
 */
var filter = {
  filters: {
    codeToText: function codeToText(value, data, defaultTxt) {
      value = value + '';
      var result = void 0;
      if (defaultTxt === undefined) {
        defaultTxt = '请选择';
      }
      if (value && data) {
        result = data.filter(function (item) {
          return item.value + '' === value;
        });
        if (result.length > 0) {
          return result[0].text;
        } else {
          return defaultTxt;
        }
      } else {
        return defaultTxt;
      }
    },
    dateFormat: function dateFormat(dateStr) {
      var formatStr = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'yyyy-MM-dd';

      return _dateFormat(dateStr, formatStr);
    },
    dateFormatPower: function dateFormatPower(dateStr) {
      var date = new Date(dateStr);
      var formatStr = void 0;
      var nowDate = new Date();
      if (date.getFullYear() === nowDate.getFullYear() && date.getMonth() === nowDate.getMonth() && date.getDate() === nowDate.getDate()) {
        formatStr = 'hh:mm';
      } else {
        formatStr = 'MM-dd hh:mm';
      }
      return _dateFormat(dateStr, formatStr);
    }
  },
  methods: {
    codeToText: function codeToText(value, data, defaultTxt) {
      value = value + '';
      var result = void 0;
      defaultTxt = defaultTxt || '';
      if (value && data) {
        result = data.filter(function (item) {
          return item.value === value;
        });
        if (result.length > 0) {
          return result[0].text;
        } else {
          return defaultTxt;
        }
      } else {
        return defaultTxt;
      }
    }
  }

  /**
   * 百度文本编辑器配置项
   */
};var editorConfig = {
  data: function data() {
    return {
      UEditorPath: (isProduction ? '' : 'http://localhost:7178') + '/Content/Include/js/lib/utf8-net/'
    };
  }
};

/**
 * 手机验证码
 */
var mobileVerify = {
  data: function data() {
    return {
      canSendVeify: true,
      verifyTxt: '获取验证码'
    };
  },

  methods: {
    // 验证码倒计时
    verifyCountDown: function verifyCountDown() {
      var _this2 = this;

      var time = 60;
      var countdown = setInterval(function () {
        if (time > 1) {
          time--;
          _this2.verifyTxt = time + '\u79D2';
        } else {
          _this2.verifyTxt = '获取验证码';
          clearInterval(countdown);
          _this2.canSendVeify = true;
        }
      }, 1000);
    },

    // 获取验证码
    sendVerifyCode: function sendVerifyCode(mobile) {
      var _this = this;
      if (mobile && this.canSendVeify) {
        this.canSendVeify = false;
        __WEBPACK_IMPORTED_MODULE_1__components_common_mc_lib__["a" /* default */].Ajax({
          url: '/User/GetVerifycode',
          data: {
            Telephone: mobile
          },
          success: function success(response) {
            _this.$message.success('发送成功');
            _this.verifyCountDown();
            // 测试代码 - 自动填写验证码
            // _this.updateForm.VcCode = response.description
          },
          fail: function fail(response) {
            _this.$message.error(response.description);
            _this.canSendVeify = true;
          }
        });
      }
    }
  }

  /**
   * 地址选择
   */
};var addressConfig = {
  data: function data() {
    return {
      addressProp: {
        label: 'name',
        value: 'code',
        children: 'children'
      },
      addressData: __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.extend(true, [], __WEBPACK_IMPORTED_MODULE_2__assets_data_address_picker_data_js__["a" /* mcAddressData */]) // 省市区数据
    };
  }
};

// /**
//  * 地址选择，除去中国全境，全省，全市
//  */
// export const addressConfigWithoutAll = {
//   data() {
//     return {
//       addressProp: {
//         label: 'name',
//         value: 'code',
//         children: 'children'
//       },
//       addressData: (() => {
//         let addressData = mcAddressData.filter(i => {
//           if (i.children && i.children.length > 0) {
//             i.children = i.children.filter(j => {
//               if (j.children && j.children.length > 0) {
//                 j.children = j.children.filter(k => k.code !== '-1')
//                 if (j.children.length === 0) delete j.children
//               }
//               return j.code !== '-1'
//             })
//             if (i.children.length === 0) delete i.children
//           }
//           return i.code !== '-1'
//         })
//         return addressData
//       })() // 省市区数据
//     }
//   }
// }

/**
 * 验证码混合对象
 */
var verify = {
  data: function data() {
    return {};
  },

  methods: {
    required: function required(msg) {
      var type = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'string';

      return {
        type: type,
        required: true,
        validator: function validator(rule, value, callback) {
          value = value + '';
          if (!value.trim()) {
            callback(new Error('\u8BF7\u8F93\u5165' + msg));
          } else {
            callback();
          }
        },

        trigger: 'blur'
      };
    },
    requiredCheck: function requiredCheck(msg) {
      return {
        type: 'array',
        required: true,
        message: '\u8BF7\u81F3\u5C11\u9009\u62E9\u4E00\u9879' + msg,
        trigger: 'change'
      };
    },
    requiredSelect: function requiredSelect(msg) {
      var type = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'string';

      return {
        type: type,
        required: true,
        message: '\u8BF7\u9009\u62E9' + msg,
        trigger: 'change'
      };
    },

    // 类型验证
    check: function check(type, msg) {
      return {
        type: type,
        required: true,
        message: '\u8BF7\u8F93\u5165\u6B63\u786E\u7684' + msg,
        trigger: 'blur'
      };
    },

    // 手机号验证
    checkMobile: function checkMobile(msg) {
      return {
        required: true,
        validator: function validator(rule, value, callback) {
          if (!/^(0|86|17951)?1(3[0-9]|4[57]|5[0-35-9]|7[0135678]|8[0-9])\d{8}$/.test(value)) {
            callback(new Error('\u8BF7\u8F93\u5165\u6B63\u786E\u7684' + msg));
          } else {
            callback();
          }
        },

        trigger: 'blur'
      };
    },

    // 身份证验证码
    checkIdcrad: function checkIdcrad(msg) {
      return {
        required: true,
        validator: function validator(rule, value, callback) {
          if (!/^(^[1-9]\d{7}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])\d{3}$)|(^[1-9]\d{5}[1-9]\d{3}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])((\d{4})|\d{3}[Xx])$)$/.test(value)) {
            callback(new Error('\u8BF7\u8F93\u5165\u6B63\u786E\u7684' + msg));
          } else {
            callback();
          }
        },

        trigger: 'blur'
      };
    },

    // 银行卡验证(弱)
    checkBankcrad: function checkBankcrad(msg) {
      return {
        required: true,
        validator: function validator(rule, value, callback) {
          if (!/^([1-9]{1})(\d{14}|\d{18})$/.test(value)) {
            callback(new Error('\u8BF7\u8F93\u5165\u6B63\u786E\u7684' + msg));
          } else {
            callback();
          }
        },

        trigger: 'blur'
      };
    },

    // 全中文验证
    checkChinese: function checkChinese(msg) {
      return {
        required: true,
        validator: function validator(rule, value, callback) {
          if (!/^[\u4E00-\u9FA5]+$/.test(value)) {
            callback(new Error(msg + '\u8BF7\u8F93\u5165\u4E2D\u6587'));
          } else {
            callback();
          }
        },

        trigger: 'blur'
      };
    },

    // 车牌号验证
    checkCarLicence: function checkCarLicence(msg) {
      return {
        required: true,
        validator: function validator(rule, value, callback) {
          if (!/^[冀豫云辽黑湘皖鲁苏浙赣鄂桂甘晋蒙陕吉闽贵粤青藏川宁琼渝京津沪新京军空海北沈兰济南广成使领A-Z]{1}[a-zA-Z0-9]{5}[a-zA-Z0-9挂学警港澳]{1}$/.test(value)) {
            callback(new Error('\u8BF7\u8F93\u5165\u6B63\u786E\u7684' + msg));
          } else {
            callback();
          }
        },

        trigger: 'blur'
      };
    }
  }
};

/* harmony default export */ __webpack_exports__["a"] = ({
  filter: filter,
  editorConfig: editorConfig,
  mobileVerify: mobileVerify,
  addressConfig: addressConfig,
  // addressConfigWithoutAll: addressConfigWithoutAll,
  verify: verify
});

/***/ }),
/* 80 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export setMemberToken */
/* unused harmony export getMemberToken */
/* unused harmony export deleteMemberToken */
/* unused harmony export loginOut */
/* unused harmony export getLoginMemberModel */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_js_cookie__ = __webpack_require__(641);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_js_cookie___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_js_cookie__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__config__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_common_mc_lib__ = __webpack_require__(78);
/**
 * 用户相关操作类
 */






// store 相关
// import * as types from '@/store/mutation-types'

/**
 * 设置用户登录token
 * @param {String} token token字符串
 */
var setMemberToken = function setMemberToken(token) {
  __WEBPACK_IMPORTED_MODULE_1_js_cookie___default.a.set(__WEBPACK_IMPORTED_MODULE_2__config__["a" /* default */].ProjectName + '_UserLoginToken', token, {
    expires: 7,
    path: '/'
    //, domain: config.domainName
  });
};

/**
 * 获取登录用户token
 */
var getMemberToken = function getMemberToken() {
  return __WEBPACK_IMPORTED_MODULE_1_js_cookie___default.a.get(__WEBPACK_IMPORTED_MODULE_2__config__["a" /* default */].ProjectName + '_UserLoginToken', {
    expires: 7,
    path: '/'
    //, domain: config.domainName
  });
};

/**
 * 删除登录用户token
 */
var deleteMemberToken = function deleteMemberToken() {
  __WEBPACK_IMPORTED_MODULE_1_js_cookie___default.a.remove(__WEBPACK_IMPORTED_MODULE_2__config__["a" /* default */].ProjectName + '_UserLoginToken', {
    expires: 7,
    path: '/'
    //, domain: config.domainName
  });
};

/**
 * 退出登录
 */
var loginOut = function loginOut() {
  deleteMemberToken();
  window.location.href = '/';
};

/**
 * 获得登录用户模型
 */
var getLoginMemberModel = function getLoginMemberModel() {
  var hasLoading = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;

  var def = __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.Deferred();
  __WEBPACK_IMPORTED_MODULE_3__components_common_mc_lib__["a" /* default */].Ajax({
    url: '/Login/GetLoginWebModel',
    data: {
      token: getMemberToken()
    },
    hasLoading: hasLoading,
    success: function success(res) {
      def.resolve(res);
    },
    fail: function fail(res) {
      def.reject(res);
    },
    error: function error(res) {
      def.reject(res);
    }
  });
  return def;
};

/* harmony default export */ __webpack_exports__["a"] = ({
  setMemberToken: setMemberToken,
  getMemberToken: getMemberToken,
  deleteMemberToken: deleteMemberToken,
  loginOut: loginOut,
  getLoginMemberModel: getLoginMemberModel
});

/***/ }),
/* 81 */,
/* 82 */,
/* 83 */,
/* 84 */,
/* 85 */,
/* 86 */,
/* 87 */,
/* 88 */,
/* 89 */,
/* 90 */,
/* 91 */,
/* 92 */,
/* 93 */,
/* 94 */,
/* 95 */,
/* 96 */,
/* 97 */,
/* 98 */,
/* 99 */,
/* 100 */,
/* 101 */,
/* 102 */,
/* 103 */,
/* 104 */,
/* 105 */,
/* 106 */,
/* 107 */,
/* 108 */,
/* 109 */,
/* 110 */,
/* 111 */,
/* 112 */,
/* 113 */,
/* 114 */,
/* 115 */,
/* 116 */,
/* 117 */,
/* 118 */,
/* 119 */,
/* 120 */,
/* 121 */,
/* 122 */,
/* 123 */,
/* 124 */,
/* 125 */,
/* 126 */,
/* 127 */,
/* 128 */,
/* 129 */,
/* 130 */,
/* 131 */,
/* 132 */,
/* 133 */,
/* 134 */,
/* 135 */,
/* 136 */,
/* 137 */,
/* 138 */,
/* 139 */,
/* 140 */,
/* 141 */,
/* 142 */,
/* 143 */,
/* 144 */,
/* 145 */,
/* 146 */,
/* 147 */,
/* 148 */,
/* 149 */,
/* 150 */,
/* 151 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
var files = __webpack_require__(806);
var modules = {};

files.keys().forEach(function (key) {
  if (key === './index.js') return;
  modules[key.replace(/(\.\/|\.js)/g, '')] = files(key).default;
});

/* harmony default export */ __webpack_exports__["default"] = (modules);

/***/ }),
/* 152 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return UPDATE_MEMBERINFO; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return UPDATE_MEMBERPOWER; });
/* unused harmony export UPDATE_MODULE */
/* === 权限相关 START === */

// 更新用户信息
var UPDATE_MEMBERINFO = 'UPDATE_MEMBERINFO';

// 更新用户权限
var UPDATE_MEMBERPOWER = 'UPDATE_MEMBERPOWER';

// 更新菜单
var UPDATE_MODULE = 'UPDATE_MODULE';

/* === 权限相关 END === */

/***/ }),
/* 153 */,
/* 154 */,
/* 155 */,
/* 156 */,
/* 157 */,
/* 158 */,
/* 159 */,
/* 160 */,
/* 161 */,
/* 162 */,
/* 163 */,
/* 164 */,
/* 165 */,
/* 166 */,
/* 167 */,
/* 168 */,
/* 169 */,
/* 170 */,
/* 171 */,
/* 172 */,
/* 173 */,
/* 174 */,
/* 175 */,
/* 176 */,
/* 177 */,
/* 178 */,
/* 179 */,
/* 180 */,
/* 181 */,
/* 182 */,
/* 183 */,
/* 184 */,
/* 185 */,
/* 186 */,
/* 187 */,
/* 188 */,
/* 189 */,
/* 190 */,
/* 191 */,
/* 192 */,
/* 193 */,
/* 194 */,
/* 195 */,
/* 196 */,
/* 197 */,
/* 198 */,
/* 199 */,
/* 200 */,
/* 201 */,
/* 202 */,
/* 203 */,
/* 204 */,
/* 205 */,
/* 206 */,
/* 207 */,
/* 208 */,
/* 209 */,
/* 210 */,
/* 211 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(268),
  /* template */
  __webpack_require__(778),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 212 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(601)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(285),
  /* template */
  __webpack_require__(742),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 213 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(618)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(287),
  /* template */
  __webpack_require__(765),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 214 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(621)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(291),
  /* template */
  __webpack_require__(770),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 215 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App__ = __webpack_require__(648);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__App__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__store_common__ = __webpack_require__(247);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__router__ = __webpack_require__(244);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui__ = __webpack_require__(102);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_element_ui__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_theme_default_index_css__ = __webpack_require__(588);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_theme_default_index_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_element_ui_lib_theme_default_index_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__style_font_awesome_4_7_0_css_font_awesome_min_css__ = __webpack_require__(589);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__style_font_awesome_4_7_0_css_font_awesome_min_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__style_font_awesome_4_7_0_css_font_awesome_min_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_element_ui_lib_locale_lang_en__ = __webpack_require__(576);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_element_ui_lib_locale_lang_en___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_element_ui_lib_locale_lang_en__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_jquery__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_jquery__);
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.










__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_4_element_ui___default.a, { locale: __WEBPACK_IMPORTED_MODULE_7_element_ui_lib_locale_lang_en___default.a });

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].config.productionTip = false;



window.vueEvent = new __WEBPACK_IMPORTED_MODULE_0_vue__["default"]();

// 注册图片上传指令
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].directive('imageupload', {
  bind: function bind(el, binding, vnode) {
    var $el = __WEBPACK_IMPORTED_MODULE_8_jquery___default()(el);
    $el.on('click', function () {
      window.Mc.showImgUpload(function () {
        window.vueEvent.$off('upload:success').$on('upload:success', function (data) {
          vnode.data.on['upload-change'](data.url, data);
          // vnode.data.on['upload-success'](url)
        });
      });
    });
  },
  inserted: function inserted(el, binding, vnode) {
    // if (binding.value) {
    //   vnode.data.on['upload-change'](binding.value)
    // }
  },
  update: function update(el, binding, vnode) {
    // if (binding.value === binding.oldValue) return
    // let value = binding.value ? binding.value : ''
    // vnode.data.on['upload-change'](value)
  },
  componentUpdated: function componentUpdated(el, binding, vnode) {},
  unbind: function unbind(el, binding, vnode) {}
});

// 注册文件上传指令
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].directive('fileupload', {
  bind: function bind(el, binding, vnode) {
    // console.log("select:bind")
    var $el = __WEBPACK_IMPORTED_MODULE_8_jquery___default()(el);
    $el.on('click', function () {
      window.Mc.showFileUpload(function () {
        window.vueEvent.$off('upload:success').$on('upload:success', function (data) {
          vnode.data.on['upload-change'](data.url, data);
          // vnode.data.on['upload-success'](url)
        });
      });
    });
  },
  inserted: function inserted(el, binding, vnode) {
    // if (binding.value) {
    //   vnode.data.on['upload-change'](binding.value)
    // }
  },
  update: function update(el, binding, vnode) {
    // if (binding.value === binding.oldValue) return
    // let value = binding.value ? binding.value : ''
    // vnode.data.on['upload-change'](value)
  },
  componentUpdated: function componentUpdated(el, binding, vnode) {},
  unbind: function unbind(el, binding, vnode) {}
});

// 注册文件上传指令 - k3询价excel上传
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].directive('fileuploadk3', {
  bind: function bind(el, binding, vnode) {
    // console.log("select:bind")
    var $el = __WEBPACK_IMPORTED_MODULE_8_jquery___default()(el);
    $el.on('click', function () {
      window.Mc.showFileUploadK3(function () {
        window.vueEvent.$off('upload:success').$on('upload:success', function (data) {
          vnode.data.on['upload-change'](data);
          // vnode.data.on['upload-success'](url)
        });
      });
    });
  },
  inserted: function inserted(el, binding, vnode) {
    // if (binding.value) {
    //   vnode.data.on['upload-change'](binding.value)
    // }
  },
  update: function update(el, binding, vnode) {
    // if (binding.value === binding.oldValue) return
    // let value = binding.value ? binding.value : ''
    // vnode.data.on['upload-change'](value)
  },
  componentUpdated: function componentUpdated(el, binding, vnode) {},
  unbind: function unbind(el, binding, vnode) {}
});

/* eslint-disable no-new */
new __WEBPACK_IMPORTED_MODULE_0_vue__["default"]({
  el: '#app',
  store: __WEBPACK_IMPORTED_MODULE_2__store_common__["a" /* default */],
  router: __WEBPACK_IMPORTED_MODULE_3__router__["a" /* default */],
  template: '<App/>',
  components: {
    App: __WEBPACK_IMPORTED_MODULE_1__App___default.a
  }
});

/***/ }),
/* 216 */,
/* 217 */,
/* 218 */,
/* 219 */,
/* 220 */,
/* 221 */,
/* 222 */,
/* 223 */,
/* 224 */,
/* 225 */,
/* 226 */,
/* 227 */,
/* 228 */,
/* 229 */,
/* 230 */,
/* 231 */,
/* 232 */,
/* 233 */,
/* 234 */,
/* 235 */,
/* 236 */,
/* 237 */,
/* 238 */,
/* 239 */,
/* 240 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return mcAddressData; });
var mcAddressData=[{'idx':0,'code':'-1','name':'中国全境','search':'中国全境|zhongguoquanjing|zgqj'},{'idx':1,'code':'110000','name':'北京','search':'北京|beijingshi|bjs','children':[{'idx':'1,0','code':'-1','name':'全省','search':'全省|quansheng|qs'},{'idx':'1,1','code':'110100','name':'北京','search':'北京-北京|beijing-beijing|bj-bj','children':[{'idx':'1,1,0','code':'-1','name':'全市','search':'全市|quansheng|qs'},{'idx':'1,1,1','code':'110101','name':'东城区','search':'北京-北京-东城区|beijing-beijing-dongchengqu|bj-bj-dcq'},{'idx':'1,1,2','code':'110102','name':'西城区','search':'北京-北京-西城区|beijing-beijing-xichengqu|bj-bj-bjcq'},{'idx':'1,1,3','code':'110105','name':'朝阳区','search':'北京-北京-朝阳区|beijing-beijing-chaoyangqu|bj-bj-cyq'},{'idx':'1,1,4','code':'110106','name':'丰台区','search':'北京-北京-丰台区|beijing-beijing-fengtaiqu|bj-bj-ftq'},{'idx':'1,1,5','code':'110107','name':'石景山区','search':'北京-北京-石景山区|beijing-beijing-shijingshanqu|bj-bj-sjsq'},{'idx':'1,1,6','code':'110108','name':'海淀区','search':'北京-北京-海淀区|beijing-beijing-haidianqu|bj-bj-hdq'},{'idx':'1,1,7','code':'110109','name':'门头沟区','search':'北京-北京-门头沟区|beijing-beijing-mentougouqu|bj-bj-mtgq'},{'idx':'1,1,8','code':'110111','name':'房山区','search':'北京-北京-房山区|beijing-beijing-fangshanqu|bj-bj-fsq'},{'idx':'1,1,9','code':'110112','name':'通州区','search':'北京-北京-通州区|beijing-beijing-tongzhouqu|bj-bj-tzq'},{'idx':'1,1,10','code':'110113','name':'顺义区','search':'北京-北京-顺义区|beijing-beijing-shunyiqu|bj-bj-syq'},{'idx':'1,1,11','code':'110114','name':'昌平区','search':'北京-北京-昌平区|beijing-beijing-changpingqu|bj-bj-cpq'},{'idx':'1,1,12','code':'110115','name':'大兴区','search':'北京-北京-大兴区|beijing-beijing-daxingqu|bj-bj-dxq'},{'idx':'1,1,13','code':'110116','name':'怀柔区','search':'北京-北京-怀柔区|beijing-beijing-huairouqu|bj-bj-hrq'},{'idx':'1,1,14','code':'110117','name':'平谷区','search':'北京-北京-平谷区|beijing-beijing-pingguqu|bj-bj-pgq'},{'idx':'1,1,15','code':'110228','name':'密云县','search':'北京-北京-密云县|beijing-beijing-miyunxian|bj-bj-myx'},{'idx':'1,1,16','code':'110229','name':'延庆县','search':'北京-北京-延庆县|beijing-beijing-yanqingxian|bj-bj-yqx'}]}]},{'idx':2,'code':'120000','name':'天津','search':'天津|tianjinshi|tjs','children':[{'idx':'2,0','code':'-1','name':'全省','search':'全省|quansheng|qs'},{'idx':'2,1','code':'120100','name':'天津','search':'天津-天津|tianjin-tianjin|tj-tj','children':[{'idx':'2,1,0','code':'-1','name':'全市','search':'全市|quansheng|qs'},{'idx':'2,1,1','code':'120101','name':'和平区','search':'天津-天津-和平区|tianjin-tianjin-hepingqu|tj-tj-hpq'},{'idx':'2,1,2','code':'120102','name':'河东区','search':'天津-天津-河东区|tianjin-tianjin-hedongqu|tj-tj-hdq'},{'idx':'2,1,3','code':'120103','name':'河西区','search':'天津-天津-河西区|tianjin-tianjin-hexiqu|tj-tj-hxq'},{'idx':'2,1,4','code':'120104','name':'南开区','search':'天津-天津-南开区|tianjin-tianjin-nankaiqu|tj-tj-nkq'},{'idx':'2,1,5','code':'120105','name':'河北区','search':'天津-天津-河北区|tianjin-tianjin-hebeiqu|tj-tj-hbq'},{'idx':'2,1,6','code':'120106','name':'红桥区','search':'天津-天津-红桥区|tianjin-tianjin-hongqiaoqu|tj-tj-hqq'},{'idx':'2,1,7','code':'120110','name':'东丽区','search':'天津-天津-东丽区|tianjin-tianjin-dongliqu|tj-tj-dlq'},{'idx':'2,1,8','code':'120111','name':'西青区','search':'天津-天津-西青区|tianjin-tianjin-xiqingqu|tj-tj-xqq'},{'idx':'2,1,9','code':'120112','name':'津南区','search':'天津-天津-津南区|tianjin-tianjin-jinnanqu|tj-tj-jnq'},{'idx':'2,1,10','code':'120113','name':'北辰区','search':'天津-天津-北辰区|tianjin-tianjin-beichenqu|tj-tj-bcq'},{'idx':'2,1,11','code':'120114','name':'武清区','search':'天津-天津-武清区|tianjin-tianjin-wuqingqu|tj-tj-wqq'},{'idx':'2,1,12','code':'120115','name':'宝坻区','search':'天津-天津-宝坻区|tianjin-tianjin-baodiqu|tj-tj-bdq'},{'idx':'2,1,13','code':'120116','name':'滨海新区','search':'天津-天津-滨海新区|tianjin-tianjin-binhaixinqu|tj-tj-bhxq'},{'idx':'2,1,14','code':'120117','name':'宁河区','search':'天津-天津-宁河区|tianjin-tianjin-ninghequ|tj-tj-nhq'},{'idx':'2,1,15','code':'120118','name':'静海区','search':'天津-天津-静海区|tianjin-tianjin-jinghaiqu|tj-tj-jhq'},{'idx':'2,1,18','code':'120225','name':'蓟县','search':'天津-天津-蓟县|tianjin-tianjin-jixian|tj-tj-jx'}]}]},{'idx':3,'code':'130000','name':'河北','search':'河北|hebeisheng|hbs','children':[{'idx':'3,0','code':'-1','name':'全省','search':'全省|quansheng|qs'},{'idx':'3,1','code':'130100','name':'石家庄','search':'河北-石家庄|hebei-shijiazhuangshi|hb-sjzs','children':[{'idx':'3,1,0','code':'-1','name':'全市','search':'全市|quansheng|qs'},{'idx':'3,1,1','code':'130101','name':'市辖区','search':'河北-石家庄-市辖区|hebei-shijiazhuang-shixiaqu|hb-sjz-sxq'},{'idx':'3,1,2','code':'130102','name':'长安区','search':'河北-石家庄-长安区|hebei-shijiazhuang-changanqu|hb-sjz-caq'},{'idx':'3,1,3','code':'130104','name':'桥西区','search':'河北-石家庄-桥西区|hebei-shijiazhuang-qiaoxiqu|hb-sjz-qxq'},{'idx':'3,1,4','code':'130105','name':'新华区','search':'河北-石家庄-新华区|hebei-shijiazhuang-xinhuaqu|hb-sjz-xhq'},{'idx':'3,1,5','code':'130107','name':'井陉矿区','search':'河北-石家庄-井陉矿区|hebei-shijiazhuang-jingjingkuangqu|hb-sjz-jjkq'},{'idx':'3,1,6','code':'130108','name':'裕华区','search':'河北-石家庄-裕华区|hebei-shijiazhuang-yuhuaqu|hb-sjz-yhq'},{'idx':'3,1,7','code':'130109','name':'藁城区','search':'河北-石家庄-藁城区|hebei-shijiazhuang-gaochengqu|hb-sjz-gcq'},{'idx':'3,1,8','code':'130110','name':'鹿泉区','search':'河北-石家庄-鹿泉区|hebei-shijiazhuang-luquanqu|hb-sjz-lqq'},{'idx':'3,1,9','code':'130111','name':'栾城区','search':'河北-石家庄-栾城区|hebei-shijiazhuang-luanchengqu|hb-sjz-lcq'},{'idx':'3,1,10','code':'130121','name':'井陉县','search':'河北-石家庄-井陉县|hebei-shijiazhuang-jingjingxian|hb-sjz-jjx'},{'idx':'3,1,11','code':'130123','name':'正定县','search':'河北-石家庄-正定县|hebei-shijiazhuang-zhengdingxian|hb-sjz-zdx'},{'idx':'3,1,12','code':'130125','name':'行唐县','search':'河北-石家庄-行唐县|hebei-shijiazhuang-xingtangxian|hb-sjz-xtx'},{'idx':'3,1,13','code':'130126','name':'灵寿县','search':'河北-石家庄-灵寿县|hebei-shijiazhuang-lingshouxian|hb-sjz-lsx'},{'idx':'3,1,14','code':'130127','name':'高邑县','search':'河北-石家庄-高邑县|hebei-shijiazhuang-gaoyixian|hb-sjz-gyx'},{'idx':'3,1,15','code':'130128','name':'深泽县','search':'河北-石家庄-深泽县|hebei-shijiazhuang-shenzexian|hb-sjz-szx'},{'idx':'3,1,16','code':'130129','name':'赞皇县','search':'河北-石家庄-赞皇县|hebei-shijiazhuang-zanhuangxian|hb-sjz-zhx'},{'idx':'3,1,17','code':'130130','name':'无极县','search':'河北-石家庄-无极县|hebei-shijiazhuang-wujixian|hb-sjz-wjx'},{'idx':'3,1,18','code':'130131','name':'平山县','search':'河北-石家庄-平山县|hebei-shijiazhuang-pingshanxian|hb-sjz-psx'},{'idx':'3,1,19','code':'130132','name':'元氏县','search':'河北-石家庄-元氏县|hebei-shijiazhuang-yuanshixian|hb-sjz-ysx'},{'idx':'3,1,20','code':'130133','name':'赵县','search':'河北-石家庄-赵县|hebei-shijiazhuang-zhaoxian|hb-sjz-zx'},{'idx':'3,1,21','code':'130183','name':'晋州市','search':'河北-石家庄-晋州市|hebei-shijiazhuang-jinzhoushi|hb-sjz-jzs'},{'idx':'3,1,22','code':'130184','name':'新乐市','search':'河北-石家庄-新乐市|hebei-shijiazhuang-xinleshi|hb-sjz-xls'}]},{'idx':'3,2','code':'130200','name':'唐山','search':'河北-唐山|hebei-tangshanshi|hb-tss','children':[{'idx':'3,2,0','code':'-1','name':'全市','search':'全市|quansheng|qs'},{'idx':'3,2,1','code':'130201','name':'市辖区','search':'河北-唐山-市辖区|hebei-tangshan-shixiaqu|hb-ts-sxq'},{'idx':'3,2,2','code':'130202','name':'路南区','search':'河北-唐山-路南区|hebei-tangshan-lunanqu|hb-ts-lnq'},{'idx':'3,2,3','code':'130203','name':'路北区','search':'河北-唐山-路北区|hebei-tangshan-lubeiqu|hb-ts-lbq'},{'idx':'3,2,4','code':'130204','name':'古冶区','search':'河北-唐山-古冶区|hebei-tangshan-guyequ|hb-ts-gyq'},{'idx':'3,2,5','code':'130205','name':'开平区','search':'河北-唐山-开平区|hebei-tangshan-kaipingqu|hb-ts-kpq'},{'idx':'3,2,6','code':'130207','name':'丰南区','search':'河北-唐山-丰南区|hebei-tangshan-fengnanqu|hb-ts-fnq'},{'idx':'3,2,7','code':'130208','name':'丰润区','search':'河北-唐山-丰润区|hebei-tangshan-fengrunqu|hb-ts-frq'},{'idx':'3,2,8','code':'130209','name':'曹妃甸区','search':'河北-唐山-曹妃甸区|hebei-tangshan-caofeidianqu|hb-ts-cfdq'},{'idx':'3,2,9','code':'130223','name':'滦县','search':'河北-唐山-滦县|hebei-tangshan-luanxian|hb-ts-lx'},{'idx':'3,2,10','code':'130224','name':'滦南县','search':'河北-唐山-滦南县|hebei-tangshan-luannanxian|hb-ts-lnx'},{'idx':'3,2,11','code':'130225','name':'乐亭县','search':'河北-唐山-乐亭县|hebei-tangshan-letingxian|hb-ts-ltx'},{'idx':'3,2,12','code':'130227','name':'迁西县','search':'河北-唐山-迁西县|hebei-tangshan-qianxixian|hb-ts-qxx'},{'idx':'3,2,13','code':'130229','name':'玉田县','search':'河北-唐山-玉田县|hebei-tangshan-yutianxian|hb-ts-ytx'},{'idx':'3,2,14','code':'130281','name':'遵化市','search':'河北-唐山-遵化市|hebei-tangshan-zunhuashi|hb-ts-zhs'},{'idx':'3,2,15','code':'130283','name':'迁安市','search':'河北-唐山-迁安市|hebei-tangshan-qiananshi|hb-ts-qas'}]},{'idx':'3,3','code':'130300','name':'秦皇岛','search':'河北-秦皇岛|hebei-qinhuangdaoshi|hb-qhds','children':[{'idx':'3,3,0','code':'-1','name':'全市','search':'全市|quansheng|qs'},{'idx':'3,3,1','code':'130301','name':'市辖区','search':'河北-秦皇岛-市辖区|hebei-qinhuangdao-shixiaqu|hb-qhd-sxq'},{'idx':'3,3,2','code':'130302','name':'海港区','search':'河北-秦皇岛-海港区|hebei-qinhuangdao-haigangqu|hb-qhd-hgq'},{'idx':'3,3,3','code':'130303','name':'山海关区','search':'河北-秦皇岛-山海关区|hebei-qinhuangdao-shanhaiguanqu|hb-qhd-shgq'},{'idx':'3,3,4','code':'130304','name':'北戴河区','search':'河北-秦皇岛-北戴河区|hebei-qinhuangdao-beidaihequ|hb-qhd-bdhq'},{'idx':'3,3,5','code':'130306','name':'抚宁区','search':'河北-秦皇岛-抚宁区|hebei-qinhuangdao-funingqu|hb-qhd-fnq'},{'idx':'3,3,6','code':'130321','name':'青龙满族自治县','search':'河北-秦皇岛-青龙满族自治县|hebei-qinhuangdao-qinglongmanzuzizhixian|hb-qhd-qlmzzzx'},{'idx':'3,3,7','code':'130322','name':'昌黎县','search':'河北-秦皇岛-昌黎县|hebei-qinhuangdao-changlixian|hb-qhd-clx'},{'idx':'3,3,8','code':'130324','name':'卢龙县','search':'河北-秦皇岛-卢龙县|hebei-qinhuangdao-lulongxian|hb-qhd-llx'}]},{'idx':'3,4','code':'130400','name':'邯郸','search':'河北-邯郸|hebei-handanshi|hb-hds','children':[{'idx':'3,4,0','code':'-1','name':'全市','search':'全市|quansheng|qs'},{'idx':'3,4,1','code':'130401','name':'市辖区','search':'河北-邯郸-市辖区|hebei-handan-shixiaqu|hb-hd-sxq'},{'idx':'3,4,2','code':'130402','name':'邯山区','search':'河北-邯郸-邯山区|hebei-handan-hanshanqu|hb-hd-hsq'},{'idx':'3,4,3','code':'130403','name':'丛台区','search':'河北-邯郸-丛台区|hebei-handan-congtaiqu|hb-hd-ctq'},{'idx':'3,4,4','code':'130404','name':'复兴区','search':'河北-邯郸-复兴区|hebei-handan-fuxingqu|hb-hd-fxq'},{'idx':'3,4,5','code':'130406','name':'峰峰矿区','search':'河北-邯郸-峰峰矿区|hebei-handan-fengfengkuangqu|hb-hd-ffkq'},{'idx':'3,4,6','code':'130421','name':'邯郸县','search':'河北-邯郸-邯郸县|hebei-handan-handanxian|hb-hd-hdx'},{'idx':'3,4,7','code':'130423','name':'临漳县','search':'河北-邯郸-临漳县|hebei-handan-linzhangxian|hb-hd-lzx'},{'idx':'3,4,8','code':'130424','name':'成安县','search':'河北-邯郸-成安县|hebei-handan-chenganxian|hb-hd-cax'},{'idx':'3,4,9','code':'130425','name':'大名县','search':'河北-邯郸-大名县|hebei-handan-damingxian|hb-hd-dmx'},{'idx':'3,4,10','code':'130426','name':'涉县','search':'河北-邯郸-涉县|hebei-handan-shexian|hb-hd-sx'},{'idx':'3,4,11','code':'130427','name':'磁县','search':'河北-邯郸-磁县|hebei-handan-cixian|hb-hd-cx'},{'idx':'3,4,12','code':'130428','name':'肥乡县','search':'河北-邯郸-肥乡县|hebei-handan-feixiangxian|hb-hd-fxx'},{'idx':'3,4,13','code':'130429','name':'永年县','search':'河北-邯郸-永年县|hebei-handan-yongnianxian|hb-hd-ynx'},{'idx':'3,4,14','code':'130430','name':'邱县','search':'河北-邯郸-邱县|hebei-handan-qiuxian|hb-hd-qx'},{'idx':'3,4,15','code':'130431','name':'鸡泽县','search':'河北-邯郸-鸡泽县|hebei-handan-jizexian|hb-hd-jzx'},{'idx':'3,4,16','code':'130432','name':'广平县','search':'河北-邯郸-广平县|hebei-handan-guangpingxian|hb-hd-gpx'},{'idx':'3,4,17','code':'130433','name':'馆陶县','search':'河北-邯郸-馆陶县|hebei-handan-guantaoxian|hb-hd-gtx'},{'idx':'3,4,18','code':'130434','name':'魏县','search':'河北-邯郸-魏县|hebei-handan-weixian|hb-hd-wx'},{'idx':'3,4,19','code':'130435','name':'曲周县','search':'河北-邯郸-曲周县|hebei-handan-quzhouxian|hb-hd-qzx'},{'idx':'3,4,20','code':'130481','name':'武安市','search':'河北-邯郸-武安市|hebei-handan-wuanshi|hb-hd-was'}]},{'idx':'3,5','code':'130500','name':'邢台','search':'河北-邢台|hebei-xingtaishi|hb-xts','children':[{'idx':'3,5,0','code':'-1','name':'全市','search':'全市|quansheng|qs'},{'idx':'3,5,1','code':'130501','name':'市辖区','search':'河北-邢台-市辖区|hebei-xingtai-shixiaqu|hb-xt-sxq'},{'idx':'3,5,2','code':'130502','name':'桥东区','search':'河北-邢台-桥东区|hebei-xingtai-qiaodongqu|hb-xt-qdq'},{'idx':'3,5,3','code':'130503','name':'桥西区','search':'河北-邢台-桥西区|hebei-xingtai-qiaoxiqu|hb-xt-qxq'},{'idx':'3,5,4','code':'130521','name':'邢台县','search':'河北-邢台-邢台县|hebei-xingtai-xingtaixian|hb-xt-xtx'},{'idx':'3,5,5','code':'130522','name':'临城县','search':'河北-邢台-临城县|hebei-xingtai-linchengxian|hb-xt-lcx'},{'idx':'3,5,6','code':'130523','name':'内丘县','search':'河北-邢台-内丘县|hebei-xingtai-neiqiuxian|hb-xt-nqx'},{'idx':'3,5,7','code':'130524','name':'柏乡县','search':'河北-邢台-柏乡县|hebei-xingtai-baixiangxian|hb-xt-bxx'},{'idx':'3,5,8','code':'130525','name':'隆尧县','search':'河北-邢台-隆尧县|hebei-xingtai-longyaoxian|hb-xt-lyx'},{'idx':'3,5,9','code':'130526','name':'任县','search':'河北-邢台-任县|hebei-xingtai-renxian|hb-xt-rx'},{'idx':'3,5,10','code':'130527','name':'南和县','search':'河北-邢台-南和县|hebei-xingtai-nanhexian|hb-xt-nhx'},{'idx':'3,5,11','code':'130528','name':'宁晋县','search':'河北-邢台-宁晋县|hebei-xingtai-ningjinxian|hb-xt-njx'},{'idx':'3,5,12','code':'130529','name':'巨鹿县','search':'河北-邢台-巨鹿县|hebei-xingtai-juluxian|hb-xt-jlx'},{'idx':'3,5,13','code':'130530','name':'新河县','search':'河北-邢台-新河县|hebei-xingtai-xinhexian|hb-xt-xhx'},{'idx':'3,5,14','code':'130531','name':'广宗县','search':'河北-邢台-广宗县|hebei-xingtai-guangzongxian|hb-xt-gzx'},{'idx':'3,5,15','code':'130532','name':'平乡县','search':'河北-邢台-平乡县|hebei-xingtai-pingxiangxian|hb-xt-pxx'},{'idx':'3,5,16','code':'130533','name':'威县','search':'河北-邢台-威县|hebei-xingtai-weixian|hb-xt-wx'},{'idx':'3,5,17','code':'130534','name':'清河县','search':'河北-邢台-清河县|hebei-xingtai-qinghexian|hb-xt-qhx'},{'idx':'3,5,18','code':'130535','name':'临西县','search':'河北-邢台-临西县|hebei-xingtai-linxixian|hb-xt-lxx'},{'idx':'3,5,19','code':'130581','name':'南宫市','search':'河北-邢台-南宫市|hebei-xingtai-nangongshi|hb-xt-ngs'},{'idx':'3,5,20','code':'130582','name':'沙河市','search':'河北-邢台-沙河市|hebei-xingtai-shaheshi|hb-xt-shs'}]},{'idx':'3,6','code':'130600','name':'保定','search':'河北-保定|hebei-baodingshi|hb-bds','children':[{'idx':'3,6,0','code':'-1','name':'全市','search':'全市|quansheng|qs'},{'idx':'3,6,1','code':'130601','name':'市辖区','search':'河北-保定-市辖区|hebei-baoding-shixiaqu|hb-bd-sxq'},{'idx':'3,6,2','code':'130602','name':'竞秀区','search':'河北-保定-竞秀区|hebei-baoding-jingxiuqu|hb-bd-jxq'},{'idx':'3,6,3','code':'130606','name':'莲池区','search':'河北-保定-莲池区|hebei-baoding-lianchiqu|hb-bd-lcq'},{'idx':'3,6,4','code':'130607','name':'满城区','search':'河北-保定-满城区|hebei-baoding-manchengqu|hb-bd-mcq'},{'idx':'3,6,5','code':'130608','name':'清苑区','search':'河北-保定-清苑区|hebei-baoding-qingyuanqu|hb-bd-qyq'},{'idx':'3,6,6','code':'130609','name':'徐水区','search':'河北-保定-徐水区|hebei-baoding-xushuiqu|hb-bd-xsq'},{'idx':'3,6,7','code':'130623','name':'涞水县','search':'河北-保定-涞水县|hebei-baoding-laishuixian|hb-bd-lsx'},{'idx':'3,6,8','code':'130624','name':'阜平县','search':'河北-保定-阜平县|hebei-baoding-fupingxian|hb-bd-fpx'},{'idx':'3,6,9','code':'130626','name':'定兴县','search':'河北-保定-定兴县|hebei-baoding-dingxingxian|hb-bd-dxx'},{'idx':'3,6,10','code':'130627','name':'唐县','search':'河北-保定-唐县|hebei-baoding-tangxian|hb-bd-tx'},{'idx':'3,6,11','code':'130628','name':'高阳县','search':'河北-保定-高阳县|hebei-baoding-gaoyangxian|hb-bd-gyx'},{'idx':'3,6,12','code':'130629','name':'容城县','search':'河北-保定-容城县|hebei-baoding-rongchengxian|hb-bd-rcx'},{'idx':'3,6,13','code':'130630','name':'涞源县','search':'河北-保定-涞源县|hebei-baoding-laiyuanxian|hb-bd-lyx'},{'idx':'3,6,14','code':'130631','name':'望都县','search':'河北-保定-望都县|hebei-baoding-wangduxian|hb-bd-wdx'},{'idx':'3,6,15','code':'130632','name':'安新县','search':'河北-保定-安新县|hebei-baoding-anxinxian|hb-bd-axx'},{'idx':'3,6,16','code':'130633','name':'易县','search':'河北-保定-易县|hebei-baoding-yixian|hb-bd-yx'},{'idx':'3,6,17','code':'130634','name':'曲阳县','search':'河北-保定-曲阳县|hebei-baoding-quyangxian|hb-bd-qyx'},{'idx':'3,6,18','code':'130635','name':'蠡县','search':'河北-保定-蠡县|hebei-baoding-lixian|hb-bd-lx'},{'idx':'3,6,19','code':'130636','name':'顺平县','search':'河北-保定-顺平县|hebei-baoding-shunpingxian|hb-bd-spx'},{'idx':'3,6,20','code':'130637','name':'博野县','search':'河北-保定-博野县|hebei-baoding-boyexian|hb-bd-byx'},{'idx':'3,6,21','code':'130638','name':'雄县','search':'河北-保定-雄县|hebei-baoding-xiongxian|hb-bd-xx'},{'idx':'3,6,22','code':'130681','name':'涿州市','search':'河北-保定-涿州市|hebei-baoding-zhuozhoushi|hb-bd-zzs'},{'idx':'3,6,23','code':'130683','name':'安国市','search':'河北-保定-安国市|hebei-baoding-anguoshi|hb-bd-ags'},{'idx':'3,6,24','code':'130684','name':'高碑店市','search':'河北-保定-高碑店市|hebei-baoding-gaobeidianshi|hb-bd-gbds'}]},{'idx':'3,7','code':'130700','name':'张家口','search':'河北-张家口|hebei-zhangjiakoushi|hb-zjks','children':[{'idx':'3,7,0','code':'-1','name':'全市','search':'全市|quansheng|qs'},{'idx':'3,7,1','code':'130701','name':'市辖区','search':'河北-张家口-市辖区|hebei-zhangjiakou-shixiaqu|hb-zjk-sxq'},{'idx':'3,7,2','code':'130702','name':'桥东区','search':'河北-张家口-桥东区|hebei-zhangjiakou-qiaodongqu|hb-zjk-qdq'},{'idx':'3,7,3','code':'130703','name':'桥西区','search':'河北-张家口-桥西区|hebei-zhangjiakou-qiaoxiqu|hb-zjk-qxq'},{'idx':'3,7,4','code':'130705','name':'宣化区','search':'河北-张家口-宣化区|hebei-zhangjiakou-xuanhuaqu|hb-zjk-xhq'},{'idx':'3,7,5','code':'130706','name':'下花园区','search':'河北-张家口-下花园区|hebei-zhangjiakou-xiahuayuanqu|hb-zjk-xhyq'},{'idx':'3,7,6','code':'130721','name':'宣化县','search':'河北-张家口-宣化县|hebei-zhangjiakou-xuanhuaxian|hb-zjk-xhx'},{'idx':'3,7,7','code':'130722','name':'张北县','search':'河北-张家口-张北县|hebei-zhangjiakou-zhangbeixian|hb-zjk-zbx'},{'idx':'3,7,8','code':'130723','name':'康保县','search':'河北-张家口-康保县|hebei-zhangjiakou-kangbaoxian|hb-zjk-kbx'},{'idx':'3,7,9','code':'130724','name':'沽源县','search':'河北-张家口-沽源县|hebei-zhangjiakou-guyuanxian|hb-zjk-gyx'},{'idx':'3,7,10','code':'130725','name':'尚义县','search':'河北-张家口-尚义县|hebei-zhangjiakou-shangyixian|hb-zjk-syx'},{'idx':'3,7,11','code':'130726','name':'蔚县','search':'河北-张家口-蔚县|hebei-zhangjiakou-weixian|hb-zjk-wx'},{'idx':'3,7,12','code':'130727','name':'阳原县','search':'河北-张家口-阳原县|hebei-zhangjiakou-yangyuanxian|hb-zjk-yyx'},{'idx':'3,7,13','code':'130728','name':'怀安县','search':'河北-张家口-怀安县|hebei-zhangjiakou-huaianxian|hb-zjk-hax'},{'idx':'3,7,14','code':'130729','name':'万全县','search':'河北-张家口-万全县|hebei-zhangjiakou-wanquanxian|hb-zjk-wqx'},{'idx':'3,7,15','code':'130730','name':'怀来县','search':'河北-张家口-怀来县|hebei-zhangjiakou-huailaixian|hb-zjk-hlx'},{'idx':'3,7,16','code':'130731','name':'涿鹿县','search':'河北-张家口-涿鹿县|hebei-zhangjiakou-zhuoluxian|hb-zjk-zlx'},{'idx':'3,7,17','code':'130732','name':'赤城县','search':'河北-张家口-赤城县|hebei-zhangjiakou-chichengxian|hb-zjk-ccx'},{'idx':'3,7,18','code':'130733','name':'崇礼县','search':'河北-张家口-崇礼县|hebei-zhangjiakou-chonglixian|hb-zjk-clx'}]},{'idx':'3,8','code':'130800','name':'承德','search':'河北-承德|hebei-chengdeshi|hb-cds','children':[{'idx':'3,8,0','code':'-1','name':'全市','search':'全市|quansheng|qs'},{'idx':'3,8,1','code':'130801','name':'市辖区','search':'河北-承德-市辖区|hebei-chengde-shixiaqu|hb-cd-sxq'},{'idx':'3,8,2','code':'130802','name':'双桥区','search':'河北-承德-双桥区|hebei-chengde-shuangqiaoqu|hb-cd-sqq'},{'idx':'3,8,3','code':'130803','name':'双滦区','search':'河北-承德-双滦区|hebei-chengde-shuangluanqu|hb-cd-slq'},{'idx':'3,8,4','code':'130804','name':'鹰手营子矿区','search':'河北-承德-鹰手营子矿区|hebei-chengde-yingshouyingzikuangqu|hb-cd-ysyzkq'},{'idx':'3,8,5','code':'130821','name':'承德县','search':'河北-承德-承德县|hebei-chengde-chengdexian|hb-cd-cdx'},{'idx':'3,8,6','code':'130822','name':'兴隆县','search':'河北-承德-兴隆县|hebei-chengde-xinglongxian|hb-cd-xlx'},{'idx':'3,8,7','code':'130823','name':'平泉县','search':'河北-承德-平泉县|hebei-chengde-pingquanxian|hb-cd-pqx'},{'idx':'3,8,8','code':'130824','name':'滦平县','search':'河北-承德-滦平县|hebei-chengde-luanpingxian|hb-cd-lpx'},{'idx':'3,8,9','code':'130825','name':'隆化县','search':'河北-承德-隆化县|hebei-chengde-longhuaxian|hb-cd-lhx'},{'idx':'3,8,10','code':'130826','name':'丰宁满族自治县','search':'河北-承德-丰宁满族自治县|hebei-chengde-fengningmanzuzizhixian|hb-cd-fnmzzzx'},{'idx':'3,8,11','code':'130827','name':'宽城满族自治县','search':'河北-承德-宽城满族自治县|hebei-chengde-kuanchengmanzuzizhixian|hb-cd-kcmzzzx'},{'idx':'3,8,12','code':'130828','name':'围场满族蒙古族自治县','search':'河北-承德-围场满族蒙古族自治县|hebei-chengde-weichangmanzumengguzuzizhixian|hb-cd-wcmzmgzzzx'}]},{'idx':'3,9','code':'130900','name':'沧州','search':'河北-沧州|hebei-cangzhoushi|hb-czs','children':[{'idx':'3,9,0','code':'-1','name':'全市','search':'全市|quansheng|qs'},{'idx':'3,9,1','code':'130901','name':'市辖区','search':'河北-沧州-市辖区|hebei-cangzhou-shixiaqu|hb-cz-sxq'},{'idx':'3,9,2','code':'130902','name':'新华区','search':'河北-沧州-新华区|hebei-cangzhou-xinhuaqu|hb-cz-xhq'},{'idx':'3,9,3','code':'130903','name':'运河区','search':'河北-沧州-运河区|hebei-cangzhou-yunhequ|hb-cz-yhq'},{'idx':'3,9,4','code':'130921','name':'沧县','search':'河北-沧州-沧县|hebei-cangzhou-cangxian|hb-cz-cx'},{'idx':'3,9,5','code':'130922','name':'青县','search':'河北-沧州-青县|hebei-cangzhou-qingxian|hb-cz-qx'},{'idx':'3,9,6','code':'130923','name':'东光县','search':'河北-沧州-东光县|hebei-cangzhou-dongguangxian|hb-cz-dgx'},{'idx':'3,9,7','code':'130924','name':'海兴县','search':'河北-沧州-海兴县|hebei-cangzhou-haixingxian|hb-cz-hxx'},{'idx':'3,9,8','code':'130925','name':'盐山县','search':'河北-沧州-盐山县|hebei-cangzhou-yanshanxian|hb-cz-ysx'},{'idx':'3,9,9','code':'130926','name':'肃宁县','search':'河北-沧州-肃宁县|hebei-cangzhou-suningxian|hb-cz-snx'},{'idx':'3,9,10','code':'130927','name':'南皮县','search':'河北-沧州-南皮县|hebei-cangzhou-nanpixian|hb-cz-npx'},{'idx':'3,9,11','code':'130928','name':'吴桥县','search':'河北-沧州-吴桥县|hebei-cangzhou-wuqiaoxian|hb-cz-wqx'},{'idx':'3,9,12','code':'130929','name':'献县','search':'河北-沧州-献县|hebei-cangzhou-xianxian|hb-cz-xx'},{'idx':'3,9,13','code':'130930','name':'孟村回族自治县','search':'河北-沧州-孟村回族自治县|hebei-cangzhou-mengcunhuizuzizhixian|hb-cz-mchzzzx'},{'idx':'3,9,14','code':'130981','name':'泊头市','search':'河北-沧州-泊头市|hebei-cangzhou-botoushi|hb-cz-bts'},{'idx':'3,9,15','code':'130982','name':'任丘市','search':'河北-沧州-任丘市|hebei-cangzhou-renqiushi|hb-cz-rqs'},{'idx':'3,9,16','code':'130983','name':'黄骅市','search':'河北-沧州-黄骅市|hebei-cangzhou-huanghuashi|hb-cz-hhs'},{'idx':'3,9,17','code':'130984','name':'河间市','search':'河北-沧州-河间市|hebei-cangzhou-hejianshi|hb-cz-hjs'}]},{'idx':'3,10','code':'131000','name':'廊坊','search':'河北-廊坊|hebei-langfangshi|hb-lfs','children':[{'idx':'3,10,0','code':'-1','name':'全市','search':'全市|quansheng|qs'},{'idx':'3,10,1','code':'131001','name':'市辖区','search':'河北-廊坊-市辖区|hebei-langfang-shixiaqu|hb-lf-sxq'},{'idx':'3,10,2','code':'131002','name':'安次区','search':'河北-廊坊-安次区|hebei-langfang-anciqu|hb-lf-acq'},{'idx':'3,10,3','code':'131003','name':'广阳区','search':'河北-廊坊-广阳区|hebei-langfang-guangyangqu|hb-lf-gyq'},{'idx':'3,10,4','code':'131022','name':'固安县','search':'河北-廊坊-固安县|hebei-langfang-guanxian|hb-lf-gax'},{'idx':'3,10,5','code':'131023','name':'永清县','search':'河北-廊坊-永清县|hebei-langfang-yongqingxian|hb-lf-yqx'},{'idx':'3,10,6','code':'131024','name':'香河县','search':'河北-廊坊-香河县|hebei-langfang-xianghexian|hb-lf-xhx'},{'idx':'3,10,7','code':'131025','name':'大城县','search':'河北-廊坊-大城县|hebei-langfang-dachengxian|hb-lf-dcx'},{'idx':'3,10,8','code':'131026','name':'文安县','search':'河北-廊坊-文安县|hebei-langfang-wenanxian|hb-lf-wax'},{'idx':'3,10,9','code':'131028','name':'大厂回族自治县','search':'河北-廊坊-大厂回族自治县|hebei-langfang-dachanghuizuzizhixian|hb-lf-dchzzzx'},{'idx':'3,10,10','code':'131081','name':'霸州市','search':'河北-廊坊-霸州市|hebei-langfang-bazhoushi|hb-lf-bzs'},{'idx':'3,10,11','code':'131082','name':'三河市','search':'河北-廊坊-三河市|hebei-langfang-sanheshi|hb-lf-shs'}]},{'idx':'3,11','code':'131100','name':'衡水','search':'河北-衡水|hebei-hengshuishi|hb-hss','children':[{'idx':'3,11,0','code':'-1','name':'全市','search':'全市|quansheng|qs'},{'idx':'3,11,1','code':'131101','name':'市辖区','search':'河北-衡水-市辖区|hebei-hengshui-shixiaqu|hb-hs-sxq'},{'idx':'3,11,2','code':'131102','name':'桃城区','search':'河北-衡水-桃城区|hebei-hengshui-taochengqu|hb-hs-tcq'},{'idx':'3,11,3','code':'131121','name':'枣强县','search':'河北-衡水-枣强县|hebei-hengshui-zaoqiangxian|hb-hs-zqx'},{'idx':'3,11,4','code':'131122','name':'武邑县','search':'河北-衡水-武邑县|hebei-hengshui-wuyixian|hb-hs-wyx'},{'idx':'3,11,5','code':'131123','name':'武强县','search':'河北-衡水-武强县|hebei-hengshui-wuqiangxian|hb-hs-wqx'},{'idx':'3,11,6','code':'131124','name':'饶阳县','search':'河北-衡水-饶阳县|hebei-hengshui-raoyangxian|hb-hs-ryx'},{'idx':'3,11,7','code':'131125','name':'安平县','search':'河北-衡水-安平县|hebei-hengshui-anpingxian|hb-hs-apx'},{'idx':'3,11,8','code':'131126','name':'故城县','search':'河北-衡水-故城县|hebei-hengshui-guchengxian|hb-hs-gcx'},{'idx':'3,11,9','code':'131127','name':'景县','search':'河北-衡水-景县|hebei-hengshui-jingxian|hb-hs-jx'},{'idx':'3,11,10','code':'131128','name':'阜城县','search':'河北-衡水-阜城县|hebei-hengshui-fuchengxian|hb-hs-fcx'},{'idx':'3,11,11','code':'131181','name':'冀州市','search':'河北-衡水-冀州市|hebei-hengshui-jizhoushi|hb-hs-jzs'},{'idx':'3,11,12','code':'131182','name':'深州市','search':'河北-衡水-深州市|hebei-hengshui-shenzhoushi|hb-hs-szs'}]},{'idx':'3,12','code':'139000','name':'省直辖县级行政区划','search':'河北-省直辖县级行政区划|hebei-shengzhixiaxianjixingzhengquhua|hb-szxxjxzqh','children':[{'idx':'3,12,0','code':'-1','name':'全市','search':'全市|quansheng|qs'},{'idx':'3,12,1','code':'139001','name':'定州市','search':'河北-省直辖县级行政区划-定州市|hebei-shengzhixiaxianjixingzhengquhua-dingzhoushi|hb-szxxjxzqh-dzs'},{'idx':'3,12,2','code':'139002','name':'辛集市','search':'河北-省直辖县级行政区划-辛集市|hebei-shengzhixiaxianjixingzhengquhua-xinjishi|hb-szxxjxzqh-xjs'}]}]},{'idx':4,'code':'140000','name':'山西','search':'山西|shanxisheng|sxs','children':[{'idx':'4,0','code':'-1','name':'全省','search':'全省|quansheng|qs'},{'idx':'4,1','code':'140100','name':'太原','search':'山西-太原|shanxi-taiyuanshi|sx-tys','children':[{'idx':'4,1,0','code':'-1','name':'全市','search':'全市|quansheng|qs'},{'idx':'4,1,1','code':'140101','name':'市辖区','search':'山西-太原-市辖区|shanxi-taiyuan-shixiaqu|sx-ty-sxq'},{'idx':'4,1,2','code':'140105','name':'小店区','search':'山西-太原-小店区|shanxi-taiyuan-xiaodianqu|sx-ty-xdq'},{'idx':'4,1,3','code':'140106','name':'迎泽区','search':'山西-太原-迎泽区|shanxi-taiyuan-yingzequ|sx-ty-yzq'},{'idx':'4,1,4','code':'140107','name':'杏花岭区','search':'山西-太原-杏花岭区|shanxi-taiyuan-xinghualingqu|sx-ty-xhlq'},{'idx':'4,1,5','code':'140108','name':'尖草坪区','search':'山西-太原-尖草坪区|shanxi-taiyuan-jiancaopingqu|sx-ty-jcpq'},{'idx':'4,1,6','code':'140109','name':'万柏林区','search':'山西-太原-万柏林区|shanxi-taiyuan-wanbailinqu|sx-ty-wblq'},{'idx':'4,1,7','code':'140110','name':'晋源区','search':'山西-太原-晋源区|shanxi-taiyuan-jinyuanqu|sx-ty-jyq'},{'idx':'4,1,8','code':'140121','name':'清徐县','search':'山西-太原-清徐县|shanxi-taiyuan-qingxuxian|sx-ty-qxx'},{'idx':'4,1,9','code':'140122','name':'阳曲县','search':'山西-太原-阳曲县|shanxi-taiyuan-yangquxian|sx-ty-yqx'},{'idx':'4,1,10','code':'140123','name':'娄烦县','search':'山西-太原-娄烦县|shanxi-taiyuan-loufanxian|sx-ty-lfx'},{'idx':'4,1,11','code':'140181','name':'古交市','search':'山西-太原-古交市|shanxi-taiyuan-gujiaoshi|sx-ty-gjs'}]},{'idx':'4,2','code':'140200','name':'大同','search':'山西-大同|shanxi-datongshi|sx-dts','children':[{'idx':'4,2,0','code':'-1','name':'全市','search':'全市|quansheng|qs'},{'idx':'4,2,1','code':'140201','name':'市辖区','search':'山西-大同-市辖区|shanxi-datong-shixiaqu|sx-dt-sxq'},{'idx':'4,2,2','code':'140202','name':'城区','search':'山西-大同-城区|shanxi-datong-chengqu|sx-dt-cq'},{'idx':'4,2,3','code':'140203','name':'矿区','search':'山西-大同-矿区|shanxi-datong-kuangqu|sx-dt-kq'},{'idx':'4,2,4','code':'140211','name':'南郊区','search':'山西-大同-南郊区|shanxi-datong-nanjiaoqu|sx-dt-njq'},{'idx':'4,2,5','code':'140212','name':'新荣区','search':'山西-大同-新荣区|shanxi-datong-xinrongqu|sx-dt-xrq'},{'idx':'4,2,6','code':'140221','name':'阳高县','search':'山西-大同-阳高县|shanxi-datong-yanggaoxian|sx-dt-ygx'},{'idx':'4,2,7','code':'140222','name':'天镇县','search':'山西-大同-天镇县|shanxi-datong-tianzhenxian|sx-dt-tzx'},{'idx':'4,2,8','code':'140223','name':'广灵县','search':'山西-大同-广灵县|shanxi-datong-guanglingxian|sx-dt-glx'},{'idx':'4,2,9','code':'140224','name':'灵丘县','search':'山西-大同-灵丘县|shanxi-datong-lingqiuxian|sx-dt-lqx'},{'idx':'4,2,10','code':'140225','name':'浑源县','search':'山西-大同-浑源县|shanxi-datong-hunyuanxian|sx-dt-hyx'},{'idx':'4,2,11','code':'140226','name':'左云县','search':'山西-大同-左云县|shanxi-datong-zuoyunxian|sx-dt-zyx'},{'idx':'4,2,12','code':'140227','name':'大同县','search':'山西-大同-大同县|shanxi-datong-datongxian|sx-dt-dtx'}]},{'idx':'4,3','code':'140300','name':'阳泉','search':'山西-阳泉|shanxi-yangquanshi|sx-yqs','children':[{'idx':'4,3,0','code':'-1','name':'全市','search':'全市|quansheng|qs'},{'idx':'4,3,1','code':'140301','name':'市辖区','search':'山西-阳泉-市辖区|shanxi-yangquan-shixiaqu|sx-yq-sxq'},{'idx':'4,3,2','code':'140302','name':'城区','search':'山西-阳泉-城区|shanxi-yangquan-chengqu|sx-yq-cq'},{'idx':'4,3,3','code':'140303','name':'矿区','search':'山西-阳泉-矿区|shanxi-yangquan-kuangqu|sx-yq-kq'},{'idx':'4,3,4','code':'140311','name':'郊区','search':'山西-阳泉-郊区|shanxi-yangquan-jiaoqu|sx-yq-jq'},{'idx':'4,3,5','code':'140321','name':'平定县','search':'山西-阳泉-平定县|shanxi-yangquan-pingdingxian|sx-yq-pdx'},{'idx':'4,3,6','code':'140322','name':'盂县','search':'山西-阳泉-盂县|shanxi-yangquan-yuxian|sx-yq-yx'}]},{'idx':'4,4','code':'140400','name':'长治','search':'山西-长治|shanxi-changzhishi|sx-czs','children':[{'idx':'4,4,0','code':'-1','name':'全市','search':'全市|quansheng|qs'},{'idx':'4,4,1','code':'140401','name':'市辖区','search':'山西-长治-市辖区|shanxi-changzhi-shixiaqu|sx-cz-sxq'},{'idx':'4,4,2','code':'140402','name':'城区','search':'山西-长治-城区|shanxi-changzhi-chengqu|sx-cz-cq'},{'idx':'4,4,3','code':'140411','name':'郊区','search':'山西-长治-郊区|shanxi-changzhi-jiaoqu|sx-cz-jq'},{'idx':'4,4,4','code':'140421','name':'长治县','search':'山西-长治-长治县|shanxi-changzhi-changzhixian|sx-cz-czx'},{'idx':'4,4,5','code':'140423','name':'襄垣县','search':'山西-长治-襄垣县|shanxi-changzhi-xiangyuanxian|sx-cz-xyx'},{'idx':'4,4,6','code':'140424','name':'屯留县','search':'山西-长治-屯留县|shanxi-changzhi-tunliuxian|sx-cz-tlx'},{'idx':'4,4,7','code':'140425','name':'平顺县','search':'山西-长治-平顺县|shanxi-changzhi-pingshunxian|sx-cz-psx'},{'idx':'4,4,8','code':'140426','name':'黎城县','search':'山西-长治-黎城县|shanxi-changzhi-lichengxian|sx-cz-lcx'},{'idx':'4,4,9','code':'140427','name':'壶关县','search':'山西-长治-壶关县|shanxi-changzhi-huguanxian|sx-cz-hgx'},{'idx':'4,4,10','code':'140428','name':'长子县','search':'山西-长治-长子县|shanxi-changzhi-changzixian|sx-cz-czx'},{'idx':'4,4,11','code':'140429','name':'武乡县','search':'山西-长治-武乡县|shanxi-changzhi-wuxiangxian|sx-cz-wxx'},{'idx':'4,4,12','code':'140430','name':'沁县','search':'山西-长治-沁县|shanxi-changzhi-qinxian|sx-cz-qx'},{'idx':'4,4,13','code':'140431','name':'沁源县','search':'山西-长治-沁源县|shanxi-changzhi-qinyuanxian|sx-cz-qyx'},{'idx':'4,4,14','code':'140481','name':'潞城市','search':'山西-长治-潞城市|shanxi-changzhi-luchengshi|sx-cz-lcs'}]},{'idx':'4,5','code':'140500','name':'晋城','search':'山西-晋城|shanxi-jinchengshi|sx-jcs','children':[{'idx':'4,5,0','code':'-1','name':'全市','search':'全市|quansheng|qs'},{'idx':'4,5,1','code':'140501','name':'市辖区','search':'山西-晋城-市辖区|shanxi-jincheng-shixiaqu|sx-jc-sxq'},{'idx':'4,5,2','code':'140502','name':'城区','search':'山西-晋城-城区|shanxi-jincheng-chengqu|sx-jc-cq'},{'idx':'4,5,3','code':'140521','name':'沁水县','search':'山西-晋城-沁水县|shanxi-jincheng-qinshuixian|sx-jc-qsx'},{'idx':'4,5,4','code':'140522','name':'阳城县','search':'山西-晋城-阳城县|shanxi-jincheng-yangchengxian|sx-jc-ycx'},{'idx':'4,5,5','code':'140524','name':'陵川县','search':'山西-晋城-陵川县|shanxi-jincheng-lingchuanxian|sx-jc-lcx'},{'idx':'4,5,6','code':'140525','name':'泽州县','search':'山西-晋城-泽州县|shanxi-jincheng-zezhouxian|sx-jc-zzx'},{'idx':'4,5,7','code':'140581','name':'高平市','search':'山西-晋城-高平市|shanxi-jincheng-gaopingshi|sx-jc-gps'}]},{'idx':'4,6','code':'140600','name':'朔州','search':'山西-朔州|shanxi-shuozhoushi|sx-szs','children':[{'idx':'4,6,0','code':'-1','name':'全市','search':'全市|quansheng|qs'},{'idx':'4,6,1','code':'140601','name':'市辖区','search':'山西-朔州-市辖区|shanxi-shuozhou-shixiaqu|sx-sz-sxq'},{'idx':'4,6,2','code':'140602','name':'朔城区','search':'山西-朔州-朔城区|shanxi-shuozhou-shuochengqu|sx-sz-scq'},{'idx':'4,6,3','code':'140603','name':'平鲁区','search':'山西-朔州-平鲁区|shanxi-shuozhou-pingluqu|sx-sz-plq'},{'idx':'4,6,4','code':'140621','name':'山阴县','search':'山西-朔州-山阴县|shanxi-shuozhou-shanyinxian|sx-sz-syx'},{'idx':'4,6,5','code':'140622','name':'应县','search':'山西-朔州-应县|shanxi-shuozhou-yingxian|sx-sz-yx'},{'idx':'4,6,6','code':'140623','name':'右玉县','search':'山西-朔州-右玉县|shanxi-shuozhou-youyuxian|sx-sz-yyx'},{'idx':'4,6,7','code':'140624','name':'怀仁县','search':'山西-朔州-怀仁县|shanxi-shuozhou-huairenxian|sx-sz-hrx'}]},{'idx':'4,7','code':'140700','name':'晋中','search':'山西-晋中|shanxi-jinzhongshi|sx-jzs','children':[{'idx':'4,7,0','code':'-1','name':'全市','search':'全市|quansheng|qs'},{'idx':'4,7,1','code':'140701','name':'市辖区','search':'山西-晋中-市辖区|shanxi-jinzhong-shixiaqu|sx-jz-sxq'},{'idx':'4,7,2','code':'140702','name':'榆次区','search':'山西-晋中-榆次区|shanxi-jinzhong-yuciqu|sx-jz-ycq'},{'idx':'4,7,3','code':'140721','name':'榆社县','search':'山西-晋中-榆社县|shanxi-jinzhong-yushexian|sx-jz-ysx'},{'idx':'4,7,4','code':'140722','name':'左权县','search':'山西-晋中-左权县|shanxi-jinzhong-zuoquanxian|sx-jz-zqx'},{'idx':'4,7,5','code':'140723','name':'和顺县','search':'山西-晋中-和顺县|shanxi-jinzhong-heshunxian|sx-jz-hsx'},{'idx':'4,7,6','code':'140724','name':'昔阳县','search':'山西-晋中-昔阳县|shanxi-jinzhong-xiyangxian|sx-jz-xyx'},{'idx':'4,7,7','code':'140725','name':'寿阳县','search':'山西-晋中-寿阳县|shanxi-jinzhong-shouyangxian|sx-jz-syx'},{'idx':'4,7,8','code':'140726','name':'太谷县','search':'山西-晋中-太谷县|shanxi-jinzhong-taiguxian|sx-jz-tgx'},{'idx':'4,7,9','code':'140727','name':'祁县','search':'山西-晋中-祁县|shanxi-jinzhong-qixian|sx-jz-qx'},{'idx':'4,7,10','code':'140728','name':'平遥县','search':'山西-晋中-平遥县|shanxi-jinzhong-pingyaoxian|sx-jz-pyx'},{'idx':'4,7,11','code':'140729','name':'灵石县','search':'山西-晋中-灵石县|shanxi-jinzhong-lingshixian|sx-jz-lsx'},{'idx':'4,7,12','code':'140781','name':'介休市','search':'山西-晋中-介休市|shanxi-jinzhong-jiexiushi|sx-jz-jxs'}]},{'idx':'4,8','code':'140800','name':'运城','search':'山西-运城|shanxi-yunchengshi|sx-ycs','children':[{'idx':'4,8,0','code':'-1','name':'全市','search':'全市|quansheng|qs'},{'idx':'4,8,1','code':'140801','name':'市辖区','search':'山西-运城-市辖区|shanxi-yuncheng-shixiaqu|sx-yc-sxq'},{'idx':'4,8,2','code':'140802','name':'盐湖区','search':'山西-运城-盐湖区|shanxi-yuncheng-yanhuqu|sx-yc-yhq'},{'idx':'4,8,3','code':'140821','name':'临猗县','search':'山西-运城-临猗县|shanxi-yuncheng-linyixian|sx-yc-lyx'},{'idx':'4,8,4','code':'140822','name':'万荣县','search':'山西-运城-万荣县|shanxi-yuncheng-wanrongxian|sx-yc-wrx'},{'idx':'4,8,5','code':'140823','name':'闻喜县','search':'山西-运城-闻喜县|shanxi-yuncheng-wenxixian|sx-yc-wxx'},{'idx':'4,8,6','code':'140824','name':'稷山县','search':'山西-运城-稷山县|shanxi-yuncheng-jishanxian|sx-yc-jsx'},{'idx':'4,8,7','code':'140825','name':'新绛县','search':'山西-运城-新绛县|shanxi-yuncheng-xinjiangxian|sx-yc-xjx'},{'idx':'4,8,8','code':'140826','name':'绛县','search':'山西-运城-绛县|shanxi-yuncheng-jiangxian|sx-yc-jx'},{'idx':'4,8,9','code':'140827','name':'垣曲县','search':'山西-运城-垣曲县|shanxi-yuncheng-yuanquxian|sx-yc-yqx'},{'idx':'4,8,10','code':'140828','name':'夏县','search':'山西-运城-夏县|shanxi-yuncheng-xiaxian|sx-yc-xx'},{'idx':'4,8,11','code':'140829','name':'平陆县','search':'山西-运城-平陆县|shanxi-yuncheng-pingluxian|sx-yc-plx'},{'idx':'4,8,12','code':'140830','name':'芮城县','search':'山西-运城-芮城县|shanxi-yuncheng-ruichengxian|sx-yc-rcx'},{'idx':'4,8,13','code':'140881','name':'永济市','search':'山西-运城-永济市|shanxi-yuncheng-yongjishi|sx-yc-yjs'},{'idx':'4,8,14','code':'140882','name':'河津市','search':'山西-运城-河津市|shanxi-yuncheng-hejinshi|sx-yc-hjs'}]},{'idx':'4,9','code':'140900','name':'忻州','search':'山西-忻州|shanxi-xinzhoushi|sx-xzs','children':[{'idx':'4,9,0','code':'-1','name':'全市','search':'全市|quansheng|qs'},{'idx':'4,9,1','code':'140901','name':'市辖区','search':'山西-忻州-市辖区|shanxi-xinzhou-shixiaqu|sx-xz-sxq'},{'idx':'4,9,2','code':'140902','name':'忻府区','search':'山西-忻州-忻府区|shanxi-xinzhou-xinfuqu|sx-xz-xfq'},{'idx':'4,9,3','code':'140921','name':'定襄县','search':'山西-忻州-定襄县|shanxi-xinzhou-dingxiangxian|sx-xz-dxx'},{'idx':'4,9,4','code':'140922','name':'五台县','search':'山西-忻州-五台县|shanxi-xinzhou-wutaixian|sx-xz-wtx'},{'idx':'4,9,5','code':'140923','name':'代县','search':'山西-忻州-代县|shanxi-xinzhou-daixian|sx-xz-dx'},{'idx':'4,9,6','code':'140924','name':'繁峙县','search':'山西-忻州-繁峙县|shanxi-xinzhou-fanzhixian|sx-xz-fzx'},{'idx':'4,9,7','code':'140925','name':'宁武县','search':'山西-忻州-宁武县|shanxi-xinzhou-ningwuxian|sx-xz-nwx'},{'idx':'4,9,8','code':'140926','name':'静乐县','search':'山西-忻州-静乐县|shanxi-xinzhou-jinglexian|sx-xz-jlx'},{'idx':'4,9,9','code':'140927','name':'神池县','search':'山西-忻州-神池县|shanxi-xinzhou-shenchixian|sx-xz-scx'},{'idx':'4,9,10','code':'140928','name':'五寨县','search':'山西-忻州-五寨县|shanxi-xinzhou-wuzhaixian|sx-xz-wzx'},{'idx':'4,9,11','code':'140929','name':'岢岚县','search':'山西-忻州-岢岚县|shanxi-xinzhou-kelanxian|sx-xz-klx'},{'idx':'4,9,12','code':'140930','name':'河曲县','search':'山西-忻州-河曲县|shanxi-xinzhou-hequxian|sx-xz-hqx'},{'idx':'4,9,13','code':'140931','name':'保德县','search':'山西-忻州-保德县|shanxi-xinzhou-baodexian|sx-xz-bdx'},{'idx':'4,9,14','code':'140932','name':'偏关县','search':'山西-忻州-偏关县|shanxi-xinzhou-pianguanxian|sx-xz-pgx'},{'idx':'4,9,15','code':'140981','name':'原平市','search':'山西-忻州-原平市|shanxi-xinzhou-yuanpingshi|sx-xz-yps'}]},{'idx':'4,10','code':'141000','name':'临汾','search':'山西-临汾|shanxi-linfenshi|sx-lfs','children':[{'idx':'4,10,0','code':'-1','name':'全市','search':'全市|quansheng|qs'},{'idx':'4,10,1','code':'141001','name':'市辖区','search':'山西-临汾-市辖区|shanxi-linfen-shixiaqu|sx-lf-sxq'},{'idx':'4,10,2','code':'141002','name':'尧都区','search':'山西-临汾-尧都区|shanxi-linfen-yaoduqu|sx-lf-ydq'},{'idx':'4,10,3','code':'141021','name':'曲沃县','search':'山西-临汾-曲沃县|shanxi-linfen-quwoxian|sx-lf-qwx'},{'idx':'4,10,4','code':'141022','name':'翼城县','search':'山西-临汾-翼城县|shanxi-linfen-yichengxian|sx-lf-ycx'},{'idx':'4,10,5','code':'141023','name':'襄汾县','search':'山西-临汾-襄汾县|shanxi-linfen-xiangfenxian|sx-lf-xfx'},{'idx':'4,10,6','code':'141024','name':'洪洞县','search':'山西-临汾-洪洞县|shanxi-linfen-hongdongxian|sx-lf-hdx'},{'idx':'4,10,7','code':'141025','name':'古县','search':'山西-临汾-古县|shanxi-linfen-guxian|sx-lf-gx'},{'idx':'4,10,8','code':'141026','name':'安泽县','search':'山西-临汾-安泽县|shanxi-linfen-anzexian|sx-lf-azx'},{'idx':'4,10,9','code':'141027','name':'浮山县','search':'山西-临汾-浮山县|shanxi-linfen-fushanxian|sx-lf-fsx'},{'idx':'4,10,10','code':'141028','name':'吉县','search':'山西-临汾-吉县|shanxi-linfen-jixian|sx-lf-jx'},{'idx':'4,10,11','code':'141029','name':'乡宁县','search':'山西-临汾-乡宁县|shanxi-linfen-xiangningxian|sx-lf-xnx'},{'idx':'4,10,12','code':'141030','name':'大宁县','search':'山西-临汾-大宁县|shanxi-linfen-daningxian|sx-lf-dnx'},{'idx':'4,10,13','code':'141031','name':'隰县','search':'山西-临汾-隰县|shanxi-linfen-xixian|sx-lf-xx'},{'idx':'4,10,14','code':'141032','name':'永和县','search':'山西-临汾-永和县|shanxi-linfen-yonghexian|sx-lf-yhx'},{'idx':'4,10,15','code':'141033','name':'蒲县','search':'山西-临汾-蒲县|shanxi-linfen-puxian|sx-lf-px'},{'idx':'4,10,16','code':'141034','name':'汾西县','search':'山西-临汾-汾西县|shanxi-linfen-fenxixian|sx-lf-fxx'},{'idx':'4,10,17','code':'141081','name':'侯马市','search':'山西-临汾-侯马市|shanxi-linfen-houmashi|sx-lf-hms'},{'idx':'4,10,18','code':'141082','name':'霍州市','search':'山西-临汾-霍州市|shanxi-linfen-huozhoushi|sx-lf-hzs'}]},{'idx':'4,11','code':'141100','name':'吕梁','search':'山西-吕梁|shanxi-lvliangshi|sx-lls','children':[{'idx':'4,11,0','code':'-1','name':'全市','search':'全市|quansheng|qs'},{'idx':'4,11,1','code':'141101','name':'市辖区','search':'山西-吕梁-市辖区|shanxi-lvliang-shixiaqu|sx-ll-sxq'},{'idx':'4,11,2','code':'141102','name':'离石区','search':'山西-吕梁-离石区|shanxi-lvliang-lishiqu|sx-ll-lsq'},{'idx':'4,11,3','code':'141121','name':'文水县','search':'山西-吕梁-文水县|shanxi-lvliang-wenshuixian|sx-ll-wsx'},{'idx':'4,11,4','code':'141122','name':'交城县','search':'山西-吕梁-交城县|shanxi-lvliang-jiaochengxian|sx-ll-jcx'},{'idx':'4,11,5','code':'141123','name':'兴县','search':'山西-吕梁-兴县|shanxi-lvliang-xingxian|sx-ll-xx'},{'idx':'4,11,6','code':'141124','name':'临县','search':'山西-吕梁-临县|shanxi-lvliang-linxian|sx-ll-lx'},{'idx':'4,11,7','code':'141125','name':'柳林县','search':'山西-吕梁-柳林县|shanxi-lvliang-liulinxian|sx-ll-llx'},{'idx':'4,11,8','code':'141126','name':'石楼县','search':'山西-吕梁-石楼县|shanxi-lvliang-shilouxian|sx-ll-slx'},{'idx':'4,11,9','code':'141127','name':'岚县','search':'山西-吕梁-岚县|shanxi-lvliang-lanxian|sx-ll-lx'},{'idx':'4,11,10','code':'141128','name':'方山县','search':'山西-吕梁-方山县|shanxi-lvliang-fangshanxian|sx-ll-fsx'},{'idx':'4,11,11','code':'141129','name':'中阳县','search':'山西-吕梁-中阳县|shanxi-lvliang-zhongyangxian|sx-ll-zyx'},{'idx':'4,11,12','code':'141130','name':'交口县','search':'山西-吕梁-交口县|shanxi-lvliang-jiaokouxian|sx-ll-jkx'},{'idx':'4,11,13','code':'141181','name':'孝义市','search':'山西-吕梁-孝义市|shanxi-lvliang-xiaoyishi|sx-ll-xys'},{'idx':'4,11,14','code':'141182','name':'汾阳市','search':'山西-吕梁-汾阳市|shanxi-lvliang-fenyangshi|sx-ll-fys'}]}]},{'idx':5,'code':'150000','name':'内蒙古','search':'内蒙古|neimengguzizhiqu|nmgzzq','children':[{'idx':'5,0','code':'-1','name':'全省','search':'全省|quansheng|qs'},{'idx':'5,1','code':'150100','name':'呼和浩特','search':'内蒙古-呼和浩特|neimenggu-huhehaoteshi|nmg-hhhts','children':[{'idx':'5,1,0','code':'-1','name':'全市','search':'全市|quansheng|qs'},{'idx':'5,1,1','code':'150101','name':'市辖区','search':'内蒙古-呼和浩特-市辖区|neimenggu-huhehaote-shixiaqu|nmg-hhht-sxq'},{'idx':'5,1,2','code':'150102','name':'新城区','search':'内蒙古-呼和浩特-新城区|neimenggu-huhehaote-xinchengqu|nmg-hhht-xcq'},{'idx':'5,1,3','code':'150103','name':'回民区','search':'内蒙古-呼和浩特-回民区|neimenggu-huhehaote-huiminqu|nmg-hhht-hmq'},{'idx':'5,1,4','code':'150104','name':'玉泉区','search':'内蒙古-呼和浩特-玉泉区|neimenggu-huhehaote-yuquanqu|nmg-hhht-yqq'},{'idx':'5,1,5','code':'150105','name':'赛罕区','search':'内蒙古-呼和浩特-赛罕区|neimenggu-huhehaote-saihanqu|nmg-hhht-shq'},{'idx':'5,1,6','code':'150121','name':'土默特左旗','search':'内蒙古-呼和浩特-土默特左旗|neimenggu-huhehaote-tumotezuoqi|nmg-hhht-tmtzq'},{'idx':'5,1,7','code':'150122','name':'托克托县','search':'内蒙古-呼和浩特-托克托县|neimenggu-huhehaote-tuoketuoxian|nmg-hhht-tktx'},{'idx':'5,1,8','code':'150123','name':'和林格尔县','search':'内蒙古-呼和浩特-和林格尔县|neimenggu-huhehaote-helingeerxian|nmg-hhht-hlgex'},{'idx':'5,1,9','code':'150124','name':'清水河县','search':'内蒙古-呼和浩特-清水河县|neimenggu-huhehaote-qingshuihexian|nmg-hhht-qshx'},{'idx':'5,1,10','code':'150125','name':'武川县','search':'内蒙古-呼和浩特-武川县|neimenggu-huhehaote-wuchuanxian|nmg-hhht-wcx'}]},{'idx':'5,2','code':'150200','name':'包头','search':'内蒙古-包头|neimenggu-baotoushi|nmg-bts','children':[{'idx':'5,2,0','code':'-1','name':'全市','search':'全市|quansheng|qs'},{'idx':'5,2,1','code':'150201','name':'市辖区','search':'内蒙古-包头-市辖区|neimenggu-baotou-shixiaqu|nmg-bt-sxq'},{'idx':'5,2,2','code':'150202','name':'东河区','search':'内蒙古-包头-东河区|neimenggu-baotou-donghequ|nmg-bt-dhq'},{'idx':'5,2,3','code':'150203','name':'昆都仑区','search':'内蒙古-包头-昆都仑区|neimenggu-baotou-kundulunqu|nmg-bt-kdlq'},{'idx':'5,2,4','code':'150204','name':'青山区','search':'内蒙古-包头-青山区|neimenggu-baotou-qingshanqu|nmg-bt-qsq'},{'idx':'5,2,5','code':'150205','name':'石拐区','search':'内蒙古-包头-石拐区|neimenggu-baotou-shiguaiqu|nmg-bt-sgq'},{'idx':'5,2,6','code':'150206','name':'白云鄂博矿区','search':'内蒙古-包头-白云鄂博矿区|neimenggu-baotou-baiyunebokuangqu|nmg-bt-byebkq'},{'idx':'5,2,7','code':'150207','name':'九原区','search':'内蒙古-包头-九原区|neimenggu-baotou-jiuyuanqu|nmg-bt-jyq'},{'idx':'5,2,8','code':'150221','name':'土默特右旗','search':'内蒙古-包头-土默特右旗|neimenggu-baotou-tumoteyouqi|nmg-bt-tmtyq'},{'idx':'5,2,9','code':'150222','name':'固阳县','search':'内蒙古-包头-固阳县|neimenggu-baotou-guyangxian|nmg-bt-gyx'},{'idx':'5,2,10','code':'150223','name':'达尔罕茂明安联合旗','search':'内蒙古-包头-达尔罕茂明安联合旗|neimenggu-baotou-daerhanmaominganlianheqi|nmg-bt-dehmmalhq'}]},{'idx':'5,3','code':'150300','name':'乌海','search':'内蒙古-乌海|neimenggu-wuhaishi|nmg-whs','children':[{'idx':'5,3,0','code':'-1','name':'全市','search':'全市|quansheng|qs'},{'idx':'5,3,1','code':'150301','name':'市辖区','search':'内蒙古-乌海-市辖区|neimenggu-wuhai-shixiaqu|nmg-wh-sxq'},{'idx':'5,3,2','code':'150302','name':'海勃湾区','search':'内蒙古-乌海-海勃湾区|neimenggu-wuhai-haibowanqu|nmg-wh-hbwq'},{'idx':'5,3,3','code':'150303','name':'海南区','search':'内蒙古-乌海-海南区|neimenggu-wuhai-hainanqu|nmg-wh-hnq'},{'idx':'5,3,4','code':'150304','name':'乌达区','search':'内蒙古-乌海-乌达区|neimenggu-wuhai-wudaqu|nmg-wh-wdq'}]},{'idx':'5,4','code':'150400','name':'赤峰','search':'内蒙古-赤峰|neimenggu-chifengshi|nmg-cfs','children':[{'idx':'5,4,0','code':'-1','name':'全市','search':'全市|quansheng|qs'},{'idx':'5,4,1','code':'150401','name':'市辖区','search':'内蒙古-赤峰-市辖区|neimenggu-chifeng-shixiaqu|nmg-cf-sxq'},{'idx':'5,4,2','code':'150402','name':'红山区','search':'内蒙古-赤峰-红山区|neimenggu-chifeng-hongshanqu|nmg-cf-hsq'},{'idx':'5,4,3','code':'150403','name':'元宝山区','search':'内蒙古-赤峰-元宝山区|neimenggu-chifeng-yuanbaoshanqu|nmg-cf-ybsq'},{'idx':'5,4,4','code':'150404','name':'松山区','search':'内蒙古-赤峰-松山区|neimenggu-chifeng-songshanqu|nmg-cf-ssq'},{'idx':'5,4,5','code':'150421','name':'阿鲁科尔沁旗','search':'内蒙古-赤峰-阿鲁科尔沁旗|neimenggu-chifeng-alukeerqinqi|nmg-cf-alkeqq'},{'idx':'5,4,6','code':'150422','name':'巴林左旗','search':'内蒙古-赤峰-巴林左旗|neimenggu-chifeng-balinzuoqi|nmg-cf-blzq'},{'idx':'5,4,7','code':'150423','name':'巴林右旗','search':'内蒙古-赤峰-巴林右旗|neimenggu-chifeng-balinyouqi|nmg-cf-blyq'},{'idx':'5,4,8','code':'150424','name':'林西县','search':'内蒙古-赤峰-林西县|neimenggu-chifeng-linxixian|nmg-cf-lxx'},{'idx':'5,4,9','code':'150425','name':'克什克腾旗','search':'内蒙古-赤峰-克什克腾旗|neimenggu-chifeng-keshiketengqi|nmg-cf-ksktq'},{'idx':'5,4,10','code':'150426','name':'翁牛特旗','search':'内蒙古-赤峰-翁牛特旗|neimenggu-chifeng-wengniuteqi|nmg-cf-wntq'},{'idx':'5,4,11','code':'150428','name':'喀喇沁旗','search':'内蒙古-赤峰-喀喇沁旗|neimenggu-chifeng-kalaqinqi|nmg-cf-klqq'},{'idx':'5,4,12','code':'150429','name':'宁城县','search':'内蒙古-赤峰-宁城县|neimenggu-chifeng-ningchengxian|nmg-cf-ncx'},{'idx':'5,4,13','code':'150430','name':'敖汉旗','search':'内蒙古-赤峰-敖汉旗|neimenggu-chifeng-aohanqi|nmg-cf-ahq'}]},{'idx':'5,5','code':'150500','name':'通辽','search':'内蒙古-通辽|neimenggu-tongliaoshi|nmg-tls','children':[{'idx':'5,5,0','code':'-1','name':'全市','search':'全市|quansheng|qs'},{'idx':'5,5,1','code':'150501','name':'市辖区','search':'内蒙古-通辽-市辖区|neimenggu-tongliao-shixiaqu|nmg-tl-sxq'},{'idx':'5,5,2','code':'150502','name':'科尔沁区','search':'内蒙古-通辽-科尔沁区|neimenggu-tongliao-keerqinqu|nmg-tl-keqq'},{'idx':'5,5,3','code':'150521','name':'科尔沁左翼中旗','search':'内蒙古-通辽-科尔沁左翼中旗|neimenggu-tongliao-keerqinzuoyizhongqi|nmg-tl-keqzyzq'},{'idx':'5,5,4','code':'150522','name':'科尔沁左翼后旗','search':'内蒙古-通辽-科尔沁左翼后旗|neimenggu-tongliao-keerqinzuoyihouqi|nmg-tl-keqzyhq'},{'idx':'5,5,5','code':'150523','name':'开鲁县','search':'内蒙古-通辽-开鲁县|neimenggu-tongliao-kailuxian|nmg-tl-klx'},{'idx':'5,5,6','code':'150524','name':'库伦旗','search':'内蒙古-通辽-库伦旗|neimenggu-tongliao-kulunqi|nmg-tl-klq'},{'idx':'5,5,7','code':'150525','name':'奈曼旗','search':'内蒙古-通辽-奈曼旗|neimenggu-tongliao-naimanqi|nmg-tl-nmq'},{'idx':'5,5,8','code':'150526','name':'扎鲁特旗','search':'内蒙古-通辽-扎鲁特旗|neimenggu-tongliao-zhaluteqi|nmg-tl-zltq'},{'idx':'5,5,9','code':'150581','name':'霍林郭勒市','search':'内蒙古-通辽-霍林郭勒市|neimenggu-tongliao-huolinguoleshi|nmg-tl-hlgls'}]},{'idx':'5,6','code':'150600','name':'鄂尔多斯','search':'内蒙古-鄂尔多斯|neimenggu-eerduosishi|nmg-eedss','children':[{'idx':'5,6,0','code':'-1','name':'全市','search':'全市|quansheng|qs'},{'idx':'5,6,1','code':'150601','name':'市辖区','search':'内蒙古-鄂尔多斯-市辖区|neimenggu-eerduosi-shixiaqu|nmg-eeds-sxq'},{'idx':'5,6,2','code':'150602','name':'东胜区','search':'内蒙古-鄂尔多斯-东胜区|neimenggu-eerduosi-dongshengqu|nmg-eeds-dsq'},{'idx':'5,6,3','code':'150621','name':'达拉特旗','search':'内蒙古-鄂尔多斯-达拉特旗|neimenggu-eerduosi-dalateqi|nmg-eeds-dltq'},{'idx':'5,6,4','code':'150622','name':'准格尔旗','search':'内蒙古-鄂尔多斯-准格尔旗|neimenggu-eerduosi-zhungeerqi|nmg-eeds-zgeq'},{'idx':'5,6,5','code':'150623','name':'鄂托克前旗','search':'内蒙古-鄂尔多斯-鄂托克前旗|neimenggu-eerduosi-etuokeqianqi|nmg-eeds-etkqq'},{'idx':'5,6,6','code':'150624','name':'鄂托克旗','search':'内蒙古-鄂尔多斯-鄂托克旗|neimenggu-eerduosi-etuokeqi|nmg-eeds-etkq'},{'idx':'5,6,7','code':'150625','name':'杭锦旗','search':'内蒙古-鄂尔多斯-杭锦旗|neimenggu-eerduosi-hangjinqi|nmg-eeds-hjq'},{'idx':'5,6,8','code':'150626','name':'乌审旗','search':'内蒙古-鄂尔多斯-乌审旗|neimenggu-eerduosi-wushenqi|nmg-eeds-wsq'},{'idx':'5,6,9','code':'150627','name':'伊金霍洛旗','search':'内蒙古-鄂尔多斯-伊金霍洛旗|neimenggu-eerduosi-yijinhuoluoqi|nmg-eeds-yjhlq'}]},{'idx':'5,7','code':'150700','name':'呼伦贝尔','search':'内蒙古-呼伦贝尔|neimenggu-hulunbeiershi|nmg-hlbes','children':[{'idx':'5,7,0','code':'-1','name':'全市','search':'全市|quansheng|qs'},{'idx':'5,7,1','code':'150701','name':'市辖区','search':'内蒙古-呼伦贝尔-市辖区|neimenggu-hulunbeier-shixiaqu|nmg-hlbe-sxq'},{'idx':'5,7,2','code':'150702','name':'海拉尔区','search':'内蒙古-呼伦贝尔-海拉尔区|neimenggu-hulunbeier-hailaerqu|nmg-hlbe-hleq'},{'idx':'5,7,3','code':'150703','name':'扎赉诺尔区','search':'内蒙古-呼伦贝尔-扎赉诺尔区|neimenggu-hulunbeier-zhalainuoerqu|nmg-hlbe-zlneq'},{'idx':'5,7,4','code':'150721','name':'阿荣旗','search':'内蒙古-呼伦贝尔-阿荣旗|neimenggu-hulunbeier-arongqi|nmg-hlbe-arq'},{'idx':'5,7,5','code':'150722','name':'莫力达瓦达斡尔族自治旗','search':'内蒙古-呼伦贝尔-莫力达瓦达斡尔族自治旗|neimenggu-hulunbeier-molidawadawoerzuzizhiqi|nmg-hlbe-mldwdwezzzq'},{'idx':'5,7,6','code':'150723','name':'鄂伦春自治旗','search':'内蒙古-呼伦贝尔-鄂伦春自治旗|neimenggu-hulunbeier-elunchunzizhiqi|nmg-hlbe-elczzq'},{'idx':'5,7,7','code':'150724','name':'鄂温克族自治旗','search':'内蒙古-呼伦贝尔-鄂温克族自治旗|neimenggu-hulunbeier-ewenkezuzizhiqi|nmg-hlbe-ewkzzzq'},{'idx':'5,7,8','code':'150725','name':'陈巴尔虎旗','search':'内蒙古-呼伦贝尔-陈巴尔虎旗|neimenggu-hulunbeier-chenbaerhuqi|nmg-hlbe-cbehq'},{'idx':'5,7,9','code':'150726','name':'新巴尔虎左旗','search':'内蒙古-呼伦贝尔-新巴尔虎左旗|neimenggu-hulunbeier-xinbaerhuzuoqi|nmg-hlbe-xbehzq'},{'idx':'5,7,10','code':'150727','name':'新巴尔虎右旗','search':'内蒙古-呼伦贝尔-新巴尔虎右旗|neimenggu-hulunbeier-xinbaerhuyouqi|nmg-hlbe-xbehyq'},{'idx':'5,7,11','code':'150781','name':'满洲里市','search':'内蒙古-呼伦贝尔-满洲里市|neimenggu-hulunbeier-manzhoulishi|nmg-hlbe-mzls'},{'idx':'5,7,12','code':'150782','name':'牙克石市','search':'内蒙古-呼伦贝尔-牙克石市|neimenggu-hulunbeier-yakeshishi|nmg-hlbe-ykss'},{'idx':'5,7,13','code':'150783','name':'扎兰屯市','search':'内蒙古-呼伦贝尔-扎兰屯市|neimenggu-hulunbeier-zhalantunshi|nmg-hlbe-zlts'},{'idx':'5,7,14','code':'150784','name':'额尔古纳市','search':'内蒙古-呼伦贝尔-额尔古纳市|neimenggu-hulunbeier-eergunashi|nmg-hlbe-eegns'},{'idx':'5,7,15','code':'150785','name':'根河市','search':'内蒙古-呼伦贝尔-根河市|neimenggu-hulunbeier-genheshi|nmg-hlbe-ghs'}]},{'idx':'5,8','code':'150800','name':'巴彦淖尔','search':'内蒙古-巴彦淖尔|neimenggu-bayannaoershi|nmg-bynes','children':[{'idx':'5,8,0','code':'-1','name':'全市','search':'全市|quansheng|qs'},{'idx':'5,8,1','code':'150801','name':'市辖区','search':'内蒙古-巴彦淖尔-市辖区|neimenggu-bayannaoer-shixiaqu|nmg-byne-sxq'},{'idx':'5,8,2','code':'150802','name':'临河区','search':'内蒙古-巴彦淖尔-临河区|neimenggu-bayannaoer-linhequ|nmg-byne-lhq'},{'idx':'5,8,3','code':'150821','name':'五原县','search':'内蒙古-巴彦淖尔-五原县|neimenggu-bayannaoer-wuyuanxian|nmg-byne-wyx'},{'idx':'5,8,4','code':'150822','name':'磴口县','search':'内蒙古-巴彦淖尔-磴口县|neimenggu-bayannaoer-dengkouxian|nmg-byne-dkx'},{'idx':'5,8,5','code':'150823','name':'乌拉特前旗','search':'内蒙古-巴彦淖尔-乌拉特前旗|neimenggu-bayannaoer-wulateqianqi|nmg-byne-wltqq'},{'idx':'5,8,6','code':'150824','name':'乌拉特中旗','search':'内蒙古-巴彦淖尔-乌拉特中旗|neimenggu-bayannaoer-wulatezhongqi|nmg-byne-wltzq'},{'idx':'5,8,7','code':'150825','name':'乌拉特后旗','search':'内蒙古-巴彦淖尔-乌拉特后旗|neimenggu-bayannaoer-wulatehouqi|nmg-byne-wlthq'},{'idx':'5,8,8','code':'150826','name':'杭锦后旗','search':'内蒙古-巴彦淖尔-杭锦后旗|neimenggu-bayannaoer-hangjinhouqi|nmg-byne-hjhq'}]},{'idx':'5,9','code':'150900','name':'乌兰察布','search':'内蒙古-乌兰察布|neimenggu-wulanchabushi|nmg-wlcbs','children':[{'idx':'5,9,0','code':'-1','name':'全市','search':'全市|quansheng|qs'},{'idx':'5,9,1','code':'150901','name':'市辖区','search':'内蒙古-乌兰察布-市辖区|neimenggu-wulanchabu-shixiaqu|nmg-wlcb-sxq'},{'idx':'5,9,2','code':'150902','name':'集宁区','search':'内蒙古-乌兰察布-集宁区|neimenggu-wulanchabu-jiningqu|nmg-wlcb-jnq'},{'idx':'5,9,3','code':'150921','name':'卓资县','search':'内蒙古-乌兰察布-卓资县|neimenggu-wulanchabu-zhuozixian|nmg-wlcb-zzx'},{'idx':'5,9,4','code':'150922','name':'化德县','search':'内蒙古-乌兰察布-化德县|neimenggu-wulanchabu-huadexian|nmg-wlcb-hdx'},{'idx':'5,9,5','code':'150923','name':'商都县','search':'内蒙古-乌兰察布-商都县|neimenggu-wulanchabu-shangduxian|nmg-wlcb-sdx'},{'idx':'5,9,6','code':'150924','name':'兴和县','search':'内蒙古-乌兰察布-兴和县|neimenggu-wulanchabu-xinghexian|nmg-wlcb-xhx'},{'idx':'5,9,7','code':'150925','name':'凉城县','search':'内蒙古-乌兰察布-凉城县|neimenggu-wulanchabu-liangchengxian|nmg-wlcb-lcx'},{'idx':'5,9,8','code':'150926','name':'察哈尔右翼前旗','search':'内蒙古-乌兰察布-察哈尔右翼前旗|neimenggu-wulanchabu-chahaeryouyiqianqi|nmg-wlcb-cheyyqq'},{'idx':'5,9,9','code':'150927','name':'察哈尔右翼中旗','search':'内蒙古-乌兰察布-察哈尔右翼中旗|neimenggu-wulanchabu-chahaeryouyizhongqi|nmg-wlcb-cheyyzq'},{'idx':'5,9,10','code':'150928','name':'察哈尔右翼后旗','search':'内蒙古-乌兰察布-察哈尔右翼后旗|neimenggu-wulanchabu-chahaeryouyihouqi|nmg-wlcb-cheyyhq'},{'idx':'5,9,11','code':'150929','name':'四子王旗','search':'内蒙古-乌兰察布-四子王旗|neimenggu-wulanchabu-siziwangqi|nmg-wlcb-szwq'},{'idx':'5,9,12','code':'150981','name':'丰镇市','search':'内蒙古-乌兰察布-丰镇市|neimenggu-wulanchabu-fengzhenshi|nmg-wlcb-fzs'}]},{'idx':'5,10','code':'152200','name':'兴安盟','search':'内蒙古-兴安盟|neimenggu-xinganmeng|nmg-xam','children':[{'idx':'5,10,0','code':'-1','name':'全市','search':'全市|quansheng|qs'},{'idx':'5,10,1','code':'152201','name':'乌兰浩特市','search':'内蒙古-兴安盟-乌兰浩特市|neimenggu-xinganmeng-wulanhaoteshi|nmg-xam-wlhts'},{'idx':'5,10,2','code':'152202','name':'阿尔山市','search':'内蒙古-兴安盟-阿尔山市|neimenggu-xinganmeng-aershanshi|nmg-xam-aess'},{'idx':'5,10,3','code':'152221','name':'科尔沁右翼前旗','search':'内蒙古-兴安盟-科尔沁右翼前旗|neimenggu-xinganmeng-keerqinyouyiqianqi|nmg-xam-keqyyqq'},{'idx':'5,10,4','code':'152222','name':'科尔沁右翼中旗','search':'内蒙古-兴安盟-科尔沁右翼中旗|neimenggu-xinganmeng-keerqinyouyizhongqi|nmg-xam-keqyyzq'},{'idx':'5,10,5','code':'152223','name':'扎赉特旗','search':'内蒙古-兴安盟-扎赉特旗|neimenggu-xinganmeng-zhalaiteqi|nmg-xam-zltq'},{'idx':'5,10,6','code':'152224','name':'突泉县','search':'内蒙古-兴安盟-突泉县|neimenggu-xinganmeng-tuquanxian|nmg-xam-tqx'}]},{'idx':'5,11','code':'152500','name':'锡林郭勒盟','search':'内蒙古-锡林郭勒盟|neimenggu-xilinguolemeng|nmg-xlglm','children':[{'idx':'5,11,0','code':'-1','name':'全市','search':'全市|quansheng|qs'},{'idx':'5,11,1','code':'152501','name':'二连浩特市','search':'内蒙古-锡林郭勒盟-二连浩特市|neimenggu-xilinguolemeng-erlianhaoteshi|nmg-xlglm-elhts'},{'idx':'5,11,2','code':'152502','name':'锡林浩特市','search':'内蒙古-锡林郭勒盟-锡林浩特市|neimenggu-xilinguolemeng-xilinhaoteshi|nmg-xlglm-xlhts'},{'idx':'5,11,3','code':'152522','name':'阿巴嘎旗','search':'内蒙古-锡林郭勒盟-阿巴嘎旗|neimenggu-xilinguolemeng-abagaqi|nmg-xlglm-abgq'},{'idx':'5,11,4','code':'152523','name':'苏尼特左旗','search':'内蒙古-锡林郭勒盟-苏尼特左旗|neimenggu-xilinguolemeng-sunitezuoqi|nmg-xlglm-sntzq'},{'idx':'5,11,5','code':'152524','name':'苏尼特右旗','search':'内蒙古-锡林郭勒盟-苏尼特右旗|neimenggu-xilinguolemeng-suniteyouqi|nmg-xlglm-sntyq'},{'idx':'5,11,6','code':'152525','name':'东乌珠穆沁旗','search':'内蒙古-锡林郭勒盟-东乌珠穆沁旗|neimenggu-xilinguolemeng-dongwuzhumuqinqi|nmg-xlglm-dwzmqq'},{'idx':'5,11,7','code':'152526','name':'西乌珠穆沁旗','search':'内蒙古-锡林郭勒盟-西乌珠穆沁旗|neimenggu-xilinguolemeng-xiwuzhumuqinqi|nmg-xlglm-xwzmqq'},{'idx':'5,11,8','code':'152527','name':'太仆寺旗','search':'内蒙古-锡林郭勒盟-太仆寺旗|neimenggu-xilinguolemeng-taipusiqi|nmg-xlglm-tpsq'},{'idx':'5,11,9','code':'152528','name':'镶黄旗','search':'内蒙古-锡林郭勒盟-镶黄旗|neimenggu-xilinguolemeng-xianghuangqi|nmg-xlglm-xhq'},{'idx':'5,11,10','code':'152529','name':'正镶白旗','search':'内蒙古-锡林郭勒盟-正镶白旗|neimenggu-xilinguolemeng-zhengxiangbaiqi|nmg-xlglm-zxbq'},{'idx':'5,11,11','code':'152530','name':'正蓝旗','search':'内蒙古-锡林郭勒盟-正蓝旗|neimenggu-xilinguolemeng-zhenglanqi|nmg-xlglm-zlq'},{'idx':'5,11,12','code':'152531','name':'多伦县','search':'内蒙古-锡林郭勒盟-多伦县|neimenggu-xilinguolemeng-duolunxian|nmg-xlglm-dlx'}]},{'idx':'5,12','code':'152900','name':'阿拉善盟','search':'内蒙古-阿拉善盟|neimenggu-alashanmeng|nmg-alsm','children':[{'idx':'5,12,0','code':'-1','name':'全市','search':'全市|quansheng|qs'},{'idx':'5,12,1','code':'152921','name':'阿拉善左旗','search':'内蒙古-阿拉善盟-阿拉善左旗|neimenggu-alashanmeng-alashanzuoqi|nmg-alsm-alszq'},{'idx':'5,12,2','code':'152922','name':'阿拉善右旗','search':'内蒙古-阿拉善盟-阿拉善右旗|neimenggu-alashanmeng-alashanyouqi|nmg-alsm-alsyq'},{'idx':'5,12,3','code':'152923','name':'额济纳旗','search':'内蒙古-阿拉善盟-额济纳旗|neimenggu-alashanmeng-ejinaqi|nmg-alsm-ejnq'}]}]},{'idx':6,'code':'210000','name':'辽宁','search':'辽宁|liaoningsheng|lns','children':[{'idx':'6,0','code':'-1','name':'全省','search':'全省|quansheng|qs'},{'idx':'6,1','code':'210100','name':'沈阳','search':'辽宁-沈阳|liaoning-shenyangshi|ln-sys','children':[{'idx':'6,1,0','code':'-1','name':'全市','search':'全市|quansheng|qs'},{'idx':'6,1,1','code':'210101','name':'市辖区','search':'辽宁-沈阳-市辖区|liaoning-shenyang-shixiaqu|ln-sy-sxq'},{'idx':'6,1,2','code':'210102','name':'和平区','search':'辽宁-沈阳-和平区|liaoning-shenyang-hepingqu|ln-sy-hpq'},{'idx':'6,1,3','code':'210103','name':'沈河区','search':'辽宁-沈阳-沈河区|liaoning-shenyang-shenhequ|ln-sy-shq'},{'idx':'6,1,4','code':'210104','name':'大东区','search':'辽宁-沈阳-大东区|liaoning-shenyang-dadongqu|ln-sy-ddq'},{'idx':'6,1,5','code':'210105','name':'皇姑区','search':'辽宁-沈阳-皇姑区|liaoning-shenyang-huangguqu|ln-sy-hgq'},{'idx':'6,1,6','code':'210106','name':'铁西区','search':'辽宁-沈阳-铁西区|liaoning-shenyang-tiexiqu|ln-sy-txq'},{'idx':'6,1,7','code':'210111','name':'苏家屯区','search':'辽宁-沈阳-苏家屯区|liaoning-shenyang-sujiatunqu|ln-sy-sjtq'},{'idx':'6,1,8','code':'210112','name':'浑南区','search':'辽宁-沈阳-浑南区|liaoning-shenyang-hunnanqu|ln-sy-hnq'},{'idx':'6,1,9','code':'210113','name':'沈北新区','search':'辽宁-沈阳-沈北新区|liaoning-shenyang-shenbeixinqu|ln-sy-sbxq'},{'idx':'6,1,10','code':'210114','name':'于洪区','search':'辽宁-沈阳-于洪区|liaoning-shenyang-yuhongqu|ln-sy-yhq'},{'idx':'6,1,11','code':'210122','name':'辽中县','search':'辽宁-沈阳-辽中县|liaoning-shenyang-liaozhongxian|ln-sy-lzx'},{'idx':'6,1,12','code':'210123','name':'康平县','search':'辽宁-沈阳-康平县|liaoning-shenyang-kangpingxian|ln-sy-kpx'},{'idx':'6,1,13','code':'210124','name':'法库县','search':'辽宁-沈阳-法库县|liaoning-shenyang-fakuxian|ln-sy-fkx'},{'idx':'6,1,14','code':'210181','name':'新民市','search':'辽宁-沈阳-新民市|liaoning-shenyang-xinminshi|ln-sy-xms'}]},{'idx':'6,2','code':'210200','name':'大连','search':'辽宁-大连|liaoning-dalianshi|ln-dls','children':[{'idx':'6,2,0','code':'-1','name':'全市','search':'全市|quansheng|qs'},{'idx':'6,2,1','code':'210201','name':'市辖区','search':'辽宁-大连-市辖区|liaoning-dalian-shixiaqu|ln-dl-sxq'},{'idx':'6,2,2','code':'210202','name':'中山区','search':'辽宁-大连-中山区|liaoning-dalian-zhongshanqu|ln-dl-zsq'},{'idx':'6,2,3','code':'210203','name':'西岗区','search':'辽宁-大连-西岗区|liaoning-dalian-xigangqu|ln-dl-xgq'},{'idx':'6,2,4','code':'210204','name':'沙河口区','search':'辽宁-大连-沙河口区|liaoning-dalian-shahekouqu|ln-dl-shkq'},{'idx':'6,2,5','code':'210211','name':'甘井子区','search':'辽宁-大连-甘井子区|liaoning-dalian-ganjingziqu|ln-dl-gjzq'},{'idx':'6,2,6','code':'210212','name':'旅顺口区','search':'辽宁-大连-旅顺口区|liaoning-dalian-lvshunkouqu|ln-dl-lskq'},{'idx':'6,2,7','code':'210213','name':'金州区','search':'辽宁-大连-金州区|liaoning-dalian-jinzhouqu|ln-dl-jzq'},{'idx':'6,2,8','code':'210224','name':'长海县','search':'辽宁-大连-长海县|liaoning-dalian-changhaixian|ln-dl-chx'},{'idx':'6,2,9','code':'210281','name':'瓦房店市','search':'辽宁-大连-瓦房店市|liaoning-dalian-wafangdianshi|ln-dl-wfds'},{'idx':'6,2,10','code':'210282','name':'普兰店市','search':'辽宁-大连-普兰店市|liaoning-dalian-pulandianshi|ln-dl-plds'},{'idx':'6,2,11','code':'210283','name':'庄河市','search':'辽宁-大连-庄河市|liaoning-dalian-zhuangheshi|ln-dl-zhs'}]},{'idx':'6,3','code':'210300','name':'鞍山','search':'辽宁-鞍山|liaoning-anshanshi|ln-ass','children':[{'idx':'6,3,0','code':'-1','name':'全市','search':'全市|quansheng|qs'},{'idx':'6,3,1','code':'210301','name':'市辖区','search':'辽宁-鞍山-市辖区|liaoning-anshan-shixiaqu|ln-as-sxq'},{'idx':'6,3,2','code':'210302','name':'铁东区','search':'辽宁-鞍山-铁东区|liaoning-anshan-tiedongqu|ln-as-tdq'},{'idx':'6,3,3','code':'210303','name':'铁西区','search':'辽宁-鞍山-铁西区|liaoning-anshan-tiexiqu|ln-as-txq'},{'idx':'6,3,4','code':'210304','name':'立山区','search':'辽宁-鞍山-立山区|liaoning-anshan-lishanqu|ln-as-lsq'},{'idx':'6,3,5','code':'210311','name':'千山区','search':'辽宁-鞍山-千山区|liaoning-anshan-qianshanqu|ln-as-qsq'},{'idx':'6,3,6','code':'210321','name':'台安县','search':'辽宁-鞍山-台安县|liaoning-anshan-taianxian|ln-as-tax'},{'idx':'6,3,7','code':'210323','name':'岫岩满族自治县','search':'辽宁-鞍山-岫岩满族自治县|liaoning-anshan-xiuyanmanzuzizhixian|ln-as-xymzzzx'},{'idx':'6,3,8','code':'210381','name':'海城市','search':'辽宁-鞍山-海城市|liaoning-anshan-haichengshi|ln-as-hcs'}]},{'idx':'6,4','code':'210400','name':'抚顺','search':'辽宁-抚顺|liaoning-fushunshi|ln-fss','children':[{'idx':'6,4,0','code':'-1','name':'全市','search':'全市|quansheng|qs'},{'idx':'6,4,1','code':'210401','name':'市辖区','search':'辽宁-抚顺-市辖区|liaoning-fushun-shixiaqu|ln-fs-sxq'},{'idx':'6,4,2','code':'210402','name':'新抚区','search':'辽宁-抚顺-新抚区|liaoning-fushun-xinfuqu|ln-fs-xfq'},{'idx':'6,4,3','code':'210403','name':'东洲区','search':'辽宁-抚顺-东洲区|liaoning-fushun-dongzhouqu|ln-fs-dzq'},{'idx':'6,4,4','code':'210404','name':'望花区','search':'辽宁-抚顺-望花区|liaoning-fushun-wanghuaqu|ln-fs-whq'},{'idx':'6,4,5','code':'210411','name':'顺城区','search':'辽宁-抚顺-顺城区|liaoning-fushun-shunchengqu|ln-fs-scq'},{'idx':'6,4,6','code':'210421','name':'抚顺县','search':'辽宁-抚顺-抚顺县|liaoning-fushun-fushunxian|ln-fs-fsx'},{'idx':'6,4,7','code':'210422','name':'新宾满族自治县','search':'辽宁-抚顺-新宾满族自治县|liaoning-fushun-xinbinmanzuzizhixian|ln-fs-xbmzzzx'},{'idx':'6,4,8','code':'210423','name':'清原满族自治县','search':'辽宁-抚顺-清原满族自治县|liaoning-fushun-qingyuanmanzuzizhixian|ln-fs-qymzzzx'}]},{'idx':'6,5','code':'210500','name':'本溪','search':'辽宁-本溪|liaoning-benxishi|ln-bxs','children':[{'idx':'6,5,0','code':'-1','name':'全市','search':'全市|quansheng|qs'},{'idx':'6,5,1','code':'210501','name':'市辖区','search':'辽宁-本溪-市辖区|liaoning-benxi-shixiaqu|ln-bx-sxq'},{'idx':'6,5,2','code':'210502','name':'平山区','search':'辽宁-本溪-平山区|liaoning-benxi-pingshanqu|ln-bx-psq'},{'idx':'6,5,3','code':'210503','name':'溪湖区','search':'辽宁-本溪-溪湖区|liaoning-benxi-xihuqu|ln-bx-xhq'},{'idx':'6,5,4','code':'210504','name':'明山区','search':'辽宁-本溪-明山区|liaoning-benxi-mingshanqu|ln-bx-msq'},{'idx':'6,5,5','code':'210505','name':'南芬区','search':'辽宁-本溪-南芬区|liaoning-benxi-nanfenqu|ln-bx-nfq'},{'idx':'6,5,6','code':'210521','name':'本溪满族自治县','search':'辽宁-本溪-本溪满族自治县|liaoning-benxi-benximanzuzizhixian|ln-bx-bxmzzzx'},{'idx':'6,5,7','code':'210522','name':'桓仁满族自治县','search':'辽宁-本溪-桓仁满族自治县|liaoning-benxi-huanrenmanzuzizhixian|ln-bx-hrmzzzx'}]},{'idx':'6,6','code':'210600','name':'丹东','search':'辽宁-丹东|liaoning-dandongshi|ln-dds','children':[{'idx':'6,6,0','code':'-1','name':'全市','search':'全市|quansheng|qs'},{'idx':'6,6,1','code':'210601','name':'市辖区','search':'辽宁-丹东-市辖区|liaoning-dandong-shixiaqu|ln-dd-sxq'},{'idx':'6,6,2','code':'210602','name':'元宝区','search':'辽宁-丹东-元宝区|liaoning-dandong-yuanbaoqu|ln-dd-ybq'},{'idx':'6,6,3','code':'210603','name':'振兴区','search':'辽宁-丹东-振兴区|liaoning-dandong-zhenxingqu|ln-dd-zxq'},{'idx':'6,6,4','code':'210604','name':'振安区','search':'辽宁-丹东-振安区|liaoning-dandong-zhenanqu|ln-dd-zaq'},{'idx':'6,6,5','code':'210624','name':'宽甸满族自治县','search':'辽宁-丹东-宽甸满族自治县|liaoning-dandong-kuandianmanzuzizhixian|ln-dd-kdmzzzx'},{'idx':'6,6,6','code':'210681','name':'东港市','search':'辽宁-丹东-东港市|liaoning-dandong-donggangshi|ln-dd-dgs'},{'idx':'6,6,7','code':'210682','name':'凤城市','search':'辽宁-丹东-凤城市|liaoning-dandong-fengchengshi|ln-dd-fcs'}]},{'idx':'6,7','code':'210700','name':'锦州','search':'辽宁-锦州|liaoning-jinzhoushi|ln-jzs','children':[{'idx':'6,7,0','code':'-1','name':'全市','search':'全市|quansheng|qs'},{'idx':'6,7,1','code':'210701','name':'市辖区','search':'辽宁-锦州-市辖区|liaoning-jinzhou-shixiaqu|ln-jz-sxq'},{'idx':'6,7,2','code':'210702','name':'古塔区','search':'辽宁-锦州-古塔区|liaoning-jinzhou-gutaqu|ln-jz-gtq'},{'idx':'6,7,3','code':'210703','name':'凌河区','search':'辽宁-锦州-凌河区|liaoning-jinzhou-linghequ|ln-jz-lhq'},{'idx':'6,7,4','code':'210711','name':'太和区','search':'辽宁-锦州-太和区|liaoning-jinzhou-taihequ|ln-jz-thq'},{'idx':'6,7,5','code':'210726','name':'黑山县','search':'辽宁-锦州-黑山县|liaoning-jinzhou-heishanxian|ln-jz-hsx'},{'idx':'6,7,6','code':'210727','name':'义县','search':'辽宁-锦州-义县|liaoning-jinzhou-yixian|ln-jz-yx'},{'idx':'6,7,7','code':'210781','name':'凌海市','search':'辽宁-锦州-凌海市|liaoning-jinzhou-linghaishi|ln-jz-lhs'},{'idx':'6,7,8','code':'210782','name':'北镇市','search':'辽宁-锦州-北镇市|liaoning-jinzhou-beizhenshi|ln-jz-bzs'}]},{'idx':'6,8','code':'210800','name':'营口','search':'辽宁-营口|liaoning-yingkoushi|ln-yks','children':[{'idx':'6,8,0','code':'-1','name':'全市','search':'全市|quansheng|qs'},{'idx':'6,8,1','code':'210801','name':'市辖区','search':'辽宁-营口-市辖区|liaoning-yingkou-shixiaqu|ln-yk-sxq'},{'idx':'6,8,2','code':'210802','name':'站前区','search':'辽宁-营口-站前区|liaoning-yingkou-zhanqianqu|ln-yk-zqq'},{'idx':'6,8,3','code':'210803','name':'西市区','search':'辽宁-营口-西市区|liaoning-yingkou-xishiqu|ln-yk-xsq'},{'idx':'6,8,4','code':'210804','name':'鲅鱼圈区','search':'辽宁-营口-鲅鱼圈区|liaoning-yingkou-bayuquanqu|ln-yk-byqq'},{'idx':'6,8,5','code':'210811','name':'老边区','search':'辽宁-营口-老边区|liaoning-yingkou-laobianqu|ln-yk-lbq'},{'idx':'6,8,6','code':'210881','name':'盖州市','search':'辽宁-营口-盖州市|liaoning-yingkou-gaizhoushi|ln-yk-gzs'},{'idx':'6,8,7','code':'210882','name':'大石桥市','search':'辽宁-营口-大石桥市|liaoning-yingkou-dashiqiaoshi|ln-yk-dsqs'}]},{'idx':'6,9','code':'210900','name':'阜新','search':'辽宁-阜新|liaoning-fuxinshi|ln-fxs','children':[{'idx':'6,9,0','code':'-1','name':'全市','search':'全市|quansheng|qs'},{'idx':'6,9,1','code':'210901','name':'市辖区','search':'辽宁-阜新-市辖区|liaoning-fuxin-shixiaqu|ln-fx-sxq'},{'idx':'6,9,2','code':'210902','name':'海州区','search':'辽宁-阜新-海州区|liaoning-fuxin-haizhouqu|ln-fx-hzq'},{'idx':'6,9,3','code':'210903','name':'新邱区','search':'辽宁-阜新-新邱区|liaoning-fuxin-xinqiuqu|ln-fx-xqq'},{'idx':'6,9,4','code':'210904','name':'太平区','search':'辽宁-阜新-太平区|liaoning-fuxin-taipingqu|ln-fx-tpq'},{'idx':'6,9,5','code':'210905','name':'清河门区','search':'辽宁-阜新-清河门区|liaoning-fuxin-qinghemenqu|ln-fx-qhmq'},{'idx':'6,9,6','code':'210911','name':'细河区','search':'辽宁-阜新-细河区|liaoning-fuxin-xihequ|ln-fx-xhq'},{'idx':'6,9,7','code':'210921','name':'阜新蒙古族自治县','search':'辽宁-阜新-阜新蒙古族自治县|liaoning-fuxin-fuxinmengguzuzizhixian|ln-fx-fxmgzzzx'},{'idx':'6,9,8','code':'210922','name':'彰武县','search':'辽宁-阜新-彰武县|liaoning-fuxin-zhangwuxian|ln-fx-zwx'}]},{'idx':'6,10','code':'211000','name':'辽阳','search':'辽宁-辽阳|liaoning-liaoyangshi|ln-lys','children':[{'idx':'6,10,0','code':'-1','name':'全市','search':'全市|quansheng|qs'},{'idx':'6,10,1','code':'211001','name':'市辖区','search':'辽宁-辽阳-市辖区|liaoning-liaoyang-shixiaqu|ln-ly-sxq'},{'idx':'6,10,2','code':'211002','name':'白塔区','search':'辽宁-辽阳-白塔区|liaoning-liaoyang-baitaqu|ln-ly-btq'},{'idx':'6,10,3','code':'211003','name':'文圣区','search':'辽宁-辽阳-文圣区|liaoning-liaoyang-wenshengqu|ln-ly-wsq'},{'idx':'6,10,4','code':'211004','name':'宏伟区','search':'辽宁-辽阳-宏伟区|liaoning-liaoyang-hongweiqu|ln-ly-hwq'},{'idx':'6,10,5','code':'211005','name':'弓长岭区','search':'辽宁-辽阳-弓长岭区|liaoning-liaoyang-gongchanglingqu|ln-ly-gclq'},{'idx':'6,10,6','code':'211011','name':'太子河区','search':'辽宁-辽阳-太子河区|liaoning-liaoyang-taizihequ|ln-ly-tzhq'},{'idx':'6,10,7','code':'211021','name':'辽阳县','search':'辽宁-辽阳-辽阳县|liaoning-liaoyang-liaoyangxian|ln-ly-lyx'},{'idx':'6,10,8','code':'211081','name':'灯塔市','search':'辽宁-辽阳-灯塔市|liaoning-liaoyang-dengtashi|ln-ly-dts'}]},{'idx':'6,11','code':'211100','name':'盘锦','search':'辽宁-盘锦|liaoning-panjinshi|ln-pjs','children':[{'idx':'6,11,0','code':'-1','name':'全市','search':'全市|quansheng|qs'},{'idx':'6,11,1','code':'211101','name':'市辖区','search':'辽宁-盘锦-市辖区|liaoning-panjin-shixiaqu|ln-pj-sxq'},{'idx':'6,11,2','code':'211102','name':'双台子区','search':'辽宁-盘锦-双台子区|liaoning-panjin-shuangtaiziqu|ln-pj-stzq'},{'idx':'6,11,3','code':'211103','name':'兴隆台区','search':'辽宁-盘锦-兴隆台区|liaoning-panjin-xinglongtaiqu|ln-pj-xltq'},{'idx':'6,11,4','code':'211121','name':'大洼县','search':'辽宁-盘锦-大洼县|liaoning-panjin-dawaxian|ln-pj-dwx'},{'idx':'6,11,5','code':'211122','name':'盘山县','search':'辽宁-盘锦-盘山县|liaoning-panjin-panshanxian|ln-pj-psx'}]},{'idx':'6,12','code':'211200','name':'铁岭','search':'辽宁-铁岭|liaoning-tielingshi|ln-tls','children':[{'idx':'6,12,0','code':'-1','name':'全市','search':'全市|quansheng|qs'},{'idx':'6,12,1','code':'211201','name':'市辖区','search':'辽宁-铁岭-市辖区|liaoning-tieling-shixiaqu|ln-tl-sxq'},{'idx':'6,12,2','code':'211202','name':'银州区','search':'辽宁-铁岭-银州区|liaoning-tieling-yinzhouqu|ln-tl-yzq'},{'idx':'6,12,3','code':'211204','name':'清河区','search':'辽宁-铁岭-清河区|liaoning-tieling-qinghequ|ln-tl-qhq'},{'idx':'6,12,4','code':'211221','name':'铁岭县','search':'辽宁-铁岭-铁岭县|liaoning-tieling-tielingxian|ln-tl-tlx'},{'idx':'6,12,5','code':'211223','name':'西丰县','search':'辽宁-铁岭-西丰县|liaoning-tieling-xifengxian|ln-tl-xfx'},{'idx':'6,12,6','code':'211224','name':'昌图县','search':'辽宁-铁岭-昌图县|liaoning-tieling-changtuxian|ln-tl-ctx'},{'idx':'6,12,7','code':'211281','name':'调兵山市','search':'辽宁-铁岭-调兵山市|liaoning-tieling-diaobingshanshi|ln-tl-dbss'},{'idx':'6,12,8','code':'211282','name':'开原市','search':'辽宁-铁岭-开原市|liaoning-tieling-kaiyuanshi|ln-tl-kys'}]},{'idx':'6,13','code':'211300','name':'朝阳','search':'辽宁-朝阳|liaoning-chaoyangshi|ln-cys','children':[{'idx':'6,13,0','code':'-1','name':'全市','search':'全市|quansheng|qs'},{'idx':'6,13,1','code':'211301','name':'市辖区','search':'辽宁-朝阳-市辖区|liaoning-chaoyang-shixiaqu|ln-cy-sxq'},{'idx':'6,13,2','code':'211302','name':'双塔区','search':'辽宁-朝阳-双塔区|liaoning-chaoyang-shuangtaqu|ln-cy-stq'},{'idx':'6,13,3','code':'211303','name':'龙城区','search':'辽宁-朝阳-龙城区|liaoning-chaoyang-longchengqu|ln-cy-lcq'},{'idx':'6,13,4','code':'211321','name':'朝阳县','search':'辽宁-朝阳-朝阳县|liaoning-chaoyang-chaoyangxian|ln-cy-cyx'},{'idx':'6,13,5','code':'211322','name':'建平县','search':'辽宁-朝阳-建平县|liaoning-chaoyang-jianpingxian|ln-cy-jpx'},{'idx':'6,13,6','code':'211324','name':'喀喇沁左翼蒙古族自治县','search':'辽宁-朝阳-喀喇沁左翼蒙古族自治县|liaoning-chaoyang-kalaqinzuoyimengguzuzizhixian|ln-cy-klqzymgzzzx'},{'idx':'6,13,7','code':'211381','name':'北票市','search':'辽宁-朝阳-北票市|liaoning-chaoyang-beipiaoshi|ln-cy-bps'},{'idx':'6,13,8','code':'211382','name':'凌源市','search':'辽宁-朝阳-凌源市|liaoning-chaoyang-lingyuanshi|ln-cy-lys'}]},{'idx':'6,14','code':'211400','name':'葫芦岛','search':'辽宁-葫芦岛|liaoning-huludaoshi|ln-hlds','children':[{'idx':'6,14,0','code':'-1','name':'全市','search':'全市|quansheng|qs'},{'idx':'6,14,1','code':'211401','name':'市辖区','search':'辽宁-葫芦岛-市辖区|liaoning-huludao-shixiaqu|ln-hld-sxq'},{'idx':'6,14,2','code':'211402','name':'连山区','search':'辽宁-葫芦岛-连山区|liaoning-huludao-lianshanqu|ln-hld-lsq'},{'idx':'6,14,3','code':'211403','name':'龙港区','search':'辽宁-葫芦岛-龙港区|liaoning-huludao-longgangqu|ln-hld-lgq'},{'idx':'6,14,4','code':'211404','name':'南票区','search':'辽宁-葫芦岛-南票区|liaoning-huludao-nanpiaoqu|ln-hld-npq'},{'idx':'6,14,5','code':'211421','name':'绥中县','search':'辽宁-葫芦岛-绥中县|liaoning-huludao-suizhongxian|ln-hld-szx'},{'idx':'6,14,6','code':'211422','name':'建昌县','search':'辽宁-葫芦岛-建昌县|liaoning-huludao-jianchangxian|ln-hld-jcx'},{'idx':'6,14,7','code':'211481','name':'兴城市','search':'辽宁-葫芦岛-兴城市|liaoning-huludao-xingchengshi|ln-hld-xcs'}]}]},{'idx':7,'code':'220000','name':'吉林','search':'吉林|jilinsheng|jls','children':[{'idx':'7,0','code':'-1','name':'全省','search':'全省|quansheng|qs'},{'idx':'7,1','code':'220100','name':'长春','search':'吉林-长春|jilin-changchunshi|jl-ccs','children':[{'idx':'7,1,0','code':'-1','name':'全市','search':'全市|quansheng|qs'},{'idx':'7,1,1','code':'220101','name':'市辖区','search':'吉林-长春-市辖区|jilin-changchun-shixiaqu|jl-cc-sxq'},{'idx':'7,1,2','code':'220102','name':'南关区','search':'吉林-长春-南关区|jilin-changchun-nanguanqu|jl-cc-ngq'},{'idx':'7,1,3','code':'220103','name':'宽城区','search':'吉林-长春-宽城区|jilin-changchun-kuanchengqu|jl-cc-kcq'},{'idx':'7,1,4','code':'220104','name':'朝阳区','search':'吉林-长春-朝阳区|jilin-changchun-chaoyangqu|jl-cc-cyq'},{'idx':'7,1,5','code':'220105','name':'二道区','search':'吉林-长春-二道区|jilin-changchun-erdaoqu|jl-cc-edq'},{'idx':'7,1,6','code':'220106','name':'绿园区','search':'吉林-长春-绿园区|jilin-changchun-lvyuanqu|jl-cc-lyq'},{'idx':'7,1,7','code':'220112','name':'双阳区','search':'吉林-长春-双阳区|jilin-changchun-shuangyangqu|jl-cc-syq'},{'idx':'7,1,8','code':'220113','name':'九台区','search':'吉林-长春-九台区|jilin-changchun-jiutaiqu|jl-cc-jtq'},{'idx':'7,1,9','code':'220122','name':'农安县','search':'吉林-长春-农安县|jilin-changchun-nonganxian|jl-cc-nax'},{'idx':'7,1,10','code':'220182','name':'榆树市','search':'吉林-长春-榆树市|jilin-changchun-yushushi|jl-cc-yss'},{'idx':'7,1,11','code':'220183','name':'德惠市','search':'吉林-长春-德惠市|jilin-changchun-dehuishi|jl-cc-dhs'}]},{'idx':'7,2','code':'220200','name':'吉林','search':'吉林-吉林|jilin-jilinshi|jl-jls','children':[{'idx':'7,2,0','code':'-1','name':'全市','search':'全市|quansheng|qs'},{'idx':'7,2,1','code':'220201','name':'市辖区','search':'吉林-吉林-市辖区|jilin-jilin-shixiaqu|jl-jl-sxq'},{'idx':'7,2,2','code':'220202','name':'昌邑区','search':'吉林-吉林-昌邑区|jilin-jilin-changyiqu|jl-jl-cyq'},{'idx':'7,2,3','code':'220203','name':'龙潭区','search':'吉林-吉林-龙潭区|jilin-jilin-longtanqu|jl-jl-ltq'},{'idx':'7,2,4','code':'220204','name':'船营区','search':'吉林-吉林-船营区|jilin-jilin-chuanyingqu|jl-jl-cyq'},{'idx':'7,2,5','code':'220211','name':'丰满区','search':'吉林-吉林-丰满区|jilin-jilin-fengmanqu|jl-jl-fmq'},{'idx':'7,2,6','code':'220221','name':'永吉县','search':'吉林-吉林-永吉县|jilin-jilin-yongjixian|jl-jl-yjx'},{'idx':'7,2,7','code':'220281','name':'蛟河市','search':'吉林-吉林-蛟河市|jilin-jilin-jiaoheshi|jl-jl-jhs'},{'idx':'7,2,8','code':'220282','name':'桦甸市','search':'吉林-吉林-桦甸市|jilin-jilin-huadianshi|jl-jl-hds'},{'idx':'7,2,9','code':'220283','name':'舒兰市','search':'吉林-吉林-舒兰市|jilin-jilin-shulanshi|jl-jl-sls'},{'idx':'7,2,10','code':'220284','name':'磐石市','search':'吉林-吉林-磐石市|jilin-jilin-panshishi|jl-jl-pss'}]},{'idx':'7,3','code':'220300','name':'四平','search':'吉林-四平|jilin-sipingshi|jl-sps','children':[{'idx':'7,3,0','code':'-1','name':'全市','search':'全市|quansheng|qs'},{'idx':'7,3,1','code':'220301','name':'市辖区','search':'吉林-四平-市辖区|jilin-siping-shixiaqu|jl-sp-sxq'},{'idx':'7,3,2','code':'220302','name':'铁西区','search':'吉林-四平-铁西区|jilin-siping-tiexiqu|jl-sp-txq'},{'idx':'7,3,3','code':'220303','name':'铁东区','search':'吉林-四平-铁东区|jilin-siping-tiedongqu|jl-sp-tdq'},{'idx':'7,3,4','code':'220322','name':'梨树县','search':'吉林-四平-梨树县|jilin-siping-lishuxian|jl-sp-lsx'},{'idx':'7,3,5','code':'220323','name':'伊通满族自治县','search':'吉林-四平-伊通满族自治县|jilin-siping-yitongmanzuzizhixian|jl-sp-ytmzzzx'},{'idx':'7,3,6','code':'220381','name':'公主岭市','search':'吉林-四平-公主岭市|jilin-siping-gongzhulingshi|jl-sp-gzls'},{'idx':'7,3,7','code':'220382','name':'双辽市','search':'吉林-四平-双辽市|jilin-siping-shuangliaoshi|jl-sp-sls'}]},{'idx':'7,4','code':'220400','name':'辽源','search':'吉林-辽源|jilin-liaoyuanshi|jl-lys','children':[{'idx':'7,4,0','code':'-1','name':'全市','search':'全市|quansheng|qs'},{'idx':'7,4,1','code':'220401','name':'市辖区','search':'吉林-辽源-市辖区|jilin-liaoyuan-shixiaqu|jl-ly-sxq'},{'idx':'7,4,2','code':'220402','name':'龙山区','search':'吉林-辽源-龙山区|jilin-liaoyuan-longshanqu|jl-ly-lsq'},{'idx':'7,4,3','code':'220403','name':'西安区','search':'吉林-辽源-西安区|jilin-liaoyuan-xianqu|jl-ly-xaq'},{'idx':'7,4,4','code':'220421','name':'东丰县','search':'吉林-辽源-东丰县|jilin-liaoyuan-dongfengxian|jl-ly-dfx'},{'idx':'7,4,5','code':'220422','name':'东辽县','search':'吉林-辽源-东辽县|jilin-liaoyuan-dongliaoxian|jl-ly-dlx'}]},{'idx':'7,5','code':'220500','name':'通化','search':'吉林-通化|jilin-tonghuashi|jl-ths','children':[{'idx':'7,5,0','code':'-1','name':'全市','search':'全市|quansheng|qs'},{'idx':'7,5,1','code':'220501','name':'市辖区','search':'吉林-通化-市辖区|jilin-tonghua-shixiaqu|jl-th-sxq'},{'idx':'7,5,2','code':'220502','name':'东昌区','search':'吉林-通化-东昌区|jilin-tonghua-dongchangqu|jl-th-dcq'},{'idx':'7,5,3','code':'220503','name':'二道江区','search':'吉林-通化-二道江区|jilin-tonghua-erdaojiangqu|jl-th-edjq'},{'idx':'7,5,4','code':'220521','name':'通化县','search':'吉林-通化-通化县|jilin-tonghua-tonghuaxian|jl-th-thx'},{'idx':'7,5,5','code':'220523','name':'辉南县','search':'吉林-通化-辉南县|jilin-tonghua-huinanxian|jl-th-hnx'},{'idx':'7,5,6','code':'220524','name':'柳河县','search':'吉林-通化-柳河县|jilin-tonghua-liuhexian|jl-th-lhx'},{'idx':'7,5,7','code':'220581','name':'梅河口市','search':'吉林-通化-梅河口市|jilin-tonghua-meihekoushi|jl-th-mhks'},{'idx':'7,5,8','code':'220582','name':'集安市','search':'吉林-通化-集安市|jilin-tonghua-jianshi|jl-th-jas'}]},{'idx':'7,6','code':'220600','name':'白山','search':'吉林-白山|jilin-baishanshi|jl-bss','children':[{'idx':'7,6,0','code':'-1','name':'全市','search':'全市|quansheng|qs'},{'idx':'7,6,1','code':'220601','name':'市辖区','search':'吉林-白山-市辖区|jilin-baishan-shixiaqu|jl-bs-sxq'},{'idx':'7,6,2','code':'220602','name':'浑江区','search':'吉林-白山-浑江区|jilin-baishan-hunjiangqu|jl-bs-hjq'},{'idx':'7,6,3','code':'220605','name':'江源区','search':'吉林-白山-江源区|jilin-baishan-jiangyuanqu|jl-bs-jyq'},{'idx':'7,6,4','code':'220621','name':'抚松县','search':'吉林-白山-抚松县|jilin-baishan-fusongxian|jl-bs-fsx'},{'idx':'7,6,5','code':'220622','name':'靖宇县','search':'吉林-白山-靖宇县|jilin-baishan-jingyuxian|jl-bs-jyx'},{'idx':'7,6,6','code':'220623','name':'长白朝鲜族自治县','search':'吉林-白山-长白朝鲜族自治县|jilin-baishan-changbaichaoxianzuzizhixian|jl-bs-cbcxzzzx'},{'idx':'7,6,7','code':'220681','name':'临江市','search':'吉林-白山-临江市|jilin-baishan-linjiangshi|jl-bs-ljs'}]},{'idx':'7,7','code':'220700','name':'松原','search':'吉林-松原|jilin-songyuanshi|jl-sys','children':[{'idx':'7,7,0','code':'-1','name':'全市','search':'全市|quansheng|qs'},{'idx':'7,7,1','code':'220701','name':'市辖区','search':'吉林-松原-市辖区|jilin-songyuan-shixiaqu|jl-sy-sxq'},{'idx':'7,7,2','code':'220702','name':'宁江区','search':'吉林-松原-宁江区|jilin-songyuan-ningjiangqu|jl-sy-njq'},{'idx':'7,7,3','code':'220721','name':'前郭尔罗斯蒙古族自治县','search':'吉林-松原-前郭尔罗斯蒙古族自治县|jilin-songyuan-qianguoerluosimengguzuzizhixian|jl-sy-qgelsmgzzzx'},{'idx':'7,7,4','code':'220722','name':'长岭县','search':'吉林-松原-长岭县|jilin-songyuan-changlingxian|jl-sy-clx'},{'idx':'7,7,5','code':'220723','name':'乾安县','search':'吉林-松原-乾安县|jilin-songyuan-qiananxian|jl-sy-qax'},{'idx':'7,7,6','code':'220781','name':'扶余市','search':'吉林-松原-扶余市|jilin-songyuan-fuyushi|jl-sy-fys'}]},{'idx':'7,8','code':'220800','name':'白城','search':'吉林-白城|jilin-baichengshi|jl-bcs','children':[{'idx':'7,8,0','code':'-1','name':'全市','search':'全市|quansheng|qs'},{'idx':'7,8,1','code':'220801','name':'市辖区','search':'吉林-白城-市辖区|jilin-baicheng-shixiaqu|jl-bc-sxq'},{'idx':'7,8,2','code':'220802','name':'洮北区','search':'吉林-白城-洮北区|jilin-baicheng-taobeiqu|jl-bc-tbq'},{'idx':'7,8,3','code':'220821','name':'镇赉县','search':'吉林-白城-镇赉县|jilin-baicheng-zhenlaixian|jl-bc-zlx'},{'idx':'7,8,4','code':'220822','name':'通榆县','search':'吉林-白城-通榆县|jilin-baicheng-tongyuxian|jl-bc-tyx'},{'idx':'7,8,5','code':'220881','name':'洮南市','search':'吉林-白城-洮南市|jilin-baicheng-taonanshi|jl-bc-tns'},{'idx':'7,8,6','code':'220882','name':'大安市','search':'吉林-白城-大安市|jilin-baicheng-daanshi|jl-bc-das'}]},{'idx':'7,9','code':'222400','name':'延边朝鲜族','search':'吉林-延边朝鲜族|jilin-yanbianchaoxianzuzizhizhou|jl-ybcxzzzz','children':[{'idx':'7,9,0','code':'-1','name':'全市','search':'全市|quansheng|qs'},{'idx':'7,9,1','code':'222401','name':'延吉市','search':'吉林-延边朝鲜族-延吉市|jilin-yanbianchaoxianzu-yanjishi|jl-ybcxz-yjs'},{'idx':'7,9,2','code':'222402','name':'图们市','search':'吉林-延边朝鲜族-图们市|jilin-yanbianchaoxianzu-tumenshi|jl-ybcxz-tms'},{'idx':'7,9,3','code':'222403','name':'敦化市','search':'吉林-延边朝鲜族-敦化市|jilin-yanbianchaoxianzu-dunhuashi|jl-ybcxz-dhs'},{'idx':'7,9,4','code':'222404','name':'珲春市','search':'吉林-延边朝鲜族-珲春市|jilin-yanbianchaoxianzu-huichunshi|jl-ybcxz-hcs'},{'idx':'7,9,5','code':'222405','name':'龙井市','search':'吉林-延边朝鲜族-龙井市|jilin-yanbianchaoxianzu-longjingshi|jl-ybcxz-ljs'},{'idx':'7,9,6','code':'222406','name':'和龙市','search':'吉林-延边朝鲜族-和龙市|jilin-yanbianchaoxianzu-helongshi|jl-ybcxz-hls'},{'idx':'7,9,7','code':'222424','name':'汪清县','search':'吉林-延边朝鲜族-汪清县|jilin-yanbianchaoxianzu-wangqingxian|jl-ybcxz-wqx'},{'idx':'7,9,8','code':'222426','name':'安图县','search':'吉林-延边朝鲜族-安图县|jilin-yanbianchaoxianzu-antuxian|jl-ybcxz-atx'}]}]},{'idx':8,'code':'230000','name':'黑龙江','search':'黑龙江|heilongjiangsheng|hljs','children':[{'idx':'8,0','code':'-1','name':'全省','search':'全省|quansheng|qs'},{'idx':'8,1','code':'230100','name':'哈尔滨','search':'黑龙江-哈尔滨|heilongjiang-haerbinshi|hlj-hebs','children':[{'idx':'8,1,0','code':'-1','name':'全市','search':'全市|quansheng|qs'},{'idx':'8,1,1','code':'230101','name':'市辖区','search':'黑龙江-哈尔滨-市辖区|heilongjiang-haerbin-shixiaqu|hlj-heb-sxq'},{'idx':'8,1,2','code':'230102','name':'道里区','search':'黑龙江-哈尔滨-道里区|heilongjiang-haerbin-daoliqu|hlj-heb-dlq'},{'idx':'8,1,3','code':'230103','name':'南岗区','search':'黑龙江-哈尔滨-南岗区|heilongjiang-haerbin-nangangqu|hlj-heb-ngq'},{'idx':'8,1,4','code':'230104','name':'道外区','search':'黑龙江-哈尔滨-道外区|heilongjiang-haerbin-daowaiqu|hlj-heb-dwq'},{'idx':'8,1,5','code':'230108','name':'平房区','search':'黑龙江-哈尔滨-平房区|heilongjiang-haerbin-pingfangqu|hlj-heb-pfq'},{'idx':'8,1,6','code':'230109','name':'松北区','search':'黑龙江-哈尔滨-松北区|heilongjiang-haerbin-songbeiqu|hlj-heb-sbq'},{'idx':'8,1,7','code':'230110','name':'香坊区','search':'黑龙江-哈尔滨-香坊区|heilongjiang-haerbin-xiangfangqu|hlj-heb-xfq'},{'idx':'8,1,8','code':'230111','name':'呼兰区','search':'黑龙江-哈尔滨-呼兰区|heilongjiang-haerbin-hulanqu|hlj-heb-hlq'},{'idx':'8,1,9','code':'230112','name':'阿城区','search':'黑龙江-哈尔滨-阿城区|heilongjiang-haerbin-achengqu|hlj-heb-acq'},{'idx':'8,1,10','code':'230113','name':'双城区','search':'黑龙江-哈尔滨-双城区|heilongjiang-haerbin-shuangchengqu|hlj-heb-scq'},{'idx':'8,1,11','code':'230123','name':'依兰县','search':'黑龙江-哈尔滨-依兰县|heilongjiang-haerbin-yilanxian|hlj-heb-ylx'},{'idx':'8,1,12','code':'230124','name':'方正县','search':'黑龙江-哈尔滨-方正县|heilongjiang-haerbin-fangzhengxian|hlj-heb-fzx'},{'idx':'8,1,13','code':'230125','name':'宾县','search':'黑龙江-哈尔滨-宾县|heilongjiang-haerbin-binxian|hlj-heb-bx'},{'idx':'8,1,14','code':'230126','name':'巴彦县','search':'黑龙江-哈尔滨-巴彦县|heilongjiang-haerbin-bayanxian|hlj-heb-byx'},{'idx':'8,1,15','code':'230127','name':'木兰县','search':'黑龙江-哈尔滨-木兰县|heilongjiang-haerbin-mulanxian|hlj-heb-mlx'},{'idx':'8,1,16','code':'230128','name':'通河县','search':'黑龙江-哈尔滨-通河县|heilongjiang-haerbin-tonghexian|hlj-heb-thx'},{'idx':'8,1,17','code':'230129','name':'延寿县','search':'黑龙江-哈尔滨-延寿县|heilongjiang-haerbin-yanshouxian|hlj-heb-ysx'},{'idx':'8,1,18','code':'230183','name':'尚志市','search':'黑龙江-哈尔滨-尚志市|heilongjiang-haerbin-shangzhishi|hlj-heb-szs'},{'idx':'8,1,19','code':'230184','name':'五常市','search':'黑龙江-哈尔滨-五常市|heilongjiang-haerbin-wuchangshi|hlj-heb-wcs'}]},{'idx':'8,2','code':'230200','name':'齐齐哈尔','search':'黑龙江-齐齐哈尔|heilongjiang-qiqihaershi|hlj-qqhes','children':[{'idx':'8,2,0','code':'-1','name':'全市','search':'全市|quansheng|qs'},{'idx':'8,2,1','code':'230201','name':'市辖区','search':'黑龙江-齐齐哈尔-市辖区|heilongjiang-qiqihaer-shixiaqu|hlj-qqhe-sxq'},{'idx':'8,2,2','code':'230202','name':'龙沙区','search':'黑龙江-齐齐哈尔-龙沙区|heilongjiang-qiqihaer-longshaqu|hlj-qqhe-lsq'},{'idx':'8,2,3','code':'230203','name':'建华区','search':'黑龙江-齐齐哈尔-建华区|heilongjiang-qiqihaer-jianhuaqu|hlj-qqhe-jhq'},{'idx':'8,2,4','code':'230204','name':'铁锋区','search':'黑龙江-齐齐哈尔-铁锋区|heilongjiang-qiqihaer-tiefengqu|hlj-qqhe-tfq'},{'idx':'8,2,5','code':'230205','name':'昂昂溪区','search':'黑龙江-齐齐哈尔-昂昂溪区|heilongjiang-qiqihaer-angangxiqu|hlj-qqhe-aaxq'},{'idx':'8,2,6','code':'230206','name':'富拉尔基区','search':'黑龙江-齐齐哈尔-富拉尔基区|heilongjiang-qiqihaer-fulaerjiqu|hlj-qqhe-flejq'},{'idx':'8,2,7','code':'230207','name':'碾子山区','search':'黑龙江-齐齐哈尔-碾子山区|heilongjiang-qiqihaer-nianzishanqu|hlj-qqhe-nzsq'},{'idx':'8,2,8','code':'230208','name':'梅里斯达斡尔族区','search':'黑龙江-齐齐哈尔-梅里斯达斡尔族区|heilongjiang-qiqihaer-meilisidawoerzuqu|hlj-qqhe-mlsdwezq'},{'idx':'8,2,9','code':'230221','name':'龙江县','search':'黑龙江-齐齐哈尔-龙江县|heilongjiang-qiqihaer-longjiangxian|hlj-qqhe-ljx'},{'idx':'8,2,10','code':'230223','name':'依安县','search':'黑龙江-齐齐哈尔-依安县|heilongjiang-qiqihaer-yianxian|hlj-qqhe-yax'},{'idx':'8,2,11','code':'230224','name':'泰来县','search':'黑龙江-齐齐哈尔-泰来县|heilongjiang-qiqihaer-tailaixian|hlj-qqhe-tlx'},{'idx':'8,2,12','code':'230225','name':'甘南县','search':'黑龙江-齐齐哈尔-甘南县|heilongjiang-qiqihaer-gannanxian|hlj-qqhe-gnx'},{'idx':'8,2,13','code':'230227','name':'富裕县','search':'黑龙江-齐齐哈尔-富裕县|heilongjiang-qiqihaer-fuyuxian|hlj-qqhe-fyx'},{'idx':'8,2,14','code':'230229','name':'克山县','search':'黑龙江-齐齐哈尔-克山县|heilongjiang-qiqihaer-keshanxian|hlj-qqhe-ksx'},{'idx':'8,2,15','code':'230230','name':'克东县','search':'黑龙江-齐齐哈尔-克东县|heilongjiang-qiqihaer-kedongxian|hlj-qqhe-kdx'},{'idx':'8,2,16','code':'230231','name':'拜泉县','search':'黑龙江-齐齐哈尔-拜泉县|heilongjiang-qiqihaer-baiquanxian|hlj-qqhe-bqx'},{'idx':'8,2,17','code':'230281','name':'讷河市','search':'黑龙江-齐齐哈尔-讷河市|heilongjiang-qiqihaer-neheshi|hlj-qqhe-nhs'}]},{'idx':'8,3','code':'230300','name':'鸡西','search':'黑龙江-鸡西|heilongjiang-jixishi|hlj-jxs','children':[{'idx':'8,3,0','code':'-1','name':'全市','search':'全市|quansheng|qs'},{'idx':'8,3,1','code':'230301','name':'市辖区','search':'黑龙江-鸡西-市辖区|heilongjiang-jixi-shixiaqu|hlj-jx-sxq'},{'idx':'8,3,2','code':'230302','name':'鸡冠区','search':'黑龙江-鸡西-鸡冠区|heilongjiang-jixi-jiguanqu|hlj-jx-jgq'},{'idx':'8,3,3','code':'230303','name':'恒山区','search':'黑龙江-鸡西-恒山区|heilongjiang-jixi-hengshanqu|hlj-jx-hsq'},{'idx':'8,3,4','code':'230304','name':'滴道区','search':'黑龙江-鸡西-滴道区|heilongjiang-jixi-didaoqu|hlj-jx-ddq'},{'idx':'8,3,5','code':'230305','name':'梨树区','search':'黑龙江-鸡西-梨树区|heilongjiang-jixi-lishuqu|hlj-jx-lsq'},{'idx':'8,3,6','code':'230306','name':'城子河区','search':'黑龙江-鸡西-城子河区|heilongjiang-jixi-chengzihequ|hlj-jx-czhq'},{'idx':'8,3,7','code':'230307','name':'麻山区','search':'黑龙江-鸡西-麻山区|heilongjiang-jixi-mashanqu|hlj-jx-msq'},{'idx':'8,3,8','code':'230321','name':'鸡东县','search':'黑龙江-鸡西-鸡东县|heilongjiang-jixi-jidongxian|hlj-jx-jdx'},{'idx':'8,3,9','code':'230381','name':'虎林市','search':'黑龙江-鸡西-虎林市|heilongjiang-jixi-hulinshi|hlj-jx-hls'},{'idx':'8,3,10','code':'230382','name':'密山市','search':'黑龙江-鸡西-密山市|heilongjiang-jixi-mishanshi|hlj-jx-mss'}]},{'idx':'8,4','code':'230400','name':'鹤岗','search':'黑龙江-鹤岗|heilongjiang-hegangshi|hlj-hgs','children':[{'idx':'8,4,0','code':'-1','name':'全市','search':'全市|quansheng|qs'},{'idx':'8,4,1','code':'230401','name':'市辖区','search':'黑龙江-鹤岗-市辖区|heilongjiang-hegang-shixiaqu|hlj-hg-sxq'},{'idx':'8,4,2','code':'230402','name':'向阳区','search':'黑龙江-鹤岗-向阳区|heilongjiang-hegang-xiangyangqu|hlj-hg-xyq'},{'idx':'8,4,3','code':'230403','name':'工农区','search':'黑龙江-鹤岗-工农区|heilongjiang-hegang-gongnongqu|hlj-hg-gnq'},{'idx':'8,4,4','code':'230404','name':'南山区','search':'黑龙江-鹤岗-南山区|heilongjiang-hegang-nanshanqu|hlj-hg-nsq'},{'idx':'8,4,5','code':'230405','name':'兴安区','search':'黑龙江-鹤岗-兴安区|heilongjiang-hegang-xinganqu|hlj-hg-xaq'},{'idx':'8,4,6','code':'230406','name':'东山区','search':'黑龙江-鹤岗-东山区|heilongjiang-hegang-dongshanqu|hlj-hg-dsq'},{'idx':'8,4,7','code':'230407','name':'兴山区','search':'黑龙江-鹤岗-兴山区|heilongjiang-hegang-xingshanqu|hlj-hg-xsq'},{'idx':'8,4,8','code':'230421','name':'萝北县','search':'黑龙江-鹤岗-萝北县|heilongjiang-hegang-luobeixian|hlj-hg-lbx'},{'idx':'8,4,9','code':'230422','name':'绥滨县','search':'黑龙江-鹤岗-绥滨县|heilongjiang-hegang-suibinxian|hlj-hg-sbx'}]},{'idx':'8,5','code':'230500','name':'双鸭山','search':'黑龙江-双鸭山|heilongjiang-shuangyashanshi|hlj-syss','children':[{'idx':'8,5,0','code':'-1','name':'全市','search':'全市|quansheng|qs'},{'idx':'8,5,1','code':'230501','name':'市辖区','search':'黑龙江-双鸭山-市辖区|heilongjiang-shuangyashan-shixiaqu|hlj-sys-sxq'},{'idx':'8,5,2','code':'230502','name':'尖山区','search':'黑龙江-双鸭山-尖山区|heilongjiang-shuangyashan-jianshanqu|hlj-sys-jsq'},{'idx':'8,5,3','code':'230503','name':'岭东区','search':'黑龙江-双鸭山-岭东区|heilongjiang-shuangyashan-lingdongqu|hlj-sys-ldq'},{'idx':'8,5,4','code':'230505','name':'四方台区','search':'黑龙江-双鸭山-四方台区|heilongjiang-shuangyashan-sifangtaiqu|hlj-sys-sftq'},{'idx':'8,5,5','code':'230506','name':'宝山区','search':'黑龙江-双鸭山-宝山区|heilongjiang-shuangyashan-baoshanqu|hlj-sys-bsq'},{'idx':'8,5,6','code':'230521','name':'集贤县','search':'黑龙江-双鸭山-集贤县|heilongjiang-shuangyashan-jixianxian|hlj-sys-jxx'},{'idx':'8,5,7','code':'230522','name':'友谊县','search':'黑龙江-双鸭山-友谊县|heilongjiang-shuangyashan-youyixian|hlj-sys-yyx'},{'idx':'8,5,8','code':'230523','name':'宝清县','search':'黑龙江-双鸭山-宝清县|heilongjiang-shuangyashan-baoqingxian|hlj-sys-bqx'},{'idx':'8,5,9','code':'230524','name':'饶河县','search':'黑龙江-双鸭山-饶河县|heilongjiang-shuangyashan-raohexian|hlj-sys-rhx'}]},{'idx':'8,6','code':'230600','name':'大庆','search':'黑龙江-大庆|heilongjiang-daqingshi|hlj-dqs','children':[{'idx':'8,6,0','code':'-1','name':'全市','search':'全市|quansheng|qs'},{'idx':'8,6,1','code':'230601','name':'市辖区','search':'黑龙江-大庆-市辖区|heilongjiang-daqing-shixiaqu|hlj-dq-sxq'},{'idx':'8,6,2','code':'230602','name':'萨尔图区','search':'黑龙江-大庆-萨尔图区|heilongjiang-daqing-saertuqu|hlj-dq-setq'},{'idx':'8,6,3','code':'230603','name':'龙凤区','search':'黑龙江-大庆-龙凤区|heilongjiang-daqing-longfengqu|hlj-dq-lfq'},{'idx':'8,6,4','code':'230604','name':'让胡路区','search':'黑龙江-大庆-让胡路区|heilongjiang-daqing-ranghuluqu|hlj-dq-rhlq'},{'idx':'8,6,5','code':'230605','name':'红岗区','search':'黑龙江-大庆-红岗区|heilongjiang-daqing-honggangqu|hlj-dq-hgq'},{'idx':'8,6,6','code':'230606','name':'大同区','search':'黑龙江-大庆-大同区|heilongjiang-daqing-datongqu|hlj-dq-dtq'},{'idx':'8,6,7','code':'230621','name':'肇州县','search':'黑龙江-大庆-肇州县|heilongjiang-daqing-zhaozhouxian|hlj-dq-zzx'},{'idx':'8,6,8','code':'230622','name':'肇源县','search':'黑龙江-大庆-肇源县|heilongjiang-daqing-zhaoyuanxian|hlj-dq-zyx'},{'idx':'8,6,9','code':'230623','name':'林甸县','search':'黑龙江-大庆-林甸县|heilongjiang-daqing-lindianxian|hlj-dq-ldx'},{'idx':'8,6,10','code':'230624','name':'杜尔伯特蒙古族自治县','search':'黑龙江-大庆-杜尔伯特蒙古族自治县|heilongjiang-daqing-duerbotemengguzuzizhixian|hlj-dq-debtmgzzzx'}]},{'idx':'8,7','code':'230700','name':'伊春','search':'黑龙江-伊春|heilongjiang-yichunshi|hlj-ycs','children':[{'idx':'8,7,0','code':'-1','name':'全市','search':'全市|quansheng|qs'},{'idx':'8,7,1','code':'230701','name':'市辖区','search':'黑龙江-伊春-市辖区|heilongjiang-yichun-shixiaqu|hlj-yc-sxq'},{'idx':'8,7,2','code':'230702','name':'伊春区','search':'黑龙江-伊春-伊春区|heilongjiang-yichun-yichunqu|hlj-yc-ycq'},{'idx':'8,7,3','code':'230703','name':'南岔区','search':'黑龙江-伊春-南岔区|heilongjiang-yichun-nanchaqu|hlj-yc-ncq'},{'idx':'8,7,4','code':'230704','name':'友好区','search':'黑龙江-伊春-友好区|heilongjiang-yichun-youhaoqu|hlj-yc-yhq'},{'idx':'8,7,5','code':'230705','name':'西林区','search':'黑龙江-伊春-西林区|heilongjiang-yichun-xilinqu|hlj-yc-xlq'},{'idx':'8,7,6','code':'230706','name':'翠峦区','search':'黑龙江-伊春-翠峦区|heilongjiang-yichun-cuiluanqu|hlj-yc-clq'},{'idx':'8,7,7','code':'230707','name':'新青区','search':'黑龙江-伊春-新青区|heilongjiang-yichun-xinqingqu|hlj-yc-xqq'},{'idx':'8,7,8','code':'230708','name':'美溪区','search':'黑龙江-伊春-美溪区|heilongjiang-yichun-meixiqu|hlj-yc-mxq'},{'idx':'8,7,9','code':'230709','name':'金山屯区','search':'黑龙江-伊春-金山屯区|heilongjiang-yichun-jinshantunqu|hlj-yc-jstq'},{'idx':'8,7,10','code':'230710','name':'五营区','search':'黑龙江-伊春-五营区|heilongjiang-yichun-wuyingqu|hlj-yc-wyq'},{'idx':'8,7,11','code':'230711','name':'乌马河区','search':'黑龙江-伊春-乌马河区|heilongjiang-yichun-wumahequ|hlj-yc-wmhq'},{'idx':'8,7,12','code':'230712','name':'汤旺河区','search':'黑龙江-伊春-汤旺河区|heilongjiang-yichun-tangwanghequ|hlj-yc-twhq'},{'idx':'8,7,13','code':'230713','name':'带岭区','search':'黑龙江-伊春-带岭区|heilongjiang-yichun-dailingqu|hlj-yc-dlq'},{'idx':'8,7,14','code':'230714','name':'乌伊岭区','search':'黑龙江-伊春-乌伊岭区|heilongjiang-yichun-wuyilingqu|hlj-yc-wylq'},{'idx':'8,7,15','code':'230715','name':'红星区','search':'黑龙江-伊春-红星区|heilongjiang-yichun-hongxingqu|hlj-yc-hxq'},{'idx':'8,7,16','code':'230716','name':'上甘岭区','search':'黑龙江-伊春-上甘岭区|heilongjiang-yichun-shangganlingqu|hlj-yc-sglq'},{'idx':'8,7,17','code':'230722','name':'嘉荫县','search':'黑龙江-伊春-嘉荫县|heilongjiang-yichun-jiayinxian|hlj-yc-jyx'},{'idx':'8,7,18','code':'230781','name':'铁力市','search':'黑龙江-伊春-铁力市|heilongjiang-yichun-tielishi|hlj-yc-tls'}]},{'idx':'8,8','code':'230800','name':'佳木斯','search':'黑龙江-佳木斯|heilongjiang-jiamusishi|hlj-jmss','children':[{'idx':'8,8,0','code':'-1','name':'全市','search':'全市|quansheng|qs'},{'idx':'8,8,1','code':'230801','name':'市辖区','search':'黑龙江-佳木斯-市辖区|heilongjiang-jiamusi-shixiaqu|hlj-jms-sxq'},{'idx':'8,8,2','code':'230803','name':'向阳区','search':'黑龙江-佳木斯-向阳区|heilongjiang-jiamusi-xiangyangqu|hlj-jms-xyq'},{'idx':'8,8,3','code':'230804','name':'前进区','search':'黑龙江-佳木斯-前进区|heilongjiang-jiamusi-qianjinqu|hlj-jms-qjq'},{'idx':'8,8,4','code':'230805','name':'东风区','search':'黑龙江-佳木斯-东风区|heilongjiang-jiamusi-dongfengqu|hlj-jms-dfq'},{'idx':'8,8,5','code':'230811','name':'郊区','search':'黑龙江-佳木斯-郊区|heilongjiang-jiamusi-jiaoqu|hlj-jms-jq'},{'idx':'8,8,6','code':'230822','name':'桦南县','search':'黑龙江-佳木斯-桦南县|heilongjiang-jiamusi-huananxian|hlj-jms-hnx'},{'idx':'8,8,7','code':'230826','name':'桦川县','search':'黑龙江-佳木斯-桦川县|heilongjiang-jiamusi-huachuanxian|hlj-jms-hcx'},{'idx':'8,8,8','code':'230828','name':'汤原县','search':'黑龙江-佳木斯-汤原县|heilongjiang-jiamusi-tangyuanxian|hlj-jms-tyx'},{'idx':'8,8,9','code':'230833','name':'抚远县','search':'黑龙江-佳木斯-抚远县|heilongjiang-jiamusi-fuyuanxian|hlj-jms-fyx'},{'idx':'8,8,10','code':'230881','name':'同江市','search':'黑龙江-佳木斯-同江市|heilongjiang-jiamusi-tongjiangshi|hlj-jms-tjs'},{'idx':'8,8,11','code':'230882','name':'富锦市','search':'黑龙江-佳木斯-富锦市|heilongjiang-jiamusi-fujinshi|hlj-jms-fjs'}]},{'idx':'8,9','code':'230900','name':'七台河','search':'黑龙江-七台河|heilongjiang-qitaiheshi|hlj-qths','children':[{'idx':'8,9,0','code':'-1','name':'全市','search':'全市|quansheng|qs'},{'idx':'8,9,1','code':'230901','name':'市辖区','search':'黑龙江-七台河-市辖区|heilongjiang-qitaihe-shixiaqu|hlj-qth-sxq'},{'idx':'8,9,2','code':'230902','name':'新兴区','search':'黑龙江-七台河-新兴区|heilongjiang-qitaihe-xinxingqu|hlj-qth-xxq'},{'idx':'8,9,3','code':'230903','name':'桃山区','search':'黑龙江-七台河-桃山区|heilongjiang-qitaihe-taoshanqu|hlj-qth-tsq'},{'idx':'8,9,4','code':'230904','name':'茄子河区','search':'黑龙江-七台河-茄子河区|heilongjiang-qitaihe-qiezihequ|hlj-qth-qzhq'},{'idx':'8,9,5','code':'230921','name':'勃利县','search':'黑龙江-七台河-勃利县|heilongjiang-qitaihe-bolixian|hlj-qth-blx'}]},{'idx':'8,10','code':'231000','name':'牡丹江','search':'黑龙江-牡丹江|heilongjiang-mudanjiangshi|hlj-mdjs','children':[{'idx':'8,10,0','code':'-1','name':'全市','search':'全市|quansheng|qs'},{'idx':'8,10,1','code':'231001','name':'市辖区','search':'黑龙江-牡丹江-市辖区|heilongjiang-mudanjiang-shixiaqu|hlj-mdj-sxq'},{'idx':'8,10,2','code':'231002','name':'东安区','search':'黑龙江-牡丹江-东安区|heilongjiang-mudanjiang-donganqu|hlj-mdj-daq'},{'idx':'8,10,3','code':'231003','name':'阳明区','search':'黑龙江-牡丹江-阳明区|heilongjiang-mudanjiang-yangmingqu|hlj-mdj-ymq'},{'idx':'8,10,4','code':'231004','name':'爱民区','search':'黑龙江-牡丹江-爱民区|heilongjiang-mudanjiang-aiminqu|hlj-mdj-amq'},{'idx':'8,10,5','code':'231005','name':'西安区','search':'黑龙江-牡丹江-西安区|heilongjiang-mudanjiang-xianqu|hlj-mdj-xaq'},{'idx':'8,10,6','code':'231024','name':'东宁县','search':'黑龙江-牡丹江-东宁县|heilongjiang-mudanjiang-dongningxian|hlj-mdj-dnx'},{'idx':'8,10,7','code':'231025','name':'林口县','search':'黑龙江-牡丹江-林口县|heilongjiang-mudanjiang-linkouxian|hlj-mdj-lkx'},{'idx':'8,10,8','code':'231081','name':'绥芬河市','search':'黑龙江-牡丹江-绥芬河市|heilongjiang-mudanjiang-suifenheshi|hlj-mdj-sfhs'},{'idx':'8,10,9','code':'231083','name':'海林市','search':'黑龙江-牡丹江-海林市|heilongjiang-mudanjiang-hailinshi|hlj-mdj-hls'},{'idx':'8,10,10','code':'231084','name':'宁安市','search':'黑龙江-牡丹江-宁安市|heilongjiang-mudanjiang-ninganshi|hlj-mdj-nas'},{'idx':'8,10,11','code':'231085','name':'穆棱市','search':'黑龙江-牡丹江-穆棱市|heilongjiang-mudanjiang-mulengshi|hlj-mdj-mls'}]},{'idx':'8,11','code':'231100','name':'黑河','search':'黑龙江-黑河|heilongjiang-heiheshi|hlj-hhs','children':[{'idx':'8,11,0','code':'-1','name':'全市','search':'全市|quansheng|qs'},{'idx':'8,11,1','code':'231101','name':'市辖区','search':'黑龙江-黑河-市辖区|heilongjiang-heihe-shixiaqu|hlj-hh-sxq'},{'idx':'8,11,2','code':'231102','name':'爱辉区','search':'黑龙江-黑河-爱辉区|heilongjiang-heihe-aihuiqu|hlj-hh-ahq'},{'idx':'8,11,3','code':'231121','name':'嫩江县','search':'黑龙江-黑河-嫩江县|heilongjiang-heihe-nenjiangxian|hlj-hh-njx'},{'idx':'8,11,4','code':'231123','name':'逊克县','search':'黑龙江-黑河-逊克县|heilongjiang-heihe-xunkexian|hlj-hh-xkx'},{'idx':'8,11,5','code':'231124','name':'孙吴县','search':'黑龙江-黑河-孙吴县|heilongjiang-heihe-sunwuxian|hlj-hh-swx'},{'idx':'8,11,6','code':'231181','name':'北安市','search':'黑龙江-黑河-北安市|heilongjiang-heihe-beianshi|hlj-hh-bas'},{'idx':'8,11,7','code':'231182','name':'五大连池市','search':'黑龙江-黑河-五大连池市|heilongjiang-heihe-wudalianchishi|hlj-hh-wdlcs'}]},{'idx':'8,12','code':'231200','name':'绥化','search':'黑龙江-绥化|heilongjiang-suihuashi|hlj-shs','children':[{'idx':'8,12,0','code':'-1','name':'全市','search':'全市|quansheng|qs'},{'idx':'8,12,1','code':'231201','name':'市辖区','search':'黑龙江-绥化-市辖区|heilongjiang-suihua-shixiaqu|hlj-sh-sxq'},{'idx':'8,12,2','code':'231202','name':'北林区','search':'黑龙江-绥化-北林区|heilongjiang-suihua-beilinqu|hlj-sh-blq'},{'idx':'8,12,3','code':'231221','name':'望奎县','search':'黑龙江-绥化-望奎县|heilongjiang-suihua-wangkuixian|hlj-sh-wkx'},{'idx':'8,12,4','code':'231222','name':'兰西县','search':'黑龙江-绥化-兰西县|heilongjiang-suihua-lanxixian|hlj-sh-lxx'},{'idx':'8,12,5','code':'231223','name':'青冈县','search':'黑龙江-绥化-青冈县|heilongjiang-suihua-qinggangxian|hlj-sh-qgx'},{'idx':'8,12,6','code':'231224','name':'庆安县','search':'黑龙江-绥化-庆安县|heilongjiang-suihua-qinganxian|hlj-sh-qax'},{'idx':'8,12,7','code':'231225','name':'明水县','search':'黑龙江-绥化-明水县|heilongjiang-suihua-mingshuixian|hlj-sh-msx'},{'idx':'8,12,8','code':'231226','name':'绥棱县','search':'黑龙江-绥化-绥棱县|heilongjiang-suihua-suilengxian|hlj-sh-slx'},{'idx':'8,12,9','code':'231281','name':'安达市','search':'黑龙江-绥化-安达市|heilongjiang-suihua-andashi|hlj-sh-ads'},{'idx':'8,12,10','code':'231282','name':'肇东市','search':'黑龙江-绥化-肇东市|heilongjiang-suihua-zhaodongshi|hlj-sh-zds'},{'idx':'8,12,11','code':'231283','name':'海伦市','search':'黑龙江-绥化-海伦市|heilongjiang-suihua-hailunshi|hlj-sh-hls'}]},{'idx':'8,13','code':'232700','name':'大兴安岭','search':'黑龙江-大兴安岭|heilongjiang-daxinganlingdiqu|hlj-dxaldq','children':[{'idx':'8,13,0','code':'-1','name':'全市','search':'全市|quansheng|qs'},{'idx':'8,13,1','code':'232721','name':'呼玛县','search':'黑龙江-大兴安岭-呼玛县|heilongjiang-daxinganling-humaxian|hlj-dxal-hmx'},{'idx':'8,13,2','code':'232722','name':'塔河县','search':'黑龙江-大兴安岭-塔河县|heilongjiang-daxinganling-tahexian|hlj-dxal-thx'},{'idx':'8,13,3','code':'232723','name':'漠河县','search':'黑龙江-大兴安岭-漠河县|heilongjiang-daxinganling-mohexian|hlj-dxal-mhx'}]}]},{'idx':9,'code':'310000','name':'上海','search':'上海|shanghaishi|shs','children':[{'idx':'9,0','code':'-1','name':'全省','search':'全省|quansheng|qs'},{'idx':'9,1','code':'310100','name':'上海','search':'上海-上海|shanghai-shanghai|sh-sxq','children':[{'idx':'9,1,0','code':'-1','name':'全市','search':'全市|quansheng|qs'},{'idx':'9,1,1','code':'310101','name':'黄浦区','search':'上海-上海-黄浦区|shanghai-shanghai-huangpuqu|sh-sh-hpq'},{'idx':'9,1,2','code':'310104','name':'徐汇区','search':'上海-上海-徐汇区|shanghai-shanghai-xuhuiqu|sh-sh-xhq'},{'idx':'9,1,3','code':'310105','name':'长宁区','search':'上海-上海-长宁区|shanghai-shanghai-changningqu|sh-sh-cnq'},{'idx':'9,1,4','code':'310106','name':'静安区','search':'上海-上海-静安区|shanghai-shanghai-jinganqu|sh-sh-jaq'},{'idx':'9,1,5','code':'310107','name':'普陀区','search':'上海-上海-普陀区|shanghai-shanghai-putuoqu|sh-sh-ptq'},{'idx':'9,1,6','code':'310108','name':'闸北区','search':'上海-上海-闸北区|shanghai-shanghai-zhabeiqu|sh-sh-zbq'},{'idx':'9,1,7','code':'310109','name':'虹口区','search':'上海-上海-虹口区|shanghai-shanghai-hongkouqu|sh-sh-hkq'},{'idx':'9,1,8','code':'310110','name':'杨浦区','search':'上海-上海-杨浦区|shanghai-shanghai-yangpuqu|sh-sh-ypq'},{'idx':'9,1,9','code':'310112','name':'闵行区','search':'上海-上海-闵行区|shanghai-shanghai-minxingqu|sh-sh-mxq'},{'idx':'9,1,10','code':'310113','name':'宝山区','search':'上海-上海-宝山区|shanghai-shanghai-baoshanqu|sh-sh-bsq'},{'idx':'9,1,11','code':'310114','name':'嘉定区','search':'上海-上海-嘉定区|shanghai-shanghai-jiadingqu|sh-sh-jdq'},{'idx':'9,1,12','code':'310115','name':'浦东新区','search':'上海-上海-浦东新区|shanghai-shanghai-pudongxinqu|sh-sh-pdxq'},{'idx':'9,1,13','code':'310116','name':'金山区','search':'上海-上海-金山区|shanghai-shanghai-jinshanqu|sh-sh-jsq'},{'idx':'9,1,14','code':'310117','name':'松江区','search':'上海-上海-松江区|shanghai-shanghai-songjiangqu|sh-sh-sjq'},{'idx':'9,1,15','code':'310118','name':'青浦区','search':'上海-上海-青浦区|shanghai-shanghai-qingpuqu|sh-sh-qpq'},{'idx':'9,1,16','code':'310120','name':'奉贤区','search':'上海-上海-奉贤区|shanghai-shanghai-fengxianqu|sh-sh-fxq'},{'idx':'9,1,17','code':'310230','name':'崇明县','search':'上海-上海-崇明县|shanghai-shanghai-chongmingxian|sh-sh-cmx'}]}]},{'idx':10,'code':'320000','name':'江苏','search':'江苏|jiangsusheng|jss','children':[{'idx':'10,0','code':'-1','name':'全省','search':'全省|quansheng|qs'},{'idx':'10,1','code':'320100','name':'南京','search':'江苏-南京|jiangsu-nanjingshi|js-njs','children':[{'idx':'10,1,0','code':'-1','name':'全市','search':'全市|quansheng|qs'},{'idx':'10,1,1','code':'320101','name':'市辖区','search':'江苏-南京-市辖区|jiangsu-nanjing-shixiaqu|js-nj-sxq'},{'idx':'10,1,2','code':'320102','name':'玄武区','search':'江苏-南京-玄武区|jiangsu-nanjing-xuanwuqu|js-nj-xwq'},{'idx':'10,1,3','code':'320104','name':'秦淮区','search':'江苏-南京-秦淮区|jiangsu-nanjing-qinhuaiqu|js-nj-qhq'},{'idx':'10,1,4','code':'320105','name':'建邺区','search':'江苏-南京-建邺区|jiangsu-nanjing-jianyequ|js-nj-jyq'},{'idx':'10,1,5','code':'320106','name':'鼓楼区','search':'江苏-南京-鼓楼区|jiangsu-nanjing-gulouqu|js-nj-glq'},{'idx':'10,1,6','code':'320111','name':'浦口区','search':'江苏-南京-浦口区|jiangsu-nanjing-pukouqu|js-nj-pkq'},{'idx':'10,1,7','code':'320113','name':'栖霞区','search':'江苏-南京-栖霞区|jiangsu-nanjing-qixiaqu|js-nj-qxq'},{'idx':'10,1,8','code':'320114','name':'雨花台区','search':'江苏-南京-雨花台区|jiangsu-nanjing-yuhuataiqu|js-nj-yhtq'},{'idx':'10,1,9','code':'320115','name':'江宁区','search':'江苏-南京-江宁区|jiangsu-nanjing-jiangningqu|js-nj-jnq'},{'idx':'10,1,10','code':'320116','name':'六合区','search':'江苏-南京-六合区|jiangsu-nanjing-liuhequ|js-nj-lhq'},{'idx':'10,1,11','code':'320117','name':'溧水区','search':'江苏-南京-溧水区|jiangsu-nanjing-lishuiqu|js-nj-lsq'},{'idx':'10,1,12','code':'320118','name':'高淳区','search':'江苏-南京-高淳区|jiangsu-nanjing-gaochunqu|js-nj-gcq'}]},{'idx':'10,2','code':'320200','name':'无锡','search':'江苏-无锡|jiangsu-wuxishi|js-wxs','children':[{'idx':'10,2,0','code':'-1','name':'全市','search':'全市|quansheng|qs'},{'idx':'10,2,1','code':'320201','name':'市辖区','search':'江苏-无锡-市辖区|jiangsu-wuxi-shixiaqu|js-wx-sxq'},{'idx':'10,2,2','code':'320202','name':'崇安区','search':'江苏-无锡-崇安区|jiangsu-wuxi-chonganqu|js-wx-caq'},{'idx':'10,2,3','code':'320203','name':'南长区','search':'江苏-无锡-南长区|jiangsu-wuxi-nanchangqu|js-wx-ncq'},{'idx':'10,2,4','code':'320204','name':'北塘区','search':'江苏-无锡-北塘区|jiangsu-wuxi-beitangqu|js-wx-btq'},{'idx':'10,2,5','code':'320205','name':'锡山区','search':'江苏-无锡-锡山区|jiangsu-wuxi-xishanqu|js-wx-xsq'},{'idx':'10,2,6','code':'320206','name':'惠山区','search':'江苏-无锡-惠山区|jiangsu-wuxi-huishanqu|js-wx-hsq'},{'idx':'10,2,7','code':'320211','name':'滨湖区','search':'江苏-无锡-滨湖区|jiangsu-wuxi-binhuqu|js-wx-bhq'},{'idx':'10,2,8','code':'320281','name':'江阴市','search':'江苏-无锡-江阴市|jiangsu-wuxi-jiangyinshi|js-wx-jys'},{'idx':'10,2,9','code':'320282','name':'宜兴市','search':'江苏-无锡-宜兴市|jiangsu-wuxi-yixingshi|js-wx-yxs'}]},{'idx':'10,3','code':'320300','name':'徐州','search':'江苏-徐州|jiangsu-xuzhoushi|js-xzs','children':[{'idx':'10,3,0','code':'-1','name':'全市','search':'全市|quansheng|qs'},{'idx':'10,3,1','code':'320301','name':'市辖区','search':'江苏-徐州-市辖区|jiangsu-xuzhou-shixiaqu|js-xz-sxq'},{'idx':'10,3,2','code':'320302','name':'鼓楼区','search':'江苏-徐州-鼓楼区|jiangsu-xuzhou-gulouqu|js-xz-glq'},{'idx':'10,3,3','code':'320303','name':'云龙区','search':'江苏-徐州-云龙区|jiangsu-xuzhou-yunlongqu|js-xz-ylq'},{'idx':'10,3,4','code':'320305','name':'贾汪区','search':'江苏-徐州-贾汪区|jiangsu-xuzhou-jiawangqu|js-xz-jwq'},{'idx':'10,3,5','code':'320311','name':'泉山区','search':'江苏-徐州-泉山区|jiangsu-xuzhou-quanshanqu|js-xz-qsq'},{'idx':'10,3,6','code':'320312','name':'铜山区','search':'江苏-徐州-铜山区|jiangsu-xuzhou-tongshanqu|js-xz-tsq'},{'idx':'10,3,7','code':'320321','name':'丰县','search':'江苏-徐州-丰县|jiangsu-xuzhou-fengxian|js-xz-fx'},{'idx':'10,3,8','code':'320322','name':'沛县','search':'江苏-徐州-沛县|jiangsu-xuzhou-peixian|js-xz-px'},{'idx':'10,3,9','code':'320324','name':'睢宁县','search':'江苏-徐州-睢宁县|jiangsu-xuzhou-suiningxian|js-xz-snx'},{'idx':'10,3,10','code':'320381','name':'新沂市','search':'江苏-徐州-新沂市|jiangsu-xuzhou-xinyishi|js-xz-xys'},{'idx':'10,3,11','code':'320382','name':'邳州市','search':'江苏-徐州-邳州市|jiangsu-xuzhou-pizhoushi|js-xz-pzs'}]},{'idx':'10,4','code':'320400','name':'常州','search':'江苏-常州|jiangsu-changzhoushi|js-czs','children':[{'idx':'10,4,0','code':'-1','name':'全市','search':'全市|quansheng|qs'},{'idx':'10,4,1','code':'320401','name':'市辖区','search':'江苏-常州-市辖区|jiangsu-changzhou-shixiaqu|js-cz-sxq'},{'idx':'10,4,2','code':'320402','name':'天宁区','search':'江苏-常州-天宁区|jiangsu-changzhou-tianningqu|js-cz-tnq'},{'idx':'10,4,3','code':'320404','name':'钟楼区','search':'江苏-常州-钟楼区|jiangsu-changzhou-zhonglouqu|js-cz-zlq'},{'idx':'10,4,4','code':'320411','name':'新北区','search':'江苏-常州-新北区|jiangsu-changzhou-xinbeiqu|js-cz-xbq'},{'idx':'10,4,5','code':'320412','name':'武进区','search':'江苏-常州-武进区|jiangsu-changzhou-wujinqu|js-cz-wjq'},{'idx':'10,4,6','code':'320413','name':'金坛区','search':'江苏-常州-金坛区|jiangsu-changzhou-jintanqu|js-cz-jtq'},{'idx':'10,4,7','code':'320481','name':'溧阳市','search':'江苏-常州-溧阳市|jiangsu-changzhou-liyangshi|js-cz-lys'}]},{'idx':'10,5','code':'320500','name':'苏州','search':'江苏-苏州|jiangsu-suzhoushi|js-szs','children':[{'idx':'10,5,0','code':'-1','name':'全市','search':'全市|quansheng|qs'},{'idx':'10,5,1','code':'320501','name':'市辖区','search':'江苏-苏州-市辖区|jiangsu-suzhou-shixiaqu|js-sz-sxq'},{'idx':'10,5,2','code':'320505','name':'虎丘区','search':'江苏-苏州-虎丘区|jiangsu-suzhou-huqiuqu|js-sz-hqq'},{'idx':'10,5,3','code':'320506','name':'吴中区','search':'江苏-苏州-吴中区|jiangsu-suzhou-wuzhongqu|js-sz-wzq'},{'idx':'10,5,4','code':'320507','name':'相城区','search':'江苏-苏州-相城区|jiangsu-suzhou-xiangchengqu|js-sz-xcq'},{'idx':'10,5,5','code':'320508','name':'姑苏区','search':'江苏-苏州-姑苏区|jiangsu-suzhou-gusuqu|js-sz-gsq'},{'idx':'10,5,6','code':'320509','name':'吴江区','search':'江苏-苏州-吴江区|jiangsu-suzhou-wujiangqu|js-sz-wjq'},{'idx':'10,5,7','code':'320581','name':'常熟市','search':'江苏-苏州-常熟市|jiangsu-suzhou-changshushi|js-sz-css'},{'idx':'10,5,8','code':'320582','name':'张家港市','search':'江苏-苏州-张家港市|jiangsu-suzhou-zhangjiagangshi|js-sz-zjgs'},{'idx':'10,5,9','code':'320583','name':'昆山市','search':'江苏-苏州-昆山市|jiangsu-suzhou-kunshanshi|js-sz-kss'},{'idx':'10,5,10','code':'320585','name':'太仓市','search':'江苏-苏州-太仓市|jiangsu-suzhou-taicangshi|js-sz-tcs'}]},{'idx':'10,6','code':'320600','name':'南通','search':'江苏-南通|jiangsu-nantongshi|js-nts','children':[{'idx':'10,6,0','code':'-1','name':'全市','search':'全市|quansheng|qs'},{'idx':'10,6,1','code':'320601','name':'市辖区','search':'江苏-南通-市辖区|jiangsu-nantong-shixiaqu|js-nt-sxq'},{'idx':'10,6,2','code':'320602','name':'崇川区','search':'江苏-南通-崇川区|jiangsu-nantong-chongchuanqu|js-nt-ccq'},{'idx':'10,6,3','code':'320611','name':'港闸区','search':'江苏-南通-港闸区|jiangsu-nantong-gangzhaqu|js-nt-gzq'},{'idx':'10,6,4','code':'320612','name':'通州区','search':'江苏-南通-通州区|jiangsu-nantong-tongzhouqu|js-nt-tzq'},{'idx':'10,6,5','code':'320621','name':'海安县','search':'江苏-南通-海安县|jiangsu-nantong-haianxian|js-nt-hax'},{'idx':'10,6,6','code':'320623','name':'如东县','search':'江苏-南通-如东县|jiangsu-nantong-rudongxian|js-nt-rdx'},{'idx':'10,6,7','code':'320681','name':'启东市','search':'江苏-南通-启东市|jiangsu-nantong-qidongshi|js-nt-qds'},{'idx':'10,6,8','code':'320682','name':'如皋市','search':'江苏-南通-如皋市|jiangsu-nantong-rugaoshi|js-nt-rgs'},{'idx':'10,6,9','code':'320684','name':'海门市','search':'江苏-南通-海门市|jiangsu-nantong-haimenshi|js-nt-hms'}]},{'idx':'10,7','code':'320700','name':'连云港','search':'江苏-连云港|jiangsu-lianyungangshi|js-lygs','children':[{'idx':'10,7,0','code':'-1','name':'全市','search':'全市|quansheng|qs'},{'idx':'10,7,1','code':'320701','name':'市辖区','search':'江苏-连云港-市辖区|jiangsu-lianyungang-shixiaqu|js-lyg-sxq'},{'idx':'10,7,2','code':'320703','name':'连云区','search':'江苏-连云港-连云区|jiangsu-lianyungang-lianyunqu|js-lyg-lyq'},{'idx':'10,7,3','code':'320706','name':'海州区','search':'江苏-连云港-海州区|jiangsu-lianyungang-haizhouqu|js-lyg-hzq'},{'idx':'10,7,4','code':'320707','name':'赣榆区','search':'江苏-连云港-赣榆区|jiangsu-lianyungang-ganyuqu|js-lyg-gyq'},{'idx':'10,7,5','code':'320722','name':'东海县','search':'江苏-连云港-东海县|jiangsu-lianyungang-donghaixian|js-lyg-dhx'},{'idx':'10,7,6','code':'320723','name':'灌云县','search':'江苏-连云港-灌云县|jiangsu-lianyungang-guanyunxian|js-lyg-gyx'},{'idx':'10,7,7','code':'320724','name':'灌南县','search':'江苏-连云港-灌南县|jiangsu-lianyungang-guannanxian|js-lyg-gnx'}]},{'idx':'10,8','code':'320800','name':'淮安','search':'江苏-淮安|jiangsu-huaianshi|js-has','children':[{'idx':'10,8,0','code':'-1','name':'全市','search':'全市|quansheng|qs'},{'idx':'10,8,1','code':'320801','name':'市辖区','search':'江苏-淮安-市辖区|jiangsu-huaian-shixiaqu|js-ha-sxq'},{'idx':'10,8,2','code':'320802','name':'清河区','search':'江苏-淮安-清河区|jiangsu-huaian-qinghequ|js-ha-qhq'},{'idx':'10,8,3','code':'320803','name':'淮安区','search':'江苏-淮安-淮安区|jiangsu-huaian-huaianqu|js-ha-haq'},{'idx':'10,8,4','code':'320804','name':'淮阴区','search':'江苏-淮安-淮阴区|jiangsu-huaian-huaiyinqu|js-ha-hyq'},{'idx':'10,8,5','code':'320811','name':'清浦区','search':'江苏-淮安-清浦区|jiangsu-huaian-qingpuqu|js-ha-qpq'},{'idx':'10,8,6','code':'320826','name':'涟水县','search':'江苏-淮安-涟水县|jiangsu-huaian-lianshuixian|js-ha-lsx'},{'idx':'10,8,7','code':'320829','name':'洪泽县','search':'江苏-淮安-洪泽县|jiangsu-huaian-hongzexian|js-ha-hzx'},{'idx':'10,8,8','code':'320830','name':'盱眙县','search':'江苏-淮安-盱眙县|jiangsu-huaian-xuyixian|js-ha-xyx'},{'idx':'10,8,9','code':'320831','name':'金湖县','search':'江苏-淮安-金湖县|jiangsu-huaian-jinhuxian|js-ha-jhx'}]},{'idx':'10,9','code':'320900','name':'盐城','search':'江苏-盐城|jiangsu-yanchengshi|js-ycs','children':[{'idx':'10,9,0','code':'-1','name':'全市','search':'全市|quansheng|qs'},{'idx':'10,9,1','code':'320901','name':'市辖区','search':'江苏-盐城-市辖区|jiangsu-yancheng-shixiaqu|js-yc-sxq'},{'idx':'10,9,2','code':'320902','name':'亭湖区','search':'江苏-盐城-亭湖区|jiangsu-yancheng-tinghuqu|js-yc-thq'},{'idx':'10,9,3','code':'320903','name':'盐都区','search':'江苏-盐城-盐都区|jiangsu-yancheng-yanduqu|js-yc-ydq'},{'idx':'10,9,4','code':'320904','name':'大丰区','search':'江苏-盐城-大丰区|jiangsu-yancheng-dafengqu|js-yc-dfq'},{'idx':'10,9,5','code':'320921','name':'响水县','search':'江苏-盐城-响水县|jiangsu-yancheng-xiangshuixian|js-yc-xsx'},{'idx':'10,9,6','code':'320922','name':'滨海县','search':'江苏-盐城-滨海县|jiangsu-yancheng-binhaixian|js-yc-bhx'},{'idx':'10,9,7','code':'320923','name':'阜宁县','search':'江苏-盐城-阜宁县|jiangsu-yancheng-funingxian|js-yc-fnx'},{'idx':'10,9,8','code':'320924','name':'射阳县','search':'江苏-盐城-射阳县|jiangsu-yancheng-sheyangxian|js-yc-syx'},{'idx':'10,9,9','code':'320925','name':'建湖县','search':'江苏-盐城-建湖县|jiangsu-yancheng-jianhuxian|js-yc-jhx'},{'idx':'10,9,10','code':'320981','name':'东台市','search':'江苏-盐城-东台市|jiangsu-yancheng-dongtaishi|js-yc-dts'}]},{'idx':'10,10','code':'321000','name':'扬州','search':'江苏-扬州|jiangsu-yangzhoushi|js-yzs','children':[{'idx':'10,10,0','code':'-1','name':'全市','search':'全市|quansheng|qs'},{'idx':'10,10,1','code':'321001','name':'市辖区','search':'江苏-扬州-市辖区|jiangsu-yangzhou-shixiaqu|js-yz-sxq'},{'idx':'10,10,2','code':'321002','name':'广陵区','search':'江苏-扬州-广陵区|jiangsu-yangzhou-guanglingqu|js-yz-glq'},{'idx':'10,10,3','code':'321003','name':'邗江区','search':'江苏-扬州-邗江区|jiangsu-yangzhou-hanjiangqu|js-yz-hjq'},{'idx':'10,10,4','code':'321012','name':'江都区','search':'江苏-扬州-江都区|jiangsu-yangzhou-jiangduqu|js-yz-jdq'},{'idx':'10,10,5','code':'321023','name':'宝应县','search':'江苏-扬州-宝应县|jiangsu-yangzhou-baoyingxian|js-yz-byx'},{'idx':'10,10,6','code':'321081','name':'仪征市','search':'江苏-扬州-仪征市|jiangsu-yangzhou-yizhengshi|js-yz-yzs'},{'idx':'10,10,7','code':'321084','name':'高邮市','search':'江苏-扬州-高邮市|jiangsu-yangzhou-gaoyoushi|js-yz-gys'}]},{'idx':'10,11','code':'321100','name':'镇江','search':'江苏-镇江|jiangsu-zhenjiangshi|js-zjs','children':[{'idx':'10,11,0','code':'-1','name':'全市','search':'全市|quansheng|qs'},{'idx':'10,11,1','code':'321101','name':'市辖区','search':'江苏-镇江-市辖区|jiangsu-zhenjiang-shixiaqu|js-zj-sxq'},{'idx':'10,11,2','code':'321102','name':'京口区','search':'江苏-镇江-京口区|jiangsu-zhenjiang-jingkouqu|js-zj-jkq'},{'idx':'10,11,3','code':'321111','name':'润州区','search':'江苏-镇江-润州区|jiangsu-zhenjiang-runzhouqu|js-zj-rzq'},{'idx':'10,11,4','code':'321112','name':'丹徒区','search':'江苏-镇江-丹徒区|jiangsu-zhenjiang-dantuqu|js-zj-dtq'},{'idx':'10,11,5','code':'321181','name':'丹阳市','search':'江苏-镇江-丹阳市|jiangsu-zhenjiang-danyangshi|js-zj-dys'},{'idx':'10,11,6','code':'321182','name':'扬中市','search':'江苏-镇江-扬中市|jiangsu-zhenjiang-yangzhongshi|js-zj-yzs'},{'idx':'10,11,7','code':'321183','name':'句容市','search':'江苏-镇江-句容市|jiangsu-zhenjiang-jurongshi|js-zj-jrs'}]},{'idx':'10,12','code':'321200','name':'泰州','search':'江苏-泰州|jiangsu-taizhoushi|js-tzs','children':[{'idx':'10,12,0','code':'-1','name':'全市','search':'全市|quansheng|qs'},{'idx':'10,12,1','code':'321201','name':'市辖区','search':'江苏-泰州-市辖区|jiangsu-taizhou-shixiaqu|js-tz-sxq'},{'idx':'10,12,2','code':'321202','name':'海陵区','search':'江苏-泰州-海陵区|jiangsu-taizhou-hailingqu|js-tz-hlq'},{'idx':'10,12,3','code':'321203','name':'高港区','search':'江苏-泰州-高港区|jiangsu-taizhou-gaogangqu|js-tz-ggq'},{'idx':'10,12,4','code':'321204','name':'姜堰区','search':'江苏-泰州-姜堰区|jiangsu-taizhou-jiangyanqu|js-tz-jyq'},{'idx':'10,12,5','code':'321281','name':'兴化市','search':'江苏-泰州-兴化市|jiangsu-taizhou-xinghuashi|js-tz-xhs'},{'idx':'10,12,6','code':'321282','name':'靖江市','search':'江苏-泰州-靖江市|jiangsu-taizhou-jingjiangshi|js-tz-jjs'},{'idx':'10,12,7','code':'321283','name':'泰兴市','search':'江苏-泰州-泰兴市|jiangsu-taizhou-taixingshi|js-tz-txs'}]},{'idx':'10,13','code':'321300','name':'宿迁','search':'江苏-宿迁|jiangsu-suqianshi|js-sqs','children':[{'idx':'10,13,0','code':'-1','name':'全市','search':'全市|quansheng|qs'},{'idx':'10,13,1','code':'321301','name':'市辖区','search':'江苏-宿迁-市辖区|jiangsu-suqian-shixiaqu|js-sq-sxq'},{'idx':'10,13,2','code':'321302','name':'宿城区','search':'江苏-宿迁-宿城区|jiangsu-suqian-suchengqu|js-sq-scq'},{'idx':'10,13,3','code':'321311','name':'宿豫区','search':'江苏-宿迁-宿豫区|jiangsu-suqian-suyuqu|js-sq-syq'},{'idx':'10,13,4','code':'321322','name':'沭阳县','search':'江苏-宿迁-沭阳县|jiangsu-suqian-shuyangxian|js-sq-syx'},{'idx':'10,13,5','code':'321323','name':'泗阳县','search':'江苏-宿迁-泗阳县|jiangsu-suqian-siyangxian|js-sq-syx'},{'idx':'10,13,6','code':'321324','name':'泗洪县','search':'江苏-宿迁-泗洪县|jiangsu-suqian-sihongxian|js-sq-shx'}]}]},{'idx':11,'code':'330000','name':'浙江','search':'浙江|zhejiangsheng|zjs','children':[{'idx':'11,0','code':'-1','name':'全省','search':'全省|quansheng|qs'},{'idx':'11,1','code':'330100','name':'杭州','search':'浙江-杭州|zhejiang-hangzhoushi|zj-hzs','children':[{'idx':'11,1,0','code':'-1','name':'全市','search':'全市|quansheng|qs'},{'idx':'11,1,1','code':'330101','name':'市辖区','search':'浙江-杭州-市辖区|zhejiang-hangzhou-shixiaqu|zj-hz-sxq'},{'idx':'11,1,2','code':'330102','name':'上城区','search':'浙江-杭州-上城区|zhejiang-hangzhou-shangchengqu|zj-hz-scq'},{'idx':'11,1,3','code':'330103','name':'下城区','search':'浙江-杭州-下城区|zhejiang-hangzhou-xiachengqu|zj-hz-xcq'},{'idx':'11,1,4','code':'330104','name':'江干区','search':'浙江-杭州-江干区|zhejiang-hangzhou-jiangganqu|zj-hz-jgq'},{'idx':'11,1,5','code':'330105','name':'拱墅区','search':'浙江-杭州-拱墅区|zhejiang-hangzhou-gongshuqu|zj-hz-gsq'},{'idx':'11,1,6','code':'330106','name':'西湖区','search':'浙江-杭州-西湖区|zhejiang-hangzhou-xihuqu|zj-hz-xhq'},{'idx':'11,1,7','code':'330108','name':'滨江区','search':'浙江-杭州-滨江区|zhejiang-hangzhou-binjiangqu|zj-hz-bjq'},{'idx':'11,1,8','code':'330109','name':'萧山区','search':'浙江-杭州-萧山区|zhejiang-hangzhou-xiaoshanqu|zj-hz-xsq'},{'idx':'11,1,9','code':'330110','name':'余杭区','search':'浙江-杭州-余杭区|zhejiang-hangzhou-yuhangqu|zj-hz-yhq'},{'idx':'11,1,10','code':'330111','name':'富阳区','search':'浙江-杭州-富阳区|zhejiang-hangzhou-fuyangqu|zj-hz-fyq'},{'idx':'11,1,11','code':'330122','name':'桐庐县','search':'浙江-杭州-桐庐县|zhejiang-hangzhou-tongluxian|zj-hz-tlx'},{'idx':'11,1,12','code':'330127','name':'淳安县','search':'浙江-杭州-淳安县|zhejiang-hangzhou-chunanxian|zj-hz-cax'},{'idx':'11,1,13','code':'330182','name':'建德市','search':'浙江-杭州-建德市|zhejiang-hangzhou-jiandeshi|zj-hz-jds'},{'idx':'11,1,14','code':'330185','name':'临安市','search':'浙江-杭州-临安市|zhejiang-hangzhou-linanshi|zj-hz-las'}]},{'idx':'11,2','code':'330200','name':'宁波','search':'浙江-宁波|zhejiang-ningboshi|zj-nbs','children':[{'idx':'11,2,0','code':'-1','name':'全市','search':'全市|quansheng|qs'},{'idx':'11,2,1','code':'330201','name':'市辖区','search':'浙江-宁波-市辖区|zhejiang-ningbo-shixiaqu|zj-nb-sxq'},{'idx':'11,2,2','code':'330203','name':'海曙区','search':'浙江-宁波-海曙区|zhejiang-ningbo-haishuqu|zj-nb-hsq'},{'idx':'11,2,3','code':'330204','name':'江东区','search':'浙江-宁波-江东区|zhejiang-ningbo-jiangdongqu|zj-nb-jdq'},{'idx':'11,2,4','code':'330205','name':'江北区','search':'浙江-宁波-江北区|zhejiang-ningbo-jiangbeiqu|zj-nb-jbq'},{'idx':'11,2,5','code':'330206','name':'北仑区','search':'浙江-宁波-北仑区|zhejiang-ningbo-beilunqu|zj-nb-blq'},{'idx':'11,2,6','code':'330211','name':'镇海区','search':'浙江-宁波-镇海区|zhejiang-ningbo-zhenhaiqu|zj-nb-zhq'},{'idx':'11,2,7','code':'330212','name':'鄞州区','search':'浙江-宁波-鄞州区|zhejiang-ningbo-yinzhouqu|zj-nb-yzq'},{'idx':'11,2,8','code':'330225','name':'象山县','search':'浙江-宁波-象山县|zhejiang-ningbo-xiangshanxian|zj-nb-xsx'},{'idx':'11,2,9','code':'330226','name':'宁海县','search':'浙江-宁波-宁海县|zhejiang-ningbo-ninghaixian|zj-nb-nhx'},{'idx':'11,2,10','code':'330281','name':'余姚市','search':'浙江-宁波-余姚市|zhejiang-ningbo-yuyaoshi|zj-nb-yys'},{'idx':'11,2,11','code':'330282','name':'慈溪市','search':'浙江-宁波-慈溪市|zhejiang-ningbo-cixishi|zj-nb-cxs'},{'idx':'11,2,12','code':'330283','name':'奉化市','search':'浙江-宁波-奉化市|zhejiang-ningbo-fenghuashi|zj-nb-fhs'}]},{'idx':'11,3','code':'330300','name':'温州','search':'浙江-温州|zhejiang-wenzhoushi|zj-wzs','children':[{'idx':'11,3,0','code':'-1','name':'全市','search':'全市|quansheng|qs'},{'idx':'11,3,1','code':'330301','name':'市辖区','search':'浙江-温州-市辖区|zhejiang-wenzhou-shixiaqu|zj-wz-sxq'},{'idx':'11,3,2','code':'330302','name':'鹿城区','search':'浙江-温州-鹿城区|zhejiang-wenzhou-luchengqu|zj-wz-lcq'},{'idx':'11,3,3','code':'330303','name':'龙湾区','search':'浙江-温州-龙湾区|zhejiang-wenzhou-longwanqu|zj-wz-lwq'},{'idx':'11,3,4','code':'330304','name':'瓯海区','search':'浙江-温州-瓯海区|zhejiang-wenzhou-ouhaiqu|zj-wz-ohq'},{'idx':'11,3,5','code':'330305','name':'洞头区','search':'浙江-温州-洞头区|zhejiang-wenzhou-dongtouqu|zj-wz-dtq'},{'idx':'11,3,6','code':'330324','name':'永嘉县','search':'浙江-温州-永嘉县|zhejiang-wenzhou-yongjiaxian|zj-wz-yjx'},{'idx':'11,3,7','code':'330326','name':'平阳县','search':'浙江-温州-平阳县|zhejiang-wenzhou-pingyangxian|zj-wz-pyx'},{'idx':'11,3,8','code':'330327','name':'苍南县','search':'浙江-温州-苍南县|zhejiang-wenzhou-cangnanxian|zj-wz-cnx'},{'idx':'11,3,9','code':'330328','name':'文成县','search':'浙江-温州-文成县|zhejiang-wenzhou-wenchengxian|zj-wz-wcx'},{'idx':'11,3,10','code':'330329','name':'泰顺县','search':'浙江-温州-泰顺县|zhejiang-wenzhou-taishunxian|zj-wz-tsx'},{'idx':'11,3,11','code':'330381','name':'瑞安市','search':'浙江-温州-瑞安市|zhejiang-wenzhou-ruianshi|zj-wz-ras'},{'idx':'11,3,12','code':'330382','name':'乐清市','search':'浙江-温州-乐清市|zhejiang-wenzhou-leqingshi|zj-wz-lqs'}]},{'idx':'11,4','code':'330400','name':'嘉兴','search':'浙江-嘉兴|zhejiang-jiaxingshi|zj-jxs','children':[{'idx':'11,4,0','code':'-1','name':'全市','search':'全市|quansheng|qs'},{'idx':'11,4,1','code':'330401','name':'市辖区','search':'浙江-嘉兴-市辖区|zhejiang-jiaxing-shixiaqu|zj-jx-sxq'},{'idx':'11,4,2','code':'330402','name':'南湖区','search':'浙江-嘉兴-南湖区|zhejiang-jiaxing-nanhuqu|zj-jx-nhq'},{'idx':'11,4,3','code':'330411','name':'秀洲区','search':'浙江-嘉兴-秀洲区|zhejiang-jiaxing-xiuzhouqu|zj-jx-xzq'},{'idx':'11,4,4','code':'330421','name':'嘉善县','search':'浙江-嘉兴-嘉善县|zhejiang-jiaxing-jiashanxian|zj-jx-jsx'},{'idx':'11,4,5','code':'330424','name':'海盐县','search':'浙江-嘉兴-海盐县|zhejiang-jiaxing-haiyanxian|zj-jx-hyx'},{'idx':'11,4,6','code':'330481','name':'海宁市','search':'浙江-嘉兴-海宁市|zhejiang-jiaxing-hainingshi|zj-jx-hns'},{'idx':'11,4,7','code':'330482','name':'平湖市','search':'浙江-嘉兴-平湖市|zhejiang-jiaxing-pinghushi|zj-jx-phs'},{'idx':'11,4,8','code':'330483','name':'桐乡市','search':'浙江-嘉兴-桐乡市|zhejiang-jiaxing-tongxiangshi|zj-jx-txs'}]},{'idx':'11,5','code':'330500','name':'湖州','search':'浙江-湖州|zhejiang-huzhoushi|zj-hzs','children':[{'idx':'11,5,0','code':'-1','name':'全市','search':'全市|quansheng|qs'},{'idx':'11,5,1','code':'330501','name':'市辖区','search':'浙江-湖州-市辖区|zhejiang-huzhou-shixiaqu|zj-hz-sxq'},{'idx':'11,5,2','code':'330502','name':'吴兴区','search':'浙江-湖州-吴兴区|zhejiang-huzhou-wuxingqu|zj-hz-wxq'},{'idx':'11,5,3','code':'330503','name':'南浔区','search':'浙江-湖州-南浔区|zhejiang-huzhou-nanxunqu|zj-hz-nxq'},{'idx':'11,5,4','code':'330521','name':'德清县','search':'浙江-湖州-德清县|zhejiang-huzhou-deqingxian|zj-hz-dqx'},{'idx':'11,5,5','code':'330522','name':'长兴县','search':'浙江-湖州-长兴县|zhejiang-huzhou-changxingxian|zj-hz-cxx'},{'idx':'11,5,6','code':'330523','name':'安吉县','search':'浙江-湖州-安吉县|zhejiang-huzhou-anjixian|zj-hz-ajx'}]},{'idx':'11,6','code':'330600','name':'绍兴','search':'浙江-绍兴|zhejiang-shaoxingshi|zj-sxs','children':[{'idx':'11,6,0','code':'-1','name':'全市','search':'全市|quansheng|qs'},{'idx':'11,6,1','code':'330601','name':'市辖区','search':'浙江-绍兴-市辖区|zhejiang-shaoxing-shixiaqu|zj-sx-sxq'},{'idx':'11,6,2','code':'330602','name':'越城区','search':'浙江-绍兴-越城区|zhejiang-shaoxing-yuechengqu|zj-sx-ycq'},{'idx':'11,6,3','code':'330603','name':'柯桥区','search':'浙江-绍兴-柯桥区|zhejiang-shaoxing-keqiaoqu|zj-sx-kqq'},{'idx':'11,6,4','code':'330604','name':'上虞区','search':'浙江-绍兴-上虞区|zhejiang-shaoxing-shangyuqu|zj-sx-syq'},{'idx':'11,6,5','code':'330624','name':'新昌县','search':'浙江-绍兴-新昌县|zhejiang-shaoxing-xinchangxian|zj-sx-xcx'},{'idx':'11,6,6','code':'330681','name':'诸暨市','search':'浙江-绍兴-诸暨市|zhejiang-shaoxing-zhujishi|zj-sx-zjs'},{'idx':'11,6,7','code':'330683','name':'嵊州市','search':'浙江-绍兴-嵊州市|zhejiang-shaoxing-shengzhoushi|zj-sx-szs'}]},{'idx':'11,7','code':'330700','name':'金华','search':'浙江-金华|zhejiang-jinhuashi|zj-jhs','children':[{'idx':'11,7,0','code':'-1','name':'全市','search':'全市|quansheng|qs'},{'idx':'11,7,1','code':'330701','name':'市辖区','search':'浙江-金华-市辖区|zhejiang-jinhua-shixiaqu|zj-jh-sxq'},{'idx':'11,7,2','code':'330702','name':'婺城区','search':'浙江-金华-婺城区|zhejiang-jinhua-wuchengqu|zj-jh-wcq'},{'idx':'11,7,3','code':'330703','name':'金东区','search':'浙江-金华-金东区|zhejiang-jinhua-jindongqu|zj-jh-jdq'},{'idx':'11,7,4','code':'330723','name':'武义县','search':'浙江-金华-武义县|zhejiang-jinhua-wuyixian|zj-jh-wyx'},{'idx':'11,7,5','code':'330726','name':'浦江县','search':'浙江-金华-浦江县|zhejiang-jinhua-pujiangxian|zj-jh-pjx'},{'idx':'11,7,6','code':'330727','name':'磐安县','search':'浙江-金华-磐安县|zhejiang-jinhua-pananxian|zj-jh-pax'},{'idx':'11,7,7','code':'330781','name':'兰溪市','search':'浙江-金华-兰溪市|zhejiang-jinhua-lanxishi|zj-jh-lxs'},{'idx':'11,7,8','code':'330782','name':'义乌市','search':'浙江-金华-义乌市|zhejiang-jinhua-yiwushi|zj-jh-yws'},{'idx':'11,7,9','code':'330783','name':'东阳市','search':'浙江-金华-东阳市|zhejiang-jinhua-dongyangshi|zj-jh-dys'},{'idx':'11,7,10','code':'330784','name':'永康市','search':'浙江-金华-永康市|zhejiang-jinhua-yongkangshi|zj-jh-yks'}]},{'idx':'11,8','code':'330800','name':'衢州','search':'浙江-衢州|zhejiang-quzhoushi|zj-qzs','children':[{'idx':'11,8,0','code':'-1','name':'全市','search':'全市|quansheng|qs'},{'idx':'11,8,1','code':'330801','name':'市辖区','search':'浙江-衢州-市辖区|zhejiang-quzhou-shixiaqu|zj-qz-sxq'},{'idx':'11,8,2','code':'330802','name':'柯城区','search':'浙江-衢州-柯城区|zhejiang-quzhou-kechengqu|zj-qz-kcq'},{'idx':'11,8,3','code':'330803','name':'衢江区','search':'浙江-衢州-衢江区|zhejiang-quzhou-qujiangqu|zj-qz-qjq'},{'idx':'11,8,4','code':'330822','name':'常山县','search':'浙江-衢州-常山县|zhejiang-quzhou-changshanxian|zj-qz-csx'},{'idx':'11,8,5','code':'330824','name':'开化县','search':'浙江-衢州-开化县|zhejiang-quzhou-kaihuaxian|zj-qz-khx'},{'idx':'11,8,6','code':'330825','name':'龙游县','search':'浙江-衢州-龙游县|zhejiang-quzhou-longyouxian|zj-qz-lyx'},{'idx':'11,8,7','code':'330881','name':'江山市','search':'浙江-衢州-江山市|zhejiang-quzhou-jiangshanshi|zj-qz-jss'}]},{'idx':'11,9','code':'330900','name':'舟山','search':'浙江-舟山|zhejiang-zhoushanshi|zj-zss','children':[{'idx':'11,9,0','code':'-1','name':'全市','search':'全市|quansheng|qs'},{'idx':'11,9,1','code':'330901','name':'市辖区','search':'浙江-舟山-市辖区|zhejiang-zhoushan-shixiaqu|zj-zs-sxq'},{'idx':'11,9,2','code':'330902','name':'定海区','search':'浙江-舟山-定海区|zhejiang-zhoushan-dinghaiqu|zj-zs-dhq'},{'idx':'11,9,3','code':'330903','name':'普陀区','search':'浙江-舟山-普陀区|zhejiang-zhoushan-putuoqu|zj-zs-ptq'},{'idx':'11,9,4','code':'330921','name':'岱山县','search':'浙江-舟山-岱山县|zhejiang-zhoushan-daishanxian|zj-zs-dsx'},{'idx':'11,9,5','code':'330922','name':'嵊泗县','search':'浙江-舟山-嵊泗县|zhejiang-zhoushan-shengsixian|zj-zs-ssx'}]},{'idx':'11,10','code':'331000','name':'台州','search':'浙江-台州|zhejiang-taizhoushi|zj-tzs','children':[{'idx':'11,10,0','code':'-1','name':'全市','search':'全市|quansheng|qs'},{'idx':'11,10,1','code':'331001','name':'市辖区','search':'浙江-台州-市辖区|zhejiang-taizhou-shixiaqu|zj-tz-sxq'},{'idx':'11,10,2','code':'331002','name':'椒江区','search':'浙江-台州-椒江区|zhejiang-taizhou-jiaojiangqu|zj-tz-jjq'},{'idx':'11,10,3','code':'331003','name':'黄岩区','search':'浙江-台州-黄岩区|zhejiang-taizhou-huangyanqu|zj-tz-hyq'},{'idx':'11,10,4','code':'331004','name':'路桥区','search':'浙江-台州-路桥区|zhejiang-taizhou-luqiaoqu|zj-tz-lqq'},{'idx':'11,10,5','code':'331021','name':'玉环县','search':'浙江-台州-玉环县|zhejiang-taizhou-yuhuanxian|zj-tz-yhx'},{'idx':'11,10,6','code':'331022','name':'三门县','search':'浙江-台州-三门县|zhejiang-taizhou-sanmenxian|zj-tz-smx'},{'idx':'11,10,7','code':'331023','name':'天台县','search':'浙江-台州-天台县|zhejiang-taizhou-tiantaixian|zj-tz-ttx'},{'idx':'11,10,8','code':'331024','name':'仙居县','search':'浙江-台州-仙居县|zhejiang-taizhou-xianjuxian|zj-tz-xjx'},{'idx':'11,10,9','code':'331081','name':'温岭市','search':'浙江-台州-温岭市|zhejiang-taizhou-wenlingshi|zj-tz-wls'},{'idx':'11,10,10','code':'331082','name':'临海市','search':'浙江-台州-临海市|zhejiang-taizhou-linhaishi|zj-tz-lhs'}]},{'idx':'11,11','code':'331100','name':'丽水','search':'浙江-丽水|zhejiang-lishuishi|zj-lss','children':[{'idx':'11,11,0','code':'-1','name':'全市','search':'全市|quansheng|qs'},{'idx':'11,11,1','code':'331101','name':'市辖区','search':'浙江-丽水-市辖区|zhejiang-lishui-shixiaqu|zj-ls-sxq'},{'idx':'11,11,2','code':'331102','name':'莲都区','search':'浙江-丽水-莲都区|zhejiang-lishui-lianduqu|zj-ls-ldq'},{'idx':'11,11,3','code':'331121','name':'青田县','search':'浙江-丽水-青田县|zhejiang-lishui-qingtianxian|zj-ls-qtx'},{'idx':'11,11,4','code':'331122','name':'缙云县','search':'浙江-丽水-缙云县|zhejiang-lishui-jinyunxian|zj-ls-jyx'},{'idx':'11,11,5','code':'331123','name':'遂昌县','search':'浙江-丽水-遂昌县|zhejiang-lishui-suichangxian|zj-ls-scx'},{'idx':'11,11,6','code':'331124','name':'松阳县','search':'浙江-丽水-松阳县|zhejiang-lishui-songyangxian|zj-ls-syx'},{'idx':'11,11,7','code':'331125','name':'云和县','search':'浙江-丽水-云和县|zhejiang-lishui-yunhexian|zj-ls-yhx'},{'idx':'11,11,8','code':'331126','name':'庆元县','search':'浙江-丽水-庆元县|zhejiang-lishui-qingyuanxian|zj-ls-qyx'},{'idx':'11,11,9','code':'331127','name':'景宁畲族自治县','search':'浙江-丽水-景宁畲族自治县|zhejiang-lishui-jingningshezuzizhixian|zj-ls-jnszzzx'},{'idx':'11,11,10','code':'331181','name':'龙泉市','search':'浙江-丽水-龙泉市|zhejiang-lishui-longquanshi|zj-ls-lqs'}]}]},{'idx':12,'code':'340000','name':'安徽','search':'安徽|anhuisheng|ahs','children':[{'idx':'12,0','code':'-1','name':'全省','search':'全省|quansheng|qs'},{'idx':'12,1','code':'340100','name':'合肥','search':'安徽-合肥|anhui-hefeishi|ah-hfs','children':[{'idx':'12,1,0','code':'-1','name':'全市','search':'全市|quansheng|qs'},{'idx':'12,1,1','code':'340101','name':'市辖区','search':'安徽-合肥-市辖区|anhui-hefei-shixiaqu|ah-hf-sxq'},{'idx':'12,1,2','code':'340102','name':'瑶海区','search':'安徽-合肥-瑶海区|anhui-hefei-yaohaiqu|ah-hf-yhq'},{'idx':'12,1,3','code':'340103','name':'庐阳区','search':'安徽-合肥-庐阳区|anhui-hefei-luyangqu|ah-hf-lyq'},{'idx':'12,1,4','code':'340104','name':'蜀山区','search':'安徽-合肥-蜀山区|anhui-hefei-shushanqu|ah-hf-ssq'},{'idx':'12,1,5','code':'340111','name':'包河区','search':'安徽-合肥-包河区|anhui-hefei-baohequ|ah-hf-bhq'},{'idx':'12,1,6','code':'340121','name':'长丰县','search':'安徽-合肥-长丰县|anhui-hefei-changfengxian|ah-hf-cfx'},{'idx':'12,1,7','code':'340122','name':'肥东县','search':'安徽-合肥-肥东县|anhui-hefei-feidongxian|ah-hf-fdx'},{'idx':'12,1,8','code':'340123','name':'肥西县','search':'安徽-合肥-肥西县|anhui-hefei-feixixian|ah-hf-fxx'},{'idx':'12,1,9','code':'340124','name':'庐江县','search':'安徽-合肥-庐江县|anhui-hefei-lujiangxian|ah-hf-ljx'},{'idx':'12,1,10','code':'340181','name':'巢湖市','search':'安徽-合肥-巢湖市|anhui-hefei-chaohushi|ah-hf-chs'}]},{'idx':'12,2','code':'340200','name':'芜湖','search':'安徽-芜湖|anhui-wuhushi|ah-whs','children':[{'idx':'12,2,0','code':'-1','name':'全市','search':'全市|quansheng|qs'},{'idx':'12,2,1','code':'340201','name':'市辖区','search':'安徽-芜湖-市辖区|anhui-wuhu-shixiaqu|ah-wh-sxq'},{'idx':'12,2,2','code':'340202','name':'镜湖区','search':'安徽-芜湖-镜湖区|anhui-wuhu-jinghuqu|ah-wh-jhq'},{'idx':'12,2,3','code':'340203','name':'弋江区','search':'安徽-芜湖-弋江区|anhui-wuhu-yijiangqu|ah-wh-yjq'},{'idx':'12,2,4','code':'340207','name':'鸠江区','search':'安徽-芜湖-鸠江区|anhui-wuhu-jiujiangqu|ah-wh-jjq'},{'idx':'12,2,5','code':'340208','name':'三山区','search':'安徽-芜湖-三山区|anhui-wuhu-sanshanqu|ah-wh-ssq'},{'idx':'12,2,6','code':'340221','name':'芜湖县','search':'安徽-芜湖-芜湖县|anhui-wuhu-wuhuxian|ah-wh-whx'},{'idx':'12,2,7','code':'340222','name':'繁昌县','search':'安徽-芜湖-繁昌县|anhui-wuhu-fanchangxian|ah-wh-fcx'},{'idx':'12,2,8','code':'340223','name':'南陵县','search':'安徽-芜湖-南陵县|anhui-wuhu-nanlingxian|ah-wh-nlx'},{'idx':'12,2,9','code':'340225','name':'无为县','search':'安徽-芜湖-无为县|anhui-wuhu-wuweixian|ah-wh-wwx'}]},{'idx':'12,3','code':'340300','name':'蚌埠','search':'安徽-蚌埠|anhui-bangbushi|ah-bbs','children':[{'idx':'12,3,0','code':'-1','name':'全市','search':'全市|quansheng|qs'},{'idx':'12,3,1','code':'340301','name':'市辖区','search':'安徽-蚌埠-市辖区|anhui-bangbu-shixiaqu|ah-bb-sxq'},{'idx':'12,3,2','code':'340302','name':'龙子湖区','search':'安徽-蚌埠-龙子湖区|anhui-bangbu-longzihuqu|ah-bb-lzhq'},{'idx':'12,3,3','code':'340303','name':'蚌山区','search':'安徽-蚌埠-蚌山区|anhui-bangbu-bangshanqu|ah-bb-bsq'},{'idx':'12,3,4','code':'340304','name':'禹会区','search':'安徽-蚌埠-禹会区|anhui-bangbu-yuhuiqu|ah-bb-yhq'},{'idx':'12,3,5','code':'340311','name':'淮上区','search':'安徽-蚌埠-淮上区|anhui-bangbu-huaishangqu|ah-bb-hsq'},{'idx':'12,3,6','code':'340321','name':'怀远县','search':'安徽-蚌埠-怀远县|anhui-bangbu-huaiyuanxian|ah-bb-hyx'},{'idx':'12,3,7','code':'340322','name':'五河县','search':'安徽-蚌埠-五河县|anhui-bangbu-wuhexian|ah-bb-whx'},{'idx':'12,3,8','code':'340323','name':'固镇县','search':'安徽-蚌埠-固镇县|anhui-bangbu-guzhenxian|ah-bb-gzx'}]},{'idx':'12,4','code':'340400','name':'淮南','search':'安徽-淮南|anhui-huainanshi|ah-hns','children':[{'idx':'12,4,0','code':'-1','name':'全市','search':'全市|quansheng|qs'},{'idx':'12,4,1','code':'340401','name':'市辖区','search':'安徽-淮南-市辖区|anhui-huainan-shixiaqu|ah-hn-sxq'},{'idx':'12,4,2','code':'340402','name':'大通区','search':'安徽-淮南-大通区|anhui-huainan-datongqu|ah-hn-dtq'},{'idx':'12,4,3','code':'340403','name':'田家庵区','search':'安徽-淮南-田家庵区|anhui-huainan-tianjiaanqu|ah-hn-tjaq'},{'idx':'12,4,4','code':'340404','name':'谢家集区','search':'安徽-淮南-谢家集区|anhui-huainan-xiejiajiqu|ah-hn-xjjq'},{'idx':'12,4,5','code':'340405','name':'八公山区','search':'安徽-淮南-八公山区|anhui-huainan-bagongshanqu|ah-hn-bgsq'},{'idx':'12,4,6','code':'340406','name':'潘集区','search':'安徽-淮南-潘集区|anhui-huainan-panjiqu|ah-hn-pjq'},{'idx':'12,4,7','code':'340421','name':'凤台县','search':'安徽-淮南-凤台县|anhui-huainan-fengtaixian|ah-hn-ftx'}]},{'idx':'12,5','code':'340500','name':'马鞍山','search':'安徽-马鞍山|anhui-maanshanshi|ah-mass','children':[{'idx':'12,5,0','code':'-1','name':'全市','search':'全市|quansheng|qs'},{'idx':'12,5,1','code':'340501','name':'市辖区','search':'安徽-马鞍山-市辖区|anhui-maanshan-shixiaqu|ah-mas-sxq'},{'idx':'12,5,2','code':'340503','name':'花山区','search':'安徽-马鞍山-花山区|anhui-maanshan-huashanqu|ah-mas-hsq'},{'idx':'12,5,3','code':'340504','name':'雨山区','search':'安徽-马鞍山-雨山区|anhui-maanshan-yushanqu|ah-mas-ysq'},{'idx':'12,5,4','code':'340506','name':'博望区','search':'安徽-马鞍山-博望区|anhui-maanshan-bowangqu|ah-mas-bwq'},{'idx':'12,5,5','code':'340521','name':'当涂县','search':'安徽-马鞍山-当涂县|anhui-maanshan-dangtuxian|ah-mas-dtx'},{'idx':'12,5,6','code':'340522','name':'含山县','search':'安徽-马鞍山-含山县|anhui-maanshan-hanshanxian|ah-mas-hsx'},{'idx':'12,5,7','code':'340523','name':'和县','search':'安徽-马鞍山-和县|anhui-maanshan-hexian|ah-mas-hx'}]},{'idx':'12,6','code':'340600','name':'淮北','search':'安徽-淮北|anhui-huaibeishi|ah-hbs','children':[{'idx':'12,6,0','code':'-1','name':'全市','search':'全市|quansheng|qs'},{'idx':'12,6,1','code':'340601','name':'市辖区','search':'安徽-淮北-市辖区|anhui-huaibei-shixiaqu|ah-hb-sxq'},{'idx':'12,6,2','code':'340602','name':'杜集区','search':'安徽-淮北-杜集区|anhui-huaibei-dujiqu|ah-hb-djq'},{'idx':'12,6,3','code':'340603','name':'相山区','search':'安徽-淮北-相山区|anhui-huaibei-xiangshanqu|ah-hb-xsq'},{'idx':'12,6,4','code':'340604','name':'烈山区','search':'安徽-淮北-烈山区|anhui-huaibei-lieshanqu|ah-hb-lsq'},{'idx':'12,6,5','code':'340621','name':'濉溪县','search':'安徽-淮北-濉溪县|anhui-huaibei-suixixian|ah-hb-sxx'}]},{'idx':'12,7','code':'340700','name':'铜陵','search':'安徽-铜陵|anhui-tonglingshi|ah-tls','children':[{'idx':'12,7,0','code':'-1','name':'全市','search':'全市|quansheng|qs'},{'idx':'12,7,1','code':'340701','name':'市辖区','search':'安徽-铜陵-市辖区|anhui-tongling-shixiaqu|ah-tl-sxq'},{'idx':'12,7,2','code':'340702','name':'铜官山区','search':'安徽-铜陵-铜官山区|anhui-tongling-tongguanshanqu|ah-tl-tgsq'},{'idx':'12,7,3','code':'340703','name':'狮子山区','search':'安徽-铜陵-狮子山区|anhui-tongling-shizishanqu|ah-tl-szsq'},{'idx':'12,7,4','code':'340711','name':'郊区','search':'安徽-铜陵-郊区|anhui-tongling-jiaoqu|ah-tl-jq'},{'idx':'12,7,5','code':'340721','name':'铜陵县','search':'安徽-铜陵-铜陵县|anhui-tongling-tonglingxian|ah-tl-tlx'}]},{'idx':'12,8','code':'340800','name':'安庆','search':'安徽-安庆|anhui-anqingshi|ah-aqs','children':[{'idx':'12,8,0','code':'-1','name':'全市','search':'全市|quansheng|qs'},{'idx':'12,8,1','code':'340801','name':'市辖区','search':'安徽-安庆-市辖区|anhui-anqing-shixiaqu|ah-aq-sxq'},{'idx':'12,8,2','code':'340802','name':'迎江区','search':'安徽-安庆-迎江区|anhui-anqing-yingjiangqu|ah-aq-yjq'},{'idx':'12,8,3','code':'340803','name':'大观区','search':'安徽-安庆-大观区|anhui-anqing-daguanqu|ah-aq-dgq'},{'idx':'12,8,4','code':'340811','name':'宜秀区','search':'安徽-安庆-宜秀区|anhui-anqing-yixiuqu|ah-aq-yxq'},{'idx':'12,8,5','code':'340822','name':'怀宁县','search':'安徽-安庆-怀宁县|anhui-anqing-huainingxian|ah-aq-hnx'},{'idx':'12,8,6','code':'340823','name':'枞阳县','search':'安徽-安庆-枞阳县|anhui-anqing-congyangxian|ah-aq-cyx'},{'idx':'12,8,7','code':'340824','name':'潜山县','search':'安徽-安庆-潜山县|anhui-anqing-qianshanxian|ah-aq-qsx'},{'idx':'12,8,8','code':'340825','name':'太湖县','search':'安徽-安庆-太湖县|anhui-anqing-taihuxian|ah-aq-thx'},{'idx':'12,8,9','code':'340826','name':'宿松县','search':'安徽-安庆-宿松县|anhui-anqing-susongxian|ah-aq-ssx'},{'idx':'12,8,10','code':'340827','name':'望江县','search':'安徽-安庆-望江县|anhui-anqing-wangjiangxian|ah-aq-wjx'},{'idx':'12,8,11','code':'340828','name':'岳西县','search':'安徽-安庆-岳西县|anhui-anqing-yuexixian|ah-aq-yxx'},{'idx':'12,8,12','code':'340881','name':'桐城市','search':'安徽-安庆-桐城市|anhui-anqing-tongchengshi|ah-aq-tcs'}]},{'idx':'12,9','code':'341000','name':'黄山','search':'安徽-黄山|anhui-huangshanshi|ah-hss','children':[{'idx':'12,9,0','code':'-1','name':'全市','search':'全市|quansheng|qs'},{'idx':'12,9,1','code':'341001','name':'市辖区','search':'安徽-黄山-市辖区|anhui-huangshan-shixiaqu|ah-hs-sxq'},{'idx':'12,9,2','code':'341002','name':'屯溪区','search':'安徽-黄山-屯溪区|anhui-huangshan-tunxiqu|ah-hs-txq'},{'idx':'12,9,3','code':'341003','name':'黄山区','search':'安徽-黄山-黄山区|anhui-huangshan-huangshanqu|ah-hs-hsq'},{'idx':'12,9,4','code':'341004','name':'徽州区','search':'安徽-黄山-徽州区|anhui-huangshan-huizhouqu|ah-hs-hzq'},{'idx':'12,9,5','code':'341021','name':'歙县','search':'安徽-黄山-歙县|anhui-huangshan-xixian|ah-hs-xx'},{'idx':'12,9,6','code':'341022','name':'休宁县','search':'安徽-黄山-休宁县|anhui-huangshan-xiuningxian|ah-hs-xnx'},{'idx':'12,9,7','code':'341023','name':'黟县','search':'安徽-黄山-黟县|anhui-huangshan-yixian|ah-hs-yx'},{'idx':'12,9,8','code':'341024','name':'祁门县','search':'安徽-黄山-祁门县|anhui-huangshan-qimenxian|ah-hs-qmx'}]},{'idx':'12,10','code':'341100','name':'滁州','search':'安徽-滁州|anhui-chuzhoushi|ah-czs','children':[{'idx':'12,10,0','code':'-1','name':'全市','search':'全市|quansheng|qs'},{'idx':'12,10,1','code':'341101','name':'市辖区','search':'安徽-滁州-市辖区|anhui-chuzhou-shixiaqu|ah-cz-sxq'},{'idx':'12,10,2','code':'341102','name':'琅琊区','search':'安徽-滁州-琅琊区|anhui-chuzhou-langyaqu|ah-cz-lyq'},{'idx':'12,10,3','code':'341103','name':'南谯区','search':'安徽-滁州-南谯区|anhui-chuzhou-nanqiaoqu|ah-cz-nqq'},{'idx':'12,10,4','code':'341122','name':'来安县','search':'安徽-滁州-来安县|anhui-chuzhou-laianxian|ah-cz-lax'},{'idx':'12,10,5','code':'341124','name':'全椒县','search':'安徽-滁州-全椒县|anhui-chuzhou-quanjiaoxian|ah-cz-qjx'},{'idx':'12,10,6','code':'341125','name':'定远县','search':'安徽-滁州-定远县|anhui-chuzhou-dingyuanxian|ah-cz-dyx'},{'idx':'12,10,7','code':'341126','name':'凤阳县','search':'安徽-滁州-凤阳县|anhui-chuzhou-fengyangxian|ah-cz-fyx'},{'idx':'12,10,8','code':'341181','name':'天长市','search':'安徽-滁州-天长市|anhui-chuzhou-tianchangshi|ah-cz-tcs'},{'idx':'12,10,9','code':'341182','name':'明光市','search':'安徽-滁州-明光市|anhui-chuzhou-mingguangshi|ah-cz-mgs'}]},{'idx':'12,11','code':'341200','name':'阜阳','search':'安徽-阜阳|anhui-fuyangshi|ah-fys','children':[{'idx':'12,11,0','code':'-1','name':'全市','search':'全市|quansheng|qs'},{'idx':'12,11,1','code':'341201','name':'市辖区','search':'安徽-阜阳-市辖区|anhui-fuyang-shixiaqu|ah-fy-sxq'},{'idx':'12,11,2','code':'341202','name':'颍州区','search':'安徽-阜阳-颍州区|anhui-fuyang-yingzhouqu|ah-fy-yzq'},{'idx':'12,11,3','code':'341203','name':'颍东区','search':'安徽-阜阳-颍东区|anhui-fuyang-yingdongqu|ah-fy-ydq'},{'idx':'12,11,4','code':'341204','name':'颍泉区','search':'安徽-阜阳-颍泉区|anhui-fuyang-yingquanqu|ah-fy-yqq'},{'idx':'12,11,5','code':'341221','name':'临泉县','search':'安徽-阜阳-临泉县|anhui-fuyang-linquanxian|ah-fy-lqx'},{'idx':'12,11,6','code':'341222','name':'太和县','search':'安徽-阜阳-太和县|anhui-fuyang-taihexian|ah-fy-thx'},{'idx':'12,11,7','code':'341225','name':'阜南县','search':'安徽-阜阳-阜南县|anhui-fuyang-funanxian|ah-fy-fnx'},{'idx':'12,11,8','code':'341226','name':'颍上县','search':'安徽-阜阳-颍上县|anhui-fuyang-yingshangxian|ah-fy-ysx'},{'idx':'12,11,9','code':'341282','name':'界首市','search':'安徽-阜阳-界首市|anhui-fuyang-jieshoushi|ah-fy-jss'}]},{'idx':'12,12','code':'341300','name':'宿州','search':'安徽-宿州|anhui-suzhoushi|ah-szs','children':[{'idx':'12,12,0','code':'-1','name':'全市','search':'全市|quansheng|qs'},{'idx':'12,12,1','code':'341301','name':'市辖区','search':'安徽-宿州-市辖区|anhui-suzhou-shixiaqu|ah-sz-sxq'},{'idx':'12,12,2','code':'341302','name':'埇桥区','search':'安徽-宿州-埇桥区|anhui-suzhou-埇qiaoqu|ah-sz-埇qq'},{'idx':'12,12,3','code':'341321','name':'砀山县','search':'安徽-宿州-砀山县|anhui-suzhou-dangshanxian|ah-sz-dsx'},{'idx':'12,12,4','code':'341322','name':'萧县','search':'安徽-宿州-萧县|anhui-suzhou-xiaoxian|ah-sz-xx'},{'idx':'12,12,5','code':'341323','name':'灵璧县','search':'安徽-宿州-灵璧县|anhui-suzhou-lingbixian|ah-sz-lbx'},{'idx':'12,12,6','code':'341324','name':'泗县','search':'安徽-宿州-泗县|anhui-suzhou-sixian|ah-sz-sx'}]},{'idx':'12,13','code':'341500','name':'六安','search':'安徽-六安|anhui-liuanshi|ah-las','children':[{'idx':'12,13,0','code':'-1','name':'全市','search':'全市|quansheng|qs'},{'idx':'12,13,1','code':'341501','name':'市辖区','search':'安徽-六安-市辖区|anhui-liuan-shixiaqu|ah-la-sxq'},{'idx':'12,13,2','code':'341502','name':'金安区','search':'安徽-六安-金安区|anhui-liuan-jinanqu|ah-la-jaq'},{'idx':'12,13,3','code':'341503','name':'裕安区','search':'安徽-六安-裕安区|anhui-liuan-yuanqu|ah-la-yaq'},{'idx':'12,13,4','code':'341521','name':'寿县','search':'安徽-六安-寿县|anhui-liuan-shouxian|ah-la-sx'},{'idx':'12,13,5','code':'341522','name':'霍邱县','search':'安徽-六安-霍邱县|anhui-liuan-huoqiuxian|ah-la-hqx'},{'idx':'12,13,6','code':'341523','name':'舒城县','search':'安徽-六安-舒城县|anhui-liuan-shuchengxian|ah-la-scx'},{'idx':'12,13,7','code':'341524','name':'金寨县','search':'安徽-六安-金寨县|anhui-liuan-jinzhaixian|ah-la-jzx'},{'idx':'12,13,8','code':'341525','name':'霍山县','search':'安徽-六安-霍山县|anhui-liuan-huoshanxian|ah-la-hsx'}]},{'idx':'12,14','code':'341600','name':'亳州','search':'安徽-亳州|anhui-bozhoushi|ah-bzs','children':[{'idx':'12,14,0','code':'-1','name':'全市','search':'全市|quansheng|qs'},{'idx':'12,14,1','code':'341601','name':'市辖区','search':'安徽-亳州-市辖区|anhui-bozhou-shixiaqu|ah-bz-sxq'},{'idx':'12,14,2','code':'341602','name':'谯城区','search':'安徽-亳州-谯城区|anhui-bozhou-qiaochengqu|ah-bz-qcq'},{'idx':'12,14,3','code':'341621','name':'涡阳县','search':'安徽-亳州-涡阳县|anhui-bozhou-woyangxian|ah-bz-wyx'},{'idx':'12,14,4','code':'341622','name':'蒙城县','search':'安徽-亳州-蒙城县|anhui-bozhou-mengchengxian|ah-bz-mcx'},{'idx':'12,14,5','code':'341623','name':'利辛县','search':'安徽-亳州-利辛县|anhui-bozhou-lixinxian|ah-bz-lxx'}]},{'idx':'12,15','code':'341700','name':'池州','search':'安徽-池州|anhui-chizhoushi|ah-czs','children':[{'idx':'12,15,0','code':'-1','name':'全市','search':'全市|quansheng|qs'},{'idx':'12,15,1','code':'341701','name':'市辖区','search':'安徽-池州-市辖区|anhui-chizhou-shixiaqu|ah-cz-sxq'},{'idx':'12,15,2','code':'341702','name':'贵池区','search':'安徽-池州-贵池区|anhui-chizhou-guichiqu|ah-cz-gcq'},{'idx':'12,15,3','code':'341721','name':'东至县','search':'安徽-池州-东至县|anhui-chizhou-dongzhixian|ah-cz-dzx'},{'idx':'12,15,4','code':'341722','name':'石台县','search':'安徽-池州-石台县|anhui-chizhou-shitaixian|ah-cz-stx'},{'idx':'12,15,5','code':'341723','name':'青阳县','search':'安徽-池州-青阳县|anhui-chizhou-qingyangxian|ah-cz-qyx'}]},{'idx':'12,16','code':'341800','name':'宣城','search':'安徽-宣城|anhui-xuanchengshi|ah-xcs','children':[{'idx':'12,16,0','code':'-1','name':'全市','search':'全市|quansheng|qs'},{'idx':'12,16,1','code':'341801','name':'市辖区','search':'安徽-宣城-市辖区|anhui-xuancheng-shixiaqu|ah-xc-sxq'},{'idx':'12,16,2','code':'341802','name':'宣州区','search':'安徽-宣城-宣州区|anhui-xuancheng-xuanzhouqu|ah-xc-xzq'},{'idx':'12,16,3','code':'341821','name':'郎溪县','search':'安徽-宣城-郎溪县|anhui-xuancheng-langxixian|ah-xc-lxx'},{'idx':'12,16,4','code':'341822','name':'广德县','search':'安徽-宣城-广德县|anhui-xuancheng-guangdexian|ah-xc-gdx'},{'idx':'12,16,5','code':'341823','name':'泾县','search':'安徽-宣城-泾县|anhui-xuancheng-jingxian|ah-xc-jx'},{'idx':'12,16,6','code':'341824','name':'绩溪县','search':'安徽-宣城-绩溪县|anhui-xuancheng-jixixian|ah-xc-jxx'},{'idx':'12,16,7','code':'341825','name':'旌德县','search':'安徽-宣城-旌德县|anhui-xuancheng-jingdexian|ah-xc-jdx'},{'idx':'12,16,8','code':'341881','name':'宁国市','search':'安徽-宣城-宁国市|anhui-xuancheng-ningguoshi|ah-xc-ngs'}]}]},{'idx':13,'code':'350000','name':'福建','search':'福建|fujiansheng|fjs','children':[{'idx':'13,0','code':'-1','name':'全省','search':'全省|quansheng|qs'},{'idx':'13,1','code':'350100','name':'福州','search':'福建-福州|fujian-fuzhoushi|fj-fzs','children':[{'idx':'13,1,0','code':'-1','name':'全市','search':'全市|quansheng|qs'},{'idx':'13,1,1','code':'350101','name':'市辖区','search':'福建-福州-市辖区|fujian-fuzhou-shixiaqu|fj-fz-sxq'},{'idx':'13,1,2','code':'350102','name':'鼓楼区','search':'福建-福州-鼓楼区|fujian-fuzhou-gulouqu|fj-fz-glq'},{'idx':'13,1,3','code':'350103','name':'台江区','search':'福建-福州-台江区|fujian-fuzhou-taijiangqu|fj-fz-tjq'},{'idx':'13,1,4','code':'350104','name':'仓山区','search':'福建-福州-仓山区|fujian-fuzhou-cangshanqu|fj-fz-csq'},{'idx':'13,1,5','code':'350105','name':'马尾区','search':'福建-福州-马尾区|fujian-fuzhou-maweiqu|fj-fz-mwq'},{'idx':'13,1,6','code':'350111','name':'晋安区','search':'福建-福州-晋安区|fujian-fuzhou-jinanqu|fj-fz-jaq'},{'idx':'13,1,7','code':'350121','name':'闽侯县','search':'福建-福州-闽侯县|fujian-fuzhou-minhouxian|fj-fz-mhx'},{'idx':'13,1,8','code':'350122','name':'连江县','search':'福建-福州-连江县|fujian-fuzhou-lianjiangxian|fj-fz-ljx'},{'idx':'13,1,9','code':'350123','name':'罗源县','search':'福建-福州-罗源县|fujian-fuzhou-luoyuanxian|fj-fz-lyx'},{'idx':'13,1,10','code':'350124','name':'闽清县','search':'福建-福州-闽清县|fujian-fuzhou-minqingxian|fj-fz-mqx'},{'idx':'13,1,11','code':'350125','name':'永泰县','search':'福建-福州-永泰县|fujian-fuzhou-yongtaixian|fj-fz-ytx'},{'idx':'13,1,12','code':'350128','name':'平潭县','search':'福建-福州-平潭县|fujian-fuzhou-pingtanxian|fj-fz-ptx'},{'idx':'13,1,13','code':'350181','name':'福清市','search':'福建-福州-福清市|fujian-fuzhou-fuqingshi|fj-fz-fqs'},{'idx':'13,1,14','code':'350182','name':'长乐市','search':'福建-福州-长乐市|fujian-fuzhou-changleshi|fj-fz-cls'}]},{'idx':'13,2','code':'350200','name':'厦门','search':'福建-厦门|fujian-xiamenshi|fj-xms','children':[{'idx':'13,2,0','code':'-1','name':'全市','search':'全市|quansheng|qs'},{'idx':'13,2,1','code':'350201','name':'市辖区','search':'福建-厦门-市辖区|fujian-xiamen-shixiaqu|fj-xm-sxq'},{'idx':'13,2,2','code':'350203','name':'思明区','search':'福建-厦门-思明区|fujian-xiamen-simingqu|fj-xm-smq'},{'idx':'13,2,3','code':'350205','name':'海沧区','search':'福建-厦门-海沧区|fujian-xiamen-haicangqu|fj-xm-hcq'},{'idx':'13,2,4','code':'350206','name':'湖里区','search':'福建-厦门-湖里区|fujian-xiamen-huliqu|fj-xm-hlq'},{'idx':'13,2,5','code':'350211','name':'集美区','search':'福建-厦门-集美区|fujian-xiamen-jimeiqu|fj-xm-jmq'},{'idx':'13,2,6','code':'350212','name':'同安区','search':'福建-厦门-同安区|fujian-xiamen-tonganqu|fj-xm-taq'},{'idx':'13,2,7','code':'350213','name':'翔安区','search':'福建-厦门-翔安区|fujian-xiamen-xianganqu|fj-xm-xaq'}]},{'idx':'13,3','code':'350300','name':'莆田','search':'福建-莆田|fujian-putianshi|fj-pts','children':[{'idx':'13,3,0','code':'-1','name':'全市','search':'全市|quansheng|qs'},{'idx':'13,3,1','code':'350301','name':'市辖区','search':'福建-莆田-市辖区|fujian-putian-shixiaqu|fj-pt-sxq'},{'idx':'13,3,2','code':'350302','name':'城厢区','search':'福建-莆田-城厢区|fujian-putian-chengxiangqu|fj-pt-cxq'},{'idx':'13,3,3','code':'350303','name':'涵江区','search':'福建-莆田-涵江区|fujian-putian-hanjiangqu|fj-pt-hjq'},{'idx':'13,3,4','code':'350304','name':'荔城区','search':'福建-莆田-荔城区|fujian-putian-lichengqu|fj-pt-lcq'},{'idx':'13,3,5','code':'350305','name':'秀屿区','search':'福建-莆田-秀屿区|fujian-putian-xiuyuqu|fj-pt-xyq'},{'idx':'13,3,6','code':'350322','name':'仙游县','search':'福建-莆田-仙游县|fujian-putian-xianyouxian|fj-pt-xyx'}]},{'idx':'13,4','code':'350400','name':'三明','search':'福建-三明|fujian-sanmingshi|fj-sms','children':[{'idx':'13,4,0','code':'-1','name':'全市','search':'全市|quansheng|qs'},{'idx':'13,4,1','code':'350401','name':'市辖区','search':'福建-三明-市辖区|fujian-sanming-shixiaqu|fj-sm-sxq'},{'idx':'13,4,2','code':'350402','name':'梅列区','search':'福建-三明-梅列区|fujian-sanming-meiliequ|fj-sm-mlq'},{'idx':'13,4,3','code':'350403','name':'三元区','search':'福建-三明-三元区|fujian-sanming-sanyuanqu|fj-sm-syq'},{'idx':'13,4,4','code':'350421','name':'明溪县','search':'福建-三明-明溪县|fujian-sanming-mingxixian|fj-sm-mxx'},{'idx':'13,4,5','code':'350423','name':'清流县','search':'福建-三明-清流县|fujian-sanming-qingliuxian|fj-sm-qlx'},{'idx':'13,4,6','code':'350424','name':'宁化县','search':'福建-三明-宁化县|fujian-sanming-ninghuaxian|fj-sm-nhx'},{'idx':'13,4,7','code':'350425','name':'大田县','search':'福建-三明-大田县|fujian-sanming-datianxian|fj-sm-dtx'},{'idx':'13,4,8','code':'350426','name':'尤溪县','search':'福建-三明-尤溪县|fujian-sanming-youxixian|fj-sm-yxx'},{'idx':'13,4,9','code':'350427','name':'沙县','search':'福建-三明-沙县|fujian-sanming-shaxian|fj-sm-sx'},{'idx':'13,4,10','code':'350428','name':'将乐县','search':'福建-三明-将乐县|fujian-sanming-jianglexian|fj-sm-jlx'},{'idx':'13,4,11','code':'350429','name':'泰宁县','search':'福建-三明-泰宁县|fujian-sanming-tainingxian|fj-sm-tnx'},{'idx':'13,4,12','code':'350430','name':'建宁县','search':'福建-三明-建宁县|fujian-sanming-jianningxian|fj-sm-jnx'},{'idx':'13,4,13','code':'350481','name':'永安市','search':'福建-三明-永安市|fujian-sanming-yonganshi|fj-sm-yas'}]},{'idx':'13,5','code':'350500','name':'泉州','search':'福建-泉州|fujian-quanzhoushi|fj-qzs','children':[{'idx':'13,5,0','code':'-1','name':'全市','search':'全市|quansheng|qs'},{'idx':'13,5,1','code':'350501','name':'市辖区','search':'福建-泉州-市辖区|fujian-quanzhou-shixiaqu|fj-qz-sxq'},{'idx':'13,5,2','code':'350502','name':'鲤城区','search':'福建-泉州-鲤城区|fujian-quanzhou-lichengqu|fj-qz-lcq'},{'idx':'13,5,3','code':'350503','name':'丰泽区','search':'福建-泉州-丰泽区|fujian-quanzhou-fengzequ|fj-qz-fzq'},{'idx':'13,5,4','code':'350504','name':'洛江区','search':'福建-泉州-洛江区|fujian-quanzhou-luojiangqu|fj-qz-ljq'},{'idx':'13,5,5','code':'350505','name':'泉港区','search':'福建-泉州-泉港区|fujian-quanzhou-quangangqu|fj-qz-qgq'},{'idx':'13,5,6','code':'350521','name':'惠安县','search':'福建-泉州-惠安县|fujian-quanzhou-huianxian|fj-qz-hax'},{'idx':'13,5,7','code':'350524','name':'安溪县','search':'福建-泉州-安溪县|fujian-quanzhou-anxixian|fj-qz-axx'},{'idx':'13,5,8','code':'350525','name':'永春县','search':'福建-泉州-永春县|fujian-quanzhou-yongchunxian|fj-qz-ycx'},{'idx':'13,5,9','code':'350526','name':'德化县','search':'福建-泉州-德化县|fujian-quanzhou-dehuaxian|fj-qz-dhx'},{'idx':'13,5,10','code':'350527','name':'金门县','search':'福建-泉州-金门县|fujian-quanzhou-jinmenxian|fj-qz-jmx'},{'idx':'13,5,11','code':'350581','name':'石狮市','search':'福建-泉州-石狮市|fujian-quanzhou-shishishi|fj-qz-sss'},{'idx':'13,5,12','code':'350582','name':'晋江市','search':'福建-泉州-晋江市|fujian-quanzhou-jinjiangshi|fj-qz-jjs'},{'idx':'13,5,13','code':'350583','name':'南安市','search':'福建-泉州-南安市|fujian-quanzhou-nananshi|fj-qz-nas'}]},{'idx':'13,6','code':'350600','name':'漳州','search':'福建-漳州|fujian-zhangzhoushi|fj-zzs','children':[{'idx':'13,6,0','code':'-1','name':'全市','search':'全市|quansheng|qs'},{'idx':'13,6,1','code':'350601','name':'市辖区','search':'福建-漳州-市辖区|fujian-zhangzhou-shixiaqu|fj-zz-sxq'},{'idx':'13,6,2','code':'350602','name':'芗城区','search':'福建-漳州-芗城区|fujian-zhangzhou-xiangchengqu|fj-zz-xcq'},{'idx':'13,6,3','code':'350603','name':'龙文区','search':'福建-漳州-龙文区|fujian-zhangzhou-longwenqu|fj-zz-lwq'},{'idx':'13,6,4','code':'350622','name':'云霄县','search':'福建-漳州-云霄县|fujian-zhangzhou-yunxiaoxian|fj-zz-yxx'},{'idx':'13,6,5','code':'350623','name':'漳浦县','search':'福建-漳州-漳浦县|fujian-zhangzhou-zhangpuxian|fj-zz-zpx'},{'idx':'13,6,6','code':'350624','name':'诏安县','search':'福建-漳州-诏安县|fujian-zhangzhou-zhaoanxian|fj-zz-zax'},{'idx':'13,6,7','code':'350625','name':'长泰县','search':'福建-漳州-长泰县|fujian-zhangzhou-changtaixian|fj-zz-ctx'},{'idx':'13,6,8','code':'350626','name':'东山县','search':'福建-漳州-东山县|fujian-zhangzhou-dongshanxian|fj-zz-dsx'},{'idx':'13,6,9','code':'350627','name':'南靖县','search':'福建-漳州-南靖县|fujian-zhangzhou-nanjingxian|fj-zz-njx'},{'idx':'13,6,10','code':'350628','name':'平和县','search':'福建-漳州-平和县|fujian-zhangzhou-pinghexian|fj-zz-phx'},{'idx':'13,6,11','code':'350629','name':'华安县','search':'福建-漳州-华安县|fujian-zhangzhou-huaanxian|fj-zz-hax'},{'idx':'13,6,12','code':'350681','name':'龙海市','search':'福建-漳州-龙海市|fujian-zhangzhou-longhaishi|fj-zz-lhs'}]},{'idx':'13,7','code':'350700','name':'南平','search':'福建-南平|fujian-nanpingshi|fj-nps','children':[{'idx':'13,7,0','code':'-1','name':'全市','search':'全市|quansheng|qs'},{'idx':'13,7,1','code':'350701','name':'市辖区','search':'福建-南平-市辖区|fujian-nanping-shixiaqu|fj-np-sxq'},{'idx':'13,7,2','code':'350702','name':'延平区','search':'福建-南平-延平区|fujian-nanping-yanpingqu|fj-np-ypq'},{'idx':'13,7,3','code':'350703','name':'建阳区','search':'福建-南平-建阳区|fujian-nanping-jianyangqu|fj-np-jyq'},{'idx':'13,7,4','code':'350721','name':'顺昌县','search':'福建-南平-顺昌县|fujian-nanping-shunchangxian|fj-np-scx'},{'idx':'13,7,5','code':'350722','name':'浦城县','search':'福建-南平-浦城县|fujian-nanping-puchengxian|fj-np-pcx'},{'idx':'13,7,6','code':'350723','name':'光泽县','search':'福建-南平-光泽县|fujian-nanping-guangzexian|fj-np-gzx'},{'idx':'13,7,7','code':'350724','name':'松溪县','search':'福建-南平-松溪县|fujian-nanping-songxixian|fj-np-sxx'},{'idx':'13,7,8','code':'350725','name':'政和县','search':'福建-南平-政和县|fujian-nanping-zhenghexian|fj-np-zhx'},{'idx':'13,7,9','code':'350781','name':'邵武市','search':'福建-南平-邵武市|fujian-nanping-shaowushi|fj-np-sws'},{'idx':'13,7,10','code':'350782','name':'武夷山市','search':'福建-南平-武夷山市|fujian-nanping-wuyishanshi|fj-np-wyss'},{'idx':'13,7,11','code':'350783','name':'建瓯市','search':'福建-南平-建瓯市|fujian-nanping-jianoushi|fj-np-jos'}]},{'idx':'13,8','code':'350800','name':'龙岩','search':'福建-龙岩|fujian-longyanshi|fj-lys','children':[{'idx':'13,8,0','code':'-1','name':'全市','search':'全市|quansheng|qs'},{'idx':'13,8,1','code':'350801','name':'市辖区','search':'福建-龙岩-市辖区|fujian-longyan-shixiaqu|fj-ly-sxq'},{'idx':'13,8,2','code':'350802','name':'新罗区','search':'福建-龙岩-新罗区|fujian-longyan-xinluoqu|fj-ly-xlq'},{'idx':'13,8,3','code':'350803','name':'永定区','search':'福建-龙岩-永定区|fujian-longyan-yongdingqu|fj-ly-ydq'},{'idx':'13,8,4','code':'350821','name':'长汀县','search':'福建-龙岩-长汀县|fujian-longyan-changtingxian|fj-ly-ctx'},{'idx':'13,8,5','code':'350823','name':'上杭县','search':'福建-龙岩-上杭县|fujian-longyan-shanghangxian|fj-ly-shx'},{'idx':'13,8,6','code':'350824','name':'武平县','search':'福建-龙岩-武平县|fujian-longyan-wupingxian|fj-ly-wpx'},{'idx':'13,8,7','code':'350825','name':'连城县','search':'福建-龙岩-连城县|fujian-longyan-lianchengxian|fj-ly-lcx'},{'idx':'13,8,8','code':'350881','name':'漳平市','search':'福建-龙岩-漳平市|fujian-longyan-zhangpingshi|fj-ly-zps'}]},{'idx':'13,9','code':'350900','name':'宁德','search':'福建-宁德|fujian-ningdeshi|fj-nds','children':[{'idx':'13,9,0','code':'-1','name':'全市','search':'全市|quansheng|qs'},{'idx':'13,9,1','code':'350901','name':'市辖区','search':'福建-宁德-市辖区|fujian-ningde-shixiaqu|fj-nd-sxq'},{'idx':'13,9,2','code':'350902','name':'蕉城区','search':'福建-宁德-蕉城区|fujian-ningde-jiaochengqu|fj-nd-jcq'},{'idx':'13,9,3','code':'350921','name':'霞浦县','search':'福建-宁德-霞浦县|fujian-ningde-xiapuxian|fj-nd-xpx'},{'idx':'13,9,4','code':'350922','name':'古田县','search':'福建-宁德-古田县|fujian-ningde-gutianxian|fj-nd-gtx'},{'idx':'13,9,5','code':'350923','name':'屏南县','search':'福建-宁德-屏南县|fujian-ningde-pingnanxian|fj-nd-pnx'},{'idx':'13,9,6','code':'350924','name':'寿宁县','search':'福建-宁德-寿宁县|fujian-ningde-shouningxian|fj-nd-snx'},{'idx':'13,9,7','code':'350925','name':'周宁县','search':'福建-宁德-周宁县|fujian-ningde-zhouningxian|fj-nd-znx'},{'idx':'13,9,8','code':'350926','name':'柘荣县','search':'福建-宁德-柘荣县|fujian-ningde-zherongxian|fj-nd-zrx'},{'idx':'13,9,9','code':'350981','name':'福安市','search':'福建-宁德-福安市|fujian-ningde-fuanshi|fj-nd-fas'},{'idx':'13,9,10','code':'350982','name':'福鼎市','search':'福建-宁德-福鼎市|fujian-ningde-fudingshi|fj-nd-fds'}]}]},{'idx':14,'code':'360000','name':'江西','search':'江西|jiangxisheng|jxs','children':[{'idx':'14,0','code':'-1','name':'全省','search':'全省|quansheng|qs'},{'idx':'14,1','code':'360100','name':'南昌','search':'江西-南昌|jiangxi-nanchangshi|jx-ncs','children':[{'idx':'14,1,0','code':'-1','name':'全市','search':'全市|quansheng|qs'},{'idx':'14,1,1','code':'360101','name':'市辖区','search':'江西-南昌-市辖区|jiangxi-nanchang-shixiaqu|jx-nc-sxq'},{'idx':'14,1,2','code':'360102','name':'东湖区','search':'江西-南昌-东湖区|jiangxi-nanchang-donghuqu|jx-nc-dhq'},{'idx':'14,1,3','code':'360103','name':'西湖区','search':'江西-南昌-西湖区|jiangxi-nanchang-xihuqu|jx-nc-xhq'},{'idx':'14,1,4','code':'360104','name':'青云谱区','search':'江西-南昌-青云谱区|jiangxi-nanchang-qingyunpuqu|jx-nc-qypq'},{'idx':'14,1,5','code':'360105','name':'湾里区','search':'江西-南昌-湾里区|jiangxi-nanchang-wanliqu|jx-nc-wlq'},{'idx':'14,1,6','code':'360111','name':'青山湖区','search':'江西-南昌-青山湖区|jiangxi-nanchang-qingshanhuqu|jx-nc-qshq'},{'idx':'14,1,7','code':'360112','name':'新建区','search':'江西-南昌-新建区|jiangxi-nanchang-xinjianqu|jx-nc-xjq'},{'idx':'14,1,8','code':'360121','name':'南昌县','search':'江西-南昌-南昌县|jiangxi-nanchang-nanchangxian|jx-nc-ncx'},{'idx':'14,1,9','code':'360123','name':'安义县','search':'江西-南昌-安义县|jiangxi-nanchang-anyixian|jx-nc-ayx'},{'idx':'14,1,10','code':'360124','name':'进贤县','search':'江西-南昌-进贤县|jiangxi-nanchang-jinxianxian|jx-nc-jxx'}]},{'idx':'14,2','code':'360200','name':'景德镇','search':'江西-景德镇|jiangxi-jingdezhenshi|jx-jdzs','children':[{'idx':'14,2,0','code':'-1','name':'全市','search':'全市|quansheng|qs'},{'idx':'14,2,1','code':'360201','name':'市辖区','search':'江西-景德镇-市辖区|jiangxi-jingdezhen-shixiaqu|jx-jdz-sxq'},{'idx':'14,2,2','code':'360202','name':'昌江区','search':'江西-景德镇-昌江区|jiangxi-jingdezhen-changjiangqu|jx-jdz-cjq'},{'idx':'14,2,3','code':'360203','name':'珠山区','search':'江西-景德镇-珠山区|jiangxi-jingdezhen-zhushanqu|jx-jdz-zsq'},{'idx':'14,2,4','code':'360222','name':'浮梁县','search':'江西-景德镇-浮梁县|jiangxi-jingdezhen-fuliangxian|jx-jdz-flx'},{'idx':'14,2,5','code':'360281','name':'乐平市','search':'江西-景德镇-乐平市|jiangxi-jingdezhen-lepingshi|jx-jdz-lps'}]},{'idx':'14,3','code':'360300','name':'萍乡','search':'江西-萍乡|jiangxi-pingxiangshi|jx-pxs','children':[{'idx':'14,3,0','code':'-1','name':'全市','search':'全市|quansheng|qs'},{'idx':'14,3,1','code':'360301','name':'市辖区','search':'江西-萍乡-市辖区|jiangxi-pingxiang-shixiaqu|jx-px-sxq'},{'idx':'14,3,2','code':'360302','name':'安源区','search':'江西-萍乡-安源区|jiangxi-pingxiang-anyuanqu|jx-px-ayq'},{'idx':'14,3,3','code':'360313','name':'湘东区','search':'江西-萍乡-湘东区|jiangxi-pingxiang-xiangdongqu|jx-px-xdq'},{'idx':'14,3,4','code':'360321','name':'莲花县','search':'江西-萍乡-莲花县|jiangxi-pingxiang-lianhuaxian|jx-px-lhx'},{'idx':'14,3,5','code':'360322','name':'上栗县','search':'江西-萍乡-上栗县|jiangxi-pingxiang-shanglixian|jx-px-slx'},{'idx':'14,3,6','code':'360323','name':'芦溪县','search':'江西-萍乡-芦溪县|jiangxi-pingxiang-luxixian|jx-px-lxx'}]},{'idx':'14,4','code':'360400','name':'九江','search':'江西-九江|jiangxi-jiujiangshi|jx-jjs','children':[{'idx':'14,4,0','code':'-1','name':'全市','search':'全市|quansheng|qs'},{'idx':'14,4,1','code':'360401','name':'市辖区','search':'江西-九江-市辖区|jiangxi-jiujiang-shixiaqu|jx-jj-sxq'},{'idx':'14,4,2','code':'360402','name':'庐山区','search':'江西-九江-庐山区|jiangxi-jiujiang-lushanqu|jx-jj-lsq'},{'idx':'14,4,3','code':'360403','name':'浔阳区','search':'江西-九江-浔阳区|jiangxi-jiujiang-xunyangqu|jx-jj-xyq'},{'idx':'14,4,4','code':'360421','name':'九江县','search':'江西-九江-九江县|jiangxi-jiujiang-jiujiangxian|jx-jj-jjx'},{'idx':'14,4,5','code':'360423','name':'武宁县','search':'江西-九江-武宁县|jiangxi-jiujiang-wuningxian|jx-jj-wnx'},{'idx':'14,4,6','code':'360424','name':'修水县','search':'江西-九江-修水县|jiangxi-jiujiang-xiushuixian|jx-jj-xsx'},{'idx':'14,4,7','code':'360425','name':'永修县','search':'江西-九江-永修县|jiangxi-jiujiang-yongxiuxian|jx-jj-yxx'},{'idx':'14,4,8','code':'360426','name':'德安县','search':'江西-九江-德安县|jiangxi-jiujiang-deanxian|jx-jj-dax'},{'idx':'14,4,9','code':'360427','name':'星子县','search':'江西-九江-星子县|jiangxi-jiujiang-xingzixian|jx-jj-xzx'},{'idx':'14,4,10','code':'360428','name':'都昌县','search':'江西-九江-都昌县|jiangxi-jiujiang-duchangxian|jx-jj-dcx'},{'idx':'14,4,11','code':'360429','name':'湖口县','search':'江西-九江-湖口县|jiangxi-jiujiang-hukouxian|jx-jj-hkx'},{'idx':'14,4,12','code':'360430','name':'彭泽县','search':'江西-九江-彭泽县|jiangxi-jiujiang-pengzexian|jx-jj-pzx'},{'idx':'14,4,13','code':'360481','name':'瑞昌市','search':'江西-九江-瑞昌市|jiangxi-jiujiang-ruichangshi|jx-jj-rcs'},{'idx':'14,4,14','code':'360482','name':'共青城市','search':'江西-九江-共青城市|jiangxi-jiujiang-gongqingchengshi|jx-jj-gqcs'}]},{'idx':'14,5','code':'360500','name':'新余','search':'江西-新余|jiangxi-xinyushi|jx-xys','children':[{'idx':'14,5,0','code':'-1','name':'全市','search':'全市|quansheng|qs'},{'idx':'14,5,1','code':'360501','name':'市辖区','search':'江西-新余-市辖区|jiangxi-xinyu-shixiaqu|jx-xy-sxq'},{'idx':'14,5,2','code':'360502','name':'渝水区','search':'江西-新余-渝水区|jiangxi-xinyu-yushuiqu|jx-xy-ysq'},{'idx':'14,5,3','code':'360521','name':'分宜县','search':'江西-新余-分宜县|jiangxi-xinyu-fenyixian|jx-xy-fyx'}]},{'idx':'14,6','code':'360600','name':'鹰潭','search':'江西-鹰潭|jiangxi-yingtanshi|jx-yts','children':[{'idx':'14,6,0','code':'-1','name':'全市','search':'全市|quansheng|qs'},{'idx':'14,6,1','code':'360601','name':'市辖区','search':'江西-鹰潭-市辖区|jiangxi-yingtan-shixiaqu|jx-yt-sxq'},{'idx':'14,6,2','code':'360602','name':'月湖区','search':'江西-鹰潭-月湖区|jiangxi-yingtan-yuehuqu|jx-yt-yhq'},{'idx':'14,6,3','code':'360622','name':'余江县','search':'江西-鹰潭-余江县|jiangxi-yingtan-yujiangxian|jx-yt-yjx'},{'idx':'14,6,4','code':'360681','name':'贵溪市','search':'江西-鹰潭-贵溪市|jiangxi-yingtan-guixishi|jx-yt-gxs'}]},{'idx':'14,7','code':'360700','name':'赣州','search':'江西-赣州|jiangxi-ganzhoushi|jx-gzs','children':[{'idx':'14,7,0','code':'-1','name':'全市','search':'全市|quansheng|qs'},{'idx':'14,7,1','code':'360701','name':'市辖区','search':'江西-赣州-市辖区|jiangxi-ganzhou-shixiaqu|jx-gz-sxq'},{'idx':'14,7,2','code':'360702','name':'章贡区','search':'江西-赣州-章贡区|jiangxi-ganzhou-zhanggongqu|jx-gz-zgq'},{'idx':'14,7,3','code':'360703','name':'南康区','search':'江西-赣州-南康区|jiangxi-ganzhou-nankangqu|jx-gz-nkq'},{'idx':'14,7,4','code':'360721','name':'赣县','search':'江西-赣州-赣县|jiangxi-ganzhou-ganxian|jx-gz-gx'},{'idx':'14,7,5','code':'360722','name':'信丰县','search':'江西-赣州-信丰县|jiangxi-ganzhou-xinfengxian|jx-gz-xfx'},{'idx':'14,7,6','code':'360723','name':'大余县','search':'江西-赣州-大余县|jiangxi-ganzhou-dayuxian|jx-gz-dyx'},{'idx':'14,7,7','code':'360724','name':'上犹县','search':'江西-赣州-上犹县|jiangxi-ganzhou-shangyouxian|jx-gz-syx'},{'idx':'14,7,8','code':'360725','name':'崇义县','search':'江西-赣州-崇义县|jiangxi-ganzhou-chongyixian|jx-gz-cyx'},{'idx':'14,7,9','code':'360726','name':'安远县','search':'江西-赣州-安远县|jiangxi-ganzhou-anyuanxian|jx-gz-ayx'},{'idx':'14,7,10','code':'360727','name':'龙南县','search':'江西-赣州-龙南县|jiangxi-ganzhou-longnanxian|jx-gz-lnx'},{'idx':'14,7,11','code':'360728','name':'定南县','search':'江西-赣州-定南县|jiangxi-ganzhou-dingnanxian|jx-gz-dnx'},{'idx':'14,7,12','code':'360729','name':'全南县','search':'江西-赣州-全南县|jiangxi-ganzhou-quannanxian|jx-gz-qnx'},{'idx':'14,7,13','code':'360730','name':'宁都县','search':'江西-赣州-宁都县|jiangxi-ganzhou-ningduxian|jx-gz-ndx'},{'idx':'14,7,14','code':'360731','name':'于都县','search':'江西-赣州-于都县|jiangxi-ganzhou-yuduxian|jx-gz-ydx'},{'idx':'14,7,15','code':'360732','name':'兴国县','search':'江西-赣州-兴国县|jiangxi-ganzhou-xingguoxian|jx-gz-xgx'},{'idx':'14,7,16','code':'360733','name':'会昌县','search':'江西-赣州-会昌县|jiangxi-ganzhou-huichangxian|jx-gz-hcx'},{'idx':'14,7,17','code':'360734','name':'寻乌县','search':'江西-赣州-寻乌县|jiangxi-ganzhou-xunwuxian|jx-gz-xwx'},{'idx':'14,7,18','code':'360735','name':'石城县','search':'江西-赣州-石城县|jiangxi-ganzhou-shichengxian|jx-gz-scx'},{'idx':'14,7,19','code':'360781','name':'瑞金市','search':'江西-赣州-瑞金市|jiangxi-ganzhou-ruijinshi|jx-gz-rjs'}]},{'idx':'14,8','code':'360800','name':'吉安','search':'江西-吉安|jiangxi-jianshi|jx-jas','children':[{'idx':'14,8,0','code':'-1','name':'全市','search':'全市|quansheng|qs'},{'idx':'14,8,1','code':'360801','name':'市辖区','search':'江西-吉安-市辖区|jiangxi-jian-shixiaqu|jx-ja-sxq'},{'idx':'14,8,2','code':'360802','name':'吉州区','search':'江西-吉安-吉州区|jiangxi-jian-jizhouqu|jx-ja-jzq'},{'idx':'14,8,3','code':'360803','name':'青原区','search':'江西-吉安-青原区|jiangxi-jian-qingyuanqu|jx-ja-qyq'},{'idx':'14,8,4','code':'360821','name':'吉安县','search':'江西-吉安-吉安县|jiangxi-jian-jianxian|jx-ja-jax'},{'idx':'14,8,5','code':'360822','name':'吉水县','search':'江西-吉安-吉水县|jiangxi-jian-jishuixian|jx-ja-jsx'},{'idx':'14,8,6','code':'360823','name':'峡江县','search':'江西-吉安-峡江县|jiangxi-jian-xiajiangxian|jx-ja-xjx'},{'idx':'14,8,7','code':'360824','name':'新干县','search':'江西-吉安-新干县|jiangxi-jian-xinganxian|jx-ja-xgx'},{'idx':'14,8,8','code':'360825','name':'永丰县','search':'江西-吉安-永丰县|jiangxi-jian-yongfengxian|jx-ja-yfx'},{'idx':'14,8,9','code':'360826','name':'泰和县','search':'江西-吉安-泰和县|jiangxi-jian-taihexian|jx-ja-thx'},{'idx':'14,8,10','code':'360827','name':'遂川县','search':'江西-吉安-遂川县|jiangxi-jian-suichuanxian|jx-ja-scx'},{'idx':'14,8,11','code':'360828','name':'万安县','search':'江西-吉安-万安县|jiangxi-jian-wananxian|jx-ja-wax'},{'idx':'14,8,12','code':'360829','name':'安福县','search':'江西-吉安-安福县|jiangxi-jian-anfuxian|jx-ja-afx'},{'idx':'14,8,13','code':'360830','name':'永新县','search':'江西-吉安-永新县|jiangxi-jian-yongxinxian|jx-ja-yxx'},{'idx':'14,8,14','code':'360881','name':'井冈山市','search':'江西-吉安-井冈山市|jiangxi-jian-jinggangshanshi|jx-ja-jgss'}]},{'idx':'14,9','code':'360900','name':'宜春','search':'江西-宜春|jiangxi-yichunshi|jx-ycs','children':[{'idx':'14,9,0','code':'-1','name':'全市','search':'全市|quansheng|qs'},{'idx':'14,9,1','code':'360901','name':'市辖区','search':'江西-宜春-市辖区|jiangxi-yichun-shixiaqu|jx-yc-sxq'},{'idx':'14,9,2','code':'360902','name':'袁州区','search':'江西-宜春-袁州区|jiangxi-yichun-yuanzhouqu|jx-yc-yzq'},{'idx':'14,9,3','code':'360921','name':'奉新县','search':'江西-宜春-奉新县|jiangxi-yichun-fengxinxian|jx-yc-fxx'},{'idx':'14,9,4','code':'360922','name':'万载县','search':'江西-宜春-万载县|jiangxi-yichun-wanzaixian|jx-yc-wzx'},{'idx':'14,9,5','code':'360923','name':'上高县','search':'江西-宜春-上高县|jiangxi-yichun-shanggaoxian|jx-yc-sgx'},{'idx':'14,9,6','code':'360924','name':'宜丰县','search':'江西-宜春-宜丰县|jiangxi-yichun-yifengxian|jx-yc-yfx'},{'idx':'14,9,7','code':'360925','name':'靖安县','search':'江西-宜春-靖安县|jiangxi-yichun-jinganxian|jx-yc-jax'},{'idx':'14,9,8','code':'360926','name':'铜鼓县','search':'江西-宜春-铜鼓县|jiangxi-yichun-tongguxian|jx-yc-tgx'},{'idx':'14,9,9','code':'360981','name':'丰城市','search':'江西-宜春-丰城市|jiangxi-yichun-fengchengshi|jx-yc-fcs'},{'idx':'14,9,10','code':'360982','name':'樟树市','search':'江西-宜春-樟树市|jiangxi-yichun-zhangshushi|jx-yc-zss'},{'idx':'14,9,11','code':'360983','name':'高安市','search':'江西-宜春-高安市|jiangxi-yichun-gaoanshi|jx-yc-gas'}]},{'idx':'14,10','code':'361000','name':'抚州','search':'江西-抚州|jiangxi-fuzhoushi|jx-fzs','children':[{'idx':'14,10,0','code':'-1','name':'全市','search':'全市|quansheng|qs'},{'idx':'14,10,1','code':'361001','name':'市辖区','search':'江西-抚州-市辖区|jiangxi-fuzhou-shixiaqu|jx-fz-sxq'},{'idx':'14,10,2','code':'361002','name':'临川区','search':'江西-抚州-临川区|jiangxi-fuzhou-linchuanqu|jx-fz-lcq'},{'idx':'14,10,3','code':'361021','name':'南城县','search':'江西-抚州-南城县|jiangxi-fuzhou-nanchengxian|jx-fz-ncx'},{'idx':'14,10,4','code':'361022','name':'黎川县','search':'江西-抚州-黎川县|jiangxi-fuzhou-lichuanxian|jx-fz-lcx'},{'idx':'14,10,5','code':'361023','name':'南丰县','search':'江西-抚州-南丰县|jiangxi-fuzhou-nanfengxian|jx-fz-nfx'},{'idx':'14,10,6','code':'361024','name':'崇仁县','search':'江西-抚州-崇仁县|jiangxi-fuzhou-chongrenxian|jx-fz-crx'},{'idx':'14,10,7','code':'361025','name':'乐安县','search':'江西-抚州-乐安县|jiangxi-fuzhou-leanxian|jx-fz-lax'},{'idx':'14,10,8','code':'361026','name':'宜黄县','search':'江西-抚州-宜黄县|jiangxi-fuzhou-yihuangxian|jx-fz-yhx'},{'idx':'14,10,9','code':'361027','name':'金溪县','search':'江西-抚州-金溪县|jiangxi-fuzhou-jinxixian|jx-fz-jxx'},{'idx':'14,10,10','code':'361028','name':'资溪县','search':'江西-抚州-资溪县|jiangxi-fuzhou-zixixian|jx-fz-zxx'},{'idx':'14,10,11','code':'361029','name':'东乡县','search':'江西-抚州-东乡县|jiangxi-fuzhou-dongxiangxian|jx-fz-dxx'},{'idx':'14,10,12','code':'361030','name':'广昌县','search':'江西-抚州-广昌县|jiangxi-fuzhou-guangchangxian|jx-fz-gcx'}]},{'idx':'14,11','code':'361100','name':'上饶','search':'江西-上饶|jiangxi-shangraoshi|jx-srs','children':[{'idx':'14,11,0','code':'-1','name':'全市','search':'全市|quansheng|qs'},{'idx':'14,11,1','code':'361101','name':'市辖区','search':'江西-上饶-市辖区|jiangxi-shangrao-shixiaqu|jx-sr-sxq'},{'idx':'14,11,2','code':'361102','name':'信州区','search':'江西-上饶-信州区|jiangxi-shangrao-xinzhouqu|jx-sr-xzq'},{'idx':'14,11,3','code':'361103','name':'广丰区','search':'江西-上饶-广丰区|jiangxi-shangrao-guangfengqu|jx-sr-gfq'},{'idx':'14,11,4','code':'361121','name':'上饶县','search':'江西-上饶-上饶县|jiangxi-shangrao-shangraoxian|jx-sr-srx'},{'idx':'14,11,5','code':'361123','name':'玉山县','search':'江西-上饶-玉山县|jiangxi-shangrao-yushanxian|jx-sr-ysx'},{'idx':'14,11,6','code':'361124','name':'铅山县','search':'江西-上饶-铅山县|jiangxi-shangrao-qianshanxian|jx-sr-qsx'},{'idx':'14,11,7','code':'361125','name':'横峰县','search':'江西-上饶-横峰县|jiangxi-shangrao-hengfengxian|jx-sr-hfx'},{'idx':'14,11,8','code':'361126','name':'弋阳县','search':'江西-上饶-弋阳县|jiangxi-shangrao-yiyangxian|jx-sr-yyx'},{'idx':'14,11,9','code':'361127','name':'余干县','search':'江西-上饶-余干县|jiangxi-shangrao-yuganxian|jx-sr-ygx'},{'idx':'14,11,10','code':'361128','name':'鄱阳县','search':'江西-上饶-鄱阳县|jiangxi-shangrao-poyangxian|jx-sr-pyx'},{'idx':'14,11,11','code':'361129','name':'万年县','search':'江西-上饶-万年县|jiangxi-shangrao-wannianxian|jx-sr-wnx'},{'idx':'14,11,12','code':'361130','name':'婺源县','search':'江西-上饶-婺源县|jiangxi-shangrao-wuyuanxian|jx-sr-wyx'},{'idx':'14,11,13','code':'361181','name':'德兴市','search':'江西-上饶-德兴市|jiangxi-shangrao-dexingshi|jx-sr-dxs'}]}]},{'idx':15,'code':'370000','name':'山东','search':'山东|shandongsheng|sds','children':[{'idx':'15,0','code':'-1','name':'全省','search':'全省|quansheng|qs'},{'idx':'15,1','code':'370100','name':'济南','search':'山东-济南|shandong-jinanshi|sd-jns','children':[{'idx':'15,1,0','code':'-1','name':'全市','search':'全市|quansheng|qs'},{'idx':'15,1,1','code':'370101','name':'市辖区','search':'山东-济南-市辖区|shandong-jinan-shixiaqu|sd-jn-sxq'},{'idx':'15,1,2','code':'370102','name':'历下区','search':'山东-济南-历下区|shandong-jinan-lixiaqu|sd-jn-lxq'},{'idx':'15,1,3','code':'370103','name':'市中区','search':'山东-济南-市中区|shandong-jinan-shizhongqu|sd-jn-szq'},{'idx':'15,1,4','code':'370104','name':'槐荫区','search':'山东-济南-槐荫区|shandong-jinan-huaiyinqu|sd-jn-hyq'},{'idx':'15,1,5','code':'370105','name':'天桥区','search':'山东-济南-天桥区|shandong-jinan-tianqiaoqu|sd-jn-tqq'},{'idx':'15,1,6','code':'370112','name':'历城区','search':'山东-济南-历城区|shandong-jinan-lichengqu|sd-jn-lcq'},{'idx':'15,1,7','code':'370113','name':'长清区','search':'山东-济南-长清区|shandong-jinan-changqingqu|sd-jn-cqq'},{'idx':'15,1,8','code':'370124','name':'平阴县','search':'山东-济南-平阴县|shandong-jinan-pingyinxian|sd-jn-pyx'},{'idx':'15,1,9','code':'370125','name':'济阳县','search':'山东-济南-济阳县|shandong-jinan-jiyangxian|sd-jn-jyx'},{'idx':'15,1,10','code':'370126','name':'商河县','search':'山东-济南-商河县|shandong-jinan-shanghexian|sd-jn-shx'},{'idx':'15,1,11','code':'370181','name':'章丘市','search':'山东-济南-章丘市|shandong-jinan-zhangqiushi|sd-jn-zqs'}]},{'idx':'15,2','code':'370200','name':'青岛','search':'山东-青岛|shandong-qingdaoshi|sd-qds','children':[{'idx':'15,2,0','code':'-1','name':'全市','search':'全市|quansheng|qs'},{'idx':'15,2,1','code':'370201','name':'市辖区','search':'山东-青岛-市辖区|shandong-qingdao-shixiaqu|sd-qd-sxq'},{'idx':'15,2,2','code':'370202','name':'市南区','search':'山东-青岛-市南区|shandong-qingdao-shinanqu|sd-qd-snq'},{'idx':'15,2,3','code':'370203','name':'市北区','search':'山东-青岛-市北区|shandong-qingdao-shibeiqu|sd-qd-sbq'},{'idx':'15,2,4','code':'370211','name':'黄岛区','search':'山东-青岛-黄岛区|shandong-qingdao-huangdaoqu|sd-qd-hdq'},{'idx':'15,2,5','code':'370212','name':'崂山区','search':'山东-青岛-崂山区|shandong-qingdao-laoshanqu|sd-qd-lsq'},{'idx':'15,2,6','code':'370213','name':'李沧区','search':'山东-青岛-李沧区|shandong-qingdao-licangqu|sd-qd-lcq'},{'idx':'15,2,7','code':'370214','name':'城阳区','search':'山东-青岛-城阳区|shandong-qingdao-chengyangqu|sd-qd-cyq'},{'idx':'15,2,8','code':'370281','name':'胶州市','search':'山东-青岛-胶州市|shandong-qingdao-jiaozhoushi|sd-qd-jzs'},{'idx':'15,2,9','code':'370282','name':'即墨市','search':'山东-青岛-即墨市|shandong-qingdao-jimoshi|sd-qd-jms'},{'idx':'15,2,10','code':'370283','name':'平度市','search':'山东-青岛-平度市|shandong-qingdao-pingdushi|sd-qd-pds'},{'idx':'15,2,11','code':'370285','name':'莱西市','search':'山东-青岛-莱西市|shandong-qingdao-laixishi|sd-qd-lxs'}]},{'idx':'15,3','code':'370300','name':'淄博','search':'山东-淄博|shandong-ziboshi|sd-zbs','children':[{'idx':'15,3,0','code':'-1','name':'全市','search':'全市|quansheng|qs'},{'idx':'15,3,1','code':'370301','name':'市辖区','search':'山东-淄博-市辖区|shandong-zibo-shixiaqu|sd-zb-sxq'},{'idx':'15,3,2','code':'370302','name':'淄川区','search':'山东-淄博-淄川区|shandong-zibo-zichuanqu|sd-zb-zcq'},{'idx':'15,3,3','code':'370303','name':'张店区','search':'山东-淄博-张店区|shandong-zibo-zhangdianqu|sd-zb-zdq'},{'idx':'15,3,4','code':'370304','name':'博山区','search':'山东-淄博-博山区|shandong-zibo-boshanqu|sd-zb-bsq'},{'idx':'15,3,5','code':'370305','name':'临淄区','search':'山东-淄博-临淄区|shandong-zibo-linziqu|sd-zb-lzq'},{'idx':'15,3,6','code':'370306','name':'周村区','search':'山东-淄博-周村区|shandong-zibo-zhoucunqu|sd-zb-zcq'},{'idx':'15,3,7','code':'370321','name':'桓台县','search':'山东-淄博-桓台县|shandong-zibo-huantaixian|sd-zb-htx'},{'idx':'15,3,8','code':'370322','name':'高青县','search':'山东-淄博-高青县|shandong-zibo-gaoqingxian|sd-zb-gqx'},{'idx':'15,3,9','code':'370323','name':'沂源县','search':'山东-淄博-沂源县|shandong-zibo-yiyuanxian|sd-zb-yyx'}]},{'idx':'15,4','code':'370400','name':'枣庄','search':'山东-枣庄|shandong-zaozhuangshi|sd-zzs','children':[{'idx':'15,4,0','code':'-1','name':'全市','search':'全市|quansheng|qs'},{'idx':'15,4,1','code':'370401','name':'市辖区','search':'山东-枣庄-市辖区|shandong-zaozhuang-shixiaqu|sd-zz-sxq'},{'idx':'15,4,2','code':'370402','name':'市中区','search':'山东-枣庄-市中区|shandong-zaozhuang-shizhongqu|sd-zz-szq'},{'idx':'15,4,3','code':'370403','name':'薛城区','search':'山东-枣庄-薛城区|shandong-zaozhuang-xuechengqu|sd-zz-xcq'},{'idx':'15,4,4','code':'370404','name':'峄城区','search':'山东-枣庄-峄城区|shandong-zaozhuang-yichengqu|sd-zz-ycq'},{'idx':'15,4,5','code':'370405','name':'台儿庄区','search':'山东-枣庄-台儿庄区|shandong-zaozhuang-taierzhuangqu|sd-zz-tezq'},{'idx':'15,4,6','code':'370406','name':'山亭区','search':'山东-枣庄-山亭区|shandong-zaozhuang-shantingqu|sd-zz-stq'},{'idx':'15,4,7','code':'370481','name':'滕州市','search':'山东-枣庄-滕州市|shandong-zaozhuang-tengzhoushi|sd-zz-tzs'}]},{'idx':'15,5','code':'370500','name':'东营','search':'山东-东营|shandong-dongyingshi|sd-dys','children':[{'idx':'15,5,0','code':'-1','name':'全市','search':'全市|quansheng|qs'},{'idx':'15,5,1','code':'370501','name':'市辖区','search':'山东-东营-市辖区|shandong-dongying-shixiaqu|sd-dy-sxq'},{'idx':'15,5,2','code':'370502','name':'东营区','search':'山东-东营-东营区|shandong-dongying-dongyingqu|sd-dy-dyq'},{'idx':'15,5,3','code':'370503','name':'河口区','search':'山东-东营-河口区|shandong-dongying-hekouqu|sd-dy-hkq'},{'idx':'15,5,4','code':'370521','name':'垦利县','search':'山东-东营-垦利县|shandong-dongying-kenlixian|sd-dy-klx'},{'idx':'15,5,5','code':'370522','name':'利津县','search':'山东-东营-利津县|shandong-dongying-lijinxian|sd-dy-ljx'},{'idx':'15,5,6','code':'370523','name':'广饶县','search':'山东-东营-广饶县|shandong-dongying-guangraoxian|sd-dy-grx'}]},{'idx':'15,6','code':'370600','name':'烟台','search':'山东-烟台|shandong-yantaishi|sd-yts','children':[{'idx':'15,6,0','code':'-1','name':'全市','search':'全市|quansheng|qs'},{'idx':'15,6,1','code':'370601','name':'市辖区','search':'山东-烟台-市辖区|shandong-yantai-shixiaqu|sd-yt-sxq'},{'idx':'15,6,2','code':'370602','name':'芝罘区','search':'山东-烟台-芝罘区|shandong-yantai-zhifuqu|sd-yt-zfq'},{'idx':'15,6,3','code':'370611','name':'福山区','search':'山东-烟台-福山区|shandong-yantai-fushanqu|sd-yt-fsq'},{'idx':'15,6,4','code':'370612','name':'牟平区','search':'山东-烟台-牟平区|shandong-yantai-moupingqu|sd-yt-mpq'},{'idx':'15,6,5','code':'370613','name':'莱山区','search':'山东-烟台-莱山区|shandong-yantai-laishanqu|sd-yt-lsq'},{'idx':'15,6,6','code':'370634','name':'长岛县','search':'山东-烟台-长岛县|shandong-yantai-changdaoxian|sd-yt-cdx'},{'idx':'15,6,7','code':'370681','name':'龙口市','search':'山东-烟台-龙口市|shandong-yantai-longkoushi|sd-yt-lks'},{'idx':'15,6,8','code':'370682','name':'莱阳市','search':'山东-烟台-莱阳市|shandong-yantai-laiyangshi|sd-yt-lys'},{'idx':'15,6,9','code':'370683','name':'莱州市','search':'山东-烟台-莱州市|shandong-yantai-laizhoushi|sd-yt-lzs'},{'idx':'15,6,10','code':'370684','name':'蓬莱市','search':'山东-烟台-蓬莱市|shandong-yantai-penglaishi|sd-yt-pls'},{'idx':'15,6,11','code':'370685','name':'招远市','search':'山东-烟台-招远市|shandong-yantai-zhaoyuanshi|sd-yt-zys'},{'idx':'15,6,12','code':'370686','name':'栖霞市','search':'山东-烟台-栖霞市|shandong-yantai-qixiashi|sd-yt-qxs'},{'idx':'15,6,13','code':'370687','name':'海阳市','search':'山东-烟台-海阳市|shandong-yantai-haiyangshi|sd-yt-hys'}]},{'idx':'15,7','code':'370700','name':'潍坊','search':'山东-潍坊|shandong-weifangshi|sd-wfs','children':[{'idx':'15,7,0','code':'-1','name':'全市','search':'全市|quansheng|qs'},{'idx':'15,7,1','code':'370701','name':'市辖区','search':'山东-潍坊-市辖区|shandong-weifang-shixiaqu|sd-wf-sxq'},{'idx':'15,7,2','code':'370702','name':'潍城区','search':'山东-潍坊-潍城区|shandong-weifang-weichengqu|sd-wf-wcq'},{'idx':'15,7,3','code':'370703','name':'寒亭区','search':'山东-潍坊-寒亭区|shandong-weifang-hantingqu|sd-wf-htq'},{'idx':'15,7,4','code':'370704','name':'坊子区','search':'山东-潍坊-坊子区|shandong-weifang-fangziqu|sd-wf-fzq'},{'idx':'15,7,5','code':'370705','name':'奎文区','search':'山东-潍坊-奎文区|shandong-weifang-kuiwenqu|sd-wf-kwq'},{'idx':'15,7,6','code':'370724','name':'临朐县','search':'山东-潍坊-临朐县|shandong-weifang-linquxian|sd-wf-lqx'},{'idx':'15,7,7','code':'370725','name':'昌乐县','search':'山东-潍坊-昌乐县|shandong-weifang-changlexian|sd-wf-clx'},{'idx':'15,7,8','code':'370781','name':'青州市','search':'山东-潍坊-青州市|shandong-weifang-qingzhoushi|sd-wf-qzs'},{'idx':'15,7,9','code':'370782','name':'诸城市','search':'山东-潍坊-诸城市|shandong-weifang-zhuchengshi|sd-wf-zcs'},{'idx':'15,7,10','code':'370783','name':'寿光市','search':'山东-潍坊-寿光市|shandong-weifang-shouguangshi|sd-wf-sgs'},{'idx':'15,7,11','code':'370784','name':'安丘市','search':'山东-潍坊-安丘市|shandong-weifang-anqiushi|sd-wf-aqs'},{'idx':'15,7,12','code':'370785','name':'高密市','search':'山东-潍坊-高密市|shandong-weifang-gaomishi|sd-wf-gms'},{'idx':'15,7,13','code':'370786','name':'昌邑市','search':'山东-潍坊-昌邑市|shandong-weifang-changyishi|sd-wf-cys'}]},{'idx':'15,8','code':'370800','name':'济宁','search':'山东-济宁|shandong-jiningshi|sd-jns','children':[{'idx':'15,8,0','code':'-1','name':'全市','search':'全市|quansheng|qs'},{'idx':'15,8,1','code':'370801','name':'市辖区','search':'山东-济宁-市辖区|shandong-jining-shixiaqu|sd-jn-sxq'},{'idx':'15,8,2','code':'370811','name':'任城区','search':'山东-济宁-任城区|shandong-jining-renchengqu|sd-jn-rcq'},{'idx':'15,8,3','code':'370812','name':'兖州区','search':'山东-济宁-兖州区|shandong-jining-yanzhouqu|sd-jn-yzq'},{'idx':'15,8,4','code':'370826','name':'微山县','search':'山东-济宁-微山县|shandong-jining-weishanxian|sd-jn-wsx'},{'idx':'15,8,5','code':'370827','name':'鱼台县','search':'山东-济宁-鱼台县|shandong-jining-yutaixian|sd-jn-ytx'},{'idx':'15,8,6','code':'370828','name':'金乡县','search':'山东-济宁-金乡县|shandong-jining-jinxiangxian|sd-jn-jxx'},{'idx':'15,8,7','code':'370829','name':'嘉祥县','search':'山东-济宁-嘉祥县|shandong-jining-jiaxiangxian|sd-jn-jxx'},{'idx':'15,8,8','code':'370830','name':'汶上县','search':'山东-济宁-汶上县|shandong-jining-wenshangxian|sd-jn-wsx'},{'idx':'15,8,9','code':'370831','name':'泗水县','search':'山东-济宁-泗水县|shandong-jining-sishuixian|sd-jn-ssx'},{'idx':'15,8,10','code':'370832','name':'梁山县','search':'山东-济宁-梁山县|shandong-jining-liangshanxian|sd-jn-lsx'},{'idx':'15,8,11','code':'370881','name':'曲阜市','search':'山东-济宁-曲阜市|shandong-jining-qufushi|sd-jn-qfs'},{'idx':'15,8,12','code':'370883','name':'邹城市','search':'山东-济宁-邹城市|shandong-jining-zouchengshi|sd-jn-zcs'}]},{'idx':'15,9','code':'370900','name':'泰安','search':'山东-泰安|shandong-taianshi|sd-tas','children':[{'idx':'15,9,0','code':'-1','name':'全市','search':'全市|quansheng|qs'},{'idx':'15,9,1','code':'370901','name':'市辖区','search':'山东-泰安-市辖区|shandong-taian-shixiaqu|sd-ta-sxq'},{'idx':'15,9,2','code':'370902','name':'泰山区','search':'山东-泰安-泰山区|shandong-taian-taishanqu|sd-ta-tsq'},{'idx':'15,9,3','code':'370911','name':'岱岳区','search':'山东-泰安-岱岳区|shandong-taian-daiyuequ|sd-ta-dyq'},{'idx':'15,9,4','code':'370921','name':'宁阳县','search':'山东-泰安-宁阳县|shandong-taian-ningyangxian|sd-ta-nyx'},{'idx':'15,9,5','code':'370923','name':'东平县','search':'山东-泰安-东平县|shandong-taian-dongpingxian|sd-ta-dpx'},{'idx':'15,9,6','code':'370982','name':'新泰市','search':'山东-泰安-新泰市|shandong-taian-xintaishi|sd-ta-xts'},{'idx':'15,9,7','code':'370983','name':'肥城市','search':'山东-泰安-肥城市|shandong-taian-feichengshi|sd-ta-fcs'}]},{'idx':'15,10','code':'371000','name':'威海','search':'山东-威海|shandong-weihaishi|sd-whs','children':[{'idx':'15,10,0','code':'-1','name':'全市','search':'全市|quansheng|qs'},{'idx':'15,10,1','code':'371001','name':'市辖区','search':'山东-威海-市辖区|shandong-weihai-shixiaqu|sd-wh-sxq'},{'idx':'15,10,2','code':'371002','name':'环翠区','search':'山东-威海-环翠区|shandong-weihai-huancuiqu|sd-wh-hcq'},{'idx':'15,10,3','code':'371003','name':'文登区','search':'山东-威海-文登区|shandong-weihai-wendengqu|sd-wh-wdq'},{'idx':'15,10,4','code':'371082','name':'荣成市','search':'山东-威海-荣成市|shandong-weihai-rongchengshi|sd-wh-rcs'},{'idx':'15,10,5','code':'371083','name':'乳山市','search':'山东-威海-乳山市|shandong-weihai-rushanshi|sd-wh-rss'}]},{'idx':'15,11','code':'371100','name':'日照','search':'山东-日照|shandong-rizhaoshi|sd-rzs','children':[{'idx':'15,11,0','code':'-1','name':'全市','search':'全市|quansheng|qs'},{'idx':'15,11,1','code':'371101','name':'市辖区','search':'山东-日照-市辖区|shandong-rizhao-shixiaqu|sd-rz-sxq'},{'idx':'15,11,2','code':'371102','name':'东港区','search':'山东-日照-东港区|shandong-rizhao-donggangqu|sd-rz-dgq'},{'idx':'15,11,3','code':'371103','name':'岚山区','search':'山东-日照-岚山区|shandong-rizhao-lanshanqu|sd-rz-lsq'},{'idx':'15,11,4','code':'371121','name':'五莲县','search':'山东-日照-五莲县|shandong-rizhao-wulianxian|sd-rz-wlx'},{'idx':'15,11,5','code':'371122','name':'莒县','search':'山东-日照-莒县|shandong-rizhao-juxian|sd-rz-jx'}]},{'idx':'15,12','code':'371200','name':'莱芜','search':'山东-莱芜|shandong-laiwushi|sd-lws','children':[{'idx':'15,12,0','code':'-1','name':'全市','search':'全市|quansheng|qs'},{'idx':'15,12,1','code':'371201','name':'市辖区','search':'山东-莱芜-市辖区|shandong-laiwu-shixiaqu|sd-lw-sxq'},{'idx':'15,12,2','code':'371202','name':'莱城区','search':'山东-莱芜-莱城区|shandong-laiwu-laichengqu|sd-lw-lcq'},{'idx':'15,12,3','code':'371203','name':'钢城区','search':'山东-莱芜-钢城区|shandong-laiwu-gangchengqu|sd-lw-gcq'}]},{'idx':'15,13','code':'371300','name':'临沂','search':'山东-临沂|shandong-linyishi|sd-lys','children':[{'idx':'15,13,0','code':'-1','name':'全市','search':'全市|quansheng|qs'},{'idx':'15,13,1','code':'371301','name':'市辖区','search':'山东-临沂-市辖区|shandong-linyi-shixiaqu|sd-ly-sxq'},{'idx':'15,13,2','code':'371302','name':'兰山区','search':'山东-临沂-兰山区|shandong-linyi-lanshanqu|sd-ly-lsq'},{'idx':'15,13,3','code':'371311','name':'罗庄区','search':'山东-临沂-罗庄区|shandong-linyi-luozhuangqu|sd-ly-lzq'},{'idx':'15,13,4','code':'371312','name':'河东区','search':'山东-临沂-河东区|shandong-linyi-hedongqu|sd-ly-hdq'},{'idx':'15,13,5','code':'371321','name':'沂南县','search':'山东-临沂-沂南县|shandong-linyi-yinanxian|sd-ly-ynx'},{'idx':'15,13,6','code':'371322','name':'郯城县','search':'山东-临沂-郯城县|shandong-linyi-tanchengxian|sd-ly-tcx'},{'idx':'15,13,7','code':'371323','name':'沂水县','search':'山东-临沂-沂水县|shandong-linyi-yishuixian|sd-ly-ysx'},{'idx':'15,13,8','code':'371324','name':'兰陵县','search':'山东-临沂-兰陵县|shandong-linyi-lanlingxian|sd-ly-llx'},{'idx':'15,13,9','code':'371325','name':'费县','search':'山东-临沂-费县|shandong-linyi-feixian|sd-ly-fx'},{'idx':'15,13,10','code':'371326','name':'平邑县','search':'山东-临沂-平邑县|shandong-linyi-pingyixian|sd-ly-pyx'},{'idx':'15,13,11','code':'371327','name':'莒南县','search':'山东-临沂-莒南县|shandong-linyi-junanxian|sd-ly-jnx'},{'idx':'15,13,12','code':'371328','name':'蒙阴县','search':'山东-临沂-蒙阴县|shandong-linyi-mengyinxian|sd-ly-myx'},{'idx':'15,13,13','code':'371329','name':'临沭县','search':'山东-临沂-临沭县|shandong-linyi-linshuxian|sd-ly-lsx'}]},{'idx':'15,14','code':'371400','name':'德州','search':'山东-德州|shandong-dezhoushi|sd-dzs','children':[{'idx':'15,14,0','code':'-1','name':'全市','search':'全市|quansheng|qs'},{'idx':'15,14,1','code':'371401','name':'市辖区','search':'山东-德州-市辖区|shandong-dezhou-shixiaqu|sd-dz-sxq'},{'idx':'15,14,2','code':'371402','name':'德城区','search':'山东-德州-德城区|shandong-dezhou-dechengqu|sd-dz-dcq'},{'idx':'15,14,3','code':'371403','name':'陵城区','search':'山东-德州-陵城区|shandong-dezhou-lingchengqu|sd-dz-lcq'},{'idx':'15,14,4','code':'371422','name':'宁津县','search':'山东-德州-宁津县|shandong-dezhou-ningjinxian|sd-dz-njx'},{'idx':'15,14,5','code':'371423','name':'庆云县','search':'山东-德州-庆云县|shandong-dezhou-qingyunxian|sd-dz-qyx'},{'idx':'15,14,6','code':'371424','name':'临邑县','search':'山东-德州-临邑县|shandong-dezhou-linyixian|sd-dz-lyx'},{'idx':'15,14,7','code':'371425','name':'齐河县','search':'山东-德州-齐河县|shandong-dezhou-qihexian|sd-dz-qhx'},{'idx':'15,14,8','code':'371426','name':'平原县','search':'山东-德州-平原县|shandong-dezhou-pingyuanxian|sd-dz-pyx'},{'idx':'15,14,9','code':'371427','name':'夏津县','search':'山东-德州-夏津县|shandong-dezhou-xiajinxian|sd-dz-xjx'},{'idx':'15,14,10','code':'371428','name':'武城县','search':'山东-德州-武城县|shandong-dezhou-wuchengxian|sd-dz-wcx'},{'idx':'15,14,11','code':'371481','name':'乐陵市','search':'山东-德州-乐陵市|shandong-dezhou-lelingshi|sd-dz-lls'},{'idx':'15,14,12','code':'371482','name':'禹城市','search':'山东-德州-禹城市|shandong-dezhou-yuchengshi|sd-dz-ycs'}]},{'idx':'15,15','code':'371500','name':'聊城','search':'山东-聊城|shandong-liaochengshi|sd-lcs','children':[{'idx':'15,15,0','code':'-1','name':'全市','search':'全市|quansheng|qs'},{'idx':'15,15,1','code':'371501','name':'市辖区','search':'山东-聊城-市辖区|shandong-liaocheng-shixiaqu|sd-lc-sxq'},{'idx':'15,15,2','code':'371502','name':'东昌府区','search':'山东-聊城-东昌府区|shandong-liaocheng-dongchangfuqu|sd-lc-dcfq'},{'idx':'15,15,3','code':'371521','name':'阳谷县','search':'山东-聊城-阳谷县|shandong-liaocheng-yangguxian|sd-lc-ygx'},{'idx':'15,15,4','code':'371522','name':'莘县','search':'山东-聊城-莘县|shandong-liaocheng-shenxian|sd-lc-sx'},{'idx':'15,15,5','code':'371523','name':'茌平县','search':'山东-聊城-茌平县|shandong-liaocheng-chipingxian|sd-lc-cpx'},{'idx':'15,15,6','code':'371524','name':'东阿县','search':'山东-聊城-东阿县|shandong-liaocheng-dongaxian|sd-lc-dax'},{'idx':'15,15,7','code':'371525','name':'冠县','search':'山东-聊城-冠县|shandong-liaocheng-guanxian|sd-lc-gx'},{'idx':'15,15,8','code':'371526','name':'高唐县','search':'山东-聊城-高唐县|shandong-liaocheng-gaotangxian|sd-lc-gtx'},{'idx':'15,15,9','code':'371581','name':'临清市','search':'山东-聊城-临清市|shandong-liaocheng-linqingshi|sd-lc-lqs'}]},{'idx':'15,16','code':'371600','name':'滨州','search':'山东-滨州|shandong-binzhoushi|sd-bzs','children':[{'idx':'15,16,0','code':'-1','name':'全市','search':'全市|quansheng|qs'},{'idx':'15,16,1','code':'371601','name':'市辖区','search':'山东-滨州-市辖区|shandong-binzhou-shixiaqu|sd-bz-sxq'},{'idx':'15,16,2','code':'371602','name':'滨城区','search':'山东-滨州-滨城区|shandong-binzhou-binchengqu|sd-bz-bcq'},{'idx':'15,16,3','code':'371603','name':'沾化区','search':'山东-滨州-沾化区|shandong-binzhou-zhanhuaqu|sd-bz-zhq'},{'idx':'15,16,4','code':'371621','name':'惠民县','search':'山东-滨州-惠民县|shandong-binzhou-huiminxian|sd-bz-hmx'},{'idx':'15,16,5','code':'371622','name':'阳信县','search':'山东-滨州-阳信县|shandong-binzhou-yangxinxian|sd-bz-yxx'},{'idx':'15,16,6','code':'371623','name':'无棣县','search':'山东-滨州-无棣县|shandong-binzhou-wudixian|sd-bz-wdx'},{'idx':'15,16,7','code':'371625','name':'博兴县','search':'山东-滨州-博兴县|shandong-binzhou-boxingxian|sd-bz-bxx'},{'idx':'15,16,8','code':'371626','name':'邹平县','search':'山东-滨州-邹平县|shandong-binzhou-zoupingxian|sd-bz-zpx'}]},{'idx':'15,17','code':'371700','name':'菏泽','search':'山东-菏泽|shandong-hezeshi|sd-hzs','children':[{'idx':'15,17,0','code':'-1','name':'全市','search':'全市|quansheng|qs'},{'idx':'15,17,1','code':'371701','name':'市辖区','search':'山东-菏泽-市辖区|shandong-heze-shixiaqu|sd-hz-sxq'},{'idx':'15,17,2','code':'371702','name':'牡丹区','search':'山东-菏泽-牡丹区|shandong-heze-mudanqu|sd-hz-mdq'},{'idx':'15,17,3','code':'371721','name':'曹县','search':'山东-菏泽-曹县|shandong-heze-caoxian|sd-hz-cx'},{'idx':'15,17,4','code':'371722','name':'单县','search':'山东-菏泽-单县|shandong-heze-danxian|sd-hz-dx'},{'idx':'15,17,5','code':'371723','name':'成武县','search':'山东-菏泽-成武县|shandong-heze-chengwuxian|sd-hz-cwx'},{'idx':'15,17,6','code':'371724','name':'巨野县','search':'山东-菏泽-巨野县|shandong-heze-juyexian|sd-hz-jyx'},{'idx':'15,17,7','code':'371725','name':'郓城县','search':'山东-菏泽-郓城县|shandong-heze-yunchengxian|sd-hz-ycx'},{'idx':'15,17,8','code':'371726','name':'鄄城县','search':'山东-菏泽-鄄城县|shandong-heze-juanchengxian|sd-hz-jcx'},{'idx':'15,17,9','code':'371727','name':'定陶县','search':'山东-菏泽-定陶县|shandong-heze-dingtaoxian|sd-hz-dtx'},{'idx':'15,17,10','code':'371728','name':'东明县','search':'山东-菏泽-东明县|shandong-heze-dongmingxian|sd-hz-dmx'}]}]},{'idx':16,'code':'410000','name':'河南','search':'河南|henansheng|hns','children':[{'idx':'16,0','code':'-1','name':'全省','search':'全省|quansheng|qs'},{'idx':'16,1','code':'410100','name':'郑州','search':'河南-郑州|henan-zhengzhoushi|hn-zzs','children':[{'idx':'16,1,0','code':'-1','name':'全市','search':'全市|quansheng|qs'},{'idx':'16,1,1','code':'410101','name':'市辖区','search':'河南-郑州-市辖区|henan-zhengzhou-shixiaqu|hn-zz-sxq'},{'idx':'16,1,2','code':'410102','name':'中原区','search':'河南-郑州-中原区|henan-zhengzhou-zhongyuanqu|hn-zz-zyq'},{'idx':'16,1,3','code':'410103','name':'二七区','search':'河南-郑州-二七区|henan-zhengzhou-erqiqu|hn-zz-eqq'},{'idx':'16,1,4','code':'410104','name':'管城回族区','search':'河南-郑州-管城回族区|henan-zhengzhou-guanchenghuizuqu|hn-zz-gchzq'},{'idx':'16,1,5','code':'410105','name':'金水区','search':'河南-郑州-金水区|henan-zhengzhou-jinshuiqu|hn-zz-jsq'},{'idx':'16,1,6','code':'410106','name':'上街区','search':'河南-郑州-上街区|henan-zhengzhou-shangjiequ|hn-zz-sjq'},{'idx':'16,1,7','code':'410108','name':'惠济区','search':'河南-郑州-惠济区|henan-zhengzhou-huijiqu|hn-zz-hjq'},{'idx':'16,1,8','code':'410122','name':'中牟县','search':'河南-郑州-中牟县|henan-zhengzhou-zhongmouxian|hn-zz-zmx'},{'idx':'16,1,9','code':'410181','name':'巩义市','search':'河南-郑州-巩义市|henan-zhengzhou-gongyishi|hn-zz-gys'},{'idx':'16,1,10','code':'410182','name':'荥阳市','search':'河南-郑州-荥阳市|henan-zhengzhou-yingyangshi|hn-zz-yys'},{'idx':'16,1,11','code':'410183','name':'新密市','search':'河南-郑州-新密市|henan-zhengzhou-xinmishi|hn-zz-xms'},{'idx':'16,1,12','code':'410184','name':'新郑市','search':'河南-郑州-新郑市|henan-zhengzhou-xinzhengshi|hn-zz-xzs'},{'idx':'16,1,13','code':'410185','name':'登封市','search':'河南-郑州-登封市|henan-zhengzhou-dengfengshi|hn-zz-dfs'}]},{'idx':'16,2','code':'410200','name':'开封','search':'河南-开封|henan-kaifengshi|hn-kfs','children':[{'idx':'16,2,0','code':'-1','name':'全市','search':'全市|quansheng|qs'},{'idx':'16,2,1','code':'410201','name':'市辖区','search':'河南-开封-市辖区|henan-kaifeng-shixiaqu|hn-kf-sxq'},{'idx':'16,2,2','code':'410202','name':'龙亭区','search':'河南-开封-龙亭区|henan-kaifeng-longtingqu|hn-kf-ltq'},{'idx':'16,2,3','code':'410203','name':'顺河回族区','search':'河南-开封-顺河回族区|henan-kaifeng-shunhehuizuqu|hn-kf-shhzq'},{'idx':'16,2,4','code':'410204','name':'鼓楼区','search':'河南-开封-鼓楼区|henan-kaifeng-gulouqu|hn-kf-glq'},{'idx':'16,2,5','code':'410205','name':'禹王台区','search':'河南-开封-禹王台区|henan-kaifeng-yuwangtaiqu|hn-kf-ywtq'},{'idx':'16,2,6','code':'410211','name':'金明区','search':'河南-开封-金明区|henan-kaifeng-jinmingqu|hn-kf-jmq'},{'idx':'16,2,7','code':'410212','name':'祥符区','search':'河南-开封-祥符区|henan-kaifeng-xiangfuqu|hn-kf-xfq'},{'idx':'16,2,8','code':'410221','name':'杞县','search':'河南-开封-杞县|henan-kaifeng-qixian|hn-kf-qx'},{'idx':'16,2,9','code':'410222','name':'通许县','search':'河南-开封-通许县|henan-kaifeng-tongxuxian|hn-kf-txx'},{'idx':'16,2,10','code':'410223','name':'尉氏县','search':'河南-开封-尉氏县|henan-kaifeng-weishixian|hn-kf-wsx'},{'idx':'16,2,11','code':'410225','name':'兰考县','search':'河南-开封-兰考县|henan-kaifeng-lankaoxian|hn-kf-lkx'}]},{'idx':'16,3','code':'410300','name':'洛阳','search':'河南-洛阳|henan-luoyangshi|hn-lys','children':[{'idx':'16,3,0','code':'-1','name':'全市','search':'全市|quansheng|qs'},{'idx':'16,3,1','code':'410301','name':'市辖区','search':'河南-洛阳-市辖区|henan-luoyang-shixiaqu|hn-ly-sxq'},{'idx':'16,3,2','code':'410302','name':'老城区','search':'河南-洛阳-老城区|henan-luoyang-laochengqu|hn-ly-lcq'},{'idx':'16,3,3','code':'410303','name':'西工区','search':'河南-洛阳-西工区|henan-luoyang-xigongqu|hn-ly-xgq'},{'idx':'16,3,4','code':'410304','name':'瀍河回族区','search':'河南-洛阳-瀍河回族区|henan-luoyang-瀍hehuizuqu|hn-ly-瀍hhzq'},{'idx':'16,3,5','code':'410305','name':'涧西区','search':'河南-洛阳-涧西区|henan-luoyang-jianxiqu|hn-ly-jxq'},{'idx':'16,3,6','code':'410306','name':'吉利区','search':'河南-洛阳-吉利区|henan-luoyang-jiliqu|hn-ly-jlq'},{'idx':'16,3,7','code':'410311','name':'洛龙区','search':'河南-洛阳-洛龙区|henan-luoyang-luolongqu|hn-ly-llq'},{'idx':'16,3,8','code':'410322','name':'孟津县','search':'河南-洛阳-孟津县|henan-luoyang-mengjinxian|hn-ly-mjx'},{'idx':'16,3,9','code':'410323','name':'新安县','search':'河南-洛阳-新安县|henan-luoyang-xinanxian|hn-ly-xax'},{'idx':'16,3,10','code':'410324','name':'栾川县','search':'河南-洛阳-栾川县|henan-luoyang-luanchuanxian|hn-ly-lcx'},{'idx':'16,3,11','code':'410325','name':'嵩县','search':'河南-洛阳-嵩县|henan-luoyang-songxian|hn-ly-sx'},{'idx':'16,3,12','code':'410326','name':'汝阳县','search':'河南-洛阳-汝阳县|henan-luoyang-ruyangxian|hn-ly-ryx'},{'idx':'16,3,13','code':'410327','name':'宜阳县','search':'河南-洛阳-宜阳县|henan-luoyang-yiyangxian|hn-ly-yyx'},{'idx':'16,3,14','code':'410328','name':'洛宁县','search':'河南-洛阳-洛宁县|henan-luoyang-luoningxian|hn-ly-lnx'},{'idx':'16,3,15','code':'410329','name':'伊川县','search':'河南-洛阳-伊川县|henan-luoyang-yichuanxian|hn-ly-ycx'},{'idx':'16,3,16','code':'410381','name':'偃师市','search':'河南-洛阳-偃师市|henan-luoyang-yanshishi|hn-ly-yss'}]},{'idx':'16,4','code':'410400','name':'平顶山','search':'河南-平顶山|henan-pingdingshanshi|hn-pdss','children':[{'idx':'16,4,0','code':'-1','name':'全市','search':'全市|quansheng|qs'},{'idx':'16,4,1','code':'410401','name':'市辖区','search':'河南-平顶山-市辖区|henan-pingdingshan-shixiaqu|hn-pds-sxq'},{'idx':'16,4,2','code':'410402','name':'新华区','search':'河南-平顶山-新华区|henan-pingdingshan-xinhuaqu|hn-pds-xhq'},{'idx':'16,4,3','code':'410403','name':'卫东区','search':'河南-平顶山-卫东区|henan-pingdingshan-weidongqu|hn-pds-wdq'},{'idx':'16,4,4','code':'410404','name':'石龙区','search':'河南-平顶山-石龙区|henan-pingdingshan-shilongqu|hn-pds-slq'},{'idx':'16,4,5','code':'410411','name':'湛河区','search':'河南-平顶山-湛河区|henan-pingdingshan-zhanhequ|hn-pds-zhq'},{'idx':'16,4,6','code':'410421','name':'宝丰县','search':'河南-平顶山-宝丰县|henan-pingdingshan-baofengxian|hn-pds-bfx'},{'idx':'16,4,7','code':'410422','name':'叶县','search':'河南-平顶山-叶县|henan-pingdingshan-yexian|hn-pds-yx'},{'idx':'16,4,8','code':'410423','name':'鲁山县','search':'河南-平顶山-鲁山县|henan-pingdingshan-lushanxian|hn-pds-lsx'},{'idx':'16,4,9','code':'410425','name':'郏县','search':'河南-平顶山-郏县|henan-pingdingshan-jiaxian|hn-pds-jx'},{'idx':'16,4,10','code':'410481','name':'舞钢市','search':'河南-平顶山-舞钢市|henan-pingdingshan-wugangshi|hn-pds-wgs'},{'idx':'16,4,11','code':'410482','name':'汝州市','search':'河南-平顶山-汝州市|henan-pingdingshan-ruzhoushi|hn-pds-rzs'}]},{'idx':'16,5','code':'410500','name':'安阳','search':'河南-安阳|henan-anyangshi|hn-ays','children':[{'idx':'16,5,0','code':'-1','name':'全市','search':'全市|quansheng|qs'},{'idx':'16,5,1','code':'410501','name':'市辖区','search':'河南-安阳-市辖区|henan-anyang-shixiaqu|hn-ay-sxq'},{'idx':'16,5,2','code':'410502','name':'文峰区','search':'河南-安阳-文峰区|henan-anyang-wenfengqu|hn-ay-wfq'},{'idx':'16,5,3','code':'410503','name':'北关区','search':'河南-安阳-北关区|henan-anyang-beiguanqu|hn-ay-bgq'},{'idx':'16,5,4','code':'410505','name':'殷都区','search':'河南-安阳-殷都区|henan-anyang-yinduqu|hn-ay-ydq'},{'idx':'16,5,5','code':'410506','name':'龙安区','search':'河南-安阳-龙安区|henan-anyang-longanqu|hn-ay-laq'},{'idx':'16,5,6','code':'410522','name':'安阳县','search':'河南-安阳-安阳县|henan-anyang-anyangxian|hn-ay-ayx'},{'idx':'16,5,7','code':'410523','name':'汤阴县','search':'河南-安阳-汤阴县|henan-anyang-tangyinxian|hn-ay-tyx'},{'idx':'16,5,8','code':'410526','name':'滑县','search':'河南-安阳-滑县|henan-anyang-huaxian|hn-ay-hx'},{'idx':'16,5,9','code':'410527','name':'内黄县','search':'河南-安阳-内黄县|henan-anyang-neihuangxian|hn-ay-nhx'},{'idx':'16,5,10','code':'410581','name':'林州市','search':'河南-安阳-林州市|henan-anyang-linzhoushi|hn-ay-lzs'}]},{'idx':'16,6','code':'410600','name':'鹤壁','search':'河南-鹤壁|henan-hebishi|hn-hbs','children':[{'idx':'16,6,0','code':'-1','name':'全市','search':'全市|quansheng|qs'},{'idx':'16,6,1','code':'410601','name':'市辖区','search':'河南-鹤壁-市辖区|henan-hebi-shixiaqu|hn-hb-sxq'},{'idx':'16,6,2','code':'410602','name':'鹤山区','search':'河南-鹤壁-鹤山区|henan-hebi-heshanqu|hn-hb-hsq'},{'idx':'16,6,3','code':'410603','name':'山城区','search':'河南-鹤壁-山城区|henan-hebi-shanchengqu|hn-hb-scq'},{'idx':'16,6,4','code':'410611','name':'淇滨区','search':'河南-鹤壁-淇滨区|henan-hebi-qibinqu|hn-hb-qbq'},{'idx':'16,6,5','code':'410621','name':'浚县','search':'河南-鹤壁-浚县|henan-hebi-junxian|hn-hb-jx'},{'idx':'16,6,6','code':'410622','name':'淇县','search':'河南-鹤壁-淇县|henan-hebi-qixian|hn-hb-qx'}]},{'idx':'16,7','code':'410700','name':'新乡','search':'河南-新乡|henan-xinxiangshi|hn-xxs','children':[{'idx':'16,7,0','code':'-1','name':'全市','search':'全市|quansheng|qs'},{'idx':'16,7,1','code':'410701','name':'市辖区','search':'河南-新乡-市辖区|henan-xinxiang-shixiaqu|hn-xx-sxq'},{'idx':'16,7,2','code':'410702','name':'红旗区','search':'河南-新乡-红旗区|henan-xinxiang-hongqiqu|hn-xx-hqq'},{'idx':'16,7,3','code':'410703','name':'卫滨区','search':'河南-新乡-卫滨区|henan-xinxiang-weibinqu|hn-xx-wbq'},{'idx':'16,7,4','code':'410704','name':'凤泉区','search':'河南-新乡-凤泉区|henan-xinxiang-fengquanqu|hn-xx-fqq'},{'idx':'16,7,5','code':'410711','name':'牧野区','search':'河南-新乡-牧野区|henan-xinxiang-muyequ|hn-xx-myq'},{'idx':'16,7,6','code':'410721','name':'新乡县','search':'河南-新乡-新乡县|henan-xinxiang-xinxiangxian|hn-xx-xxx'},{'idx':'16,7,7','code':'410724','name':'获嘉县','search':'河南-新乡-获嘉县|henan-xinxiang-huojiaxian|hn-xx-hjx'},{'idx':'16,7,8','code':'410725','name':'原阳县','search':'河南-新乡-原阳县|henan-xinxiang-yuanyangxian|hn-xx-yyx'},{'idx':'16,7,9','code':'410726','name':'延津县','search':'河南-新乡-延津县|henan-xinxiang-yanjinxian|hn-xx-yjx'},{'idx':'16,7,10','code':'410727','name':'封丘县','search':'河南-新乡-封丘县|henan-xinxiang-fengqiuxian|hn-xx-fqx'},{'idx':'16,7,11','code':'410728','name':'长垣县','search':'河南-新乡-长垣县|henan-xinxiang-changyuanxian|hn-xx-cyx'},{'idx':'16,7,12','code':'410781','name':'卫辉市','search':'河南-新乡-卫辉市|henan-xinxiang-weihuishi|hn-xx-whs'},{'idx':'16,7,13','code':'410782','name':'辉县市','search':'河南-新乡-辉县市|henan-xinxiang-huixianshi|hn-xx-hxs'}]},{'idx':'16,8','code':'410800','name':'焦作','search':'河南-焦作|henan-jiaozuoshi|hn-jzs','children':[{'idx':'16,8,0','code':'-1','name':'全市','search':'全市|quansheng|qs'},{'idx':'16,8,1','code':'410801','name':'市辖区','search':'河南-焦作-市辖区|henan-jiaozuo-shixiaqu|hn-jz-sxq'},{'idx':'16,8,2','code':'410802','name':'解放区','search':'河南-焦作-解放区|henan-jiaozuo-jiefangqu|hn-jz-jfq'},{'idx':'16,8,3','code':'410803','name':'中站区','search':'河南-焦作-中站区|henan-jiaozuo-zhongzhanqu|hn-jz-zzq'},{'idx':'16,8,4','code':'410804','name':'马村区','search':'河南-焦作-马村区|henan-jiaozuo-macunqu|hn-jz-mcq'},{'idx':'16,8,5','code':'410811','name':'山阳区','search':'河南-焦作-山阳区|henan-jiaozuo-shanyangqu|hn-jz-syq'},{'idx':'16,8,6','code':'410821','name':'修武县','search':'河南-焦作-修武县|henan-jiaozuo-xiuwuxian|hn-jz-xwx'},{'idx':'16,8,7','code':'410822','name':'博爱县','search':'河南-焦作-博爱县|henan-jiaozuo-boaixian|hn-jz-bax'},{'idx':'16,8,8','code':'410823','name':'武陟县','search':'河南-焦作-武陟县|henan-jiaozuo-wuzhixian|hn-jz-wzx'},{'idx':'16,8,9','code':'410825','name':'温县','search':'河南-焦作-温县|henan-jiaozuo-wenxian|hn-jz-wx'},{'idx':'16,8,10','code':'410882','name':'沁阳市','search':'河南-焦作-沁阳市|henan-jiaozuo-qinyangshi|hn-jz-qys'},{'idx':'16,8,11','code':'410883','name':'孟州市','search':'河南-焦作-孟州市|henan-jiaozuo-mengzhoushi|hn-jz-mzs'}]},{'idx':'16,9','code':'410900','name':'濮阳','search':'河南-濮阳|henan-puyangshi|hn-pys','children':[{'idx':'16,9,0','code':'-1','name':'全市','search':'全市|quansheng|qs'},{'idx':'16,9,1','code':'410901','name':'市辖区','search':'河南-濮阳-市辖区|henan-puyang-shixiaqu|hn-py-sxq'},{'idx':'16,9,2','code':'410902','name':'华龙区','search':'河南-濮阳-华龙区|henan-puyang-hualongqu|hn-py-hlq'},{'idx':'16,9,3','code':'410922','name':'清丰县','search':'河南-濮阳-清丰县|henan-puyang-qingfengxian|hn-py-qfx'},{'idx':'16,9,4','code':'410923','name':'南乐县','search':'河南-濮阳-南乐县|henan-puyang-nanlexian|hn-py-nlx'},{'idx':'16,9,5','code':'410926','name':'范县','search':'河南-濮阳-范县|henan-puyang-fanxian|hn-py-fx'},{'idx':'16,9,6','code':'410927','name':'台前县','search':'河南-濮阳-台前县|henan-puyang-taiqianxian|hn-py-tqx'},{'idx':'16,9,7','code':'410928','name':'濮阳县','search':'河南-濮阳-濮阳县|henan-puyang-puyangxian|hn-py-pyx'}]},{'idx':'16,10','code':'411000','name':'许昌','search':'河南-许昌|henan-xuchangshi|hn-xcs','children':[{'idx':'16,10,0','code':'-1','name':'全市','search':'全市|quansheng|qs'},{'idx':'16,10,1','code':'411001','name':'市辖区','search':'河南-许昌-市辖区|henan-xuchang-shixiaqu|hn-xc-sxq'},{'idx':'16,10,2','code':'411002','name':'魏都区','search':'河南-许昌-魏都区|henan-xuchang-weiduqu|hn-xc-wdq'},{'idx':'16,10,3','code':'411023','name':'许昌县','search':'河南-许昌-许昌县|henan-xuchang-xuchangxian|hn-xc-xcx'},{'idx':'16,10,4','code':'411024','name':'鄢陵县','search':'河南-许昌-鄢陵县|henan-xuchang-yanlingxian|hn-xc-ylx'},{'idx':'16,10,5','code':'411025','name':'襄城县','search':'河南-许昌-襄城县|henan-xuchang-xiangchengxian|hn-xc-xcx'},{'idx':'16,10,6','code':'411081','name':'禹州市','search':'河南-许昌-禹州市|henan-xuchang-yuzhoushi|hn-xc-yzs'},{'idx':'16,10,7','code':'411082','name':'长葛市','search':'河南-许昌-长葛市|henan-xuchang-changgeshi|hn-xc-cgs'}]},{'idx':'16,11','code':'411100','name':'漯河','search':'河南-漯河|henan-luoheshi|hn-lhs','children':[{'idx':'16,11,0','code':'-1','name':'全市','search':'全市|quansheng|qs'},{'idx':'16,11,1','code':'411101','name':'市辖区','search':'河南-漯河-市辖区|henan-luohe-shixiaqu|hn-lh-sxq'},{'idx':'16,11,2','code':'411102','name':'源汇区','search':'河南-漯河-源汇区|henan-luohe-yuanhuiqu|hn-lh-yhq'},{'idx':'16,11,3','code':'411103','name':'郾城区','search':'河南-漯河-郾城区|henan-luohe-yanchengqu|hn-lh-ycq'},{'idx':'16,11,4','code':'411104','name':'召陵区','search':'河南-漯河-召陵区|henan-luohe-zhaolingqu|hn-lh-zlq'},{'idx':'16,11,5','code':'411121','name':'舞阳县','search':'河南-漯河-舞阳县|henan-luohe-wuyangxian|hn-lh-wyx'},{'idx':'16,11,6','code':'411122','name':'临颍县','search':'河南-漯河-临颍县|henan-luohe-linyingxian|hn-lh-lyx'}]},{'idx':'16,12','code':'411200','name':'三门峡','search':'河南-三门峡|henan-sanmenxiashi|hn-smxs','children':[{'idx':'16,12,0','code':'-1','name':'全市','search':'全市|quansheng|qs'},{'idx':'16,12,1','code':'411201','name':'市辖区','search':'河南-三门峡-市辖区|henan-sanmenxia-shixiaqu|hn-smx-sxq'},{'idx':'16,12,2','code':'411202','name':'湖滨区','search':'河南-三门峡-湖滨区|henan-sanmenxia-hubinqu|hn-smx-hbq'},{'idx':'16,12,3','code':'411221','name':'渑池县','search':'河南-三门峡-渑池县|henan-sanmenxia-mianchixian|hn-smx-mcx'},{'idx':'16,12,4','code':'411222','name':'陕县','search':'河南-三门峡-陕县|henan-sanmenxia-shanxian|hn-smx-sx'},{'idx':'16,12,5','code':'411224','name':'卢氏县','search':'河南-三门峡-卢氏县|henan-sanmenxia-lushixian|hn-smx-lsx'},{'idx':'16,12,6','code':'411281','name':'义马市','search':'河南-三门峡-义马市|henan-sanmenxia-yimashi|hn-smx-yms'},{'idx':'16,12,7','code':'411282','name':'灵宝市','search':'河南-三门峡-灵宝市|henan-sanmenxia-lingbaoshi|hn-smx-lbs'}]},{'idx':'16,13','code':'411300','name':'南阳','search':'河南-南阳|henan-nanyangshi|hn-nys','children':[{'idx':'16,13,0','code':'-1','name':'全市','search':'全市|quansheng|qs'},{'idx':'16,13,1','code':'411301','name':'市辖区','search':'河南-南阳-市辖区|henan-nanyang-shixiaqu|hn-ny-sxq'},{'idx':'16,13,2','code':'411302','name':'宛城区','search':'河南-南阳-宛城区|henan-nanyang-wanchengqu|hn-ny-wcq'},{'idx':'16,13,3','code':'411303','name':'卧龙区','search':'河南-南阳-卧龙区|henan-nanyang-wolongqu|hn-ny-wlq'},{'idx':'16,13,4','code':'411321','name':'南召县','search':'河南-南阳-南召县|henan-nanyang-nanzhaoxian|hn-ny-nzx'},{'idx':'16,13,5','code':'411322','name':'方城县','search':'河南-南阳-方城县|henan-nanyang-fangchengxian|hn-ny-fcx'},{'idx':'16,13,6','code':'411323','name':'西峡县','search':'河南-南阳-西峡县|henan-nanyang-xixiaxian|hn-ny-xxx'},{'idx':'16,13,7','code':'411324','name':'镇平县','search':'河南-南阳-镇平县|henan-nanyang-zhenpingxian|hn-ny-zpx'},{'idx':'16,13,8','code':'411325','name':'内乡县','search':'河南-南阳-内乡县|henan-nanyang-neixiangxian|hn-ny-nxx'},{'idx':'16,13,9','code':'411326','name':'淅川县','search':'河南-南阳-淅川县|henan-nanyang-xichuanxian|hn-ny-xcx'},{'idx':'16,13,10','code':'411327','name':'社旗县','search':'河南-南阳-社旗县|henan-nanyang-sheqixian|hn-ny-sqx'},{'idx':'16,13,11','code':'411328','name':'唐河县','search':'河南-南阳-唐河县|henan-nanyang-tanghexian|hn-ny-thx'},{'idx':'16,13,12','code':'411329','name':'新野县','search':'河南-南阳-新野县|henan-nanyang-xinyexian|hn-ny-xyx'},{'idx':'16,13,13','code':'411330','name':'桐柏县','search':'河南-南阳-桐柏县|henan-nanyang-tongbaixian|hn-ny-tbx'},{'idx':'16,13,14','code':'411381','name':'邓州市','search':'河南-南阳-邓州市|henan-nanyang-dengzhoushi|hn-ny-dzs'}]},{'idx':'16,14','code':'411400','name':'商丘','search':'河南-商丘|henan-shangqiushi|hn-sqs','children':[{'idx':'16,14,0','code':'-1','name':'全市','search':'全市|quansheng|qs'},{'idx':'16,14,1','code':'411401','name':'市辖区','search':'河南-商丘-市辖区|henan-shangqiu-shixiaqu|hn-sq-sxq'},{'idx':'16,14,2','code':'411402','name':'梁园区','search':'河南-商丘-梁园区|henan-shangqiu-liangyuanqu|hn-sq-lyq'},{'idx':'16,14,3','code':'411403','name':'睢阳区','search':'河南-商丘-睢阳区|henan-shangqiu-suiyangqu|hn-sq-syq'},{'idx':'16,14,4','code':'411421','name':'民权县','search':'河南-商丘-民权县|henan-shangqiu-minquanxian|hn-sq-mqx'},{'idx':'16,14,5','code':'411422','name':'睢县','search':'河南-商丘-睢县|henan-shangqiu-suixian|hn-sq-sx'},{'idx':'16,14,6','code':'411423','name':'宁陵县','search':'河南-商丘-宁陵县|henan-shangqiu-ninglingxian|hn-sq-nlx'},{'idx':'16,14,7','code':'411424','name':'柘城县','search':'河南-商丘-柘城县|henan-shangqiu-zhechengxian|hn-sq-zcx'},{'idx':'16,14,8','code':'411425','name':'虞城县','search':'河南-商丘-虞城县|henan-shangqiu-yuchengxian|hn-sq-ycx'},{'idx':'16,14,9','code':'411426','name':'夏邑县','search':'河南-商丘-夏邑县|henan-shangqiu-xiayixian|hn-sq-xyx'},{'idx':'16,14,10','code':'411481','name':'永城市','search':'河南-商丘-永城市|henan-shangqiu-yongchengshi|hn-sq-ycs'}]},{'idx':'16,15','code':'411500','name':'信阳','search':'河南-信阳|henan-xinyangshi|hn-xys','children':[{'idx':'16,15,0','code':'-1','name':'全市','search':'全市|quansheng|qs'},{'idx':'16,15,1','code':'411501','name':'市辖区','search':'河南-信阳-市辖区|henan-xinyang-shixiaqu|hn-xy-sxq'},{'idx':'16,15,2','code':'411502','name':'浉河区','search':'河南-信阳-浉河区|henan-xinyang-浉hequ|hn-xy-浉hq'},{'idx':'16,15,3','code':'411503','name':'平桥区','search':'河南-信阳-平桥区|henan-xinyang-pingqiaoqu|hn-xy-pqq'},{'idx':'16,15,4','code':'411521','name':'罗山县','search':'河南-信阳-罗山县|henan-xinyang-luoshanxian|hn-xy-lsx'},{'idx':'16,15,5','code':'411522','name':'光山县','search':'河南-信阳-光山县|henan-xinyang-guangshanxian|hn-xy-gsx'},{'idx':'16,15,6','code':'411523','name':'新县','search':'河南-信阳-新县|henan-xinyang-xinxian|hn-xy-xx'},{'idx':'16,15,7','code':'411524','name':'商城县','search':'河南-信阳-商城县|henan-xinyang-shangchengxian|hn-xy-scx'},{'idx':'16,15,8','code':'411525','name':'固始县','search':'河南-信阳-固始县|henan-xinyang-gushixian|hn-xy-gsx'},{'idx':'16,15,9','code':'411526','name':'潢川县','search':'河南-信阳-潢川县|henan-xinyang-huangchuanxian|hn-xy-hcx'},{'idx':'16,15,10','code':'411527','name':'淮滨县','search':'河南-信阳-淮滨县|henan-xinyang-huaibinxian|hn-xy-hbx'},{'idx':'16,15,11','code':'411528','name':'息县','search':'河南-信阳-息县|henan-xinyang-xixian|hn-xy-xx'}]},{'idx':'16,16','code':'411600','name':'周口','search':'河南-周口|henan-zhoukoushi|hn-zks','children':[{'idx':'16,16,0','code':'-1','name':'全市','search':'全市|quansheng|qs'},{'idx':'16,16,1','code':'411601','name':'市辖区','search':'河南-周口-市辖区|henan-zhoukou-shixiaqu|hn-zk-sxq'},{'idx':'16,16,2','code':'411602','name':'川汇区','search':'河南-周口-川汇区|henan-zhoukou-chuanhuiqu|hn-zk-chq'},{'idx':'16,16,3','code':'411621','name':'扶沟县','search':'河南-周口-扶沟县|henan-zhoukou-fugouxian|hn-zk-fgx'},{'idx':'16,16,4','code':'411622','name':'西华县','search':'河南-周口-西华县|henan-zhoukou-xihuaxian|hn-zk-xhx'},{'idx':'16,16,5','code':'411623','name':'商水县','search':'河南-周口-商水县|henan-zhoukou-shangshuixian|hn-zk-ssx'},{'idx':'16,16,6','code':'411624','name':'沈丘县','search':'河南-周口-沈丘县|henan-zhoukou-shenqiuxian|hn-zk-sqx'},{'idx':'16,16,7','code':'411625','name':'郸城县','search':'河南-周口-郸城县|henan-zhoukou-danchengxian|hn-zk-dcx'},{'idx':'16,16,8','code':'411626','name':'淮阳县','search':'河南-周口-淮阳县|henan-zhoukou-huaiyangxian|hn-zk-hyx'},{'idx':'16,16,9','code':'411627','name':'太康县','search':'河南-周口-太康县|henan-zhoukou-taikangxian|hn-zk-tkx'},{'idx':'16,16,10','code':'411628','name':'鹿邑县','search':'河南-周口-鹿邑县|henan-zhoukou-luyixian|hn-zk-lyx'},{'idx':'16,16,11','code':'411681','name':'项城市','search':'河南-周口-项城市|henan-zhoukou-xiangchengshi|hn-zk-xcs'}]},{'idx':'16,17','code':'411700','name':'驻马店','search':'河南-驻马店|henan-zhumadianshi|hn-zmds','children':[{'idx':'16,17,0','code':'-1','name':'全市','search':'全市|quansheng|qs'},{'idx':'16,17,1','code':'411701','name':'市辖区','search':'河南-驻马店-市辖区|henan-zhumadian-shixiaqu|hn-zmd-sxq'},{'idx':'16,17,2','code':'411702','name':'驿城区','search':'河南-驻马店-驿城区|henan-zhumadian-yichengqu|hn-zmd-ycq'},{'idx':'16,17,3','code':'411721','name':'西平县','search':'河南-驻马店-西平县|henan-zhumadian-xipingxian|hn-zmd-xpx'},{'idx':'16,17,4','code':'411722','name':'上蔡县','search':'河南-驻马店-上蔡县|henan-zhumadian-shangcaixian|hn-zmd-scx'},{'idx':'16,17,5','code':'411723','name':'平舆县','search':'河南-驻马店-平舆县|henan-zhumadian-pingyuxian|hn-zmd-pyx'},{'idx':'16,17,6','code':'411724','name':'正阳县','search':'河南-驻马店-正阳县|henan-zhumadian-zhengyangxian|hn-zmd-zyx'},{'idx':'16,17,7','code':'411725','name':'确山县','search':'河南-驻马店-确山县|henan-zhumadian-queshanxian|hn-zmd-qsx'},{'idx':'16,17,8','code':'411726','name':'泌阳县','search':'河南-驻马店-泌阳县|henan-zhumadian-miyangxian|hn-zmd-myx'},{'idx':'16,17,9','code':'411727','name':'汝南县','search':'河南-驻马店-汝南县|henan-zhumadian-runanxian|hn-zmd-rnx'},{'idx':'16,17,10','code':'411728','name':'遂平县','search':'河南-驻马店-遂平县|henan-zhumadian-suipingxian|hn-zmd-spx'},{'idx':'16,17,11','code':'411729','name':'新蔡县','search':'河南-驻马店-新蔡县|henan-zhumadian-xincaixian|hn-zmd-xcx'}]},{'idx':'16,18','code':'419000','name':'省直辖县级行政区划','search':'河南-省直辖县级行政区划|henan-shengzhixiaxianjixingzhengquhua|hn-szxxjxzqh','children':[{'idx':'16,18,0','code':'-1','name':'全市','search':'全市|quansheng|qs'},{'idx':'16,18,1','code':'419001','name':'济源市','search':'河南-省直辖县级行政区划-济源市|henan-shengzhixiaxianjixingzhengquhua-jiyuanshi|hn-szxxjxzqh-jys'}]}]},{'idx':17,'code':'420000','name':'湖北','search':'湖北|hubeisheng|hbs','children':[{'idx':'17,0','code':'-1','name':'全省','search':'全省|quansheng|qs'},{'idx':'17,1','code':'420100','name':'武汉','search':'湖北-武汉|hubei-wuhanshi|hb-whs','children':[{'idx':'17,1,0','code':'-1','name':'全市','search':'全市|quansheng|qs'},{'idx':'17,1,1','code':'420101','name':'市辖区','search':'湖北-武汉-市辖区|hubei-wuhan-shixiaqu|hb-wh-sxq'},{'idx':'17,1,2','code':'420102','name':'江岸区','search':'湖北-武汉-江岸区|hubei-wuhan-jianganqu|hb-wh-jaq'},{'idx':'17,1,3','code':'420103','name':'江汉区','search':'湖北-武汉-江汉区|hubei-wuhan-jianghanqu|hb-wh-jhq'},{'idx':'17,1,4','code':'420104','name':'硚口区','search':'湖北-武汉-硚口区|hubei-wuhan-changkouqu|hb-wh-ckq'},{'idx':'17,1,5','code':'420105','name':'汉阳区','search':'湖北-武汉-汉阳区|hubei-wuhan-hanyangqu|hb-wh-hyq'},{'idx':'17,1,6','code':'420106','name':'武昌区','search':'湖北-武汉-武昌区|hubei-wuhan-wuchangqu|hb-wh-wcq'},{'idx':'17,1,7','code':'420107','name':'青山区','search':'湖北-武汉-青山区|hubei-wuhan-qingshanqu|hb-wh-qsq'},{'idx':'17,1,8','code':'420111','name':'洪山区','search':'湖北-武汉-洪山区|hubei-wuhan-hongshanqu|hb-wh-hsq'},{'idx':'17,1,9','code':'420112','name':'东西湖区','search':'湖北-武汉-东西湖区|hubei-wuhan-dongxihuqu|hb-wh-dxhq'},{'idx':'17,1,10','code':'420113','name':'汉南区','search':'湖北-武汉-汉南区|hubei-wuhan-hannanqu|hb-wh-hnq'},{'idx':'17,1,11','code':'420114','name':'蔡甸区','search':'湖北-武汉-蔡甸区|hubei-wuhan-caidianqu|hb-wh-cdq'},{'idx':'17,1,12','code':'420115','name':'江夏区','search':'湖北-武汉-江夏区|hubei-wuhan-jiangxiaqu|hb-wh-jxq'},{'idx':'17,1,13','code':'420116','name':'黄陂区','search':'湖北-武汉-黄陂区|hubei-wuhan-huangbeiqu|hb-wh-hbq'},{'idx':'17,1,14','code':'420117','name':'新洲区','search':'湖北-武汉-新洲区|hubei-wuhan-xinzhouqu|hb-wh-xzq'}]},{'idx':'17,2','code':'420200','name':'黄石','search':'湖北-黄石|hubei-huangshishi|hb-hss','children':[{'idx':'17,2,0','code':'-1','name':'全市','search':'全市|quansheng|qs'},{'idx':'17,2,1','code':'420201','name':'市辖区','search':'湖北-黄石-市辖区|hubei-huangshi-shixiaqu|hb-hs-sxq'},{'idx':'17,2,2','code':'420202','name':'黄石港区','search':'湖北-黄石-黄石港区|hubei-huangshi-huangshigangqu|hb-hs-hsgq'},{'idx':'17,2,3','code':'420203','name':'西塞山区','search':'湖北-黄石-西塞山区|hubei-huangshi-xisaishanqu|hb-hs-xssq'},{'idx':'17,2,4','code':'420204','name':'下陆区','search':'湖北-黄石-下陆区|hubei-huangshi-xialuqu|hb-hs-xlq'},{'idx':'17,2,5','code':'420205','name':'铁山区','search':'湖北-黄石-铁山区|hubei-huangshi-tieshanqu|hb-hs-tsq'},{'idx':'17,2,6','code':'420222','name':'阳新县','search':'湖北-黄石-阳新县|hubei-huangshi-yangxinxian|hb-hs-yxx'},{'idx':'17,2,7','code':'420281','name':'大冶市','search':'湖北-黄石-大冶市|hubei-huangshi-dayeshi|hb-hs-dys'}]},{'idx':'17,3','code':'420300','name':'十堰','search':'湖北-十堰|hubei-shiyanshi|hb-sys','children':[{'idx':'17,3,0','code':'-1','name':'全市','search':'全市|quansheng|qs'},{'idx':'17,3,1','code':'420301','name':'市辖区','search':'湖北-十堰-市辖区|hubei-shiyan-shixiaqu|hb-sy-sxq'},{'idx':'17,3,2','code':'420302','name':'茅箭区','search':'湖北-十堰-茅箭区|hubei-shiyan-maojianqu|hb-sy-mjq'},{'idx':'17,3,3','code':'420303','name':'张湾区','search':'湖北-十堰-张湾区|hubei-shiyan-zhangwanqu|hb-sy-zwq'},{'idx':'17,3,4','code':'420304','name':'郧阳区','search':'湖北-十堰-郧阳区|hubei-shiyan-yunyangqu|hb-sy-yyq'},{'idx':'17,3,5','code':'420322','name':'郧西县','search':'湖北-十堰-郧西县|hubei-shiyan-yunxixian|hb-sy-yxx'},{'idx':'17,3,6','code':'420323','name':'竹山县','search':'湖北-十堰-竹山县|hubei-shiyan-zhushanxian|hb-sy-zsx'},{'idx':'17,3,7','code':'420324','name':'竹溪县','search':'湖北-十堰-竹溪县|hubei-shiyan-zhuxixian|hb-sy-zxx'},{'idx':'17,3,8','code':'420325','name':'房县','search':'湖北-十堰-房县|hubei-shiyan-fangxian|hb-sy-fx'},{'idx':'17,3,9','code':'420381','name':'丹江口市','search':'湖北-十堰-丹江口市|hubei-shiyan-danjiangkoushi|hb-sy-djks'}]},{'idx':'17,4','code':'420500','name':'宜昌','search':'湖北-宜昌|hubei-yichangshi|hb-ycs','children':[{'idx':'17,4,0','code':'-1','name':'全市','search':'全市|quansheng|qs'},{'idx':'17,4,1','code':'420501','name':'市辖区','search':'湖北-宜昌-市辖区|hubei-yichang-shixiaqu|hb-yc-sxq'},{'idx':'17,4,2','code':'420502','name':'西陵区','search':'湖北-宜昌-西陵区|hubei-yichang-xilingqu|hb-yc-xlq'},{'idx':'17,4,3','code':'420503','name':'伍家岗区','search':'湖北-宜昌-伍家岗区|hubei-yichang-wujiagangqu|hb-yc-wjgq'},{'idx':'17,4,4','code':'420504','name':'点军区','search':'湖北-宜昌-点军区|hubei-yichang-dianjunqu|hb-yc-djq'},{'idx':'17,4,5','code':'420505','name':'猇亭区','search':'湖北-宜昌-猇亭区|hubei-yichang-猇tingqu|hb-yc-猇tq'},{'idx':'17,4,6','code':'420506','name':'夷陵区','search':'湖北-宜昌-夷陵区|hubei-yichang-yilingqu|hb-yc-ylq'},{'idx':'17,4,7','code':'420525','name':'远安县','search':'湖北-宜昌-远安县|hubei-yichang-yuananxian|hb-yc-yax'},{'idx':'17,4,8','code':'420526','name':'兴山县','search':'湖北-宜昌-兴山县|hubei-yichang-xingshanxian|hb-yc-xsx'},{'idx':'17,4,9','code':'420527','name':'秭归县','search':'湖北-宜昌-秭归县|hubei-yichang-ziguixian|hb-yc-zgx'},{'idx':'17,4,10','code':'420528','name':'长阳土家族自治县','search':'湖北-宜昌-长阳土家族自治县|hubei-yichang-changyangtujiazuzizhixian|hb-yc-cytjzzzx'},{'idx':'17,4,11','code':'420529','name':'五峰土家族自治县','search':'湖北-宜昌-五峰土家族自治县|hubei-yichang-wufengtujiazuzizhixian|hb-yc-wftjzzzx'},{'idx':'17,4,12','code':'420581','name':'宜都市','search':'湖北-宜昌-宜都市|hubei-yichang-yidushi|hb-yc-yds'},{'idx':'17,4,13','code':'420582','name':'当阳市','search':'湖北-宜昌-当阳市|hubei-yichang-dangyangshi|hb-yc-dys'},{'idx':'17,4,14','code':'420583','name':'枝江市','search':'湖北-宜昌-枝江市|hubei-yichang-zhijiangshi|hb-yc-zjs'}]},{'idx':'17,5','code':'420600','name':'襄阳','search':'湖北-襄阳|hubei-xiangyangshi|hb-xys','children':[{'idx':'17,5,0','code':'-1','name':'全市','search':'全市|quansheng|qs'},{'idx':'17,5,1','code':'420601','name':'市辖区','search':'湖北-襄阳-市辖区|hubei-xiangyang-shixiaqu|hb-xy-sxq'},{'idx':'17,5,2','code':'420602','name':'襄城区','search':'湖北-襄阳-襄城区|hubei-xiangyang-xiangchengqu|hb-xy-xcq'},{'idx':'17,5,3','code':'420606','name':'樊城区','search':'湖北-襄阳-樊城区|hubei-xiangyang-fanchengqu|hb-xy-fcq'},{'idx':'17,5,4','code':'420607','name':'襄州区','search':'湖北-襄阳-襄州区|hubei-xiangyang-xiangzhouqu|hb-xy-xzq'},{'idx':'17,5,5','code':'420624','name':'南漳县','search':'湖北-襄阳-南漳县|hubei-xiangyang-nanzhangxian|hb-xy-nzx'},{'idx':'17,5,6','code':'420625','name':'谷城县','search':'湖北-襄阳-谷城县|hubei-xiangyang-guchengxian|hb-xy-gcx'},{'idx':'17,5,7','code':'420626','name':'保康县','search':'湖北-襄阳-保康县|hubei-xiangyang-baokangxian|hb-xy-bkx'},{'idx':'17,5,8','code':'420682','name':'老河口市','search':'湖北-襄阳-老河口市|hubei-xiangyang-laohekoushi|hb-xy-lhks'},{'idx':'17,5,9','code':'420683','name':'枣阳市','search':'湖北-襄阳-枣阳市|hubei-xiangyang-zaoyangshi|hb-xy-zys'},{'idx':'17,5,10','code':'420684','name':'宜城市','search':'湖北-襄阳-宜城市|hubei-xiangyang-yichengshi|hb-xy-ycs'}]},{'idx':'17,6','code':'420700','name':'鄂州','search':'湖北-鄂州|hubei-ezhoushi|hb-ezs','children':[{'idx':'17,6,0','code':'-1','name':'全市','search':'全市|quansheng|qs'},{'idx':'17,6,1','code':'420701','name':'市辖区','search':'湖北-鄂州-市辖区|hubei-ezhou-shixiaqu|hb-ez-sxq'},{'idx':'17,6,2','code':'420702','name':'梁子湖区','search':'湖北-鄂州-梁子湖区|hubei-ezhou-liangzihuqu|hb-ez-lzhq'},{'idx':'17,6,3','code':'420703','name':'华容区','search':'湖北-鄂州-华容区|hubei-ezhou-huarongqu|hb-ez-hrq'},{'idx':'17,6,4','code':'420704','name':'鄂城区','search':'湖北-鄂州-鄂城区|hubei-ezhou-echengqu|hb-ez-ecq'}]},{'idx':'17,7','code':'420800','name':'荆门','search':'湖北-荆门|hubei-jingmenshi|hb-jms','children':[{'idx':'17,7,0','code':'-1','name':'全市','search':'全市|quansheng|qs'},{'idx':'17,7,1','code':'420801','name':'市辖区','search':'湖北-荆门-市辖区|hubei-jingmen-shixiaqu|hb-jm-sxq'},{'idx':'17,7,2','code':'420802','name':'东宝区','search':'湖北-荆门-东宝区|hubei-jingmen-dongbaoqu|hb-jm-dbq'},{'idx':'17,7,3','code':'420804','name':'掇刀区','search':'湖北-荆门-掇刀区|hubei-jingmen-duodaoqu|hb-jm-ddq'},{'idx':'17,7,4','code':'420821','name':'京山县','search':'湖北-荆门-京山县|hubei-jingmen-jingshanxian|hb-jm-jsx'},{'idx':'17,7,5','code':'420822','name':'沙洋县','search':'湖北-荆门-沙洋县|hubei-jingmen-shayangxian|hb-jm-syx'},{'idx':'17,7,6','code':'420881','name':'钟祥市','search':'湖北-荆门-钟祥市|hubei-jingmen-zhongxiangshi|hb-jm-zxs'}]},{'idx':'17,8','code':'420900','name':'孝感','search':'湖北-孝感|hubei-xiaoganshi|hb-xgs','children':[{'idx':'17,8,0','code':'-1','name':'全市','search':'全市|quansheng|qs'},{'idx':'17,8,1','code':'420901','name':'市辖区','search':'湖北-孝感-市辖区|hubei-xiaogan-shixiaqu|hb-xg-sxq'},{'idx':'17,8,2','code':'420902','name':'孝南区','search':'湖北-孝感-孝南区|hubei-xiaogan-xiaonanqu|hb-xg-xnq'},{'idx':'17,8,3','code':'420921','name':'孝昌县','search':'湖北-孝感-孝昌县|hubei-xiaogan-xiaochangxian|hb-xg-xcx'},{'idx':'17,8,4','code':'420922','name':'大悟县','search':'湖北-孝感-大悟县|hubei-xiaogan-dawuxian|hb-xg-dwx'},{'idx':'17,8,5','code':'420923','name':'云梦县','search':'湖北-孝感-云梦县|hubei-xiaogan-yunmengxian|hb-xg-ymx'},{'idx':'17,8,6','code':'420981','name':'应城市','search':'湖北-孝感-应城市|hubei-xiaogan-yingchengshi|hb-xg-ycs'},{'idx':'17,8,7','code':'420982','name':'安陆市','search':'湖北-孝感-安陆市|hubei-xiaogan-anlushi|hb-xg-als'},{'idx':'17,8,8','code':'420984','name':'汉川市','search':'湖北-孝感-汉川市|hubei-xiaogan-hanchuanshi|hb-xg-hcs'}]},{'idx':'17,9','code':'421000','name':'荆州','search':'湖北-荆州|hubei-jingzhoushi|hb-jzs','children':[{'idx':'17,9,0','code':'-1','name':'全市','search':'全市|quansheng|qs'},{'idx':'17,9,1','code':'421001','name':'市辖区','search':'湖北-荆州-市辖区|hubei-jingzhou-shixiaqu|hb-jz-sxq'},{'idx':'17,9,2','code':'421002','name':'沙市区','search':'湖北-荆州-沙市区|hubei-jingzhou-shashiqu|hb-jz-ssq'},{'idx':'17,9,3','code':'421003','name':'荆州区','search':'湖北-荆州-荆州区|hubei-jingzhou-jingzhouqu|hb-jz-jzq'},{'idx':'17,9,4','code':'421022','name':'公安县','search':'湖北-荆州-公安县|hubei-jingzhou-gonganxian|hb-jz-gax'},{'idx':'17,9,5','code':'421023','name':'监利县','search':'湖北-荆州-监利县|hubei-jingzhou-jianlixian|hb-jz-jlx'},{'idx':'17,9,6','code':'421024','name':'江陵县','search':'湖北-荆州-江陵县|hubei-jingzhou-jianglingxian|hb-jz-jlx'},{'idx':'17,9,7','code':'421081','name':'石首市','search':'湖北-荆州-石首市|hubei-jingzhou-shishoushi|hb-jz-sss'},{'idx':'17,9,8','code':'421083','name':'洪湖市','search':'湖北-荆州-洪湖市|hubei-jingzhou-honghushi|hb-jz-hhs'},{'idx':'17,9,9','code':'421087','name':'松滋市','search':'湖北-荆州-松滋市|hubei-jingzhou-songzishi|hb-jz-szs'}]},{'idx':'17,10','code':'421100','name':'黄冈','search':'湖北-黄冈|hubei-huanggangshi|hb-hgs','children':[{'idx':'17,10,0','code':'-1','name':'全市','search':'全市|quansheng|qs'},{'idx':'17,10,1','code':'421101','name':'市辖区','search':'湖北-黄冈-市辖区|hubei-huanggang-shixiaqu|hb-hg-sxq'},{'idx':'17,10,2','code':'421102','name':'黄州区','search':'湖北-黄冈-黄州区|hubei-huanggang-huangzhouqu|hb-hg-hzq'},{'idx':'17,10,3','code':'421121','name':'团风县','search':'湖北-黄冈-团风县|hubei-huanggang-tuanfengxian|hb-hg-tfx'},{'idx':'17,10,4','code':'421122','name':'红安县','search':'湖北-黄冈-红安县|hubei-huanggang-honganxian|hb-hg-hax'},{'idx':'17,10,5','code':'421123','name':'罗田县','search':'湖北-黄冈-罗田县|hubei-huanggang-luotianxian|hb-hg-ltx'},{'idx':'17,10,6','code':'421124','name':'英山县','search':'湖北-黄冈-英山县|hubei-huanggang-yingshanxian|hb-hg-ysx'},{'idx':'17,10,7','code':'421125','name':'浠水县','search':'湖北-黄冈-浠水县|hubei-huanggang-xishuixian|hb-hg-xsx'},{'idx':'17,10,8','code':'421126','name':'蕲春县','search':'湖北-黄冈-蕲春县|hubei-huanggang-qichunxian|hb-hg-qcx'},{'idx':'17,10,9','code':'421127','name':'黄梅县','search':'湖北-黄冈-黄梅县|hubei-huanggang-huangmeixian|hb-hg-hmx'},{'idx':'17,10,10','code':'421181','name':'麻城市','search':'湖北-黄冈-麻城市|hubei-huanggang-machengshi|hb-hg-mcs'},{'idx':'17,10,11','code':'421182','name':'武穴市','search':'湖北-黄冈-武穴市|hubei-huanggang-wuxueshi|hb-hg-wxs'}]},{'idx':'17,11','code':'421200','name':'咸宁','search':'湖北-咸宁|hubei-xianningshi|hb-xns','children':[{'idx':'17,11,0','code':'-1','name':'全市','search':'全市|quansheng|qs'},{'idx':'17,11,1','code':'421201','name':'市辖区','search':'湖北-咸宁-市辖区|hubei-xianning-shixiaqu|hb-xn-sxq'},{'idx':'17,11,2','code':'421202','name':'咸安区','search':'湖北-咸宁-咸安区|hubei-xianning-xiananqu|hb-xn-xaq'},{'idx':'17,11,3','code':'421221','name':'嘉鱼县','search':'湖北-咸宁-嘉鱼县|hubei-xianning-jiayuxian|hb-xn-jyx'},{'idx':'17,11,4','code':'421222','name':'通城县','search':'湖北-咸宁-通城县|hubei-xianning-tongchengxian|hb-xn-tcx'},{'idx':'17,11,5','code':'421223','name':'崇阳县','search':'湖北-咸宁-崇阳县|hubei-xianning-chongyangxian|hb-xn-cyx'},{'idx':'17,11,6','code':'421224','name':'通山县','search':'湖北-咸宁-通山县|hubei-xianning-tongshanxian|hb-xn-tsx'},{'idx':'17,11,7','code':'421281','name':'赤壁市','search':'湖北-咸宁-赤壁市|hubei-xianning-chibishi|hb-xn-cbs'}]},{'idx':'17,12','code':'421300','name':'随州','search':'湖北-随州|hubei-suizhoushi|hb-szs','children':[{'idx':'17,12,0','code':'-1','name':'全市','search':'全市|quansheng|qs'},{'idx':'17,12,1','code':'421301','name':'市辖区','search':'湖北-随州-市辖区|hubei-suizhou-shixiaqu|hb-sz-sxq'},{'idx':'17,12,2','code':'421303','name':'曾都区','search':'湖北-随州-曾都区|hubei-suizhou-zengduqu|hb-sz-zdq'},{'idx':'17,12,3','code':'421321','name':'随县','search':'湖北-随州-随县|hubei-suizhou-suixian|hb-sz-sx'},{'idx':'17,12,4','code':'421381','name':'广水市','search':'湖北-随州-广水市|hubei-suizhou-guangshuishi|hb-sz-gss'}]},{'idx':'17,13','code':'422800','name':'恩施土家族','search':'湖北-恩施土家族|hubei-enshitujiazumiaozuzizhizhou|hb-estjzmzzzz','children':[{'idx':'17,13,0','code':'-1','name':'全市','search':'全市|quansheng|qs'},{'idx':'17,13,1','code':'422801','name':'恩施市','search':'湖北-恩施土家族-恩施市|hubei-enshitujiazu-enshishi|hb-estjz-ess'},{'idx':'17,13,2','code':'422802','name':'利川市','search':'湖北-恩施土家族-利川市|hubei-enshitujiazu-lichuanshi|hb-estjz-lcs'},{'idx':'17,13,3','code':'422822','name':'建始县','search':'湖北-恩施土家族-建始县|hubei-enshitujiazu-jianshixian|hb-estjz-jsx'},{'idx':'17,13,4','code':'422823','name':'巴东县','search':'湖北-恩施土家族-巴东县|hubei-enshitujiazu-badongxian|hb-estjz-bdx'},{'idx':'17,13,5','code':'422825','name':'宣恩县','search':'湖北-恩施土家族-宣恩县|hubei-enshitujiazu-xuanenxian|hb-estjz-xex'},{'idx':'17,13,6','code':'422826','name':'咸丰县','search':'湖北-恩施土家族-咸丰县|hubei-enshitujiazu-xianfengxian|hb-estjz-xfx'},{'idx':'17,13,7','code':'422827','name':'来凤县','search':'湖北-恩施土家族-来凤县|hubei-enshitujiazu-laifengxian|hb-estjz-lfx'},{'idx':'17,13,8','code':'422828','name':'鹤峰县','search':'湖北-恩施土家族-鹤峰县|hubei-enshitujiazu-hefengxian|hb-estjz-hfx'}]},{'idx':'17,14','code':'429000','name':'省直辖县级行政区划','search':'湖北-省直辖县级行政区划|hubei-shengzhixiaxianjixingzhengquhua|hb-szxxjxzqh','children':[{'idx':'17,14,0','code':'-1','name':'全市','search':'全市|quansheng|qs'},{'idx':'17,14,1','code':'429004','name':'仙桃市','search':'湖北-省直辖县级行政区划-仙桃市|hubei-shengzhixiaxianjixingzhengquhua-xiantaoshi|hb-szxxjxzqh-xts'},{'idx':'17,14,2','code':'429005','name':'潜江市','search':'湖北-省直辖县级行政区划-潜江市|hubei-shengzhixiaxianjixingzhengquhua-qianjiangshi|hb-szxxjxzqh-qjs'},{'idx':'17,14,3','code':'429006','name':'天门市','search':'湖北-省直辖县级行政区划-天门市|hubei-shengzhixiaxianjixingzhengquhua-tianmenshi|hb-szxxjxzqh-tms'},{'idx':'17,14,4','code':'429021','name':'神农架林区','search':'湖北-省直辖县级行政区划-神农架林区|hubei-shengzhixiaxianjixingzhengquhua-shennongjialinqu|hb-szxxjxzqh-snjlq'}]}]},{'idx':18,'code':'430000','name':'湖南','search':'湖南|hunansheng|hns','children':[{'idx':'18,0','code':'-1','name':'全省','search':'全省|quansheng|qs'},{'idx':'18,1','code':'430100','name':'长沙','search':'湖南-长沙|hunan-changshashi|hn-css','children':[{'idx':'18,1,0','code':'-1','name':'全市','search':'全市|quansheng|qs'},{'idx':'18,1,1','code':'430101','name':'市辖区','search':'湖南-长沙-市辖区|hunan-changsha-shixiaqu|hn-cs-sxq'},{'idx':'18,1,2','code':'430102','name':'芙蓉区','search':'湖南-长沙-芙蓉区|hunan-changsha-furongqu|hn-cs-frq'},{'idx':'18,1,3','code':'430103','name':'天心区','search':'湖南-长沙-天心区|hunan-changsha-tianxinqu|hn-cs-txq'},{'idx':'18,1,4','code':'430104','name':'岳麓区','search':'湖南-长沙-岳麓区|hunan-changsha-yueluqu|hn-cs-ylq'},{'idx':'18,1,5','code':'430105','name':'开福区','search':'湖南-长沙-开福区|hunan-changsha-kaifuqu|hn-cs-kfq'},{'idx':'18,1,6','code':'430111','name':'雨花区','search':'湖南-长沙-雨花区|hunan-changsha-yuhuaqu|hn-cs-yhq'},{'idx':'18,1,7','code':'430112','name':'望城区','search':'湖南-长沙-望城区|hunan-changsha-wangchengqu|hn-cs-wcq'},{'idx':'18,1,8','code':'430121','name':'长沙县','search':'湖南-长沙-长沙县|hunan-changsha-changshaxian|hn-cs-csx'},{'idx':'18,1,9','code':'430124','name':'宁乡县','search':'湖南-长沙-宁乡县|hunan-changsha-ningxiangxian|hn-cs-nxx'},{'idx':'18,1,10','code':'430181','name':'浏阳市','search':'湖南-长沙-浏阳市|hunan-changsha-liuyangshi|hn-cs-lys'}]},{'idx':'18,2','code':'430200','name':'株洲','search':'湖南-株洲|hunan-zhuzhoushi|hn-zzs','children':[{'idx':'18,2,0','code':'-1','name':'全市','search':'全市|quansheng|qs'},{'idx':'18,2,1','code':'430201','name':'市辖区','search':'湖南-株洲-市辖区|hunan-zhuzhou-shixiaqu|hn-zz-sxq'},{'idx':'18,2,2','code':'430202','name':'荷塘区','search':'湖南-株洲-荷塘区|hunan-zhuzhou-hetangqu|hn-zz-htq'},{'idx':'18,2,3','code':'430203','name':'芦淞区','search':'湖南-株洲-芦淞区|hunan-zhuzhou-lusongqu|hn-zz-lsq'},{'idx':'18,2,4','code':'430204','name':'石峰区','search':'湖南-株洲-石峰区|hunan-zhuzhou-shifengqu|hn-zz-sfq'},{'idx':'18,2,5','code':'430211','name':'天元区','search':'湖南-株洲-天元区|hunan-zhuzhou-tianyuanqu|hn-zz-tyq'},{'idx':'18,2,6','code':'430221','name':'株洲县','search':'湖南-株洲-株洲县|hunan-zhuzhou-zhuzhouxian|hn-zz-zzx'},{'idx':'18,2,7','code':'430223','name':'攸县','search':'湖南-株洲-攸县|hunan-zhuzhou-youxian|hn-zz-yx'},{'idx':'18,2,8','code':'430224','name':'茶陵县','search':'湖南-株洲-茶陵县|hunan-zhuzhou-chalingxian|hn-zz-clx'},{'idx':'18,2,9','code':'430225','name':'炎陵县','search':'湖南-株洲-炎陵县|hunan-zhuzhou-yanlingxian|hn-zz-ylx'},{'idx':'18,2,10','code':'430281','name':'醴陵市','search':'湖南-株洲-醴陵市|hunan-zhuzhou-lilingshi|hn-zz-lls'}]},{'idx':'18,3','code':'430300','name':'湘潭','search':'湖南-湘潭|hunan-xiangtanshi|hn-xts','children':[{'idx':'18,3,0','code':'-1','name':'全市','search':'全市|quansheng|qs'},{'idx':'18,3,1','code':'430301','name':'市辖区','search':'湖南-湘潭-市辖区|hunan-xiangtan-shixiaqu|hn-xt-sxq'},{'idx':'18,3,2','code':'430302','name':'雨湖区','search':'湖南-湘潭-雨湖区|hunan-xiangtan-yuhuqu|hn-xt-yhq'},{'idx':'18,3,3','code':'430304','name':'岳塘区','search':'湖南-湘潭-岳塘区|hunan-xiangtan-yuetangqu|hn-xt-ytq'},{'idx':'18,3,4','code':'430321','name':'湘潭县','search':'湖南-湘潭-湘潭县|hunan-xiangtan-xiangtanxian|hn-xt-xtx'},{'idx':'18,3,5','code':'430381','name':'湘乡市','search':'湖南-湘潭-湘乡市|hunan-xiangtan-xiangxiangshi|hn-xt-xxs'},{'idx':'18,3,6','code':'430382','name':'韶山市','search':'湖南-湘潭-韶山市|hunan-xiangtan-shaoshanshi|hn-xt-sss'}]},{'idx':'18,4','code':'430400','name':'衡阳','search':'湖南-衡阳|hunan-hengyangshi|hn-hys','children':[{'idx':'18,4,0','code':'-1','name':'全市','search':'全市|quansheng|qs'},{'idx':'18,4,1','code':'430401','name':'市辖区','search':'湖南-衡阳-市辖区|hunan-hengyang-shixiaqu|hn-hy-sxq'},{'idx':'18,4,2','code':'430405','name':'珠晖区','search':'湖南-衡阳-珠晖区|hunan-hengyang-zhuhuiqu|hn-hy-zhq'},{'idx':'18,4,3','code':'430406','name':'雁峰区','search':'湖南-衡阳-雁峰区|hunan-hengyang-yanfengqu|hn-hy-yfq'},{'idx':'18,4,4','code':'430407','name':'石鼓区','search':'湖南-衡阳-石鼓区|hunan-hengyang-shiguqu|hn-hy-sgq'},{'idx':'18,4,5','code':'430408','name':'蒸湘区','search':'湖南-衡阳-蒸湘区|hunan-hengyang-zhengxiangqu|hn-hy-zxq'},{'idx':'18,4,6','code':'430412','name':'南岳区','search':'湖南-衡阳-南岳区|hunan-hengyang-nanyuequ|hn-hy-nyq'},{'idx':'18,4,7','code':'430421','name':'衡阳县','search':'湖南-衡阳-衡阳县|hunan-hengyang-hengyangxian|hn-hy-hyx'},{'idx':'18,4,8','code':'430422','name':'衡南县','search':'湖南-衡阳-衡南县|hunan-hengyang-hengnanxian|hn-hy-hnx'},{'idx':'18,4,9','code':'430423','name':'衡山县','search':'湖南-衡阳-衡山县|hunan-hengyang-hengshanxian|hn-hy-hsx'},{'idx':'18,4,10','code':'430424','name':'衡东县','search':'湖南-衡阳-衡东县|hunan-hengyang-hengdongxian|hn-hy-hdx'},{'idx':'18,4,11','code':'430426','name':'祁东县','search':'湖南-衡阳-祁东县|hunan-hengyang-qidongxian|hn-hy-qdx'},{'idx':'18,4,12','code':'430481','name':'耒阳市','search':'湖南-衡阳-耒阳市|hunan-hengyang-leiyangshi|hn-hy-lys'},{'idx':'18,4,13','code':'430482','name':'常宁市','search':'湖南-衡阳-常宁市|hunan-hengyang-changningshi|hn-hy-cns'}]},{'idx':'18,5','code':'430500','name':'邵阳','search':'湖南-邵阳|hunan-shaoyangshi|hn-sys','children':[{'idx':'18,5,0','code':'-1','name':'全市','search':'全市|quansheng|qs'},{'idx':'18,5,1','code':'430501','name':'市辖区','search':'湖南-邵阳-市辖区|hunan-shaoyang-shixiaqu|hn-sy-sxq'},{'idx':'18,5,2','code':'430502','name':'双清区','search':'湖南-邵阳-双清区|hunan-shaoyang-shuangqingqu|hn-sy-sqq'},{'idx':'18,5,3','code':'430503','name':'大祥区','search':'湖南-邵阳-大祥区|hunan-shaoyang-daxiangqu|hn-sy-dxq'},{'idx':'18,5,4','code':'430511','name':'北塔区','search':'湖南-邵阳-北塔区|hunan-shaoyang-beitaqu|hn-sy-btq'},{'idx':'18,5,5','code':'430521','name':'邵东县','search':'湖南-邵阳-邵东县|hunan-shaoyang-shaodongxian|hn-sy-sdx'},{'idx':'18,5,6','code':'430522','name':'新邵县','search':'湖南-邵阳-新邵县|hunan-shaoyang-xinshaoxian|hn-sy-xsx'},{'idx':'18,5,7','code':'430523','name':'邵阳县','search':'湖南-邵阳-邵阳县|hunan-shaoyang-shaoyangxian|hn-sy-syx'},{'idx':'18,5,8','code':'430524','name':'隆回县','search':'湖南-邵阳-隆回县|hunan-shaoyang-longhuixian|hn-sy-lhx'},{'idx':'18,5,9','code':'430525','name':'洞口县','search':'湖南-邵阳-洞口县|hunan-shaoyang-dongkouxian|hn-sy-dkx'},{'idx':'18,5,10','code':'430527','name':'绥宁县','search':'湖南-邵阳-绥宁县|hunan-shaoyang-suiningxian|hn-sy-snx'},{'idx':'18,5,11','code':'430528','name':'新宁县','search':'湖南-邵阳-新宁县|hunan-shaoyang-xinningxian|hn-sy-xnx'},{'idx':'18,5,12','code':'430529','name':'城步苗族自治县','search':'湖南-邵阳-城步苗族自治县|hunan-shaoyang-chengbumiaozuzizhixian|hn-sy-cbmzzzx'},{'idx':'18,5,13','code':'430581','name':'武冈市','search':'湖南-邵阳-武冈市|hunan-shaoyang-wugangshi|hn-sy-wgs'}]},{'idx':'18,6','code':'430600','name':'岳阳','search':'湖南-岳阳|hunan-yueyangshi|hn-yys','children':[{'idx':'18,6,0','code':'-1','name':'全市','search':'全市|quansheng|qs'},{'idx':'18,6,1','code':'430601','name':'市辖区','search':'湖南-岳阳-市辖区|hunan-yueyang-shixiaqu|hn-yy-sxq'},{'idx':'18,6,2','code':'430602','name':'岳阳楼区','search':'湖南-岳阳-岳阳楼区|hunan-yueyang-yueyanglouqu|hn-yy-yylq'},{'idx':'18,6,3','code':'430603','name':'云溪区','search':'湖南-岳阳-云溪区|hunan-yueyang-yunxiqu|hn-yy-yxq'},{'idx':'18,6,4','code':'430611','name':'君山区','search':'湖南-岳阳-君山区|hunan-yueyang-junshanqu|hn-yy-jsq'},{'idx':'18,6,5','code':'430621','name':'岳阳县','search':'湖南-岳阳-岳阳县|hunan-yueyang-yueyangxian|hn-yy-yyx'},{'idx':'18,6,6','code':'430623','name':'华容县','search':'湖南-岳阳-华容县|hunan-yueyang-huarongxian|hn-yy-hrx'},{'idx':'18,6,7','code':'430624','name':'湘阴县','search':'湖南-岳阳-湘阴县|hunan-yueyang-xiangyinxian|hn-yy-xyx'},{'idx':'18,6,8','code':'430626','name':'平江县','search':'湖南-岳阳-平江县|hunan-yueyang-pingjiangxian|hn-yy-pjx'},{'idx':'18,6,9','code':'430681','name':'汨罗市','search':'湖南-岳阳-汨罗市|hunan-yueyang-miluoshi|hn-yy-mls'},{'idx':'18,6,10','code':'430682','name':'临湘市','search':'湖南-岳阳-临湘市|hunan-yueyang-linxiangshi|hn-yy-lxs'}]},{'idx':'18,7','code':'430700','name':'常德','search':'湖南-常德|hunan-changdeshi|hn-cds','children':[{'idx':'18,7,0','code':'-1','name':'全市','search':'全市|quansheng|qs'},{'idx':'18,7,1','code':'430701','name':'市辖区','search':'湖南-常德-市辖区|hunan-changde-shixiaqu|hn-cd-sxq'},{'idx':'18,7,2','code':'430702','name':'武陵区','search':'湖南-常德-武陵区|hunan-changde-wulingqu|hn-cd-wlq'},{'idx':'18,7,3','code':'430703','name':'鼎城区','search':'湖南-常德-鼎城区|hunan-changde-dingchengqu|hn-cd-dcq'},{'idx':'18,7,4','code':'430721','name':'安乡县','search':'湖南-常德-安乡县|hunan-changde-anxiangxian|hn-cd-axx'},{'idx':'18,7,5','code':'430722','name':'汉寿县','search':'湖南-常德-汉寿县|hunan-changde-hanshouxian|hn-cd-hsx'},{'idx':'18,7,6','code':'430723','name':'澧县','search':'湖南-常德-澧县|hunan-changde-lixian|hn-cd-lx'},{'idx':'18,7,7','code':'430724','name':'临澧县','search':'湖南-常德-临澧县|hunan-changde-linlixian|hn-cd-llx'},{'idx':'18,7,8','code':'430725','name':'桃源县','search':'湖南-常德-桃源县|hunan-changde-taoyuanxian|hn-cd-tyx'},{'idx':'18,7,9','code':'430726','name':'石门县','search':'湖南-常德-石门县|hunan-changde-shimenxian|hn-cd-smx'},{'idx':'18,7,10','code':'430781','name':'津市市','search':'湖南-常德-津市市|hunan-changde-jinshishi|hn-cd-jss'}]},{'idx':'18,8','code':'430800','name':'张家界','search':'湖南-张家界|hunan-zhangjiajieshi|hn-zjjs','children':[{'idx':'18,8,0','code':'-1','name':'全市','search':'全市|quansheng|qs'},{'idx':'18,8,1','code':'430801','name':'市辖区','search':'湖南-张家界-市辖区|hunan-zhangjiajie-shixiaqu|hn-zjj-sxq'},{'idx':'18,8,2','code':'430802','name':'永定区','search':'湖南-张家界-永定区|hunan-zhangjiajie-yongdingqu|hn-zjj-ydq'},{'idx':'18,8,3','code':'430811','name':'武陵源区','search':'湖南-张家界-武陵源区|hunan-zhangjiajie-wulingyuanqu|hn-zjj-wlyq'},{'idx':'18,8,4','code':'430821','name':'慈利县','search':'湖南-张家界-慈利县|hunan-zhangjiajie-cilixian|hn-zjj-clx'},{'idx':'18,8,5','code':'430822','name':'桑植县','search':'湖南-张家界-桑植县|hunan-zhangjiajie-sangzhixian|hn-zjj-szx'}]},{'idx':'18,9','code':'430900','name':'益阳','search':'湖南-益阳|hunan-yiyangshi|hn-yys','children':[{'idx':'18,9,0','code':'-1','name':'全市','search':'全市|quansheng|qs'},{'idx':'18,9,1','code':'430901','name':'市辖区','search':'湖南-益阳-市辖区|hunan-yiyang-shixiaqu|hn-yy-sxq'},{'idx':'18,9,2','code':'430902','name':'资阳区','search':'湖南-益阳-资阳区|hunan-yiyang-ziyangqu|hn-yy-zyq'},{'idx':'18,9,3','code':'430903','name':'赫山区','search':'湖南-益阳-赫山区|hunan-yiyang-heshanqu|hn-yy-hsq'},{'idx':'18,9,4','code':'430921','name':'南县','search':'湖南-益阳-南县|hunan-yiyang-nanxian|hn-yy-nx'},{'idx':'18,9,5','code':'430922','name':'桃江县','search':'湖南-益阳-桃江县|hunan-yiyang-taojiangxian|hn-yy-tjx'},{'idx':'18,9,6','code':'430923','name':'安化县','search':'湖南-益阳-安化县|hunan-yiyang-anhuaxian|hn-yy-ahx'},{'idx':'18,9,7','code':'430981','name':'沅江市','search':'湖南-益阳-沅江市|hunan-yiyang-yuanjiangshi|hn-yy-yjs'}]},{'idx':'18,10','code':'431000','name':'郴州','search':'湖南-郴州|hunan-chenzhoushi|hn-czs','children':[{'idx':'18,10,0','code':'-1','name':'全市','search':'全市|quansheng|qs'},{'idx':'18,10,1','code':'431001','name':'市辖区','search':'湖南-郴州-市辖区|hunan-chenzhou-shixiaqu|hn-cz-sxq'},{'idx':'18,10,2','code':'431002','name':'北湖区','search':'湖南-郴州-北湖区|hunan-chenzhou-beihuqu|hn-cz-bhq'},{'idx':'18,10,3','code':'431003','name':'苏仙区','search':'湖南-郴州-苏仙区|hunan-chenzhou-suxianqu|hn-cz-sxq'},{'idx':'18,10,4','code':'431021','name':'桂阳县','search':'湖南-郴州-桂阳县|hunan-chenzhou-guiyangxian|hn-cz-gyx'},{'idx':'18,10,5','code':'431022','name':'宜章县','search':'湖南-郴州-宜章县|hunan-chenzhou-yizhangxian|hn-cz-yzx'},{'idx':'18,10,6','code':'431023','name':'永兴县','search':'湖南-郴州-永兴县|hunan-chenzhou-yongxingxian|hn-cz-yxx'},{'idx':'18,10,7','code':'431024','name':'嘉禾县','search':'湖南-郴州-嘉禾县|hunan-chenzhou-jiahexian|hn-cz-jhx'},{'idx':'18,10,8','code':'431025','name':'临武县','search':'湖南-郴州-临武县|hunan-chenzhou-linwuxian|hn-cz-lwx'},{'idx':'18,10,9','code':'431026','name':'汝城县','search':'湖南-郴州-汝城县|hunan-chenzhou-ruchengxian|hn-cz-rcx'},{'idx':'18,10,10','code':'431027','name':'桂东县','search':'湖南-郴州-桂东县|hunan-chenzhou-guidongxian|hn-cz-gdx'},{'idx':'18,10,11','code':'431028','name':'安仁县','search':'湖南-郴州-安仁县|hunan-chenzhou-anrenxian|hn-cz-arx'},{'idx':'18,10,12','code':'431081','name':'资兴市','search':'湖南-郴州-资兴市|hunan-chenzhou-zixingshi|hn-cz-zxs'}]},{'idx':'18,11','code':'431100','name':'永州','search':'湖南-永州|hunan-yongzhoushi|hn-yzs','children':[{'idx':'18,11,0','code':'-1','name':'全市','search':'全市|quansheng|qs'},{'idx':'18,11,1','code':'431101','name':'市辖区','search':'湖南-永州-市辖区|hunan-yongzhou-shixiaqu|hn-yz-sxq'},{'idx':'18,11,2','code':'431102','name':'零陵区','search':'湖南-永州-零陵区|hunan-yongzhou-linglingqu|hn-yz-llq'},{'idx':'18,11,3','code':'431103','name':'冷水滩区','search':'湖南-永州-冷水滩区|hunan-yongzhou-lengshuitanqu|hn-yz-lstq'},{'idx':'18,11,4','code':'431121','name':'祁阳县','search':'湖南-永州-祁阳县|hunan-yongzhou-qiyangxian|hn-yz-qyx'},{'idx':'18,11,5','code':'431122','name':'东安县','search':'湖南-永州-东安县|hunan-yongzhou-donganxian|hn-yz-dax'},{'idx':'18,11,6','code':'431123','name':'双牌县','search':'湖南-永州-双牌县|hunan-yongzhou-shuangpaixian|hn-yz-spx'},{'idx':'18,11,7','code':'431124','name':'道县','search':'湖南-永州-道县|hunan-yongzhou-daoxian|hn-yz-dx'},{'idx':'18,11,8','code':'431125','name':'江永县','search':'湖南-永州-江永县|hunan-yongzhou-jiangyongxian|hn-yz-jyx'},{'idx':'18,11,9','code':'431126','name':'宁远县','search':'湖南-永州-宁远县|hunan-yongzhou-ningyuanxian|hn-yz-nyx'},{'idx':'18,11,10','code':'431127','name':'蓝山县','search':'湖南-永州-蓝山县|hunan-yongzhou-lanshanxian|hn-yz-lsx'},{'idx':'18,11,11','code':'431128','name':'新田县','search':'湖南-永州-新田县|hunan-yongzhou-xintianxian|hn-yz-xtx'},{'idx':'18,11,12','code':'431129','name':'江华瑶族自治县','search':'湖南-永州-江华瑶族自治县|hunan-yongzhou-jianghuayaozuzizhixian|hn-yz-jhyzzzx'}]},{'idx':'18,12','code':'431200','name':'怀化','search':'湖南-怀化|hunan-huaihuashi|hn-hhs','children':[{'idx':'18,12,0','code':'-1','name':'全市','search':'全市|quansheng|qs'},{'idx':'18,12,1','code':'431201','name':'市辖区','search':'湖南-怀化-市辖区|hunan-huaihua-shixiaqu|hn-hh-sxq'},{'idx':'18,12,2','code':'431202','name':'鹤城区','search':'湖南-怀化-鹤城区|hunan-huaihua-hechengqu|hn-hh-hcq'},{'idx':'18,12,3','code':'431221','name':'中方县','search':'湖南-怀化-中方县|hunan-huaihua-zhongfangxian|hn-hh-zfx'},{'idx':'18,12,4','code':'431222','name':'沅陵县','search':'湖南-怀化-沅陵县|hunan-huaihua-yuanlingxian|hn-hh-ylx'},{'idx':'18,12,5','code':'431223','name':'辰溪县','search':'湖南-怀化-辰溪县|hunan-huaihua-chenxixian|hn-hh-cxx'},{'idx':'18,12,6','code':'431224','name':'溆浦县','search':'湖南-怀化-溆浦县|hunan-huaihua-xupuxian|hn-hh-xpx'},{'idx':'18,12,7','code':'431225','name':'会同县','search':'湖南-怀化-会同县|hunan-huaihua-huitongxian|hn-hh-htx'},{'idx':'18,12,8','code':'431226','name':'麻阳苗族自治县','search':'湖南-怀化-麻阳苗族自治县|hunan-huaihua-mayangmiaozuzizhixian|hn-hh-mymzzzx'},{'idx':'18,12,9','code':'431227','name':'新晃侗族自治县','search':'湖南-怀化-新晃侗族自治县|hunan-huaihua-xinhuangdongzuzizhixian|hn-hh-xhdzzzx'},{'idx':'18,12,10','code':'431228','name':'芷江侗族自治县','search':'湖南-怀化-芷江侗族自治县|hunan-huaihua-zhijiangdongzuzizhixian|hn-hh-zjdzzzx'},{'idx':'18,12,11','code':'431229','name':'靖州苗族侗族自治县','search':'湖南-怀化-靖州苗族侗族自治县|hunan-huaihua-jingzhoumiaozudongzuzizhixian|hn-hh-jzmzdzzzx'},{'idx':'18,12,12','code':'431230','name':'通道侗族自治县','search':'湖南-怀化-通道侗族自治县|hunan-huaihua-tongdaodongzuzizhixian|hn-hh-tddzzzx'},{'idx':'18,12,13','code':'431281','name':'洪江市','search':'湖南-怀化-洪江市|hunan-huaihua-hongjiangshi|hn-hh-hjs'}]},{'idx':'18,13','code':'431300','name':'娄底','search':'湖南-娄底|hunan-loudishi|hn-lds','children':[{'idx':'18,13,0','code':'-1','name':'全市','search':'全市|quansheng|qs'},{'idx':'18,13,1','code':'431301','name':'市辖区','search':'湖南-娄底-市辖区|hunan-loudi-shixiaqu|hn-ld-sxq'},{'idx':'18,13,2','code':'431302','name':'娄星区','search':'湖南-娄底-娄星区|hunan-loudi-louxingqu|hn-ld-lxq'},{'idx':'18,13,3','code':'431321','name':'双峰县','search':'湖南-娄底-双峰县|hunan-loudi-shuangfengxian|hn-ld-sfx'},{'idx':'18,13,4','code':'431322','name':'新化县','search':'湖南-娄底-新化县|hunan-loudi-xinhuaxian|hn-ld-xhx'},{'idx':'18,13,5','code':'431381','name':'冷水江市','search':'湖南-娄底-冷水江市|hunan-loudi-lengshuijiangshi|hn-ld-lsjs'},{'idx':'18,13,6','code':'431382','name':'涟源市','search':'湖南-娄底-涟源市|hunan-loudi-lianyuanshi|hn-ld-lys'}]},{'idx':'18,14','code':'433100','name':'湘西土家族','search':'湖南-湘西土家族|hunan-xiangxitujiazumiaozuzizhizhou|hn-xxtjzmzzzz','children':[{'idx':'18,14,0','code':'-1','name':'全市','search':'全市|quansheng|qs'},{'idx':'18,14,1','code':'433101','name':'吉首市','search':'湖南-湘西土家族-吉首市|hunan-xiangxitujiazu-jishoushi|hn-xxtjz-jss'},{'idx':'18,14,2','code':'433122','name':'泸溪县','search':'湖南-湘西土家族-泸溪县|hunan-xiangxitujiazu-luxixian|hn-xxtjz-lxx'},{'idx':'18,14,3','code':'433123','name':'凤凰县','search':'湖南-湘西土家族-凤凰县|hunan-xiangxitujiazu-fenghuangxian|hn-xxtjz-fhx'},{'idx':'18,14,4','code':'433124','name':'花垣县','search':'湖南-湘西土家族-花垣县|hunan-xiangxitujiazu-huayuanxian|hn-xxtjz-hyx'},{'idx':'18,14,5','code':'433125','name':'保靖县','search':'湖南-湘西土家族-保靖县|hunan-xiangxitujiazu-baojingxian|hn-xxtjz-bjx'},{'idx':'18,14,6','code':'433126','name':'古丈县','search':'湖南-湘西土家族-古丈县|hunan-xiangxitujiazu-guzhangxian|hn-xxtjz-gzx'},{'idx':'18,14,7','code':'433127','name':'永顺县','search':'湖南-湘西土家族-永顺县|hunan-xiangxitujiazu-yongshunxian|hn-xxtjz-ysx'},{'idx':'18,14,8','code':'433130','name':'龙山县','search':'湖南-湘西土家族-龙山县|hunan-xiangxitujiazu-longshanxian|hn-xxtjz-lsx'}]}]},{'idx':19,'code':'440000','name':'广东','search':'广东|guangdongsheng|gds','children':[{'idx':'19,0','code':'-1','name':'全省','search':'全省|quansheng|qs'},{'idx':'19,1','code':'440100','name':'广州','search':'广东-广州|guangdong-guangzhoushi|gd-gzs','children':[{'idx':'19,1,0','code':'-1','name':'全市','search':'全市|quansheng|qs'},{'idx':'19,1,1','code':'440101','name':'市辖区','search':'广东-广州-市辖区|guangdong-guangzhou-shixiaqu|gd-gz-sxq'},{'idx':'19,1,2','code':'440103','name':'荔湾区','search':'广东-广州-荔湾区|guangdong-guangzhou-liwanqu|gd-gz-lwq'},{'idx':'19,1,3','code':'440104','name':'越秀区','search':'广东-广州-越秀区|guangdong-guangzhou-yuexiuqu|gd-gz-yxq'},{'idx':'19,1,4','code':'440105','name':'海珠区','search':'广东-广州-海珠区|guangdong-guangzhou-haizhuqu|gd-gz-hzq'},{'idx':'19,1,5','code':'440106','name':'天河区','search':'广东-广州-天河区|guangdong-guangzhou-tianhequ|gd-gz-thq'},{'idx':'19,1,6','code':'440111','name':'白云区','search':'广东-广州-白云区|guangdong-guangzhou-baiyunqu|gd-gz-byq'},{'idx':'19,1,7','code':'440112','name':'黄埔区','search':'广东-广州-黄埔区|guangdong-guangzhou-huangpuqu|gd-gz-hpq'},{'idx':'19,1,8','code':'440113','name':'番禺区','search':'广东-广州-番禺区|guangdong-guangzhou-fanyuqu|gd-gz-fyq'},{'idx':'19,1,9','code':'440114','name':'花都区','search':'广东-广州-花都区|guangdong-guangzhou-huaduqu|gd-gz-hdq'},{'idx':'19,1,10','code':'440115','name':'南沙区','search':'广东-广州-南沙区|guangdong-guangzhou-nanshaqu|gd-gz-nsq'},{'idx':'19,1,11','code':'440117','name':'从化区','search':'广东-广州-从化区|guangdong-guangzhou-conghuaqu|gd-gz-chq'},{'idx':'19,1,12','code':'440118','name':'增城区','search':'广东-广州-增城区|guangdong-guangzhou-zengchengqu|gd-gz-zcq'}]},{'idx':'19,2','code':'440200','name':'韶关','search':'广东-韶关|guangdong-shaoguanshi|gd-sgs','children':[{'idx':'19,2,0','code':'-1','name':'全市','search':'全市|quansheng|qs'},{'idx':'19,2,1','code':'440201','name':'市辖区','search':'广东-韶关-市辖区|guangdong-shaoguan-shixiaqu|gd-sg-sxq'},{'idx':'19,2,2','code':'440203','name':'武江区','search':'广东-韶关-武江区|guangdong-shaoguan-wujiangqu|gd-sg-wjq'},{'idx':'19,2,3','code':'440204','name':'浈江区','search':'广东-韶关-浈江区|guangdong-shaoguan-zhenjiangqu|gd-sg-zjq'},{'idx':'19,2,4','code':'440205','name':'曲江区','search':'广东-韶关-曲江区|guangdong-shaoguan-qujiangqu|gd-sg-qjq'},{'idx':'19,2,5','code':'440222','name':'始兴县','search':'广东-韶关-始兴县|guangdong-shaoguan-shixingxian|gd-sg-sxx'},{'idx':'19,2,6','code':'440224','name':'仁化县','search':'广东-韶关-仁化县|guangdong-shaoguan-renhuaxian|gd-sg-rhx'},{'idx':'19,2,7','code':'440229','name':'翁源县','search':'广东-韶关-翁源县|guangdong-shaoguan-wengyuanxian|gd-sg-wyx'},{'idx':'19,2,8','code':'440232','name':'乳源瑶族自治县','search':'广东-韶关-乳源瑶族自治县|guangdong-shaoguan-ruyuanyaozuzizhixian|gd-sg-ryyzzzx'},{'idx':'19,2,9','code':'440233','name':'新丰县','search':'广东-韶关-新丰县|guangdong-shaoguan-xinfengxian|gd-sg-xfx'},{'idx':'19,2,10','code':'440281','name':'乐昌市','search':'广东-韶关-乐昌市|guangdong-shaoguan-lechangshi|gd-sg-lcs'},{'idx':'19,2,11','code':'440282','name':'南雄市','search':'广东-韶关-南雄市|guangdong-shaoguan-nanxiongshi|gd-sg-nxs'}]},{'idx':'19,3','code':'440300','name':'深圳','search':'广东-深圳|guangdong-shenzhenshi|gd-szs','children':[{'idx':'19,3,0','code':'-1','name':'全市','search':'全市|quansheng|qs'},{'idx':'19,3,1','code':'440301','name':'市辖区','search':'广东-深圳-市辖区|guangdong-shenzhen-shixiaqu|gd-sz-sxq'},{'idx':'19,3,2','code':'440303','name':'罗湖区','search':'广东-深圳-罗湖区|guangdong-shenzhen-luohuqu|gd-sz-lhq'},{'idx':'19,3,3','code':'440304','name':'福田区','search':'广东-深圳-福田区|guangdong-shenzhen-futianqu|gd-sz-ftq'},{'idx':'19,3,4','code':'440305','name':'南山区','search':'广东-深圳-南山区|guangdong-shenzhen-nanshanqu|gd-sz-nsq'},{'idx':'19,3,5','code':'440306','name':'宝安区','search':'广东-深圳-宝安区|guangdong-shenzhen-baoanqu|gd-sz-baq'},{'idx':'19,3,6','code':'440307','name':'龙岗区','search':'广东-深圳-龙岗区|guangdong-shenzhen-longgangqu|gd-sz-lgq'},{'idx':'19,3,7','code':'440308','name':'盐田区','search':'广东-深圳-盐田区|guangdong-shenzhen-yantianqu|gd-sz-ytq'}]},{'idx':'19,4','code':'440400','name':'珠海','search':'广东-珠海|guangdong-zhuhaishi|gd-zhs','children':[{'idx':'19,4,0','code':'-1','name':'全市','search':'全市|quansheng|qs'},{'idx':'19,4,1','code':'440401','name':'市辖区','search':'广东-珠海-市辖区|guangdong-zhuhai-shixiaqu|gd-zh-sxq'},{'idx':'19,4,2','code':'440402','name':'香洲区','search':'广东-珠海-香洲区|guangdong-zhuhai-xiangzhouqu|gd-zh-xzq'},{'idx':'19,4,3','code':'440403','name':'斗门区','search':'广东-珠海-斗门区|guangdong-zhuhai-doumenqu|gd-zh-dmq'},{'idx':'19,4,4','code':'440404','name':'金湾区','search':'广东-珠海-金湾区|guangdong-zhuhai-jinwanqu|gd-zh-jwq'}]},{'idx':'19,5','code':'440500','name':'汕头','search':'广东-汕头|guangdong-shantoushi|gd-sts','children':[{'idx':'19,5,0','code':'-1','name':'全市','search':'全市|quansheng|qs'},{'idx':'19,5,1','code':'440501','name':'市辖区','search':'广东-汕头-市辖区|guangdong-shantou-shixiaqu|gd-st-sxq'},{'idx':'19,5,2','code':'440507','name':'龙湖区','search':'广东-汕头-龙湖区|guangdong-shantou-longhuqu|gd-st-lhq'},{'idx':'19,5,3','code':'440511','name':'金平区','search':'广东-汕头-金平区|guangdong-shantou-jinpingqu|gd-st-jpq'},{'idx':'19,5,4','code':'440512','name':'濠江区','search':'广东-汕头-濠江区|guangdong-shantou-haojiangqu|gd-st-hjq'},{'idx':'19,5,5','code':'440513','name':'潮阳区','search':'广东-汕头-潮阳区|guangdong-shantou-chaoyangqu|gd-st-cyq'},{'idx':'19,5,6','code':'440514','name':'潮南区','search':'广东-汕头-潮南区|guangdong-shantou-chaonanqu|gd-st-cnq'},{'idx':'19,5,7','code':'440515','name':'澄海区','search':'广东-汕头-澄海区|guangdong-shantou-chenghaiqu|gd-st-chq'},{'idx':'19,5,8','code':'440523','name':'南澳县','search':'广东-汕头-南澳县|guangdong-shantou-nanaoxian|gd-st-nax'}]},{'idx':'19,6','code':'440600','name':'佛山','search':'广东-佛山|guangdong-foshanshi|gd-fss','children':[{'idx':'19,6,0','code':'-1','name':'全市','search':'全市|quansheng|qs'},{'idx':'19,6,1','code':'440601','name':'市辖区','search':'广东-佛山-市辖区|guangdong-foshan-shixiaqu|gd-fs-sxq'},{'idx':'19,6,2','code':'440604','name':'禅城区','search':'广东-佛山-禅城区|guangdong-foshan-chanchengqu|gd-fs-ccq'},{'idx':'19,6,3','code':'440605','name':'南海区','search':'广东-佛山-南海区|guangdong-foshan-nanhaiqu|gd-fs-nhq'},{'idx':'19,6,4','code':'440606','name':'顺德区','search':'广东-佛山-顺德区|guangdong-foshan-shundequ|gd-fs-sdq'},{'idx':'19,6,5','code':'440607','name':'三水区','search':'广东-佛山-三水区|guangdong-foshan-sanshuiqu|gd-fs-ssq'},{'idx':'19,6,6','code':'440608','name':'高明区','search':'广东-佛山-高明区|guangdong-foshan-gaomingqu|gd-fs-gmq'}]},{'idx':'19,7','code':'440700','name':'江门','search':'广东-江门|guangdong-jiangmenshi|gd-jms','children':[{'idx':'19,7,0','code':'-1','name':'全市','search':'全市|quansheng|qs'},{'idx':'19,7,1','code':'440701','name':'市辖区','search':'广东-江门-市辖区|guangdong-jiangmen-shixiaqu|gd-jm-sxq'},{'idx':'19,7,2','code':'440703','name':'蓬江区','search':'广东-江门-蓬江区|guangdong-jiangmen-pengjiangqu|gd-jm-pjq'},{'idx':'19,7,3','code':'440704','name':'江海区','search':'广东-江门-江海区|guangdong-jiangmen-jianghaiqu|gd-jm-jhq'},{'idx':'19,7,4','code':'440705','name':'新会区','search':'广东-江门-新会区|guangdong-jiangmen-xinhuiqu|gd-jm-xhq'},{'idx':'19,7,5','code':'440781','name':'台山市','search':'广东-江门-台山市|guangdong-jiangmen-taishanshi|gd-jm-tss'},{'idx':'19,7,6','code':'440783','name':'开平市','search':'广东-江门-开平市|guangdong-jiangmen-kaipingshi|gd-jm-kps'},{'idx':'19,7,7','code':'440784','name':'鹤山市','search':'广东-江门-鹤山市|guangdong-jiangmen-heshanshi|gd-jm-hss'},{'idx':'19,7,8','code':'440785','name':'恩平市','search':'广东-江门-恩平市|guangdong-jiangmen-enpingshi|gd-jm-eps'}]},{'idx':'19,8','code':'440800','name':'湛江','search':'广东-湛江|guangdong-zhanjiangshi|gd-zjs','children':[{'idx':'19,8,0','code':'-1','name':'全市','search':'全市|quansheng|qs'},{'idx':'19,8,1','code':'440801','name':'市辖区','search':'广东-湛江-市辖区|guangdong-zhanjiang-shixiaqu|gd-zj-sxq'},{'idx':'19,8,2','code':'440802','name':'赤坎区','search':'广东-湛江-赤坎区|guangdong-zhanjiang-chikanqu|gd-zj-ckq'},{'idx':'19,8,3','code':'440803','name':'霞山区','search':'广东-湛江-霞山区|guangdong-zhanjiang-xiashanqu|gd-zj-xsq'},{'idx':'19,8,4','code':'440804','name':'坡头区','search':'广东-湛江-坡头区|guangdong-zhanjiang-potouqu|gd-zj-ptq'},{'idx':'19,8,5','code':'440811','name':'麻章区','search':'广东-湛江-麻章区|guangdong-zhanjiang-mazhangqu|gd-zj-mzq'},{'idx':'19,8,6','code':'440823','name':'遂溪县','search':'广东-湛江-遂溪县|guangdong-zhanjiang-suixixian|gd-zj-sxx'},{'idx':'19,8,7','code':'440825','name':'徐闻县','search':'广东-湛江-徐闻县|guangdong-zhanjiang-xuwenxian|gd-zj-xwx'},{'idx':'19,8,8','code':'440881','name':'廉江市','search':'广东-湛江-廉江市|guangdong-zhanjiang-lianjiangshi|gd-zj-ljs'},{'idx':'19,8,9','code':'440882','name':'雷州市','search':'广东-湛江-雷州市|guangdong-zhanjiang-leizhoushi|gd-zj-lzs'},{'idx':'19,8,10','code':'440883','name':'吴川市','search':'广东-湛江-吴川市|guangdong-zhanjiang-wuchuanshi|gd-zj-wcs'}]},{'idx':'19,9','code':'440900','name':'茂名','search':'广东-茂名|guangdong-maomingshi|gd-mms','children':[{'idx':'19,9,0','code':'-1','name':'全市','search':'全市|quansheng|qs'},{'idx':'19,9,1','code':'440901','name':'市辖区','search':'广东-茂名-市辖区|guangdong-maoming-shixiaqu|gd-mm-sxq'},{'idx':'19,9,2','code':'440902','name':'茂南区','search':'广东-茂名-茂南区|guangdong-maoming-maonanqu|gd-mm-mnq'},{'idx':'19,9,3','code':'440904','name':'电白区','search':'广东-茂名-电白区|guangdong-maoming-dianbaiqu|gd-mm-dbq'},{'idx':'19,9,4','code':'440981','name':'高州市','search':'广东-茂名-高州市|guangdong-maoming-gaozhoushi|gd-mm-gzs'},{'idx':'19,9,5','code':'440982','name':'化州市','search':'广东-茂名-化州市|guangdong-maoming-huazhoushi|gd-mm-hzs'},{'idx':'19,9,6','code':'440983','name':'信宜市','search':'广东-茂名-信宜市|guangdong-maoming-xinyishi|gd-mm-xys'}]},{'idx':'19,10','code':'441200','name':'肇庆','search':'广东-肇庆|guangdong-zhaoqingshi|gd-zqs','children':[{'idx':'19,10,0','code':'-1','name':'全市','search':'全市|quansheng|qs'},{'idx':'19,10,1','code':'441201','name':'市辖区','search':'广东-肇庆-市辖区|guangdong-zhaoqing-shixiaqu|gd-zq-sxq'},{'idx':'19,10,2','code':'441202','name':'端州区','search':'广东-肇庆-端州区|guangdong-zhaoqing-duanzhouqu|gd-zq-dzq'},{'idx':'19,10,3','code':'441203','name':'鼎湖区','search':'广东-肇庆-鼎湖区|guangdong-zhaoqing-dinghuqu|gd-zq-dhq'},{'idx':'19,10,4','code':'441204','name':'高要区','search':'广东-肇庆-高要区|guangdong-zhaoqing-gaoyaoqu|gd-zq-gyq'},{'idx':'19,10,5','code':'441223','name':'广宁县','search':'广东-肇庆-广宁县|guangdong-zhaoqing-guangningxian|gd-zq-gnx'},{'idx':'19,10,6','code':'441224','name':'怀集县','search':'广东-肇庆-怀集县|guangdong-zhaoqing-huaijixian|gd-zq-hjx'},{'idx':'19,10,7','code':'441225','name':'封开县','search':'广东-肇庆-封开县|guangdong-zhaoqing-fengkaixian|gd-zq-fkx'},{'idx':'19,10,8','code':'441226','name':'德庆县','search':'广东-肇庆-德庆县|guangdong-zhaoqing-deqingxian|gd-zq-dqx'},{'idx':'19,10,9','code':'441284','name':'四会市','search':'广东-肇庆-四会市|guangdong-zhaoqing-sihuishi|gd-zq-shs'}]},{'idx':'19,11','code':'441300','name':'惠州','search':'广东-惠州|guangdong-huizhoushi|gd-hzs','children':[{'idx':'19,11,0','code':'-1','name':'全市','search':'全市|quansheng|qs'},{'idx':'19,11,1','code':'441301','name':'市辖区','search':'广东-惠州-市辖区|guangdong-huizhou-shixiaqu|gd-hz-sxq'},{'idx':'19,11,2','code':'441302','name':'惠城区','search':'广东-惠州-惠城区|guangdong-huizhou-huichengqu|gd-hz-hcq'},{'idx':'19,11,3','code':'441303','name':'惠阳区','search':'广东-惠州-惠阳区|guangdong-huizhou-huiyangqu|gd-hz-hyq'},{'idx':'19,11,4','code':'441322','name':'博罗县','search':'广东-惠州-博罗县|guangdong-huizhou-boluoxian|gd-hz-blx'},{'idx':'19,11,5','code':'441323','name':'惠东县','search':'广东-惠州-惠东县|guangdong-huizhou-huidongxian|gd-hz-hdx'},{'idx':'19,11,6','code':'441324','name':'龙门县','search':'广东-惠州-龙门县|guangdong-huizhou-longmenxian|gd-hz-lmx'}]},{'idx':'19,12','code':'441400','name':'梅州','search':'广东-梅州|guangdong-meizhoushi|gd-mzs','children':[{'idx':'19,12,0','code':'-1','name':'全市','search':'全市|quansheng|qs'},{'idx':'19,12,1','code':'441401','name':'市辖区','search':'广东-梅州-市辖区|guangdong-meizhou-shixiaqu|gd-mz-sxq'},{'idx':'19,12,2','code':'441402','name':'梅江区','search':'广东-梅州-梅江区|guangdong-meizhou-meijiangqu|gd-mz-mjq'},{'idx':'19,12,3','code':'441403','name':'梅县区','search':'广东-梅州-梅县区|guangdong-meizhou-meixianqu|gd-mz-mxq'},{'idx':'19,12,4','code':'441422','name':'大埔县','search':'广东-梅州-大埔县|guangdong-meizhou-dapuxian|gd-mz-dpx'},{'idx':'19,12,5','code':'441423','name':'丰顺县','search':'广东-梅州-丰顺县|guangdong-meizhou-fengshunxian|gd-mz-fsx'},{'idx':'19,12,6','code':'441424','name':'五华县','search':'广东-梅州-五华县|guangdong-meizhou-wuhuaxian|gd-mz-whx'},{'idx':'19,12,7','code':'441426','name':'平远县','search':'广东-梅州-平远县|guangdong-meizhou-pingyuanxian|gd-mz-pyx'},{'idx':'19,12,8','code':'441427','name':'蕉岭县','search':'广东-梅州-蕉岭县|guangdong-meizhou-jiaolingxian|gd-mz-jlx'},{'idx':'19,12,9','code':'441481','name':'兴宁市','search':'广东-梅州-兴宁市|guangdong-meizhou-xingningshi|gd-mz-xns'}]},{'idx':'19,13','code':'441500','name':'汕尾','search':'广东-汕尾|guangdong-shanweishi|gd-sws','children':[{'idx':'19,13,0','code':'-1','name':'全市','search':'全市|quansheng|qs'},{'idx':'19,13,1','code':'441501','name':'市辖区','search':'广东-汕尾-市辖区|guangdong-shanwei-shixiaqu|gd-sw-sxq'},{'idx':'19,13,2','code':'441502','name':'城区','search':'广东-汕尾-城区|guangdong-shanwei-chengqu|gd-sw-cq'},{'idx':'19,13,3','code':'441521','name':'海丰县','search':'广东-汕尾-海丰县|guangdong-shanwei-haifengxian|gd-sw-hfx'},{'idx':'19,13,4','code':'441523','name':'陆河县','search':'广东-汕尾-陆河县|guangdong-shanwei-luhexian|gd-sw-lhx'},{'idx':'19,13,5','code':'441581','name':'陆丰市','search':'广东-汕尾-陆丰市|guangdong-shanwei-lufengshi|gd-sw-lfs'}]},{'idx':'19,14','code':'441600','name':'河源','search':'广东-河源|guangdong-heyuanshi|gd-hys','children':[{'idx':'19,14,0','code':'-1','name':'全市','search':'全市|quansheng|qs'},{'idx':'19,14,1','code':'441601','name':'市辖区','search':'广东-河源-市辖区|guangdong-heyuan-shixiaqu|gd-hy-sxq'},{'idx':'19,14,2','code':'441602','name':'源城区','search':'广东-河源-源城区|guangdong-heyuan-yuanchengqu|gd-hy-ycq'},{'idx':'19,14,3','code':'441621','name':'紫金县','search':'广东-河源-紫金县|guangdong-heyuan-zijinxian|gd-hy-zjx'},{'idx':'19,14,4','code':'441622','name':'龙川县','search':'广东-河源-龙川县|guangdong-heyuan-longchuanxian|gd-hy-lcx'},{'idx':'19,14,5','code':'441623','name':'连平县','search':'广东-河源-连平县|guangdong-heyuan-lianpingxian|gd-hy-lpx'},{'idx':'19,14,6','code':'441624','name':'和平县','search':'广东-河源-和平县|guangdong-heyuan-hepingxian|gd-hy-hpx'},{'idx':'19,14,7','code':'441625','name':'东源县','search':'广东-河源-东源县|guangdong-heyuan-dongyuanxian|gd-hy-dyx'}]},{'idx':'19,15','code':'441700','name':'阳江','search':'广东-阳江|guangdong-yangjiangshi|gd-yjs','children':[{'idx':'19,15,0','code':'-1','name':'全市','search':'全市|quansheng|qs'},{'idx':'19,15,1','code':'441701','name':'市辖区','search':'广东-阳江-市辖区|guangdong-yangjiang-shixiaqu|gd-yj-sxq'},{'idx':'19,15,2','code':'441702','name':'江城区','search':'广东-阳江-江城区|guangdong-yangjiang-jiangchengqu|gd-yj-jcq'},{'idx':'19,15,3','code':'441704','name':'阳东区','search':'广东-阳江-阳东区|guangdong-yangjiang-yangdongqu|gd-yj-ydq'},{'idx':'19,15,4','code':'441721','name':'阳西县','search':'广东-阳江-阳西县|guangdong-yangjiang-yangxixian|gd-yj-yxx'},{'idx':'19,15,5','code':'441781','name':'阳春市','search':'广东-阳江-阳春市|guangdong-yangjiang-yangchunshi|gd-yj-ycs'}]},{'idx':'19,16','code':'441800','name':'清远','search':'广东-清远|guangdong-qingyuanshi|gd-qys','children':[{'idx':'19,16,0','code':'-1','name':'全市','search':'全市|quansheng|qs'},{'idx':'19,16,1','code':'441801','name':'市辖区','search':'广东-清远-市辖区|guangdong-qingyuan-shixiaqu|gd-qy-sxq'},{'idx':'19,16,2','code':'441802','name':'清城区','search':'广东-清远-清城区|guangdong-qingyuan-qingchengqu|gd-qy-qcq'},{'idx':'19,16,3','code':'441803','name':'清新区','search':'广东-清远-清新区|guangdong-qingyuan-qingxinqu|gd-qy-qxq'},{'idx':'19,16,4','code':'441821','name':'佛冈县','search':'广东-清远-佛冈县|guangdong-qingyuan-fogangxian|gd-qy-fgx'},{'idx':'19,16,5','code':'441823','name':'阳山县','search':'广东-清远-阳山县|guangdong-qingyuan-yangshanxian|gd-qy-ysx'},{'idx':'19,16,6','code':'441825','name':'连山壮族瑶族自治县','search':'广东-清远-连山壮族瑶族自治县|guangdong-qingyuan-lianshanzhuangzuyaozuzizhixian|gd-qy-lszzyzzzx'},{'idx':'19,16,7','code':'441826','name':'连南瑶族自治县','search':'广东-清远-连南瑶族自治县|guangdong-qingyuan-liannanyaozuzizhixian|gd-qy-lnyzzzx'},{'idx':'19,16,8','code':'441881','name':'英德市','search':'广东-清远-英德市|guangdong-qingyuan-yingdeshi|gd-qy-yds'},{'idx':'19,16,9','code':'441882','name':'连州市','search':'广东-清远-连州市|guangdong-qingyuan-lianzhoushi|gd-qy-lzs'}]},{'idx':'19,17','code':'441900','name':'东莞','search':'广东-东莞|guangdong-dongguanshi|gd-dgs','children':[{'idx':'19,17,0','code':'-1','name':'全市','search':'全市|quansheng|qs'}]},{'idx':'19,18','code':'442000','name':'中山','search':'广东-中山|guangdong-zhongshanshi|gd-zss','children':[{'idx':'19,18,0','code':'-1','name':'全市','search':'全市|quansheng|qs'}]},{'idx':'19,19','code':'445100','name':'潮州','search':'广东-潮州|guangdong-chaozhoushi|gd-czs','children':[{'idx':'19,19,0','code':'-1','name':'全市','search':'全市|quansheng|qs'},{'idx':'19,19,1','code':'445101','name':'市辖区','search':'广东-潮州-市辖区|guangdong-chaozhou-shixiaqu|gd-cz-sxq'},{'idx':'19,19,2','code':'445102','name':'湘桥区','search':'广东-潮州-湘桥区|guangdong-chaozhou-xiangqiaoqu|gd-cz-xqq'},{'idx':'19,19,3','code':'445103','name':'潮安区','search':'广东-潮州-潮安区|guangdong-chaozhou-chaoanqu|gd-cz-caq'},{'idx':'19,19,4','code':'445122','name':'饶平县','search':'广东-潮州-饶平县|guangdong-chaozhou-raopingxian|gd-cz-rpx'}]},{'idx':'19,20','code':'445200','name':'揭阳','search':'广东-揭阳|guangdong-jieyangshi|gd-jys','children':[{'idx':'19,20,0','code':'-1','name':'全市','search':'全市|quansheng|qs'},{'idx':'19,20,1','code':'445201','name':'市辖区','search':'广东-揭阳-市辖区|guangdong-jieyang-shixiaqu|gd-jy-sxq'},{'idx':'19,20,2','code':'445202','name':'榕城区','search':'广东-揭阳-榕城区|guangdong-jieyang-rongchengqu|gd-jy-rcq'},{'idx':'19,20,3','code':'445203','name':'揭东区','search':'广东-揭阳-揭东区|guangdong-jieyang-jiedongqu|gd-jy-jdq'},{'idx':'19,20,4','code':'445222','name':'揭西县','search':'广东-揭阳-揭西县|guangdong-jieyang-jiexixian|gd-jy-jxx'},{'idx':'19,20,5','code':'445224','name':'惠来县','search':'广东-揭阳-惠来县|guangdong-jieyang-huilaixian|gd-jy-hlx'},{'idx':'19,20,6','code':'445281','name':'普宁市','search':'广东-揭阳-普宁市|guangdong-jieyang-puningshi|gd-jy-pns'}]},{'idx':'19,21','code':'445300','name':'云浮','search':'广东-云浮|guangdong-yunfushi|gd-yfs','children':[{'idx':'19,21,0','code':'-1','name':'全市','search':'全市|quansheng|qs'},{'idx':'19,21,1','code':'445301','name':'市辖区','search':'广东-云浮-市辖区|guangdong-yunfu-shixiaqu|gd-yf-sxq'},{'idx':'19,21,2','code':'445302','name':'云城区','search':'广东-云浮-云城区|guangdong-yunfu-yunchengqu|gd-yf-ycq'},{'idx':'19,21,3','code':'445303','name':'云安区','search':'广东-云浮-云安区|guangdong-yunfu-yunanqu|gd-yf-yaq'},{'idx':'19,21,4','code':'445321','name':'新兴县','search':'广东-云浮-新兴县|guangdong-yunfu-xinxingxian|gd-yf-xxx'},{'idx':'19,21,5','code':'445322','name':'郁南县','search':'广东-云浮-郁南县|guangdong-yunfu-yunanxian|gd-yf-ynx'},{'idx':'19,21,6','code':'445381','name':'罗定市','search':'广东-云浮-罗定市|guangdong-yunfu-luodingshi|gd-yf-lds'}]}]},{'idx':20,'code':'450000','name':'广西','search':'广西|guangxizhuangzuzizhiqu|gxzzzzq','children':[{'idx':'20,0','code':'-1','name':'全省','search':'全省|quansheng|qs'},{'idx':'20,1','code':'450100','name':'南宁','search':'广西-南宁|guangxi-nanningshi|gx-nns','children':[{'idx':'20,1,0','code':'-1','name':'全市','search':'全市|quansheng|qs'},{'idx':'20,1,1','code':'450101','name':'市辖区','search':'广西-南宁-市辖区|guangxi-nanning-shixiaqu|gx-nn-sxq'},{'idx':'20,1,2','code':'450102','name':'兴宁区','search':'广西-南宁-兴宁区|guangxi-nanning-xingningqu|gx-nn-xnq'},{'idx':'20,1,3','code':'450103','name':'青秀区','search':'广西-南宁-青秀区|guangxi-nanning-qingxiuqu|gx-nn-qxq'},{'idx':'20,1,4','code':'450105','name':'江南区','search':'广西-南宁-江南区|guangxi-nanning-jiangnanqu|gx-nn-jnq'},{'idx':'20,1,5','code':'450107','name':'西乡塘区','search':'广西-南宁-西乡塘区|guangxi-nanning-xixiangtangqu|gx-nn-xxtq'},{'idx':'20,1,6','code':'450108','name':'良庆区','search':'广西-南宁-良庆区|guangxi-nanning-liangqingqu|gx-nn-lqq'},{'idx':'20,1,7','code':'450109','name':'邕宁区','search':'广西-南宁-邕宁区|guangxi-nanning-yongningqu|gx-nn-ynq'},{'idx':'20,1,8','code':'450110','name':'武鸣区','search':'广西-南宁-武鸣区|guangxi-nanning-wumingqu|gx-nn-wmq'},{'idx':'20,1,9','code':'450123','name':'隆安县','search':'广西-南宁-隆安县|guangxi-nanning-longanxian|gx-nn-lax'},{'idx':'20,1,10','code':'450124','name':'马山县','search':'广西-南宁-马山县|guangxi-nanning-mashanxian|gx-nn-msx'},{'idx':'20,1,11','code':'450125','name':'上林县','search':'广西-南宁-上林县|guangxi-nanning-shanglinxian|gx-nn-slx'},{'idx':'20,1,12','code':'450126','name':'宾阳县','search':'广西-南宁-宾阳县|guangxi-nanning-binyangxian|gx-nn-byx'},{'idx':'20,1,13','code':'450127','name':'横县','search':'广西-南宁-横县|guangxi-nanning-hengxian|gx-nn-hx'}]},{'idx':'20,2','code':'450200','name':'柳州','search':'广西-柳州|guangxi-liuzhoushi|gx-lzs','children':[{'idx':'20,2,0','code':'-1','name':'全市','search':'全市|quansheng|qs'},{'idx':'20,2,1','code':'450201','name':'市辖区','search':'广西-柳州-市辖区|guangxi-liuzhou-shixiaqu|gx-lz-sxq'},{'idx':'20,2,2','code':'450202','name':'城中区','search':'广西-柳州-城中区|guangxi-liuzhou-chengzhongqu|gx-lz-czq'},{'idx':'20,2,3','code':'450203','name':'鱼峰区','search':'广西-柳州-鱼峰区|guangxi-liuzhou-yufengqu|gx-lz-yfq'},{'idx':'20,2,4','code':'450204','name':'柳南区','search':'广西-柳州-柳南区|guangxi-liuzhou-liunanqu|gx-lz-lnq'},{'idx':'20,2,5','code':'450205','name':'柳北区','search':'广西-柳州-柳北区|guangxi-liuzhou-liubeiqu|gx-lz-lbq'},{'idx':'20,2,6','code':'450221','name':'柳江县','search':'广西-柳州-柳江县|guangxi-liuzhou-liujiangxian|gx-lz-ljx'},{'idx':'20,2,7','code':'450222','name':'柳城县','search':'广西-柳州-柳城县|guangxi-liuzhou-liuchengxian|gx-lz-lcx'},{'idx':'20,2,8','code':'450223','name':'鹿寨县','search':'广西-柳州-鹿寨县|guangxi-liuzhou-luzhaixian|gx-lz-lzx'},{'idx':'20,2,9','code':'450224','name':'融安县','search':'广西-柳州-融安县|guangxi-liuzhou-ronganxian|gx-lz-rax'},{'idx':'20,2,10','code':'450225','name':'融水苗族自治县','search':'广西-柳州-融水苗族自治县|guangxi-liuzhou-rongshuimiaozuzizhixian|gx-lz-rsmzzzx'},{'idx':'20,2,11','code':'450226','name':'三江侗族自治县','search':'广西-柳州-三江侗族自治县|guangxi-liuzhou-sanjiangdongzuzizhixian|gx-lz-sjdzzzx'}]},{'idx':'20,3','code':'450300','name':'桂林','search':'广西-桂林|guangxi-guilinshi|gx-gls','children':[{'idx':'20,3,0','code':'-1','name':'全市','search':'全市|quansheng|qs'},{'idx':'20,3,1','code':'450301','name':'市辖区','search':'广西-桂林-市辖区|guangxi-guilin-shixiaqu|gx-gl-sxq'},{'idx':'20,3,2','code':'450302','name':'秀峰区','search':'广西-桂林-秀峰区|guangxi-guilin-xiufengqu|gx-gl-xfq'},{'idx':'20,3,3','code':'450303','name':'叠彩区','search':'广西-桂林-叠彩区|guangxi-guilin-diecaiqu|gx-gl-dcq'},{'idx':'20,3,4','code':'450304','name':'象山区','search':'广西-桂林-象山区|guangxi-guilin-xiangshanqu|gx-gl-xsq'},{'idx':'20,3,5','code':'450305','name':'七星区','search':'广西-桂林-七星区|guangxi-guilin-qixingqu|gx-gl-qxq'},{'idx':'20,3,6','code':'450311','name':'雁山区','search':'广西-桂林-雁山区|guangxi-guilin-yanshanqu|gx-gl-ysq'},{'idx':'20,3,7','code':'450312','name':'临桂区','search':'广西-桂林-临桂区|guangxi-guilin-linguiqu|gx-gl-lgq'},{'idx':'20,3,8','code':'450321','name':'阳朔县','search':'广西-桂林-阳朔县|guangxi-guilin-yangshuoxian|gx-gl-ysx'},{'idx':'20,3,9','code':'450323','name':'灵川县','search':'广西-桂林-灵川县|guangxi-guilin-lingchuanxian|gx-gl-lcx'},{'idx':'20,3,10','code':'450324','name':'全州县','search':'广西-桂林-全州县|guangxi-guilin-quanzhouxian|gx-gl-qzx'},{'idx':'20,3,11','code':'450325','name':'兴安县','search':'广西-桂林-兴安县|guangxi-guilin-xinganxian|gx-gl-xax'},{'idx':'20,3,12','code':'450326','name':'永福县','search':'广西-桂林-永福县|guangxi-guilin-yongfuxian|gx-gl-yfx'},{'idx':'20,3,13','code':'450327','name':'灌阳县','search':'广西-桂林-灌阳县|guangxi-guilin-guanyangxian|gx-gl-gyx'},{'idx':'20,3,14','code':'450328','name':'龙胜各族自治县','search':'广西-桂林-龙胜各族自治县|guangxi-guilin-longshenggezuzizhixian|gx-gl-lsgzzzx'},{'idx':'20,3,15','code':'450329','name':'资源县','search':'广西-桂林-资源县|guangxi-guilin-ziyuanxian|gx-gl-zyx'},{'idx':'20,3,16','code':'450330','name':'平乐县','search':'广西-桂林-平乐县|guangxi-guilin-pinglexian|gx-gl-plx'},{'idx':'20,3,17','code':'450331','name':'荔浦县','search':'广西-桂林-荔浦县|guangxi-guilin-lipuxian|gx-gl-lpx'},{'idx':'20,3,18','code':'450332','name':'恭城瑶族自治县','search':'广西-桂林-恭城瑶族自治县|guangxi-guilin-gongchengyaozuzizhixian|gx-gl-gcyzzzx'}]},{'idx':'20,4','code':'450400','name':'梧州','search':'广西-梧州|guangxi-wuzhoushi|gx-wzs','children':[{'idx':'20,4,0','code':'-1','name':'全市','search':'全市|quansheng|qs'},{'idx':'20,4,1','code':'450401','name':'市辖区','search':'广西-梧州-市辖区|guangxi-wuzhou-shixiaqu|gx-wz-sxq'},{'idx':'20,4,2','code':'450403','name':'万秀区','search':'广西-梧州-万秀区|guangxi-wuzhou-wanxiuqu|gx-wz-wxq'},{'idx':'20,4,3','code':'450405','name':'长洲区','search':'广西-梧州-长洲区|guangxi-wuzhou-changzhouqu|gx-wz-czq'},{'idx':'20,4,4','code':'450406','name':'龙圩区','search':'广西-梧州-龙圩区|guangxi-wuzhou-longweiqu|gx-wz-lwq'},{'idx':'20,4,5','code':'450421','name':'苍梧县','search':'广西-梧州-苍梧县|guangxi-wuzhou-cangwuxian|gx-wz-cwx'},{'idx':'20,4,6','code':'450422','name':'藤县','search':'广西-梧州-藤县|guangxi-wuzhou-tengxian|gx-wz-tx'},{'idx':'20,4,7','code':'450423','name':'蒙山县','search':'广西-梧州-蒙山县|guangxi-wuzhou-mengshanxian|gx-wz-msx'},{'idx':'20,4,8','code':'450481','name':'岑溪市','search':'广西-梧州-岑溪市|guangxi-wuzhou-cenxishi|gx-wz-cxs'}]},{'idx':'20,5','code':'450500','name':'北海','search':'广西-北海|guangxi-beihaishi|gx-bhs','children':[{'idx':'20,5,0','code':'-1','name':'全市','search':'全市|quansheng|qs'},{'idx':'20,5,1','code':'450501','name':'市辖区','search':'广西-北海-市辖区|guangxi-beihai-shixiaqu|gx-bh-sxq'},{'idx':'20,5,2','code':'450502','name':'海城区','search':'广西-北海-海城区|guangxi-beihai-haichengqu|gx-bh-hcq'},{'idx':'20,5,3','code':'450503','name':'银海区','search':'广西-北海-银海区|guangxi-beihai-yinhaiqu|gx-bh-yhq'},{'idx':'20,5,4','code':'450512','name':'铁山港区','search':'广西-北海-铁山港区|guangxi-beihai-tieshangangqu|gx-bh-tsgq'},{'idx':'20,5,5','code':'450521','name':'合浦县','search':'广西-北海-合浦县|guangxi-beihai-hepuxian|gx-bh-hpx'}]},{'idx':'20,6','code':'450600','name':'防城港','search':'广西-防城港|guangxi-fangchenggangshi|gx-fcgs','children':[{'idx':'20,6,0','code':'-1','name':'全市','search':'全市|quansheng|qs'},{'idx':'20,6,1','code':'450601','name':'市辖区','search':'广西-防城港-市辖区|guangxi-fangchenggang-shixiaqu|gx-fcg-sxq'},{'idx':'20,6,2','code':'450602','name':'港口区','search':'广西-防城港-港口区|guangxi-fangchenggang-gangkouqu|gx-fcg-gkq'},{'idx':'20,6,3','code':'450603','name':'防城区','search':'广西-防城港-防城区|guangxi-fangchenggang-fangchengqu|gx-fcg-fcq'},{'idx':'20,6,4','code':'450621','name':'上思县','search':'广西-防城港-上思县|guangxi-fangchenggang-shangsixian|gx-fcg-ssx'},{'idx':'20,6,5','code':'450681','name':'东兴市','search':'广西-防城港-东兴市|guangxi-fangchenggang-dongxingshi|gx-fcg-dxs'}]},{'idx':'20,7','code':'450700','name':'钦州','search':'广西-钦州|guangxi-qinzhoushi|gx-qzs','children':[{'idx':'20,7,0','code':'-1','name':'全市','search':'全市|quansheng|qs'},{'idx':'20,7,1','code':'450701','name':'市辖区','search':'广西-钦州-市辖区|guangxi-qinzhou-shixiaqu|gx-qz-sxq'},{'idx':'20,7,2','code':'450702','name':'钦南区','search':'广西-钦州-钦南区|guangxi-qinzhou-qinnanqu|gx-qz-qnq'},{'idx':'20,7,3','code':'450703','name':'钦北区','search':'广西-钦州-钦北区|guangxi-qinzhou-qinbeiqu|gx-qz-qbq'},{'idx':'20,7,4','code':'450721','name':'灵山县','search':'广西-钦州-灵山县|guangxi-qinzhou-lingshanxian|gx-qz-lsx'},{'idx':'20,7,5','code':'450722','name':'浦北县','search':'广西-钦州-浦北县|guangxi-qinzhou-pubeixian|gx-qz-pbx'}]},{'idx':'20,8','code':'450800','name':'贵港','search':'广西-贵港|guangxi-guigangshi|gx-ggs','children':[{'idx':'20,8,0','code':'-1','name':'全市','search':'全市|quansheng|qs'},{'idx':'20,8,1','code':'450801','name':'市辖区','search':'广西-贵港-市辖区|guangxi-guigang-shixiaqu|gx-gg-sxq'},{'idx':'20,8,2','code':'450802','name':'港北区','search':'广西-贵港-港北区|guangxi-guigang-gangbeiqu|gx-gg-gbq'},{'idx':'20,8,3','code':'450803','name':'港南区','search':'广西-贵港-港南区|guangxi-guigang-gangnanqu|gx-gg-gnq'},{'idx':'20,8,4','code':'450804','name':'覃塘区','search':'广西-贵港-覃塘区|guangxi-guigang-qintangqu|gx-gg-qtq'},{'idx':'20,8,5','code':'450821','name':'平南县','search':'广西-贵港-平南县|guangxi-guigang-pingnanxian|gx-gg-pnx'},{'idx':'20,8,6','code':'450881','name':'桂平市','search':'广西-贵港-桂平市|guangxi-guigang-guipingshi|gx-gg-gps'}]},{'idx':'20,9','code':'450900','name':'玉林','search':'广西-玉林|guangxi-yulinshi|gx-yls','children':[{'idx':'20,9,0','code':'-1','name':'全市','search':'全市|quansheng|qs'},{'idx':'20,9,1','code':'450901','name':'市辖区','search':'广西-玉林-市辖区|guangxi-yulin-shixiaqu|gx-yl-sxq'},{'idx':'20,9,2','code':'450902','name':'玉州区','search':'广西-玉林-玉州区|guangxi-yulin-yuzhouqu|gx-yl-yzq'},{'idx':'20,9,3','code':'450903','name':'福绵区','search':'广西-玉林-福绵区|guangxi-yulin-fumianqu|gx-yl-fmq'},{'idx':'20,9,4','code':'450921','name':'容县','search':'广西-玉林-容县|guangxi-yulin-rongxian|gx-yl-rx'},{'idx':'20,9,5','code':'450922','name':'陆川县','search':'广西-玉林-陆川县|guangxi-yulin-luchuanxian|gx-yl-lcx'},{'idx':'20,9,6','code':'450923','name':'博白县','search':'广西-玉林-博白县|guangxi-yulin-bobaixian|gx-yl-bbx'},{'idx':'20,9,7','code':'450924','name':'兴业县','search':'广西-玉林-兴业县|guangxi-yulin-xingyexian|gx-yl-xyx'},{'idx':'20,9,8','code':'450981','name':'北流市','search':'广西-玉林-北流市|guangxi-yulin-beiliushi|gx-yl-bls'}]},{'idx':'20,10','code':'451000','name':'百色','search':'广西-百色|guangxi-baiseshi|gx-bss','children':[{'idx':'20,10,0','code':'-1','name':'全市','search':'全市|quansheng|qs'},{'idx':'20,10,1','code':'451001','name':'市辖区','search':'广西-百色-市辖区|guangxi-baise-shixiaqu|gx-bs-sxq'},{'idx':'20,10,2','code':'451002','name':'右江区','search':'广西-百色-右江区|guangxi-baise-youjiangqu|gx-bs-yjq'},{'idx':'20,10,3','code':'451021','name':'田阳县','search':'广西-百色-田阳县|guangxi-baise-tianyangxian|gx-bs-tyx'},{'idx':'20,10,4','code':'451022','name':'田东县','search':'广西-百色-田东县|guangxi-baise-tiandongxian|gx-bs-tdx'},{'idx':'20,10,5','code':'451023','name':'平果县','search':'广西-百色-平果县|guangxi-baise-pingguoxian|gx-bs-pgx'},{'idx':'20,10,6','code':'451024','name':'德保县','search':'广西-百色-德保县|guangxi-baise-debaoxian|gx-bs-dbx'},{'idx':'20,10,7','code':'451026','name':'那坡县','search':'广西-百色-那坡县|guangxi-baise-napoxian|gx-bs-npx'},{'idx':'20,10,8','code':'451027','name':'凌云县','search':'广西-百色-凌云县|guangxi-baise-lingyunxian|gx-bs-lyx'},{'idx':'20,10,9','code':'451028','name':'乐业县','search':'广西-百色-乐业县|guangxi-baise-leyexian|gx-bs-lyx'},{'idx':'20,10,10','code':'451029','name':'田林县','search':'广西-百色-田林县|guangxi-baise-tianlinxian|gx-bs-tlx'},{'idx':'20,10,11','code':'451030','name':'西林县','search':'广西-百色-西林县|guangxi-baise-xilinxian|gx-bs-xlx'},{'idx':'20,10,12','code':'451031','name':'隆林各族自治县','search':'广西-百色-隆林各族自治县|guangxi-baise-longlingezuzizhixian|gx-bs-llgzzzx'},{'idx':'20,10,13','code':'451081','name':'靖西市','search':'广西-百色-靖西市|guangxi-baise-jingxishi|gx-bs-jxs'}]},{'idx':'20,11','code':'451100','name':'贺州','search':'广西-贺州|guangxi-hezhoushi|gx-hzs','children':[{'idx':'20,11,0','code':'-1','name':'全市','search':'全市|quansheng|qs'},{'idx':'20,11,1','code':'451101','name':'市辖区','search':'广西-贺州-市辖区|guangxi-hezhou-shixiaqu|gx-hz-sxq'},{'idx':'20,11,2','code':'451102','name':'八步区','search':'广西-贺州-八步区|guangxi-hezhou-babuqu|gx-hz-bbq'},{'idx':'20,11,3','code':'451121','name':'昭平县','search':'广西-贺州-昭平县|guangxi-hezhou-zhaopingxian|gx-hz-zpx'},{'idx':'20,11,4','code':'451122','name':'钟山县','search':'广西-贺州-钟山县|guangxi-hezhou-zhongshanxian|gx-hz-zsx'},{'idx':'20,11,5','code':'451123','name':'富川瑶族自治县','search':'广西-贺州-富川瑶族自治县|guangxi-hezhou-fuchuanyaozuzizhixian|gx-hz-fcyzzzx'}]},{'idx':'20,12','code':'451200','name':'河池','search':'广西-河池|guangxi-hechishi|gx-hcs','children':[{'idx':'20,12,0','code':'-1','name':'全市','search':'全市|quansheng|qs'},{'idx':'20,12,1','code':'451201','name':'市辖区','search':'广西-河池-市辖区|guangxi-hechi-shixiaqu|gx-hc-sxq'},{'idx':'20,12,2','code':'451202','name':'金城江区','search':'广西-河池-金城江区|guangxi-hechi-jinchengjiangqu|gx-hc-jcjq'},{'idx':'20,12,3','code':'451221','name':'南丹县','search':'广西-河池-南丹县|guangxi-hechi-nandanxian|gx-hc-ndx'},{'idx':'20,12,4','code':'451222','name':'天峨县','search':'广西-河池-天峨县|guangxi-hechi-tianexian|gx-hc-tex'},{'idx':'20,12,5','code':'451223','name':'凤山县','search':'广西-河池-凤山县|guangxi-hechi-fengshanxian|gx-hc-fsx'},{'idx':'20,12,6','code':'451224','name':'东兰县','search':'广西-河池-东兰县|guangxi-hechi-donglanxian|gx-hc-dlx'},{'idx':'20,12,7','code':'451225','name':'罗城仫佬族自治县','search':'广西-河池-罗城仫佬族自治县|guangxi-hechi-luochengmulaozuzizhixian|gx-hc-lcmlzzzx'},{'idx':'20,12,8','code':'451226','name':'环江毛南族自治县','search':'广西-河池-环江毛南族自治县|guangxi-hechi-huanjiangmaonanzuzizhixian|gx-hc-hjmnzzzx'},{'idx':'20,12,9','code':'451227','name':'巴马瑶族自治县','search':'广西-河池-巴马瑶族自治县|guangxi-hechi-bamayaozuzizhixian|gx-hc-bmyzzzx'},{'idx':'20,12,10','code':'451228','name':'都安瑶族自治县','search':'广西-河池-都安瑶族自治县|guangxi-hechi-duanyaozuzizhixian|gx-hc-dayzzzx'},{'idx':'20,12,11','code':'451229','name':'大化瑶族自治县','search':'广西-河池-大化瑶族自治县|guangxi-hechi-dahuayaozuzizhixian|gx-hc-dhyzzzx'},{'idx':'20,12,12','code':'451281','name':'宜州市','search':'广西-河池-宜州市|guangxi-hechi-yizhoushi|gx-hc-yzs'}]},{'idx':'20,13','code':'451300','name':'来宾','search':'广西-来宾|guangxi-laibinshi|gx-lbs','children':[{'idx':'20,13,0','code':'-1','name':'全市','search':'全市|quansheng|qs'},{'idx':'20,13,1','code':'451301','name':'市辖区','search':'广西-来宾-市辖区|guangxi-laibin-shixiaqu|gx-lb-sxq'},{'idx':'20,13,2','code':'451302','name':'兴宾区','search':'广西-来宾-兴宾区|guangxi-laibin-xingbinqu|gx-lb-xbq'},{'idx':'20,13,3','code':'451321','name':'忻城县','search':'广西-来宾-忻城县|guangxi-laibin-xinchengxian|gx-lb-xcx'},{'idx':'20,13,4','code':'451322','name':'象州县','search':'广西-来宾-象州县|guangxi-laibin-xiangzhouxian|gx-lb-xzx'},{'idx':'20,13,5','code':'451323','name':'武宣县','search':'广西-来宾-武宣县|guangxi-laibin-wuxuanxian|gx-lb-wxx'},{'idx':'20,13,6','code':'451324','name':'金秀瑶族自治县','search':'广西-来宾-金秀瑶族自治县|guangxi-laibin-jinxiuyaozuzizhixian|gx-lb-jxyzzzx'},{'idx':'20,13,7','code':'451381','name':'合山市','search':'广西-来宾-合山市|guangxi-laibin-heshanshi|gx-lb-hss'}]},{'idx':'20,14','code':'451400','name':'崇左','search':'广西-崇左|guangxi-chongzuoshi|gx-czs','children':[{'idx':'20,14,0','code':'-1','name':'全市','search':'全市|quansheng|qs'},{'idx':'20,14,1','code':'451401','name':'市辖区','search':'广西-崇左-市辖区|guangxi-chongzuo-shixiaqu|gx-cz-sxq'},{'idx':'20,14,2','code':'451402','name':'江州区','search':'广西-崇左-江州区|guangxi-chongzuo-jiangzhouqu|gx-cz-jzq'},{'idx':'20,14,3','code':'451421','name':'扶绥县','search':'广西-崇左-扶绥县|guangxi-chongzuo-fusuixian|gx-cz-fsx'},{'idx':'20,14,4','code':'451422','name':'宁明县','search':'广西-崇左-宁明县|guangxi-chongzuo-ningmingxian|gx-cz-nmx'},{'idx':'20,14,5','code':'451423','name':'龙州县','search':'广西-崇左-龙州县|guangxi-chongzuo-longzhouxian|gx-cz-lzx'},{'idx':'20,14,6','code':'451424','name':'大新县','search':'广西-崇左-大新县|guangxi-chongzuo-daxinxian|gx-cz-dxx'},{'idx':'20,14,7','code':'451425','name':'天等县','search':'广西-崇左-天等县|guangxi-chongzuo-tiandengxian|gx-cz-tdx'},{'idx':'20,14,8','code':'451481','name':'凭祥市','search':'广西-崇左-凭祥市|guangxi-chongzuo-pingxiangshi|gx-cz-pxs'}]}]},{'idx':21,'code':'460000','name':'海南','search':'海南|hainansheng|hns','children':[{'idx':'21,0','code':'-1','name':'全省','search':'全省|quansheng|qs'},{'idx':'21,1','code':'460100','name':'海口','search':'海南-海口|hainan-haikoushi|hn-hks','children':[{'idx':'21,1,0','code':'-1','name':'全市','search':'全市|quansheng|qs'},{'idx':'21,1,1','code':'460101','name':'市辖区','search':'海南-海口-市辖区|hainan-haikou-shixiaqu|hn-hk-sxq'},{'idx':'21,1,2','code':'460105','name':'秀英区','search':'海南-海口-秀英区|hainan-haikou-xiuyingqu|hn-hk-xyq'},{'idx':'21,1,3','code':'460106','name':'龙华区','search':'海南-海口-龙华区|hainan-haikou-longhuaqu|hn-hk-lhq'},{'idx':'21,1,4','code':'460107','name':'琼山区','search':'海南-海口-琼山区|hainan-haikou-qiongshanqu|hn-hk-qsq'},{'idx':'21,1,5','code':'460108','name':'美兰区','search':'海南-海口-美兰区|hainan-haikou-meilanqu|hn-hk-mlq'}]},{'idx':'21,2','code':'460200','name':'三亚','search':'海南-三亚|hainan-sanyashi|hn-sys','children':[{'idx':'21,2,0','code':'-1','name':'全市','search':'全市|quansheng|qs'},{'idx':'21,2,1','code':'460201','name':'市辖区','search':'海南-三亚-市辖区|hainan-sanya-shixiaqu|hn-sy-sxq'},{'idx':'21,2,2','code':'460202','name':'海棠区','search':'海南-三亚-海棠区|hainan-sanya-haitangqu|hn-sy-htq'},{'idx':'21,2,3','code':'460203','name':'吉阳区','search':'海南-三亚-吉阳区|hainan-sanya-jiyangqu|hn-sy-jyq'},{'idx':'21,2,4','code':'460204','name':'天涯区','search':'海南-三亚-天涯区|hainan-sanya-tianyaqu|hn-sy-tyq'},{'idx':'21,2,5','code':'460205','name':'崖州区','search':'海南-三亚-崖州区|hainan-sanya-yazhouqu|hn-sy-yzq'}]},{'idx':'21,3','code':'460300','name':'三沙','search':'海南-三沙|hainan-sanshashi|hn-sss','children':[{'idx':'21,3,0','code':'-1','name':'全市','search':'全市|quansheng|qs'},{'idx':'21,3,1','code':'460321','name':'西沙群岛','search':'海南-三沙-西沙群岛|hainan-sansha-xishaqundao|hn-ss-xsqd'},{'idx':'21,3,2','code':'460322','name':'南沙群岛','search':'海南-三沙-南沙群岛|hainan-sansha-nanshaqundao|hn-ss-nsqd'},{'idx':'21,3,3','code':'460323','name':'中沙群岛的岛礁及其海域','search':'海南-三沙-中沙群岛的岛礁及其海域|hainan-sansha-zhongshaqundaodedaojiaojiqihaiyu|hn-ss-zsqdddjjqhy'}]},{'idx':'21,4','code':'469000','name':'省直辖县级行政区划','search':'海南-省直辖县级行政区划|hainan-shengzhixiaxianjixingzhengquhua|hn-szxxjxzqh','children':[{'idx':'21,4,0','code':'-1','name':'全市','search':'全市|quansheng|qs'},{'idx':'21,4,1','code':'469001','name':'五指山市','search':'海南-省直辖县级行政区划-五指山市|hainan-shengzhixiaxianjixingzhengquhua-wuzhishanshi|hn-szxxjxzqh-wzss'},{'idx':'21,4,2','code':'469002','name':'琼海市','search':'海南-省直辖县级行政区划-琼海市|hainan-shengzhixiaxianjixingzhengquhua-qionghaishi|hn-szxxjxzqh-qhs'},{'idx':'21,4,3','code':'469003','name':'儋州市','search':'海南-省直辖县级行政区划-儋州市|hainan-shengzhixiaxianjixingzhengquhua-danzhoushi|hn-szxxjxzqh-dzs'},{'idx':'21,4,4','code':'469005','name':'文昌市','search':'海南-省直辖县级行政区划-文昌市|hainan-shengzhixiaxianjixingzhengquhua-wenchangshi|hn-szxxjxzqh-wcs'},{'idx':'21,4,5','code':'469006','name':'万宁市','search':'海南-省直辖县级行政区划-万宁市|hainan-shengzhixiaxianjixingzhengquhua-wanningshi|hn-szxxjxzqh-wns'},{'idx':'21,4,6','code':'469007','name':'东方市','search':'海南-省直辖县级行政区划-东方市|hainan-shengzhixiaxianjixingzhengquhua-dongfangshi|hn-szxxjxzqh-dfs'},{'idx':'21,4,7','code':'469021','name':'定安县','search':'海南-省直辖县级行政区划-定安县|hainan-shengzhixiaxianjixingzhengquhua-dinganxian|hn-szxxjxzqh-dax'},{'idx':'21,4,8','code':'469022','name':'屯昌县','search':'海南-省直辖县级行政区划-屯昌县|hainan-shengzhixiaxianjixingzhengquhua-tunchangxian|hn-szxxjxzqh-tcx'},{'idx':'21,4,9','code':'469023','name':'澄迈县','search':'海南-省直辖县级行政区划-澄迈县|hainan-shengzhixiaxianjixingzhengquhua-chengmaixian|hn-szxxjxzqh-cmx'},{'idx':'21,4,10','code':'469024','name':'临高县','search':'海南-省直辖县级行政区划-临高县|hainan-shengzhixiaxianjixingzhengquhua-lingaoxian|hn-szxxjxzqh-lgx'},{'idx':'21,4,11','code':'469025','name':'白沙黎族自治县','search':'海南-省直辖县级行政区划-白沙黎族自治县|hainan-shengzhixiaxianjixingzhengquhua-baishalizuzizhixian|hn-szxxjxzqh-bslzzzx'},{'idx':'21,4,12','code':'469026','name':'昌江黎族自治县','search':'海南-省直辖县级行政区划-昌江黎族自治县|hainan-shengzhixiaxianjixingzhengquhua-changjianglizuzizhixian|hn-szxxjxzqh-cjlzzzx'},{'idx':'21,4,13','code':'469027','name':'乐东黎族自治县','search':'海南-省直辖县级行政区划-乐东黎族自治县|hainan-shengzhixiaxianjixingzhengquhua-ledonglizuzizhixian|hn-szxxjxzqh-ldlzzzx'},{'idx':'21,4,14','code':'469028','name':'陵水黎族自治县','search':'海南-省直辖县级行政区划-陵水黎族自治县|hainan-shengzhixiaxianjixingzhengquhua-lingshuilizuzizhixian|hn-szxxjxzqh-lslzzzx'},{'idx':'21,4,15','code':'469029','name':'保亭黎族苗族自治县','search':'海南-省直辖县级行政区划-保亭黎族苗族自治县|hainan-shengzhixiaxianjixingzhengquhua-baotinglizumiaozuzizhixian|hn-szxxjxzqh-btlzmzzzx'},{'idx':'21,4,16','code':'469030','name':'琼中黎族苗族自治县','search':'海南-省直辖县级行政区划-琼中黎族苗族自治县|hainan-shengzhixiaxianjixingzhengquhua-qiongzhonglizumiaozuzizhixian|hn-szxxjxzqh-qzlzmzzzx'}]}]},{'idx':22,'code':'500000','name':'重庆','search':'重庆|chongqingshi|cqs','children':[{'idx':'22,0','code':'-1','name':'全省','search':'全省|quansheng|qs'},{'idx':'22,1','code':'500100','name':'重庆','search':'重庆-重庆|chongqing-chongqing|cq-cq','children':[{'idx':'22,1,0','code':'-1','name':'全市','search':'全市|quansheng|qs'},{'idx':'22,1,1','code':'500101','name':'万州区','search':'重庆-重庆-万州区|chongqing-chongqing-wanzhouqu|cq-cq-wzq'},{'idx':'22,1,2','code':'500102','name':'涪陵区','search':'重庆-重庆-涪陵区|chongqing-chongqing-fulingqu|cq-cq-flq'},{'idx':'22,1,3','code':'500103','name':'渝中区','search':'重庆-重庆-渝中区|chongqing-chongqing-yuzhongqu|cq-cq-yzq'},{'idx':'22,1,4','code':'500104','name':'大渡口区','search':'重庆-重庆-大渡口区|chongqing-chongqing-dadukouqu|cq-cq-ddkq'},{'idx':'22,1,5','code':'500105','name':'江北区','search':'重庆-重庆-江北区|chongqing-chongqing-jiangbeiqu|cq-cq-jbq'},{'idx':'22,1,6','code':'500106','name':'沙坪坝区','search':'重庆-重庆-沙坪坝区|chongqing-chongqing-shapingbaqu|cq-cq-spbq'},{'idx':'22,1,7','code':'500107','name':'九龙坡区','search':'重庆-重庆-九龙坡区|chongqing-chongqing-jiulongpoqu|cq-cq-jlpq'},{'idx':'22,1,8','code':'500108','name':'南岸区','search':'重庆-重庆-南岸区|chongqing-chongqing-nananqu|cq-cq-naq'},{'idx':'22,1,9','code':'500109','name':'北碚区','search':'重庆-重庆-北碚区|chongqing-chongqing-beibeiqu|cq-cq-bbq'},{'idx':'22,1,10','code':'500110','name':'綦江区','search':'重庆-重庆-綦江区|chongqing-chongqing-qijiangqu|cq-cq-qjq'},{'idx':'22,1,11','code':'500111','name':'大足区','search':'重庆-重庆-大足区|chongqing-chongqing-dazuqu|cq-cq-dzq'},{'idx':'22,1,12','code':'500112','name':'渝北区','search':'重庆-重庆-渝北区|chongqing-chongqing-yubeiqu|cq-cq-ybq'},{'idx':'22,1,13','code':'500113','name':'巴南区','search':'重庆-重庆-巴南区|chongqing-chongqing-bananqu|cq-cq-bnq'},{'idx':'22,1,14','code':'500114','name':'黔江区','search':'重庆-重庆-黔江区|chongqing-chongqing-qianjiangqu|cq-cq-qjq'},{'idx':'22,1,15','code':'500115','name':'长寿区','search':'重庆-重庆-长寿区|chongqing-chongqing-changshouqu|cq-cq-csq'},{'idx':'22,1,16','code':'500116','name':'江津区','search':'重庆-重庆-江津区|chongqing-chongqing-jiangjinqu|cq-cq-jjq'},{'idx':'22,1,17','code':'500117','name':'合川区','search':'重庆-重庆-合川区|chongqing-chongqing-hechuanqu|cq-cq-hcq'},{'idx':'22,1,18','code':'500118','name':'永川区','search':'重庆-重庆-永川区|chongqing-chongqing-yongchuanqu|cq-cq-ycq'},{'idx':'22,1,19','code':'500119','name':'南川区','search':'重庆-重庆-南川区|chongqing-chongqing-nanchuanqu|cq-cq-ncq'},{'idx':'22,1,20','code':'500120','name':'璧山区','search':'重庆-重庆-璧山区|chongqing-chongqing-bishanqu|cq-cq-bsq'},{'idx':'22,1,21','code':'500151','name':'铜梁区','search':'重庆-重庆-铜梁区|chongqing-chongqing-tongliangqu|cq-cq-tlq'},{'idx':'22,1,22','code':'500152','name':'潼南区','search':'重庆-重庆-潼南区|chongqing-chongqing-tongnanqu|cq-cq-tnq'},{'idx':'22,1,23','code':'500153','name':'荣昌区','search':'重庆-重庆-荣昌区|chongqing-chongqing-rongchangqu|cq-cq-rcq'},{'idx':'22,1,24','code':'500228','name':'梁平县','search':'重庆-重庆-梁平县|chongqing-chongqing-liangpingxian|cq-cq-lpx'},{'idx':'22,1,25','code':'500229','name':'城口县','search':'重庆-重庆-城口县|chongqing-chongqing-chengkouxian|cq-cq-ckx'},{'idx':'22,1,26','code':'500230','name':'丰都县','search':'重庆-重庆-丰都县|chongqing-chongqing-fengduxian|cq-cq-fdx'},{'idx':'22,1,27','code':'500231','name':'垫江县','search':'重庆-重庆-垫江县|chongqing-chongqing-dianjiangxian|cq-cq-djx'},{'idx':'22,1,28','code':'500232','name':'武隆县','search':'重庆-重庆-武隆县|chongqing-chongqing-wulongxian|cq-cq-wlx'},{'idx':'22,1,29','code':'500233','name':'忠县','search':'重庆-重庆-忠县|chongqing-chongqing-zhongxian|cq-cq-zx'},{'idx':'22,1,30','code':'500234','name':'开县','search':'重庆-重庆-开县|chongqing-chongqing-kaixian|cq-cq-kx'},{'idx':'22,1,31','code':'500235','name':'云阳县','search':'重庆-重庆-云阳县|chongqing-chongqing-yunyangxian|cq-cq-yyx'},{'idx':'22,1,32','code':'500236','name':'奉节县','search':'重庆-重庆-奉节县|chongqing-chongqing-fengjiexian|cq-cq-fjx'},{'idx':'22,1,33','code':'500237','name':'巫山县','search':'重庆-重庆-巫山县|chongqing-chongqing-wushanxian|cq-cq-wsx'},{'idx':'22,1,34','code':'500238','name':'巫溪县','search':'重庆-重庆-巫溪县|chongqing-chongqing-wuxixian|cq-cq-wxx'},{'idx':'22,1,35','code':'500240','name':'石柱土家族自治县','search':'重庆-重庆-石柱土家族自治县|chongqing-chongqing-shizhutujiazuzizhixian|cq-cq-sztjzzzx'},{'idx':'22,1,36','code':'500241','name':'秀山土家族苗族自治县','search':'重庆-重庆-秀山土家族苗族自治县|chongqing-chongqing-xiushantujiazumiaozuzizhixian|cq-cq-xstjzmzzzx'},{'idx':'22,1,37','code':'500242','name':'酉阳土家族苗族自治县','search':'重庆-重庆-酉阳土家族苗族自治县|chongqing-chongqing-youyangtujiazumiaozuzizhixian|cq-cq-yytjzmzzzx'},{'idx':'22,1,38','code':'500243','name':'彭水苗族土家族自治县','search':'重庆-重庆-彭水苗族土家族自治县|chongqing-chongqing-pengshuimiaozutujiazuzizhixian|cq-cq-psmztjzzzx'}]}]},{'idx':23,'code':'510000','name':'四川','search':'四川|sichuansheng|scs','children':[{'idx':'23,0','code':'-1','name':'全省','search':'全省|quansheng|qs'},{'idx':'23,1','code':'510100','name':'成都','search':'四川-成都|sichuan-chengdushi|sc-cds','children':[{'idx':'23,1,0','code':'-1','name':'全市','search':'全市|quansheng|qs'},{'idx':'23,1,1','code':'510101','name':'市辖区','search':'四川-成都-市辖区|sichuan-chengdu-shixiaqu|sc-cd-sxq'},{'idx':'23,1,2','code':'510104','name':'锦江区','search':'四川-成都-锦江区|sichuan-chengdu-jinjiangqu|sc-cd-jjq'},{'idx':'23,1,3','code':'510105','name':'青羊区','search':'四川-成都-青羊区|sichuan-chengdu-qingyangqu|sc-cd-qyq'},{'idx':'23,1,4','code':'510106','name':'金牛区','search':'四川-成都-金牛区|sichuan-chengdu-jinniuqu|sc-cd-jnq'},{'idx':'23,1,5','code':'510107','name':'武侯区','search':'四川-成都-武侯区|sichuan-chengdu-wuhouqu|sc-cd-whq'},{'idx':'23,1,6','code':'510108','name':'成华区','search':'四川-成都-成华区|sichuan-chengdu-chenghuaqu|sc-cd-chq'},{'idx':'23,1,7','code':'510112','name':'龙泉驿区','search':'四川-成都-龙泉驿区|sichuan-chengdu-longquanyiqu|sc-cd-lqyq'},{'idx':'23,1,8','code':'510113','name':'青白江区','search':'四川-成都-青白江区|sichuan-chengdu-qingbaijiangqu|sc-cd-qbjq'},{'idx':'23,1,9','code':'510114','name':'新都区','search':'四川-成都-新都区|sichuan-chengdu-xinduqu|sc-cd-xdq'},{'idx':'23,1,10','code':'510115','name':'温江区','search':'四川-成都-温江区|sichuan-chengdu-wenjiangqu|sc-cd-wjq'},{'idx':'23,1,11','code':'510121','name':'金堂县','search':'四川-成都-金堂县|sichuan-chengdu-jintangxian|sc-cd-jtx'},{'idx':'23,1,12','code':'510122','name':'双流县','search':'四川-成都-双流县|sichuan-chengdu-shuangliuxian|sc-cd-slx'},{'idx':'23,1,13','code':'510124','name':'郫县','search':'四川-成都-郫县|sichuan-chengdu-pixian|sc-cd-px'},{'idx':'23,1,14','code':'510129','name':'大邑县','search':'四川-成都-大邑县|sichuan-chengdu-dayixian|sc-cd-dyx'},{'idx':'23,1,15','code':'510131','name':'蒲江县','search':'四川-成都-蒲江县|sichuan-chengdu-pujiangxian|sc-cd-pjx'},{'idx':'23,1,16','code':'510132','name':'新津县','search':'四川-成都-新津县|sichuan-chengdu-xinjinxian|sc-cd-xjx'},{'idx':'23,1,17','code':'510181','name':'都江堰市','search':'四川-成都-都江堰市|sichuan-chengdu-dujiangyanshi|sc-cd-djys'},{'idx':'23,1,18','code':'510182','name':'彭州市','search':'四川-成都-彭州市|sichuan-chengdu-pengzhoushi|sc-cd-pzs'},{'idx':'23,1,19','code':'510183','name':'邛崃市','search':'四川-成都-邛崃市|sichuan-chengdu-qionglaishi|sc-cd-qls'},{'idx':'23,1,20','code':'510184','name':'崇州市','search':'四川-成都-崇州市|sichuan-chengdu-chongzhoushi|sc-cd-czs'}]},{'idx':'23,2','code':'510300','name':'自贡','search':'四川-自贡|sichuan-zigongshi|sc-zgs','children':[{'idx':'23,2,0','code':'-1','name':'全市','search':'全市|quansheng|qs'},{'idx':'23,2,1','code':'510301','name':'市辖区','search':'四川-自贡-市辖区|sichuan-zigong-shixiaqu|sc-zg-sxq'},{'idx':'23,2,2','code':'510302','name':'自流井区','search':'四川-自贡-自流井区|sichuan-zigong-ziliujingqu|sc-zg-zljq'},{'idx':'23,2,3','code':'510303','name':'贡井区','search':'四川-自贡-贡井区|sichuan-zigong-gongjingqu|sc-zg-gjq'},{'idx':'23,2,4','code':'510304','name':'大安区','search':'四川-自贡-大安区|sichuan-zigong-daanqu|sc-zg-daq'},{'idx':'23,2,5','code':'510311','name':'沿滩区','search':'四川-自贡-沿滩区|sichuan-zigong-yantanqu|sc-zg-ytq'},{'idx':'23,2,6','code':'510321','name':'荣县','search':'四川-自贡-荣县|sichuan-zigong-rongxian|sc-zg-rx'},{'idx':'23,2,7','code':'510322','name':'富顺县','search':'四川-自贡-富顺县|sichuan-zigong-fushunxian|sc-zg-fsx'}]},{'idx':'23,3','code':'510400','name':'攀枝花','search':'四川-攀枝花|sichuan-panzhihuashi|sc-pzhs','children':[{'idx':'23,3,0','code':'-1','name':'全市','search':'全市|quansheng|qs'},{'idx':'23,3,1','code':'510401','name':'市辖区','search':'四川-攀枝花-市辖区|sichuan-panzhihua-shixiaqu|sc-pzh-sxq'},{'idx':'23,3,2','code':'510402','name':'东区','search':'四川-攀枝花-东区|sichuan-panzhihua-dongqu|sc-pzh-dq'},{'idx':'23,3,3','code':'510403','name':'西区','search':'四川-攀枝花-西区|sichuan-panzhihua-xiqu|sc-pzh-xq'},{'idx':'23,3,4','code':'510411','name':'仁和区','search':'四川-攀枝花-仁和区|sichuan-panzhihua-renhequ|sc-pzh-rhq'},{'idx':'23,3,5','code':'510421','name':'米易县','search':'四川-攀枝花-米易县|sichuan-panzhihua-miyixian|sc-pzh-myx'},{'idx':'23,3,6','code':'510422','name':'盐边县','search':'四川-攀枝花-盐边县|sichuan-panzhihua-yanbianxian|sc-pzh-ybx'}]},{'idx':'23,4','code':'510500','name':'泸州','search':'四川-泸州|sichuan-luzhoushi|sc-lzs','children':[{'idx':'23,4,0','code':'-1','name':'全市','search':'全市|quansheng|qs'},{'idx':'23,4,1','code':'510501','name':'市辖区','search':'四川-泸州-市辖区|sichuan-luzhou-shixiaqu|sc-lz-sxq'},{'idx':'23,4,2','code':'510502','name':'江阳区','search':'四川-泸州-江阳区|sichuan-luzhou-jiangyangqu|sc-lz-jyq'},{'idx':'23,4,3','code':'510503','name':'纳溪区','search':'四川-泸州-纳溪区|sichuan-luzhou-naxiqu|sc-lz-nxq'},{'idx':'23,4,4','code':'510504','name':'龙马潭区','search':'四川-泸州-龙马潭区|sichuan-luzhou-longmatanqu|sc-lz-lmtq'},{'idx':'23,4,5','code':'510521','name':'泸县','search':'四川-泸州-泸县|sichuan-luzhou-luxian|sc-lz-lx'},{'idx':'23,4,6','code':'510522','name':'合江县','search':'四川-泸州-合江县|sichuan-luzhou-hejiangxian|sc-lz-hjx'},{'idx':'23,4,7','code':'510524','name':'叙永县','search':'四川-泸州-叙永县|sichuan-luzhou-xuyongxian|sc-lz-xyx'},{'idx':'23,4,8','code':'510525','name':'古蔺县','search':'四川-泸州-古蔺县|sichuan-luzhou-gulinxian|sc-lz-glx'}]},{'idx':'23,5','code':'510600','name':'德阳','search':'四川-德阳|sichuan-deyangshi|sc-dys','children':[{'idx':'23,5,0','code':'-1','name':'全市','search':'全市|quansheng|qs'},{'idx':'23,5,1','code':'510601','name':'市辖区','search':'四川-德阳-市辖区|sichuan-deyang-shixiaqu|sc-dy-sxq'},{'idx':'23,5,2','code':'510603','name':'旌阳区','search':'四川-德阳-旌阳区|sichuan-deyang-jingyangqu|sc-dy-jyq'},{'idx':'23,5,3','code':'510623','name':'中江县','search':'四川-德阳-中江县|sichuan-deyang-zhongjiangxian|sc-dy-zjx'},{'idx':'23,5,4','code':'510626','name':'罗江县','search':'四川-德阳-罗江县|sichuan-deyang-luojiangxian|sc-dy-ljx'},{'idx':'23,5,5','code':'510681','name':'广汉市','search':'四川-德阳-广汉市|sichuan-deyang-guanghanshi|sc-dy-ghs'},{'idx':'23,5,6','code':'510682','name':'什邡市','search':'四川-德阳-什邡市|sichuan-deyang-shifangshi|sc-dy-sfs'},{'idx':'23,5,7','code':'510683','name':'绵竹市','search':'四川-德阳-绵竹市|sichuan-deyang-mianzhushi|sc-dy-mzs'}]},{'idx':'23,6','code':'510700','name':'绵阳','search':'四川-绵阳|sichuan-mianyangshi|sc-mys','children':[{'idx':'23,6,0','code':'-1','name':'全市','search':'全市|quansheng|qs'},{'idx':'23,6,1','code':'510701','name':'市辖区','search':'四川-绵阳-市辖区|sichuan-mianyang-shixiaqu|sc-my-sxq'},{'idx':'23,6,2','code':'510703','name':'涪城区','search':'四川-绵阳-涪城区|sichuan-mianyang-fuchengqu|sc-my-fcq'},{'idx':'23,6,3','code':'510704','name':'游仙区','search':'四川-绵阳-游仙区|sichuan-mianyang-youxianqu|sc-my-yxq'},{'idx':'23,6,4','code':'510722','name':'三台县','search':'四川-绵阳-三台县|sichuan-mianyang-santaixian|sc-my-stx'},{'idx':'23,6,5','code':'510723','name':'盐亭县','search':'四川-绵阳-盐亭县|sichuan-mianyang-yantingxian|sc-my-ytx'},{'idx':'23,6,6','code':'510724','name':'安县','search':'四川-绵阳-安县|sichuan-mianyang-anxian|sc-my-ax'},{'idx':'23,6,7','code':'510725','name':'梓潼县','search':'四川-绵阳-梓潼县|sichuan-mianyang-zitongxian|sc-my-ztx'},{'idx':'23,6,8','code':'510726','name':'北川羌族自治县','search':'四川-绵阳-北川羌族自治县|sichuan-mianyang-beichuanqiangzuzizhixian|sc-my-bcqzzzx'},{'idx':'23,6,9','code':'510727','name':'平武县','search':'四川-绵阳-平武县|sichuan-mianyang-pingwuxian|sc-my-pwx'},{'idx':'23,6,10','code':'510781','name':'江油市','search':'四川-绵阳-江油市|sichuan-mianyang-jiangyoushi|sc-my-jys'}]},{'idx':'23,7','code':'510800','name':'广元','search':'四川-广元|sichuan-guangyuanshi|sc-gys','children':[{'idx':'23,7,0','code':'-1','name':'全市','search':'全市|quansheng|qs'},{'idx':'23,7,1','code':'510801','name':'市辖区','search':'四川-广元-市辖区|sichuan-guangyuan-shixiaqu|sc-gy-sxq'},{'idx':'23,7,2','code':'510802','name':'利州区','search':'四川-广元-利州区|sichuan-guangyuan-lizhouqu|sc-gy-lzq'},{'idx':'23,7,3','code':'510811','name':'昭化区','search':'四川-广元-昭化区|sichuan-guangyuan-zhaohuaqu|sc-gy-zhq'},{'idx':'23,7,4','code':'510812','name':'朝天区','search':'四川-广元-朝天区|sichuan-guangyuan-chaotianqu|sc-gy-ctq'},{'idx':'23,7,5','code':'510821','name':'旺苍县','search':'四川-广元-旺苍县|sichuan-guangyuan-wangcangxian|sc-gy-wcx'},{'idx':'23,7,6','code':'510822','name':'青川县','search':'四川-广元-青川县|sichuan-guangyuan-qingchuanxian|sc-gy-qcx'},{'idx':'23,7,7','code':'510823','name':'剑阁县','search':'四川-广元-剑阁县|sichuan-guangyuan-jiangexian|sc-gy-jgx'},{'idx':'23,7,8','code':'510824','name':'苍溪县','search':'四川-广元-苍溪县|sichuan-guangyuan-cangxixian|sc-gy-cxx'}]},{'idx':'23,8','code':'510900','name':'遂宁','search':'四川-遂宁|sichuan-suiningshi|sc-sns','children':[{'idx':'23,8,0','code':'-1','name':'全市','search':'全市|quansheng|qs'},{'idx':'23,8,1','code':'510901','name':'市辖区','search':'四川-遂宁-市辖区|sichuan-suining-shixiaqu|sc-sn-sxq'},{'idx':'23,8,2','code':'510903','name':'船山区','search':'四川-遂宁-船山区|sichuan-suining-chuanshanqu|sc-sn-csq'},{'idx':'23,8,3','code':'510904','name':'安居区','search':'四川-遂宁-安居区|sichuan-suining-anjuqu|sc-sn-ajq'},{'idx':'23,8,4','code':'510921','name':'蓬溪县','search':'四川-遂宁-蓬溪县|sichuan-suining-pengxixian|sc-sn-pxx'},{'idx':'23,8,5','code':'510922','name':'射洪县','search':'四川-遂宁-射洪县|sichuan-suining-shehongxian|sc-sn-shx'},{'idx':'23,8,6','code':'510923','name':'大英县','search':'四川-遂宁-大英县|sichuan-suining-dayingxian|sc-sn-dyx'}]},{'idx':'23,9','code':'511000','name':'内江','search':'四川-内江|sichuan-neijiangshi|sc-njs','children':[{'idx':'23,9,0','code':'-1','name':'全市','search':'全市|quansheng|qs'},{'idx':'23,9,1','code':'511001','name':'市辖区','search':'四川-内江-市辖区|sichuan-neijiang-shixiaqu|sc-nj-sxq'},{'idx':'23,9,2','code':'511002','name':'市中区','search':'四川-内江-市中区|sichuan-neijiang-shizhongqu|sc-nj-szq'},{'idx':'23,9,3','code':'511011','name':'东兴区','search':'四川-内江-东兴区|sichuan-neijiang-dongxingqu|sc-nj-dxq'},{'idx':'23,9,4','code':'511024','name':'威远县','search':'四川-内江-威远县|sichuan-neijiang-weiyuanxian|sc-nj-wyx'},{'idx':'23,9,5','code':'511025','name':'资中县','search':'四川-内江-资中县|sichuan-neijiang-zizhongxian|sc-nj-zzx'},{'idx':'23,9,6','code':'511028','name':'隆昌县','search':'四川-内江-隆昌县|sichuan-neijiang-longchangxian|sc-nj-lcx'}]},{'idx':'23,10','code':'511100','name':'乐山','search':'四川-乐山|sichuan-leshanshi|sc-lss','children':[{'idx':'23,10,0','code':'-1','name':'全市','search':'全市|quansheng|qs'},{'idx':'23,10,1','code':'511101','name':'市辖区','search':'四川-乐山-市辖区|sichuan-leshan-shixiaqu|sc-ls-sxq'},{'idx':'23,10,2','code':'511102','name':'市中区','search':'四川-乐山-市中区|sichuan-leshan-shizhongqu|sc-ls-szq'},{'idx':'23,10,3','code':'511111','name':'沙湾区','search':'四川-乐山-沙湾区|sichuan-leshan-shawanqu|sc-ls-swq'},{'idx':'23,10,4','code':'511112','name':'五通桥区','search':'四川-乐山-五通桥区|sichuan-leshan-wutongqiaoqu|sc-ls-wtqq'},{'idx':'23,10,5','code':'511113','name':'金口河区','search':'四川-乐山-金口河区|sichuan-leshan-jinkouhequ|sc-ls-jkhq'},{'idx':'23,10,6','code':'511123','name':'犍为县','search':'四川-乐山-犍为县|sichuan-leshan-jianweixian|sc-ls-jwx'},{'idx':'23,10,7','code':'511124','name':'井研县','search':'四川-乐山-井研县|sichuan-leshan-jingyanxian|sc-ls-jyx'},{'idx':'23,10,8','code':'511126','name':'夹江县','search':'四川-乐山-夹江县|sichuan-leshan-jiajiangxian|sc-ls-jjx'},{'idx':'23,10,9','code':'511129','name':'沐川县','search':'四川-乐山-沐川县|sichuan-leshan-muchuanxian|sc-ls-mcx'},{'idx':'23,10,10','code':'511132','name':'峨边彝族自治县','search':'四川-乐山-峨边彝族自治县|sichuan-leshan-ebianyizuzizhixian|sc-ls-ebyzzzx'},{'idx':'23,10,11','code':'511133','name':'马边彝族自治县','search':'四川-乐山-马边彝族自治县|sichuan-leshan-mabianyizuzizhixian|sc-ls-mbyzzzx'},{'idx':'23,10,12','code':'511181','name':'峨眉山市','search':'四川-乐山-峨眉山市|sichuan-leshan-emeishanshi|sc-ls-emss'}]},{'idx':'23,11','code':'511300','name':'南充','search':'四川-南充|sichuan-nanchongshi|sc-ncs','children':[{'idx':'23,11,0','code':'-1','name':'全市','search':'全市|quansheng|qs'},{'idx':'23,11,1','code':'511301','name':'市辖区','search':'四川-南充-市辖区|sichuan-nanchong-shixiaqu|sc-nc-sxq'},{'idx':'23,11,2','code':'511302','name':'顺庆区','search':'四川-南充-顺庆区|sichuan-nanchong-shunqingqu|sc-nc-sqq'},{'idx':'23,11,3','code':'511303','name':'高坪区','search':'四川-南充-高坪区|sichuan-nanchong-gaopingqu|sc-nc-gpq'},{'idx':'23,11,4','code':'511304','name':'嘉陵区','search':'四川-南充-嘉陵区|sichuan-nanchong-jialingqu|sc-nc-jlq'},{'idx':'23,11,5','code':'511321','name':'南部县','search':'四川-南充-南部县|sichuan-nanchong-nanbuxian|sc-nc-nbx'},{'idx':'23,11,6','code':'511322','name':'营山县','search':'四川-南充-营山县|sichuan-nanchong-yingshanxian|sc-nc-ysx'},{'idx':'23,11,7','code':'511323','name':'蓬安县','search':'四川-南充-蓬安县|sichuan-nanchong-penganxian|sc-nc-pax'},{'idx':'23,11,8','code':'511324','name':'仪陇县','search':'四川-南充-仪陇县|sichuan-nanchong-yilongxian|sc-nc-ylx'},{'idx':'23,11,9','code':'511325','name':'西充县','search':'四川-南充-西充县|sichuan-nanchong-xichongxian|sc-nc-xcx'},{'idx':'23,11,10','code':'511381','name':'阆中市','search':'四川-南充-阆中市|sichuan-nanchong-langzhongshi|sc-nc-lzs'}]},{'idx':'23,12','code':'511400','name':'眉山','search':'四川-眉山|sichuan-meishanshi|sc-mss','children':[{'idx':'23,12,0','code':'-1','name':'全市','search':'全市|quansheng|qs'},{'idx':'23,12,1','code':'511401','name':'市辖区','search':'四川-眉山-市辖区|sichuan-meishan-shixiaqu|sc-ms-sxq'},{'idx':'23,12,2','code':'511402','name':'东坡区','search':'四川-眉山-东坡区|sichuan-meishan-dongpoqu|sc-ms-dpq'},{'idx':'23,12,3','code':'511403','name':'彭山区','search':'四川-眉山-彭山区|sichuan-meishan-pengshanqu|sc-ms-psq'},{'idx':'23,12,4','code':'511421','name':'仁寿县','search':'四川-眉山-仁寿县|sichuan-meishan-renshouxian|sc-ms-rsx'},{'idx':'23,12,5','code':'511423','name':'洪雅县','search':'四川-眉山-洪雅县|sichuan-meishan-hongyaxian|sc-ms-hyx'},{'idx':'23,12,6','code':'511424','name':'丹棱县','search':'四川-眉山-丹棱县|sichuan-meishan-danlengxian|sc-ms-dlx'},{'idx':'23,12,7','code':'511425','name':'青神县','search':'四川-眉山-青神县|sichuan-meishan-qingshenxian|sc-ms-qsx'}]},{'idx':'23,13','code':'511500','name':'宜宾','search':'四川-宜宾|sichuan-yibinshi|sc-ybs','children':[{'idx':'23,13,0','code':'-1','name':'全市','search':'全市|quansheng|qs'},{'idx':'23,13,1','code':'511501','name':'市辖区','search':'四川-宜宾-市辖区|sichuan-yibin-shixiaqu|sc-yb-sxq'},{'idx':'23,13,2','code':'511502','name':'翠屏区','search':'四川-宜宾-翠屏区|sichuan-yibin-cuipingqu|sc-yb-cpq'},{'idx':'23,13,3','code':'511503','name':'南溪区','search':'四川-宜宾-南溪区|sichuan-yibin-nanxiqu|sc-yb-nxq'},{'idx':'23,13,4','code':'511521','name':'宜宾县','search':'四川-宜宾-宜宾县|sichuan-yibin-yibinxian|sc-yb-ybx'},{'idx':'23,13,5','code':'511523','name':'江安县','search':'四川-宜宾-江安县|sichuan-yibin-jianganxian|sc-yb-jax'},{'idx':'23,13,6','code':'511524','name':'长宁县','search':'四川-宜宾-长宁县|sichuan-yibin-changningxian|sc-yb-cnx'},{'idx':'23,13,7','code':'511525','name':'高县','search':'四川-宜宾-高县|sichuan-yibin-gaoxian|sc-yb-gx'},{'idx':'23,13,8','code':'511526','name':'珙县','search':'四川-宜宾-珙县|sichuan-yibin-gongxian|sc-yb-gx'},{'idx':'23,13,9','code':'511527','name':'筠连县','search':'四川-宜宾-筠连县|sichuan-yibin-junlianxian|sc-yb-jlx'},{'idx':'23,13,10','code':'511528','name':'兴文县','search':'四川-宜宾-兴文县|sichuan-yibin-xingwenxian|sc-yb-xwx'},{'idx':'23,13,11','code':'511529','name':'屏山县','search':'四川-宜宾-屏山县|sichuan-yibin-pingshanxian|sc-yb-psx'}]},{'idx':'23,14','code':'511600','name':'广安','search':'四川-广安|sichuan-guanganshi|sc-gas','children':[{'idx':'23,14,0','code':'-1','name':'全市','search':'全市|quansheng|qs'},{'idx':'23,14,1','code':'511601','name':'市辖区','search':'四川-广安-市辖区|sichuan-guangan-shixiaqu|sc-ga-sxq'},{'idx':'23,14,2','code':'511602','name':'广安区','search':'四川-广安-广安区|sichuan-guangan-guanganqu|sc-ga-gaq'},{'idx':'23,14,3','code':'511603','name':'前锋区','search':'四川-广安-前锋区|sichuan-guangan-qianfengqu|sc-ga-qfq'},{'idx':'23,14,4','code':'511621','name':'岳池县','search':'四川-广安-岳池县|sichuan-guangan-yuechixian|sc-ga-ycx'},{'idx':'23,14,5','code':'511622','name':'武胜县','search':'四川-广安-武胜县|sichuan-guangan-wushengxian|sc-ga-wsx'},{'idx':'23,14,6','code':'511623','name':'邻水县','search':'四川-广安-邻水县|sichuan-guangan-linshuixian|sc-ga-lsx'},{'idx':'23,14,7','code':'511681','name':'华蓥市','search':'四川-广安-华蓥市|sichuan-guangan-huayingshi|sc-ga-hys'}]},{'idx':'23,15','code':'511700','name':'达州','search':'四川-达州|sichuan-dazhoushi|sc-dzs','children':[{'idx':'23,15,0','code':'-1','name':'全市','search':'全市|quansheng|qs'},{'idx':'23,15,1','code':'511701','name':'市辖区','search':'四川-达州-市辖区|sichuan-dazhou-shixiaqu|sc-dz-sxq'},{'idx':'23,15,2','code':'511702','name':'通川区','search':'四川-达州-通川区|sichuan-dazhou-tongchuanqu|sc-dz-tcq'},{'idx':'23,15,3','code':'511703','name':'达川区','search':'四川-达州-达川区|sichuan-dazhou-dachuanqu|sc-dz-dcq'},{'idx':'23,15,4','code':'511722','name':'宣汉县','search':'四川-达州-宣汉县|sichuan-dazhou-xuanhanxian|sc-dz-xhx'},{'idx':'23,15,5','code':'511723','name':'开江县','search':'四川-达州-开江县|sichuan-dazhou-kaijiangxian|sc-dz-kjx'},{'idx':'23,15,6','code':'511724','name':'大竹县','search':'四川-达州-大竹县|sichuan-dazhou-dazhuxian|sc-dz-dzx'},{'idx':'23,15,7','code':'511725','name':'渠县','search':'四川-达州-渠县|sichuan-dazhou-quxian|sc-dz-qx'},{'idx':'23,15,8','code':'511781','name':'万源市','search':'四川-达州-万源市|sichuan-dazhou-wanyuanshi|sc-dz-wys'}]},{'idx':'23,16','code':'511800','name':'雅安','search':'四川-雅安|sichuan-yaanshi|sc-yas','children':[{'idx':'23,16,0','code':'-1','name':'全市','search':'全市|quansheng|qs'},{'idx':'23,16,1','code':'511801','name':'市辖区','search':'四川-雅安-市辖区|sichuan-yaan-shixiaqu|sc-ya-sxq'},{'idx':'23,16,2','code':'511802','name':'雨城区','search':'四川-雅安-雨城区|sichuan-yaan-yuchengqu|sc-ya-ycq'},{'idx':'23,16,3','code':'511803','name':'名山区','search':'四川-雅安-名山区|sichuan-yaan-mingshanqu|sc-ya-msq'},{'idx':'23,16,4','code':'511822','name':'荥经县','search':'四川-雅安-荥经县|sichuan-yaan-yingjingxian|sc-ya-yjx'},{'idx':'23,16,5','code':'511823','name':'汉源县','search':'四川-雅安-汉源县|sichuan-yaan-hanyuanxian|sc-ya-hyx'},{'idx':'23,16,6','code':'511824','name':'石棉县','search':'四川-雅安-石棉县|sichuan-yaan-shimianxian|sc-ya-smx'},{'idx':'23,16,7','code':'511825','name':'天全县','search':'四川-雅安-天全县|sichuan-yaan-tianquanxian|sc-ya-tqx'},{'idx':'23,16,8','code':'511826','name':'芦山县','search':'四川-雅安-芦山县|sichuan-yaan-lushanxian|sc-ya-lsx'},{'idx':'23,16,9','code':'511827','name':'宝兴县','search':'四川-雅安-宝兴县|sichuan-yaan-baoxingxian|sc-ya-bxx'}]},{'idx':'23,17','code':'511900','name':'巴中','search':'四川-巴中|sichuan-bazhongshi|sc-bzs','children':[{'idx':'23,17,0','code':'-1','name':'全市','search':'全市|quansheng|qs'},{'idx':'23,17,1','code':'511901','name':'市辖区','search':'四川-巴中-市辖区|sichuan-bazhong-shixiaqu|sc-bz-sxq'},{'idx':'23,17,2','code':'511902','name':'巴州区','search':'四川-巴中-巴州区|sichuan-bazhong-bazhouqu|sc-bz-bzq'},{'idx':'23,17,3','code':'511903','name':'恩阳区','search':'四川-巴中-恩阳区|sichuan-bazhong-enyangqu|sc-bz-eyq'},{'idx':'23,17,4','code':'511921','name':'通江县','search':'四川-巴中-通江县|sichuan-bazhong-tongjiangxian|sc-bz-tjx'},{'idx':'23,17,5','code':'511922','name':'南江县','search':'四川-巴中-南江县|sichuan-bazhong-nanjiangxian|sc-bz-njx'},{'idx':'23,17,6','code':'511923','name':'平昌县','search':'四川-巴中-平昌县|sichuan-bazhong-pingchangxian|sc-bz-pcx'}]},{'idx':'23,18','code':'512000','name':'资阳','search':'四川-资阳|sichuan-ziyangshi|sc-zys','children':[{'idx':'23,18,0','code':'-1','name':'全市','search':'全市|quansheng|qs'},{'idx':'23,18,1','code':'512001','name':'市辖区','search':'四川-资阳-市辖区|sichuan-ziyang-shixiaqu|sc-zy-sxq'},{'idx':'23,18,2','code':'512002','name':'雁江区','search':'四川-资阳-雁江区|sichuan-ziyang-yanjiangqu|sc-zy-yjq'},{'idx':'23,18,3','code':'512021','name':'安岳县','search':'四川-资阳-安岳县|sichuan-ziyang-anyuexian|sc-zy-ayx'},{'idx':'23,18,4','code':'512022','name':'乐至县','search':'四川-资阳-乐至县|sichuan-ziyang-lezhixian|sc-zy-lzx'},{'idx':'23,18,5','code':'512081','name':'简阳市','search':'四川-资阳-简阳市|sichuan-ziyang-jianyangshi|sc-zy-jys'}]},{'idx':'23,19','code':'513200','name':'阿坝羌族','search':'四川-阿坝羌族|sichuan-abacangzuqiangzuzizhizhou|sc-abczqzzzz','children':[{'idx':'23,19,0','code':'-1','name':'全市','search':'全市|quansheng|qs'},{'idx':'23,19,1','code':'513221','name':'汶川县','search':'四川-阿坝羌族-汶川县|sichuan-abaqiangzu-wenchuanxian|sc-abqz-wcx'},{'idx':'23,19,2','code':'513222','name':'理县','search':'四川-阿坝羌族-理县|sichuan-abaqiangzu-lixian|sc-abqz-lx'},{'idx':'23,19,3','code':'513223','name':'茂县','search':'四川-阿坝羌族-茂县|sichuan-abaqiangzu-maoxian|sc-abqz-mx'},{'idx':'23,19,4','code':'513224','name':'松潘县','search':'四川-阿坝羌族-松潘县|sichuan-abaqiangzu-songpanxian|sc-abqz-spx'},{'idx':'23,19,5','code':'513225','name':'九寨沟县','search':'四川-阿坝羌族-九寨沟县|sichuan-abaqiangzu-jiuzhaigouxian|sc-abqz-jzgx'},{'idx':'23,19,6','code':'513226','name':'金川县','search':'四川-阿坝羌族-金川县|sichuan-abaqiangzu-jinchuanxian|sc-abqz-jcx'},{'idx':'23,19,7','code':'513227','name':'小金县','search':'四川-阿坝羌族-小金县|sichuan-abaqiangzu-xiaojinxian|sc-abqz-xjx'},{'idx':'23,19,8','code':'513228','name':'黑水县','search':'四川-阿坝羌族-黑水县|sichuan-abaqiangzu-heishuixian|sc-abqz-hsx'},{'idx':'23,19,9','code':'513229','name':'马尔康县','search':'四川-阿坝羌族-马尔康县|sichuan-abaqiangzu-maerkangxian|sc-abqz-mekx'},{'idx':'23,19,10','code':'513230','name':'壤塘县','search':'四川-阿坝羌族-壤塘县|sichuan-abaqiangzu-rangtangxian|sc-abqz-rtx'},{'idx':'23,19,11','code':'513231','name':'阿坝县','search':'四川-阿坝羌族-阿坝县|sichuan-abaqiangzu-abaxian|sc-abqz-abx'},{'idx':'23,19,12','code':'513232','name':'若尔盖县','search':'四川-阿坝羌族-若尔盖县|sichuan-abaqiangzu-ruoergaixian|sc-abqz-regx'},{'idx':'23,19,13','code':'513233','name':'红原县','search':'四川-阿坝羌族-红原县|sichuan-abaqiangzu-hongyuanxian|sc-abqz-hyx'}]},{'idx':'23,20','code':'513300','name':'甘孜','search':'四川-甘孜|sichuan-ganzicangzuzizhizhou|sc-gzczzzz','children':[{'idx':'23,20,0','code':'-1','name':'全市','search':'全市|quansheng|qs'},{'idx':'23,20,1','code':'513301','name':'康定市','search':'四川-甘孜-康定市|sichuan-ganzi-kangdingshi|sc-gz-kds'},{'idx':'23,20,2','code':'513322','name':'泸定县','search':'四川-甘孜-泸定县|sichuan-ganzi-ludingxian|sc-gz-ldx'},{'idx':'23,20,3','code':'513323','name':'丹巴县','search':'四川-甘孜-丹巴县|sichuan-ganzi-danbaxian|sc-gz-dbx'},{'idx':'23,20,4','code':'513324','name':'九龙县','search':'四川-甘孜-九龙县|sichuan-ganzi-jiulongxian|sc-gz-jlx'},{'idx':'23,20,5','code':'513325','name':'雅江县','search':'四川-甘孜-雅江县|sichuan-ganzi-yajiangxian|sc-gz-yjx'},{'idx':'23,20,6','code':'513326','name':'道孚县','search':'四川-甘孜-道孚县|sichuan-ganzi-daofuxian|sc-gz-dfx'},{'idx':'23,20,7','code':'513327','name':'炉霍县','search':'四川-甘孜-炉霍县|sichuan-ganzi-luhuoxian|sc-gz-lhx'},{'idx':'23,20,8','code':'513328','name':'甘孜县','search':'四川-甘孜-甘孜县|sichuan-ganzi-ganzixian|sc-gz-gzx'},{'idx':'23,20,9','code':'513329','name':'新龙县','search':'四川-甘孜-新龙县|sichuan-ganzi-xinlongxian|sc-gz-xlx'},{'idx':'23,20,10','code':'513330','name':'德格县','search':'四川-甘孜-德格县|sichuan-ganzi-degexian|sc-gz-dgx'},{'idx':'23,20,11','code':'513331','name':'白玉县','search':'四川-甘孜-白玉县|sichuan-ganzi-baiyuxian|sc-gz-byx'},{'idx':'23,20,12','code':'513332','name':'石渠县','search':'四川-甘孜-石渠县|sichuan-ganzi-shiquxian|sc-gz-sqx'},{'idx':'23,20,13','code':'513333','name':'色达县','search':'四川-甘孜-色达县|sichuan-ganzi-sedaxian|sc-gz-sdx'},{'idx':'23,20,14','code':'513334','name':'理塘县','search':'四川-甘孜-理塘县|sichuan-ganzi-litangxian|sc-gz-ltx'},{'idx':'23,20,15','code':'513335','name':'巴塘县','search':'四川-甘孜-巴塘县|sichuan-ganzi-batangxian|sc-gz-btx'},{'idx':'23,20,16','code':'513336','name':'乡城县','search':'四川-甘孜-乡城县|sichuan-ganzi-xiangchengxian|sc-gz-xcx'},{'idx':'23,20,17','code':'513337','name':'稻城县','search':'四川-甘孜-稻城县|sichuan-ganzi-daochengxian|sc-gz-dcx'},{'idx':'23,20,18','code':'513338','name':'得荣县','search':'四川-甘孜-得荣县|sichuan-ganzi-derongxian|sc-gz-drx'}]},{'idx':'23,21','code':'513400','name':'凉山','search':'四川-凉山|sichuan-liangshanyizuzizhizhou|sc-lsyzzzz','children':[{'idx':'23,21,0','code':'-1','name':'全市','search':'全市|quansheng|qs'},{'idx':'23,21,1','code':'513401','name':'西昌市','search':'四川-凉山-西昌市|sichuan-liangshan-xichangshi|sc-ls-xcs'},{'idx':'23,21,2','code':'513422','name':'木里藏族自治县','search':'四川-凉山-木里藏族自治县|sichuan-liangshan-mulicangzuzizhixian|sc-ls-mlczzzx'},{'idx':'23,21,3','code':'513423','name':'盐源县','search':'四川-凉山-盐源县|sichuan-liangshan-yanyuanxian|sc-ls-yyx'},{'idx':'23,21,4','code':'513424','name':'德昌县','search':'四川-凉山-德昌县|sichuan-liangshan-dechangxian|sc-ls-dcx'},{'idx':'23,21,5','code':'513425','name':'会理县','search':'四川-凉山-会理县|sichuan-liangshan-huilixian|sc-ls-hlx'},{'idx':'23,21,6','code':'513426','name':'会东县','search':'四川-凉山-会东县|sichuan-liangshan-huidongxian|sc-ls-hdx'},{'idx':'23,21,7','code':'513427','name':'宁南县','search':'四川-凉山-宁南县|sichuan-liangshan-ningnanxian|sc-ls-nnx'},{'idx':'23,21,8','code':'513428','name':'普格县','search':'四川-凉山-普格县|sichuan-liangshan-pugexian|sc-ls-pgx'},{'idx':'23,21,9','code':'513429','name':'布拖县','search':'四川-凉山-布拖县|sichuan-liangshan-butuoxian|sc-ls-btx'},{'idx':'23,21,10','code':'513430','name':'金阳县','search':'四川-凉山-金阳县|sichuan-liangshan-jinyangxian|sc-ls-jyx'},{'idx':'23,21,11','code':'513431','name':'昭觉县','search':'四川-凉山-昭觉县|sichuan-liangshan-zhaojuexian|sc-ls-zjx'},{'idx':'23,21,12','code':'513432','name':'喜德县','search':'四川-凉山-喜德县|sichuan-liangshan-xidexian|sc-ls-xdx'},{'idx':'23,21,13','code':'513433','name':'冕宁县','search':'四川-凉山-冕宁县|sichuan-liangshan-mianningxian|sc-ls-mnx'},{'idx':'23,21,14','code':'513434','name':'越西县','search':'四川-凉山-越西县|sichuan-liangshan-yuexixian|sc-ls-yxx'},{'idx':'23,21,15','code':'513435','name':'甘洛县','search':'四川-凉山-甘洛县|sichuan-liangshan-ganluoxian|sc-ls-glx'},{'idx':'23,21,16','code':'513436','name':'美姑县','search':'四川-凉山-美姑县|sichuan-liangshan-meiguxian|sc-ls-mgx'},{'idx':'23,21,17','code':'513437','name':'雷波县','search':'四川-凉山-雷波县|sichuan-liangshan-leiboxian|sc-ls-lbx'}]}]},{'idx':24,'code':'520000','name':'贵州','search':'贵州|guizhousheng|gzs','children':[{'idx':'24,0','code':'-1','name':'全省','search':'全省|quansheng|qs'},{'idx':'24,1','code':'520100','name':'贵阳','search':'贵州-贵阳|guizhou-guiyangshi|gz-gys','children':[{'idx':'24,1,0','code':'-1','name':'全市','search':'全市|quansheng|qs'},{'idx':'24,1,1','code':'520101','name':'市辖区','search':'贵州-贵阳-市辖区|guizhou-guiyang-shixiaqu|gz-gy-sxq'},{'idx':'24,1,2','code':'520102','name':'南明区','search':'贵州-贵阳-南明区|guizhou-guiyang-nanmingqu|gz-gy-nmq'},{'idx':'24,1,3','code':'520103','name':'云岩区','search':'贵州-贵阳-云岩区|guizhou-guiyang-yunyanqu|gz-gy-yyq'},{'idx':'24,1,4','code':'520111','name':'花溪区','search':'贵州-贵阳-花溪区|guizhou-guiyang-huaxiqu|gz-gy-hxq'},{'idx':'24,1,5','code':'520112','name':'乌当区','search':'贵州-贵阳-乌当区|guizhou-guiyang-wudangqu|gz-gy-wdq'},{'idx':'24,1,6','code':'520113','name':'白云区','search':'贵州-贵阳-白云区|guizhou-guiyang-baiyunqu|gz-gy-byq'},{'idx':'24,1,7','code':'520115','name':'观山湖区','search':'贵州-贵阳-观山湖区|guizhou-guiyang-guanshanhuqu|gz-gy-gshq'},{'idx':'24,1,8','code':'520121','name':'开阳县','search':'贵州-贵阳-开阳县|guizhou-guiyang-kaiyangxian|gz-gy-kyx'},{'idx':'24,1,9','code':'520122','name':'息烽县','search':'贵州-贵阳-息烽县|guizhou-guiyang-xifengxian|gz-gy-xfx'},{'idx':'24,1,10','code':'520123','name':'修文县','search':'贵州-贵阳-修文县|guizhou-guiyang-xiuwenxian|gz-gy-xwx'},{'idx':'24,1,11','code':'520181','name':'清镇市','search':'贵州-贵阳-清镇市|guizhou-guiyang-qingzhenshi|gz-gy-qzs'}]},{'idx':'24,2','code':'520200','name':'六盘水','search':'贵州-六盘水|guizhou-liupanshuishi|gz-lpss','children':[{'idx':'24,2,0','code':'-1','name':'全市','search':'全市|quansheng|qs'},{'idx':'24,2,1','code':'520201','name':'钟山区','search':'贵州-六盘水-钟山区|guizhou-liupanshui-zhongshanqu|gz-lps-zsq'},{'idx':'24,2,2','code':'520203','name':'六枝特区','search':'贵州-六盘水-六枝特区|guizhou-liupanshui-liuzhitequ|gz-lps-lztq'},{'idx':'24,2,3','code':'520221','name':'水城县','search':'贵州-六盘水-水城县|guizhou-liupanshui-shuichengxian|gz-lps-scx'},{'idx':'24,2,4','code':'520222','name':'盘县','search':'贵州-六盘水-盘县|guizhou-liupanshui-panxian|gz-lps-px'}]},{'idx':'24,3','code':'520300','name':'遵义','search':'贵州-遵义|guizhou-zunyishi|gz-zys','children':[{'idx':'24,3,0','code':'-1','name':'全市','search':'全市|quansheng|qs'},{'idx':'24,3,1','code':'520301','name':'市辖区','search':'贵州-遵义-市辖区|guizhou-zunyi-shixiaqu|gz-zy-sxq'},{'idx':'24,3,2','code':'520302','name':'红花岗区','search':'贵州-遵义-红花岗区|guizhou-zunyi-honghuagangqu|gz-zy-hhgq'},{'idx':'24,3,3','code':'520303','name':'汇川区','search':'贵州-遵义-汇川区|guizhou-zunyi-huichuanqu|gz-zy-hcq'},{'idx':'24,3,4','code':'520321','name':'遵义县','search':'贵州-遵义-遵义县|guizhou-zunyi-zunyixian|gz-zy-zyx'},{'idx':'24,3,5','code':'520322','name':'桐梓县','search':'贵州-遵义-桐梓县|guizhou-zunyi-tongzixian|gz-zy-tzx'},{'idx':'24,3,6','code':'520323','name':'绥阳县','search':'贵州-遵义-绥阳县|guizhou-zunyi-suiyangxian|gz-zy-syx'},{'idx':'24,3,7','code':'520324','name':'正安县','search':'贵州-遵义-正安县|guizhou-zunyi-zhenganxian|gz-zy-zax'},{'idx':'24,3,8','code':'520325','name':'道真仡佬族苗族自治县','search':'贵州-遵义-道真仡佬族苗族自治县|guizhou-zunyi-daozhenyilaozumiaozuzizhixian|gz-zy-dzylzmzzzx'},{'idx':'24,3,9','code':'520326','name':'务川仡佬族苗族自治县','search':'贵州-遵义-务川仡佬族苗族自治县|guizhou-zunyi-wuchuanyilaozumiaozuzizhixian|gz-zy-wcylzmzzzx'},{'idx':'24,3,10','code':'520327','name':'凤冈县','search':'贵州-遵义-凤冈县|guizhou-zunyi-fenggangxian|gz-zy-fgx'},{'idx':'24,3,11','code':'520328','name':'湄潭县','search':'贵州-遵义-湄潭县|guizhou-zunyi-meitanxian|gz-zy-mtx'},{'idx':'24,3,12','code':'520329','name':'余庆县','search':'贵州-遵义-余庆县|guizhou-zunyi-yuqingxian|gz-zy-yqx'},{'idx':'24,3,13','code':'520330','name':'习水县','search':'贵州-遵义-习水县|guizhou-zunyi-xishuixian|gz-zy-xsx'},{'idx':'24,3,14','code':'520381','name':'赤水市','search':'贵州-遵义-赤水市|guizhou-zunyi-chishuishi|gz-zy-css'},{'idx':'24,3,15','code':'520382','name':'仁怀市','search':'贵州-遵义-仁怀市|guizhou-zunyi-renhuaishi|gz-zy-rhs'}]},{'idx':'24,4','code':'520400','name':'安顺','search':'贵州-安顺|guizhou-anshunshi|gz-ass','children':[{'idx':'24,4,0','code':'-1','name':'全市','search':'全市|quansheng|qs'},{'idx':'24,4,1','code':'520401','name':'市辖区','search':'贵州-安顺-市辖区|guizhou-anshun-shixiaqu|gz-as-sxq'},{'idx':'24,4,2','code':'520402','name':'西秀区','search':'贵州-安顺-西秀区|guizhou-anshun-xixiuqu|gz-as-xxq'},{'idx':'24,4,3','code':'520403','name':'平坝区','search':'贵州-安顺-平坝区|guizhou-anshun-pingbaqu|gz-as-pbq'},{'idx':'24,4,4','code':'520422','name':'普定县','search':'贵州-安顺-普定县|guizhou-anshun-pudingxian|gz-as-pdx'},{'idx':'24,4,5','code':'520423','name':'镇宁布依族苗族自治县','search':'贵州-安顺-镇宁布依族苗族自治县|guizhou-anshun-zhenningbuyizumiaozuzizhixian|gz-as-znbyzmzzzx'},{'idx':'24,4,6','code':'520424','name':'关岭布依族苗族自治县','search':'贵州-安顺-关岭布依族苗族自治县|guizhou-anshun-guanlingbuyizumiaozuzizhixian|gz-as-glbyzmzzzx'},{'idx':'24,4,7','code':'520425','name':'紫云苗族布依族自治县','search':'贵州-安顺-紫云苗族布依族自治县|guizhou-anshun-ziyunmiaozubuyizuzizhixian|gz-as-zymzbyzzzx'}]},{'idx':'24,5','code':'520500','name':'毕节','search':'贵州-毕节|guizhou-bijieshi|gz-bjs','children':[{'idx':'24,5,0','code':'-1','name':'全市','search':'全市|quansheng|qs'},{'idx':'24,5,1','code':'520501','name':'市辖区','search':'贵州-毕节-市辖区|guizhou-bijie-shixiaqu|gz-bj-sxq'},{'idx':'24,5,2','code':'520502','name':'七星关区','search':'贵州-毕节-七星关区|guizhou-bijie-qixingguanqu|gz-bj-qxgq'},{'idx':'24,5,3','code':'520521','name':'大方县','search':'贵州-毕节-大方县|guizhou-bijie-dafangxian|gz-bj-dfx'},{'idx':'24,5,4','code':'520522','name':'黔西县','search':'贵州-毕节-黔西县|guizhou-bijie-qianxixian|gz-bj-qxx'},{'idx':'24,5,5','code':'520523','name':'金沙县','search':'贵州-毕节-金沙县|guizhou-bijie-jinshaxian|gz-bj-jsx'},{'idx':'24,5,6','code':'520524','name':'织金县','search':'贵州-毕节-织金县|guizhou-bijie-zhijinxian|gz-bj-zjx'},{'idx':'24,5,7','code':'520525','name':'纳雍县','search':'贵州-毕节-纳雍县|guizhou-bijie-nayongxian|gz-bj-nyx'},{'idx':'24,5,8','code':'520526','name':'威宁彝族回族苗族自治县','search':'贵州-毕节-威宁彝族回族苗族自治县|guizhou-bijie-weiningyizuhuizumiaozuzizhixian|gz-bj-wnyzhzmzzzx'},{'idx':'24,5,9','code':'520527','name':'赫章县','search':'贵州-毕节-赫章县|guizhou-bijie-hezhangxian|gz-bj-hzx'}]},{'idx':'24,6','code':'520600','name':'铜仁','search':'贵州-铜仁|guizhou-tongrenshi|gz-trs','children':[{'idx':'24,6,0','code':'-1','name':'全市','search':'全市|quansheng|qs'},{'idx':'24,6,1','code':'520601','name':'市辖区','search':'贵州-铜仁-市辖区|guizhou-tongren-shixiaqu|gz-tr-sxq'},{'idx':'24,6,2','code':'520602','name':'碧江区','search':'贵州-铜仁-碧江区|guizhou-tongren-bijiangqu|gz-tr-bjq'},{'idx':'24,6,3','code':'520603','name':'万山区','search':'贵州-铜仁-万山区|guizhou-tongren-wanshanqu|gz-tr-wsq'},{'idx':'24,6,4','code':'520621','name':'江口县','search':'贵州-铜仁-江口县|guizhou-tongren-jiangkouxian|gz-tr-jkx'},{'idx':'24,6,5','code':'520622','name':'玉屏侗族自治县','search':'贵州-铜仁-玉屏侗族自治县|guizhou-tongren-yupingdongzuzizhixian|gz-tr-ypdzzzx'},{'idx':'24,6,6','code':'520623','name':'石阡县','search':'贵州-铜仁-石阡县|guizhou-tongren-shiqianxian|gz-tr-sqx'},{'idx':'24,6,7','code':'520624','name':'思南县','search':'贵州-铜仁-思南县|guizhou-tongren-sinanxian|gz-tr-snx'},{'idx':'24,6,8','code':'520625','name':'印江土家族苗族自治县','search':'贵州-铜仁-印江土家族苗族自治县|guizhou-tongren-yinjiangtujiazumiaozuzizhixian|gz-tr-yjtjzmzzzx'},{'idx':'24,6,9','code':'520626','name':'德江县','search':'贵州-铜仁-德江县|guizhou-tongren-dejiangxian|gz-tr-djx'},{'idx':'24,6,10','code':'520627','name':'沿河土家族自治县','search':'贵州-铜仁-沿河土家族自治县|guizhou-tongren-yanhetujiazuzizhixian|gz-tr-yhtjzzzx'},{'idx':'24,6,11','code':'520628','name':'松桃苗族自治县','search':'贵州-铜仁-松桃苗族自治县|guizhou-tongren-songtaomiaozuzizhixian|gz-tr-stmzzzx'}]},{'idx':'24,7','code':'522300','name':'黔西南','search':'贵州-黔西南|guizhou-qianxinanbuyizumiaozuzizhizhou|gz-qxnbyzmzzzz','children':[{'idx':'24,7,0','code':'-1','name':'全市','search':'全市|quansheng|qs'},{'idx':'24,7,1','code':'522301','name':'兴义市','search':'贵州-黔西南-兴义市|guizhou-qianxinan-xingyishi|gz-qxn-xys'},{'idx':'24,7,2','code':'522322','name':'兴仁县','search':'贵州-黔西南-兴仁县|guizhou-qianxinan-xingrenxian|gz-qxn-xrx'},{'idx':'24,7,3','code':'522323','name':'普安县','search':'贵州-黔西南-普安县|guizhou-qianxinan-puanxian|gz-qxn-pax'},{'idx':'24,7,4','code':'522324','name':'晴隆县','search':'贵州-黔西南-晴隆县|guizhou-qianxinan-qinglongxian|gz-qxn-qlx'},{'idx':'24,7,5','code':'522325','name':'贞丰县','search':'贵州-黔西南-贞丰县|guizhou-qianxinan-zhenfengxian|gz-qxn-zfx'},{'idx':'24,7,6','code':'522326','name':'望谟县','search':'贵州-黔西南-望谟县|guizhou-qianxinan-wangmoxian|gz-qxn-wmx'},{'idx':'24,7,7','code':'522327','name':'册亨县','search':'贵州-黔西南-册亨县|guizhou-qianxinan-cehengxian|gz-qxn-chx'},{'idx':'24,7,8','code':'522328','name':'安龙县','search':'贵州-黔西南-安龙县|guizhou-qianxinan-anlongxian|gz-qxn-alx'}]},{'idx':'24,8','code':'522600','name':'黔东南侗族','search':'贵州-黔东南侗族|guizhou-qiandongnanmiaozudongzuzizhizhou|gz-qdnmzdzzzz','children':[{'idx':'24,8,0','code':'-1','name':'全市','search':'全市|quansheng|qs'},{'idx':'24,8,1','code':'522601','name':'凯里市','search':'贵州-黔东南侗族-凯里市|guizhou-qiandongnandongzu-kailishi|gz-qdndz-kls'},{'idx':'24,8,2','code':'522622','name':'黄平县','search':'贵州-黔东南侗族-黄平县|guizhou-qiandongnandongzu-huangpingxian|gz-qdndz-hpx'},{'idx':'24,8,3','code':'522623','name':'施秉县','search':'贵州-黔东南侗族-施秉县|guizhou-qiandongnandongzu-shibingxian|gz-qdndz-sbx'},{'idx':'24,8,4','code':'522624','name':'三穗县','search':'贵州-黔东南侗族-三穗县|guizhou-qiandongnandongzu-sansuixian|gz-qdndz-ssx'},{'idx':'24,8,5','code':'522625','name':'镇远县','search':'贵州-黔东南侗族-镇远县|guizhou-qiandongnandongzu-zhenyuanxian|gz-qdndz-zyx'},{'idx':'24,8,6','code':'522626','name':'岑巩县','search':'贵州-黔东南侗族-岑巩县|guizhou-qiandongnandongzu-cengongxian|gz-qdndz-cgx'},{'idx':'24,8,7','code':'522627','name':'天柱县','search':'贵州-黔东南侗族-天柱县|guizhou-qiandongnandongzu-tianzhuxian|gz-qdndz-tzx'},{'idx':'24,8,8','code':'522628','name':'锦屏县','search':'贵州-黔东南侗族-锦屏县|guizhou-qiandongnandongzu-jinpingxian|gz-qdndz-jpx'},{'idx':'24,8,9','code':'522629','name':'剑河县','search':'贵州-黔东南侗族-剑河县|guizhou-qiandongnandongzu-jianhexian|gz-qdndz-jhx'},{'idx':'24,8,10','code':'522630','name':'台江县','search':'贵州-黔东南侗族-台江县|guizhou-qiandongnandongzu-taijiangxian|gz-qdndz-tjx'},{'idx':'24,8,11','code':'522631','name':'黎平县','search':'贵州-黔东南侗族-黎平县|guizhou-qiandongnandongzu-lipingxian|gz-qdndz-lpx'},{'idx':'24,8,12','code':'522632','name':'榕江县','search':'贵州-黔东南侗族-榕江县|guizhou-qiandongnandongzu-rongjiangxian|gz-qdndz-rjx'},{'idx':'24,8,13','code':'522633','name':'从江县','search':'贵州-黔东南侗族-从江县|guizhou-qiandongnandongzu-congjiangxian|gz-qdndz-cjx'},{'idx':'24,8,14','code':'522634','name':'雷山县','search':'贵州-黔东南侗族-雷山县|guizhou-qiandongnandongzu-leishanxian|gz-qdndz-lsx'},{'idx':'24,8,15','code':'522635','name':'麻江县','search':'贵州-黔东南侗族-麻江县|guizhou-qiandongnandongzu-majiangxian|gz-qdndz-mjx'},{'idx':'24,8,16','code':'522636','name':'丹寨县','search':'贵州-黔东南侗族-丹寨县|guizhou-qiandongnandongzu-danzhaixian|gz-qdndz-dzx'}]},{'idx':'24,9','code':'522700','name':'黔南','search':'贵州-黔南|guizhou-qiannanbuyizumiaozuzizhizhou|gz-qnbyzmzzzz','children':[{'idx':'24,9,0','code':'-1','name':'全市','search':'全市|quansheng|qs'},{'idx':'24,9,1','code':'522701','name':'都匀市','search':'贵州-黔南-都匀市|guizhou-qiannan-duyunshi|gz-qn-dys'},{'idx':'24,9,2','code':'522702','name':'福泉市','search':'贵州-黔南-福泉市|guizhou-qiannan-fuquanshi|gz-qn-fqs'},{'idx':'24,9,3','code':'522722','name':'荔波县','search':'贵州-黔南-荔波县|guizhou-qiannan-liboxian|gz-qn-lbx'},{'idx':'24,9,4','code':'522723','name':'贵定县','search':'贵州-黔南-贵定县|guizhou-qiannan-guidingxian|gz-qn-gdx'},{'idx':'24,9,5','code':'522725','name':'瓮安县','search':'贵州-黔南-瓮安县|guizhou-qiannan-wenganxian|gz-qn-wax'},{'idx':'24,9,6','code':'522726','name':'独山县','search':'贵州-黔南-独山县|guizhou-qiannan-dushanxian|gz-qn-dsx'},{'idx':'24,9,7','code':'522727','name':'平塘县','search':'贵州-黔南-平塘县|guizhou-qiannan-pingtangxian|gz-qn-ptx'},{'idx':'24,9,8','code':'522728','name':'罗甸县','search':'贵州-黔南-罗甸县|guizhou-qiannan-luodianxian|gz-qn-ldx'},{'idx':'24,9,9','code':'522729','name':'长顺县','search':'贵州-黔南-长顺县|guizhou-qiannan-changshunxian|gz-qn-csx'},{'idx':'24,9,10','code':'522730','name':'龙里县','search':'贵州-黔南-龙里县|guizhou-qiannan-longlixian|gz-qn-llx'},{'idx':'24,9,11','code':'522731','name':'惠水县','search':'贵州-黔南-惠水县|guizhou-qiannan-huishuixian|gz-qn-hsx'},{'idx':'24,9,12','code':'522732','name':'三都水族自治县','search':'贵州-黔南-三都水族自治县|guizhou-qiannan-sandushuizuzizhixian|gz-qn-sdszzzx'}]}]},{'idx':25,'code':'530000','name':'云南','search':'云南|yunnansheng|yns','children':[{'idx':'25,0','code':'-1','name':'全省','search':'全省|quansheng|qs'},{'idx':'25,1','code':'530100','name':'昆明','search':'云南-昆明|yunnan-kunmingshi|yn-kms','children':[{'idx':'25,1,0','code':'-1','name':'全市','search':'全市|quansheng|qs'},{'idx':'25,1,1','code':'530101','name':'市辖区','search':'云南-昆明-市辖区|yunnan-kunming-shixiaqu|yn-km-sxq'},{'idx':'25,1,2','code':'530102','name':'五华区','search':'云南-昆明-五华区|yunnan-kunming-wuhuaqu|yn-km-whq'},{'idx':'25,1,3','code':'530103','name':'盘龙区','search':'云南-昆明-盘龙区|yunnan-kunming-panlongqu|yn-km-plq'},{'idx':'25,1,4','code':'530111','name':'官渡区','search':'云南-昆明-官渡区|yunnan-kunming-guanduqu|yn-km-gdq'},{'idx':'25,1,5','code':'530112','name':'西山区','search':'云南-昆明-西山区|yunnan-kunming-xishanqu|yn-km-xsq'},{'idx':'25,1,6','code':'530113','name':'东川区','search':'云南-昆明-东川区|yunnan-kunming-dongchuanqu|yn-km-dcq'},{'idx':'25,1,7','code':'530114','name':'呈贡区','search':'云南-昆明-呈贡区|yunnan-kunming-chenggongqu|yn-km-cgq'},{'idx':'25,1,8','code':'530122','name':'晋宁县','search':'云南-昆明-晋宁县|yunnan-kunming-jinningxian|yn-km-jnx'},{'idx':'25,1,9','code':'530124','name':'富民县','search':'云南-昆明-富民县|yunnan-kunming-fuminxian|yn-km-fmx'},{'idx':'25,1,10','code':'530125','name':'宜良县','search':'云南-昆明-宜良县|yunnan-kunming-yiliangxian|yn-km-ylx'},{'idx':'25,1,11','code':'530126','name':'石林彝族自治县','search':'云南-昆明-石林彝族自治县|yunnan-kunming-shilinyizuzizhixian|yn-km-slyzzzx'},{'idx':'25,1,12','code':'530127','name':'嵩明县','search':'云南-昆明-嵩明县|yunnan-kunming-songmingxian|yn-km-smx'},{'idx':'25,1,13','code':'530128','name':'禄劝彝族苗族自治县','search':'云南-昆明-禄劝彝族苗族自治县|yunnan-kunming-luquanyizumiaozuzizhixian|yn-km-lqyzmzzzx'},{'idx':'25,1,14','code':'530129','name':'寻甸回族彝族自治县','search':'云南-昆明-寻甸回族彝族自治县|yunnan-kunming-xundianhuizuyizuzizhixian|yn-km-xdhzyzzzx'},{'idx':'25,1,15','code':'530181','name':'安宁市','search':'云南-昆明-安宁市|yunnan-kunming-anningshi|yn-km-ans'}]},{'idx':'25,2','code':'530300','name':'曲靖','search':'云南-曲靖|yunnan-qujingshi|yn-qjs','children':[{'idx':'25,2,0','code':'-1','name':'全市','search':'全市|quansheng|qs'},{'idx':'25,2,1','code':'530301','name':'市辖区','search':'云南-曲靖-市辖区|yunnan-qujing-shixiaqu|yn-qj-sxq'},{'idx':'25,2,2','code':'530302','name':'麒麟区','search':'云南-曲靖-麒麟区|yunnan-qujing-qilinqu|yn-qj-qlq'},{'idx':'25,2,3','code':'530321','name':'马龙县','search':'云南-曲靖-马龙县|yunnan-qujing-malongxian|yn-qj-mlx'},{'idx':'25,2,4','code':'530322','name':'陆良县','search':'云南-曲靖-陆良县|yunnan-qujing-luliangxian|yn-qj-llx'},{'idx':'25,2,5','code':'530323','name':'师宗县','search':'云南-曲靖-师宗县|yunnan-qujing-shizongxian|yn-qj-szx'},{'idx':'25,2,6','code':'530324','name':'罗平县','search':'云南-曲靖-罗平县|yunnan-qujing-luopingxian|yn-qj-lpx'},{'idx':'25,2,7','code':'530325','name':'富源县','search':'云南-曲靖-富源县|yunnan-qujing-fuyuanxian|yn-qj-fyx'},{'idx':'25,2,8','code':'530326','name':'会泽县','search':'云南-曲靖-会泽县|yunnan-qujing-huizexian|yn-qj-hzx'},{'idx':'25,2,9','code':'530328','name':'沾益县','search':'云南-曲靖-沾益县|yunnan-qujing-zhanyixian|yn-qj-zyx'},{'idx':'25,2,10','code':'530381','name':'宣威市','search':'云南-曲靖-宣威市|yunnan-qujing-xuanweishi|yn-qj-xws'}]},{'idx':'25,3','code':'530400','name':'玉溪','search':'云南-玉溪|yunnan-yuxishi|yn-yxs','children':[{'idx':'25,3,0','code':'-1','name':'全市','search':'全市|quansheng|qs'},{'idx':'25,3,1','code':'530401','name':'市辖区','search':'云南-玉溪-市辖区|yunnan-yuxi-shixiaqu|yn-yx-sxq'},{'idx':'25,3,2','code':'530402','name':'红塔区','search':'云南-玉溪-红塔区|yunnan-yuxi-hongtaqu|yn-yx-htq'},{'idx':'25,3,3','code':'530421','name':'江川县','search':'云南-玉溪-江川县|yunnan-yuxi-jiangchuanxian|yn-yx-jcx'},{'idx':'25,3,4','code':'530422','name':'澄江县','search':'云南-玉溪-澄江县|yunnan-yuxi-chengjiangxian|yn-yx-cjx'},{'idx':'25,3,5','code':'530423','name':'通海县','search':'云南-玉溪-通海县|yunnan-yuxi-tonghaixian|yn-yx-thx'},{'idx':'25,3,6','code':'530424','name':'华宁县','search':'云南-玉溪-华宁县|yunnan-yuxi-huaningxian|yn-yx-hnx'},{'idx':'25,3,7','code':'530425','name':'易门县','search':'云南-玉溪-易门县|yunnan-yuxi-yimenxian|yn-yx-ymx'},{'idx':'25,3,8','code':'530426','name':'峨山彝族自治县','search':'云南-玉溪-峨山彝族自治县|yunnan-yuxi-eshanyizuzizhixian|yn-yx-esyzzzx'},{'idx':'25,3,9','code':'530427','name':'新平彝族傣族自治县','search':'云南-玉溪-新平彝族傣族自治县|yunnan-yuxi-xinpingyizudaizuzizhixian|yn-yx-xpyzdzzzx'},{'idx':'25,3,10','code':'530428','name':'元江哈尼族彝族傣族自治县','search':'云南-玉溪-元江哈尼族彝族傣族自治县|yunnan-yuxi-yuanjianghanizuyizudaizuzizhixian|yn-yx-yjhnzyzdzzzx'}]},{'idx':'25,4','code':'530500','name':'保山','search':'云南-保山|yunnan-baoshanshi|yn-bss','children':[{'idx':'25,4,0','code':'-1','name':'全市','search':'全市|quansheng|qs'},{'idx':'25,4,1','code':'530501','name':'市辖区','search':'云南-保山-市辖区|yunnan-baoshan-shixiaqu|yn-bs-sxq'},{'idx':'25,4,2','code':'530502','name':'隆阳区','search':'云南-保山-隆阳区|yunnan-baoshan-longyangqu|yn-bs-lyq'},{'idx':'25,4,3','code':'530521','name':'施甸县','search':'云南-保山-施甸县|yunnan-baoshan-shidianxian|yn-bs-sdx'},{'idx':'25,4,4','code':'530523','name':'龙陵县','search':'云南-保山-龙陵县|yunnan-baoshan-longlingxian|yn-bs-llx'},{'idx':'25,4,5','code':'530524','name':'昌宁县','search':'云南-保山-昌宁县|yunnan-baoshan-changningxian|yn-bs-cnx'},{'idx':'25,4,6','code':'530581','name':'腾冲市','search':'云南-保山-腾冲市|yunnan-baoshan-tengchongshi|yn-bs-tcs'}]},{'idx':'25,5','code':'530600','name':'昭通','search':'云南-昭通|yunnan-zhaotongshi|yn-zts','children':[{'idx':'25,5,0','code':'-1','name':'全市','search':'全市|quansheng|qs'},{'idx':'25,5,1','code':'530601','name':'市辖区','search':'云南-昭通-市辖区|yunnan-zhaotong-shixiaqu|yn-zt-sxq'},{'idx':'25,5,2','code':'530602','name':'昭阳区','search':'云南-昭通-昭阳区|yunnan-zhaotong-zhaoyangqu|yn-zt-zyq'},{'idx':'25,5,3','code':'530621','name':'鲁甸县','search':'云南-昭通-鲁甸县|yunnan-zhaotong-ludianxian|yn-zt-ldx'},{'idx':'25,5,4','code':'530622','name':'巧家县','search':'云南-昭通-巧家县|yunnan-zhaotong-qiaojiaxian|yn-zt-qjx'},{'idx':'25,5,5','code':'530623','name':'盐津县','search':'云南-昭通-盐津县|yunnan-zhaotong-yanjinxian|yn-zt-yjx'},{'idx':'25,5,6','code':'530624','name':'大关县','search':'云南-昭通-大关县|yunnan-zhaotong-daguanxian|yn-zt-dgx'},{'idx':'25,5,7','code':'530625','name':'永善县','search':'云南-昭通-永善县|yunnan-zhaotong-yongshanxian|yn-zt-ysx'},{'idx':'25,5,8','code':'530626','name':'绥江县','search':'云南-昭通-绥江县|yunnan-zhaotong-suijiangxian|yn-zt-sjx'},{'idx':'25,5,9','code':'530627','name':'镇雄县','search':'云南-昭通-镇雄县|yunnan-zhaotong-zhenxiongxian|yn-zt-zxx'},{'idx':'25,5,10','code':'530628','name':'彝良县','search':'云南-昭通-彝良县|yunnan-zhaotong-yiliangxian|yn-zt-ylx'},{'idx':'25,5,11','code':'530629','name':'威信县','search':'云南-昭通-威信县|yunnan-zhaotong-weixinxian|yn-zt-wxx'},{'idx':'25,5,12','code':'530630','name':'水富县','search':'云南-昭通-水富县|yunnan-zhaotong-shuifuxian|yn-zt-sfx'}]},{'idx':'25,6','code':'530700','name':'丽江','search':'云南-丽江|yunnan-lijiangshi|yn-ljs','children':[{'idx':'25,6,0','code':'-1','name':'全市','search':'全市|quansheng|qs'},{'idx':'25,6,1','code':'530701','name':'市辖区','search':'云南-丽江-市辖区|yunnan-lijiang-shixiaqu|yn-lj-sxq'},{'idx':'25,6,2','code':'530702','name':'古城区','search':'云南-丽江-古城区|yunnan-lijiang-guchengqu|yn-lj-gcq'},{'idx':'25,6,3','code':'530721','name':'玉龙纳西族自治县','search':'云南-丽江-玉龙纳西族自治县|yunnan-lijiang-yulongnaxizuzizhixian|yn-lj-ylnxzzzx'},{'idx':'25,6,4','code':'530722','name':'永胜县','search':'云南-丽江-永胜县|yunnan-lijiang-yongshengxian|yn-lj-ysx'},{'idx':'25,6,5','code':'530723','name':'华坪县','search':'云南-丽江-华坪县|yunnan-lijiang-huapingxian|yn-lj-hpx'},{'idx':'25,6,6','code':'530724','name':'宁蒗彝族自治县','search':'云南-丽江-宁蒗彝族自治县|yunnan-lijiang-ninglangyizuzizhixian|yn-lj-nlyzzzx'}]},{'idx':'25,7','code':'530800','name':'普洱','search':'云南-普洱|yunnan-puershi|yn-pes','children':[{'idx':'25,7,0','code':'-1','name':'全市','search':'全市|quansheng|qs'},{'idx':'25,7,1','code':'530801','name':'市辖区','search':'云南-普洱-市辖区|yunnan-puer-shixiaqu|yn-pe-sxq'},{'idx':'25,7,2','code':'530802','name':'思茅区','search':'云南-普洱-思茅区|yunnan-puer-simaoqu|yn-pe-smq'},{'idx':'25,7,3','code':'530821','name':'宁洱哈尼族彝族自治县','search':'云南-普洱-宁洱哈尼族彝族自治县|yunnan-puer-ningerhanizuyizuzizhixian|yn-pe-nehnzyzzzx'},{'idx':'25,7,4','code':'530822','name':'墨江哈尼族自治县','search':'云南-普洱-墨江哈尼族自治县|yunnan-puer-mojianghanizuzizhixian|yn-pe-mjhnzzzx'},{'idx':'25,7,5','code':'530823','name':'景东彝族自治县','search':'云南-普洱-景东彝族自治县|yunnan-puer-jingdongyizuzizhixian|yn-pe-jdyzzzx'},{'idx':'25,7,6','code':'530824','name':'景谷傣族彝族自治县','search':'云南-普洱-景谷傣族彝族自治县|yunnan-puer-jinggudaizuyizuzizhixian|yn-pe-jgdzyzzzx'},{'idx':'25,7,7','code':'530825','name':'镇沅彝族哈尼族拉祜族自治县','search':'云南-普洱-镇沅彝族哈尼族拉祜族自治县|yunnan-puer-zhenyuanyizuhanizulahuzuzizhixian|yn-pe-zyyzhnzlhzzzx'},{'idx':'25,7,8','code':'530826','name':'江城哈尼族彝族自治县','search':'云南-普洱-江城哈尼族彝族自治县|yunnan-puer-jiangchenghanizuyizuzizhixian|yn-pe-jchnzyzzzx'},{'idx':'25,7,9','code':'530827','name':'孟连傣族拉祜族佤族自治县','search':'云南-普洱-孟连傣族拉祜族佤族自治县|yunnan-puer-mengliandaizulahuzuwazuzizhixian|yn-pe-mldzlhzwzzzx'},{'idx':'25,7,10','code':'530828','name':'澜沧拉祜族自治县','search':'云南-普洱-澜沧拉祜族自治县|yunnan-puer-lancanglahuzuzizhixian|yn-pe-lclhzzzx'},{'idx':'25,7,11','code':'530829','name':'西盟佤族自治县','search':'云南-普洱-西盟佤族自治县|yunnan-puer-ximengwazuzizhixian|yn-pe-xmwzzzx'}]},{'idx':'25,8','code':'530900','name':'临沧','search':'云南-临沧|yunnan-lincangshi|yn-lcs','children':[{'idx':'25,8,0','code':'-1','name':'全市','search':'全市|quansheng|qs'},{'idx':'25,8,1','code':'530901','name':'市辖区','search':'云南-临沧-市辖区|yunnan-lincang-shixiaqu|yn-lc-sxq'},{'idx':'25,8,2','code':'530902','name':'临翔区','search':'云南-临沧-临翔区|yunnan-lincang-linxiangqu|yn-lc-lxq'},{'idx':'25,8,3','code':'530921','name':'凤庆县','search':'云南-临沧-凤庆县|yunnan-lincang-fengqingxian|yn-lc-fqx'},{'idx':'25,8,4','code':'530922','name':'云县','search':'云南-临沧-云县|yunnan-lincang-yunxian|yn-lc-yx'},{'idx':'25,8,5','code':'530923','name':'永德县','search':'云南-临沧-永德县|yunnan-lincang-yongdexian|yn-lc-ydx'},{'idx':'25,8,6','code':'530924','name':'镇康县','search':'云南-临沧-镇康县|yunnan-lincang-zhenkangxian|yn-lc-zkx'},{'idx':'25,8,7','code':'530925','name':'双江拉祜族佤族布朗族傣族自治县','search':'云南-临沧-双江拉祜族佤族布朗族傣族自治县|yunnan-lincang-shuangjianglahuzuwazubulangzudaizuzizhixian|yn-lc-sjlhzwzblzdzzzx'},{'idx':'25,8,8','code':'530926','name':'耿马傣族佤族自治县','search':'云南-临沧-耿马傣族佤族自治县|yunnan-lincang-gengmadaizuwazuzizhixian|yn-lc-gmdzwzzzx'},{'idx':'25,8,9','code':'530927','name':'沧源佤族自治县','search':'云南-临沧-沧源佤族自治县|yunnan-lincang-cangyuanwazuzizhixian|yn-lc-cywzzzx'}]},{'idx':'25,9','code':'532300','name':'楚雄','search':'云南-楚雄|yunnan-chuxiongyizuzizhizhou|yn-cxyzzzz','children':[{'idx':'25,9,0','code':'-1','name':'全市','search':'全市|quansheng|qs'},{'idx':'25,9,1','code':'532301','name':'楚雄市','search':'云南-楚雄-楚雄市|yunnan-chuxiong-chuxiongshi|yn-cx-cxs'},{'idx':'25,9,2','code':'532322','name':'双柏县','search':'云南-楚雄-双柏县|yunnan-chuxiong-shuangbaixian|yn-cx-sbx'},{'idx':'25,9,3','code':'532323','name':'牟定县','search':'云南-楚雄-牟定县|yunnan-chuxiong-moudingxian|yn-cx-mdx'},{'idx':'25,9,4','code':'532324','name':'南华县','search':'云南-楚雄-南华县|yunnan-chuxiong-nanhuaxian|yn-cx-nhx'},{'idx':'25,9,5','code':'532325','name':'姚安县','search':'云南-楚雄-姚安县|yunnan-chuxiong-yaoanxian|yn-cx-yax'},{'idx':'25,9,6','code':'532326','name':'大姚县','search':'云南-楚雄-大姚县|yunnan-chuxiong-dayaoxian|yn-cx-dyx'},{'idx':'25,9,7','code':'532327','name':'永仁县','search':'云南-楚雄-永仁县|yunnan-chuxiong-yongrenxian|yn-cx-yrx'},{'idx':'25,9,8','code':'532328','name':'元谋县','search':'云南-楚雄-元谋县|yunnan-chuxiong-yuanmouxian|yn-cx-ymx'},{'idx':'25,9,9','code':'532329','name':'武定县','search':'云南-楚雄-武定县|yunnan-chuxiong-wudingxian|yn-cx-wdx'},{'idx':'25,9,10','code':'532331','name':'禄丰县','search':'云南-楚雄-禄丰县|yunnan-chuxiong-lufengxian|yn-cx-lfx'}]},{'idx':'25,10','code':'532500','name':'红河哈尼族','search':'云南-红河哈尼族|yunnan-honghehanizuyizuzizhizhou|yn-hhhnzyzzzz','children':[{'idx':'25,10,0','code':'-1','name':'全市','search':'全市|quansheng|qs'},{'idx':'25,10,1','code':'532501','name':'个旧市','search':'云南-红河哈尼族-个旧市|yunnan-honghehanizu-gejiushi|yn-hhhnz-gjs'},{'idx':'25,10,2','code':'532502','name':'开远市','search':'云南-红河哈尼族-开远市|yunnan-honghehanizu-kaiyuanshi|yn-hhhnz-kys'},{'idx':'25,10,3','code':'532503','name':'蒙自市','search':'云南-红河哈尼族-蒙自市|yunnan-honghehanizu-mengzishi|yn-hhhnz-mzs'},{'idx':'25,10,4','code':'532504','name':'弥勒市','search':'云南-红河哈尼族-弥勒市|yunnan-honghehanizu-mileshi|yn-hhhnz-mls'},{'idx':'25,10,5','code':'532523','name':'屏边苗族自治县','search':'云南-红河哈尼族-屏边苗族自治县|yunnan-honghehanizu-pingbianmiaozuzizhixian|yn-hhhnz-pbmzzzx'},{'idx':'25,10,6','code':'532524','name':'建水县','search':'云南-红河哈尼族-建水县|yunnan-honghehanizu-jianshuixian|yn-hhhnz-jsx'},{'idx':'25,10,7','code':'532525','name':'石屏县','search':'云南-红河哈尼族-石屏县|yunnan-honghehanizu-shipingxian|yn-hhhnz-spx'},{'idx':'25,10,8','code':'532527','name':'泸西县','search':'云南-红河哈尼族-泸西县|yunnan-honghehanizu-luxixian|yn-hhhnz-lxx'},{'idx':'25,10,9','code':'532528','name':'元阳县','search':'云南-红河哈尼族-元阳县|yunnan-honghehanizu-yuanyangxian|yn-hhhnz-yyx'},{'idx':'25,10,10','code':'532529','name':'红河县','search':'云南-红河哈尼族-红河县|yunnan-honghehanizu-honghexian|yn-hhhnz-hhx'},{'idx':'25,10,11','code':'532530','name':'金平苗族瑶族傣族自治县','search':'云南-红河哈尼族-金平苗族瑶族傣族自治县|yunnan-honghehanizu-jinpingmiaozuyaozudaizuzizhixian|yn-hhhnz-jpmzyzdzzzx'},{'idx':'25,10,12','code':'532531','name':'绿春县','search':'云南-红河哈尼族-绿春县|yunnan-honghehanizu-lvchunxian|yn-hhhnz-lcx'},{'idx':'25,10,13','code':'532532','name':'河口瑶族自治县','search':'云南-红河哈尼族-河口瑶族自治县|yunnan-honghehanizu-hekouyaozuzizhixian|yn-hhhnz-hkyzzzx'}]},{'idx':'25,11','code':'532600','name':'文山','search':'云南-文山|yunnan-wenshanzhuangzumiaozuzizhizhou|yn-wszzmzzzz','children':[{'idx':'25,11,0','code':'-1','name':'全市','search':'全市|quansheng|qs'},{'idx':'25,11,1','code':'532601','name':'文山市','search':'云南-文山-文山市|yunnan-wenshan-wenshanshi|yn-ws-wss'},{'idx':'25,11,2','code':'532622','name':'砚山县','search':'云南-文山-砚山县|yunnan-wenshan-yanshanxian|yn-ws-ysx'},{'idx':'25,11,3','code':'532623','name':'西畴县','search':'云南-文山-西畴县|yunnan-wenshan-xichouxian|yn-ws-xcx'},{'idx':'25,11,4','code':'532624','name':'麻栗坡县','search':'云南-文山-麻栗坡县|yunnan-wenshan-malipoxian|yn-ws-mlpx'},{'idx':'25,11,5','code':'532625','name':'马关县','search':'云南-文山-马关县|yunnan-wenshan-maguanxian|yn-ws-mgx'},{'idx':'25,11,6','code':'532626','name':'丘北县','search':'云南-文山-丘北县|yunnan-wenshan-qiubeixian|yn-ws-qbx'},{'idx':'25,11,7','code':'532627','name':'广南县','search':'云南-文山-广南县|yunnan-wenshan-guangnanxian|yn-ws-gnx'},{'idx':'25,11,8','code':'532628','name':'富宁县','search':'云南-文山-富宁县|yunnan-wenshan-funingxian|yn-ws-fnx'}]},{'idx':'25,12','code':'532800','name':'西双版纳','search':'云南-西双版纳|yunnan-xishuangbannadaizuzizhizhou|yn-xsbndzzzz','children':[{'idx':'25,12,0','code':'-1','name':'全市','search':'全市|quansheng|qs'},{'idx':'25,12,1','code':'532801','name':'景洪市','search':'云南-西双版纳-景洪市|yunnan-xishuangbanna-jinghongshi|yn-xsbn-jhs'},{'idx':'25,12,2','code':'532822','name':'勐海县','search':'云南-西双版纳-勐海县|yunnan-xishuangbanna-menghaixian|yn-xsbn-mhx'},{'idx':'25,12,3','code':'532823','name':'勐腊县','search':'云南-西双版纳-勐腊县|yunnan-xishuangbanna-menglaxian|yn-xsbn-mlx'}]},{'idx':'25,13','code':'532900','name':'大理','search':'云南-大理|yunnan-dalibaizuzizhizhou|yn-dlbzzzz','children':[{'idx':'25,13,0','code':'-1','name':'全市','search':'全市|quansheng|qs'},{'idx':'25,13,1','code':'532901','name':'大理市','search':'云南-大理-大理市|yunnan-dali-dalishi|yn-dl-dls'},{'idx':'25,13,2','code':'532922','name':'漾濞彝族自治县','search':'云南-大理-漾濞彝族自治县|yunnan-dali-yangbiyizuzizhixian|yn-dl-ybyzzzx'},{'idx':'25,13,3','code':'532923','name':'祥云县','search':'云南-大理-祥云县|yunnan-dali-xiangyunxian|yn-dl-xyx'},{'idx':'25,13,4','code':'532924','name':'宾川县','search':'云南-大理-宾川县|yunnan-dali-binchuanxian|yn-dl-bcx'},{'idx':'25,13,5','code':'532925','name':'弥渡县','search':'云南-大理-弥渡县|yunnan-dali-miduxian|yn-dl-mdx'},{'idx':'25,13,6','code':'532926','name':'南涧彝族自治县','search':'云南-大理-南涧彝族自治县|yunnan-dali-nanjianyizuzizhixian|yn-dl-njyzzzx'},{'idx':'25,13,7','code':'532927','name':'巍山彝族回族自治县','search':'云南-大理-巍山彝族回族自治县|yunnan-dali-weishanyizuhuizuzizhixian|yn-dl-wsyzhzzzx'},{'idx':'25,13,8','code':'532928','name':'永平县','search':'云南-大理-永平县|yunnan-dali-yongpingxian|yn-dl-ypx'},{'idx':'25,13,9','code':'532929','name':'云龙县','search':'云南-大理-云龙县|yunnan-dali-yunlongxian|yn-dl-ylx'},{'idx':'25,13,10','code':'532930','name':'洱源县','search':'云南-大理-洱源县|yunnan-dali-eryuanxian|yn-dl-eyx'},{'idx':'25,13,11','code':'532931','name':'剑川县','search':'云南-大理-剑川县|yunnan-dali-jianchuanxian|yn-dl-jcx'},{'idx':'25,13,12','code':'532932','name':'鹤庆县','search':'云南-大理-鹤庆县|yunnan-dali-heqingxian|yn-dl-hqx'}]},{'idx':'25,14','code':'533100','name':'德宏','search':'云南-德宏|yunnan-dehongdaizujingpozuzizhizhou|yn-dhdzjpzzzz','children':[{'idx':'25,14,0','code':'-1','name':'全市','search':'全市|quansheng|qs'},{'idx':'25,14,1','code':'533102','name':'瑞丽市','search':'云南-德宏-瑞丽市|yunnan-dehong-ruilishi|yn-dh-rls'},{'idx':'25,14,2','code':'533103','name':'芒市','search':'云南-德宏-芒市|yunnan-dehong-mangshi|yn-dh-ms'},{'idx':'25,14,3','code':'533122','name':'梁河县','search':'云南-德宏-梁河县|yunnan-dehong-lianghexian|yn-dh-lhx'},{'idx':'25,14,4','code':'533123','name':'盈江县','search':'云南-德宏-盈江县|yunnan-dehong-yingjiangxian|yn-dh-yjx'},{'idx':'25,14,5','code':'533124','name':'陇川县','search':'云南-德宏-陇川县|yunnan-dehong-longchuanxian|yn-dh-lcx'}]},{'idx':'25,15','code':'533300','name':'怒江','search':'云南-怒江|yunnan-nujianglisuzuzizhizhou|yn-njlszzzz','children':[{'idx':'25,15,0','code':'-1','name':'全市','search':'全市|quansheng|qs'},{'idx':'25,15,1','code':'533321','name':'泸水县','search':'云南-怒江-泸水县|yunnan-nujiang-lushuixian|yn-nj-lsx'},{'idx':'25,15,2','code':'533323','name':'福贡县','search':'云南-怒江-福贡县|yunnan-nujiang-fugongxian|yn-nj-fgx'},{'idx':'25,15,3','code':'533324','name':'贡山独龙族怒族自治县','search':'云南-怒江-贡山独龙族怒族自治县|yunnan-nujiang-gongshandulongzunuzuzizhixian|yn-nj-gsdlznzzzx'},{'idx':'25,15,4','code':'533325','name':'兰坪白族普米族自治县','search':'云南-怒江-兰坪白族普米族自治县|yunnan-nujiang-lanpingbaizupumizuzizhixian|yn-nj-lpbzpmzzzx'}]},{'idx':'25,16','code':'533400','name':'迪庆','search':'云南-迪庆|yunnan-diqingcangzuzizhizhou|yn-dqczzzz','children':[{'idx':'25,16,0','code':'-1','name':'全市','search':'全市|quansheng|qs'},{'idx':'25,16,1','code':'533401','name':'香格里拉市','search':'云南-迪庆-香格里拉市|yunnan-diqing-xianggelilashi|yn-dq-xglls'},{'idx':'25,16,2','code':'533422','name':'德钦县','search':'云南-迪庆-德钦县|yunnan-diqing-deqinxian|yn-dq-dqx'},{'idx':'25,16,3','code':'533423','name':'维西傈僳族自治县','search':'云南-迪庆-维西傈僳族自治县|yunnan-diqing-weixilisuzuzizhixian|yn-dq-wxlszzzx'}]}]},{'idx':26,'code':'540000','name':'西藏','search':'西藏|xicangzizhiqu|xczzq','children':[{'idx':'26,0','code':'-1','name':'全省','search':'全省|quansheng|qs'},{'idx':'26,1','code':'540100','name':'拉萨','search':'西藏-拉萨|xicang-lasashi|xc-lss','children':[{'idx':'26,1,0','code':'-1','name':'全市','search':'全市|quansheng|qs'},{'idx':'26,1,1','code':'540101','name':'市辖区','search':'西藏-拉萨-市辖区|xicang-lasa-shixiaqu|xc-ls-sxq'},{'idx':'26,1,2','code':'540102','name':'城关区','search':'西藏-拉萨-城关区|xicang-lasa-chengguanqu|xc-ls-cgq'},{'idx':'26,1,3','code':'540121','name':'林周县','search':'西藏-拉萨-林周县|xicang-lasa-linzhouxian|xc-ls-lzx'},{'idx':'26,1,4','code':'540122','name':'当雄县','search':'西藏-拉萨-当雄县|xicang-lasa-dangxiongxian|xc-ls-dxx'},{'idx':'26,1,5','code':'540123','name':'尼木县','search':'西藏-拉萨-尼木县|xicang-lasa-nimuxian|xc-ls-nmx'},{'idx':'26,1,6','code':'540124','name':'曲水县','search':'西藏-拉萨-曲水县|xicang-lasa-qushuixian|xc-ls-qsx'},{'idx':'26,1,7','code':'540125','name':'堆龙德庆县','search':'西藏-拉萨-堆龙德庆县|xicang-lasa-duilongdeqingxian|xc-ls-dldqx'},{'idx':'26,1,8','code':'540126','name':'达孜县','search':'西藏-拉萨-达孜县|xicang-lasa-dazixian|xc-ls-dzx'},{'idx':'26,1,9','code':'540127','name':'墨竹工卡县','search':'西藏-拉萨-墨竹工卡县|xicang-lasa-mozhugongkaxian|xc-ls-mzgkx'}]},{'idx':'26,2','code':'540200','name':'日喀则','search':'西藏-日喀则|xicang-rikazeshi|xc-rkzs','children':[{'idx':'26,2,0','code':'-1','name':'全市','search':'全市|quansheng|qs'},{'idx':'26,2,1','code':'540202','name':'桑珠孜区','search':'西藏-日喀则-桑珠孜区|xicang-rikaze-sangzhuziqu|xc-rkz-szzq'},{'idx':'26,2,2','code':'540221','name':'南木林县','search':'西藏-日喀则-南木林县|xicang-rikaze-nanmulinxian|xc-rkz-nmlx'},{'idx':'26,2,3','code':'540222','name':'江孜县','search':'西藏-日喀则-江孜县|xicang-rikaze-jiangzixian|xc-rkz-jzx'},{'idx':'26,2,4','code':'540223','name':'定日县','search':'西藏-日喀则-定日县|xicang-rikaze-dingrixian|xc-rkz-drx'},{'idx':'26,2,5','code':'540224','name':'萨迦县','search':'西藏-日喀则-萨迦县|xicang-rikaze-sajiaxian|xc-rkz-sjx'},{'idx':'26,2,6','code':'540225','name':'拉孜县','search':'西藏-日喀则-拉孜县|xicang-rikaze-lazixian|xc-rkz-lzx'},{'idx':'26,2,7','code':'540226','name':'昂仁县','search':'西藏-日喀则-昂仁县|xicang-rikaze-angrenxian|xc-rkz-arx'},{'idx':'26,2,8','code':'540227','name':'谢通门县','search':'西藏-日喀则-谢通门县|xicang-rikaze-xietongmenxian|xc-rkz-xtmx'},{'idx':'26,2,9','code':'540228','name':'白朗县','search':'西藏-日喀则-白朗县|xicang-rikaze-bailangxian|xc-rkz-blx'},{'idx':'26,2,10','code':'540229','name':'仁布县','search':'西藏-日喀则-仁布县|xicang-rikaze-renbuxian|xc-rkz-rbx'},{'idx':'26,2,11','code':'540230','name':'康马县','search':'西藏-日喀则-康马县|xicang-rikaze-kangmaxian|xc-rkz-kmx'},{'idx':'26,2,12','code':'540231','name':'定结县','search':'西藏-日喀则-定结县|xicang-rikaze-dingjiexian|xc-rkz-djx'},{'idx':'26,2,13','code':'540232','name':'仲巴县','search':'西藏-日喀则-仲巴县|xicang-rikaze-zhongbaxian|xc-rkz-zbx'},{'idx':'26,2,14','code':'540233','name':'亚东县','search':'西藏-日喀则-亚东县|xicang-rikaze-yadongxian|xc-rkz-ydx'},{'idx':'26,2,15','code':'540234','name':'吉隆县','search':'西藏-日喀则-吉隆县|xicang-rikaze-jilongxian|xc-rkz-jlx'},{'idx':'26,2,16','code':'540235','name':'聂拉木县','search':'西藏-日喀则-聂拉木县|xicang-rikaze-nielamuxian|xc-rkz-nlmx'},{'idx':'26,2,17','code':'540236','name':'萨嘎县','search':'西藏-日喀则-萨嘎县|xicang-rikaze-sagaxian|xc-rkz-sgx'},{'idx':'26,2,18','code':'540237','name':'岗巴县','search':'西藏-日喀则-岗巴县|xicang-rikaze-gangbaxian|xc-rkz-gbx'}]},{'idx':'26,3','code':'540300','name':'昌都','search':'西藏-昌都|xicang-changdushi|xc-cds','children':[{'idx':'26,3,0','code':'-1','name':'全市','search':'全市|quansheng|qs'},{'idx':'26,3,1','code':'540302','name':'卡若区','search':'西藏-昌都-卡若区|xicang-changdu-karuoqu|xc-cd-krq'},{'idx':'26,3,2','code':'540321','name':'江达县','search':'西藏-昌都-江达县|xicang-changdu-jiangdaxian|xc-cd-jdx'},{'idx':'26,3,3','code':'540322','name':'贡觉县','search':'西藏-昌都-贡觉县|xicang-changdu-gongjuexian|xc-cd-gjx'},{'idx':'26,3,4','code':'540323','name':'类乌齐县','search':'西藏-昌都-类乌齐县|xicang-changdu-leiwuqixian|xc-cd-lwqx'},{'idx':'26,3,5','code':'540324','name':'丁青县','search':'西藏-昌都-丁青县|xicang-changdu-dingqingxian|xc-cd-dqx'},{'idx':'26,3,6','code':'540325','name':'察雅县','search':'西藏-昌都-察雅县|xicang-changdu-chayaxian|xc-cd-cyx'},{'idx':'26,3,7','code':'540326','name':'八宿县','search':'西藏-昌都-八宿县|xicang-changdu-basuxian|xc-cd-bsx'},{'idx':'26,3,8','code':'540327','name':'左贡县','search':'西藏-昌都-左贡县|xicang-changdu-zuogongxian|xc-cd-zgx'},{'idx':'26,3,9','code':'540328','name':'芒康县','search':'西藏-昌都-芒康县|xicang-changdu-mangkangxian|xc-cd-mkx'},{'idx':'26,3,10','code':'540329','name':'洛隆县','search':'西藏-昌都-洛隆县|xicang-changdu-luolongxian|xc-cd-llx'},{'idx':'26,3,11','code':'540330','name':'边坝县','search':'西藏-昌都-边坝县|xicang-changdu-bianbaxian|xc-cd-bbx'}]},{'idx':'26,4','code':'540400','name':'林芝','search':'西藏-林芝|xicang-linzhishi|xc-lzs','children':[{'idx':'26,4,0','code':'-1','name':'全市','search':'全市|quansheng|qs'},{'idx':'26,4,1','code':'540402','name':'巴宜区','search':'西藏-林芝-巴宜区|xicang-linzhi-bayiqu|xc-lz-byq'},{'idx':'26,4,2','code':'540421','name':'工布江达县','search':'西藏-林芝-工布江达县|xicang-linzhi-gongbujiangdaxian|xc-lz-gbjdx'},{'idx':'26,4,3','code':'540422','name':'米林县','search':'西藏-林芝-米林县|xicang-linzhi-milinxian|xc-lz-mlx'},{'idx':'26,4,4','code':'540423','name':'墨脱县','search':'西藏-林芝-墨脱县|xicang-linzhi-motuoxian|xc-lz-mtx'},{'idx':'26,4,5','code':'540424','name':'波密县','search':'西藏-林芝-波密县|xicang-linzhi-bomixian|xc-lz-bmx'},{'idx':'26,4,6','code':'540425','name':'察隅县','search':'西藏-林芝-察隅县|xicang-linzhi-chayuxian|xc-lz-cyx'},{'idx':'26,4,7','code':'540426','name':'朗县','search':'西藏-林芝-朗县|xicang-linzhi-langxian|xc-lz-lx'}]},{'idx':'26,5','code':'542200','name':'山南','search':'西藏-山南|xicang-shannandiqu|xc-sndq','children':[{'idx':'26,5,0','code':'-1','name':'全市','search':'全市|quansheng|qs'},{'idx':'26,5,1','code':'542221','name':'乃东县','search':'西藏-山南-乃东县|xicang-shannan-naidongxian|xc-sn-ndx'},{'idx':'26,5,2','code':'542222','name':'扎囊县','search':'西藏-山南-扎囊县|xicang-shannan-zhanangxian|xc-sn-znx'},{'idx':'26,5,3','code':'542223','name':'贡嘎县','search':'西藏-山南-贡嘎县|xicang-shannan-gonggaxian|xc-sn-ggx'},{'idx':'26,5,4','code':'542224','name':'桑日县','search':'西藏-山南-桑日县|xicang-shannan-sangrixian|xc-sn-srx'},{'idx':'26,5,5','code':'542225','name':'琼结县','search':'西藏-山南-琼结县|xicang-shannan-qiongjiexian|xc-sn-qjx'},{'idx':'26,5,6','code':'542226','name':'曲松县','search':'西藏-山南-曲松县|xicang-shannan-qusongxian|xc-sn-qsx'},{'idx':'26,5,7','code':'542227','name':'措美县','search':'西藏-山南-措美县|xicang-shannan-cuomeixian|xc-sn-cmx'},{'idx':'26,5,8','code':'542228','name':'洛扎县','search':'西藏-山南-洛扎县|xicang-shannan-luozhaxian|xc-sn-lzx'},{'idx':'26,5,9','code':'542229','name':'加查县','search':'西藏-山南-加查县|xicang-shannan-jiachaxian|xc-sn-jcx'},{'idx':'26,5,10','code':'542231','name':'隆子县','search':'西藏-山南-隆子县|xicang-shannan-longzixian|xc-sn-lzx'},{'idx':'26,5,11','code':'542232','name':'错那县','search':'西藏-山南-错那县|xicang-shannan-cuonaxian|xc-sn-cnx'},{'idx':'26,5,12','code':'542233','name':'浪卡子县','search':'西藏-山南-浪卡子县|xicang-shannan-langkazixian|xc-sn-lkzx'}]},{'idx':'26,6','code':'542400','name':'那曲','search':'西藏-那曲|xicang-naqudiqu|xc-nqdq','children':[{'idx':'26,6,0','code':'-1','name':'全市','search':'全市|quansheng|qs'},{'idx':'26,6,1','code':'542421','name':'那曲县','search':'西藏-那曲-那曲县|xicang-naqu-naquxian|xc-nq-nqx'},{'idx':'26,6,2','code':'542422','name':'嘉黎县','search':'西藏-那曲-嘉黎县|xicang-naqu-jialixian|xc-nq-jlx'},{'idx':'26,6,3','code':'542423','name':'比如县','search':'西藏-那曲-比如县|xicang-naqu-biruxian|xc-nq-brx'},{'idx':'26,6,4','code':'542424','name':'聂荣县','search':'西藏-那曲-聂荣县|xicang-naqu-nierongxian|xc-nq-nrx'},{'idx':'26,6,5','code':'542425','name':'安多县','search':'西藏-那曲-安多县|xicang-naqu-anduoxian|xc-nq-adx'},{'idx':'26,6,6','code':'542426','name':'申扎县','search':'西藏-那曲-申扎县|xicang-naqu-shenzhaxian|xc-nq-szx'},{'idx':'26,6,7','code':'542427','name':'索县','search':'西藏-那曲-索县|xicang-naqu-suoxian|xc-nq-sx'},{'idx':'26,6,8','code':'542428','name':'班戈县','search':'西藏-那曲-班戈县|xicang-naqu-bangexian|xc-nq-bgx'},{'idx':'26,6,9','code':'542429','name':'巴青县','search':'西藏-那曲-巴青县|xicang-naqu-baqingxian|xc-nq-bqx'},{'idx':'26,6,10','code':'542430','name':'尼玛县','search':'西藏-那曲-尼玛县|xicang-naqu-nimaxian|xc-nq-nmx'},{'idx':'26,6,11','code':'542431','name':'双湖县','search':'西藏-那曲-双湖县|xicang-naqu-shuanghuxian|xc-nq-shx'}]},{'idx':'26,7','code':'542500','name':'阿里','search':'西藏-阿里|xicang-alidiqu|xc-aldq','children':[{'idx':'26,7,0','code':'-1','name':'全市','search':'全市|quansheng|qs'},{'idx':'26,7,1','code':'542521','name':'普兰县','search':'西藏-阿里-普兰县|xicang-ali-pulanxian|xc-al-plx'},{'idx':'26,7,2','code':'542522','name':'札达县','search':'西藏-阿里-札达县|xicang-ali-zhadaxian|xc-al-zdx'},{'idx':'26,7,3','code':'542523','name':'噶尔县','search':'西藏-阿里-噶尔县|xicang-ali-gaerxian|xc-al-gex'},{'idx':'26,7,4','code':'542524','name':'日土县','search':'西藏-阿里-日土县|xicang-ali-rituxian|xc-al-rtx'},{'idx':'26,7,5','code':'542525','name':'革吉县','search':'西藏-阿里-革吉县|xicang-ali-gejixian|xc-al-gjx'},{'idx':'26,7,6','code':'542526','name':'改则县','search':'西藏-阿里-改则县|xicang-ali-gaizexian|xc-al-gzx'},{'idx':'26,7,7','code':'542527','name':'措勤县','search':'西藏-阿里-措勤县|xicang-ali-cuoqinxian|xc-al-cqx'}]}]},{'idx':27,'code':'610000','name':'陕西','search':'陕西|shanxisheng|sxs','children':[{'idx':'27,0','code':'-1','name':'全省','search':'全省|quansheng|qs'},{'idx':'27,1','code':'610100','name':'西安','search':'陕西-西安|shanxi-xianshi|sx-xas','children':[{'idx':'27,1,0','code':'-1','name':'全市','search':'全市|quansheng|qs'},{'idx':'27,1,1','code':'610101','name':'市辖区','search':'陕西-西安-市辖区|shanxi-xian-shixiaqu|sx-xa-sxq'},{'idx':'27,1,2','code':'610102','name':'新城区','search':'陕西-西安-新城区|shanxi-xian-xinchengqu|sx-xa-xcq'},{'idx':'27,1,3','code':'610103','name':'碑林区','search':'陕西-西安-碑林区|shanxi-xian-beilinqu|sx-xa-blq'},{'idx':'27,1,4','code':'610104','name':'莲湖区','search':'陕西-西安-莲湖区|shanxi-xian-lianhuqu|sx-xa-lhq'},{'idx':'27,1,5','code':'610111','name':'灞桥区','search':'陕西-西安-灞桥区|shanxi-xian-baqiaoqu|sx-xa-bqq'},{'idx':'27,1,6','code':'610112','name':'未央区','search':'陕西-西安-未央区|shanxi-xian-weiyangqu|sx-xa-wyq'},{'idx':'27,1,7','code':'610113','name':'雁塔区','search':'陕西-西安-雁塔区|shanxi-xian-yantaqu|sx-xa-ytq'},{'idx':'27,1,8','code':'610114','name':'阎良区','search':'陕西-西安-阎良区|shanxi-xian-yanliangqu|sx-xa-ylq'},{'idx':'27,1,9','code':'610115','name':'临潼区','search':'陕西-西安-临潼区|shanxi-xian-lintongqu|sx-xa-ltq'},{'idx':'27,1,10','code':'610116','name':'长安区','search':'陕西-西安-长安区|shanxi-xian-changanqu|sx-xa-caq'},{'idx':'27,1,11','code':'610117','name':'高陵区','search':'陕西-西安-高陵区|shanxi-xian-gaolingqu|sx-xa-glq'},{'idx':'27,1,12','code':'610122','name':'蓝田县','search':'陕西-西安-蓝田县|shanxi-xian-lantianxian|sx-xa-ltx'},{'idx':'27,1,13','code':'610124','name':'周至县','search':'陕西-西安-周至县|shanxi-xian-zhouzhixian|sx-xa-zzx'},{'idx':'27,1,14','code':'610125','name':'户县','search':'陕西-西安-户县|shanxi-xian-huxian|sx-xa-hx'}]},{'idx':'27,2','code':'610200','name':'铜川','search':'陕西-铜川|shanxi-tongchuanshi|sx-tcs','children':[{'idx':'27,2,0','code':'-1','name':'全市','search':'全市|quansheng|qs'},{'idx':'27,2,1','code':'610201','name':'市辖区','search':'陕西-铜川-市辖区|shanxi-tongchuan-shixiaqu|sx-tc-sxq'},{'idx':'27,2,2','code':'610202','name':'王益区','search':'陕西-铜川-王益区|shanxi-tongchuan-wangyiqu|sx-tc-wyq'},{'idx':'27,2,3','code':'610203','name':'印台区','search':'陕西-铜川-印台区|shanxi-tongchuan-yintaiqu|sx-tc-ytq'},{'idx':'27,2,4','code':'610204','name':'耀州区','search':'陕西-铜川-耀州区|shanxi-tongchuan-yaozhouqu|sx-tc-yzq'},{'idx':'27,2,5','code':'610222','name':'宜君县','search':'陕西-铜川-宜君县|shanxi-tongchuan-yijunxian|sx-tc-yjx'}]},{'idx':'27,3','code':'610300','name':'宝鸡','search':'陕西-宝鸡|shanxi-baojishi|sx-bjs','children':[{'idx':'27,3,0','code':'-1','name':'全市','search':'全市|quansheng|qs'},{'idx':'27,3,1','code':'610301','name':'市辖区','search':'陕西-宝鸡-市辖区|shanxi-baoji-shixiaqu|sx-bj-sxq'},{'idx':'27,3,2','code':'610302','name':'渭滨区','search':'陕西-宝鸡-渭滨区|shanxi-baoji-weibinqu|sx-bj-wbq'},{'idx':'27,3,3','code':'610303','name':'金台区','search':'陕西-宝鸡-金台区|shanxi-baoji-jintaiqu|sx-bj-jtq'},{'idx':'27,3,4','code':'610304','name':'陈仓区','search':'陕西-宝鸡-陈仓区|shanxi-baoji-chencangqu|sx-bj-ccq'},{'idx':'27,3,5','code':'610322','name':'凤翔县','search':'陕西-宝鸡-凤翔县|shanxi-baoji-fengxiangxian|sx-bj-fxx'},{'idx':'27,3,6','code':'610323','name':'岐山县','search':'陕西-宝鸡-岐山县|shanxi-baoji-qishanxian|sx-bj-qsx'},{'idx':'27,3,7','code':'610324','name':'扶风县','search':'陕西-宝鸡-扶风县|shanxi-baoji-fufengxian|sx-bj-ffx'},{'idx':'27,3,8','code':'610326','name':'眉县','search':'陕西-宝鸡-眉县|shanxi-baoji-meixian|sx-bj-mx'},{'idx':'27,3,9','code':'610327','name':'陇县','search':'陕西-宝鸡-陇县|shanxi-baoji-longxian|sx-bj-lx'},{'idx':'27,3,10','code':'610328','name':'千阳县','search':'陕西-宝鸡-千阳县|shanxi-baoji-qianyangxian|sx-bj-qyx'},{'idx':'27,3,11','code':'610329','name':'麟游县','search':'陕西-宝鸡-麟游县|shanxi-baoji-linyouxian|sx-bj-lyx'},{'idx':'27,3,12','code':'610330','name':'凤县','search':'陕西-宝鸡-凤县|shanxi-baoji-fengxian|sx-bj-fx'},{'idx':'27,3,13','code':'610331','name':'太白县','search':'陕西-宝鸡-太白县|shanxi-baoji-taibaixian|sx-bj-tbx'}]},{'idx':'27,4','code':'610400','name':'咸阳','search':'陕西-咸阳|shanxi-xianyangshi|sx-xys','children':[{'idx':'27,4,0','code':'-1','name':'全市','search':'全市|quansheng|qs'},{'idx':'27,4,1','code':'610401','name':'市辖区','search':'陕西-咸阳-市辖区|shanxi-xianyang-shixiaqu|sx-xy-sxq'},{'idx':'27,4,2','code':'610402','name':'秦都区','search':'陕西-咸阳-秦都区|shanxi-xianyang-qinduqu|sx-xy-qdq'},{'idx':'27,4,3','code':'610403','name':'杨陵区','search':'陕西-咸阳-杨陵区|shanxi-xianyang-yanglingqu|sx-xy-ylq'},{'idx':'27,4,4','code':'610404','name':'渭城区','search':'陕西-咸阳-渭城区|shanxi-xianyang-weichengqu|sx-xy-wcq'},{'idx':'27,4,5','code':'610422','name':'三原县','search':'陕西-咸阳-三原县|shanxi-xianyang-sanyuanxian|sx-xy-syx'},{'idx':'27,4,6','code':'610423','name':'泾阳县','search':'陕西-咸阳-泾阳县|shanxi-xianyang-jingyangxian|sx-xy-jyx'},{'idx':'27,4,7','code':'610424','name':'乾县','search':'陕西-咸阳-乾县|shanxi-xianyang-qianxian|sx-xy-qx'},{'idx':'27,4,8','code':'610425','name':'礼泉县','search':'陕西-咸阳-礼泉县|shanxi-xianyang-liquanxian|sx-xy-lqx'},{'idx':'27,4,9','code':'610426','name':'永寿县','search':'陕西-咸阳-永寿县|shanxi-xianyang-yongshouxian|sx-xy-ysx'},{'idx':'27,4,10','code':'610427','name':'彬县','search':'陕西-咸阳-彬县|shanxi-xianyang-binxian|sx-xy-bx'},{'idx':'27,4,11','code':'610428','name':'长武县','search':'陕西-咸阳-长武县|shanxi-xianyang-changwuxian|sx-xy-cwx'},{'idx':'27,4,12','code':'610429','name':'旬邑县','search':'陕西-咸阳-旬邑县|shanxi-xianyang-xunyixian|sx-xy-xyx'},{'idx':'27,4,13','code':'610430','name':'淳化县','search':'陕西-咸阳-淳化县|shanxi-xianyang-chunhuaxian|sx-xy-chx'},{'idx':'27,4,14','code':'610431','name':'武功县','search':'陕西-咸阳-武功县|shanxi-xianyang-wugongxian|sx-xy-wgx'},{'idx':'27,4,15','code':'610481','name':'兴平市','search':'陕西-咸阳-兴平市|shanxi-xianyang-xingpingshi|sx-xy-xps'}]},{'idx':'27,5','code':'610500','name':'渭南','search':'陕西-渭南|shanxi-weinanshi|sx-wns','children':[{'idx':'27,5,0','code':'-1','name':'全市','search':'全市|quansheng|qs'},{'idx':'27,5,1','code':'610501','name':'市辖区','search':'陕西-渭南-市辖区|shanxi-weinan-shixiaqu|sx-wn-sxq'},{'idx':'27,5,2','code':'610502','name':'临渭区','search':'陕西-渭南-临渭区|shanxi-weinan-linweiqu|sx-wn-lwq'},{'idx':'27,5,3','code':'610521','name':'华县','search':'陕西-渭南-华县|shanxi-weinan-huaxian|sx-wn-hx'},{'idx':'27,5,4','code':'610522','name':'潼关县','search':'陕西-渭南-潼关县|shanxi-weinan-tongguanxian|sx-wn-tgx'},{'idx':'27,5,5','code':'610523','name':'大荔县','search':'陕西-渭南-大荔县|shanxi-weinan-dalixian|sx-wn-dlx'},{'idx':'27,5,6','code':'610524','name':'合阳县','search':'陕西-渭南-合阳县|shanxi-weinan-heyangxian|sx-wn-hyx'},{'idx':'27,5,7','code':'610525','name':'澄城县','search':'陕西-渭南-澄城县|shanxi-weinan-chengchengxian|sx-wn-ccx'},{'idx':'27,5,8','code':'610526','name':'蒲城县','search':'陕西-渭南-蒲城县|shanxi-weinan-puchengxian|sx-wn-pcx'},{'idx':'27,5,9','code':'610527','name':'白水县','search':'陕西-渭南-白水县|shanxi-weinan-baishuixian|sx-wn-bsx'},{'idx':'27,5,10','code':'610528','name':'富平县','search':'陕西-渭南-富平县|shanxi-weinan-fupingxian|sx-wn-fpx'},{'idx':'27,5,11','code':'610581','name':'韩城市','search':'陕西-渭南-韩城市|shanxi-weinan-hanchengshi|sx-wn-hcs'},{'idx':'27,5,12','code':'610582','name':'华阴市','search':'陕西-渭南-华阴市|shanxi-weinan-huayinshi|sx-wn-hys'}]},{'idx':'27,6','code':'610600','name':'延安','search':'陕西-延安|shanxi-yananshi|sx-yas','children':[{'idx':'27,6,0','code':'-1','name':'全市','search':'全市|quansheng|qs'},{'idx':'27,6,1','code':'610601','name':'市辖区','search':'陕西-延安-市辖区|shanxi-yanan-shixiaqu|sx-ya-sxq'},{'idx':'27,6,2','code':'610602','name':'宝塔区','search':'陕西-延安-宝塔区|shanxi-yanan-baotaqu|sx-ya-btq'},{'idx':'27,6,3','code':'610621','name':'延长县','search':'陕西-延安-延长县|shanxi-yanan-yanchangxian|sx-ya-ycx'},{'idx':'27,6,4','code':'610622','name':'延川县','search':'陕西-延安-延川县|shanxi-yanan-yanchuanxian|sx-ya-ycx'},{'idx':'27,6,5','code':'610623','name':'子长县','search':'陕西-延安-子长县|shanxi-yanan-zichangxian|sx-ya-zcx'},{'idx':'27,6,6','code':'610624','name':'安塞县','search':'陕西-延安-安塞县|shanxi-yanan-ansaixian|sx-ya-asx'},{'idx':'27,6,7','code':'610625','name':'志丹县','search':'陕西-延安-志丹县|shanxi-yanan-zhidanxian|sx-ya-zdx'},{'idx':'27,6,8','code':'610626','name':'吴起县','search':'陕西-延安-吴起县|shanxi-yanan-wuqixian|sx-ya-wqx'},{'idx':'27,6,9','code':'610627','name':'甘泉县','search':'陕西-延安-甘泉县|shanxi-yanan-ganquanxian|sx-ya-gqx'},{'idx':'27,6,10','code':'610628','name':'富县','search':'陕西-延安-富县|shanxi-yanan-fuxian|sx-ya-fx'},{'idx':'27,6,11','code':'610629','name':'洛川县','search':'陕西-延安-洛川县|shanxi-yanan-luochuanxian|sx-ya-lcx'},{'idx':'27,6,12','code':'610630','name':'宜川县','search':'陕西-延安-宜川县|shanxi-yanan-yichuanxian|sx-ya-ycx'},{'idx':'27,6,13','code':'610631','name':'黄龙县','search':'陕西-延安-黄龙县|shanxi-yanan-huanglongxian|sx-ya-hlx'},{'idx':'27,6,14','code':'610632','name':'黄陵县','search':'陕西-延安-黄陵县|shanxi-yanan-huanglingxian|sx-ya-hlx'}]},{'idx':'27,7','code':'610700','name':'汉中','search':'陕西-汉中|shanxi-hanzhongshi|sx-hzs','children':[{'idx':'27,7,0','code':'-1','name':'全市','search':'全市|quansheng|qs'},{'idx':'27,7,1','code':'610701','name':'市辖区','search':'陕西-汉中-市辖区|shanxi-hanzhong-shixiaqu|sx-hz-sxq'},{'idx':'27,7,2','code':'610702','name':'汉台区','search':'陕西-汉中-汉台区|shanxi-hanzhong-hantaiqu|sx-hz-htq'},{'idx':'27,7,3','code':'610721','name':'南郑县','search':'陕西-汉中-南郑县|shanxi-hanzhong-nanzhengxian|sx-hz-nzx'},{'idx':'27,7,4','code':'610722','name':'城固县','search':'陕西-汉中-城固县|shanxi-hanzhong-chengguxian|sx-hz-cgx'},{'idx':'27,7,5','code':'610723','name':'洋县','search':'陕西-汉中-洋县|shanxi-hanzhong-yangxian|sx-hz-yx'},{'idx':'27,7,6','code':'610724','name':'西乡县','search':'陕西-汉中-西乡县|shanxi-hanzhong-xixiangxian|sx-hz-xxx'},{'idx':'27,7,7','code':'610725','name':'勉县','search':'陕西-汉中-勉县|shanxi-hanzhong-mianxian|sx-hz-mx'},{'idx':'27,7,8','code':'610726','name':'宁强县','search':'陕西-汉中-宁强县|shanxi-hanzhong-ningqiangxian|sx-hz-nqx'},{'idx':'27,7,9','code':'610727','name':'略阳县','search':'陕西-汉中-略阳县|shanxi-hanzhong-lueyangxian|sx-hz-lyx'},{'idx':'27,7,10','code':'610728','name':'镇巴县','search':'陕西-汉中-镇巴县|shanxi-hanzhong-zhenbaxian|sx-hz-zbx'},{'idx':'27,7,11','code':'610729','name':'留坝县','search':'陕西-汉中-留坝县|shanxi-hanzhong-liubaxian|sx-hz-lbx'},{'idx':'27,7,12','code':'610730','name':'佛坪县','search':'陕西-汉中-佛坪县|shanxi-hanzhong-fopingxian|sx-hz-fpx'}]},{'idx':'27,8','code':'610800','name':'榆林','search':'陕西-榆林|shanxi-yulinshi|sx-yls','children':[{'idx':'27,8,0','code':'-1','name':'全市','search':'全市|quansheng|qs'},{'idx':'27,8,1','code':'610801','name':'市辖区','search':'陕西-榆林-市辖区|shanxi-yulin-shixiaqu|sx-yl-sxq'},{'idx':'27,8,2','code':'610802','name':'榆阳区','search':'陕西-榆林-榆阳区|shanxi-yulin-yuyangqu|sx-yl-yyq'},{'idx':'27,8,3','code':'610821','name':'神木县','search':'陕西-榆林-神木县|shanxi-yulin-shenmuxian|sx-yl-smx'},{'idx':'27,8,4','code':'610822','name':'府谷县','search':'陕西-榆林-府谷县|shanxi-yulin-fuguxian|sx-yl-fgx'},{'idx':'27,8,5','code':'610823','name':'横山县','search':'陕西-榆林-横山县|shanxi-yulin-hengshanxian|sx-yl-hsx'},{'idx':'27,8,6','code':'610824','name':'靖边县','search':'陕西-榆林-靖边县|shanxi-yulin-jingbianxian|sx-yl-jbx'},{'idx':'27,8,7','code':'610825','name':'定边县','search':'陕西-榆林-定边县|shanxi-yulin-dingbianxian|sx-yl-dbx'},{'idx':'27,8,8','code':'610826','name':'绥德县','search':'陕西-榆林-绥德县|shanxi-yulin-suidexian|sx-yl-sdx'},{'idx':'27,8,9','code':'610827','name':'米脂县','search':'陕西-榆林-米脂县|shanxi-yulin-mizhixian|sx-yl-mzx'},{'idx':'27,8,10','code':'610828','name':'佳县','search':'陕西-榆林-佳县|shanxi-yulin-jiaxian|sx-yl-jx'},{'idx':'27,8,11','code':'610829','name':'吴堡县','search':'陕西-榆林-吴堡县|shanxi-yulin-wubaoxian|sx-yl-wbx'},{'idx':'27,8,12','code':'610830','name':'清涧县','search':'陕西-榆林-清涧县|shanxi-yulin-qingjianxian|sx-yl-qjx'},{'idx':'27,8,13','code':'610831','name':'子洲县','search':'陕西-榆林-子洲县|shanxi-yulin-zizhouxian|sx-yl-zzx'}]},{'idx':'27,9','code':'610900','name':'安康','search':'陕西-安康|shanxi-ankangshi|sx-aks','children':[{'idx':'27,9,0','code':'-1','name':'全市','search':'全市|quansheng|qs'},{'idx':'27,9,1','code':'610901','name':'市辖区','search':'陕西-安康-市辖区|shanxi-ankang-shixiaqu|sx-ak-sxq'},{'idx':'27,9,2','code':'610902','name':'汉滨区','search':'陕西-安康-汉滨区|shanxi-ankang-hanbinqu|sx-ak-hbq'},{'idx':'27,9,3','code':'610921','name':'汉阴县','search':'陕西-安康-汉阴县|shanxi-ankang-hanyinxian|sx-ak-hyx'},{'idx':'27,9,4','code':'610922','name':'石泉县','search':'陕西-安康-石泉县|shanxi-ankang-shiquanxian|sx-ak-sqx'},{'idx':'27,9,5','code':'610923','name':'宁陕县','search':'陕西-安康-宁陕县|shanxi-ankang-ningshanxian|sx-ak-nsx'},{'idx':'27,9,6','code':'610924','name':'紫阳县','search':'陕西-安康-紫阳县|shanxi-ankang-ziyangxian|sx-ak-zyx'},{'idx':'27,9,7','code':'610925','name':'岚皋县','search':'陕西-安康-岚皋县|shanxi-ankang-langaoxian|sx-ak-lgx'},{'idx':'27,9,8','code':'610926','name':'平利县','search':'陕西-安康-平利县|shanxi-ankang-pinglixian|sx-ak-plx'},{'idx':'27,9,9','code':'610927','name':'镇坪县','search':'陕西-安康-镇坪县|shanxi-ankang-zhenpingxian|sx-ak-zpx'},{'idx':'27,9,10','code':'610928','name':'旬阳县','search':'陕西-安康-旬阳县|shanxi-ankang-xunyangxian|sx-ak-xyx'},{'idx':'27,9,11','code':'610929','name':'白河县','search':'陕西-安康-白河县|shanxi-ankang-baihexian|sx-ak-bhx'}]},{'idx':'27,10','code':'611000','name':'商洛','search':'陕西-商洛|shanxi-shangluoshi|sx-sls','children':[{'idx':'27,10,0','code':'-1','name':'全市','search':'全市|quansheng|qs'},{'idx':'27,10,1','code':'611001','name':'市辖区','search':'陕西-商洛-市辖区|shanxi-shangluo-shixiaqu|sx-sl-sxq'},{'idx':'27,10,2','code':'611002','name':'商州区','search':'陕西-商洛-商州区|shanxi-shangluo-shangzhouqu|sx-sl-szq'},{'idx':'27,10,3','code':'611021','name':'洛南县','search':'陕西-商洛-洛南县|shanxi-shangluo-luonanxian|sx-sl-lnx'},{'idx':'27,10,4','code':'611022','name':'丹凤县','search':'陕西-商洛-丹凤县|shanxi-shangluo-danfengxian|sx-sl-dfx'},{'idx':'27,10,5','code':'611023','name':'商南县','search':'陕西-商洛-商南县|shanxi-shangluo-shangnanxian|sx-sl-snx'},{'idx':'27,10,6','code':'611024','name':'山阳县','search':'陕西-商洛-山阳县|shanxi-shangluo-shanyangxian|sx-sl-syx'},{'idx':'27,10,7','code':'611025','name':'镇安县','search':'陕西-商洛-镇安县|shanxi-shangluo-zhenanxian|sx-sl-zax'},{'idx':'27,10,8','code':'611026','name':'柞水县','search':'陕西-商洛-柞水县|shanxi-shangluo-zuoshuixian|sx-sl-zsx'}]}]},{'idx':28,'code':'620000','name':'甘肃','search':'甘肃|gansusheng|gss','children':[{'idx':'28,0','code':'-1','name':'全省','search':'全省|quansheng|qs'},{'idx':'28,1','code':'620100','name':'兰州','search':'甘肃-兰州|gansu-lanzhoushi|gs-lzs','children':[{'idx':'28,1,0','code':'-1','name':'全市','search':'全市|quansheng|qs'},{'idx':'28,1,1','code':'620101','name':'市辖区','search':'甘肃-兰州-市辖区|gansu-lanzhou-shixiaqu|gs-lz-sxq'},{'idx':'28,1,2','code':'620102','name':'城关区','search':'甘肃-兰州-城关区|gansu-lanzhou-chengguanqu|gs-lz-cgq'},{'idx':'28,1,3','code':'620103','name':'七里河区','search':'甘肃-兰州-七里河区|gansu-lanzhou-qilihequ|gs-lz-qlhq'},{'idx':'28,1,4','code':'620104','name':'西固区','search':'甘肃-兰州-西固区|gansu-lanzhou-xiguqu|gs-lz-xgq'},{'idx':'28,1,5','code':'620105','name':'安宁区','search':'甘肃-兰州-安宁区|gansu-lanzhou-anningqu|gs-lz-anq'},{'idx':'28,1,6','code':'620111','name':'红古区','search':'甘肃-兰州-红古区|gansu-lanzhou-hongguqu|gs-lz-hgq'},{'idx':'28,1,7','code':'620121','name':'永登县','search':'甘肃-兰州-永登县|gansu-lanzhou-yongdengxian|gs-lz-ydx'},{'idx':'28,1,8','code':'620122','name':'皋兰县','search':'甘肃-兰州-皋兰县|gansu-lanzhou-gaolanxian|gs-lz-glx'},{'idx':'28,1,9','code':'620123','name':'榆中县','search':'甘肃-兰州-榆中县|gansu-lanzhou-yuzhongxian|gs-lz-yzx'}]},{'idx':'28,2','code':'620200','name':'嘉峪关','search':'甘肃-嘉峪关|gansu-jiayuguanshi|gs-jygs','children':[{'idx':'28,2,0','code':'-1','name':'全市','search':'全市|quansheng|qs'},{'idx':'28,2,1','code':'620201','name':'市辖区','search':'甘肃-嘉峪关-市辖区|gansu-jiayuguan-shixiaqu|gs-jyg-sxq'}]},{'idx':'28,3','code':'620300','name':'金昌','search':'甘肃-金昌|gansu-jinchangshi|gs-jcs','children':[{'idx':'28,3,0','code':'-1','name':'全市','search':'全市|quansheng|qs'},{'idx':'28,3,1','code':'620301','name':'市辖区','search':'甘肃-金昌-市辖区|gansu-jinchang-shixiaqu|gs-jc-sxq'},{'idx':'28,3,2','code':'620302','name':'金川区','search':'甘肃-金昌-金川区|gansu-jinchang-jinchuanqu|gs-jc-jcq'},{'idx':'28,3,3','code':'620321','name':'永昌县','search':'甘肃-金昌-永昌县|gansu-jinchang-yongchangxian|gs-jc-ycx'}]},{'idx':'28,4','code':'620400','name':'白银','search':'甘肃-白银|gansu-baiyinshi|gs-bys','children':[{'idx':'28,4,0','code':'-1','name':'全市','search':'全市|quansheng|qs'},{'idx':'28,4,1','code':'620401','name':'市辖区','search':'甘肃-白银-市辖区|gansu-baiyin-shixiaqu|gs-by-sxq'},{'idx':'28,4,2','code':'620402','name':'白银区','search':'甘肃-白银-白银区|gansu-baiyin-baiyinqu|gs-by-byq'},{'idx':'28,4,3','code':'620403','name':'平川区','search':'甘肃-白银-平川区|gansu-baiyin-pingchuanqu|gs-by-pcq'},{'idx':'28,4,4','code':'620421','name':'靖远县','search':'甘肃-白银-靖远县|gansu-baiyin-jingyuanxian|gs-by-jyx'},{'idx':'28,4,5','code':'620422','name':'会宁县','search':'甘肃-白银-会宁县|gansu-baiyin-huiningxian|gs-by-hnx'},{'idx':'28,4,6','code':'620423','name':'景泰县','search':'甘肃-白银-景泰县|gansu-baiyin-jingtaixian|gs-by-jtx'}]},{'idx':'28,5','code':'620500','name':'天水','search':'甘肃-天水|gansu-tianshuishi|gs-tss','children':[{'idx':'28,5,0','code':'-1','name':'全市','search':'全市|quansheng|qs'},{'idx':'28,5,1','code':'620501','name':'市辖区','search':'甘肃-天水-市辖区|gansu-tianshui-shixiaqu|gs-ts-sxq'},{'idx':'28,5,2','code':'620502','name':'秦州区','search':'甘肃-天水-秦州区|gansu-tianshui-qinzhouqu|gs-ts-qzq'},{'idx':'28,5,3','code':'620503','name':'麦积区','search':'甘肃-天水-麦积区|gansu-tianshui-maijiqu|gs-ts-mjq'},{'idx':'28,5,4','code':'620521','name':'清水县','search':'甘肃-天水-清水县|gansu-tianshui-qingshuixian|gs-ts-qsx'},{'idx':'28,5,5','code':'620522','name':'秦安县','search':'甘肃-天水-秦安县|gansu-tianshui-qinanxian|gs-ts-qax'},{'idx':'28,5,6','code':'620523','name':'甘谷县','search':'甘肃-天水-甘谷县|gansu-tianshui-ganguxian|gs-ts-ggx'},{'idx':'28,5,7','code':'620524','name':'武山县','search':'甘肃-天水-武山县|gansu-tianshui-wushanxian|gs-ts-wsx'},{'idx':'28,5,8','code':'620525','name':'张家川回族自治县','search':'甘肃-天水-张家川回族自治县|gansu-tianshui-zhangjiachuanhuizuzizhixian|gs-ts-zjchzzzx'}]},{'idx':'28,6','code':'620600','name':'武威','search':'甘肃-武威|gansu-wuweishi|gs-wws','children':[{'idx':'28,6,0','code':'-1','name':'全市','search':'全市|quansheng|qs'},{'idx':'28,6,1','code':'620601','name':'市辖区','search':'甘肃-武威-市辖区|gansu-wuwei-shixiaqu|gs-ww-sxq'},{'idx':'28,6,2','code':'620602','name':'凉州区','search':'甘肃-武威-凉州区|gansu-wuwei-liangzhouqu|gs-ww-lzq'},{'idx':'28,6,3','code':'620621','name':'民勤县','search':'甘肃-武威-民勤县|gansu-wuwei-minqinxian|gs-ww-mqx'},{'idx':'28,6,4','code':'620622','name':'古浪县','search':'甘肃-武威-古浪县|gansu-wuwei-gulangxian|gs-ww-glx'},{'idx':'28,6,5','code':'620623','name':'天祝藏族自治县','search':'甘肃-武威-天祝藏族自治县|gansu-wuwei-tianzhucangzuzizhixian|gs-ww-tzczzzx'}]},{'idx':'28,7','code':'620700','name':'张掖','search':'甘肃-张掖|gansu-zhangyeshi|gs-zys','children':[{'idx':'28,7,0','code':'-1','name':'全市','search':'全市|quansheng|qs'},{'idx':'28,7,1','code':'620701','name':'市辖区','search':'甘肃-张掖-市辖区|gansu-zhangye-shixiaqu|gs-zy-sxq'},{'idx':'28,7,2','code':'620702','name':'甘州区','search':'甘肃-张掖-甘州区|gansu-zhangye-ganzhouqu|gs-zy-gzq'},{'idx':'28,7,3','code':'620721','name':'肃南裕固族自治县','search':'甘肃-张掖-肃南裕固族自治县|gansu-zhangye-sunanyuguzuzizhixian|gs-zy-snygzzzx'},{'idx':'28,7,4','code':'620722','name':'民乐县','search':'甘肃-张掖-民乐县|gansu-zhangye-minlexian|gs-zy-mlx'},{'idx':'28,7,5','code':'620723','name':'临泽县','search':'甘肃-张掖-临泽县|gansu-zhangye-linzexian|gs-zy-lzx'},{'idx':'28,7,6','code':'620724','name':'高台县','search':'甘肃-张掖-高台县|gansu-zhangye-gaotaixian|gs-zy-gtx'},{'idx':'28,7,7','code':'620725','name':'山丹县','search':'甘肃-张掖-山丹县|gansu-zhangye-shandanxian|gs-zy-sdx'}]},{'idx':'28,8','code':'620800','name':'平凉','search':'甘肃-平凉|gansu-pingliangshi|gs-pls','children':[{'idx':'28,8,0','code':'-1','name':'全市','search':'全市|quansheng|qs'},{'idx':'28,8,1','code':'620801','name':'市辖区','search':'甘肃-平凉-市辖区|gansu-pingliang-shixiaqu|gs-pl-sxq'},{'idx':'28,8,2','code':'620802','name':'崆峒区','search':'甘肃-平凉-崆峒区|gansu-pingliang-kongdongqu|gs-pl-kdq'},{'idx':'28,8,3','code':'620821','name':'泾川县','search':'甘肃-平凉-泾川县|gansu-pingliang-jingchuanxian|gs-pl-jcx'},{'idx':'28,8,4','code':'620822','name':'灵台县','search':'甘肃-平凉-灵台县|gansu-pingliang-lingtaixian|gs-pl-ltx'},{'idx':'28,8,5','code':'620823','name':'崇信县','search':'甘肃-平凉-崇信县|gansu-pingliang-chongxinxian|gs-pl-cxx'},{'idx':'28,8,6','code':'620824','name':'华亭县','search':'甘肃-平凉-华亭县|gansu-pingliang-huatingxian|gs-pl-htx'},{'idx':'28,8,7','code':'620825','name':'庄浪县','search':'甘肃-平凉-庄浪县|gansu-pingliang-zhuanglangxian|gs-pl-zlx'},{'idx':'28,8,8','code':'620826','name':'静宁县','search':'甘肃-平凉-静宁县|gansu-pingliang-jingningxian|gs-pl-jnx'}]},{'idx':'28,9','code':'620900','name':'酒泉','search':'甘肃-酒泉|gansu-jiuquanshi|gs-jqs','children':[{'idx':'28,9,0','code':'-1','name':'全市','search':'全市|quansheng|qs'},{'idx':'28,9,1','code':'620901','name':'市辖区','search':'甘肃-酒泉-市辖区|gansu-jiuquan-shixiaqu|gs-jq-sxq'},{'idx':'28,9,2','code':'620902','name':'肃州区','search':'甘肃-酒泉-肃州区|gansu-jiuquan-suzhouqu|gs-jq-szq'},{'idx':'28,9,3','code':'620921','name':'金塔县','search':'甘肃-酒泉-金塔县|gansu-jiuquan-jintaxian|gs-jq-jtx'},{'idx':'28,9,4','code':'620922','name':'瓜州县','search':'甘肃-酒泉-瓜州县|gansu-jiuquan-guazhouxian|gs-jq-gzx'},{'idx':'28,9,5','code':'620923','name':'肃北蒙古族自治县','search':'甘肃-酒泉-肃北蒙古族自治县|gansu-jiuquan-subeimengguzuzizhixian|gs-jq-sbmgzzzx'},{'idx':'28,9,6','code':'620924','name':'阿克塞哈萨克族自治县','search':'甘肃-酒泉-阿克塞哈萨克族自治县|gansu-jiuquan-akesaihasakezuzizhixian|gs-jq-akshskzzzx'},{'idx':'28,9,7','code':'620981','name':'玉门市','search':'甘肃-酒泉-玉门市|gansu-jiuquan-yumenshi|gs-jq-yms'},{'idx':'28,9,8','code':'620982','name':'敦煌市','search':'甘肃-酒泉-敦煌市|gansu-jiuquan-dunhuangshi|gs-jq-dhs'}]},{'idx':'28,10','code':'621000','name':'庆阳','search':'甘肃-庆阳|gansu-qingyangshi|gs-qys','children':[{'idx':'28,10,0','code':'-1','name':'全市','search':'全市|quansheng|qs'},{'idx':'28,10,1','code':'621001','name':'市辖区','search':'甘肃-庆阳-市辖区|gansu-qingyang-shixiaqu|gs-qy-sxq'},{'idx':'28,10,2','code':'621002','name':'西峰区','search':'甘肃-庆阳-西峰区|gansu-qingyang-xifengqu|gs-qy-xfq'},{'idx':'28,10,3','code':'621021','name':'庆城县','search':'甘肃-庆阳-庆城县|gansu-qingyang-qingchengxian|gs-qy-qcx'},{'idx':'28,10,4','code':'621022','name':'环县','search':'甘肃-庆阳-环县|gansu-qingyang-huanxian|gs-qy-hx'},{'idx':'28,10,5','code':'621023','name':'华池县','search':'甘肃-庆阳-华池县|gansu-qingyang-huachixian|gs-qy-hcx'},{'idx':'28,10,6','code':'621024','name':'合水县','search':'甘肃-庆阳-合水县|gansu-qingyang-heshuixian|gs-qy-hsx'},{'idx':'28,10,7','code':'621025','name':'正宁县','search':'甘肃-庆阳-正宁县|gansu-qingyang-zhengningxian|gs-qy-znx'},{'idx':'28,10,8','code':'621026','name':'宁县','search':'甘肃-庆阳-宁县|gansu-qingyang-ningxian|gs-qy-nx'},{'idx':'28,10,9','code':'621027','name':'镇原县','search':'甘肃-庆阳-镇原县|gansu-qingyang-zhenyuanxian|gs-qy-zyx'}]},{'idx':'28,11','code':'621100','name':'定西','search':'甘肃-定西|gansu-dingxishi|gs-dxs','children':[{'idx':'28,11,0','code':'-1','name':'全市','search':'全市|quansheng|qs'},{'idx':'28,11,1','code':'621101','name':'市辖区','search':'甘肃-定西-市辖区|gansu-dingxi-shixiaqu|gs-dx-sxq'},{'idx':'28,11,2','code':'621102','name':'安定区','search':'甘肃-定西-安定区|gansu-dingxi-andingqu|gs-dx-adq'},{'idx':'28,11,3','code':'621121','name':'通渭县','search':'甘肃-定西-通渭县|gansu-dingxi-tongweixian|gs-dx-twx'},{'idx':'28,11,4','code':'621122','name':'陇西县','search':'甘肃-定西-陇西县|gansu-dingxi-longxixian|gs-dx-lxx'},{'idx':'28,11,5','code':'621123','name':'渭源县','search':'甘肃-定西-渭源县|gansu-dingxi-weiyuanxian|gs-dx-wyx'},{'idx':'28,11,6','code':'621124','name':'临洮县','search':'甘肃-定西-临洮县|gansu-dingxi-lintaoxian|gs-dx-ltx'},{'idx':'28,11,7','code':'621125','name':'漳县','search':'甘肃-定西-漳县|gansu-dingxi-zhangxian|gs-dx-zx'},{'idx':'28,11,8','code':'621126','name':'岷县','search':'甘肃-定西-岷县|gansu-dingxi-minxian|gs-dx-mx'}]},{'idx':'28,12','code':'621200','name':'陇南','search':'甘肃-陇南|gansu-longnanshi|gs-lns','children':[{'idx':'28,12,0','code':'-1','name':'全市','search':'全市|quansheng|qs'},{'idx':'28,12,1','code':'621201','name':'市辖区','search':'甘肃-陇南-市辖区|gansu-longnan-shixiaqu|gs-ln-sxq'},{'idx':'28,12,2','code':'621202','name':'武都区','search':'甘肃-陇南-武都区|gansu-longnan-wuduqu|gs-ln-wdq'},{'idx':'28,12,3','code':'621221','name':'成县','search':'甘肃-陇南-成县|gansu-longnan-chengxian|gs-ln-cx'},{'idx':'28,12,4','code':'621222','name':'文县','search':'甘肃-陇南-文县|gansu-longnan-wenxian|gs-ln-wx'},{'idx':'28,12,5','code':'621223','name':'宕昌县','search':'甘肃-陇南-宕昌县|gansu-longnan-dangchangxian|gs-ln-dcx'},{'idx':'28,12,6','code':'621224','name':'康县','search':'甘肃-陇南-康县|gansu-longnan-kangxian|gs-ln-kx'},{'idx':'28,12,7','code':'621225','name':'西和县','search':'甘肃-陇南-西和县|gansu-longnan-xihexian|gs-ln-xhx'},{'idx':'28,12,8','code':'621226','name':'礼县','search':'甘肃-陇南-礼县|gansu-longnan-lixian|gs-ln-lx'},{'idx':'28,12,9','code':'621227','name':'徽县','search':'甘肃-陇南-徽县|gansu-longnan-huixian|gs-ln-hx'},{'idx':'28,12,10','code':'621228','name':'两当县','search':'甘肃-陇南-两当县|gansu-longnan-liangdangxian|gs-ln-ldx'}]},{'idx':'28,13','code':'622900','name':'临夏','search':'甘肃-临夏|gansu-linxiahuizuzizhizhou|gs-lxhzzzz','children':[{'idx':'28,13,0','code':'-1','name':'全市','search':'全市|quansheng|qs'},{'idx':'28,13,1','code':'622901','name':'临夏市','search':'甘肃-临夏-临夏市|gansu-linxia-linxiashi|gs-lx-lxs'},{'idx':'28,13,2','code':'622921','name':'临夏县','search':'甘肃-临夏-临夏县|gansu-linxia-linxiaxian|gs-lx-lxx'},{'idx':'28,13,3','code':'622922','name':'康乐县','search':'甘肃-临夏-康乐县|gansu-linxia-kanglexian|gs-lx-klx'},{'idx':'28,13,4','code':'622923','name':'永靖县','search':'甘肃-临夏-永靖县|gansu-linxia-yongjingxian|gs-lx-yjx'},{'idx':'28,13,5','code':'622924','name':'广河县','search':'甘肃-临夏-广河县|gansu-linxia-guanghexian|gs-lx-ghx'},{'idx':'28,13,6','code':'622925','name':'和政县','search':'甘肃-临夏-和政县|gansu-linxia-hezhengxian|gs-lx-hzx'},{'idx':'28,13,7','code':'622926','name':'东乡族自治县','search':'甘肃-临夏-东乡族自治县|gansu-linxia-dongxiangzuzizhixian|gs-lx-dxzzzx'},{'idx':'28,13,8','code':'622927','name':'积石山保安族东乡族撒拉族自治县','search':'甘肃-临夏-积石山保安族东乡族撒拉族自治县|gansu-linxia-jishishanbaoanzudongxiangzusalazuzizhixian|gs-lx-jssbazdxzslzzzx'}]},{'idx':'28,14','code':'623000','name':'甘南','search':'甘肃-甘南|gansu-gannancangzuzizhizhou|gs-gnczzzz','children':[{'idx':'28,14,0','code':'-1','name':'全市','search':'全市|quansheng|qs'},{'idx':'28,14,1','code':'623001','name':'合作市','search':'甘肃-甘南-合作市|gansu-gannan-hezuoshi|gs-gn-hzs'},{'idx':'28,14,2','code':'623021','name':'临潭县','search':'甘肃-甘南-临潭县|gansu-gannan-lintanxian|gs-gn-ltx'},{'idx':'28,14,3','code':'623022','name':'卓尼县','search':'甘肃-甘南-卓尼县|gansu-gannan-zhuonixian|gs-gn-znx'},{'idx':'28,14,4','code':'623023','name':'舟曲县','search':'甘肃-甘南-舟曲县|gansu-gannan-zhouquxian|gs-gn-zqx'},{'idx':'28,14,5','code':'623024','name':'迭部县','search':'甘肃-甘南-迭部县|gansu-gannan-diebuxian|gs-gn-dbx'},{'idx':'28,14,6','code':'623025','name':'玛曲县','search':'甘肃-甘南-玛曲县|gansu-gannan-maquxian|gs-gn-mqx'},{'idx':'28,14,7','code':'623026','name':'碌曲县','search':'甘肃-甘南-碌曲县|gansu-gannan-luquxian|gs-gn-lqx'},{'idx':'28,14,8','code':'623027','name':'夏河县','search':'甘肃-甘南-夏河县|gansu-gannan-xiahexian|gs-gn-xhx'}]}]},{'idx':29,'code':'630000','name':'青海','search':'青海|qinghaisheng|qhs','children':[{'idx':'29,0','code':'-1','name':'全省','search':'全省|quansheng|qs'},{'idx':'29,1','code':'630100','name':'西宁','search':'青海-西宁|qinghai-xiningshi|qh-xns','children':[{'idx':'29,1,0','code':'-1','name':'全市','search':'全市|quansheng|qs'},{'idx':'29,1,1','code':'630101','name':'市辖区','search':'青海-西宁-市辖区|qinghai-xining-shixiaqu|qh-xn-sxq'},{'idx':'29,1,2','code':'630102','name':'城东区','search':'青海-西宁-城东区|qinghai-xining-chengdongqu|qh-xn-cdq'},{'idx':'29,1,3','code':'630103','name':'城中区','search':'青海-西宁-城中区|qinghai-xining-chengzhongqu|qh-xn-czq'},{'idx':'29,1,4','code':'630104','name':'城西区','search':'青海-西宁-城西区|qinghai-xining-chengxiqu|qh-xn-cxq'},{'idx':'29,1,5','code':'630105','name':'城北区','search':'青海-西宁-城北区|qinghai-xining-chengbeiqu|qh-xn-cbq'},{'idx':'29,1,6','code':'630121','name':'大通回族土族自治县','search':'青海-西宁-大通回族土族自治县|qinghai-xining-datonghuizutuzuzizhixian|qh-xn-dthztzzzx'},{'idx':'29,1,7','code':'630122','name':'湟中县','search':'青海-西宁-湟中县|qinghai-xining-huangzhongxian|qh-xn-hzx'},{'idx':'29,1,8','code':'630123','name':'湟源县','search':'青海-西宁-湟源县|qinghai-xining-huangyuanxian|qh-xn-hyx'}]},{'idx':'29,2','code':'630200','name':'海东','search':'青海-海东|qinghai-haidongshi|qh-hds','children':[{'idx':'29,2,0','code':'-1','name':'全市','search':'全市|quansheng|qs'},{'idx':'29,2,1','code':'630202','name':'乐都区','search':'青海-海东-乐都区|qinghai-haidong-leduqu|qh-hd-ldq'},{'idx':'29,2,2','code':'630203','name':'平安区','search':'青海-海东-平安区|qinghai-haidong-pinganqu|qh-hd-paq'},{'idx':'29,2,3','code':'630222','name':'民和回族土族自治县','search':'青海-海东-民和回族土族自治县|qinghai-haidong-minhehuizutuzuzizhixian|qh-hd-mhhztzzzx'},{'idx':'29,2,4','code':'630223','name':'互助土族自治县','search':'青海-海东-互助土族自治县|qinghai-haidong-huzhutuzuzizhixian|qh-hd-hztzzzx'},{'idx':'29,2,5','code':'630224','name':'化隆回族自治县','search':'青海-海东-化隆回族自治县|qinghai-haidong-hualonghuizuzizhixian|qh-hd-hlhzzzx'},{'idx':'29,2,6','code':'630225','name':'循化撒拉族自治县','search':'青海-海东-循化撒拉族自治县|qinghai-haidong-xunhuasalazuzizhixian|qh-hd-xhslzzzx'}]},{'idx':'29,3','code':'632200','name':'海北','search':'青海-海北|qinghai-haibeicangzuzizhizhou|qh-hbczzzz','children':[{'idx':'29,3,0','code':'-1','name':'全市','search':'全市|quansheng|qs'},{'idx':'29,3,1','code':'632221','name':'门源回族自治县','search':'青海-海北-门源回族自治县|qinghai-haibei-menyuanhuizuzizhixian|qh-hb-myhzzzx'},{'idx':'29,3,2','code':'632222','name':'祁连县','search':'青海-海北-祁连县|qinghai-haibei-qilianxian|qh-hb-qlx'},{'idx':'29,3,3','code':'632223','name':'海晏县','search':'青海-海北-海晏县|qinghai-haibei-haiyanxian|qh-hb-hyx'},{'idx':'29,3,4','code':'632224','name':'刚察县','search':'青海-海北-刚察县|qinghai-haibei-gangchaxian|qh-hb-gcx'}]},{'idx':'29,4','code':'632300','name':'黄南','search':'青海-黄南|qinghai-huangnancangzuzizhizhou|qh-hnczzzz','children':[{'idx':'29,4,0','code':'-1','name':'全市','search':'全市|quansheng|qs'},{'idx':'29,4,1','code':'632321','name':'同仁县','search':'青海-黄南-同仁县|qinghai-huangnan-tongrenxian|qh-hn-trx'},{'idx':'29,4,2','code':'632322','name':'尖扎县','search':'青海-黄南-尖扎县|qinghai-huangnan-jianzhaxian|qh-hn-jzx'},{'idx':'29,4,3','code':'632323','name':'泽库县','search':'青海-黄南-泽库县|qinghai-huangnan-zekuxian|qh-hn-zkx'},{'idx':'29,4,4','code':'632324','name':'河南蒙古族自治县','search':'青海-黄南-河南蒙古族自治县|qinghai-huangnan-henanmengguzuzizhixian|qh-hn-hnmgzzzx'}]},{'idx':'29,5','code':'632500','name':'海南','search':'青海-海南|qinghai-hainancangzuzizhizhou|qh-hnczzzz','children':[{'idx':'29,5,0','code':'-1','name':'全市','search':'全市|quansheng|qs'},{'idx':'29,5,1','code':'632521','name':'共和县','search':'青海-海南-共和县|qinghai-hainan-gonghexian|qh-hn-ghx'},{'idx':'29,5,2','code':'632522','name':'同德县','search':'青海-海南-同德县|qinghai-hainan-tongdexian|qh-hn-tdx'},{'idx':'29,5,3','code':'632523','name':'贵德县','search':'青海-海南-贵德县|qinghai-hainan-guidexian|qh-hn-gdx'},{'idx':'29,5,4','code':'632524','name':'兴海县','search':'青海-海南-兴海县|qinghai-hainan-xinghaixian|qh-hn-xhx'},{'idx':'29,5,5','code':'632525','name':'贵南县','search':'青海-海南-贵南县|qinghai-hainan-guinanxian|qh-hn-gnx'}]},{'idx':'29,6','code':'632600','name':'果洛','search':'青海-果洛|qinghai-guoluocangzuzizhizhou|qh-glczzzz','children':[{'idx':'29,6,0','code':'-1','name':'全市','search':'全市|quansheng|qs'},{'idx':'29,6,1','code':'632621','name':'玛沁县','search':'青海-果洛-玛沁县|qinghai-guoluo-maqinxian|qh-gl-mqx'},{'idx':'29,6,2','code':'632622','name':'班玛县','search':'青海-果洛-班玛县|qinghai-guoluo-banmaxian|qh-gl-bmx'},{'idx':'29,6,3','code':'632623','name':'甘德县','search':'青海-果洛-甘德县|qinghai-guoluo-gandexian|qh-gl-gdx'},{'idx':'29,6,4','code':'632624','name':'达日县','search':'青海-果洛-达日县|qinghai-guoluo-darixian|qh-gl-drx'},{'idx':'29,6,5','code':'632625','name':'久治县','search':'青海-果洛-久治县|qinghai-guoluo-jiuzhixian|qh-gl-jzx'},{'idx':'29,6,6','code':'632626','name':'玛多县','search':'青海-果洛-玛多县|qinghai-guoluo-maduoxian|qh-gl-mdx'}]},{'idx':'29,7','code':'632700','name':'玉树','search':'青海-玉树|qinghai-yushucangzuzizhizhou|qh-ysczzzz','children':[{'idx':'29,7,0','code':'-1','name':'全市','search':'全市|quansheng|qs'},{'idx':'29,7,1','code':'632701','name':'玉树市','search':'青海-玉树-玉树市|qinghai-yushu-yushushi|qh-ys-yss'},{'idx':'29,7,2','code':'632722','name':'杂多县','search':'青海-玉树-杂多县|qinghai-yushu-zaduoxian|qh-ys-zdx'},{'idx':'29,7,3','code':'632723','name':'称多县','search':'青海-玉树-称多县|qinghai-yushu-chengduoxian|qh-ys-cdx'},{'idx':'29,7,4','code':'632724','name':'治多县','search':'青海-玉树-治多县|qinghai-yushu-zhiduoxian|qh-ys-zdx'},{'idx':'29,7,5','code':'632725','name':'囊谦县','search':'青海-玉树-囊谦县|qinghai-yushu-nangqianxian|qh-ys-nqx'},{'idx':'29,7,6','code':'632726','name':'曲麻莱县','search':'青海-玉树-曲麻莱县|qinghai-yushu-qumalaixian|qh-ys-qmlx'}]},{'idx':'29,8','code':'632800','name':'海西族','search':'青海-海西族|qinghai-haiximengguzucangzuzizhizhou|qh-hxmgzczzzz','children':[{'idx':'29,8,0','code':'-1','name':'全市','search':'全市|quansheng|qs'},{'idx':'29,8,1','code':'632801','name':'格尔木市','search':'青海-海西族-格尔木市|qinghai-haixizu-geermushi|qh-hxz-gems'},{'idx':'29,8,2','code':'632802','name':'德令哈市','search':'青海-海西族-德令哈市|qinghai-haixizu-delinghashi|qh-hxz-dlhs'},{'idx':'29,8,3','code':'632821','name':'乌兰县','search':'青海-海西族-乌兰县|qinghai-haixizu-wulanxian|qh-hxz-wlx'},{'idx':'29,8,4','code':'632822','name':'都兰县','search':'青海-海西族-都兰县|qinghai-haixizu-dulanxian|qh-hxz-dlx'},{'idx':'29,8,5','code':'632823','name':'天峻县','search':'青海-海西族-天峻县|qinghai-haixizu-tianjunxian|qh-hxz-tjx'}]}]},{'idx':30,'code':'640000','name':'宁夏','search':'宁夏|ningxiahuizuzizhiqu|nxhzzzq','children':[{'idx':'30,0','code':'-1','name':'全省','search':'全省|quansheng|qs'},{'idx':'30,1','code':'640100','name':'银川','search':'宁夏-银川|ningxia-yinchuanshi|nx-ycs','children':[{'idx':'30,1,0','code':'-1','name':'全市','search':'全市|quansheng|qs'},{'idx':'30,1,1','code':'640101','name':'市辖区','search':'宁夏-银川-市辖区|ningxia-yinchuan-shixiaqu|nx-yc-sxq'},{'idx':'30,1,2','code':'640104','name':'兴庆区','search':'宁夏-银川-兴庆区|ningxia-yinchuan-xingqingqu|nx-yc-xqq'},{'idx':'30,1,3','code':'640105','name':'西夏区','search':'宁夏-银川-西夏区|ningxia-yinchuan-xixiaqu|nx-yc-xxq'},{'idx':'30,1,4','code':'640106','name':'金凤区','search':'宁夏-银川-金凤区|ningxia-yinchuan-jinfengqu|nx-yc-jfq'},{'idx':'30,1,5','code':'640121','name':'永宁县','search':'宁夏-银川-永宁县|ningxia-yinchuan-yongningxian|nx-yc-ynx'},{'idx':'30,1,6','code':'640122','name':'贺兰县','search':'宁夏-银川-贺兰县|ningxia-yinchuan-helanxian|nx-yc-hlx'},{'idx':'30,1,7','code':'640181','name':'灵武市','search':'宁夏-银川-灵武市|ningxia-yinchuan-lingwushi|nx-yc-lws'}]},{'idx':'30,2','code':'640200','name':'石嘴山','search':'宁夏-石嘴山|ningxia-shizuishanshi|nx-szss','children':[{'idx':'30,2,0','code':'-1','name':'全市','search':'全市|quansheng|qs'},{'idx':'30,2,1','code':'640201','name':'市辖区','search':'宁夏-石嘴山-市辖区|ningxia-shizuishan-shixiaqu|nx-szs-sxq'},{'idx':'30,2,2','code':'640202','name':'大武口区','search':'宁夏-石嘴山-大武口区|ningxia-shizuishan-dawukouqu|nx-szs-dwkq'},{'idx':'30,2,3','code':'640205','name':'惠农区','search':'宁夏-石嘴山-惠农区|ningxia-shizuishan-huinongqu|nx-szs-hnq'},{'idx':'30,2,4','code':'640221','name':'平罗县','search':'宁夏-石嘴山-平罗县|ningxia-shizuishan-pingluoxian|nx-szs-plx'}]},{'idx':'30,3','code':'640300','name':'吴忠','search':'宁夏-吴忠|ningxia-wuzhongshi|nx-wzs','children':[{'idx':'30,3,0','code':'-1','name':'全市','search':'全市|quansheng|qs'},{'idx':'30,3,1','code':'640301','name':'市辖区','search':'宁夏-吴忠-市辖区|ningxia-wuzhong-shixiaqu|nx-wz-sxq'},{'idx':'30,3,2','code':'640302','name':'利通区','search':'宁夏-吴忠-利通区|ningxia-wuzhong-litongqu|nx-wz-ltq'},{'idx':'30,3,3','code':'640303','name':'红寺堡区','search':'宁夏-吴忠-红寺堡区|ningxia-wuzhong-hongsibaoqu|nx-wz-hsbq'},{'idx':'30,3,4','code':'640323','name':'盐池县','search':'宁夏-吴忠-盐池县|ningxia-wuzhong-yanchixian|nx-wz-ycx'},{'idx':'30,3,5','code':'640324','name':'同心县','search':'宁夏-吴忠-同心县|ningxia-wuzhong-tongxinxian|nx-wz-txx'},{'idx':'30,3,6','code':'640381','name':'青铜峡市','search':'宁夏-吴忠-青铜峡市|ningxia-wuzhong-qingtongxiashi|nx-wz-qtxs'}]},{'idx':'30,4','code':'640400','name':'固原','search':'宁夏-固原|ningxia-guyuanshi|nx-gys','children':[{'idx':'30,4,0','code':'-1','name':'全市','search':'全市|quansheng|qs'},{'idx':'30,4,1','code':'640401','name':'市辖区','search':'宁夏-固原-市辖区|ningxia-guyuan-shixiaqu|nx-gy-sxq'},{'idx':'30,4,2','code':'640402','name':'原州区','search':'宁夏-固原-原州区|ningxia-guyuan-yuanzhouqu|nx-gy-yzq'},{'idx':'30,4,3','code':'640422','name':'西吉县','search':'宁夏-固原-西吉县|ningxia-guyuan-xijixian|nx-gy-xjx'},{'idx':'30,4,4','code':'640423','name':'隆德县','search':'宁夏-固原-隆德县|ningxia-guyuan-longdexian|nx-gy-ldx'},{'idx':'30,4,5','code':'640424','name':'泾源县','search':'宁夏-固原-泾源县|ningxia-guyuan-jingyuanxian|nx-gy-jyx'},{'idx':'30,4,6','code':'640425','name':'彭阳县','search':'宁夏-固原-彭阳县|ningxia-guyuan-pengyangxian|nx-gy-pyx'}]},{'idx':'30,5','code':'640500','name':'中卫','search':'宁夏-中卫|ningxia-zhongweishi|nx-zws','children':[{'idx':'30,5,0','code':'-1','name':'全市','search':'全市|quansheng|qs'},{'idx':'30,5,1','code':'640501','name':'市辖区','search':'宁夏-中卫-市辖区|ningxia-zhongwei-shixiaqu|nx-zw-sxq'},{'idx':'30,5,2','code':'640502','name':'沙坡头区','search':'宁夏-中卫-沙坡头区|ningxia-zhongwei-shapotouqu|nx-zw-sptq'},{'idx':'30,5,3','code':'640521','name':'中宁县','search':'宁夏-中卫-中宁县|ningxia-zhongwei-zhongningxian|nx-zw-znx'},{'idx':'30,5,4','code':'640522','name':'海原县','search':'宁夏-中卫-海原县|ningxia-zhongwei-haiyuanxian|nx-zw-hyx'}]}]},{'idx':31,'code':'650000','name':'新疆','search':'新疆|xinjiangweiwuerzizhiqu|xjwwezzq','children':[{'idx':'31,0','code':'-1','name':'全省','search':'全省|quansheng|qs'},{'idx':'31,1','code':'650100','name':'乌鲁木齐','search':'新疆-乌鲁木齐|xinjiang-wulumuqishi|xj-wlmqs','children':[{'idx':'31,1,0','code':'-1','name':'全市','search':'全市|quansheng|qs'},{'idx':'31,1,1','code':'650101','name':'市辖区','search':'新疆-乌鲁木齐-市辖区|xinjiang-wulumuqi-shixiaqu|xj-wlmq-sxq'},{'idx':'31,1,2','code':'650102','name':'天山区','search':'新疆-乌鲁木齐-天山区|xinjiang-wulumuqi-tianshanqu|xj-wlmq-tsq'},{'idx':'31,1,3','code':'650103','name':'沙依巴克区','search':'新疆-乌鲁木齐-沙依巴克区|xinjiang-wulumuqi-shayibakequ|xj-wlmq-sybkq'},{'idx':'31,1,4','code':'650104','name':'新市区','search':'新疆-乌鲁木齐-新市区|xinjiang-wulumuqi-xinshiqu|xj-wlmq-xsq'},{'idx':'31,1,5','code':'650105','name':'水磨沟区','search':'新疆-乌鲁木齐-水磨沟区|xinjiang-wulumuqi-shuimogouqu|xj-wlmq-smgq'},{'idx':'31,1,6','code':'650106','name':'头屯河区','search':'新疆-乌鲁木齐-头屯河区|xinjiang-wulumuqi-toutunhequ|xj-wlmq-tthq'},{'idx':'31,1,7','code':'650107','name':'达坂城区','search':'新疆-乌鲁木齐-达坂城区|xinjiang-wulumuqi-dabanchengqu|xj-wlmq-dbcq'},{'idx':'31,1,8','code':'650109','name':'米东区','search':'新疆-乌鲁木齐-米东区|xinjiang-wulumuqi-midongqu|xj-wlmq-mdq'},{'idx':'31,1,9','code':'650121','name':'乌鲁木齐县','search':'新疆-乌鲁木齐-乌鲁木齐县|xinjiang-wulumuqi-wulumuqixian|xj-wlmq-wlmqx'}]},{'idx':'31,2','code':'650200','name':'克拉玛依','search':'新疆-克拉玛依|xinjiang-kelamayishi|xj-klmys','children':[{'idx':'31,2,0','code':'-1','name':'全市','search':'全市|quansheng|qs'},{'idx':'31,2,1','code':'650201','name':'市辖区','search':'新疆-克拉玛依-市辖区|xinjiang-kelamayi-shixiaqu|xj-klmy-sxq'},{'idx':'31,2,2','code':'650202','name':'独山子区','search':'新疆-克拉玛依-独山子区|xinjiang-kelamayi-dushanziqu|xj-klmy-dszq'},{'idx':'31,2,3','code':'650203','name':'克拉玛依区','search':'新疆-克拉玛依-克拉玛依区|xinjiang-kelamayi-kelamayiqu|xj-klmy-klmyq'},{'idx':'31,2,4','code':'650204','name':'白碱滩区','search':'新疆-克拉玛依-白碱滩区|xinjiang-kelamayi-baijiantanqu|xj-klmy-bjtq'},{'idx':'31,2,5','code':'650205','name':'乌尔禾区','search':'新疆-克拉玛依-乌尔禾区|xinjiang-kelamayi-wuerhequ|xj-klmy-wehq'}]},{'idx':'31,3','code':'650400','name':'吐鲁番','search':'新疆-吐鲁番|xinjiang-tulufanshi|xj-tlfs','children':[{'idx':'31,3,0','code':'-1','name':'全市','search':'全市|quansheng|qs'},{'idx':'31,3,1','code':'650402','name':'高昌区','search':'新疆-吐鲁番-高昌区|xinjiang-tulufan-gaochangqu|xj-tlf-gcq'},{'idx':'31,3,2','code':'650421','name':'鄯善县','search':'新疆-吐鲁番-鄯善县|xinjiang-tulufan-shanshanxian|xj-tlf-ssx'},{'idx':'31,3,3','code':'650422','name':'托克逊县','search':'新疆-吐鲁番-托克逊县|xinjiang-tulufan-tuokexunxian|xj-tlf-tkxx'}]},{'idx':'31,4','code':'652200','name':'哈密','search':'新疆-哈密|xinjiang-hamidiqu|xj-hmdq','children':[{'idx':'31,4,0','code':'-1','name':'全市','search':'全市|quansheng|qs'},{'idx':'31,4,1','code':'652201','name':'哈密市','search':'新疆-哈密-哈密市|xinjiang-hami-hamishi|xj-hm-hms'},{'idx':'31,4,2','code':'652222','name':'巴里坤哈萨克自治县','search':'新疆-哈密-巴里坤哈萨克自治县|xinjiang-hami-balikunhasakezizhixian|xj-hm-blkhskzzx'},{'idx':'31,4,3','code':'652223','name':'伊吾县','search':'新疆-哈密-伊吾县|xinjiang-hami-yiwuxian|xj-hm-ywx'}]},{'idx':'31,5','code':'652300','name':'昌吉','search':'新疆-昌吉|xinjiang-changjihuizuzizhizhou|xj-cjhzzzz','children':[{'idx':'31,5,0','code':'-1','name':'全市','search':'全市|quansheng|qs'},{'idx':'31,5,1','code':'652301','name':'昌吉市','search':'新疆-昌吉-昌吉市|xinjiang-changji-changjishi|xj-cj-cjs'},{'idx':'31,5,2','code':'652302','name':'阜康市','search':'新疆-昌吉-阜康市|xinjiang-changji-fukangshi|xj-cj-fks'},{'idx':'31,5,3','code':'652323','name':'呼图壁县','search':'新疆-昌吉-呼图壁县|xinjiang-changji-hutubixian|xj-cj-htbx'},{'idx':'31,5,4','code':'652324','name':'玛纳斯县','search':'新疆-昌吉-玛纳斯县|xinjiang-changji-manasixian|xj-cj-mnsx'},{'idx':'31,5,5','code':'652325','name':'奇台县','search':'新疆-昌吉-奇台县|xinjiang-changji-qitaixian|xj-cj-qtx'},{'idx':'31,5,6','code':'652327','name':'吉木萨尔县','search':'新疆-昌吉-吉木萨尔县|xinjiang-changji-jimusaerxian|xj-cj-jmsex'},{'idx':'31,5,7','code':'652328','name':'木垒哈萨克自治县','search':'新疆-昌吉-木垒哈萨克自治县|xinjiang-changji-muleihasakezizhixian|xj-cj-mlhskzzx'}]},{'idx':'31,6','code':'652700','name':'博尔塔拉','search':'新疆-博尔塔拉|xinjiang-boertalamengguzizhizhou|xj-betlmgzzz','children':[{'idx':'31,6,0','code':'-1','name':'全市','search':'全市|quansheng|qs'},{'idx':'31,6,1','code':'652701','name':'博乐市','search':'新疆-博尔塔拉-博乐市|xinjiang-boertala-boleshi|xj-betl-bls'},{'idx':'31,6,2','code':'652702','name':'阿拉山口市','search':'新疆-博尔塔拉-阿拉山口市|xinjiang-boertala-alashankoushi|xj-betl-alsks'},{'idx':'31,6,3','code':'652722','name':'精河县','search':'新疆-博尔塔拉-精河县|xinjiang-boertala-jinghexian|xj-betl-jhx'},{'idx':'31,6,4','code':'652723','name':'温泉县','search':'新疆-博尔塔拉-温泉县|xinjiang-boertala-wenquanxian|xj-betl-wqx'}]},{'idx':'31,7','code':'652800','name':'巴音郭楞','search':'新疆-巴音郭楞|xinjiang-bayinguolengmengguzizhizhou|xj-byglmgzzz','children':[{'idx':'31,7,0','code':'-1','name':'全市','search':'全市|quansheng|qs'},{'idx':'31,7,1','code':'652801','name':'库尔勒市','search':'新疆-巴音郭楞-库尔勒市|xinjiang-bayinguoleng-kuerleshi|xj-bygl-kels'},{'idx':'31,7,2','code':'652822','name':'轮台县','search':'新疆-巴音郭楞-轮台县|xinjiang-bayinguoleng-luntaixian|xj-bygl-ltx'},{'idx':'31,7,3','code':'652823','name':'尉犁县','search':'新疆-巴音郭楞-尉犁县|xinjiang-bayinguoleng-weilixian|xj-bygl-wlx'},{'idx':'31,7,4','code':'652824','name':'若羌县','search':'新疆-巴音郭楞-若羌县|xinjiang-bayinguoleng-ruoqiangxian|xj-bygl-rqx'},{'idx':'31,7,5','code':'652825','name':'且末县','search':'新疆-巴音郭楞-且末县|xinjiang-bayinguoleng-qiemoxian|xj-bygl-qmx'},{'idx':'31,7,6','code':'652826','name':'焉耆回族自治县','search':'新疆-巴音郭楞-焉耆回族自治县|xinjiang-bayinguoleng-yanqihuizuzizhixian|xj-bygl-yqhzzzx'},{'idx':'31,7,7','code':'652827','name':'和静县','search':'新疆-巴音郭楞-和静县|xinjiang-bayinguoleng-hejingxian|xj-bygl-hjx'},{'idx':'31,7,8','code':'652828','name':'和硕县','search':'新疆-巴音郭楞-和硕县|xinjiang-bayinguoleng-heshuoxian|xj-bygl-hsx'},{'idx':'31,7,9','code':'652829','name':'博湖县','search':'新疆-巴音郭楞-博湖县|xinjiang-bayinguoleng-bohuxian|xj-bygl-bhx'}]},{'idx':'31,8','code':'652900','name':'阿克苏','search':'新疆-阿克苏|xinjiang-akesudiqu|xj-aksdq','children':[{'idx':'31,8,0','code':'-1','name':'全市','search':'全市|quansheng|qs'},{'idx':'31,8,1','code':'652901','name':'阿克苏市','search':'新疆-阿克苏-阿克苏市|xinjiang-akesu-akesushi|xj-aks-akss'},{'idx':'31,8,2','code':'652922','name':'温宿县','search':'新疆-阿克苏-温宿县|xinjiang-akesu-wensuxian|xj-aks-wsx'},{'idx':'31,8,3','code':'652923','name':'库车县','search':'新疆-阿克苏-库车县|xinjiang-akesu-kuchexian|xj-aks-kcx'},{'idx':'31,8,4','code':'652924','name':'沙雅县','search':'新疆-阿克苏-沙雅县|xinjiang-akesu-shayaxian|xj-aks-syx'},{'idx':'31,8,5','code':'652925','name':'新和县','search':'新疆-阿克苏-新和县|xinjiang-akesu-xinhexian|xj-aks-xhx'},{'idx':'31,8,6','code':'652926','name':'拜城县','search':'新疆-阿克苏-拜城县|xinjiang-akesu-baichengxian|xj-aks-bcx'},{'idx':'31,8,7','code':'652927','name':'乌什县','search':'新疆-阿克苏-乌什县|xinjiang-akesu-wushixian|xj-aks-wsx'},{'idx':'31,8,8','code':'652928','name':'阿瓦提县','search':'新疆-阿克苏-阿瓦提县|xinjiang-akesu-awatixian|xj-aks-awtx'},{'idx':'31,8,9','code':'652929','name':'柯坪县','search':'新疆-阿克苏-柯坪县|xinjiang-akesu-kepingxian|xj-aks-kpx'}]},{'idx':'31,9','code':'653000','name':'克孜勒苏柯尔克孜','search':'新疆-克孜勒苏柯尔克孜|xinjiang-kezilesukeerkezizizhizhou|xj-kzlskekzzzz','children':[{'idx':'31,9,0','code':'-1','name':'全市','search':'全市|quansheng|qs'},{'idx':'31,9,1','code':'653001','name':'阿图什市','search':'新疆-克孜勒苏柯尔克孜-阿图什市|xinjiang-kezilesukeerkezi-atushishi|xj-kzlskekz-atss'},{'idx':'31,9,2','code':'653022','name':'阿克陶县','search':'新疆-克孜勒苏柯尔克孜-阿克陶县|xinjiang-kezilesukeerkezi-aketaoxian|xj-kzlskekz-aktx'},{'idx':'31,9,3','code':'653023','name':'阿合奇县','search':'新疆-克孜勒苏柯尔克孜-阿合奇县|xinjiang-kezilesukeerkezi-aheqixian|xj-kzlskekz-ahqx'},{'idx':'31,9,4','code':'653024','name':'乌恰县','search':'新疆-克孜勒苏柯尔克孜-乌恰县|xinjiang-kezilesukeerkezi-wuqiaxian|xj-kzlskekz-wqx'}]},{'idx':'31,10','code':'653100','name':'喀什','search':'新疆-喀什|xinjiang-kashidiqu|xj-ksdq','children':[{'idx':'31,10,0','code':'-1','name':'全市','search':'全市|quansheng|qs'},{'idx':'31,10,1','code':'653101','name':'喀什市','search':'新疆-喀什-喀什市|xinjiang-kashi-kashishi|xj-ks-kss'},{'idx':'31,10,2','code':'653121','name':'疏附县','search':'新疆-喀什-疏附县|xinjiang-kashi-shufuxian|xj-ks-sfx'},{'idx':'31,10,3','code':'653122','name':'疏勒县','search':'新疆-喀什-疏勒县|xinjiang-kashi-shulexian|xj-ks-slx'},{'idx':'31,10,4','code':'653123','name':'英吉沙县','search':'新疆-喀什-英吉沙县|xinjiang-kashi-yingjishaxian|xj-ks-yjsx'},{'idx':'31,10,5','code':'653124','name':'泽普县','search':'新疆-喀什-泽普县|xinjiang-kashi-zepuxian|xj-ks-zpx'},{'idx':'31,10,6','code':'653125','name':'莎车县','search':'新疆-喀什-莎车县|xinjiang-kashi-shachexian|xj-ks-scx'},{'idx':'31,10,7','code':'653126','name':'叶城县','search':'新疆-喀什-叶城县|xinjiang-kashi-yechengxian|xj-ks-ycx'},{'idx':'31,10,8','code':'653127','name':'麦盖提县','search':'新疆-喀什-麦盖提县|xinjiang-kashi-maigaitixian|xj-ks-mgtx'},{'idx':'31,10,9','code':'653128','name':'岳普湖县','search':'新疆-喀什-岳普湖县|xinjiang-kashi-yuepuhuxian|xj-ks-yphx'},{'idx':'31,10,10','code':'653129','name':'伽师县','search':'新疆-喀什-伽师县|xinjiang-kashi-gashixian|xj-ks-gsx'},{'idx':'31,10,11','code':'653130','name':'巴楚县','search':'新疆-喀什-巴楚县|xinjiang-kashi-bachuxian|xj-ks-bcx'},{'idx':'31,10,12','code':'653131','name':'塔什库尔干塔吉克自治县','search':'新疆-喀什-塔什库尔干塔吉克自治县|xinjiang-kashi-tashikuergantajikezizhixian|xj-ks-tskegtjkzzx'}]},{'idx':'31,11','code':'653200','name':'和田','search':'新疆-和田|xinjiang-hetiandiqu|xj-htdq','children':[{'idx':'31,11,0','code':'-1','name':'全市','search':'全市|quansheng|qs'},{'idx':'31,11,1','code':'653201','name':'和田市','search':'新疆-和田-和田市|xinjiang-hetian-hetianshi|xj-ht-hts'},{'idx':'31,11,2','code':'653221','name':'和田县','search':'新疆-和田-和田县|xinjiang-hetian-hetianxian|xj-ht-htx'},{'idx':'31,11,3','code':'653222','name':'墨玉县','search':'新疆-和田-墨玉县|xinjiang-hetian-moyuxian|xj-ht-myx'},{'idx':'31,11,4','code':'653223','name':'皮山县','search':'新疆-和田-皮山县|xinjiang-hetian-pishanxian|xj-ht-psx'},{'idx':'31,11,5','code':'653224','name':'洛浦县','search':'新疆-和田-洛浦县|xinjiang-hetian-luopuxian|xj-ht-lpx'},{'idx':'31,11,6','code':'653225','name':'策勒县','search':'新疆-和田-策勒县|xinjiang-hetian-celexian|xj-ht-clx'},{'idx':'31,11,7','code':'653226','name':'于田县','search':'新疆-和田-于田县|xinjiang-hetian-yutianxian|xj-ht-ytx'},{'idx':'31,11,8','code':'653227','name':'民丰县','search':'新疆-和田-民丰县|xinjiang-hetian-minfengxian|xj-ht-mfx'}]},{'idx':'31,12','code':'654000','name':'伊犁','search':'新疆-伊犁|xinjiang-yilihasakezizhizhou|xj-ylhskzzz','children':[{'idx':'31,12,0','code':'-1','name':'全市','search':'全市|quansheng|qs'},{'idx':'31,12,1','code':'654002','name':'伊宁市','search':'新疆-伊犁-伊宁市|xinjiang-yili-yiningshi|xj-yl-yns'},{'idx':'31,12,2','code':'654003','name':'奎屯市','search':'新疆-伊犁-奎屯市|xinjiang-yili-kuitunshi|xj-yl-kts'},{'idx':'31,12,3','code':'654004','name':'霍尔果斯市','search':'新疆-伊犁-霍尔果斯市|xinjiang-yili-huoerguosishi|xj-yl-hegss'},{'idx':'31,12,4','code':'654021','name':'伊宁县','search':'新疆-伊犁-伊宁县|xinjiang-yili-yiningxian|xj-yl-ynx'},{'idx':'31,12,5','code':'654022','name':'察布查尔锡伯自治县','search':'新疆-伊犁-察布查尔锡伯自治县|xinjiang-yili-chabuchaerxibozizhixian|xj-yl-cbcexbzzx'},{'idx':'31,12,6','code':'654023','name':'霍城县','search':'新疆-伊犁-霍城县|xinjiang-yili-huochengxian|xj-yl-hcx'},{'idx':'31,12,7','code':'654024','name':'巩留县','search':'新疆-伊犁-巩留县|xinjiang-yili-gongliuxian|xj-yl-glx'},{'idx':'31,12,8','code':'654025','name':'新源县','search':'新疆-伊犁-新源县|xinjiang-yili-xinyuanxian|xj-yl-xyx'},{'idx':'31,12,9','code':'654026','name':'昭苏县','search':'新疆-伊犁-昭苏县|xinjiang-yili-zhaosuxian|xj-yl-zsx'},{'idx':'31,12,10','code':'654027','name':'特克斯县','search':'新疆-伊犁-特克斯县|xinjiang-yili-tekesixian|xj-yl-tksx'},{'idx':'31,12,11','code':'654028','name':'尼勒克县','search':'新疆-伊犁-尼勒克县|xinjiang-yili-nilekexian|xj-yl-nlkx'}]},{'idx':'31,13','code':'654200','name':'塔城','search':'新疆-塔城|xinjiang-tachengdiqu|xj-tcdq','children':[{'idx':'31,13,0','code':'-1','name':'全市','search':'全市|quansheng|qs'},{'idx':'31,13,1','code':'654201','name':'塔城市','search':'新疆-塔城-塔城市|xinjiang-tacheng-tachengshi|xj-tc-tcs'},{'idx':'31,13,2','code':'654202','name':'乌苏市','search':'新疆-塔城-乌苏市|xinjiang-tacheng-wusushi|xj-tc-wss'},{'idx':'31,13,3','code':'654221','name':'额敏县','search':'新疆-塔城-额敏县|xinjiang-tacheng-eminxian|xj-tc-emx'},{'idx':'31,13,4','code':'654223','name':'沙湾县','search':'新疆-塔城-沙湾县|xinjiang-tacheng-shawanxian|xj-tc-swx'},{'idx':'31,13,5','code':'654224','name':'托里县','search':'新疆-塔城-托里县|xinjiang-tacheng-tuolixian|xj-tc-tlx'},{'idx':'31,13,6','code':'654225','name':'裕民县','search':'新疆-塔城-裕民县|xinjiang-tacheng-yuminxian|xj-tc-ymx'},{'idx':'31,13,7','code':'654226','name':'和布克赛尔蒙古自治县','search':'新疆-塔城-和布克赛尔蒙古自治县|xinjiang-tacheng-hebukesaiermengguzizhixian|xj-tc-hbksemgzzx'}]},{'idx':'31,14','code':'654300','name':'阿勒泰','search':'新疆-阿勒泰|xinjiang-aletaidiqu|xj-altdq','children':[{'idx':'31,14,0','code':'-1','name':'全市','search':'全市|quansheng|qs'},{'idx':'31,14,1','code':'654301','name':'阿勒泰市','search':'新疆-阿勒泰-阿勒泰市|xinjiang-aletai-aletaishi|xj-alt-alts'},{'idx':'31,14,2','code':'654321','name':'布尔津县','search':'新疆-阿勒泰-布尔津县|xinjiang-aletai-buerjinxian|xj-alt-bejx'},{'idx':'31,14,3','code':'654322','name':'富蕴县','search':'新疆-阿勒泰-富蕴县|xinjiang-aletai-fuyunxian|xj-alt-fyx'},{'idx':'31,14,4','code':'654323','name':'福海县','search':'新疆-阿勒泰-福海县|xinjiang-aletai-fuhaixian|xj-alt-fhx'},{'idx':'31,14,5','code':'654324','name':'哈巴河县','search':'新疆-阿勒泰-哈巴河县|xinjiang-aletai-habahexian|xj-alt-hbhx'},{'idx':'31,14,6','code':'654325','name':'青河县','search':'新疆-阿勒泰-青河县|xinjiang-aletai-qinghexian|xj-alt-qhx'},{'idx':'31,14,7','code':'654326','name':'吉木乃县','search':'新疆-阿勒泰-吉木乃县|xinjiang-aletai-jimunaixian|xj-alt-jmnx'}]},{'idx':'31,15','code':'659000','name':'自治区直辖县级行政区划','search':'新疆-自治区直辖县级行政区划|xinjiang-zizhiquzhixiaxianjixingzhengquhua|xj-zzqzxxjxzqh','children':[{'idx':'31,15,0','code':'-1','name':'全市','search':'全市|quansheng|qs'},{'idx':'31,15,1','code':'659001','name':'石河子市','search':'新疆-自治区直辖县级行政区划-石河子市|xinjiang-zizhiquzhixiaxianjixingzhengquhua-shihezishi|xj-zzqzxxjxzqh-shzs'},{'idx':'31,15,2','code':'659002','name':'阿拉尔市','search':'新疆-自治区直辖县级行政区划-阿拉尔市|xinjiang-zizhiquzhixiaxianjixingzhengquhua-alaershi|xj-zzqzxxjxzqh-ales'},{'idx':'31,15,3','code':'659003','name':'图木舒克市','search':'新疆-自治区直辖县级行政区划-图木舒克市|xinjiang-zizhiquzhixiaxianjixingzhengquhua-tumushukeshi|xj-zzqzxxjxzqh-tmsks'},{'idx':'31,15,4','code':'659004','name':'五家渠市','search':'新疆-自治区直辖县级行政区划-五家渠市|xinjiang-zizhiquzhixiaxianjixingzhengquhua-wujiaqushi|xj-zzqzxxjxzqh-wjqs'}]}]},{'idx':32,'code':'710000','name':'台湾','search':'台湾|taiwansheng|tws','children':[{'idx':'32,0','code':'-1','name':'全省','search':'全省|quansheng|qs'}]},{'idx':33,'code':'810000','name':'香港特别行政区','search':'香港特别行政区|xianggangtebiexingzhengqu|xgtbxzq','children':[{'idx':'33,0','code':'-1','name':'全省','search':'全省|quansheng|qs'}]},{'idx':34,'code':'820000','name':'澳门特别行政区','search':'澳门特别行政区|aomentebiexingzhengqu|amtbxzq','children':[{'idx':'34,0','code':'-1','name':'全省','search':'全省|quansheng|qs'}]}];

/***/ }),
/* 241 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__dom__ = __webpack_require__(242);



var nodeList = [];
var ctx = '@@clickoutsideContext';

if (!__WEBPACK_IMPORTED_MODULE_0_vue__["default"].prototype.$isServer) {
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__dom__["a" /* on */])(document, 'click', function (e) {
    nodeList.forEach(function (node) {
      var argument = node[ctx].argument;
      if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__dom__["b" /* hasClass */])(e.target, argument)) {
        return;
      }
      node[ctx].documentHandler(e);
    });
  });
}

/**
 * v-clickoutside
 * @desc 点击元素外面才会触发的事件
 * @example
 * ```vue
 * <div v-element-clickoutside="handleClose">
 * ```
 */
/* harmony default export */ __webpack_exports__["a"] = ({
  bind: function bind(el, binding, vnode) {
    var id = nodeList.push(el) - 1;

    var documentHandler = function documentHandler(e) {
      if (!vnode.context || el.contains(e.target) || vnode.context.popperElm && vnode.context.popperElm.contains(e.target)) return;

      if (binding.expression && el[ctx].methodName && vnode.context[el[ctx].methodName]) {
        vnode.context[el[ctx].methodName]();
      } else {
        el[ctx].bindingFn && el[ctx].bindingFn();
      }
    };
    el[ctx] = {
      id: id,
      documentHandler: documentHandler,
      methodName: binding.expression,
      bindingFn: binding.value,
      argument: binding.arg
    };
  },
  update: function update(el, binding) {
    el[ctx].methodName = binding.expression;
    el[ctx].bindingFn = binding.value;
  },
  unbind: function unbind(el) {
    var len = nodeList.length;

    for (var i = 0; i < len; i++) {
      if (nodeList[i][ctx].id === el[ctx].id) {
        nodeList.splice(i, 1);
        break;
      }
    }
  }
});

/***/ }),
/* 242 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return on; });
/* unused harmony export off */
/* unused harmony export once */
/* harmony export (immutable) */ __webpack_exports__["b"] = hasClass;
/* unused harmony export addClass */
/* unused harmony export removeClass */
/* unused harmony export getStyle */
/* unused harmony export setStyle */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(15);

/* istanbul ignore next */



var isServer = __WEBPACK_IMPORTED_MODULE_1_vue__["default"].prototype.$isServer;
var SPECIAL_CHARS_REGEXP = /([:\-_]+(.))/g;
var MOZ_HACK_REGEXP = /^moz([A-Z])/;
var ieVersion = isServer ? 0 : Number(document.documentMode);

/* istanbul ignore next */
var trim = function trim(string) {
  return (string || '').replace(/^[\s\uFEFF]+|[\s\uFEFF]+$/g, '');
};
/* istanbul ignore next */
var camelCase = function camelCase(name) {
  return name.replace(SPECIAL_CHARS_REGEXP, function (_, separator, letter, offset) {
    return offset ? letter.toUpperCase() : letter;
  }).replace(MOZ_HACK_REGEXP, 'Moz$1');
};

/* istanbul ignore next */
var on = function () {
  if (!isServer && document.addEventListener) {
    return function (element, event, handler) {
      if (element && event && handler) {
        element.addEventListener(event, handler, false);
      }
    };
  } else {
    return function (element, event, handler) {
      if (element && event && handler) {
        element.attachEvent('on' + event, handler);
      }
    };
  }
}();

/* istanbul ignore next */
var off = function () {
  if (!isServer && document.removeEventListener) {
    return function (element, event, handler) {
      if (element && event) {
        element.removeEventListener(event, handler, false);
      }
    };
  } else {
    return function (element, event, handler) {
      if (element && event) {
        element.detachEvent('on' + event, handler);
      }
    };
  }
}();

/* istanbul ignore next */
var once = function once(el, event, fn) {
  var listener = function listener() {
    if (fn) {
      fn.apply(this, arguments);
    }
    off(el, event, listener);
  };
  on(el, event, listener);
};

/* istanbul ignore next */
function hasClass(el, cls) {
  if (!el || !cls) return false;
  if (cls.indexOf(' ') !== -1) throw new Error('className should not contain space.');
  if (el.classList) {
    return el.classList.contains(cls);
  } else {
    return (' ' + el.className + ' ').indexOf(' ' + cls + ' ') > -1;
  }
}

/* istanbul ignore next */
function addClass(el, cls) {
  if (!el) return;
  var curClass = el.className;
  var classes = (cls || '').split(' ');

  for (var i = 0, j = classes.length; i < j; i++) {
    var clsName = classes[i];
    if (!clsName) continue;

    if (el.classList) {
      el.classList.add(clsName);
    } else {
      if (!hasClass(el, clsName)) {
        curClass += ' ' + clsName;
      }
    }
  }
  if (!el.classList) {
    el.className = curClass;
  }
}

/* istanbul ignore next */
function removeClass(el, cls) {
  if (!el || !cls) return;
  var classes = cls.split(' ');
  var curClass = ' ' + el.className + ' ';

  for (var i = 0, j = classes.length; i < j; i++) {
    var clsName = classes[i];
    if (!clsName) continue;

    if (el.classList) {
      el.classList.remove(clsName);
    } else {
      if (hasClass(el, clsName)) {
        curClass = curClass.replace(' ' + clsName + ' ', ' ');
      }
    }
  }
  if (!el.classList) {
    el.className = trim(curClass);
  }
}

/* istanbul ignore next */
var getStyle = ieVersion < 9 ? function (element, styleName) {
  if (isServer) return;
  if (!element || !styleName) return null;
  styleName = camelCase(styleName);
  if (styleName === 'float') {
    styleName = 'styleFloat';
  }
  try {
    switch (styleName) {
      case 'opacity':
        try {
          return element.filters.item('alpha').opacity / 100;
        } catch (e) {
          return 1.0;
        }
      default:
        return element.style[styleName] || element.currentStyle ? element.currentStyle[styleName] : null;
    }
  } catch (e) {
    return element.style[styleName];
  }
} : function (element, styleName) {
  if (isServer) return;
  if (!element || !styleName) return null;
  styleName = camelCase(styleName);
  if (styleName === 'float') {
    styleName = 'cssFloat';
  }
  try {
    var computed = document.defaultView.getComputedStyle(element, '');
    return element.style[styleName] || computed ? computed[styleName] : null;
  } catch (e) {
    return element.style[styleName];
  }
};

/* istanbul ignore next */
function setStyle(element, styleName, value) {
  if (!element || !styleName) return;

  if ((typeof styleName === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(styleName)) === 'object') {
    for (var prop in styleName) {
      if (styleName.hasOwnProperty(prop)) {
        setStyle(element, prop, styleName[prop]);
      }
    }
  } else {
    styleName = camelCase(styleName);
    if (styleName === 'opacity' && ieVersion < 9) {
      element.style.filter = isNaN(value) ? '' : 'alpha(opacity=' + value * 100 + ')';
    } else {
      element.style[styleName] = value;
    }
  }
}

/***/ }),
/* 243 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return objArrDeepCopy; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__);

/**
 * 对象数组的深度拷贝.
 * source是原数据，extendObj是新增的键值对
 */
var objArrDeepCopy = function objArrDeepCopy(source, extendObj) {
  var sourceCopy = source instanceof Array ? [] : {};
  for (var item in source) {
    sourceCopy[item] = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(source[item]) === 'object' ? objArrDeepCopy(source[item], extendObj) : source[item];
    if ((typeof extendObj === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(extendObj)) === 'object' && !(sourceCopy instanceof Array)) {
      for (var param in extendObj) {
        sourceCopy[param] = extendObj[param];
      }
    }
  }
  return sourceCopy;
};

/***/ }),
/* 244 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(801);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__page_common_Login__ = __webpack_require__(698);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__page_common_Login___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__page_common_Login__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__page_common_Main__ = __webpack_require__(699);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__page_common_Main___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__page_common_Main__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__page_common_Welcome__ = __webpack_require__(700);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__page_common_Welcome___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__page_common_Welcome__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__page_common_AdminUserInfo__ = __webpack_require__(697);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__page_common_AdminUserInfo___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__page_common_AdminUserInfo__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__page_system_DepartmentStaffManagement__ = __webpack_require__(717);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__page_system_DepartmentStaffManagement___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__page_system_DepartmentStaffManagement__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__page_system_ModuleManagement__ = __webpack_require__(719);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__page_system_ModuleManagement___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__page_system_ModuleManagement__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__page_system_LabelManagement__ = __webpack_require__(718);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__page_system_LabelManagement___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__page_system_LabelManagement__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__page_other_CooperativeManage__ = __webpack_require__(705);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__page_other_CooperativeManage___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__page_other_CooperativeManage__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__page_other_MemberLeaveMessage__ = __webpack_require__(706);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__page_other_MemberLeaveMessage___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__page_other_MemberLeaveMessage__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__page_other_ProblemFeedBack__ = __webpack_require__(707);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__page_other_ProblemFeedBack___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__page_other_ProblemFeedBack__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__page_other_StaffmienManage__ = __webpack_require__(708);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__page_other_StaffmienManage___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__page_other_StaffmienManage__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__page_other_StaffmienTypeManage__ = __webpack_require__(709);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__page_other_StaffmienTypeManage___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__page_other_StaffmienTypeManage__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__page_config_BannerManage__ = __webpack_require__(701);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__page_config_BannerManage___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__page_config_BannerManage__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__page_config_ConfigManage__ = __webpack_require__(702);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__page_config_ConfigManage___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__page_config_ConfigManage__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__page_config_ContactManage__ = __webpack_require__(703);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__page_config_ContactManage___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16__page_config_ContactManage__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__page_config_ProductionBaseManage__ = __webpack_require__(704);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__page_config_ProductionBaseManage___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17__page_config_ProductionBaseManage__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__page_cms_CaseManage__ = __webpack_require__(684);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__page_cms_CaseManage___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18__page_cms_CaseManage__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__page_cms_CaseTypeManage__ = __webpack_require__(685);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__page_cms_CaseTypeManage___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19__page_cms_CaseTypeManage__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__page_cms_DownfileManage__ = __webpack_require__(686);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__page_cms_DownfileManage___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20__page_cms_DownfileManage__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__page_cms_DownfileTypeManage__ = __webpack_require__(687);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__page_cms_DownfileTypeManage___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21__page_cms_DownfileTypeManage__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__page_cms_NavigateionManage__ = __webpack_require__(689);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__page_cms_NavigateionManage___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_22__page_cms_NavigateionManage__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__page_cms_NewsManage__ = __webpack_require__(690);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__page_cms_NewsManage___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_23__page_cms_NewsManage__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__page_cms_NewsTypeManage__ = __webpack_require__(691);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__page_cms_NewsTypeManage___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_24__page_cms_NewsTypeManage__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__page_cms_ProductManage__ = __webpack_require__(692);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__page_cms_ProductManage___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_25__page_cms_ProductManage__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__page_cms_ProductTypeManage__ = __webpack_require__(694);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__page_cms_ProductTypeManage___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_26__page_cms_ProductTypeManage__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__page_cms_VideoManage__ = __webpack_require__(696);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__page_cms_VideoManage___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_27__page_cms_VideoManage__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__page_cms_SinglePageManage__ = __webpack_require__(695);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__page_cms_SinglePageManage___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_28__page_cms_SinglePageManage__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__page_cms_IndexConfigSetting__ = __webpack_require__(688);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__page_cms_IndexConfigSetting___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_29__page_cms_IndexConfigSetting__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__page_cms_ProductQuestionManage__ = __webpack_require__(693);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__page_cms_ProductQuestionManage___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_30__page_cms_ProductQuestionManage__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__page_product_ProductSSGT__ = __webpack_require__(715);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__page_product_ProductSSGT___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_31__page_product_ProductSSGT__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__page_product_ProductTypeSSGT__ = __webpack_require__(716);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__page_product_ProductTypeSSGT___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_32__page_product_ProductTypeSSGT__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__page_product_ProductMemberTypeManagement__ = __webpack_require__(713);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__page_product_ProductMemberTypeManagement___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_33__page_product_ProductMemberTypeManagement__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34__page_product_ProductMemberManagement__ = __webpack_require__(712);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34__page_product_ProductMemberManagement___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_34__page_product_ProductMemberManagement__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35__page_product_ProductNumberConfigManagement__ = __webpack_require__(714);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35__page_product_ProductNumberConfigManagement___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_35__page_product_ProductNumberConfigManagement__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36__page_product_EnquiryOnlineSubmitManagement__ = __webpack_require__(711);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36__page_product_EnquiryOnlineSubmitManagement___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_36__page_product_EnquiryOnlineSubmitManagement__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37__page_product_EnquiryOnlineConfigManagement__ = __webpack_require__(710);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37__page_product_EnquiryOnlineConfigManagement___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_37__page_product_EnquiryOnlineConfigManagement__);
// var isProduction = process.env.NODE_ENV === 'production'




// 登录页

// 系统主页面

// 欢迎页面

// 个人管理页面

// === 权限相关 START ===
// 部门员工管理

// 菜单管理

// 角色管理

// === 权限相关 END ===





























// 新增模块 2018年12月27日
// 产品用户类型管理

// 产品用户管理

// 用户数量系数管理

// 在线询价查看

// 在线询价配置管理


// 项目信息录入
// import ProjectInfo from '@/page/ProjectInfo'

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

var router = new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  routes: [{
    path: '/Login',
    name: 'Login',
    component: __WEBPACK_IMPORTED_MODULE_2__page_common_Login___default.a
  }, {
    path: '/',
    component: __WEBPACK_IMPORTED_MODULE_3__page_common_Main___default.a,
    children: [{
      path: '/',
      name: 'WelcomeIndex',
      component: __WEBPACK_IMPORTED_MODULE_4__page_common_Welcome___default.a
    }, {
      path: '/Welcome',
      name: 'Welcome',
      component: __WEBPACK_IMPORTED_MODULE_4__page_common_Welcome___default.a
    }, {
      path: '/AdminUserInfo',
      name: 'AdminUserInfo',
      component: __WEBPACK_IMPORTED_MODULE_5__page_common_AdminUserInfo___default.a
    }, {
      path: '/system/DepartmentStaffManagement',
      name: 'DepartmentStaffManagement',
      component: __WEBPACK_IMPORTED_MODULE_6__page_system_DepartmentStaffManagement___default.a
    }, {
      path: '/system/ModuleManagement',
      name: 'ModuleManagement',
      component: __WEBPACK_IMPORTED_MODULE_7__page_system_ModuleManagement___default.a
    }, {
      path: '/system/LabelManagement',
      name: 'LabelManagement',
      component: __WEBPACK_IMPORTED_MODULE_8__page_system_LabelManagement___default.a
    }, {
      path: '/config/BannerManage',
      name: 'BannerManage',
      component: __WEBPACK_IMPORTED_MODULE_14__page_config_BannerManage___default.a
    }, {
      path: '/config/ConfigManage',
      name: 'ConfigManage',
      component: __WEBPACK_IMPORTED_MODULE_15__page_config_ConfigManage___default.a
    }, {
      path: '/config/ProductionBaseManage',
      name: 'ProductionBaseManage',
      component: __WEBPACK_IMPORTED_MODULE_17__page_config_ProductionBaseManage___default.a
    }, {
      path: '/config/ContactManage',
      name: 'ContactManage',
      component: __WEBPACK_IMPORTED_MODULE_16__page_config_ContactManage___default.a
    }, {
      path: '/other/CooperativeManage',
      name: 'CooperativeManage',
      component: __WEBPACK_IMPORTED_MODULE_9__page_other_CooperativeManage___default.a
    }, {
      path: '/other/MemberLeaveMessage',
      name: 'MemberLeaveMessage',
      component: __WEBPACK_IMPORTED_MODULE_10__page_other_MemberLeaveMessage___default.a
    }, {
      path: '/other/ProblemFeedBack',
      name: 'ProblemFeedBack',
      component: __WEBPACK_IMPORTED_MODULE_11__page_other_ProblemFeedBack___default.a
    }, {
      path: '/other/StaffmienManage',
      name: 'StaffmienManage',
      component: __WEBPACK_IMPORTED_MODULE_12__page_other_StaffmienManage___default.a
    }, {
      path: '/other/StaffmienTypeManage',
      name: 'StaffmienTypeManage',
      component: __WEBPACK_IMPORTED_MODULE_13__page_other_StaffmienTypeManage___default.a
    }, {
      path: '/cms/CaseManage',
      name: 'CaseManage',
      component: __WEBPACK_IMPORTED_MODULE_18__page_cms_CaseManage___default.a
    }, {
      path: '/cms/CaseTypeManage',
      name: 'CaseTypeManage',
      component: __WEBPACK_IMPORTED_MODULE_19__page_cms_CaseTypeManage___default.a
    }, {
      path: '/cms/DownfileManage',
      name: 'DownfileManage',
      component: __WEBPACK_IMPORTED_MODULE_20__page_cms_DownfileManage___default.a
    }, {
      path: '/cms/DownfileTypeManage',
      name: 'DownfileTypeManage',
      component: __WEBPACK_IMPORTED_MODULE_21__page_cms_DownfileTypeManage___default.a
    }, {
      path: '/cms/NavigateionManage',
      name: 'NavigateionManage',
      component: __WEBPACK_IMPORTED_MODULE_22__page_cms_NavigateionManage___default.a
    }, {
      path: '/cms/NewsManage',
      name: 'NewsManage',
      component: __WEBPACK_IMPORTED_MODULE_23__page_cms_NewsManage___default.a
    }, {
      path: '/cms/NewsTypeManage',
      name: 'NewsTypeManage',
      component: __WEBPACK_IMPORTED_MODULE_24__page_cms_NewsTypeManage___default.a
    }, {
      path: '/cms/ProductManage',
      name: 'ProductManage',
      component: __WEBPACK_IMPORTED_MODULE_25__page_cms_ProductManage___default.a
    }, {
      path: '/cms/ProductTypeManage',
      name: 'ProductTypeManage',
      component: __WEBPACK_IMPORTED_MODULE_26__page_cms_ProductTypeManage___default.a
    }, {
      path: '/cms/VideoManage',
      name: 'VideoManage',
      component: __WEBPACK_IMPORTED_MODULE_27__page_cms_VideoManage___default.a
    }, {
      path: '/cms/SinglePageManage',
      name: 'SinglePageManage',
      component: __WEBPACK_IMPORTED_MODULE_28__page_cms_SinglePageManage___default.a
    }, {
      path: '/product/ProductSSGT',
      name: 'ProductSSGT',
      component: __WEBPACK_IMPORTED_MODULE_31__page_product_ProductSSGT___default.a
    }, {
      path: '/product/ProductTypeSSGT',
      name: 'ProductTypeSSGT',
      component: __WEBPACK_IMPORTED_MODULE_32__page_product_ProductTypeSSGT___default.a
    }, {
      path: '/product/EnquiryOnlineSubmitManagement',
      name: 'EnquiryOnlineSubmitManagement',
      component: __WEBPACK_IMPORTED_MODULE_36__page_product_EnquiryOnlineSubmitManagement___default.a
    }, {
      path: '/product/EnquiryOnlineConfigManagement',
      name: 'EnquiryOnlineConfigManagement',
      component: __WEBPACK_IMPORTED_MODULE_37__page_product_EnquiryOnlineConfigManagement___default.a
    }, {
      path: '/product/ProductMemberManagement',
      name: 'ProductMemberManagement',
      component: __WEBPACK_IMPORTED_MODULE_34__page_product_ProductMemberManagement___default.a
    }, {
      path: '/product/ProductNumberConfigManagement',
      name: 'ProductNumberConfigManagement',
      component: __WEBPACK_IMPORTED_MODULE_35__page_product_ProductNumberConfigManagement___default.a
    }, {
      path: '/product/ProductMemberTypeManagement',
      name: 'ProductMemberTypeManagement',
      component: __WEBPACK_IMPORTED_MODULE_33__page_product_ProductMemberTypeManagement___default.a
    }, {
      path: '/cms/IndexConfigSetting',
      name: 'IndexConfigSetting',
      component: __WEBPACK_IMPORTED_MODULE_29__page_cms_IndexConfigSetting___default.a
    }, {
      path: '/cms/ProductQuestionManage',
      name: 'ProductQuestionManage',
      component: __WEBPACK_IMPORTED_MODULE_30__page_cms_ProductQuestionManage___default.a
    }]
  }]
});

router.beforeEach(function (to, from, next) {
  // 获取登录用户信息, 成功(用户已登录)进入, 失败(用户未登录)跳转登录页
  router.app.$store.dispatch('getLoginMemberInfo').then(function (res) {
    // 已登录
    if (to.fullPath === '/Login') {
      // 如果登陆页自动跳转到首页
      next('/');
    }
    // 正常页面进入
    next();
  }, function () {
    // 未登录
    if (to.fullPath !== '/Login') {
      // 非登录页跳转登录页
      next('/Login');
    }
    // 直接进入登录页
    next();
  });
});

/* harmony default export */ __webpack_exports__["a"] = (router);

/***/ }),
/* 245 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getLoginMemberInfo", function() { return getLoginMemberInfo; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_common_user__ = __webpack_require__(80);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__store_mutation_types__ = __webpack_require__(152);



// 获得登录用户信息
var getLoginMemberInfo = function getLoginMemberInfo(_ref) {
  var commit = _ref.commit;
  var hasLoading = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

  return __WEBPACK_IMPORTED_MODULE_0__components_common_user__["a" /* default */].getLoginMemberModel(hasLoading).then(function (res) {
    commit(__WEBPACK_IMPORTED_MODULE_1__store_mutation_types__["a" /* UPDATE_MEMBERINFO */], res.data.AdminUser);
    commit(__WEBPACK_IMPORTED_MODULE_1__store_mutation_types__["b" /* UPDATE_MEMBERPOWER */], res.data.ModuleList);
  });
};

/***/ }),
/* 246 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "quickNavModuleData", function() { return quickNavModuleData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "sideModuleData", function() { return sideModuleData; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_common_tools__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_common_tree__ = __webpack_require__(36);



// 菜单树
var moduleTree = new __WEBPACK_IMPORTED_MODULE_1__components_common_tree__["a" /* default */].TreeCreate(function (item) {
  for (var key in item) {
    if (item.hasOwnProperty(key)) {
      this[key] = item[key];
    }
  }
}, {
  FId: 'MoFacode',
  Id: 'MoCode'
});

// 快捷菜单
var quickNavModuleData = function quickNavModuleData(state) {
  return state.user.memberPower.filter(function (item) {
    return item.IsLeaf === 1 && item.MoType === 0;
  });
};

// 侧边菜单
var sideModuleData = function sideModuleData(state) {
  var data = __WEBPACK_IMPORTED_MODULE_0__components_common_tools__["a" /* default */].getModel(state.user.memberPower);
  // 首页
  data.unshift({
    MoFacode: '0',
    MoCode: '1',
    MoName: 'Index',
    MoUrl: '/Welcome',
    MoLogo: 'fa-gg',
    MoSort: 10000,
    MoType: 0,
    IsLeaf: 1,
    MoState: 1
  });
  // 个人信息页面
  data.unshift({
    MoFacode: '0',
    MoCode: '2',
    MoName: 'Member Manage',
    MoUrl: '/AdminUserInfo',
    MoLogo: 'fa-gg',
    MoSort: 10001,
    MoType: 1,
    IsLeaf: 1,
    MoState: 1
  });
  moduleTree.create(data);
  return moduleTree.getTreeData();
};

/***/ }),
/* 247 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(804);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__actions__ = __webpack_require__(245);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__getters__ = __webpack_require__(246);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__modules__ = __webpack_require__(151);






__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */]);

var debug = "production" !== 'production';

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */].Store({
  actions: __WEBPACK_IMPORTED_MODULE_2__actions__,
  getters: __WEBPACK_IMPORTED_MODULE_3__getters__,
  modules: __WEBPACK_IMPORTED_MODULE_4__modules__["default"],
  strict: debug
}));

/***/ }),
/* 248 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(156);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__store_mutation_types__ = __webpack_require__(152);


var _mutations;



var state = {
  memberInfo: null, // 用户信息
  memberPower: null // 用户权限
};

var mutations = (_mutations = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_1__store_mutation_types__["a" /* UPDATE_MEMBERINFO */], function (state, newVal) {
  state.memberInfo = newVal;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_1__store_mutation_types__["b" /* UPDATE_MEMBERPOWER */], function (state, newVal) {
  state.memberPower = newVal;
}), _mutations);

/* harmony default export */ __webpack_exports__["default"] = ({
  state: state,
  mutations: mutations
});

/***/ }),
/* 249 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'VueUEditor',
  props: {
    ueditorPath: {
      type: String,
      default: '/static/ueditor1_4_3_3/'
    },
    ueditorConfig: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  data: function data() {
    return {
      randomId: 'editor_' + Math.random() * 100000000000000000,
      instance: null,

      scriptTagStatus: 0
    };
  },
  created: function created() {
    if (window.UE !== undefined) {
      this.scriptTagStatus = 2;
      this.initEditor();
    } else {
      this.insertScriptTag();
    }
  },
  beforeDestroy: function beforeDestroy() {
    if (this.instance !== null && this.instance.destroy) {
      this.instance.destroy();
    }
  },

  methods: {
    insertScriptTag: function insertScriptTag() {
      var _this = this;

      var editorScriptTag = document.getElementById('editorScriptTag');
      var configScriptTag = document.getElementById('configScriptTag');

      if (editorScriptTag === null) {
        configScriptTag = document.createElement('script');
        configScriptTag.type = 'text/javascript';configScriptTag.src = this.ueditorPath + 'ueditor.config.js';configScriptTag.id = 'configScriptTag';

        editorScriptTag = document.createElement('script');
        editorScriptTag.type = 'text/javascript';editorScriptTag.src = this.ueditorPath + 'ueditor.all.js';editorScriptTag.id = 'editorScriptTag';
        var s = document.getElementsByTagName('head')[0];
        s.appendChild(configScriptTag);
        s.appendChild(editorScriptTag);
      }

      if (configScriptTag.loaded) {
        this.scriptTagStatus++;
      } else {
        configScriptTag.addEventListener('load', function () {
          _this.scriptTagStatus++;
          configScriptTag.loaded = true;
          _this.initEditor();
        });
      }

      if (editorScriptTag.loaded) {
        this.scriptTagStatus++;
      } else {
        editorScriptTag.addEventListener('load', function () {
          _this.scriptTagStatus++;
          editorScriptTag.loaded = true;
          _this.initEditor();
        });
      }

      this.initEditor();
    },
    initEditor: function initEditor() {
      var _this2 = this;

      if (this.scriptTagStatus === 2 && this.instance === null) {
        this.$nextTick(function () {
          _this2.instance = window.UE.getEditor(_this2.randomId, _this2.ueditorConfig);

          _this2.instance.addListener('ready', function () {
            _this2.$emit('ready', _this2.instance);
          });
        });
      }
    }
  }
});

/***/ }),
/* 250 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_clipboard__ = __webpack_require__(334);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_clipboard___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_clipboard__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_common_config__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui__ = __webpack_require__(102);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_element_ui__);
//
//
//
//
//
//
//
//
//
//
//
//






window.Mc || (window.Mc = {});

// 是否能上传
window.Mc._canUpload = true;

// 显示图片上传
window.Mc.showImgUpload = function (callback) {
  if (window.Mc._canUpload) {
    __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#common_upload_img input').trigger('click');
    callback && callback();
  }
};

// 显示文件上传
window.Mc.showFileUpload = function (callback) {
  if (window.Mc._canUpload) {
    __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#common_upload_file input').trigger('click');
    callback && callback();
  }
};

// 显示文件上传 - k3询价excel上传
window.Mc.showFileUploadK3 = function (callback) {
  if (window.Mc._canUpload) {
    __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#common_upload_file_k3 input').trigger('click');
    callback && callback();
  }
};

// 复制文本
var copyTxt;
window.Mc.copyTxt = function (txt, callback) {
  copyTxt = txt;
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#common_copy_btn').trigger('click');
  callback && callback();
};

var loadingInstance = void 0;

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'app',
  mounted: function mounted() {
    // 初始化全局图片上传
    this.initImgUpload();
    // 初始化全局文件上传
    this.initFileUpload();
    // 初始化全局文件上传 - k3询价excel上传
    this.initFileUploadK3();
    // 初始化全局复制
    this.initClipboard();
  },

  methods: {
    // 初始化全局图片上传
    initImgUpload: function initImgUpload() {
      // 全局图片上传
      window.Mc.gImageUpload = new window.Mc.Uploader({
        target: '#common_upload_img',
        url: __WEBPACK_IMPORTED_MODULE_2__components_common_config__["a" /* default */].AjaxUrl + '/controller.ashx?action=uploadimage',
        auto: true,
        showLoadingFun: function showLoadingFun() {
          window.Mc._canUpload = false;
          loadingInstance = __WEBPACK_IMPORTED_MODULE_3_element_ui__["Loading"].service({
            fullscreen: true
          });
        },
        hideLoadingFun: function hideLoadingFun() {
          window.Mc._canUpload = true;
          loadingInstance.close();
        },

        successHideLoading: false,
        success: function success($this, res, file) {
          window.vueEvent.$emit('upload:success', res.data);
        }
      });
    },

    // 初始化全局文件上传
    initFileUpload: function initFileUpload() {
      // 全局文件上传
      window.Mc.gFileUpload = new window.Mc.Uploader({
        target: '#common_upload_file',
        type: 'file',
        name: 'upfile',
        url: __WEBPACK_IMPORTED_MODULE_2__components_common_config__["a" /* default */].AjaxUrl + '/controller.ashx?action=uploadfile',
        auto: true,
        showLoadingFun: function showLoadingFun() {
          window.Mc._canUpload = false;
          loadingInstance = __WEBPACK_IMPORTED_MODULE_3_element_ui__["Loading"].service({
            fullscreen: true
          });
        },
        hideLoadingFun: function hideLoadingFun() {
          window.Mc._canUpload = true;
          loadingInstance.close();
        },

        successHideLoading: false,
        success: function success($this, res, file) {
          window.vueEvent.$emit('upload:success', res.data);
        }
      });
    },

    // 初始化全局文件上传 - k3询价excel上传
    initFileUploadK3: function initFileUploadK3() {
      // 全局文件上传
      window.Mc.gFileUploadK3 = new window.Mc.Uploader({
        target: '#common_upload_file_k3',
        type: 'file',
        name: 'file',
        url: __WEBPACK_IMPORTED_MODULE_2__components_common_config__["a" /* default */].AjaxUrl + '/Ajax/UploadExcelTemplateInAdmin',
        auto: true,
        showLoadingFun: function showLoadingFun() {
          window.Mc._canUpload = false;
          loadingInstance = __WEBPACK_IMPORTED_MODULE_3_element_ui__["Loading"].service({
            fullscreen: true
          });
        },
        hideLoadingFun: function hideLoadingFun() {
          window.Mc._canUpload = true;
          loadingInstance.close();
        },

        successHideLoading: false,
        success: function success($this, res, file) {
          window.vueEvent.$emit('upload:success', res);
        }
      });
    },

    // 初始化全局复制
    initClipboard: function initClipboard() {
      var _this = this;
      // 如果存在则销毁
      if (window.Mc.gClipboard) {
        window.Mc.gClipboard.destroy();
      }
      // 全局复制
      var clipboard = new __WEBPACK_IMPORTED_MODULE_1_clipboard___default.a('#common_copy_btn', {
        text: function text() {
          return copyTxt;
        }
      });
      clipboard.on('success', function (e) {
        _this.$message.success('copy success!');
        // console.info('Action:', e.action)
        // console.info('Text:', e.text)
        // console.info('Trigger:', e.trigger)
        // e.clearSelection()
      });
      clipboard.on('error', function (e) {
        _this.$message.error('copy fail!');
        // console.error('Action:', e.action)
        // console.error('Trigger:', e.trigger)
      });
      window.Mc.gClipboard = clipboard;
    }
  }
});

/***/ }),
/* 251 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_underscore__ = __webpack_require__(149);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_underscore___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_underscore__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// import $ from 'jquery'

// import config from '@/components/common/config'

/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    // collapsed: {
    //   type: Boolean,
    //   default() {
    //     return false
    //   }
    // },
    text: {
      type: String,
      default: function _default() {
        return 'text';
      }
    },
    href: {
      type: String,
      default: function _default() {
        return 'href';
      }
    },
    logo: {
      type: String,
      default: function _default() {
        return 'logo';
      }
    },
    isLeaf: {
      type: String,
      default: function _default() {
        return 'isLeaf';
      }
    },
    groupKey: {
      type: String,
      default: function _default() {
        return 'groupKey';
      }
    },
    // menuData: {
    //   type: Array,
    //   default() {
    //     return []
    //   }
    // },
    activeNavIdx: {
      type: Number,
      default: 0
    }
  },
  created: function created() {
    this.initSideData();
  },
  data: function data() {
    return {
      sideData: []
      // sidebarCollapsed: this.collapsed
    };
  },

  computed: {
    groupMenuData: function groupMenuData() {
      return __WEBPACK_IMPORTED_MODULE_0_underscore___default.a.toArray(__WEBPACK_IMPORTED_MODULE_0_underscore___default.a.groupBy(this.$store.getters.sideModuleData, this.groupKey));
    }
  },
  watch: {
    groupMenuData: function groupMenuData() {
      this.initSideData();
    },
    $route: function $route() {
      this.initSideData();
    }
  },
  methods: {
    initSideData: function initSideData() {
      var _this = this;

      console.log(111);
      var tmp = void 0,
          currentIdx = void 0;
      tmp = [];
      currentIdx = 0;
      // var data = $.extend(true, [], this.menuData)
      this.groupMenuData.forEach(function (menuList, i) {
        tmp[i] = menuList.map(function (item) {
          // this.$set(item, 'id', false)
          if (item[_this.isLeaf]) {
            // 叶子节点
            if (_this.txtEqual(item[_this.href], _this.$route.path)) {
              currentIdx = i;
            }
          } else {
            // 非叶子节点
            var sonActive = false;
            if (item.children) {
              sonActive = item.children.find(function (el) {
                return _this.txtEqual(el[_this.href], _this.$route.path);
              });
            }
            if (sonActive) {
              item.expand = true;
              // this.$set(item, 'expand', true)
              currentIdx = i;
            } else {
              item.expand = false;
              // this.$set(item, 'expand', false)
            }
          }
          return item;
        });
      });
      this.$emit('update:activeNavIdx', currentIdx);
      this.sideData = tmp[currentIdx];
    },
    txtEqual: function txtEqual(a, b) {
      return (a ? a.toLowerCase() : a) === (b ? b.toLowerCase() : b);
    },

    // 展开收拢子菜单
    toggleSubMenu: function toggleSubMenu(item) {
      var _this2 = this;

      this.sideData.forEach(function (el) {
        if (el[_this2.href] !== item[_this2.href]) {
          el.expand = false;
        }
      });
      item.expand = !item.expand;
    },

    // 菜单展开
    slideDown: function slideDown(el, childrenNbr) {
      // el.style.height = 'auto'
      // el.getBoundingClientRect().height
      var height = childrenNbr * 40;
      el.style.height = '0px';
      // 触发浏览器重绘
      el.offsetHeight;
      this.$nextTick(function () {
        el.style.height = height + 'px';
        el.style.opacity = 1;
      });
    },

    // 菜单收拢前
    beforeSlideUp: function beforeSlideUp(el, childrenNbr) {
      // el.style.height = 'auto'
      // let height = el.getBoundingClientRect().height
      var height = childrenNbr * 40;
      el.style.height = height + 'px';
      // 触发浏览器重绘
      el.offsetHeight;
    },

    // 菜单收拢
    slideUp: function slideUp(el) {
      el.style.opacity = 0;
      el.style.height = '0px';
    }
    // // 侧栏展开收拢
    // toggleSlide() {
    //   this.sidebarCollapsed = !this.sidebarCollapsed
    // }

  }
});

/***/ }),
/* 252 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_common_config__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_common_user__ = __webpack_require__(80);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



// import tools from '@/components/common/tools'

/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    activeNavIdx: {
      type: Number,
      default: 0
    }
  },
  data: function data() {
    return {
      config: __WEBPACK_IMPORTED_MODULE_0__components_common_config__["a" /* default */]
    };
  },

  computed: {
    memberInfo: function memberInfo() {
      return this.$store.state.user.memberInfo;
    }
  },
  methods: {
    // 顶部导航点击
    changeNav: function changeNav(url) {
      this.$router.push(url);
    },

    // 侧栏展开收拢
    toggleSidebar: function toggleSidebar() {
      this.$emit('toggleSideBar');
    },
    loginOut: function loginOut() {
      __WEBPACK_IMPORTED_MODULE_1__components_common_user__["a" /* default */].loginOut();
    }
  }
});

/***/ }),
/* 253 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_common_tools__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__libcomponents_img_upload_img_upload__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__libcomponents_img_upload_img_upload___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__libcomponents_img_upload_img_upload__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__libcomponents_mc_editor_mc_editor__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__libcomponents_mc_editor_mc_editor___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__libcomponents_mc_editor_mc_editor__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






// 数据对象
var dataStore = __WEBPACK_IMPORTED_MODULE_1__components_common_tools__["a" /* default */].createDataStore({
  CtCode: '0',
  CiName: '',
  CiAuthor: '',
  CiImg: '',
  CiContent: '',
  CiDescribe: '',
  CiSort: '',
  IsRelease: false,
  ReleaseTime: ''
});

// 请求相关操作
var page = {
  methods: {
    // add操作
    addDataAjax: function addDataAjax() {
      var _this = this;

      var data = __WEBPACK_IMPORTED_MODULE_1__components_common_tools__["a" /* default */].getModel(this.formData);
      data.IsRelease = data.IsRelease ? 1 : 0;
      data.CiContent = this.$refs.editCiContent.getValue();
      __WEBPACK_IMPORTED_MODULE_1__components_common_tools__["a" /* default */].commonAjax.call(this, true, '/Ajax/AddCaseInfoInAdmin', data).then(function () {
        _this.$message.success('Operate success!');
        // add成功
        _this.$emit('addSuccess');
      });
    },

    // 修改操作
    updateDataAjax: function updateDataAjax(id, state) {
      var _this2 = this;

      var data = __WEBPACK_IMPORTED_MODULE_1__components_common_tools__["a" /* default */].getModel(this.formData);
      data.IsRelease = data.IsRelease ? 1 : 0;
      data.CiContent = this.$refs.editCiContent.getValue();
      __WEBPACK_IMPORTED_MODULE_1__components_common_tools__["a" /* default */].commonAjax.call(this, true, '/Ajax/UpdateCaseInfoInAdmin', data).then(function () {
        _this2.$message.success('Operate success!');
        // 修改成功
        _this2.$emit('updateSuccess');
      });
    }
  }
};

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'CaseForm',
  componentName: 'CaseForm',
  mixins: [page],
  components: {
    imgUpload: __WEBPACK_IMPORTED_MODULE_2__libcomponents_img_upload_img_upload___default.a, mcEditor: __WEBPACK_IMPORTED_MODULE_3__libcomponents_mc_editor_mc_editor___default.a
  },
  props: ['sideCurrent'],
  created: function created() {
    this.setSideCurrent();
  },
  data: function data() {
    return {
      formData: dataStore.getDefaultData()
    };
  },

  watch: {
    sideCurrent: function sideCurrent() {
      this.setSideCurrent();
    }
  },
  methods: {
    // 设置侧边当前项
    setSideCurrent: function setSideCurrent() {
      if (this.sideCurrent) {
        dataStore.setDefaultData(__WEBPACK_IMPORTED_MODULE_0_jquery___default.a.extend(dataStore.getDefaultData(), {
          // 侧边code
          CtCode: this.sideCurrent.CtCode
        }));
      }
    },

    // 重置表单值
    resetValue: function resetValue() {
      this.formData = dataStore.getDefaultData();
    },

    // 设置表单值
    setValue: function setValue(value) {
      value.IsRelease = !!value.IsRelease;
      this.formData = __WEBPACK_IMPORTED_MODULE_1__components_common_tools__["a" /* default */].extendData(dataStore.getDefaultData(), value || {});
    },

    // 发布
    doAdd: function doAdd(formName) {
      var _this3 = this;

      this.$refs[formName].validate(function (valid) {
        if (valid) {
          _this3.addDataAjax();
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },

    // 修改
    doUpdate: function doUpdate(formName) {
      var _this4 = this;

      this.$refs[formName].validate(function (valid) {
        if (valid) {
          _this4.updateDataAjax();
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    }
  }
});

/***/ }),
/* 254 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_common_tools__ = __webpack_require__(2);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



// 数据对象
var dataStore = __WEBPACK_IMPORTED_MODULE_0__components_common_tools__["a" /* default */].createDataStore({
  CtName: '',
  CtSort: ''
});

// 请求相关操作
var page = {
  methods: {
    // add操作
    addDataAjax: function addDataAjax() {
      var _this = this;

      var data = __WEBPACK_IMPORTED_MODULE_0__components_common_tools__["a" /* default */].getModel(this.formData);
      __WEBPACK_IMPORTED_MODULE_0__components_common_tools__["a" /* default */].commonAjax.call(this, true, '/Ajax/AddCaseTypeInAdmin', data).then(function () {
        _this.$message.success('Operate success!');
        // add成功
        _this.$emit('addSuccess');
      });
    },

    // 修改操作
    updateDataAjax: function updateDataAjax(id, state) {
      var _this2 = this;

      var data = __WEBPACK_IMPORTED_MODULE_0__components_common_tools__["a" /* default */].getModel(this.formData);
      __WEBPACK_IMPORTED_MODULE_0__components_common_tools__["a" /* default */].commonAjax.call(this, true, '/Ajax/UpdateCaseTypeInAdmin', data).then(function () {
        _this2.$message.success('Operate success!');
        // 修改成功
        _this2.$emit('updateSuccess');
      });
    }
  }
};

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'CaseTypeForm',
  componentName: 'CaseTypeForm',
  mixins: [page],
  data: function data() {
    return {
      formData: dataStore.getDefaultData()
    };
  },

  methods: {
    // 重置表单值
    resetValue: function resetValue() {
      this.formData = dataStore.getDefaultData();
    },

    // 设置表单值
    setValue: function setValue(value) {
      this.formData = __WEBPACK_IMPORTED_MODULE_0__components_common_tools__["a" /* default */].extendData(dataStore.getDefaultData(), value || {});
    },

    // 发布
    doAdd: function doAdd(formName) {
      var _this3 = this;

      this.$refs[formName].validate(function (valid) {
        if (valid) {
          _this3.addDataAjax();
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },

    // 修改
    doUpdate: function doUpdate(formName) {
      var _this4 = this;

      this.$refs[formName].validate(function (valid) {
        if (valid) {
          _this4.updateDataAjax();
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    }
  }
});

/***/ }),
/* 255 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_common_tools__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__libcomponents_img_upload_img_upload__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__libcomponents_img_upload_img_upload___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__libcomponents_img_upload_img_upload__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__libcomponents_file_upload_file_upload__ = __webpack_require__(213);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__libcomponents_file_upload_file_upload___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__libcomponents_file_upload_file_upload__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






// 数据对象
var dataStore = __WEBPACK_IMPORTED_MODULE_1__components_common_tools__["a" /* default */].createDataStore({
  DtCode: '',
  DiTitle: '',
  DiImg: '',
  DiAttachment: '',
  DiSort: ''
});

// 请求相关操作
var page = {
  methods: {
    // add操作
    addDataAjax: function addDataAjax() {
      var _this = this;

      var data = __WEBPACK_IMPORTED_MODULE_1__components_common_tools__["a" /* default */].getModel(this.formData);
      // console.log(data)
      __WEBPACK_IMPORTED_MODULE_1__components_common_tools__["a" /* default */].commonAjax.call(this, true, '/Ajax/AddDataInfoInAdmin', data).then(function () {
        _this.$message.success('Operate success!');
        // add成功
        _this.$emit('addSuccess');
      });
    },

    // 修改操作
    updateDataAjax: function updateDataAjax(id, state) {
      var _this2 = this;

      var data = __WEBPACK_IMPORTED_MODULE_1__components_common_tools__["a" /* default */].getModel(this.formData);
      // console.log(data)
      __WEBPACK_IMPORTED_MODULE_1__components_common_tools__["a" /* default */].commonAjax.call(this, true, '/Ajax/UpdateDataInfoInAdmin', data).then(function () {
        _this2.$message.success('Operate success!');
        // 修改成功
        _this2.$emit('updateSuccess');
      });
    }
  }
};

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'DownfileForm',
  componentName: 'DownfileForm',
  mixins: [page],
  components: {
    imgUpload: __WEBPACK_IMPORTED_MODULE_2__libcomponents_img_upload_img_upload___default.a, fileUpload: __WEBPACK_IMPORTED_MODULE_3__libcomponents_file_upload_file_upload___default.a
  },
  props: ['sideCurrent'],
  created: function created() {
    this.setSideCurrent();
  },
  data: function data() {
    return {
      formData: dataStore.getDefaultData()
    };
  },

  watch: {
    sideCurrent: function sideCurrent() {
      this.setSideCurrent();
    }
  },
  methods: {
    // 设置侧边当前项
    setSideCurrent: function setSideCurrent() {
      if (this.sideCurrent) {
        dataStore.setDefaultData(__WEBPACK_IMPORTED_MODULE_0_jquery___default.a.extend(dataStore.getDefaultData(), {
          // 侧边code
          DtCode: this.sideCurrent.DtCode
        }));
      }
    },

    // 重置表单值
    resetValue: function resetValue() {
      this.formData = dataStore.getDefaultData();
    },

    // 设置表单值
    setValue: function setValue(value) {
      this.formData = __WEBPACK_IMPORTED_MODULE_1__components_common_tools__["a" /* default */].extendData(dataStore.getDefaultData(), value || {});
    },

    // 发布
    doAdd: function doAdd(formName) {
      var _this3 = this;

      this.$refs[formName].validate(function (valid) {
        if (valid) {
          _this3.addDataAjax();
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },

    // 修改
    doUpdate: function doUpdate(formName) {
      var _this4 = this;

      this.$refs[formName].validate(function (valid) {
        if (valid) {
          _this4.updateDataAjax();
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    }
  }
});

/***/ }),
/* 256 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_common_tools__ = __webpack_require__(2);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



// 数据对象
var dataStore = __WEBPACK_IMPORTED_MODULE_0__components_common_tools__["a" /* default */].createDataStore({
  DtFacode: '0',
  DtName: '',
  DtSort: '',
  DtBtnName: '',
  IsLeaf: 0
});

// 请求相关操作
var page = {
  methods: {
    // add操作
    addDataAjax: function addDataAjax() {
      var _this = this;

      var data = __WEBPACK_IMPORTED_MODULE_0__components_common_tools__["a" /* default */].getModel(this.formData);
      data.IsLeaf = data.IsLeaf ? 1 : 0;
      __WEBPACK_IMPORTED_MODULE_0__components_common_tools__["a" /* default */].commonAjax.call(this, true, '/Ajax/AddDataTypeInAdmin', data).then(function () {
        _this.$message.success('Operate success!');
        // add成功
        _this.$emit('addSuccess');
      });
    },

    // 修改操作
    updateDataAjax: function updateDataAjax(id, state) {
      var _this2 = this;

      var data = __WEBPACK_IMPORTED_MODULE_0__components_common_tools__["a" /* default */].getModel(this.formData);
      data.IsLeaf = data.IsLeaf ? 1 : 0;
      __WEBPACK_IMPORTED_MODULE_0__components_common_tools__["a" /* default */].commonAjax.call(this, true, '/Ajax/UpdateDataTypeInAdmin', data).then(function () {
        _this2.$message.success('Operate success!');
        // 修改成功
        _this2.$emit('updateSuccess');
      });
    }
  }
};

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'DownfileTypeForm',
  componentName: 'DownfileTypeForm',
  mixins: [page],
  data: function data() {
    return {
      formData: dataStore.getDefaultData()
    };
  },

  methods: {
    // 重置表单值
    resetValue: function resetValue() {
      this.formData = dataStore.getDefaultData();
    },

    // 设置表单值
    setValue: function setValue(value) {
      value.IsLeaf = !!value.IsLeaf;
      this.formData = __WEBPACK_IMPORTED_MODULE_0__components_common_tools__["a" /* default */].extendData(dataStore.getDefaultData(), value || {});
    },

    // 发布
    doAdd: function doAdd(formName) {
      var _this3 = this;

      this.$refs[formName].validate(function (valid) {
        if (valid) {
          _this3.addDataAjax();
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },

    // 修改
    doUpdate: function doUpdate(formName) {
      var _this4 = this;

      this.$refs[formName].validate(function (valid) {
        if (valid) {
          _this4.updateDataAjax();
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    }
  }
});

/***/ }),
/* 257 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_common_tools__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__libcomponents_img_upload_img_upload__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__libcomponents_img_upload_img_upload___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__libcomponents_img_upload_img_upload__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




// 数据对象
var dataStore = __WEBPACK_IMPORTED_MODULE_0__components_common_tools__["a" /* default */].createDataStore({
  IsImg: '',
  IsName: '',
  IsDes: '',
  IsUrl: '',
  IsSort: ''
});

// 请求相关操作
var page = {
  methods: {
    // add操作
    addDataAjax: function addDataAjax() {
      var _this = this;

      var data = __WEBPACK_IMPORTED_MODULE_0__components_common_tools__["a" /* default */].getModel(this.formData);
      __WEBPACK_IMPORTED_MODULE_0__components_common_tools__["a" /* default */].commonAjax.call(this, true, '/Ajax/AddIndexSettingInAdmin', data).then(function () {
        _this.$message.success('Operate success!');
        // add成功
        _this.$emit('addSuccess');
      });
    },

    // 修改操作
    updateDataAjax: function updateDataAjax(id, state) {
      var _this2 = this;

      var data = __WEBPACK_IMPORTED_MODULE_0__components_common_tools__["a" /* default */].getModel(this.formData);
      __WEBPACK_IMPORTED_MODULE_0__components_common_tools__["a" /* default */].commonAjax.call(this, true, '/Ajax/UpdateIndexSettingInAdmin', data).then(function () {
        _this2.$message.success('Operate success!');
        // 修改成功
        _this2.$emit('updateSuccess');
      });
    }
  }
};

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'IndexConfigSetForm',
  componentName: 'IndexConfigSetForm',
  mixins: [page],
  components: {
    imgUpload: __WEBPACK_IMPORTED_MODULE_1__libcomponents_img_upload_img_upload___default.a
  },
  data: function data() {
    return {
      formData: dataStore.getDefaultData()
    };
  },

  methods: {
    // 重置表单值
    resetValue: function resetValue() {
      this.formData = dataStore.getDefaultData();
    },

    // 设置表单值
    setValue: function setValue(value) {
      this.formData = __WEBPACK_IMPORTED_MODULE_0__components_common_tools__["a" /* default */].extendData(dataStore.getDefaultData(), value || {});
    },

    // 发布
    doAdd: function doAdd(formName) {
      var _this3 = this;

      this.$refs[formName].validate(function (valid) {
        if (valid) {
          _this3.addDataAjax();
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },

    // 修改
    doUpdate: function doUpdate(formName) {
      var _this4 = this;

      this.$refs[formName].validate(function (valid) {
        if (valid) {
          _this4.updateDataAjax();
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    }
  }
});

/***/ }),
/* 258 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_common_tools__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__libcomponents_img_upload_img_upload__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__libcomponents_img_upload_img_upload___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__libcomponents_img_upload_img_upload__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




// 数据对象
var dataStore = __WEBPACK_IMPORTED_MODULE_0__components_common_tools__["a" /* default */].createDataStore({
  NbFacode: '0',
  NbName: '',
  IsLeaf: false,
  IsShow: false,
  NbUrl: '',
  NbImg: '',
  NbSort: ''
});

// 请求相关操作
var page = {
  methods: {
    // add操作
    addDataAjax: function addDataAjax() {
      var _this = this;

      var data = __WEBPACK_IMPORTED_MODULE_0__components_common_tools__["a" /* default */].getModel(this.formData);
      data.IsLeaf = data.NbFacode === '0' ? data.IsLeaf ? 1 : 0 : 1;
      data.IsShow = data.IsShow ? 1 : 0;
      data.SeoKey = this.dynamicTags.join(',');
      __WEBPACK_IMPORTED_MODULE_0__components_common_tools__["a" /* default */].commonAjax.call(this, true, '/Ajax/AddNavigationInAdmin', data).then(function () {
        _this.$message.success('Operate success!');
        // add成功
        _this.$emit('addSuccess');
      });
    },

    // 修改操作
    updateDataAjax: function updateDataAjax(id, state) {
      var _this2 = this;

      var data = __WEBPACK_IMPORTED_MODULE_0__components_common_tools__["a" /* default */].getModel(this.formData);
      data.IsLeaf = data.NbFacode === '0' ? data.IsLeaf ? 1 : 0 : 1;
      data.IsShow = data.IsShow ? 1 : 0;
      data.SeoKey = this.dynamicTags.join(',');
      __WEBPACK_IMPORTED_MODULE_0__components_common_tools__["a" /* default */].commonAjax.call(this, true, '/Ajax/UpdateNavigationInAdmin', data).then(function () {
        _this2.$message.success('Operate success!');
        // 修改成功
        _this2.$emit('updateSuccess');
      });
    }
  }
};

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'NavigateionForm',
  componentName: 'NavigateionForm',
  mixins: [page],
  components: {
    imgUpload: __WEBPACK_IMPORTED_MODULE_1__libcomponents_img_upload_img_upload___default.a
  },
  data: function data() {
    return {
      dynamicTags: [],
      inputVisible: false,
      inputValue: '',
      formData: dataStore.getDefaultData()
    };
  },

  methods: {
    // 重置表单值
    resetValue: function resetValue() {
      this.formData = dataStore.getDefaultData();
    },

    // 设置表单值
    setValue: function setValue(value) {
      var data = __WEBPACK_IMPORTED_MODULE_0__components_common_tools__["a" /* default */].extendData(dataStore.getDefaultData(), value || {});
      data.IsLeaf = !!value.IsLeaf;
      data.IsShow = !!value.IsShow;
      this.dynamicTags = data.SeoKey ? data.SeoKey.split(',') : [];
      this.formData = data;
    },

    // 发布
    doAdd: function doAdd(formName) {
      var _this3 = this;

      this.$refs[formName].validate(function (valid) {
        if (valid) {
          _this3.addDataAjax();
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },

    // 修改
    doUpdate: function doUpdate(formName) {
      var _this4 = this;

      this.$refs[formName].validate(function (valid) {
        if (valid) {
          _this4.updateDataAjax();
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    handleClose: function handleClose(tag) {
      this.dynamicTags.splice(this.dynamicTags.indexOf(tag), 1);
    },
    showInput: function showInput() {
      var _this5 = this;

      this.inputVisible = true;
      this.$nextTick(function (_) {
        _this5.$refs.saveTagInput.$refs.input.focus();
      });
    },
    handleInputConfirm: function handleInputConfirm() {
      var inputValue = this.inputValue;
      if (inputValue) {
        this.dynamicTags.push(inputValue);
      }
      this.inputVisible = false;
      this.inputValue = '';
    }
  }
});

/***/ }),
/* 259 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_common_tools__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__libcomponents_img_upload_img_upload__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__libcomponents_img_upload_img_upload___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__libcomponents_img_upload_img_upload__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__libcomponents_mc_editor_mc_editor__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__libcomponents_mc_editor_mc_editor___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__libcomponents_mc_editor_mc_editor__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






// 数据对象
var dataStore = __WEBPACK_IMPORTED_MODULE_1__components_common_tools__["a" /* default */].createDataStore({
  NtCode: '0',
  NiName: '',
  NiImg: '',
  NiContent: '',
  NiDescribe: '',
  NiSort: '',
  IsIndex: false,
  IsHot: false,
  IsRelease: false,
  ReleaseTime: ''
});

// 请求相关操作
var page = {
  methods: {
    // add操作
    addDataAjax: function addDataAjax() {
      var _this = this;

      var data = __WEBPACK_IMPORTED_MODULE_1__components_common_tools__["a" /* default */].getModel(this.formData);
      data.IsIndex = data.IsIndex ? 1 : 0;
      data.IsHot = data.IsHot ? 1 : 0;
      data.IsRelease = data.IsRelease ? 1 : 0;
      data.NiContent = this.$refs.editNiContent.getValue();
      __WEBPACK_IMPORTED_MODULE_1__components_common_tools__["a" /* default */].commonAjax.call(this, true, '/Ajax/AddNewsInfoInAdmin', data).then(function () {
        _this.$message.success('Operate success!');
        // add成功
        _this.$emit('addSuccess');
      });
    },

    // 修改操作
    updateDataAjax: function updateDataAjax(id, state) {
      var _this2 = this;

      var data = __WEBPACK_IMPORTED_MODULE_1__components_common_tools__["a" /* default */].getModel(this.formData);
      data.IsIndex = data.IsIndex ? 1 : 0;
      data.IsHot = data.IsHot ? 1 : 0;
      data.IsRelease = data.IsRelease ? 1 : 0;
      data.NiContent = this.$refs.editNiContent.getValue();
      __WEBPACK_IMPORTED_MODULE_1__components_common_tools__["a" /* default */].commonAjax.call(this, true, '/Ajax/UpdateNewsInfoInAdmin', data).then(function () {
        _this2.$message.success('Operate success!');
        // 修改成功
        _this2.$emit('updateSuccess');
      });
    }
  }
};

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'NewsForm',
  componentName: 'NewsForm',
  mixins: [page],
  components: {
    imgUpload: __WEBPACK_IMPORTED_MODULE_2__libcomponents_img_upload_img_upload___default.a, mcEditor: __WEBPACK_IMPORTED_MODULE_3__libcomponents_mc_editor_mc_editor___default.a
  },
  props: ['sideCurrent'],
  created: function created() {
    this.setSideCurrent();
  },
  data: function data() {
    return {
      formData: dataStore.getDefaultData()
    };
  },

  watch: {
    sideCurrent: function sideCurrent() {
      this.setSideCurrent();
    }
  },
  methods: {
    // 设置侧边当前项
    setSideCurrent: function setSideCurrent() {
      if (this.sideCurrent) {
        dataStore.setDefaultData(__WEBPACK_IMPORTED_MODULE_0_jquery___default.a.extend(dataStore.getDefaultData(), {
          // 侧边code
          NtCode: this.sideCurrent.NtCode
        }));
      }
    },

    // 重置表单值
    resetValue: function resetValue() {
      this.formData = dataStore.getDefaultData();
    },

    // 设置表单值
    setValue: function setValue(value) {
      value.IsIndex = !!value.IsIndex;
      value.IsHot = !!value.IsHot;
      value.IsRelease = !!value.IsRelease;
      this.formData = __WEBPACK_IMPORTED_MODULE_1__components_common_tools__["a" /* default */].extendData(dataStore.getDefaultData(), value || {});
    },

    // 发布
    doAdd: function doAdd(formName) {
      var _this3 = this;

      this.$refs[formName].validate(function (valid) {
        if (valid) {
          _this3.addDataAjax();
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },

    // 修改
    doUpdate: function doUpdate(formName) {
      var _this4 = this;

      this.$refs[formName].validate(function (valid) {
        if (valid) {
          _this4.updateDataAjax();
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    }
  }
});

/***/ }),
/* 260 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_common_tools__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__libcomponents_img_upload_img_upload__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__libcomponents_img_upload_img_upload___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__libcomponents_img_upload_img_upload__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




// 数据对象
var dataStore = __WEBPACK_IMPORTED_MODULE_0__components_common_tools__["a" /* default */].createDataStore({
  NtName: '',
  NtSort: ''
});

// 请求相关操作
var page = {
  methods: {
    // add操作
    addDataAjax: function addDataAjax() {
      var _this = this;

      var data = __WEBPACK_IMPORTED_MODULE_0__components_common_tools__["a" /* default */].getModel(this.formData);
      __WEBPACK_IMPORTED_MODULE_0__components_common_tools__["a" /* default */].commonAjax.call(this, true, '/Ajax/AddNewsTypeInAdmin', data).then(function () {
        _this.$message.success('Operate success!');
        // add成功
        _this.$emit('addSuccess');
      });
    },

    // 修改操作
    updateDataAjax: function updateDataAjax(id, state) {
      var _this2 = this;

      var data = __WEBPACK_IMPORTED_MODULE_0__components_common_tools__["a" /* default */].getModel(this.formData);
      __WEBPACK_IMPORTED_MODULE_0__components_common_tools__["a" /* default */].commonAjax.call(this, true, '/Ajax/UpdateNewsTypeInAdmin', data).then(function () {
        _this2.$message.success('Operate success!');
        // 修改成功
        _this2.$emit('updateSuccess');
      });
    }
  }
};

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'NewsTypeForm',
  componentName: 'NewsTypeForm',
  mixins: [page],
  components: {
    imgUpload: __WEBPACK_IMPORTED_MODULE_1__libcomponents_img_upload_img_upload___default.a
  },
  data: function data() {
    return {
      formData: dataStore.getDefaultData()
    };
  },

  methods: {
    // 重置表单值
    resetValue: function resetValue() {
      this.formData = dataStore.getDefaultData();
    },

    // 设置表单值
    setValue: function setValue(value) {
      this.formData = __WEBPACK_IMPORTED_MODULE_0__components_common_tools__["a" /* default */].extendData(dataStore.getDefaultData(), value || {});
    },

    // 发布
    doAdd: function doAdd(formName) {
      var _this3 = this;

      this.$refs[formName].validate(function (valid) {
        if (valid) {
          _this3.addDataAjax();
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },

    // 修改
    doUpdate: function doUpdate(formName) {
      var _this4 = this;

      this.$refs[formName].validate(function (valid) {
        if (valid) {
          _this4.updateDataAjax();
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    }
  }
});

/***/ }),
/* 261 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_common_tools__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__libcomponents_img_upload_img_upload__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__libcomponents_img_upload_img_upload___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__libcomponents_img_upload_img_upload__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__libcomponents_mc_editor_mc_editor__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__libcomponents_mc_editor_mc_editor___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__libcomponents_mc_editor_mc_editor__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__libcomponents_file_upload_file_upload__ = __webpack_require__(213);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__libcomponents_file_upload_file_upload___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__libcomponents_file_upload_file_upload__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







// 数据对象
var dataStore = __WEBPACK_IMPORTED_MODULE_1__components_common_tools__["a" /* default */].createDataStore({
  PtRoute: '0',
  PiName: '',
  PiContent: '',
  PiDescribe: '',
  PiImg: '',
  PiCover: '',
  PiSort: '',
  // 组件未设置
  PiAttachment: ''
});

// 请求相关操作
var page = {
  methods: {
    // add操作
    addDataAjax: function addDataAjax() {
      var _this = this;

      var data = __WEBPACK_IMPORTED_MODULE_1__components_common_tools__["a" /* default */].getModel(this.formData);
      // console.log(data)
      data.PiContent = this.$refs.editorPiContent.getValue();
      __WEBPACK_IMPORTED_MODULE_1__components_common_tools__["a" /* default */].commonAjax.call(this, true, '/Ajax/AddProductInfoInAdmin', data).then(function () {
        _this.$message.success('Operate success!');
        // add成功
        _this.$emit('addSuccess');
      });
    },

    // 修改操作
    updateDataAjax: function updateDataAjax(id, state) {
      var _this2 = this;

      var data = __WEBPACK_IMPORTED_MODULE_1__components_common_tools__["a" /* default */].getModel(this.formData);
      // console.log(data)
      data.PiContent = this.$refs.editorPiContent.getValue();
      __WEBPACK_IMPORTED_MODULE_1__components_common_tools__["a" /* default */].commonAjax.call(this, true, '/Ajax/UpdateProductInfoInAdmin', data).then(function () {
        _this2.$message.success('Operate success!');
        // 修改成功
        _this2.$emit('updateSuccess');
      });
    }
  }
};

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'ProductForm',
  componentName: 'ProductForm',
  mixins: [page],
  components: {
    imgUpload: __WEBPACK_IMPORTED_MODULE_2__libcomponents_img_upload_img_upload___default.a, mcEditor: __WEBPACK_IMPORTED_MODULE_3__libcomponents_mc_editor_mc_editor___default.a, fileUpload: __WEBPACK_IMPORTED_MODULE_4__libcomponents_file_upload_file_upload___default.a
  },
  props: ['sideCurrent'],
  created: function created() {
    this.setSideCurrent();
  },
  data: function data() {
    return {
      formData: dataStore.getDefaultData()
    };
  },

  watch: {
    sideCurrent: function sideCurrent() {
      this.setSideCurrent();
    }
  },
  methods: {
    // 设置侧边当前项
    setSideCurrent: function setSideCurrent() {
      if (this.sideCurrent) {
        dataStore.setDefaultData(__WEBPACK_IMPORTED_MODULE_0_jquery___default.a.extend(dataStore.getDefaultData(), {
          PtRoute: this.sideCurrent.PtCode
        }));
      }
    },

    // 重置表单值
    resetValue: function resetValue() {
      this.formData = dataStore.getDefaultData();
    },

    // 设置表单值
    setValue: function setValue(value) {
      this.formData = __WEBPACK_IMPORTED_MODULE_1__components_common_tools__["a" /* default */].extendData(dataStore.getDefaultData(), value || {});
    },

    // 发布
    doAdd: function doAdd(formName) {
      var _this3 = this;

      this.$refs[formName].validate(function (valid) {
        if (valid) {
          _this3.addDataAjax();
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },

    // 修改
    doUpdate: function doUpdate(formName) {
      var _this4 = this;

      this.$refs[formName].validate(function (valid) {
        if (valid) {
          _this4.updateDataAjax();
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    }
  }
});

/***/ }),
/* 262 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_common_tools__ = __webpack_require__(2);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



// 数据对象
var dataStore = __WEBPACK_IMPORTED_MODULE_0__components_common_tools__["a" /* default */].createDataStore({
  PtFacode: '0',
  PtName: '',
  PtDescribe: '',
  PtSort: '',
  IsLeaf: false
});

// 请求相关操作
var page = {
  methods: {
    // add操作
    addDataAjax: function addDataAjax() {
      var _this = this;

      var data = __WEBPACK_IMPORTED_MODULE_0__components_common_tools__["a" /* default */].getModel(this.formData);
      data.IsLeaf = data.IsLeaf ? 1 : 0;
      __WEBPACK_IMPORTED_MODULE_0__components_common_tools__["a" /* default */].commonAjax.call(this, true, '/Ajax/AddProductTypeInAdmin', data).then(function () {
        _this.$message.success('Operate success!');
        // add成功
        _this.$emit('addSuccess');
      });
    },

    // 修改操作
    updateDataAjax: function updateDataAjax(id, state) {
      var _this2 = this;

      var data = __WEBPACK_IMPORTED_MODULE_0__components_common_tools__["a" /* default */].getModel(this.formData);
      data.IsLeaf = data.IsLeaf ? 1 : 0;
      __WEBPACK_IMPORTED_MODULE_0__components_common_tools__["a" /* default */].commonAjax.call(this, true, '/Ajax/UpdateProductTypeInAdmin', data).then(function () {
        _this2.$message.success('Operate success!');
        // 修改成功
        _this2.$emit('updateSuccess');
      });
    }
  }
};

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'ProductTypeForm',
  componentName: 'ProductTypeForm',
  mixins: [page],
  data: function data() {
    return {
      formData: dataStore.getDefaultData()
    };
  },

  methods: {
    // 重置表单值
    resetValue: function resetValue() {
      this.formData = dataStore.getDefaultData();
    },

    // 设置表单值
    setValue: function setValue(value) {
      value.IsLeaf = !!value.IsLeaf;
      this.formData = __WEBPACK_IMPORTED_MODULE_0__components_common_tools__["a" /* default */].extendData(dataStore.getDefaultData(), value || {});
    },

    // 发布
    doAdd: function doAdd(formName) {
      var _this3 = this;

      this.$refs[formName].validate(function (valid) {
        if (valid) {
          _this3.addDataAjax();
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },

    // 修改
    doUpdate: function doUpdate(formName) {
      var _this4 = this;

      this.$refs[formName].validate(function (valid) {
        if (valid) {
          _this4.updateDataAjax();
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    }
  }
});

/***/ }),
/* 263 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_common_tools__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__libcomponents_mc_editor_mc_editor__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__libcomponents_mc_editor_mc_editor___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__libcomponents_mc_editor_mc_editor__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




// 数据对象
var dataStore = __WEBPACK_IMPORTED_MODULE_0__components_common_tools__["a" /* default */].createDataStore({
  PsSubject: '',
  PsMessage: '',
  RpTheme: '',
  RpContent: ''
});

// 请求相关操作
var page = {
  methods: {
    // 修改操作
    updateDataAjax: function updateDataAjax(id, state) {
      var _this = this;

      var data = __WEBPACK_IMPORTED_MODULE_0__components_common_tools__["a" /* default */].getModel(this.formData);
      data.RpContent = this.$refs.editRpContent.getValue();
      __WEBPACK_IMPORTED_MODULE_0__components_common_tools__["a" /* default */].commonAjax.call(this, true, '/Ajax/AdminUserReplyQuestionInAdmin', data).then(function () {
        _this.$message.success('Operate success!');
        // 修改成功
        _this.$emit('updateSuccess');
      });
    }
  }
};

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'QuestionOne',
  componentName: 'QuestionOne',
  mixins: [page],
  components: {
    mcEditor: __WEBPACK_IMPORTED_MODULE_1__libcomponents_mc_editor_mc_editor___default.a
  },
  data: function data() {
    return {
      formData: dataStore.getDefaultData()
    };
  },

  methods: {
    // 重置表单值
    resetValue: function resetValue() {
      this.formData = dataStore.getDefaultData();
    },

    // 设置表单值
    setValue: function setValue(value) {
      this.formData = __WEBPACK_IMPORTED_MODULE_0__components_common_tools__["a" /* default */].extendData(dataStore.getDefaultData(), value || {});
    },

    // 发布
    doAdd: function doAdd(formName) {
      var _this2 = this;

      this.$refs[formName].validate(function (valid) {
        if (valid) {
          _this2.addDataAjax();
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },

    // 修改
    doUpdate: function doUpdate(formName) {
      var _this3 = this;

      this.$refs[formName].validate(function (valid) {
        if (valid) {
          _this3.updateDataAjax();
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    }
  }
});

/***/ }),
/* 264 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_common_tools__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__libcomponents_mc_editor_mc_editor__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__libcomponents_mc_editor_mc_editor___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__libcomponents_mc_editor_mc_editor__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




// 数据对象
var dataStore = __WEBPACK_IMPORTED_MODULE_0__components_common_tools__["a" /* default */].createDataStore({
  SpName: '',
  SpSort: '',
  SpDescribe: ''
});

// 请求相关操作
var page = {
  methods: {
    // add操作
    addDataAjax: function addDataAjax() {
      var _this = this;

      var data = __WEBPACK_IMPORTED_MODULE_0__components_common_tools__["a" /* default */].getModel(this.formData);
      data.SpDescribe = this.$refs.editSpDescribe.getValue();
      __WEBPACK_IMPORTED_MODULE_0__components_common_tools__["a" /* default */].commonAjax.call(this, true, '/Ajax/AddSinglePageInAdmin', data).then(function () {
        _this.$message.success('Operate success!');
        // add成功
        _this.$emit('addSuccess');
      });
    },

    // 修改操作
    updateDataAjax: function updateDataAjax(id, state) {
      var _this2 = this;

      var data = __WEBPACK_IMPORTED_MODULE_0__components_common_tools__["a" /* default */].getModel(this.formData);
      data.SpDescribe = this.$refs.editSpDescribe.getValue();
      __WEBPACK_IMPORTED_MODULE_0__components_common_tools__["a" /* default */].commonAjax.call(this, true, '/Ajax/UpdateSinglePageInAdmin', data).then(function () {
        _this2.$message.success('Operate success!');
        // 修改成功
        _this2.$emit('updateSuccess');
      });
    }
  }
};

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'SinglePageForm',
  componentName: 'SinglePageForm',
  mixins: [page],
  components: {
    mcEditor: __WEBPACK_IMPORTED_MODULE_1__libcomponents_mc_editor_mc_editor___default.a
  },
  data: function data() {
    return {
      formData: dataStore.getDefaultData()
    };
  },

  methods: {
    // 重置表单值
    resetValue: function resetValue() {
      this.formData = dataStore.getDefaultData();
    },

    // 设置表单值
    setValue: function setValue(value) {
      this.formData = __WEBPACK_IMPORTED_MODULE_0__components_common_tools__["a" /* default */].extendData(dataStore.getDefaultData(), value || {});
    },

    // 发布
    doAdd: function doAdd(formName) {
      var _this3 = this;

      this.$refs[formName].validate(function (valid) {
        if (valid) {
          _this3.addDataAjax();
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },

    // 修改
    doUpdate: function doUpdate(formName) {
      var _this4 = this;

      this.$refs[formName].validate(function (valid) {
        if (valid) {
          _this4.updateDataAjax();
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    }
  }
});

/***/ }),
/* 265 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_common_tools__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__libcomponents_img_upload_img_upload__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__libcomponents_img_upload_img_upload___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__libcomponents_img_upload_img_upload__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__libcomponents_mc_editor_mc_editor__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__libcomponents_mc_editor_mc_editor___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__libcomponents_mc_editor_mc_editor__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






// 数据对象
var dataStore = __WEBPACK_IMPORTED_MODULE_1__components_common_tools__["a" /* default */].createDataStore({
  StCode: '0',
  SiName: '',
  SiImg: '',
  SiDescribe: '',
  SiContent: '',
  SiSort: ''
});

// 请求相关操作
var page = {
  methods: {
    // add操作
    addDataAjax: function addDataAjax() {
      var _this = this;

      var data = __WEBPACK_IMPORTED_MODULE_1__components_common_tools__["a" /* default */].getModel(this.formData);
      data.SiContent = this.$refs.editContent.getValue();
      // console.log(data)
      __WEBPACK_IMPORTED_MODULE_1__components_common_tools__["a" /* default */].commonAjax.call(this, true, '/Ajax/AddStaffmienInfoInAdmin', data).then(function () {
        _this.$message.success('Operate success!');
        // add成功
        _this.$emit('addSuccess');
      });
    },

    // 修改操作
    updateDataAjax: function updateDataAjax(id, state) {
      var _this2 = this;

      var data = __WEBPACK_IMPORTED_MODULE_1__components_common_tools__["a" /* default */].getModel(this.formData);
      data.SiContent = this.$refs.editContent.getValue();
      // console.log(data)
      __WEBPACK_IMPORTED_MODULE_1__components_common_tools__["a" /* default */].commonAjax.call(this, true, '/Ajax/UpdateStaffmienInfoInAdmin', data).then(function () {
        _this2.$message.success('Operate success!');
        // 修改成功
        _this2.$emit('updateSuccess');
      });
    }
  }
};

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'StaffmienForm',
  componentName: 'StaffmienForm',
  mixins: [page],
  components: {
    imgUpload: __WEBPACK_IMPORTED_MODULE_2__libcomponents_img_upload_img_upload___default.a, mcEditor: __WEBPACK_IMPORTED_MODULE_3__libcomponents_mc_editor_mc_editor___default.a
  },
  props: ['sideCurrent'],
  created: function created() {
    this.setSideCurrent();
  },
  data: function data() {
    return {
      formData: dataStore.getDefaultData()
    };
  },

  watch: {
    sideCurrent: function sideCurrent() {
      this.setSideCurrent();
    }
  },
  methods: {
    // 设置侧边当前项
    setSideCurrent: function setSideCurrent() {
      if (this.sideCurrent) {
        dataStore.setDefaultData(__WEBPACK_IMPORTED_MODULE_0_jquery___default.a.extend(dataStore.getDefaultData(), {
          // 侧边code
          StCode: this.sideCurrent.StCode
        }));
      }
    },

    // 重置表单值
    resetValue: function resetValue() {
      this.formData = dataStore.getDefaultData();
    },

    // 设置表单值
    setValue: function setValue(value) {
      this.formData = __WEBPACK_IMPORTED_MODULE_1__components_common_tools__["a" /* default */].extendData(dataStore.getDefaultData(), value || {});
    },

    // 发布
    doAdd: function doAdd(formName) {
      var _this3 = this;

      this.$refs[formName].validate(function (valid) {
        if (valid) {
          _this3.addDataAjax();
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },

    // 修改
    doUpdate: function doUpdate(formName) {
      var _this4 = this;

      this.$refs[formName].validate(function (valid) {
        if (valid) {
          _this4.updateDataAjax();
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    }
  }
});

/***/ }),
/* 266 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_common_tools__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__libcomponents_img_upload_img_upload__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__libcomponents_img_upload_img_upload___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__libcomponents_img_upload_img_upload__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




// 数据对象
var dataStore = __WEBPACK_IMPORTED_MODULE_0__components_common_tools__["a" /* default */].createDataStore({
  // 图片
  BnImg: '',
  // 角色名称
  BnUrl: '',
  // 角色Sort
  BnSort: ''
});

// 请求相关操作
var page = {
  methods: {
    // add操作
    addDataAjax: function addDataAjax() {
      var _this = this;

      var data = __WEBPACK_IMPORTED_MODULE_0__components_common_tools__["a" /* default */].getModel(this.formData);
      __WEBPACK_IMPORTED_MODULE_0__components_common_tools__["a" /* default */].commonAjax.call(this, true, '/Ajax/AddStaffmienTypeInAdmin', data).then(function () {
        _this.$message.success('Operate success!');
        // add成功
        _this.$emit('addSuccess');
      });
    },

    // 修改操作
    updateDataAjax: function updateDataAjax(id, state) {
      var _this2 = this;

      var data = __WEBPACK_IMPORTED_MODULE_0__components_common_tools__["a" /* default */].getModel(this.formData);
      __WEBPACK_IMPORTED_MODULE_0__components_common_tools__["a" /* default */].commonAjax.call(this, true, '/Ajax/UpdateStaffmienTypeInAdmin', data).then(function () {
        _this2.$message.success('Operate success!');
        // 修改成功
        _this2.$emit('updateSuccess');
      });
    }
  }
};

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'StaffmienTypeForm',
  componentName: 'StaffmienTypeForm',
  mixins: [page],
  components: {
    imgUpload: __WEBPACK_IMPORTED_MODULE_1__libcomponents_img_upload_img_upload___default.a
  },
  data: function data() {
    return {
      formData: dataStore.getDefaultData()
    };
  },

  methods: {
    // 重置表单值
    resetValue: function resetValue() {
      this.formData = dataStore.getDefaultData();
    },

    // 设置表单值
    setValue: function setValue(value) {
      this.formData = __WEBPACK_IMPORTED_MODULE_0__components_common_tools__["a" /* default */].extendData(dataStore.getDefaultData(), value || {});
    },

    // 发布
    doAdd: function doAdd(formName) {
      var _this3 = this;

      this.$refs[formName].validate(function (valid) {
        if (valid) {
          _this3.addDataAjax();
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },

    // 修改
    doUpdate: function doUpdate(formName) {
      var _this4 = this;

      this.$refs[formName].validate(function (valid) {
        if (valid) {
          _this4.updateDataAjax();
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    }
  }
});

/***/ }),
/* 267 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_common_tools__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__libcomponents_img_upload_img_upload__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__libcomponents_img_upload_img_upload___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__libcomponents_img_upload_img_upload__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__libcomponents_video_upload_video_upload__ = __webpack_require__(683);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__libcomponents_video_upload_video_upload___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__libcomponents_video_upload_video_upload__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





// 数据对象
var dataStore = __WEBPACK_IMPORTED_MODULE_0__components_common_tools__["a" /* default */].createDataStore({
  IsOutlink: false,
  VdCover: '',
  VdName: '',
  VdSort: '',
  VdUrl: ''
});

// 请求相关操作
var page = {
  methods: {
    // add操作
    addDataAjax: function addDataAjax() {
      var _this = this;

      var data = __WEBPACK_IMPORTED_MODULE_0__components_common_tools__["a" /* default */].getModel(this.formData);
      data.IsOutlink = data.IsOutlink ? 1 : 0;
      __WEBPACK_IMPORTED_MODULE_0__components_common_tools__["a" /* default */].commonAjax.call(this, true, '/Ajax/AddVideoInAdmin', data).then(function () {
        _this.$message.success('Operate success!');
        // add成功
        _this.$emit('addSuccess');
      });
    },

    // 修改操作
    updateDataAjax: function updateDataAjax(id, state) {
      var _this2 = this;

      var data = __WEBPACK_IMPORTED_MODULE_0__components_common_tools__["a" /* default */].getModel(this.formData);
      data.IsOutlink = data.IsOutlink ? 1 : 0;
      __WEBPACK_IMPORTED_MODULE_0__components_common_tools__["a" /* default */].commonAjax.call(this, true, '/Ajax/UpdateVideoInAdmin', data).then(function () {
        _this2.$message.success('Operate success!');
        // 修改成功
        _this2.$emit('updateSuccess');
      });
    }
  }
};

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'VideoForm',
  componentName: 'VideoForm',
  mixins: [page],
  components: {
    imgUpload: __WEBPACK_IMPORTED_MODULE_1__libcomponents_img_upload_img_upload___default.a, videoUpload: __WEBPACK_IMPORTED_MODULE_2__libcomponents_video_upload_video_upload___default.a
  },
  data: function data() {
    return {
      formData: dataStore.getDefaultData()
    };
  },

  methods: {
    // 重置表单值
    resetValue: function resetValue() {
      this.formData = dataStore.getDefaultData();
    },

    // 设置表单值
    setValue: function setValue(value) {
      this.formData = __WEBPACK_IMPORTED_MODULE_0__components_common_tools__["a" /* default */].extendData(dataStore.getDefaultData(), value || {});
    },

    // 发布
    doAdd: function doAdd(formName) {
      var _this3 = this;

      this.$refs[formName].validate(function (valid) {
        if (valid) {
          _this3.addDataAjax();
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },

    // 修改
    doUpdate: function doUpdate(formName) {
      var _this4 = this;

      this.$refs[formName].validate(function (valid) {
        if (valid) {
          _this4.updateDataAjax();
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    }
  }
});

/***/ }),
/* 268 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_common_tools__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__libcomponents_img_upload_img_upload__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__libcomponents_img_upload_img_upload___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__libcomponents_img_upload_img_upload__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




// 数据对象
var dataStore = __WEBPACK_IMPORTED_MODULE_0__components_common_tools__["a" /* default */].createDataStore({
  // 图片
  BnImg: '',
  // 角色名称
  BnUrl: '',
  // 角色Sort
  BnSort: ''
});

// 请求相关操作
var page = {
  methods: {
    // add操作
    addDataAjax: function addDataAjax() {
      var _this = this;

      var data = __WEBPACK_IMPORTED_MODULE_0__components_common_tools__["a" /* default */].getModel(this.formData);
      __WEBPACK_IMPORTED_MODULE_0__components_common_tools__["a" /* default */].commonAjax.call(this, true, '/Ajax/AddBannerInAdmin', data).then(function () {
        _this.$message.success('Operate success!');
        // add成功
        _this.$emit('addSuccess');
      });
    },

    // 修改操作
    updateDataAjax: function updateDataAjax(id, state) {
      var _this2 = this;

      var data = __WEBPACK_IMPORTED_MODULE_0__components_common_tools__["a" /* default */].getModel(this.formData);
      __WEBPACK_IMPORTED_MODULE_0__components_common_tools__["a" /* default */].commonAjax.call(this, true, '/Ajax/UpdateBannerInAdmin', data).then(function () {
        _this2.$message.success('Operate success!');
        // 修改成功
        _this2.$emit('updateSuccess');
      });
    }
  }
};

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'BannerForm',
  componentName: 'BannerForm',
  mixins: [page],
  components: {
    imgUpload: __WEBPACK_IMPORTED_MODULE_1__libcomponents_img_upload_img_upload___default.a
  },
  data: function data() {
    return {
      formData: dataStore.getDefaultData()
    };
  },

  methods: {
    // 重置表单值
    resetValue: function resetValue() {
      this.formData = dataStore.getDefaultData();
    },

    // 设置表单值
    setValue: function setValue(value) {
      this.formData = __WEBPACK_IMPORTED_MODULE_0__components_common_tools__["a" /* default */].extendData(dataStore.getDefaultData(), value || {});
    },

    // 发布
    doAdd: function doAdd(formName) {
      var _this3 = this;

      this.$refs[formName].validate(function (valid) {
        if (valid) {
          _this3.addDataAjax();
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },

    // 修改
    doUpdate: function doUpdate(formName) {
      var _this4 = this;

      this.$refs[formName].validate(function (valid) {
        if (valid) {
          _this4.updateDataAjax();
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    }
  }
});

/***/ }),
/* 269 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_common_tools__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__libcomponents_img_upload_img_upload__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__libcomponents_img_upload_img_upload___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__libcomponents_img_upload_img_upload__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




// 数据对象
var dataStore = __WEBPACK_IMPORTED_MODULE_0__components_common_tools__["a" /* default */].createDataStore({
  CfYear: '',
  CfNum: '',
  CfPer: '',
  CfTest: '',
  CfGlobalInfo: '',
  CfWebQrcode: '',
  CfAppQrcode: ''
});

// 请求相关操作
var page = {
  methods: {
    // 修改操作
    updateDataAjax: function updateDataAjax(id, state) {
      var _this = this;

      var data = __WEBPACK_IMPORTED_MODULE_0__components_common_tools__["a" /* default */].getModel(this.formData);
      __WEBPACK_IMPORTED_MODULE_0__components_common_tools__["a" /* default */].commonAjax.call(this, true, '/Ajax/UpdateConfigInAdmin', data).then(function () {
        _this.$message.success('Operate success!');
        // 修改成功
        _this.$emit('updateSuccess');
      });
    }
  }
};

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'ConfigForm',
  componentName: 'ConfigForm',
  mixins: [page],
  components: {
    imgUpload: __WEBPACK_IMPORTED_MODULE_1__libcomponents_img_upload_img_upload___default.a
  },
  data: function data() {
    return {
      formData: dataStore.getDefaultData()
    };
  },

  methods: {
    // 重置表单值
    resetValue: function resetValue() {
      this.formData = dataStore.getDefaultData();
    },

    // 设置表单值
    setValue: function setValue(value) {
      this.formData = __WEBPACK_IMPORTED_MODULE_0__components_common_tools__["a" /* default */].extendData(dataStore.getDefaultData(), value || {});
    },

    // 修改
    doUpdate: function doUpdate(formName) {
      var _this2 = this;

      this.$refs[formName].validate(function (valid) {
        if (valid) {
          _this2.updateDataAjax();
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    }
  }
});

/***/ }),
/* 270 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_common_tools__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__libcomponents_mc_editor_mc_editor__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__libcomponents_mc_editor_mc_editor___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__libcomponents_mc_editor_mc_editor__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




// 数据对象
var dataStore = __WEBPACK_IMPORTED_MODULE_0__components_common_tools__["a" /* default */].createDataStore({
  BnImg: '',
  CaName: '',
  CaSort: '',
  CaContent: ''
});

// 请求相关操作
var page = {
  methods: {
    // 修改操作
    updateDataAjax: function updateDataAjax(id, state) {
      var _this = this;

      var data = __WEBPACK_IMPORTED_MODULE_0__components_common_tools__["a" /* default */].getModel(this.formData);
      data.CaContent = this.$refs.editContent.getValue();
      __WEBPACK_IMPORTED_MODULE_0__components_common_tools__["a" /* default */].commonAjax.call(this, true, '/Ajax/UpdateCompanyAddressInAdmin', data).then(function () {
        _this.$message.success('Operate success!');
        // 修改成功
        _this.$emit('updateSuccess');
      });
    }
  }
};

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'ContactForm',
  components: {
    mcEditor: __WEBPACK_IMPORTED_MODULE_1__libcomponents_mc_editor_mc_editor___default.a
  },
  componentName: 'ContactForm',
  mixins: [page],
  data: function data() {
    return {
      formData: dataStore.getDefaultData()
    };
  },

  methods: {
    // 重置表单值
    resetValue: function resetValue() {
      this.formData = dataStore.getDefaultData();
    },

    // 设置表单值
    setValue: function setValue(value) {
      this.formData = __WEBPACK_IMPORTED_MODULE_0__components_common_tools__["a" /* default */].extendData(dataStore.getDefaultData(), value || {});
    },

    // 修改
    doUpdate: function doUpdate(formName) {
      var _this2 = this;

      this.$refs[formName].validate(function (valid) {
        if (valid) {
          _this2.updateDataAjax();
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    }
  }
});

/***/ }),
/* 271 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_common_tools__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__libcomponents_img_upload_img_upload__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__libcomponents_img_upload_img_upload___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__libcomponents_img_upload_img_upload__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




// 数据对象
var dataStore = __WEBPACK_IMPORTED_MODULE_0__components_common_tools__["a" /* default */].createDataStore({
  PbImg: '',
  PbName: '',
  PbDescribe: '',
  PbSort: ''
});

// 请求相关操作
var page = {
  methods: {
    // add操作
    addDataAjax: function addDataAjax() {
      var _this = this;

      var data = __WEBPACK_IMPORTED_MODULE_0__components_common_tools__["a" /* default */].getModel(this.formData);
      __WEBPACK_IMPORTED_MODULE_0__components_common_tools__["a" /* default */].commonAjax.call(this, true, '/Ajax/AddProductionBaseInAdmin', data).then(function () {
        _this.$message.success('Operate success!');
        // add成功
        _this.$emit('addSuccess');
      });
    },

    // 修改操作
    updateDataAjax: function updateDataAjax(id, state) {
      var _this2 = this;

      var data = __WEBPACK_IMPORTED_MODULE_0__components_common_tools__["a" /* default */].getModel(this.formData);
      __WEBPACK_IMPORTED_MODULE_0__components_common_tools__["a" /* default */].commonAjax.call(this, true, '/Ajax/UpdateProductionBaseInAdmin', data).then(function () {
        _this2.$message.success('Operate success!');
        // 修改成功
        _this2.$emit('updateSuccess');
      });
    }
  }
};

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'ProductionBaseForm',
  componentName: 'ProductionBaseForm',
  mixins: [page],
  components: {
    imgUpload: __WEBPACK_IMPORTED_MODULE_1__libcomponents_img_upload_img_upload___default.a
  },
  data: function data() {
    return {
      formData: dataStore.getDefaultData()
    };
  },

  methods: {
    // 重置表单值
    resetValue: function resetValue() {
      this.formData = dataStore.getDefaultData();
    },

    // 设置表单值
    setValue: function setValue(value) {
      this.formData = __WEBPACK_IMPORTED_MODULE_0__components_common_tools__["a" /* default */].extendData(dataStore.getDefaultData(), value || {});
    },

    // 发布
    doAdd: function doAdd(formName) {
      var _this3 = this;

      this.$refs[formName].validate(function (valid) {
        if (valid) {
          _this3.addDataAjax();
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },

    // 修改
    doUpdate: function doUpdate(formName) {
      var _this4 = this;

      this.$refs[formName].validate(function (valid) {
        if (valid) {
          _this4.updateDataAjax();
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    }
  }
});

/***/ }),
/* 272 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_common_tools__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__libcomponents_img_upload_img_upload__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__libcomponents_img_upload_img_upload___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__libcomponents_img_upload_img_upload__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__libcomponents_mc_editor_mc_editor__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__libcomponents_mc_editor_mc_editor___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__libcomponents_mc_editor_mc_editor__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





// 数据对象
var dataStore = __WEBPACK_IMPORTED_MODULE_0__components_common_tools__["a" /* default */].createDataStore({
  CpImg: '',
  CpName: '',
  CpDescribe: '',
  CpSort: '',
  CpContent: ''
});

// 请求相关操作
var page = {
  methods: {
    // add操作
    addDataAjax: function addDataAjax() {
      var _this = this;

      var data = __WEBPACK_IMPORTED_MODULE_0__components_common_tools__["a" /* default */].getModel(this.formData);
      data.CpContent = this.$refs.editContent.getValue();
      __WEBPACK_IMPORTED_MODULE_0__components_common_tools__["a" /* default */].commonAjax.call(this, true, '/Ajax/AddCooperativePartnerListInAdmin', data).then(function () {
        _this.$message.success('Operate success!');
        // add成功
        _this.$emit('addSuccess');
      });
    },

    // 修改操作
    updateDataAjax: function updateDataAjax(id, state) {
      var _this2 = this;

      var data = __WEBPACK_IMPORTED_MODULE_0__components_common_tools__["a" /* default */].getModel(this.formData);
      data.CpContent = this.$refs.editContent.getValue();
      __WEBPACK_IMPORTED_MODULE_0__components_common_tools__["a" /* default */].commonAjax.call(this, true, '/Ajax/UpdateCooperativePartnerListInAdmin', data).then(function () {
        _this2.$message.success('Operate success!');
        // 修改成功
        _this2.$emit('updateSuccess');
      });
    }
  }
};

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'CooperativeForm',
  componentName: 'CooperativeForm',
  mixins: [page],
  components: {
    imgUpload: __WEBPACK_IMPORTED_MODULE_1__libcomponents_img_upload_img_upload___default.a, mcEditor: __WEBPACK_IMPORTED_MODULE_2__libcomponents_mc_editor_mc_editor___default.a
  },
  data: function data() {
    return {
      formData: dataStore.getDefaultData()
    };
  },

  methods: {
    // 重置表单值
    resetValue: function resetValue() {
      this.formData = dataStore.getDefaultData();
    },

    // 设置表单值
    setValue: function setValue(value) {
      this.formData = __WEBPACK_IMPORTED_MODULE_0__components_common_tools__["a" /* default */].extendData(dataStore.getDefaultData(), value || {});
    },

    // 发布
    doAdd: function doAdd(formName) {
      var _this3 = this;

      this.$refs[formName].validate(function (valid) {
        if (valid) {
          _this3.addDataAjax();
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },

    // 修改
    doUpdate: function doUpdate(formName) {
      var _this4 = this;

      this.$refs[formName].validate(function (valid) {
        if (valid) {
          _this4.updateDataAjax();
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    }
  }
});

/***/ }),
/* 273 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_common_tools__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__libcomponents_img_upload_img_upload__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__libcomponents_img_upload_img_upload___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__libcomponents_img_upload_img_upload__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




// 数据对象
var dataStore = __WEBPACK_IMPORTED_MODULE_0__components_common_tools__["a" /* default */].createDataStore({
  PfName: '',
  PfImg: '',
  PfDescribe: '',
  PfUrl: '',
  PfSort: ''
});

// 请求相关操作
var page = {
  methods: {
    // add操作
    addDataAjax: function addDataAjax() {
      var _this = this;

      var data = __WEBPACK_IMPORTED_MODULE_0__components_common_tools__["a" /* default */].getModel(this.formData);
      __WEBPACK_IMPORTED_MODULE_0__components_common_tools__["a" /* default */].commonAjax.call(this, true, '/Ajax/AddProblemFeedbackInAdmin', data).then(function () {
        _this.$message.success('Operate success!');
        // add成功
        _this.$emit('addSuccess');
      });
    },

    // 修改操作
    updateDataAjax: function updateDataAjax(id, state) {
      var _this2 = this;

      var data = __WEBPACK_IMPORTED_MODULE_0__components_common_tools__["a" /* default */].getModel(this.formData);
      __WEBPACK_IMPORTED_MODULE_0__components_common_tools__["a" /* default */].commonAjax.call(this, true, '/Ajax/UpdateProblemFeedbackInAdmin', data).then(function () {
        _this2.$message.success('Operate success!');
        // 修改成功
        _this2.$emit('updateSuccess');
      });
    }
  }
};

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'ProblemFeedBackForm',
  componentName: 'ProblemFeedBackForm',
  mixins: [page],
  components: {
    imgUpload: __WEBPACK_IMPORTED_MODULE_1__libcomponents_img_upload_img_upload___default.a
  },
  data: function data() {
    return {
      formData: dataStore.getDefaultData()
    };
  },

  methods: {
    // 重置表单值
    resetValue: function resetValue() {
      this.formData = dataStore.getDefaultData();
    },

    // 设置表单值
    setValue: function setValue(value) {
      this.formData = __WEBPACK_IMPORTED_MODULE_0__components_common_tools__["a" /* default */].extendData(dataStore.getDefaultData(), value || {});
    },

    // 发布
    doAdd: function doAdd(formName) {
      var _this3 = this;

      this.$refs[formName].validate(function (valid) {
        if (valid) {
          _this3.addDataAjax();
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },

    // 修改
    doUpdate: function doUpdate(formName) {
      var _this4 = this;

      this.$refs[formName].validate(function (valid) {
        if (valid) {
          _this4.updateDataAjax();
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    }
  }
});

/***/ }),
/* 274 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_common_tools__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__libcomponents_img_upload_img_upload__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__libcomponents_img_upload_img_upload___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__libcomponents_img_upload_img_upload__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




// 数据对象
var dataStore = __WEBPACK_IMPORTED_MODULE_0__components_common_tools__["a" /* default */].createDataStore({
  ScSeoTitle: '',
  ScSeoDescription: '',
  ScSeoKey: '',
  ScTelephone: '',
  ScEmail: '',
  ScStatisticalCode: '',
  ScJscode: '',
  ScBusinessCode: ''
});

// 请求相关操作
var page = {
  methods: {
    // 修改操作
    updateDataAjax: function updateDataAjax(id, state) {
      var _this = this;

      var data = __WEBPACK_IMPORTED_MODULE_0__components_common_tools__["a" /* default */].getModel(this.formData);
      data.ScSeoKey = this.dynamicTags.join(',');
      __WEBPACK_IMPORTED_MODULE_0__components_common_tools__["a" /* default */].commonAjax.call(this, true, '/Ajax/UpdateConfigInAdmin', data).then(function () {
        _this.$message.success('Success');
        // 修改成功
        _this.$emit('updateSuccess');
      });
    },

    // 修改操作
    update2DataAjax: function update2DataAjax(id, state) {
      var _this2 = this;

      var data = __WEBPACK_IMPORTED_MODULE_0__components_common_tools__["a" /* default */].getModel(this.formData);
      __WEBPACK_IMPORTED_MODULE_0__components_common_tools__["a" /* default */].commonAjax.call(this, true, '/Ajax/UpdateConfigInAdmin', data).then(function () {
        _this2.$message.success('Success');
        _this2.$emit('updateSuccess');
      });
    }
  }
};

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'WelcomeForm',
  componentName: 'WelcomeForm',
  mixins: [page],
  components: {
    imgUpload: __WEBPACK_IMPORTED_MODULE_1__libcomponents_img_upload_img_upload___default.a
  },
  data: function data() {
    return {
      dynamicTags: [],
      inputVisible: false,
      inputValue: '',
      formData: dataStore.getDefaultData()
    };
  },

  methods: {
    // 重置表单值
    resetValue: function resetValue() {
      this.formData = dataStore.getDefaultData();
    },

    // 设置表单值
    setValue: function setValue(value) {
      var data = __WEBPACK_IMPORTED_MODULE_0__components_common_tools__["a" /* default */].extendData(dataStore.getDefaultData(), value || {});
      this.dynamicTags = data.ScSeoKey ? data.ScSeoKey.split(',') : [];
      this.formData = data;
    },

    // 修改
    doUpdate: function doUpdate(formName) {
      var _this3 = this;

      this.$refs[formName].validate(function (valid) {
        if (valid) {
          _this3.updateDataAjax();
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    handleClose: function handleClose(tag) {
      this.dynamicTags.splice(this.dynamicTags.indexOf(tag), 1);
    },
    showInput: function showInput() {
      var _this4 = this;

      this.inputVisible = true;
      this.$nextTick(function (_) {
        _this4.$refs.saveTagInput.$refs.input.focus();
      });
    },
    handleInputConfirm: function handleInputConfirm() {
      var inputValue = this.inputValue;
      if (inputValue) {
        this.dynamicTags.push(inputValue);
      }
      this.inputVisible = false;
      this.inputValue = '';
    }
  }
});

/***/ }),
/* 275 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_common_tools__ = __webpack_require__(2);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



// 数据对象
var dataStore = __WEBPACK_IMPORTED_MODULE_0__components_common_tools__["a" /* default */].createDataStore({
  PrTax: '',
  PrEuroRate: '',
  PrDollarRate: ''
});

// 请求相关操作
var page = {
  methods: {
    // 修改操作
    updateDataAjax: function updateDataAjax(id, state) {
      var _this = this;

      var data = __WEBPACK_IMPORTED_MODULE_0__components_common_tools__["a" /* default */].getModel(this.formData);
      __WEBPACK_IMPORTED_MODULE_0__components_common_tools__["a" /* default */].commonAjax.call(this, true, '/Ajax/UpdateConfigInAdmin', data).then(function () {
        _this.$message.success('Operate successfully!');
        // 修改成功
        _this.$emit('updateSuccess');
      });
    }
  }
};

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'EnquiryOnlineConfigForm',
  componentName: 'EnquiryOnlineConfigForm',
  mixins: [page],
  components: {},
  data: function data() {
    return {
      formData: dataStore.getDefaultData()
    };
  },

  methods: {
    // 重置表单值
    resetValue: function resetValue() {
      this.formData = dataStore.getDefaultData();
    },

    // 设置表单值
    setValue: function setValue(value) {
      this.formData = __WEBPACK_IMPORTED_MODULE_0__components_common_tools__["a" /* default */].extendData(dataStore.getDefaultData(), value || {});
    },

    // 修改
    doUpdate: function doUpdate(formName) {
      var _this2 = this;

      this.$refs[formName].validate(function (valid) {
        if (valid) {
          _this2.updateDataAjax();
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    }
  }
});

/***/ }),
/* 276 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_common_tools__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_common_config__ = __webpack_require__(44);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





// 数据对象
var dataStore = __WEBPACK_IMPORTED_MODULE_1__components_common_tools__["a" /* default */].createDataStore({
  minTime: '',
  maxTime: ''
});

// 请求相关操作
var page = {
  methods: {
    // 新增操作
    addDataAjax: function addDataAjax() {
      var data = __WEBPACK_IMPORTED_MODULE_1__components_common_tools__["a" /* default */].getModel(this.formData);
      var extraData = this.extraData || {};
      var param = __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.extend({
        All: 1,
        MinTime: data.minTime,
        MaxTime: data.maxTime
      }, extraData);
      this.$emit('FormClose');
      // console.log(param)
      // console.log(this.url)
      window.open(__WEBPACK_IMPORTED_MODULE_2__components_common_config__["a" /* default */].AjaxUrl + this.url + '?' + __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.param(param));
    }
  }
};

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'ExportForm',
  componentName: 'ExportForm',
  mixins: [page],
  data: function data() {
    return {
      formData: dataStore.getDefaultData()
    };
  },

  props: ['url', 'extraData'],
  methods: {
    // 重置表单值
    resetValue: function resetValue() {
      this.formData = dataStore.getDefaultData();
    },

    // 设置表单值
    setValue: function setValue(value) {
      this.formData = __WEBPACK_IMPORTED_MODULE_1__components_common_tools__["a" /* default */].extendData(dataStore.getDefaultData(), value || {});
    },

    // 发布
    doExport: function doExport(formName) {
      var _this = this;

      this.$refs[formName].validate(function (valid) {
        if (valid) {
          _this.addDataAjax();
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    }
  }
});

/***/ }),
/* 277 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_common_tools__ = __webpack_require__(2);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



// 数据对象
var dataStore = __WEBPACK_IMPORTED_MODULE_0__components_common_tools__["a" /* default */].createDataStore({
  Account: '', // 账户
  Password: '', // 密码
  Rate: '', // 报价系数
  CuName: '' // 姓名
});

// 请求相关操作
var page = {
  methods: {
    // 新增操作
    addDataAjax: function addDataAjax() {
      var _this = this;

      var data = __WEBPACK_IMPORTED_MODULE_0__components_common_tools__["a" /* default */].getModel(this.formData);
      // console.log(data)
      __WEBPACK_IMPORTED_MODULE_0__components_common_tools__["a" /* default */].commonAjax.call(this, true, '/Ajax/AddCustomInAdmin', data).then(function () {
        _this.$message.success('Operate successfully!');
        // 添加成功
        _this.$emit('addSuccess');
      });
    },

    // 修改操作
    updateDataAjax: function updateDataAjax() {
      var _this2 = this;

      var data = __WEBPACK_IMPORTED_MODULE_0__components_common_tools__["a" /* default */].getModel(this.formData);
      // console.log(data)
      __WEBPACK_IMPORTED_MODULE_0__components_common_tools__["a" /* default */].commonAjax.call(this, true, '/Ajax/UpdateCustomInAdmin', data).then(function () {
        _this2.$message.success('Operate successfully!');
        // 修改成功
        _this2.$emit('updateSuccess');
      });
    }
  }
};

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'ProductMemberForm',
  componentName: 'ProductMemberForm',
  mixins: [page],
  components: {},
  data: function data() {
    return {
      formData: dataStore.getDefaultData()
    };
  },

  methods: {
    // 重置表单值
    resetValue: function resetValue() {
      this.formData = dataStore.getDefaultData();
    },

    // 设置表单值
    setValue: function setValue(value) {
      this.formData = __WEBPACK_IMPORTED_MODULE_0__components_common_tools__["a" /* default */].extendData(dataStore.getDefaultData(), value || {});
    },

    // 发布
    doAdd: function doAdd(formName) {
      var _this3 = this;

      this.$refs[formName].validate(function (valid) {
        if (valid) {
          _this3.addDataAjax();
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },

    // 修改
    doUpdate: function doUpdate(formName) {
      var _this4 = this;

      this.$refs[formName].validate(function (valid) {
        if (valid) {
          _this4.updateDataAjax();
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    }
  }
});

/***/ }),
/* 278 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_common_tools__ = __webpack_require__(2);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



// 数据对象
var dataStore = __WEBPACK_IMPORTED_MODULE_0__components_common_tools__["a" /* default */].createDataStore({
  CtName: '', // 名称
  Sort: 0 // 排序
});

// 请求相关操作
var page = {
  methods: {
    // 新增操作
    addDataAjax: function addDataAjax() {
      var _this = this;

      var data = __WEBPACK_IMPORTED_MODULE_0__components_common_tools__["a" /* default */].getModel(this.formData);
      // console.log(data)
      __WEBPACK_IMPORTED_MODULE_0__components_common_tools__["a" /* default */].commonAjax.call(this, true, '/Ajax/AddCustomTypeInAdmin', data).then(function () {
        _this.$message.success('Operate successfully!');
        // 添加成功
        _this.$emit('addSuccess');
      });
    },

    // 修改操作
    updateDataAjax: function updateDataAjax() {
      var _this2 = this;

      var data = __WEBPACK_IMPORTED_MODULE_0__components_common_tools__["a" /* default */].getModel(this.formData);
      // console.log(data)
      __WEBPACK_IMPORTED_MODULE_0__components_common_tools__["a" /* default */].commonAjax.call(this, true, '/Ajax/UpdateCustomTypeInAdmin', data).then(function () {
        _this2.$message.success('Operate successfully!');
        // 修改成功
        _this2.$emit('updateSuccess');
      });
    }
  }
};

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'ProductMemberTypeForm',
  componentName: 'ProductMemberTypeForm',
  mixins: [page],
  components: {},
  data: function data() {
    return {
      formData: dataStore.getDefaultData()
    };
  },

  methods: {
    // 重置表单值
    resetValue: function resetValue() {
      this.formData = dataStore.getDefaultData();
    },

    // 设置表单值
    setValue: function setValue(value) {
      this.formData = __WEBPACK_IMPORTED_MODULE_0__components_common_tools__["a" /* default */].extendData(dataStore.getDefaultData(), value || {});
    },

    // 发布
    doAdd: function doAdd(formName) {
      var _this3 = this;

      this.$refs[formName].validate(function (valid) {
        if (valid) {
          _this3.addDataAjax();
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },

    // 修改
    doUpdate: function doUpdate(formName) {
      var _this4 = this;

      this.$refs[formName].validate(function (valid) {
        if (valid) {
          _this4.updateDataAjax();
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    }
  }
});

/***/ }),
/* 279 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_common_tools__ = __webpack_require__(2);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



// 数据对象
var dataStore = __WEBPACK_IMPORTED_MODULE_0__components_common_tools__["a" /* default */].createDataStore({
  CuCode: '',
  Num: '', // 数量
  Rate: 1, // 系数
  Reamrk: '' // 说明
});

// 请求相关操作
var page = {
  methods: {
    // 新增操作
    addDataAjax: function addDataAjax() {
      var _this = this;

      var data = __WEBPACK_IMPORTED_MODULE_0__components_common_tools__["a" /* default */].getModel(this.formData);
      // console.log(data)
      __WEBPACK_IMPORTED_MODULE_0__components_common_tools__["a" /* default */].commonAjax.call(this, true, '/Ajax/AddProductNumberInAdmin', data).then(function () {
        _this.$message.success('Operate successfully!');
        // 添加成功
        _this.$emit('addSuccess');
      });
    },

    // 修改操作
    updateDataAjax: function updateDataAjax() {
      var _this2 = this;

      var data = __WEBPACK_IMPORTED_MODULE_0__components_common_tools__["a" /* default */].getModel(this.formData);
      // console.log(data)
      __WEBPACK_IMPORTED_MODULE_0__components_common_tools__["a" /* default */].commonAjax.call(this, true, '/Ajax/UpdateProductNumberInAdmin', data).then(function () {
        _this2.$message.success('Operate successfully!');
        // 修改成功
        _this2.$emit('updateSuccess');
      });
    }
  }
};

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'ProductNumberConfigForm',
  componentName: 'ProductNumberConfigForm',
  mixins: [page],
  components: {},
  data: function data() {
    return {
      formData: dataStore.getDefaultData()
    };
  },

  methods: {
    // 重置表单值
    resetValue: function resetValue() {
      this.formData = dataStore.getDefaultData();
    },

    // 设置表单值
    setValue: function setValue(value) {
      this.formData = __WEBPACK_IMPORTED_MODULE_0__components_common_tools__["a" /* default */].extendData(dataStore.getDefaultData(), value || {});
    },

    // 发布
    doAdd: function doAdd(formName) {
      var _this3 = this;

      this.$refs[formName].validate(function (valid) {
        if (valid) {
          _this3.addDataAjax();
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },

    // 修改
    doUpdate: function doUpdate(formName) {
      var _this4 = this;

      this.$refs[formName].validate(function (valid) {
        if (valid) {
          _this4.updateDataAjax();
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    }
  }
});

/***/ }),
/* 280 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_common_tools__ = __webpack_require__(2);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




// 数据对象
var dataStore = __WEBPACK_IMPORTED_MODULE_1__components_common_tools__["a" /* default */].createDataStore({
  PsCode: '0',
  PsmName: '',
  PsmSort: ''
});

// 请求相关操作
var page = {
  methods: {
    // add操作
    addDataAjax: function addDataAjax() {
      var _this = this;

      var data = __WEBPACK_IMPORTED_MODULE_1__components_common_tools__["a" /* default */].getModel(this.formData);
      // console.log(data)
      __WEBPACK_IMPORTED_MODULE_1__components_common_tools__["a" /* default */].commonAjax.call(this, true, '/Ajax/AddUpdateProselectSsgtModelInAdmin', data).then(function () {
        _this.$message.success('Operate success!');
        // add成功
        _this.$emit('addSuccess');
      });
    },

    // 修改操作
    updateDataAjax: function updateDataAjax(id, state) {
      var _this2 = this;

      var data = __WEBPACK_IMPORTED_MODULE_1__components_common_tools__["a" /* default */].getModel(this.formData);
      // console.log(data)
      __WEBPACK_IMPORTED_MODULE_1__components_common_tools__["a" /* default */].commonAjax.call(this, true, '/Ajax/AddUpdateProselectSsgtModelInAdmin', data).then(function () {
        _this2.$message.success('Operate success!');
        // 修改成功
        _this2.$emit('updateSuccess');
      });
    }
  }
};

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'ProductSSSGTForm',
  componentName: 'ProductSSSGTForm',
  mixins: [page],
  components: {},
  props: ['sideCurrent'],
  created: function created() {
    this.setSideCurrent();
  },
  data: function data() {
    return {
      formData: dataStore.getDefaultData()
    };
  },

  watch: {
    sideCurrent: function sideCurrent() {
      this.setSideCurrent();
    }
  },
  methods: {
    // 设置侧边当前项
    setSideCurrent: function setSideCurrent() {
      if (this.sideCurrent) {
        dataStore.setDefaultData(__WEBPACK_IMPORTED_MODULE_0_jquery___default.a.extend(dataStore.getDefaultData(), {
          PsCode: this.sideCurrent.PsCode
        }));
      }
    },

    // 重置表单值
    resetValue: function resetValue() {
      this.formData = dataStore.getDefaultData();
    },

    // 设置表单值
    setValue: function setValue(value) {
      this.formData = __WEBPACK_IMPORTED_MODULE_1__components_common_tools__["a" /* default */].extendData(dataStore.getDefaultData(), value || {});
    },

    // 发布
    doAdd: function doAdd(formName) {
      var _this3 = this;

      this.$refs[formName].validate(function (valid) {
        if (valid) {
          _this3.addDataAjax();
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },

    // 修改
    doUpdate: function doUpdate(formName) {
      var _this4 = this;

      this.$refs[formName].validate(function (valid) {
        if (valid) {
          _this4.updateDataAjax();
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    }
  }
});

/***/ }),
/* 281 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_common_tools__ = __webpack_require__(2);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



// 数据对象
var dataStore = __WEBPACK_IMPORTED_MODULE_0__components_common_tools__["a" /* default */].createDataStore({
  PsLastCode: '0',
  PsName: ''
});

// 请求相关操作
var page = {
  methods: {
    // add操作
    addDataAjax: function addDataAjax() {
      var _this = this;

      var data = __WEBPACK_IMPORTED_MODULE_0__components_common_tools__["a" /* default */].getModel(this.formData);
      __WEBPACK_IMPORTED_MODULE_0__components_common_tools__["a" /* default */].commonAjax.call(this, true, '/Ajax/AddUpdateProselectSsgtInAdmin', data).then(function () {
        _this.$message.success('Operate success!');
        // add成功
        _this.$emit('addSuccess');
      });
    },

    // 修改操作
    updateDataAjax: function updateDataAjax(id, state) {
      var _this2 = this;

      var data = __WEBPACK_IMPORTED_MODULE_0__components_common_tools__["a" /* default */].getModel(this.formData);
      __WEBPACK_IMPORTED_MODULE_0__components_common_tools__["a" /* default */].commonAjax.call(this, true, '/Ajax/AddUpdateProselectSsgtInAdmin', data).then(function () {
        _this2.$message.success('Operate success!');
        // 修改成功
        _this2.$emit('updateSuccess');
      });
    }
  }
};

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'ProductTypeFormSSGT',
  componentName: 'ProductTypeFormSSGT',
  mixins: [page],
  data: function data() {
    return {
      formData: dataStore.getDefaultData()
    };
  },

  methods: {
    // 重置表单值
    resetValue: function resetValue() {
      this.formData = dataStore.getDefaultData();
    },

    // 设置表单值
    setValue: function setValue(value) {
      value.IsLeaf = !!value.IsLeaf;
      this.formData = __WEBPACK_IMPORTED_MODULE_0__components_common_tools__["a" /* default */].extendData(dataStore.getDefaultData(), value || {});
    },

    // 发布
    doAdd: function doAdd(formName) {
      var _this3 = this;

      this.$refs[formName].validate(function (valid) {
        if (valid) {
          _this3.addDataAjax();
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },

    // 修改
    doUpdate: function doUpdate(formName) {
      var _this4 = this;

      this.$refs[formName].validate(function (valid) {
        if (valid) {
          _this4.updateDataAjax();
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    }
  }
});

/***/ }),
/* 282 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_common_tools__ = __webpack_require__(2);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



// 数据对象
var dataStore = __WEBPACK_IMPORTED_MODULE_0__components_common_tools__["a" /* default */].createDataStore({
  // 角色名称
  LbName: '',
  // 角色Sort
  LbSort: ''
});

// 请求相关操作
var page = {
  methods: {
    // add操作
    addDataAjax: function addDataAjax() {
      var _this = this;

      var data = __WEBPACK_IMPORTED_MODULE_0__components_common_tools__["a" /* default */].getModel(this.formData);
      __WEBPACK_IMPORTED_MODULE_0__components_common_tools__["a" /* default */].commonAjax.call(this, true, '/SystemManage/AddLabel', data).then(function () {
        _this.$message.success('Operate success!');
        // add成功
        _this.$emit('addSuccess');
      });
    },

    // 修改操作
    updateDataAjax: function updateDataAjax(id, state) {
      var _this2 = this;

      var data = __WEBPACK_IMPORTED_MODULE_0__components_common_tools__["a" /* default */].getModel(this.formData);
      __WEBPACK_IMPORTED_MODULE_0__components_common_tools__["a" /* default */].commonAjax.call(this, true, '/SystemManage/UpdateLabel', data).then(function () {
        _this2.$message.success('Operate success!');
        // 修改成功
        _this2.$emit('updateSuccess');
      });
    }
  }
};

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'LabelForm',
  componentName: 'LabelForm',
  mixins: [page],
  data: function data() {
    return {
      formData: dataStore.getDefaultData()
    };
  },

  methods: {
    // 重置表单值
    resetValue: function resetValue() {
      this.formData = dataStore.getDefaultData();
    },

    // 设置表单值
    setValue: function setValue(value) {
      this.formData = __WEBPACK_IMPORTED_MODULE_0__components_common_tools__["a" /* default */].extendData(dataStore.getDefaultData(), value || {});
    },

    // 发布
    doAdd: function doAdd(formName) {
      var _this3 = this;

      this.$refs[formName].validate(function (valid) {
        if (valid) {
          _this3.addDataAjax();
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },

    // 修改
    doUpdate: function doUpdate(formName) {
      var _this4 = this;

      this.$refs[formName].validate(function (valid) {
        if (valid) {
          _this4.updateDataAjax();
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    }
  }
});

/***/ }),
/* 283 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_common_config__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_common_tools__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_common_tree__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__libcomponents_tree_select_tree_vue__ = __webpack_require__(214);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__libcomponents_tree_select_tree_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__libcomponents_tree_select_tree_vue__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





// import storeTools from '@/store/tools'



// 数据对象
var dataStore = __WEBPACK_IMPORTED_MODULE_1__components_common_tools__["a" /* default */].createDataStore({
  // 父亲节点CODE
  MoFacode: '',
  // 菜单类型
  MoType: '',
  // 菜单名称
  MoName: '',
  // 菜单图标
  MoLogo: '',
  // 菜单描述
  MoDescribe: '',
  // 菜单Sort
  MoSort: '',
  // 是否叶子节点
  IsLeaf: false,
  // 菜单URL
  MoUrl: ''
});

// 请求相关操作
var page = {
  methods: {
    // add操作
    addDataAjax: function addDataAjax() {
      var _this = this;

      var data = __WEBPACK_IMPORTED_MODULE_1__components_common_tools__["a" /* default */].getModel(this.formData);
      data.IsLeaf = data.IsLeaf ? 1 : 0;
      __WEBPACK_IMPORTED_MODULE_1__components_common_tools__["a" /* default */].commonAjax.call(this, true, '/SystemManage/AddModule', data).then(function () {
        _this.$message.success('Operate success!');
        // add成功
        _this.$emit('addSuccess');
      });
    },

    // 修改操作
    updateDataAjax: function updateDataAjax(id, state) {
      var _this2 = this;

      var data = __WEBPACK_IMPORTED_MODULE_1__components_common_tools__["a" /* default */].getModel(this.formData);
      data.IsLeaf = data.IsLeaf ? 1 : 0;
      __WEBPACK_IMPORTED_MODULE_1__components_common_tools__["a" /* default */].commonAjax.call(this, true, '/SystemManage/UpdateModule', data).then(function () {
        _this2.$message.success('Operate success!');
        // 修改成功
        _this2.$emit('updateSuccess');
        // 重新获取登录用户信息
        _this2.$store.dispatch('getLoginMemberInfo', false);
      });
    }
  }

  // 菜单树
};var moduleTree = new __WEBPACK_IMPORTED_MODULE_2__components_common_tree__["a" /* default */].TreeCreate(function (item) {
  for (var key in item) {
    if (item.hasOwnProperty(key)) {
      this[key] = item[key];
    }
  }
}, { FId: 'MoFacode', Id: 'MoCode', rootId: '-1' });

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'ModuleForm',
  componentName: 'ModuleForm',
  mixins: [page],
  components: {
    treeSelect: __WEBPACK_IMPORTED_MODULE_3__libcomponents_tree_select_tree_vue___default.a
  },
  props: ['moduleData', 'moduleProp'],
  data: function data() {
    return {
      config: __WEBPACK_IMPORTED_MODULE_0__components_common_config__["a" /* default */],
      formData: dataStore.getDefaultData(),
      iconList: ['fa-image', 'fa-inbox', 'fa-rss', 'fa-search', 'fa-folder-o', 'fa-bug', 'fa-calendar-check-o', 'fa-cog', 'fa-tags', 'fa-user-o', 'fa-file-o', 'fa-align-left', 'fa-paperclip', 'fa-gg', 'fa-slack', 'fa-skyatlas', 'fa-html5']
    };
  },

  computed: {
    // 侧边树数据
    treeData: function treeData() {
      var treeFlatData = this.moduleData.filter(function (item) {
        return !item.IsLeaf;
      });
      moduleTree.create(treeFlatData);
      var treeData = moduleTree.getTreeData();
      return treeData;
    }
  },
  methods: {
    showTreeError: function showTreeError(error) {
      this.$message.info(error.message);
    },
    setSelectedId: function setSelectedId(val) {
      this.formData.MoFacode = val;
    },

    // 重置表单值
    resetValue: function resetValue() {
      this.formData = dataStore.getDefaultData();
    },

    // 设置表单值
    setValue: function setValue(value) {
      this.formData = __WEBPACK_IMPORTED_MODULE_1__components_common_tools__["a" /* default */].extendData(dataStore.getDefaultData(), value || {});
      this.formData.IsLeaf = !!this.formData.IsLeaf;
    },

    // 发布
    doAdd: function doAdd(formName) {
      var _this3 = this;

      this.$refs[formName].validate(function (valid) {
        if (valid) {
          _this3.addDataAjax();
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },

    // 修改
    doUpdate: function doUpdate(formName) {
      var _this4 = this;

      this.$refs[formName].validate(function (valid) {
        if (valid) {
          _this4.updateDataAjax();
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },

    // 选择菜单图标
    selectLogo: function selectLogo(val) {
      this.formData.MoLogo = val;
    }
  }
});

/***/ }),
/* 284 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_common_tools__ = __webpack_require__(2);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



// 数据对象
var dataStore = __WEBPACK_IMPORTED_MODULE_0__components_common_tools__["a" /* default */].createDataStore({
  // id
  Id: '',
  // 密码
  AuPassword: ''
});

// 请求相关操作
var page = {
  methods: {
    // 修改操作
    updateDataAjax: function updateDataAjax(id, state) {
      var _this = this;

      var data = __WEBPACK_IMPORTED_MODULE_0__components_common_tools__["a" /* default */].getModel(this.formData);
      __WEBPACK_IMPORTED_MODULE_0__components_common_tools__["a" /* default */].commonAjax.call(this, true, '/SystemManage/ResetPasswordInAdmin', data).then(function () {
        _this.$message.success('Operate success!');
        // 修改成功
        _this.$emit('updateSuccess');
      });
    }
  }
};

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'PasswordForm',
  componentName: 'PasswordForm',
  mixins: [page],
  data: function data() {
    return {
      formData: dataStore.getDefaultData()
    };
  },

  methods: {
    // 重置表单值
    resetValue: function resetValue() {
      this.formData = dataStore.getDefaultData();
    },

    // 设置表单值
    setValue: function setValue(value) {
      this.formData = __WEBPACK_IMPORTED_MODULE_0__components_common_tools__["a" /* default */].extendData(dataStore.getDefaultData(), value || {});
    },

    // 修改
    doUpdate: function doUpdate(formName) {
      var _this2 = this;

      this.$refs[formName].validate(function (valid) {
        if (valid) {
          _this2.updateDataAjax();
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    }
  }
});

/***/ }),
/* 285 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_underscore__ = __webpack_require__(149);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_underscore___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_underscore__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_common_tools__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_common_tree__ = __webpack_require__(36);
//
//
//
//
//
//
//
//
//
//
//







// 菜单树
var moduleTree = new __WEBPACK_IMPORTED_MODULE_3__components_common_tree__["a" /* default */].TreeCreate(function (item) {
  for (var key in item) {
    if (item.hasOwnProperty(key)) {
      this[key] = item[key];
    }
  }
}, { FId: 'MoFacode', Id: 'MoCode' });

// 请求相关操作
var page = {
  methods: {
    // 获得指定部门权限
    getDepartmentPowerDataAjax: function getDepartmentPowerDataAjax(hasLoading) {
      return __WEBPACK_IMPORTED_MODULE_2__components_common_tools__["a" /* default */].commonAjax.call(this, hasLoading, '/SystemManage/GetAdminUserModuleFromOgCode', {
        code: this.currentCode
      });
    },

    // 获得指定用户权限
    getUserPowerDataAjax: function getUserPowerDataAjax(hasLoading) {
      return __WEBPACK_IMPORTED_MODULE_2__components_common_tools__["a" /* default */].commonAjax.call(this, hasLoading, '/SystemManage/GetAdminUserModule', {
        code: this.currentCode
      });
    },

    // 获得指定角色权限
    getLabelPowerDataAjax: function getLabelPowerDataAjax(hasLoading) {
      return __WEBPACK_IMPORTED_MODULE_2__components_common_tools__["a" /* default */].commonAjax.call(this, hasLoading, '/SystemManage/GetAdminUserModuleFromLbCode', {
        code: this.currentCode
      });
    },

    // 获取菜单列表操作
    getModuleListDataAjax: function getModuleListDataAjax() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_2__components_common_tools__["a" /* default */].commonAjax.call(this, false, '/SystemManage/GetModuleList', {
        All: 1
      }).then(function (res) {
        var result = res.data;
        moduleTree.create(result);
        _this.moduleData = moduleTree.getTreeData();
      });
    },

    // add权限操作
    updatePowerDataAjax: function updatePowerDataAjax() {
      var _this2 = this;

      var data = __WEBPACK_IMPORTED_MODULE_2__components_common_tools__["a" /* default */].getModel(this.submitData);
      data = data.map(function (item) {
        return {
          MoCode: item.MoCode,
          ReType: _this2.currentType,
          ReCode: _this2.currentCode
        };
      });
      return __WEBPACK_IMPORTED_MODULE_2__components_common_tools__["a" /* default */].commonAjax.call(this, true, '/SystemManage/AddModuleRelationAdmin', __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.extend({
        code: this.currentCode
      }, __WEBPACK_IMPORTED_MODULE_2__components_common_tools__["a" /* default */].mvcParamMatch(data, 'modellist'))).then(function () {
        _this2.$message.success('修改成功!');
        // if (this.currentType === this.PowerTypeConfig.STAFF) {
        //   // 如果是[员工],且修改为当前用户 -> 重新获取用户信息
        //   if (this.currentCode === this.$store.state.user.memberInfo.AuCode) {
        //     this.$store.dispatch('getLoginMemberInfo', false)
        //   }
        // }
        // 因为无法得知是否修改的为当前用户的部门或关联的角色的权限, 所以修改成功后都重新获取用户信息
        _this2.$store.dispatch('getLoginMemberInfo', false);
        _this2.$emit('updatePowerSuccess');
      });
    }
  }
};

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'PowerForm',
  componentName: 'PowerForm',
  mixins: [page],
  // props: [
  //   'currentType', // 关联类型 0[部门] 1[员工] 2[角色]
  //   'currentCode' // currentType 对应类型的 [部门][员工][角色] 的 code
  // ],
  created: function created() {
    // 获取菜单列表操作
    this.getModuleListDataAjax();
  },
  data: function data() {
    return {
      // 权限类型配置项
      PowerTypeConfig: {
        // 部门
        DEPARTMENT: 0,
        // 员工
        STAFF: 1,
        // 角色(标签)
        LABEL: 2
      },
      // 权限菜单树数据
      moduleData: [],
      // 权限菜单树配置项
      moduleProp: {
        label: 'MoName',
        children: 'children'
      },
      // 关联类型 0[部门] 1[员工] 2[角色]
      currentType: null,
      // currentType 对应类型的 [部门][员工][角色] 的 code
      currentCode: null,
      // 提交的数据
      submitData: []
    };
  },

  methods: {
    // ConfirmGive permission
    doConfirm: function doConfirm() {
      this.updatePowerDataAjax();
    },

    // 权限树选中状态变化
    checkPowerTreeChange: function checkPowerTreeChange(item, isSelect) {
      if (isSelect) {
        this.submitData.push(__WEBPACK_IMPORTED_MODULE_2__components_common_tools__["a" /* default */].getModel(item));
      } else {
        var idx = __WEBPACK_IMPORTED_MODULE_1_underscore___default.a.findIndex(this.submitData, function (el) {
          return el.MoCode === item.MoCode;
        });
        if (idx !== -1) {
          this.submitData.splice(idx, 1);
        }
      }
    },

    // 获取默认数据
    getDefaultData: function getDefaultData(currentType, currentCode) {
      var _this3 = this;

      var hasLoading = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

      this.currentType = currentType;
      this.currentCode = currentCode;
      var def = void 0;
      if (currentType === this.PowerTypeConfig.DEPARTMENT) {
        // 获得指定部门权限
        def = this.getDepartmentPowerDataAjax(hasLoading);
      } else if (currentType === this.PowerTypeConfig.STAFF) {
        // 获得指定用户权限
        def = this.getUserPowerDataAjax(hasLoading);
      } else if (currentType === this.PowerTypeConfig.LABEL) {
        // 获得指定角色权限
        def = this.getLabelPowerDataAjax(hasLoading);
      }
      def.then(function (res) {
        var result = res.data;
        _this3.$refs.powerTree.setCheckedKeys(result.map(function (item) {
          return item.MoCode;
        }));
      });
      return def;
    }
  }
});

/***/ }),
/* 286 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'copyBtn',
  props: {
    // 需拷贝文本
    text: {
      type: String,
      default: ''
    }
  },
  data: function data() {
    return {};
  },

  methods: {
    copyTxt: function copyTxt() {
      window.Mc.copyTxt(this.text);
    }
  }
});

/***/ }),
/* 287 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// import $ from 'jquery'
// import tools from '@/components/common/tools'

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'videoUpload',
  props: {
    width: {
      type: Number,
      default: 350
    },
    // 工作模式
    // 'url-name'
    // 'url'
    workMode: {
      type: String,
      default: 'url-name'
    },
    fileName: {
      type: String,
      default: ''
    },
    fileUrl: {
      type: String,
      default: ''
    }
  },
  created: function created() {},
  data: function data() {
    return {};
  },

  methods: {
    // 上传成功
    fileUploadSuccess: function fileUploadSuccess(val, data) {
      this.$emit('update:fileUrl', val);
      this.$emit('update:fileName', data.title);
    }
  }
});

/***/ }),
/* 288 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_common_tools__ = __webpack_require__(2);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// import $ from 'jquery'


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'imgUpload',
  props: {
    // prompt文字
    tip: {
      type: String,
      default: ''
    },
    // 是否多图
    mult: {
      type: Boolean,
      default: false
    },
    size: {
      type: String,
      default: 'normal'
    },
    // 多图模式下,列个数
    colNbr: {
      type: Number,
      default: 1
    },
    value: {
      type: String,
      default: ''
    }
  },
  created: function created() {
    this.setValue(this.value);
  },
  data: function data() {
    return {
      img: '',
      imgList: ''
    };
  },

  watch: {
    // 值变化
    value: function value(newVal) {
      this.setValue(newVal);
    }
  },
  computed: {
    // 多图列表
    multImgList: function multImgList() {
      if (this.imgList) {
        var data = __WEBPACK_IMPORTED_MODULE_0__components_common_tools__["a" /* default */].getModel(this.imgList);
        data.push('');
        return data;
      } else {
        return [''];
      }
    }
  },
  methods: {
    setValue: function setValue(val) {
      if (this.mult) {
        // 多图
        if (val) {
          this.imgList = val.split(',');
        } else {
          this.imgList = [];
        }
      } else {
        // 单图
        this.img = val;
      }
    },

    // 更新值
    updateValue: function updateValue() {
      if (this.mult) {
        // 多图
        this.$emit('input', this.imgList.join(','));
      } else {
        // 单图
        this.$emit('input', this.img);
      }
    },

    // 单图片上传成功
    singleImgUplad: function singleImgUplad(url) {
      this.$emit('input', url);
    },

    // 多图片上传成功
    multImgUplad: function multImgUplad(url, idx) {
      this.imgList[idx] = url;
      this.$emit('input', this.imgList.join(','));
    },

    // 删除多图项
    delImg: function delImg(idx) {
      var _this = this;

      this.$confirm('是否确认删除?', 'prompt', {
        confirmButtonText: 'Confirm',
        cancelButtonText: 'Canel',
        type: 'warning'
      }).then(function () {
        _this.imgList.splice(idx, 1);
        _this.$emit('input', _this.imgList.join(','));
      });
    }
  }
});

/***/ }),
/* 289 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_common_mc_lib__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_common_config__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_ueditor__ = __webpack_require__(803);
//
//
//
//
//
//
//
//
//
//

// import $ from 'jquery'
// import tools from '@/components/common/tools'





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'mcEditor',
  components: {
    VueUEditor: __WEBPACK_IMPORTED_MODULE_2_vue_ueditor__["a" /* default */]
  },
  props: {
    isFullWidth: {
      type: Boolean,
      default: false
    },
    value: {
      type: String,
      default: ''
    }
  },
  data: function data() {
    return {
      vueUEditorId: 'vue_ueditor_' + __WEBPACK_IMPORTED_MODULE_0__components_common_mc_lib__["a" /* default */].Guid(20),
      config: __WEBPACK_IMPORTED_MODULE_1__components_common_config__["a" /* default */],
      editorInstance: null,
      editorValue: this.value !== null && this.value !== undefined ? this.value : ''
    };
  },

  watch: {
    // 值变化
    value: function value(newVal) {
      if (newVal === null || newVal === undefined) newVal = '';
      if (this.editorInstance) {
        if (newVal !== this.editorValue) {
          this.editorInstance.setContent(newVal);
        }
      } else {
        this.editorValue = newVal;
      }
    }
  },
  methods: {
    editorReady: function editorReady(editorInstance) {
      var _this = this;

      editorInstance.setContent(this.editorValue);
      this.editorInstance = editorInstance;
      editorInstance.addListener('contentChange showmessage focus blur', function () {
        var result = editorInstance.getContent();
        _this.editorValue = result;
        _this.$emit('input', result);
      });
    },

    // 获取文本编辑器对象
    getEditorInstance: function getEditorInstance() {
      return this.editorInstance;
    },

    // 获取值
    getValue: function getValue() {
      return this.editorInstance.getContent();
    }
  }
});

/***/ }),
/* 290 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'treeNode',
  props: {
    node: {
      type: Object,
      defautl: {}
    },
    treeProps: {},
    multiple: {},
    currentNodeId: {},
    eventHub: {},
    query: {
      type: String
    },
    isQuering: {
      type: Boolean
    }
  },
  data: function data() {
    return {};
  },

  methods: {
    handleClick: function handleClick(node, event) {
      var targetClass = event.target.getAttribute('class');
      if (node.expanded) {
        this.$set(node, 'expanded', false);
      } else {
        this.$set(node, 'expanded', true);
      }
      if (!(targetClass.indexOf('icon') > -1)) {
        this.eventHub.$emit('node-click', node, event);
      }
    },
    handleTitleVisible: function handleTitleVisible(title) {
      var titleLen = title.replace(/[^\x00-\xff]/g, '..').length;
      if (titleLen > 28) {
        return title;
      } else {
        return '';
      }
    }
  }
});

/***/ }),
/* 291 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(156);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui__ = __webpack_require__(102);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_element_ui__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__tree_node_vue__ = __webpack_require__(682);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__tree_node_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__tree_node_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_clickoutside__ = __webpack_require__(241);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_throttle_debounce_throttle__ = __webpack_require__(148);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_throttle_debounce_throttle___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_throttle_debounce_throttle__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_tools__ = __webpack_require__(243);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







__WEBPACK_IMPORTED_MODULE_1_vue__["default"].component(__WEBPACK_IMPORTED_MODULE_2_element_ui__["Scrollbar"].name, __WEBPACK_IMPORTED_MODULE_2_element_ui__["Scrollbar"]);
__WEBPACK_IMPORTED_MODULE_1_vue__["default"].component(__WEBPACK_IMPORTED_MODULE_2_element_ui__["Tag"].name, __WEBPACK_IMPORTED_MODULE_2_element_ui__["Tag"]);

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'tree',
  components: {
    treeNode: __WEBPACK_IMPORTED_MODULE_3__tree_node_vue___default.a
  },
  props: {
    treeData: {
      type: Array,
      default: []
    },
    treeProps: {
      type: Object,
      default: {
        id: 'id',
        label: 'label',
        children: 'children'
      }
    },
    placeholder: {
      type: String,
      default: '请选择'
    },
    value: {},
    multiple: {
      type: Boolean
    }
  },
  created: function created() {
    this.eventHub.$on('node-click', this.handleNodeClick);
    if (this.isDefault) {
      this.setDefaultValue();
    }
  },
  updated: function updated() {
    this.isDefault = true;
  },

  computed: {
    showCloseIcon: function showCloseIcon() {
      return this.hovering && this.value !== undefined && this.value !== '' && !this.multiple;
    }
  },
  watch: {
    value: function value(val) {
      if (this.isDefault) {
        this.setDefaultValue();
      }
    },
    treeData: function treeData(val) {
      if (val) {
        var _treeNodes;

        this.treeNodes = (_treeNodes = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_treeNodes, this.treeProps.children, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__utils_tools__["a" /* objArrDeepCopy */])(val, { visible: true })), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_treeNodes, 'visible', true), _treeNodes);
        if (this.isDefault) {
          this.setDefaultValue();
        }
      }
    },
    checkedKeys: function checkedKeys(val) {
      if (val.length) {
        this.placetext = '';
      } else {
        this.placetext = this.placeholder;
      }
      if (this.multiple) {
        setTimeout(function () {
          this.resetTreeTop();
        }.bind(this), 400);
        if (!this.isDefault) {
          this.setInputFocus();
        }
      }
    }
  },
  data: function data() {
    var _treeNodes2;

    return {
      treeNodes: (_treeNodes2 = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_treeNodes2, this.treeProps.children, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__utils_tools__["a" /* objArrDeepCopy */])(this.treeData, { visible: true })), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_treeNodes2, 'visible', true), _treeNodes2),
      placetext: this.placeholder,
      currentNodeId: '',
      currentSelected: '',
      treeSelected: '',
      treeVisible: false,
      eventHub: new __WEBPACK_IMPORTED_MODULE_1_vue__["default"](),
      isQuering: false,
      query: '',
      checkedItems: [],
      checkedKeys: [],
      isDefault: true,
      error: {
        message: '',
        data: ''
      },
      hovering: false
    };
  },

  methods: {
    resetValue: function resetValue() {
      if (this.multiple) {
        this.checkedItems = [];
        this.checkedKeys = [];
        this.$emit('setSelectedId', []);
      } else {
        this.treeSelected = '';
        this.currentNodeId = '';
        this.$emit('setSelectedId', '');
      }
    },
    handleCloseTree: function handleCloseTree(val) {
      if (this.showCloseIcon) {
        this.resetValue();
      } else {
        if (val === undefined) {
          this.treeVisible = false;
        } else {
          this.treeVisible = val;
        }
        if (this.multiple) {
          this.treeSelected = '';
          this.handleFilter();
          if (val) {
            this.setInputFocus();
          }
        }
      }
    },
    handleNodeClick: function handleNodeClick(node, event) {
      if (event) {
        this.isDefault = false;
      }
      if (this.multiple) {
        if (!this.hasSameItem(this.checkedItems, node)) {
          this.handleAddItem(node);
          this.$emit('setSelectedId', this.checkedKeys);
        } else {
          this.handleDelItem(node, event);
        }
      } else {
        this.currentNodeId = node[this.treeProps.id];
        this.treeSelected = node[this.treeProps.label];
        this.currentSelected = this.treeSelected;
        this.$emit('setSelectedId', node[this.treeProps.id]);
      }
    },
    setDefaultValue: function setDefaultValue() {
      if (!this.multiple) {
        this.setSelected(this.value);
      } else {
        this.setCheckedKeys(this.value);
      }
    },

    // 单选设置初始值
    setSelected: function setSelected(val) {
      var self = this;
      var treeNodes = self.treeNodes;

      self.resetValue();
      self.findTreeItem(val, treeNodes);
      if (!this.currentNodeId) {
        this.setErrorMessage(val);
      }
    },

    // 多选设置初始值
    setCheckedKeys: function setCheckedKeys(val) {
      var self = this;
      var treeNodes = this.treeNodes;

      this.resetValue();
      val.forEach(function (id) {
        self.findTreeItem(id, treeNodes);
      });
      this.getNotExistedItem(val, this.checkedKeys);
    },
    findTreeItem: function findTreeItem(id, treeNodes) {
      var self = this;
      var childNodes = treeNodes[self.treeProps.children];

      for (var i = 0; i < childNodes.length; i++) {
        if (childNodes[i][self.treeProps.id] === id) {
          if (self.multiple) {
            self.handleAddItem(childNodes[i]);
          } else {
            self.handleNodeClick(childNodes[i]);
          }
          break;
        } else {
          self.findTreeItem(id, childNodes[i]);
        }
      }
    },

    handleFilter: __WEBPACK_IMPORTED_MODULE_5_throttle_debounce_throttle___default()(1000, function () {
      this.isQuering = true;
      if (this.isQuering) {
        this.query = this.treeSelected;
        this.treeFilterMethod(this.treeNodes);
      }
    }),
    treeFilterMethod: function treeFilterMethod(node) {
      var self = this;
      var childNodes = node[self.treeProps.children];

      childNodes.forEach(function (child) {
        child.visible = child[self.treeProps.label].toLowerCase().indexOf(self.query.toLowerCase()) > -1;
        self.treeFilterMethod(child);
      });
      if (!node.visible && childNodes.length) {
        var allHidden = true;
        childNodes.forEach(function (child) {
          if (child.visible) allHidden = false;
        });
        node.visible = allHidden === false;
      }
      if (node.visible) {
        this.$set(node, 'expanded', true);
        if (self.query === '') {
          node.expanded = false;
        }
      }
    },
    handleAutoComplete: function handleAutoComplete() {
      setTimeout(function () {
        this.query = '';
        if (this.currentNodeId) {
          this.treeSelected = this.currentSelected;
        } else if (!this.multiple) {
          this.treeSelected = '';
          this.handleFilter();
        }
        if (this.isQuery) {
          this.treeVisible = false;
        }
        this.isQuery = false;
      }.bind(this), 250);
    },
    handleAddItem: function handleAddItem(item) {
      this.checkedItems.push(item);
      this.checkedKeys.push(item[this.treeProps.id]);
      this.$set(item, 'checked', true);
    },
    handleDelItem: function handleDelItem(item, event) {
      if (event) {
        this.isDefault = false;
      }
      this.checkedKeys.splice(this.checkedKeys.indexOf(item[this.treeProps.id]), 1);
      this.checkedItems.splice(this.checkedItems.indexOf(item), 1);
      this.$set(item, 'checked', false);
      this.$emit('setSelectedId', this.checkedKeys);
    },
    hasSameItem: function hasSameItem(obj, item) {
      return obj.indexOf(item) > -1;
    },
    getNotExistedItem: function getNotExistedItem(all, part) {
      var notExisted = [];

      all.forEach(function (item) {
        if (!(part.indexOf(item) > -1)) {
          notExisted.push(item);
        }
      });
      this.setErrorMessage(notExisted);
    },
    setErrorMessage: function setErrorMessage(data) {
      if (!data || !data.toString()) return;
      var errorText = data instanceof Array ? data.toString() : data;

      this.error.message = '发现不存在的部门id:' + errorText;
      this.error.data = data;
      this.$emit('errorCallback', this.error);
    },
    resetTreeTop: function resetTreeTop() {
      this.$nextTick(function () {
        var inputMultiple = this.$refs.atsTree.querySelector('.ats-input-multiple');
        var treeScrollbar = this.$refs.atsTree.querySelector('.ats-tree-scrollbar');
        var inputMultipleHeight = inputMultiple.offsetHeight;

        treeScrollbar.style.top = inputMultipleHeight + 5 + 'px';
      });
    },
    setInputFocus: function setInputFocus() {
      var multipleInput = this.$refs.multipleInput;

      multipleInput.focus();
    },
    handleTitleVisible: function handleTitleVisible(str) {
      if (!str) return '';
      var tempLen = 0;

      for (var i = 0; i < str.length; i++) {
        if (str.charCodeAt(i) > 255) {
          tempLen += 2;
        } else {
          tempLen += 1;
        }
      }
      if (tempLen >= 15) {
        return str;
      } else {
        return '';
      }
    }
  },
  filters: {
    // 截取前18个字节
    showEllips: function showEllips(str) {
      if (!str) return '';
      var tempLen = 0;

      for (var i = 0; i < str.length; i++) {
        if (str.charCodeAt(i) > 255) {
          tempLen += 2;
        } else {
          tempLen += 1;
        }
        if (tempLen >= 15) {
          str = str.substring(0, i) + '...';
          break;
        }
      }
      return str;
    }
  },
  directives: { Clickoutside: __WEBPACK_IMPORTED_MODULE_4__utils_clickoutside__["a" /* default */] }
});

/***/ }),
/* 292 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// import $ from 'jquery'
// import tools from '@/components/common/tools'

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'videoUpload',
  props: {
    // 工作模式
    // upload
    // outer
    // upload-outer
    workMode: {
      type: String,
      default: 'upload-outer'
    },
    isOuter: {
      type: Boolean,
      default: true
    },
    width: {
      type: Number,
      default: 400
    },
    url: {
      type: String,
      default: ''
    }
  },
  created: function created() {},
  data: function data() {
    return {
      isOuterUrl: this.isOuter,
      videoUrl: this.url
    };
  },

  watch: {
    // 工作模式变化
    workMode: function workMode(newVal) {
      if (this.workMode === 'upload-outer' || this.workMode === 'outer') {
        this.isOuter = true;
      } else if (this.workMode === 'upload') {
        this.isOuter = false;
      }
    },

    // 是否外链变化
    isOuter: function isOuter(newVal) {
      this.isOuterUrl = newVal;
    },

    // url变化
    url: function url(newVal) {
      this.videoUrl = newVal;
    }
  },
  methods: {
    // 改变是否外链
    changeOuter: function changeOuter() {
      this.$emit('update:isOuter', this.isOuterUrl);
      this.$emit('update:url', '');
    },

    // 外链输入框值变化
    outerIptChange: function outerIptChange() {
      this.$emit('update:url', this.videoUrl);
    },

    // 本地视频上传成功
    videoUploadSuccess: function videoUploadSuccess(val) {
      this.$emit('update:url', val);
    }
  }
});

/***/ }),
/* 293 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_common_tools__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_cms_CaseForm__ = __webpack_require__(651);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_cms_CaseForm___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_cms_CaseForm__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__libcomponents_copy_btn_copy_btn__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__libcomponents_copy_btn_copy_btn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__libcomponents_copy_btn_copy_btn__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// import $ from 'jquery'
// import mixin from '@/components/common/mixin'




// 表格相关操作
var table = {
  methods: {
    getTableData: __WEBPACK_IMPORTED_MODULE_0__components_common_tools__["a" /* default */].commonTableDateFetch({
      url: '/Ajax/GetCaseInfoListInAdmin',
      data: function data() {
        return {
          CtCode: this.tree.current ? this.tree.current.CtCode : null
        };
      },
      success: function success(response) {
        var result = response.data;
        this.table.data = result;
      }
    }),
    refreshTableData: function refreshTableData() {
      this.getTableData(this.table.currentPage);
    }
  }

  // 请求相关操作
};var page = {
  methods: {
    // 获得分类数据
    getTypeDataAjax: function getTypeDataAjax() {
      var _this = this;

      __WEBPACK_IMPORTED_MODULE_0__components_common_tools__["a" /* default */].commonAjax.call(this, true, '/Ajax/GetCaseTypeListInAdmin', {
        All: 1,
        OrderName: 'CT_SORT DESC'
      }).then(function (res) {
        var result = res.data;
        // this.dataStore.commit(types.UPDATE_MODULE, result)
        // sideTree.create(result)
        // let treeData = sideTree.getTreeData()
        if (result[0]) {
          _this.tree.current = result[0];
          // 获得右侧表格数据
          _this.getTableData();
        }
        _this.tree.data = result;
      });
    },

    // 删除操作
    delDataAjax: function delDataAjax(id) {
      var _this2 = this;

      __WEBPACK_IMPORTED_MODULE_0__components_common_tools__["a" /* default */].commonAjax.call(this, true, '/Ajax/DeleteCaseInfoInAdmin', {
        Id: id
      }).then(function () {
        _this2.$message.success('delete success!');
        // 重新获取列表数据
        _this2.refreshTableData();
      });
    }
  }
};

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'CaseManagement',
  mixins: [table, page],
  components: {
    CaseForm: __WEBPACK_IMPORTED_MODULE_1__components_cms_CaseForm___default.a, copyBtn: __WEBPACK_IMPORTED_MODULE_2__libcomponents_copy_btn_copy_btn___default.a
  },
  created: function created() {
    this.getTypeDataAjax();
  },
  data: function data() {
    return {
      tree: {
        data: [],
        current: null,
        prop: {
          label: 'CtName',
          children: 'children'
        }
      },
      table: {
        isLoading: false, // 是否正在加载
        ajaxData: { OrderName: 'CI_SORT DESC' }, // 额外请求参数
        data: [], // 表格当前数据
        currentPage: 1, // 当前页码
        pageSize: 15, // 每页条数
        pageTotal: 0 // 总页数
      },
      page: {
        popShow: false
      }
    };
  },

  computed: {},
  methods: {
    // 树节点点击事件
    clickModuleTree: function clickModuleTree(item) {
      var current = this.tree.current;
      if (current.CtCode !== item.CtCode) {
        this.tree.current = item;
        // 重新获取列表数据
        this.getTableData();
      }
    },

    // 页码点击事件
    handleTableCurrentChange: function handleTableCurrentChange(val) {
      this.getTableData(val);
    },

    // 显示add弹出层
    showAddPop: function showAddPop() {
      this.page.popShow = true;
      this.$nextTick(function () {
        this.$refs.popForm.resetValue();
      });
    },

    // 显示修改弹出层
    showUpdatePop: function showUpdatePop(idx, item) {
      this.page.popShow = true;
      this.$nextTick(function () {
        this.$refs.popForm.setValue(item);
      });
    },

    // add操作
    handleAdd: function handleAdd() {
      // 重新获取列表数据
      this.refreshTableData();
      this.page.popShow = false;
    },

    // 修改操作
    handleUpdate: function handleUpdate() {
      // 重新获取列表数据
      this.refreshTableData();
      this.page.popShow = false;
    },

    // 删除操作
    handleDel: function handleDel(idx, item) {
      var _this3 = this;

      this.$confirm('This will permanently delete the record', 'prompt', {
        confirmButtonText: 'Confirm',
        cancelButtonText: 'Canel',
        type: 'warning'
      }).then(function () {
        _this3.delDataAjax(item.Id);
      });
    }
  }
});

/***/ }),
/* 294 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_common_tools__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_cms_CaseTypeForm__ = __webpack_require__(652);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_cms_CaseTypeForm___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_cms_CaseTypeForm__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// import $ from 'jquery'
// import mixin from '@/components/common/mixin'



// 表格相关操作
var table = {
  methods: {
    getTableData: __WEBPACK_IMPORTED_MODULE_0__components_common_tools__["a" /* default */].commonTableDateFetch({
      url: '/Ajax/GetCaseTypeListInAdmin',
      success: function success(response) {
        var result = response.data;
        this.table.data = result;
      }
    }),
    refreshTableData: function refreshTableData() {
      this.getTableData(this.table.currentPage);
    }
  }

  // 请求相关操作
};var page = {
  methods: {
    // 删除操作
    delDataAjax: function delDataAjax(id) {
      var _this = this;

      __WEBPACK_IMPORTED_MODULE_0__components_common_tools__["a" /* default */].commonAjax.call(this, true, '/Ajax/DeleteCaseTypeInAdmin', {
        Id: id
      }).then(function () {
        _this.$message.success('delete success!');
        // 重新获取列表数据
        _this.refreshTableData();
      });
    }
  }
};

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'CaseTypeManagement',
  mixins: [table, page],
  components: {
    CaseTypeForm: __WEBPACK_IMPORTED_MODULE_1__components_cms_CaseTypeForm___default.a
  },
  created: function created() {
    this.getTableData();
  },
  data: function data() {
    return {
      table: {
        isLoading: false, // 是否正在加载
        ajaxData: {
          OrderName: 'CT_SORT DESC'
        }, // 额外请求参数
        data: [], // 表格当前数据
        currentPage: 1, // 当前页码
        pageSize: 15, // 每页条数
        pageTotal: 0 // 总页数
      },
      page: {
        popShow: false
      }
    };
  },

  computed: {},
  methods: {
    // 页码点击事件
    handleTableCurrentChange: function handleTableCurrentChange(val) {
      this.getTableData(val);
    },

    // 显示add弹出层
    showAddPop: function showAddPop() {
      this.page.popShow = true;
      this.$nextTick(function () {
        this.$refs.popForm.resetValue();
      });
    },

    // 显示修改弹出层
    showUpdatePop: function showUpdatePop(idx, item) {
      this.page.popShow = true;
      this.$nextTick(function () {
        this.$refs.popForm.setValue(item);
      });
    },

    // add操作
    handleAdd: function handleAdd() {
      // 刷新表格数据
      this.refreshTableData();
      this.page.popShow = false;
    },

    // 修改操作
    handleUpdate: function handleUpdate() {
      // 刷新表格数据
      this.refreshTableData();
      this.page.popShow = false;
    },

    // 删除操作
    handleDel: function handleDel(idx, item) {
      var _this2 = this;

      this.$confirm('This will permanently delete the record', 'prompt', {
        confirmButtonText: 'Confirm',
        cancelButtonText: 'Canel',
        type: 'warning'
      }).then(function () {
        _this2.delDataAjax(item.Id);
      });
    }
  }
});

/***/ }),
/* 295 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_common_tools__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_cms_DownfileForm__ = __webpack_require__(653);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_cms_DownfileForm___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_cms_DownfileForm__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_common_tree__ = __webpack_require__(36);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// import $ from 'jquery'
// import mixin from '@/components/common/mixin'




// 侧边树
var sideTree = new __WEBPACK_IMPORTED_MODULE_2__components_common_tree__["a" /* default */].TreeCreate(function (item) {
  for (var key in item) {
    if (item.hasOwnProperty(key)) {
      this[key] = item[key];
    }
  }
}, { FId: 'DtFacode', Id: 'DtCode' });

// 表格相关操作
var table = {
  methods: {
    getTableData: __WEBPACK_IMPORTED_MODULE_0__components_common_tools__["a" /* default */].commonTableDateFetch({
      url: '/Ajax/GetDataInfoListInAdmin',
      data: function data() {
        return {
          DtRoute: this.tree.current ? this.tree.current.DtRoute : null
        };
      },
      success: function success(response) {
        var result = response.data;
        this.table.data = result;
      }
    }),
    refreshTableData: function refreshTableData() {
      this.getTableData(this.table.currentPage);
    }
  }

  // 请求相关操作
};var page = {
  methods: {
    // 获得分类数据
    getTypeDataAjax: function getTypeDataAjax() {
      var _this = this;

      __WEBPACK_IMPORTED_MODULE_0__components_common_tools__["a" /* default */].commonAjax.call(this, true, '/Ajax/GetDataTypeListInAdmin', {
        All: 1,
        OrderName: 'DT_SORT DESC'
      }).then(function (res) {
        var result = res.data;
        // this.dataStore.commit(types.UPDATE_MODULE, result)
        sideTree.create(result);
        var treeData = sideTree.getTreeData();
        if (treeData[0]) {
          _this.tree.current = treeData[0];
          // 获得右侧表格数据
          _this.getTableData();
        }
        _this.tree.data = treeData;
      });
    },

    // 删除操作
    delDataAjax: function delDataAjax(id) {
      var _this2 = this;

      __WEBPACK_IMPORTED_MODULE_0__components_common_tools__["a" /* default */].commonAjax.call(this, true, '/Ajax/DeleteDataInfoInAdmin', {
        Id: id
      }).then(function () {
        _this2.$message.success('delete success!');
        // 重新获取列表数据
        _this2.refreshTableData();
      });
    }
  }
};

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'DownfileManagement',
  mixins: [table, page],
  components: {
    DownfileForm: __WEBPACK_IMPORTED_MODULE_1__components_cms_DownfileForm___default.a
  },
  created: function created() {
    this.getTypeDataAjax();
  },
  data: function data() {
    return {
      tree: {
        data: [],
        current: null,
        prop: {
          label: 'DtName',
          children: 'children'
        }
      },
      table: {
        isLoading: false, // 是否正在加载
        ajaxData: { OrderName: 'DI_SORT DESC' }, // 额外请求参数
        data: [], // 表格当前数据
        currentPage: 1, // 当前页码
        pageSize: 15, // 每页条数
        pageTotal: 0 // 总页数
      },
      page: {
        popShow: false
      }
    };
  },

  computed: {},
  methods: {
    // 树节点点击事件
    clickModuleTree: function clickModuleTree(item) {
      var current = this.tree.current;
      if (current.DtCode !== item.DtCode) {
        this.tree.current = item;
        // 重新获取列表数据
        this.getTableData();
      }
    },

    // 页码点击事件
    handleTableCurrentChange: function handleTableCurrentChange(val) {
      this.getTableData(val);
    },

    // 显示add弹出层
    showAddPop: function showAddPop() {
      this.page.popShow = true;
      this.$nextTick(function () {
        this.$refs.popForm.resetValue();
      });
    },

    // 显示修改弹出层
    showUpdatePop: function showUpdatePop(idx, item) {
      this.page.popShow = true;
      this.$nextTick(function () {
        this.$refs.popForm.setValue(item);
      });
    },

    // add操作
    handleAdd: function handleAdd() {
      // 重新获取列表数据
      this.refreshTableData();
      this.page.popShow = false;
    },

    // 修改操作
    handleUpdate: function handleUpdate() {
      // 重新获取列表数据
      this.refreshTableData();
      this.page.popShow = false;
    },

    // 删除操作
    handleDel: function handleDel(idx, item) {
      var _this3 = this;

      this.$confirm('This will permanently delete the record', 'prompt', {
        confirmButtonText: 'Confirm',
        cancelButtonText: 'Canel',
        type: 'warning'
      }).then(function () {
        _this3.delDataAjax(item.Id);
      });
    }
  }
});

/***/ }),
/* 296 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_common_tools__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_cms_DownfileTypeForm__ = __webpack_require__(654);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_cms_DownfileTypeForm___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_cms_DownfileTypeForm__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__libcomponents_copy_btn_copy_btn__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__libcomponents_copy_btn_copy_btn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__libcomponents_copy_btn_copy_btn__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// import $ from 'jquery'
// import mixin from '@/components/common/mixin'




// 表格相关操作
var table = {
  methods: {
    getTableData: __WEBPACK_IMPORTED_MODULE_0__components_common_tools__["a" /* default */].commonTableDateFetch({
      url: '/Ajax/GetDataTypeListInAdmin',
      data: function data() {
        var DtFacode = this.$route.query.code;
        return {
          DtFacode: DtFacode == null ? '0' : DtFacode
        };
      },
      success: function success(response) {
        var result = response.data;
        this.table.data = result;
      }
    }),
    refreshTableData: function refreshTableData() {
      this.getTableData(this.table.currentPage);
    }
  }

  // 路径页面进入数据获取
};var routeDataGet = {
  watch: {
    // 如果路由有变化，会再次执行该方法
    '$route': 'fetchData'
  },
  methods: {
    fetchData: function fetchData() {
      this.getTableData();
    }
  }

  // 请求相关操作
};var page = {
  methods: {
    // 删除操作
    delDataAjax: function delDataAjax(id) {
      var _this = this;

      __WEBPACK_IMPORTED_MODULE_0__components_common_tools__["a" /* default */].commonAjax.call(this, true, '/Ajax/DeleteDataTypeInAdmin', {
        Id: id
      }).then(function () {
        _this.$message.success('delete success!');
        // 重新获取列表数据
        _this.refreshTableData();
      });
    }
  }
};

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'DownfileTypeManagement',
  mixins: [routeDataGet, table, page],
  components: {
    DownfileTypeForm: __WEBPACK_IMPORTED_MODULE_1__components_cms_DownfileTypeForm___default.a, copyBtn: __WEBPACK_IMPORTED_MODULE_2__libcomponents_copy_btn_copy_btn___default.a
  },
  created: function created() {
    this.getTableData();
  },
  data: function data() {
    return {
      table: {
        isLoading: false, // 是否正在加载
        ajaxData: { OrderName: 'DT_SORT DESC' }, // 额外请求参数
        data: [], // 表格当前数据
        currentPage: 1, // 当前页码
        pageSize: 15, // 每页条数
        pageTotal: 0 // 总页数
      },
      page: {
        popShow: false
      }
    };
  },

  computed: {},
  methods: {
    // 页码点击事件
    handleTableCurrentChange: function handleTableCurrentChange(val) {
      this.getTableData(val);
    },

    // 显示add弹出层
    showAddPop: function showAddPop() {
      var DtFacode = this.$route.query.code;
      this.page.popShow = true;
      this.$nextTick(function () {
        this.$refs.popForm.resetValue();
        this.$refs.popForm.setValue({
          DtFacode: DtFacode == null ? '0' : DtFacode
        });
      });
    },

    // 显示修改弹出层
    showUpdatePop: function showUpdatePop(idx, item) {
      this.page.popShow = true;
      this.$nextTick(function () {
        this.$refs.popForm.setValue(item);
      });
    },

    // add操作
    handleAdd: function handleAdd() {
      // 刷新表格数据
      this.refreshTableData();
      this.page.popShow = false;
    },

    // 修改操作
    handleUpdate: function handleUpdate() {
      // 刷新表格数据
      this.refreshTableData();
      this.page.popShow = false;
    },

    // 删除操作
    handleDel: function handleDel(idx, item) {
      var _this2 = this;

      this.$confirm('This will permanently delete the record', 'prompt', {
        confirmButtonText: 'Confirm',
        cancelButtonText: 'Canel',
        type: 'warning'
      }).then(function () {
        _this2.delDataAjax(item.Id);
      });
    },

    // 跳转下一级
    SkipNextGrade: function SkipNextGrade(idx, item) {
      // this.refreshTableData()
      this.$router.push('DownfileTypeManage?code=' + item.DtCode);
    },
    goBack: function goBack() {
      window.history.go(-1);
    }
  }
});

/***/ }),
/* 297 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_common_tools__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_cms_IndexConfigSetForm__ = __webpack_require__(655);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_cms_IndexConfigSetForm___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_cms_IndexConfigSetForm__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// import $ from 'jquery'
// import mixin from '@/components/common/mixin'



// 表格相关操作
var table = {
  methods: {
    getTableData: __WEBPACK_IMPORTED_MODULE_0__components_common_tools__["a" /* default */].commonTableDateFetch({
      url: '/Ajax/GetIndexSettingInAdmin',
      success: function success(response) {
        var result = response.data;
        this.table.data = result;
      }
    }),
    refreshTableData: function refreshTableData() {
      this.getTableData(this.table.currentPage);
    }
  }

  // 请求相关操作
};var page = {
  methods: {
    // 删除操作
    delDataAjax: function delDataAjax(id) {
      var _this = this;

      __WEBPACK_IMPORTED_MODULE_0__components_common_tools__["a" /* default */].commonAjax.call(this, true, '/Ajax/DeleteSinglePageInAdmin', {
        Id: id
      }).then(function () {
        _this.$message.success('delete success!');
        // 重新获取列表数据
        _this.refreshTableData();
      });
    }
  }
};

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'IndexConfigSetting',
  mixins: [table, page],
  components: {
    IndexConfigSetForm: __WEBPACK_IMPORTED_MODULE_1__components_cms_IndexConfigSetForm___default.a
  },
  created: function created() {
    this.getTableData();
  },
  data: function data() {
    return {
      table: {
        isLoading: false, // 是否正在加载
        ajaxData: {}, // 额外请求参数
        data: [], // 表格当前数据
        currentPage: 1, // 当前页码
        pageSize: 15, // 每页条数
        pageTotal: 0 // 总页数
      },
      page: {
        popShow: false
      }
    };
  },

  computed: {},
  methods: {
    // 页码点击事件
    handleTableCurrentChange: function handleTableCurrentChange(val) {
      this.getTableData(val);
    },

    // 显示add弹出层
    showAddPop: function showAddPop() {
      this.page.popShow = true;
      this.$nextTick(function () {
        this.$refs.popForm.resetValue();
      });
    },

    // 显示修改弹出层
    showUpdatePop: function showUpdatePop(idx, item) {
      this.page.popShow = true;
      this.$nextTick(function () {
        this.$refs.popForm.setValue(item);
      });
    },

    // add操作
    handleAdd: function handleAdd() {
      // 刷新表格数据
      this.refreshTableData();
      this.page.popShow = false;
    },

    // 修改操作
    handleUpdate: function handleUpdate() {
      // 刷新表格数据
      this.refreshTableData();
      this.page.popShow = false;
    },

    // 删除操作
    handleDel: function handleDel(idx, item) {
      var _this2 = this;

      this.$confirm('This will permanently delete the record', 'prompt', {
        confirmButtonText: 'Confirm',
        cancelButtonText: 'Canel',
        type: 'warning'
      }).then(function () {
        _this2.delDataAjax(item.Id);
      });
    }
  }
});

/***/ }),
/* 298 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_common_tools__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_cms_NavigateionForm__ = __webpack_require__(656);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_cms_NavigateionForm___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_cms_NavigateionForm__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__libcomponents_copy_btn_copy_btn__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__libcomponents_copy_btn_copy_btn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__libcomponents_copy_btn_copy_btn__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// import $ from 'jquery'
// import mixin from '@/components/common/mixin'




// 表格相关操作
var table = {
  methods: {
    getTableData: __WEBPACK_IMPORTED_MODULE_0__components_common_tools__["a" /* default */].commonTableDateFetch({
      url: '/Ajax/GetNavigationListInAdmin',
      data: function data() {
        var NbFacode = this.$route.query.code;
        return {
          NbFacode: NbFacode == null ? '0' : NbFacode
        };
      },
      success: function success(response) {
        var result = response.data;
        this.table.data = result;
      }
    }),
    refreshTableData: function refreshTableData() {
      this.getTableData(this.table.currentPage);
    }
  }

  // 路径页面进入数据获取
};var routeDataGet = {
  watch: {
    // 如果路由有变化，会再次执行该方法
    '$route': 'fetchData'
  },
  methods: {
    fetchData: function fetchData() {
      this.getTableData();
    }
  }

  // 请求相关操作
};var page = {
  methods: {
    // 删除操作
    delDataAjax: function delDataAjax(id) {
      var _this = this;

      __WEBPACK_IMPORTED_MODULE_0__components_common_tools__["a" /* default */].commonAjax.call(this, true, '/Ajax/DeleteNavigationInAdmin', {
        Id: id
      }).then(function () {
        _this.$message.success('delete success!');
        // 重新获取列表数据
        _this.refreshTableData();
      });
    }
  }
};

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'NavigateionManage',
  mixins: [routeDataGet, table, page],
  components: {
    NavigateionForm: __WEBPACK_IMPORTED_MODULE_1__components_cms_NavigateionForm___default.a, copyBtn: __WEBPACK_IMPORTED_MODULE_2__libcomponents_copy_btn_copy_btn___default.a
  },
  created: function created() {
    this.getTableData();
  },
  data: function data() {
    return {
      table: {
        isLoading: false, // 是否正在加载
        ajaxData: {
          OrderName: 'NB_SORT DESC'
          // NbFacode: this.NbCode
        }, // 额外请求参数
        data: [], // 表格当前数据
        currentPage: 1, // 当前页码
        pageSize: 12, // 每页条数
        pageTotal: 0 // 总页数
      },
      page: {
        popShow: false
      }
    };
  },

  computed: {},
  methods: {
    // 页码点击事件
    handleTableCurrentChange: function handleTableCurrentChange(val) {
      this.getTableData(val);
    },

    // 显示add弹出层
    showAddPop: function showAddPop() {
      var NbFacode = this.$route.query.code;
      this.page.popShow = true;
      this.$nextTick(function () {
        this.$refs.popForm.resetValue();
        this.$refs.popForm.setValue({
          NbFacode: NbFacode == null ? '0' : NbFacode
        });
      });
    },

    // 显示修改弹出层
    showUpdatePop: function showUpdatePop(idx, item) {
      this.page.popShow = true;
      this.$nextTick(function () {
        this.$refs.popForm.setValue(item);
      });
    },

    // add操作
    handleAdd: function handleAdd() {
      // 刷新表格数据
      this.refreshTableData();
      this.page.popShow = false;
    },

    // 修改操作
    handleUpdate: function handleUpdate() {
      // 刷新表格数据
      this.refreshTableData();
      this.page.popShow = false;
    },

    // 删除操作
    handleDel: function handleDel(idx, item) {
      var _this2 = this;

      this.$confirm('This will permanently delete the record', 'prompt', {
        confirmButtonText: 'Confirm',
        cancelButtonText: 'Canel',
        type: 'warning'
      }).then(function () {
        _this2.delDataAjax(item.Id);
      });
    },

    // 跳转下一级
    SkipNextGrade: function SkipNextGrade(idx, item) {
      // this.refreshTableData()
      this.$router.push('NavigateionManage?code=' + item.NbCode);
    },
    goBack: function goBack() {
      window.history.go(-1);
    }
  }
});

/***/ }),
/* 299 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_common_tools__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_cms_NewsForm__ = __webpack_require__(657);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_cms_NewsForm___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_cms_NewsForm__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__libcomponents_copy_btn_copy_btn__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__libcomponents_copy_btn_copy_btn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__libcomponents_copy_btn_copy_btn__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// import $ from 'jquery'
// import mixin from '@/components/common/mixin'




// 表格相关操作
var table = {
  methods: {
    getTableData: __WEBPACK_IMPORTED_MODULE_0__components_common_tools__["a" /* default */].commonTableDateFetch({
      url: '/Ajax/GetNewsInfoListInAdmin',
      data: function data() {
        return {
          NtCode: this.tree.current ? this.tree.current.NtCode : null
        };
      },
      success: function success(response) {
        var result = response.data;
        this.table.data = result;
      }
    }),
    refreshTableData: function refreshTableData() {
      this.getTableData(this.table.currentPage);
    }
  }

  // 请求相关操作
};var page = {
  methods: {
    // 获得分类数据
    getTypeDataAjax: function getTypeDataAjax() {
      var _this = this;

      __WEBPACK_IMPORTED_MODULE_0__components_common_tools__["a" /* default */].commonAjax.call(this, true, '/Ajax/GetNewsTypeListInAdmin', {
        All: 1,
        OrderName: 'NT_SORT DESC'
      }).then(function (res) {
        var result = res.data;
        // this.dataStore.commit(types.UPDATE_MODULE, result)
        if (result[0]) {
          _this.tree.current = result[0];
          // 获得右侧表格数据
          _this.getTableData();
        }
        _this.tree.data = result;
      });
    },

    // 删除操作
    delDataAjax: function delDataAjax(id) {
      var _this2 = this;

      __WEBPACK_IMPORTED_MODULE_0__components_common_tools__["a" /* default */].commonAjax.call(this, true, '/Ajax/DeleteNewsInfoInAdmin', {
        Id: id
      }).then(function () {
        _this2.$message.success('delete success!');
        // 重新获取列表数据
        _this2.refreshTableData();
      });
    }
  }
};

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'NewsManagement',
  mixins: [table, page],
  components: {
    NewsForm: __WEBPACK_IMPORTED_MODULE_1__components_cms_NewsForm___default.a, copyBtn: __WEBPACK_IMPORTED_MODULE_2__libcomponents_copy_btn_copy_btn___default.a
  },
  created: function created() {
    this.getTypeDataAjax();
  },
  data: function data() {
    return {
      tree: {
        data: [],
        current: null,
        prop: {
          label: 'NtName',
          children: 'children'
        }
      },
      table: {
        isLoading: false, // 是否正在加载
        ajaxData: { OrderName: 'NI_SORT DESC' }, // 额外请求参数
        data: [], // 表格当前数据
        currentPage: 1, // 当前页码
        pageSize: 15, // 每页条数
        pageTotal: 0 // 总页数
      },
      page: {
        popShow: false
      }
    };
  },

  computed: {},
  methods: {
    // 树节点点击事件
    clickModuleTree: function clickModuleTree(item) {
      var current = this.tree.current;
      if (current.NtCode !== item.NtCode) {
        this.tree.current = item;
        // 重新获取列表数据
        this.getTableData();
      }
    },

    // 页码点击事件
    handleTableCurrentChange: function handleTableCurrentChange(val) {
      this.getTableData(val);
    },

    // 显示add弹出层
    showAddPop: function showAddPop() {
      this.page.popShow = true;
      this.$nextTick(function () {
        this.$refs.popForm.resetValue();
      });
    },

    // 显示修改弹出层
    showUpdatePop: function showUpdatePop(idx, item) {
      this.page.popShow = true;
      this.$nextTick(function () {
        this.$refs.popForm.setValue(item);
      });
    },

    // add操作
    handleAdd: function handleAdd() {
      // 重新获取列表数据
      this.refreshTableData();
      this.page.popShow = false;
    },

    // 修改操作
    handleUpdate: function handleUpdate() {
      // 重新获取列表数据
      this.refreshTableData();
      this.page.popShow = false;
    },

    // 删除操作
    handleDel: function handleDel(idx, item) {
      var _this3 = this;

      this.$confirm('This will permanently delete the record', 'prompt', {
        confirmButtonText: 'Confirm',
        cancelButtonText: 'Canel',
        type: 'warning'
      }).then(function () {
        _this3.delDataAjax(item.Id);
      });
    }
  }
});

/***/ }),
/* 300 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_common_tools__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_cms_NewsTypeForm__ = __webpack_require__(658);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_cms_NewsTypeForm___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_cms_NewsTypeForm__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__libcomponents_copy_btn_copy_btn__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__libcomponents_copy_btn_copy_btn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__libcomponents_copy_btn_copy_btn__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// import $ from 'jquery'
// import mixin from '@/components/common/mixin'




// 表格相关操作
var table = {
  methods: {
    getTableData: __WEBPACK_IMPORTED_MODULE_0__components_common_tools__["a" /* default */].commonTableDateFetch({
      url: '/Ajax/GetNewsTypeListInAdmin',
      success: function success(response) {
        var result = response.data;
        this.table.data = result;
      }
    }),
    refreshTableData: function refreshTableData() {
      this.getTableData(this.table.currentPage);
    }
  }

  // 请求相关操作
};var page = {
  methods: {
    // 删除操作
    delDataAjax: function delDataAjax(id) {
      var _this = this;

      __WEBPACK_IMPORTED_MODULE_0__components_common_tools__["a" /* default */].commonAjax.call(this, true, '/Ajax/DeleteNewsTypeInAdmin', {
        Id: id
      }).then(function () {
        _this.$message.success('delete success!');
        // 重新获取列表数据
        _this.refreshTableData();
      });
    }
  }
};

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'NewsTypeManagement',
  mixins: [table, page],
  components: {
    NewsTypeForm: __WEBPACK_IMPORTED_MODULE_1__components_cms_NewsTypeForm___default.a, copyBtn: __WEBPACK_IMPORTED_MODULE_2__libcomponents_copy_btn_copy_btn___default.a
  },
  created: function created() {
    this.getTableData();
  },
  data: function data() {
    return {
      table: {
        isLoading: false, // 是否正在加载
        ajaxData: {
          OrderName: 'NT_SORT DESC'
        }, // 额外请求参数
        data: [], // 表格当前数据
        currentPage: 1, // 当前页码
        pageSize: 15, // 每页条数
        pageTotal: 0 // 总页数
      },
      page: {
        popShow: false
      }
    };
  },

  computed: {},
  methods: {
    // 页码点击事件
    handleTableCurrentChange: function handleTableCurrentChange(val) {
      this.getTableData(val);
    },

    // 显示add弹出层
    showAddPop: function showAddPop() {
      this.page.popShow = true;
      this.$nextTick(function () {
        this.$refs.popForm.resetValue();
      });
    },

    // 显示修改弹出层
    showUpdatePop: function showUpdatePop(idx, item) {
      this.page.popShow = true;
      this.$nextTick(function () {
        this.$refs.popForm.setValue(item);
      });
    },

    // add操作
    handleAdd: function handleAdd() {
      // 刷新表格数据
      this.refreshTableData();
      this.page.popShow = false;
    },

    // 修改操作
    handleUpdate: function handleUpdate() {
      // 刷新表格数据
      this.refreshTableData();
      this.page.popShow = false;
    },

    // 删除操作
    handleDel: function handleDel(idx, item) {
      var _this2 = this;

      this.$confirm('This will permanently delete the record', 'prompt', {
        confirmButtonText: 'Confirm',
        cancelButtonText: 'Canel',
        type: 'warning'
      }).then(function () {
        _this2.delDataAjax(item.Id);
      });
    }
  }
});

/***/ }),
/* 301 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_common_tools__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_cms_ProductForm__ = __webpack_require__(659);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_cms_ProductForm___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_cms_ProductForm__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_common_tree__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__libcomponents_copy_btn_copy_btn__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__libcomponents_copy_btn_copy_btn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__libcomponents_copy_btn_copy_btn__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// import $ from 'jquery'
// import mixin from '@/components/common/mixin'





// 侧边树
var sideTree = new __WEBPACK_IMPORTED_MODULE_2__components_common_tree__["a" /* default */].TreeCreate(function (item) {
  for (var key in item) {
    if (item.hasOwnProperty(key)) {
      this[key] = item[key];
    }
  }
}, { FId: 'PtFacode', Id: 'PtCode' });

// 表格相关操作
var table = {
  methods: {
    getTableData: __WEBPACK_IMPORTED_MODULE_0__components_common_tools__["a" /* default */].commonTableDateFetch({
      url: '/Ajax/GetProductInfoListInAdmin',
      data: function data() {
        return {
          PtCode: this.tree.current ? this.tree.current.PtCode : null
        };
      },
      success: function success(response) {
        var result = response.data;
        this.table.data = result;
      }
    }),
    refreshTableData: function refreshTableData() {
      this.getTableData(this.table.currentPage);
    }
  }

  // 请求相关操作
};var page = {
  methods: {
    // 获得分类数据
    getTypeDataAjax: function getTypeDataAjax() {
      var _this = this;

      __WEBPACK_IMPORTED_MODULE_0__components_common_tools__["a" /* default */].commonAjax.call(this, true, '/Ajax/GetProductTypeInAdmin', {
        All: 1,
        OrderName: 'PT_SORT DESC'
      }).then(function (res) {
        var result = res.data;
        // this.dataStore.commit(types.UPDATE_MODULE, result)
        sideTree.create(result);
        var treeData = sideTree.getTreeData();
        if (treeData[0]) {
          _this.tree.current = treeData[0];
          // 获得右侧表格数据
          _this.getTableData();
        }
        _this.tree.data = treeData;
      });
    },

    // 删除操作
    delDataAjax: function delDataAjax(id) {
      var _this2 = this;

      __WEBPACK_IMPORTED_MODULE_0__components_common_tools__["a" /* default */].commonAjax.call(this, true, '/Ajax/DeleteProductInfoInAdmin', {
        Id: id
      }).then(function () {
        _this2.$message.success('delete success!');
        // 重新获取列表数据
        _this2.refreshTableData();
      });
    }
  }
};

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'ProductManagement',
  mixins: [table, page],
  components: {
    ProductForm: __WEBPACK_IMPORTED_MODULE_1__components_cms_ProductForm___default.a, copyBtn: __WEBPACK_IMPORTED_MODULE_3__libcomponents_copy_btn_copy_btn___default.a
  },
  created: function created() {
    this.getTypeDataAjax();
  },
  data: function data() {
    return {
      tree: {
        data: [],
        current: null,
        prop: {
          label: 'PtName',
          children: 'children'
        }
      },
      table: {
        isLoading: false, // 是否正在加载
        ajaxData: { OrderName: 'PI_SORT DESC' }, // 额外请求参数
        data: [], // 表格当前数据
        currentPage: 1, // 当前页码
        pageSize: 15, // 每页条数
        pageTotal: 0 // 总页数
      },
      page: {
        popShow: false
      }
    };
  },

  computed: {},
  methods: {
    // 树节点点击事件
    clickModuleTree: function clickModuleTree(item) {
      var current = this.tree.current;
      if (current.PtCode !== item.PtCode) {
        this.tree.current = item;
        // 重新获取列表数据
        this.getTableData();
      }
    },

    // 页码点击事件
    handleTableCurrentChange: function handleTableCurrentChange(val) {
      this.getTableData(val);
    },

    // 显示add弹出层
    showAddPop: function showAddPop() {
      this.page.popShow = true;
      this.$nextTick(function () {
        this.$refs.popForm.resetValue();
      });
    },

    // 显示修改弹出层
    showUpdatePop: function showUpdatePop(idx, item) {
      this.page.popShow = true;
      this.$nextTick(function () {
        this.$refs.popForm.setValue(item);
      });
    },

    // add操作
    handleAdd: function handleAdd() {
      // 重新获取列表数据
      this.refreshTableData();
      this.page.popShow = false;
    },

    // 修改操作
    handleUpdate: function handleUpdate() {
      // 重新获取列表数据
      this.refreshTableData();
      this.page.popShow = false;
    },

    // 删除操作
    handleDel: function handleDel(idx, item) {
      var _this3 = this;

      this.$confirm('This will permanently delete the record', 'prompt', {
        confirmButtonText: 'Confirm',
        cancelButtonText: 'Canel',
        type: 'warning'
      }).then(function () {
        _this3.delDataAjax(item.Id);
      });
    }
  }
});

/***/ }),
/* 302 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_common_tools__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_cms_QuestionOne__ = __webpack_require__(661);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_cms_QuestionOne___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_cms_QuestionOne__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// import $ from 'jquery'
// import mixin from '@/components/common/mixin'



// 表格相关操作
var table = {
  methods: {
    getTableData: __WEBPACK_IMPORTED_MODULE_0__components_common_tools__["a" /* default */].commonTableDateFetch({
      url: '/Ajax/GetProductQuestionListInAdmin',
      success: function success(response) {
        var result = response.data;
        this.table.data = result;
      }
    }),
    refreshTableData: function refreshTableData() {
      this.getTableData(this.table.currentPage);
    }
  }

  // 请求相关操作
};var page = {
  methods: {
    // 删除操作
    delDataAjax: function delDataAjax(id) {
      var _this = this;

      __WEBPACK_IMPORTED_MODULE_0__components_common_tools__["a" /* default */].commonAjax.call(this, true, '/Ajax/DeleteProductQuestionInAdmin', {
        Id: id
      }).then(function () {
        _this.$message.success('delete success!');
        // 重新获取列表数据
        _this.refreshTableData();
      });
    }
  }
};

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'ProductQuestionManage',
  mixins: [table, page],
  components: {
    QuestionOne: __WEBPACK_IMPORTED_MODULE_1__components_cms_QuestionOne___default.a
  },
  created: function created() {
    this.getTableData();
  },
  data: function data() {
    return {
      table: {
        isLoading: false, // 是否正在加载
        ajaxData: {}, // 额外请求参数
        data: [], // 表格当前数据
        currentPage: 1, // 当前页码
        pageSize: 15, // 每页条数
        pageTotal: 0 // 总页数
      },
      page: {
        popShow: false
      }
    };
  },

  computed: {},
  methods: {
    // 页码点击事件
    handleTableCurrentChange: function handleTableCurrentChange(val) {
      this.getTableData(val);
    },

    // 显示修改弹出层
    showUpdatePop: function showUpdatePop(idx, item) {
      this.page.popShow = true;
      this.$nextTick(function () {
        this.$refs.popForm.setValue(item);
      });
    },

    // 修改操作
    handleUpdate: function handleUpdate() {
      // 刷新表格数据
      this.refreshTableData();
      this.page.popShow = false;
    },

    // 删除操作
    handleDel: function handleDel(idx, item) {
      var _this2 = this;

      this.$confirm('This will permanently delete the record', 'prompt', {
        confirmButtonText: 'Confirm',
        cancelButtonText: 'Canel',
        type: 'warning'
      }).then(function () {
        _this2.delDataAjax(item.Id);
      });
    }
  }
});

/***/ }),
/* 303 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_common_tools__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_cms_ProductTypeForm__ = __webpack_require__(660);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_cms_ProductTypeForm___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_cms_ProductTypeForm__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__libcomponents_copy_btn_copy_btn__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__libcomponents_copy_btn_copy_btn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__libcomponents_copy_btn_copy_btn__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// import $ from 'jquery'
// import mixin from '@/components/common/mixin'




// 表格相关操作
var table = {
  methods: {
    getTableData: __WEBPACK_IMPORTED_MODULE_0__components_common_tools__["a" /* default */].commonTableDateFetch({
      url: '/Ajax/GetProductTypeInAdmin',
      data: function data() {
        var PtFacode = this.$route.query.code;
        return {
          PtFacode: PtFacode == null ? '0' : PtFacode
        };
      },
      success: function success(response) {
        var result = response.data;
        this.table.data = result;
      }
    }),
    refreshTableData: function refreshTableData() {
      this.getTableData(this.table.currentPage);
    }
  }

  // 路径页面进入数据获取
};var routeDataGet = {
  watch: {
    // 如果路由有变化，会再次执行该方法
    '$route': 'fetchData'
  },
  methods: {
    fetchData: function fetchData() {
      this.getTableData();
    }
  }

  // 请求相关操作
};var page = {
  methods: {
    // 删除操作
    delDataAjax: function delDataAjax(id) {
      var _this = this;

      __WEBPACK_IMPORTED_MODULE_0__components_common_tools__["a" /* default */].commonAjax.call(this, true, '/Ajax/DeleteProductTypeInAdmin', {
        Id: id
      }).then(function () {
        _this.$message.success('delete success!');
        // 重新获取列表数据
        _this.refreshTableData();
      });
    }
  }
};

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'ProductTypeManagement',
  mixins: [routeDataGet, table, page],
  components: {
    ProductTypeForm: __WEBPACK_IMPORTED_MODULE_1__components_cms_ProductTypeForm___default.a, copyBtn: __WEBPACK_IMPORTED_MODULE_2__libcomponents_copy_btn_copy_btn___default.a
  },
  created: function created() {
    this.getTableData();
  },
  data: function data() {
    return {
      table: {
        isLoading: false, // 是否正在加载
        ajaxData: {
          OrderName: 'PT_SORT DESC'
        }, // 额外请求参数
        data: [], // 表格当前数据
        currentPage: 1, // 当前页码
        pageSize: 15, // 每页条数
        pageTotal: 0 // 总页数
      },
      page: {
        popShow: false
      }
    };
  },

  computed: {},
  methods: {
    // 页码点击事件
    handleTableCurrentChange: function handleTableCurrentChange(val) {
      this.getTableData(val);
    },

    // 显示add弹出层
    showAddPop: function showAddPop() {
      var PtFacode = this.$route.query.code;
      this.page.popShow = true;
      this.$nextTick(function () {
        this.$refs.popForm.resetValue();
        this.$refs.popForm.setValue({
          PtFacode: PtFacode == null ? '0' : PtFacode
        });
      });
    },

    // 显示修改弹出层
    showUpdatePop: function showUpdatePop(idx, item) {
      this.page.popShow = true;
      this.$nextTick(function () {
        this.$refs.popForm.setValue(item);
      });
    },

    // add操作
    handleAdd: function handleAdd() {
      // 刷新表格数据
      this.refreshTableData();
      this.page.popShow = false;
    },

    // 修改操作
    handleUpdate: function handleUpdate() {
      // 刷新表格数据
      this.refreshTableData();
      this.page.popShow = false;
    },

    // 删除操作
    handleDel: function handleDel(idx, item) {
      var _this2 = this;

      this.$confirm('This will permanently delete the record', 'prompt', {
        confirmButtonText: 'Confirm',
        cancelButtonText: 'Canel',
        type: 'warning'
      }).then(function () {
        _this2.delDataAjax(item.Id);
      });
    },

    // 跳转下一级
    SkipNextGrade: function SkipNextGrade(idx, item) {
      // this.refreshTableData()
      this.$router.push('ProductTypeManage?code=' + item.PtCode);
    },
    goBack: function goBack() {
      window.history.go(-1);
    }
  }
});

/***/ }),
/* 304 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_common_tools__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_cms_SinglePageForm__ = __webpack_require__(662);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_cms_SinglePageForm___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_cms_SinglePageForm__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__libcomponents_copy_btn_copy_btn__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__libcomponents_copy_btn_copy_btn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__libcomponents_copy_btn_copy_btn__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// import $ from 'jquery'
// import mixin from '@/components/common/mixin'




// 表格相关操作
var table = {
  methods: {
    getTableData: __WEBPACK_IMPORTED_MODULE_0__components_common_tools__["a" /* default */].commonTableDateFetch({
      url: '/Ajax/GetSinglePageListInAdmin',
      success: function success(response) {
        var result = response.data;
        this.table.data = result;
      }
    }),
    refreshTableData: function refreshTableData() {
      this.getTableData(this.table.currentPage);
    }
  }

  // 请求相关操作
};var page = {
  methods: {
    // 删除操作
    delDataAjax: function delDataAjax(id) {
      var _this = this;

      __WEBPACK_IMPORTED_MODULE_0__components_common_tools__["a" /* default */].commonAjax.call(this, true, '/Ajax/DeleteSinglePageInAdmin', {
        Id: id
      }).then(function () {
        _this.$message.success('delete success!');
        // 重新获取列表数据
        _this.refreshTableData();
      });
    }
  }
};

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'SinglePageManage',
  mixins: [table, page],
  components: {
    SinglePageForm: __WEBPACK_IMPORTED_MODULE_1__components_cms_SinglePageForm___default.a, copyBtn: __WEBPACK_IMPORTED_MODULE_2__libcomponents_copy_btn_copy_btn___default.a
  },
  created: function created() {
    this.getTableData();
  },
  data: function data() {
    return {
      table: {
        isLoading: false, // 是否正在加载
        ajaxData: {}, // 额外请求参数
        data: [], // 表格当前数据
        currentPage: 1, // 当前页码
        pageSize: 15, // 每页条数
        pageTotal: 0 // 总页数
      },
      page: {
        popShow: false
      }
    };
  },

  computed: {},
  methods: {
    // 页码点击事件
    handleTableCurrentChange: function handleTableCurrentChange(val) {
      this.getTableData(val);
    },

    // 显示add弹出层
    showAddPop: function showAddPop() {
      this.page.popShow = true;
      this.$nextTick(function () {
        this.$refs.popForm.resetValue();
      });
    },

    // 显示修改弹出层
    showUpdatePop: function showUpdatePop(idx, item) {
      this.page.popShow = true;
      this.$nextTick(function () {
        this.$refs.popForm.setValue(item);
      });
    },

    // add操作
    handleAdd: function handleAdd() {
      // 刷新表格数据
      this.refreshTableData();
      this.page.popShow = false;
    },

    // 修改操作
    handleUpdate: function handleUpdate() {
      // 刷新表格数据
      this.refreshTableData();
      this.page.popShow = false;
    },

    // 删除操作
    handleDel: function handleDel(idx, item) {
      var _this2 = this;

      this.$confirm('This will permanently delete the record', 'prompt', {
        confirmButtonText: 'Confirm',
        cancelButtonText: 'Canel',
        type: 'warning'
      }).then(function () {
        _this2.delDataAjax(item.Id);
      });
    }
  }
});

/***/ }),
/* 305 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_common_tools__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_cms_VideoForm__ = __webpack_require__(665);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_cms_VideoForm___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_cms_VideoForm__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// import $ from 'jquery'
// import mixin from '@/components/common/mixin'



// 表格相关操作
var table = {
  methods: {
    getTableData: __WEBPACK_IMPORTED_MODULE_0__components_common_tools__["a" /* default */].commonTableDateFetch({
      url: '/Ajax/GetVideoListInAdmin',
      success: function success(response) {
        var result = response.data;
        this.table.data = result;
      }
    }),
    refreshTableData: function refreshTableData() {
      this.getTableData(this.table.currentPage);
    }
  }

  // 请求相关操作
};var page = {
  methods: {
    // 删除操作
    delDataAjax: function delDataAjax(id) {
      var _this = this;

      __WEBPACK_IMPORTED_MODULE_0__components_common_tools__["a" /* default */].commonAjax.call(this, true, '/Ajax/DeleteVideoInAdmin', {
        Id: id
      }).then(function () {
        _this.$message.success('delete success!');
        // 重新获取列表数据
        _this.refreshTableData();
      });
    }
  }
};

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'VideoManagement',
  mixins: [table, page],
  components: {
    VideoForm: __WEBPACK_IMPORTED_MODULE_1__components_cms_VideoForm___default.a
  },
  created: function created() {
    this.getTableData();
  },
  data: function data() {
    return {
      table: {
        isLoading: false, // 是否正在加载
        ajaxData: {}, // 额外请求参数
        data: [], // 表格当前数据
        currentPage: 1, // 当前页码
        pageSize: 15, // 每页条数
        pageTotal: 0 // 总页数
      },
      page: {
        popShow: false
      }
    };
  },

  computed: {},
  methods: {
    // 页码点击事件
    handleTableCurrentChange: function handleTableCurrentChange(val) {
      this.getTableData(val);
    },

    // 显示add弹出层
    showAddPop: function showAddPop() {
      this.page.popShow = true;
      this.$nextTick(function () {
        this.$refs.popForm.resetValue();
      });
    },

    // 显示修改弹出层
    showUpdatePop: function showUpdatePop(idx, item) {
      this.page.popShow = true;
      this.$nextTick(function () {
        this.$refs.popForm.setValue(item);
      });
    },

    // add操作
    handleAdd: function handleAdd() {
      // 刷新表格数据
      this.refreshTableData();
      this.page.popShow = false;
    },

    // 修改操作
    handleUpdate: function handleUpdate() {
      // 刷新表格数据
      this.refreshTableData();
      this.page.popShow = false;
    },

    // 删除操作
    handleDel: function handleDel(idx, item) {
      var _this2 = this;

      this.$confirm('This will permanently delete the record', 'prompt', {
        confirmButtonText: 'Confirm',
        cancelButtonText: 'Canel',
        type: 'warning'
      }).then(function () {
        _this2.delDataAjax(item.Id);
      });
    }
  }
});

/***/ }),
/* 306 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_common_tools__ = __webpack_require__(2);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



// 请求相关操作
var page = {
  methods: {
    // 修改操作
    updateDataAjax: function updateDataAjax(id, state) {
      var _this = this;

      var data = __WEBPACK_IMPORTED_MODULE_0__components_common_tools__["a" /* default */].getModel(this.formData);
      __WEBPACK_IMPORTED_MODULE_0__components_common_tools__["a" /* default */].commonAjax.call(this, true, '/SystemManage/UpdateAdminuser', data).then(function () {
        _this.$message.success('Operate success!');
        // 重新获取登录用户信息
        _this.$store.dispatch('getLoginMemberInfo', false);
      });
    }
  }
};

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'AdminUserInfo',
  mixins: [page],
  created: function created() {
    this.formData = __WEBPACK_IMPORTED_MODULE_0__components_common_tools__["a" /* default */].getModel(this.$store.state.user.memberInfo);
  },
  data: function data() {
    return {
      formData: null
    };
  },

  methods: {
    // 修改
    doUpdate: function doUpdate(formName) {
      var _this2 = this;

      this.$refs[formName].validate(function (valid) {
        if (valid) {
          _this2.updateDataAjax();
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    }
  }
});

/***/ }),
/* 307 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_common_tools__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_common_user__ = __webpack_require__(80);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




// 请求相关操作
var page = {
  methods: {
    // 用户登录
    userLoginAjax: function userLoginAjax() {
      var _this = this;

      __WEBPACK_IMPORTED_MODULE_0__components_common_tools__["a" /* default */].commonAjax.call(this, 0, '/Login/AdminLoginInWeb', {
        username: this.username,
        password: this.password
      }).then(function (res) {
        __WEBPACK_IMPORTED_MODULE_1__components_common_user__["a" /* default */].setMemberToken(res.description);
        _this.$router.push('/Welcome');
      });
    }
  }
};

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Login',
  mixins: [page],
  mounted: function mounted() {
    this.initBg();
  },

  components: {},
  data: function data() {
    return {
      username: '',
      password: ''
    };
  },

  methods: {
    doLogin: function doLogin() {
      this.userLoginAjax();
    },
    initBg: function initBg() {
      window.particlesJS('particles_bg', {
        'particles': {
          'number': {
            'value': 100,
            'density': {
              'enable': true,
              'value_area': 1000
            }
          },
          'color': {
            'value': ['#aa73ff', '#f8c210', '#83d238', '#33b1f8']
          },

          'shape': {
            'type': 'circle',
            'stroke': {
              'width': 0,
              'color': '#fff'
            },
            'polygon': {
              'nb_sides': 5
            },
            'image': {
              'src': 'img/github.svg',
              'width': 100,
              'height': 100
            }
          },
          'opacity': {
            'value': 0.6,
            'random': false,
            'anim': {
              'enable': false,
              'speed': 1,
              'opacity_min': 0.1,
              'sync': false
            }
          },
          'size': {
            'value': 2,
            'random': true,
            'anim': {
              'enable': false,
              'speed': 40,
              'size_min': 0.1,
              'sync': false
            }
          },
          'line_linked': {
            'enable': true,
            'distance': 120,
            'color': '#ffffff',
            'opacity': 0.4,
            'width': 1
          }
        },
        'interactivity': {
          'detect_on': 'canvas',
          'events': {
            'onhover': {
              'enable': true,
              'mode': 'grab'
            },
            'onclick': {
              'enable': false
            },
            'resize': true
          },
          'modes': {
            'grab': {
              'distance': 140,
              'line_linked': {
                'opacity': 1
              }
            },
            'bubble': {
              'distance': 400,
              'size': 40,
              'duration': 2,
              'opacity': 8,
              'speed': 3
            },
            'repulse': {
              'distance': 200,
              'duration': 0.4
            },
            'push': {
              'particles_nb': 4
            },
            'remove': {
              'particles_nb': 2
            }
          }
        },
        'retina_detect': true
      });
    }
  }
});

/***/ }),
/* 308 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_TopBar__ = __webpack_require__(650);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_TopBar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_TopBar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_SideBar__ = __webpack_require__(649);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_SideBar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_SideBar__);
//
//
//
//
//
//
//
//
//
//
//
//
//





var $body = __WEBPACK_IMPORTED_MODULE_0_jquery___default()('body');

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Main',
  components: {
    topBar: __WEBPACK_IMPORTED_MODULE_1__components_TopBar___default.a, sideBar: __WEBPACK_IMPORTED_MODULE_2__components_SideBar___default.a
  },
  data: function data() {
    return {
      sidebarCollapsed: false,
      activeNavIdx: 0
      // sideMenuData: [{
      //   text: '工程信息',
      //   href: '/ProjectInfo'
      // }, {
      //   text: '工程调试',
      //   href: '/ProjectDebug'
      // }, {
      //   text: '打印设置',
      //   href: '/PrintSetting'
      // }]
      //   sideMenuData: [{
      //   text: '工程信息',
      //   href: '/ProjectInfo'
      // }, {
      //   text: '基础数据录入',
      //   href: '/BasicDataEntry2'
      // }, {
      //   text: '收入表',
      //   href: '/Driver',
      //   children: [{
      //     text: '测试1',
      //     href: '/ProjectInfo'
      //   }, {
      //     text: '测试2',
      //     href: '/BasicDataEntry'
      //   }]
      // }, {
      //   text: '测试菜单2',
      //   href: '/test2',
      //   children: [{
      //     text: '测试2-1',
      //     href: '/test2-1'
      //   }, {
      //     text: '测试2-2',
      //     href: '/test2-2'
      //   }]
      // }, {
      //   text: '测试菜单3',
      //   href: '/test3',
      //   children: [{
      //     text: '测试3-1',
      //     href: '/test3-1'
      //   }, {
      //     text: '测试3-2',
      //     href: '/test3-2'
      //   }]
      // }, {
      //   text: '测试菜单4',
      //   href: '/test4',
      //   children: [{
      //     text: '测试4-1',
      //     href: '/test4-1'
      //   }, {
      //     text: '测试4-2',
      //     href: '/test4-2'
      //   }, {
      //     text: '测试4-3',
      //     href: '/test4-3'
      //   }]
      // }, {
      //   text: '成本表',
      //   href: '/Driver'
      // }]
    };
  },

  methods: {
    toggleSideBar: function toggleSideBar() {
      if (this.sidebarCollapsed) {
        this.sidebarCollapsed = false;
        $body.removeClass('collapsed');
      } else {
        this.sidebarCollapsed = true;
        $body.addClass('collapsed');
      }
    }
  }
});

/***/ }),
/* 309 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_common_tools__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_other_WelcomeForm__ = __webpack_require__(671);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_other_WelcomeForm___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_other_WelcomeForm__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// import tools from '@/components/common/tools'



// 请求相关操作
var page = {
  methods: {
    getDataAjax: function getDataAjax() {
      var _this = this;

      __WEBPACK_IMPORTED_MODULE_0__components_common_tools__["a" /* default */].commonAjax.call(this, true, '/Ajax/GetConfigInfoInCommon', {}).then(function (res) {
        _this.$refs.popForm.setValue(res.data);
      });
    }
  }
};

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Welcome',
  mixins: [page],
  components: {
    WelcomeForm: __WEBPACK_IMPORTED_MODULE_1__components_other_WelcomeForm___default.a
  },
  mounted: function mounted() {},
  created: function created() {
    this.getDataAjax();
  },
  data: function data() {
    return {};
  },

  computed: {
    // 导航菜单
    menuNav: function menuNav() {
      return this.$store.getters.quickNavModuleData;
    }
  },
  methods: {
    // 修改操作
    handleUpdate: function handleUpdate() {
      // 刷新表格数据
      this.getDataAjax();
    }
  }
});

/***/ }),
/* 310 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_common_tools__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_config_BannerForm__ = __webpack_require__(211);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_config_BannerForm___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_config_BannerForm__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// import $ from 'jquery'
// import mixin from '@/components/common/mixin'



// 表格相关操作
var table = {
  methods: {
    getTableData: __WEBPACK_IMPORTED_MODULE_0__components_common_tools__["a" /* default */].commonTableDateFetch({
      url: '/Ajax/GetBannerListInAdmin',
      success: function success(response) {
        var result = response.data;
        this.table.data = result;
      }
    }),
    refreshTableData: function refreshTableData() {
      this.getTableData(this.table.currentPage);
    }
  }

  // 请求相关操作
};var page = {
  methods: {
    // 删除操作
    delDataAjax: function delDataAjax(id) {
      var _this = this;

      __WEBPACK_IMPORTED_MODULE_0__components_common_tools__["a" /* default */].commonAjax.call(this, true, '/Ajax/DeleteBannerInAdmin', {
        Id: id
      }).then(function () {
        _this.$message.success('delete success!');
        // 重新获取列表数据
        _this.refreshTableData();
      });
    }
  }
};

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'BannerManagement',
  mixins: [table, page],
  components: {
    BannerForm: __WEBPACK_IMPORTED_MODULE_1__components_config_BannerForm___default.a
  },
  created: function created() {
    this.getTableData();
  },
  data: function data() {
    return {
      table: {
        isLoading: false, // 是否正在加载
        ajaxData: {}, // 额外请求参数
        data: [], // 表格当前数据
        currentPage: 1, // 当前页码
        pageSize: 15, // 每页条数
        pageTotal: 0 // 总页数
      },
      page: {
        popShow: false
      }
    };
  },

  computed: {},
  methods: {
    // 页码点击事件
    handleTableCurrentChange: function handleTableCurrentChange(val) {
      this.getTableData(val);
    },

    // 显示add弹出层
    showAddPop: function showAddPop() {
      this.page.popShow = true;
      this.$nextTick(function () {
        this.$refs.popForm.resetValue();
      });
    },

    // 显示修改弹出层
    showUpdatePop: function showUpdatePop(idx, item) {
      this.page.popShow = true;
      this.$nextTick(function () {
        this.$refs.popForm.setValue(item);
      });
    },

    // add操作
    handleAdd: function handleAdd() {
      // 刷新表格数据
      this.refreshTableData();
      this.page.popShow = false;
    },

    // 修改操作
    handleUpdate: function handleUpdate() {
      // 刷新表格数据
      this.refreshTableData();
      this.page.popShow = false;
    },

    // 删除操作
    handleDel: function handleDel(idx, item) {
      var _this2 = this;

      this.$confirm('This will permanently delete the record', 'prompt', {
        confirmButtonText: 'Confirm',
        cancelButtonText: 'Canel',
        type: 'warning'
      }).then(function () {
        _this2.delDataAjax(item.Id);
      });
    }
  }
});

/***/ }),
/* 311 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_common_tools__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_config_ConfigForm__ = __webpack_require__(666);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_config_ConfigForm___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_config_ConfigForm__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// import $ from 'jquery'
// import mixin from '@/components/common/mixin'



// 请求相关操作
var page = {
  methods: {
    getDataAjax: function getDataAjax() {
      var _this = this;

      __WEBPACK_IMPORTED_MODULE_0__components_common_tools__["a" /* default */].commonAjax.call(this, true, '/Ajax/GetConfigInfoInCommon', {}).then(function (res) {
        _this.$refs.popForm.setValue(res.data);
      });
    }
  }
};

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'ConfigManagement',
  mixins: [page],
  components: {
    ConfigForm: __WEBPACK_IMPORTED_MODULE_1__components_config_ConfigForm___default.a
  },
  created: function created() {
    this.getDataAjax();
  },
  data: function data() {
    return {};
  },

  computed: {},
  methods: {
    // 修改操作
    handleUpdate: function handleUpdate() {
      // 刷新表格数据
      this.getDataAjax();
    }
  }
});

/***/ }),
/* 312 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_common_tools__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_config_ContactForm__ = __webpack_require__(667);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_config_ContactForm___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_config_ContactForm__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// import $ from 'jquery'
// import mixin from '@/components/common/mixin'



// 请求相关操作
var page = {
  methods: {
    // 获取数据操作
    GetDataAjax: function GetDataAjax() {
      var _this = this;

      __WEBPACK_IMPORTED_MODULE_0__components_common_tools__["a" /* default */].commonAjax.call(this, true, '/Ajax/GetCompanyAddressListInAdmin', {
        All: 1,
        OrderName: 'CA_SORT DESC'
      }).then(function (response) {
        var result = response.data;
        _this.table.data = result;
      });
    }
  }
};

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'ContactManagement',
  mixins: [page],
  components: {
    ContactForm: __WEBPACK_IMPORTED_MODULE_1__components_config_ContactForm___default.a
  },
  created: function created() {
    this.GetDataAjax();
  },
  data: function data() {
    return {
      table: {
        isLoading: false, // 是否正在加载
        ajaxData: {}, // 额外请求参数
        data: [], // 表格当前数据
        currentPage: 1, // 当前页码
        pageSize: 15, // 每页条数
        pageTotal: 0 // 总页数
      },
      page: {
        popShow: false
      }
    };
  },

  computed: {},
  methods: {
    // 显示修改弹出层
    showUpdatePop: function showUpdatePop(idx, item) {
      this.page.popShow = true;
      this.$nextTick(function () {
        this.$refs.popForm.setValue(item);
      });
    },

    // 修改操作
    handleUpdate: function handleUpdate() {
      // 刷新表格数据
      this.GetDataAjax();
      this.page.popShow = false;
    }
  }
});

/***/ }),
/* 313 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_common_tools__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_config_ProductionBaseForm__ = __webpack_require__(668);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_config_ProductionBaseForm___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_config_ProductionBaseForm__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// import $ from 'jquery'
// import mixin from '@/components/common/mixin'



// 表格相关操作
var table = {
  methods: {
    getTableData: __WEBPACK_IMPORTED_MODULE_0__components_common_tools__["a" /* default */].commonTableDateFetch({
      url: '/Ajax/GetProductionBaseListInAdmin',
      success: function success(response) {
        var result = response.data;
        this.table.data = result;
      }
    }),
    refreshTableData: function refreshTableData() {
      this.getTableData(this.table.currentPage);
    }
  }

  // 请求相关操作
};var page = {
  methods: {
    // 删除操作
    delDataAjax: function delDataAjax(id) {
      var _this = this;

      __WEBPACK_IMPORTED_MODULE_0__components_common_tools__["a" /* default */].commonAjax.call(this, true, '/Ajax/DeleteProductionBaseInAdmin', {
        Id: id,
        OrderName: 'PB_SORT DESC'
      }).then(function () {
        _this.$message.success('delete success!');
        // 重新获取列表数据
        _this.refreshTableData();
      });
    }
  }
};

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'ProductionBaseManage',
  mixins: [table, page],
  components: {
    ProductionBaseForm: __WEBPACK_IMPORTED_MODULE_1__components_config_ProductionBaseForm___default.a
  },
  created: function created() {
    this.getTableData();
  },
  data: function data() {
    return {
      table: {
        isLoading: false, // 是否正在加载
        ajaxData: {}, // 额外请求参数
        data: [], // 表格当前数据
        currentPage: 1, // 当前页码
        pageSize: 15, // 每页条数
        pageTotal: 0 // 总页数
      },
      page: {
        popShow: false
      }
    };
  },

  computed: {},
  methods: {
    // 页码点击事件
    handleTableCurrentChange: function handleTableCurrentChange(val) {
      this.getTableData(val);
    },

    // 显示add弹出层
    showAddPop: function showAddPop() {
      this.page.popShow = true;
      this.$nextTick(function () {
        this.$refs.popForm.resetValue();
      });
    },

    // 显示修改弹出层
    showUpdatePop: function showUpdatePop(idx, item) {
      this.page.popShow = true;
      this.$nextTick(function () {
        this.$refs.popForm.setValue(item);
      });
    },

    // add操作
    handleAdd: function handleAdd() {
      // 刷新表格数据
      this.refreshTableData();
      this.page.popShow = false;
    },

    // 修改操作
    handleUpdate: function handleUpdate() {
      // 刷新表格数据
      this.refreshTableData();
      this.page.popShow = false;
    },

    // 删除操作
    handleDel: function handleDel(idx, item) {
      var _this2 = this;

      this.$confirm('This will permanently delete the record', 'prompt', {
        confirmButtonText: 'Confirm',
        cancelButtonText: 'Canel',
        type: 'warning'
      }).then(function () {
        _this2.delDataAjax(item.Id);
      });
    }
  }
});

/***/ }),
/* 314 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_common_tools__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_other_CooperativeForm__ = __webpack_require__(669);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_other_CooperativeForm___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_other_CooperativeForm__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// import $ from 'jquery'
// import mixin from '@/components/common/mixin'



// 表格相关操作
var table = {
  methods: {
    getTableData: __WEBPACK_IMPORTED_MODULE_0__components_common_tools__["a" /* default */].commonTableDateFetch({
      url: '/Ajax/GetCooperativePartnerListListInAdmin',
      success: function success(response) {
        var result = response.data;
        this.table.data = result;
      }
    }),
    refreshTableData: function refreshTableData() {
      this.getTableData(this.table.currentPage);
    }
  }

  // 请求相关操作
};var page = {
  methods: {
    // 删除操作
    delDataAjax: function delDataAjax(id) {
      var _this = this;

      __WEBPACK_IMPORTED_MODULE_0__components_common_tools__["a" /* default */].commonAjax.call(this, true, '/Ajax/DeleteCooperativePartnerListInAdmin', {
        Id: id
      }).then(function () {
        _this.$message.success('delete success!');
        // 重新获取列表数据
        _this.refreshTableData();
      });
    }
  }
};

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'CooperativeManagement',
  mixins: [table, page],
  components: {
    CooperativeForm: __WEBPACK_IMPORTED_MODULE_1__components_other_CooperativeForm___default.a
  },
  created: function created() {
    this.getTableData();
  },
  data: function data() {
    return {
      table: {
        isLoading: false, // 是否正在加载
        ajaxData: {}, // 额外请求参数
        data: [], // 表格当前数据
        currentPage: 1, // 当前页码
        pageSize: 15, // 每页条数
        pageTotal: 0 // 总页数
      },
      page: {
        popShow: false
      }
    };
  },

  computed: {},
  methods: {
    // 页码点击事件
    handleTableCurrentChange: function handleTableCurrentChange(val) {
      this.getTableData(val);
    },

    // 显示add弹出层
    showAddPop: function showAddPop() {
      this.page.popShow = true;
      this.$nextTick(function () {
        this.$refs.popForm.resetValue();
      });
    },

    // 显示修改弹出层
    showUpdatePop: function showUpdatePop(idx, item) {
      this.page.popShow = true;
      this.$nextTick(function () {
        this.$refs.popForm.setValue(item);
      });
    },

    // add操作
    handleAdd: function handleAdd() {
      // 刷新表格数据
      this.refreshTableData();
      this.page.popShow = false;
    },

    // 修改操作
    handleUpdate: function handleUpdate() {
      // 刷新表格数据
      this.refreshTableData();
      this.page.popShow = false;
    },

    // 删除操作
    handleDel: function handleDel(idx, item) {
      var _this2 = this;

      this.$confirm('This will permanently delete the record', 'prompt', {
        confirmButtonText: 'Confirm',
        cancelButtonText: 'Canel',
        type: 'warning'
      }).then(function () {
        _this2.delDataAjax(item.Id);
      });
    }
  }
});

/***/ }),
/* 315 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_common_tools__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_config_BannerForm__ = __webpack_require__(211);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_config_BannerForm___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_config_BannerForm__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// import $ from 'jquery'
// import mixin from '@/components/common/mixin'



// 表格相关操作
var table = {
  methods: {
    getTableData: __WEBPACK_IMPORTED_MODULE_0__components_common_tools__["a" /* default */].commonTableDateFetch({
      url: '/Ajax/GetMemberLeaveFeedbackInAdmin',
      success: function success(response) {
        var result = response.data;
        this.table.data = result;
      }
    }),
    refreshTableData: function refreshTableData() {
      this.getTableData(this.table.currentPage);
    }
  }

  // 请求相关操作
};var page = {
  methods: {
    // 删除操作
    delDataAjax: function delDataAjax(id) {
      var _this = this;

      __WEBPACK_IMPORTED_MODULE_0__components_common_tools__["a" /* default */].commonAjax.call(this, true, '/Ajax/DeleteMemberLeaveFeedbackInAdmin', {
        Id: id
      }).then(function () {
        _this.$message.success('delete success!');
        // 重新获取列表数据
        _this.refreshTableData();
      });
    }
  }
};

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'MemberLeaveMessage',
  mixins: [table, page],
  components: {
    BannerForm: __WEBPACK_IMPORTED_MODULE_1__components_config_BannerForm___default.a
  },
  created: function created() {
    this.getTableData();
  },
  data: function data() {
    return {
      table: {
        isLoading: false, // 是否正在加载
        ajaxData: {}, // 额外请求参数
        data: [], // 表格当前数据
        currentPage: 1, // 当前页码
        pageSize: 15, // 每页条数
        pageTotal: 0 // 总页数
      },
      page: {
        popShow: false
      }
    };
  },

  computed: {},
  methods: {
    // 页码点击事件
    handleTableCurrentChange: function handleTableCurrentChange(val) {
      this.getTableData(val);
    },

    // 显示add弹出层
    showAddPop: function showAddPop() {
      this.page.popShow = true;
      this.$nextTick(function () {
        this.$refs.popForm.resetValue();
      });
    },

    // 显示修改弹出层
    showUpdatePop: function showUpdatePop(idx, item) {
      this.page.popShow = true;
      this.$nextTick(function () {
        this.$refs.popForm.setValue(item);
      });
    },

    // add操作
    handleAdd: function handleAdd() {
      // 刷新表格数据
      this.refreshTableData();
      this.page.popShow = false;
    },

    // 修改操作
    handleUpdate: function handleUpdate() {
      // 刷新表格数据
      this.refreshTableData();
      this.page.popShow = false;
    },

    // 删除操作
    handleDel: function handleDel(idx, item) {
      var _this2 = this;

      this.$confirm('This will permanently delete the record', 'prompt', {
        confirmButtonText: 'Confirm',
        cancelButtonText: 'Canel',
        type: 'warning'
      }).then(function () {
        _this2.delDataAjax(item.Id);
      });
    }
  }
});

/***/ }),
/* 316 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_common_tools__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_other_ProblemFeedBackForm__ = __webpack_require__(670);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_other_ProblemFeedBackForm___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_other_ProblemFeedBackForm__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// import $ from 'jquery'
// import mixin from '@/components/common/mixin'



// 表格相关操作
var table = {
  methods: {
    getTableData: __WEBPACK_IMPORTED_MODULE_0__components_common_tools__["a" /* default */].commonTableDateFetch({
      url: '/Ajax/GetProblemFeedbackListInAdmin',
      success: function success(response) {
        var result = response.data;
        this.table.data = result;
      }
    }),
    refreshTableData: function refreshTableData() {
      this.getTableData(this.table.currentPage);
    }
  }

  // 请求相关操作
};var page = {
  methods: {
    // 删除操作
    delDataAjax: function delDataAjax(id) {
      var _this = this;

      __WEBPACK_IMPORTED_MODULE_0__components_common_tools__["a" /* default */].commonAjax.call(this, true, '/Ajax/DeleteProblemFeedbackInAdmin', {
        Id: id,
        OrderName: 'PF_SORT DESC'
      }).then(function () {
        _this.$message.success('delete success!');
        // 重新获取列表数据
        _this.refreshTableData();
      });
    }
  }
};

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'ProblemFeedBackManagement',
  mixins: [table, page],
  components: {
    ProblemFeedBackForm: __WEBPACK_IMPORTED_MODULE_1__components_other_ProblemFeedBackForm___default.a
  },
  created: function created() {
    this.getTableData();
  },
  data: function data() {
    return {
      table: {
        isLoading: false, // 是否正在加载
        ajaxData: {}, // 额外请求参数
        data: [], // 表格当前数据
        currentPage: 1, // 当前页码
        pageSize: 15, // 每页条数
        pageTotal: 0 // 总页数
      },
      page: {
        popShow: false
      }
    };
  },

  computed: {},
  methods: {
    // 页码点击事件
    handleTableCurrentChange: function handleTableCurrentChange(val) {
      this.getTableData(val);
    },

    // 显示add弹出层
    showAddPop: function showAddPop() {
      this.page.popShow = true;
      this.$nextTick(function () {
        this.$refs.popForm.resetValue();
      });
    },

    // 显示修改弹出层
    showUpdatePop: function showUpdatePop(idx, item) {
      this.page.popShow = true;
      this.$nextTick(function () {
        this.$refs.popForm.setValue(item);
      });
    },

    // add操作
    handleAdd: function handleAdd() {
      // 刷新表格数据
      this.refreshTableData();
      this.page.popShow = false;
    },

    // 修改操作
    handleUpdate: function handleUpdate() {
      // 刷新表格数据
      this.refreshTableData();
      this.page.popShow = false;
    },

    // 删除操作
    handleDel: function handleDel(idx, item) {
      var _this2 = this;

      this.$confirm('This will permanently delete the record', 'prompt', {
        confirmButtonText: 'Confirm',
        cancelButtonText: 'Canel',
        type: 'warning'
      }).then(function () {
        _this2.delDataAjax(item.Id);
      });
    }
  }
});

/***/ }),
/* 317 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_common_tools__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_cms_StaffmienForm__ = __webpack_require__(663);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_cms_StaffmienForm___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_cms_StaffmienForm__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// import $ from 'jquery'
// import mixin from '@/components/common/mixin'



// 表格相关操作
var table = {
  methods: {
    getTableData: __WEBPACK_IMPORTED_MODULE_0__components_common_tools__["a" /* default */].commonTableDateFetch({
      url: '/Ajax/GetStaffmienInfoListInAdmin',
      data: function data() {
        return {
          StCode: this.tree.current ? this.tree.current.StCode : null
        };
      },
      success: function success(response) {
        var result = response.data;
        this.table.data = result;
      }
    }),
    refreshTableData: function refreshTableData() {
      this.getTableData(this.table.currentPage);
    }
  }

  // 请求相关操作
};var page = {
  methods: {
    // 获得分类数据
    getTypeDataAjax: function getTypeDataAjax() {
      var _this = this;

      __WEBPACK_IMPORTED_MODULE_0__components_common_tools__["a" /* default */].commonAjax.call(this, true, '/Ajax/GetStaffmienTypeListInAdmin', {
        All: 1,
        OrderName: 'ST_SORT DESC'
      }).then(function (res) {
        var result = res.data;
        // this.dataStore.commit(types.UPDATE_MODULE, result)
        if (result[0]) {
          _this.tree.current = result[0];
          // 获得右侧表格数据
          _this.getTableData();
        }
        _this.tree.data = result;
      });
    },

    // 删除操作
    delDataAjax: function delDataAjax(id) {
      var _this2 = this;

      __WEBPACK_IMPORTED_MODULE_0__components_common_tools__["a" /* default */].commonAjax.call(this, true, '/Ajax/DeleteStaffmienInfoInAdmin', {
        Id: id
      }).then(function () {
        _this2.$message.success('delete success!');
        // 重新获取列表数据
        _this2.refreshTableData();
      });
    }
  }
};

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'StaffmienManagement',
  mixins: [table, page],
  components: {
    StaffmienForm: __WEBPACK_IMPORTED_MODULE_1__components_cms_StaffmienForm___default.a
  },
  created: function created() {
    this.getTypeDataAjax();
  },
  data: function data() {
    return {
      tree: {
        data: [],
        current: null,
        prop: {
          label: 'StName',
          children: 'children'
        }
      },
      table: {
        isLoading: false, // 是否正在加载
        ajaxData: { OrderName: 'SI_SORT DESC' }, // 额外请求参数
        data: [], // 表格当前数据
        currentPage: 1, // 当前页码
        pageSize: 15, // 每页条数
        pageTotal: 0 // 总页数
      },
      page: {
        popShow: false
      }
    };
  },

  computed: {},
  methods: {
    // 树节点点击事件
    clickModuleTree: function clickModuleTree(item) {
      var current = this.tree.current;
      if (current.StCode !== item.StCode) {
        this.tree.current = item;
        // 重新获取列表数据
        this.getTableData();
      }
    },

    // 页码点击事件
    handleTableCurrentChange: function handleTableCurrentChange(val) {
      this.getTableData(val);
    },

    // 显示add弹出层
    showAddPop: function showAddPop() {
      this.page.popShow = true;
      this.$nextTick(function () {
        this.$refs.popForm.resetValue();
      });
    },

    // 显示修改弹出层
    showUpdatePop: function showUpdatePop(idx, item) {
      this.page.popShow = true;
      this.$nextTick(function () {
        this.$refs.popForm.setValue(item);
      });
    },

    // add操作
    handleAdd: function handleAdd() {
      // 重新获取列表数据
      this.refreshTableData();
      this.page.popShow = false;
    },

    // 修改操作
    handleUpdate: function handleUpdate() {
      // 重新获取列表数据
      this.refreshTableData();
      this.page.popShow = false;
    },

    // 删除操作
    handleDel: function handleDel(idx, item) {
      var _this3 = this;

      this.$confirm('This will permanently delete the record', 'prompt', {
        confirmButtonText: 'Confirm',
        cancelButtonText: 'Canel',
        type: 'warning'
      }).then(function () {
        _this3.delDataAjax(item.Id);
      });
    }
  }
});

/***/ }),
/* 318 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_common_tools__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_cms_StaffmienTypeForm__ = __webpack_require__(664);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_cms_StaffmienTypeForm___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_cms_StaffmienTypeForm__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// import $ from 'jquery'
// import mixin from '@/components/common/mixin'



// 表格相关操作
var table = {
  methods: {
    getTableData: __WEBPACK_IMPORTED_MODULE_0__components_common_tools__["a" /* default */].commonTableDateFetch({
      url: '/Ajax/GetStaffmienTypeListInAdmin',
      success: function success(response) {
        var result = response.data;
        this.table.data = result;
      }
    }),
    refreshTableData: function refreshTableData() {
      this.getTableData(this.table.currentPage);
    }
  }

  // 请求相关操作
};var page = {
  methods: {
    // 删除操作
    delDataAjax: function delDataAjax(id) {
      var _this = this;

      __WEBPACK_IMPORTED_MODULE_0__components_common_tools__["a" /* default */].commonAjax.call(this, true, '/Ajax/DeleteStaffmienTypeInAdmin', {
        Id: id
      }).then(function () {
        _this.$message.success('delete success!');
        // 重新获取列表数据
        _this.refreshTableData();
      });
    }
  }
};

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'StaffmienTypeManagement',
  mixins: [table, page],
  components: {
    StaffmienTypeForm: __WEBPACK_IMPORTED_MODULE_1__components_cms_StaffmienTypeForm___default.a
  },
  created: function created() {
    this.getTableData();
  },
  data: function data() {
    return {
      table: {
        isLoading: false, // 是否正在加载
        ajaxData: { OrderName: 'ST_SORT DESC' }, // 额外请求参数
        data: [], // 表格当前数据
        currentPage: 1, // 当前页码
        pageSize: 15, // 每页条数
        pageTotal: 0 // 总页数
      },
      page: {
        popShow: false
      }
    };
  },

  computed: {},
  methods: {
    // 页码点击事件
    handleTableCurrentChange: function handleTableCurrentChange(val) {
      this.getTableData(val);
    },

    // 显示add弹出层
    showAddPop: function showAddPop() {
      this.page.popShow = true;
      this.$nextTick(function () {
        this.$refs.popForm.resetValue();
      });
    },

    // 显示修改弹出层
    showUpdatePop: function showUpdatePop(idx, item) {
      this.page.popShow = true;
      this.$nextTick(function () {
        this.$refs.popForm.setValue(item);
      });
    },

    // add操作
    handleAdd: function handleAdd() {
      // 刷新表格数据
      this.refreshTableData();
      this.page.popShow = false;
    },

    // 修改操作
    handleUpdate: function handleUpdate() {
      // 刷新表格数据
      this.refreshTableData();
      this.page.popShow = false;
    },

    // 删除操作
    handleDel: function handleDel(idx, item) {
      var _this2 = this;

      this.$confirm('This will permanently delete the record', 'prompt', {
        confirmButtonText: 'Confirm',
        cancelButtonText: 'Canel',
        type: 'warning'
      }).then(function () {
        _this2.delDataAjax(item.Id);
      });
    }
  }
});

/***/ }),
/* 319 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_common_tools__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_product_EnquiryOnlineConfigForm__ = __webpack_require__(672);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_product_EnquiryOnlineConfigForm___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_product_EnquiryOnlineConfigForm__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// import $ from 'jquery'
// import mixin from '@/components/common/mixin'



// 请求相关操作
var page = {
  methods: {
    getDataAjax: function getDataAjax() {
      var _this = this;

      __WEBPACK_IMPORTED_MODULE_0__components_common_tools__["a" /* default */].commonAjax.call(this, true, '/Ajax/GetConfigInfoInCommon', {}).then(function (res) {
        _this.$refs.popForm.setValue(res.data);
      });
    }
  }
};

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'EnquiryOnlineConfigManagement',
  mixins: [page],
  components: {
    EnquiryOnlineConfigForm: __WEBPACK_IMPORTED_MODULE_1__components_product_EnquiryOnlineConfigForm___default.a
  },
  created: function created() {
    this.getDataAjax();
  },
  data: function data() {
    return {};
  },

  computed: {},
  methods: {
    // 修改操作
    handleUpdate: function handleUpdate() {
      // 刷新表格数据
      this.getDataAjax();
    }
  }
});

/***/ }),
/* 320 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_common_mixin__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_common_tools__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_product_ExportForm__ = __webpack_require__(673);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_product_ExportForm___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_product_ExportForm__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// import $ from 'jquery'


// import ProductMemberTypeForm from '@/components/product/ProductMemberTypeForm'


// 表格相关操作
var table = {
  methods: {
    getTableData: __WEBPACK_IMPORTED_MODULE_1__components_common_tools__["a" /* default */].commonTableDateFetch({
      url: '/Ajax/GetProductListInAdmin',
      success: function success(response) {
        var result = response.data;
        var shuilv = this.configData ? this.configData.PrTax : 0.16;
        result.forEach(function (item) {
          item.AllPrice = item.Price * item.Num;
          item.PriceNoTax = parseFloat((item.Price / (1 + shuilv)).toFixed(2));
          item.AllPriceNoTax = item.PriceNoTax * item.Num;
        });
        this.table.data = result;
      }
    }),
    refreshTableData: function refreshTableData() {
      this.getTableData(this.table.currentPage);
    }
  }

  // 请求相关操作
};var page = {
  methods: {
    // 获得所有用户
    getAllUserDataAjax: function getAllUserDataAjax() {
      var _this = this;

      __WEBPACK_IMPORTED_MODULE_1__components_common_tools__["a" /* default */].commonAjax.call(this, true, '/Ajax/GetCustomListInAdmin', {
        All: 1
      }).then(function (res) {
        var result = res.data;
        _this.userData = result;
      });
    },

    // 获得配置项
    getConfigDataAjax: function getConfigDataAjax() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_1__components_common_tools__["a" /* default */].commonAjax.call(this, true, '/Ajax/GetConfigInfoInCommon').then(function (res) {
        var result = res.data;
        _this2.configData = result;
      });
    },

    // 删除操作
    delDataAjax: function delDataAjax(CtCode) {
      // tools.commonAjax.call(this, true, '/Ajax/DelCustomTypeInAdmin', {
      //   CtCode
      // }).then(() => {
      //   this.$message.success('Deleted successfully!')
      //   // 重新获取列表数据
      //   this.refreshTableData()
      // })
    }
  }
};

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'EnquiryOnlineSubmitManagement',
  mixins: [table, page, __WEBPACK_IMPORTED_MODULE_0__components_common_mixin__["a" /* default */].filter],
  components: {
    // ProductMemberTypeForm
    ExportForm: __WEBPACK_IMPORTED_MODULE_2__components_product_ExportForm___default.a
  },
  created: function created() {
    var _this3 = this;

    // 获得配置项
    this.getConfigDataAjax().then(function () {
      _this3.getTableData();
    });
    // 获得所有用户
    this.getAllUserDataAjax();
  },
  data: function data() {
    return {
      search: {
        key: '',
        value: ''
      },
      userData: [],
      configData: null,
      selectUser: '',
      table: {
        isLoading: false, // 是否正在加载
        ajaxData: {}, // 额外请求参数
        data: [], // 表格当前数据
        currentPage: 1, // 当前页码
        pageSize: 15, // 每页条数
        pageTotal: 0 // 总页数
      },
      page: {
        popShow: false
      },
      exportPopShow: false
    };
  },

  filters: {
    priceHandle: function priceHandle(data) {
      data = parseFloat(data);
      if (!isNaN(data)) {
        return parseFloat(data.toFixed(2));
      } else {
        return 0;
      }
    }
  },
  methods: {
    uploadSuccess: function uploadSuccess() {
      this.$message.success('Uploaded successfully!');
    },

    // 搜索事件
    handleSearch: function handleSearch() {
      if (this.search.value) {
        this.table.ajaxData = {};
        this.table.ajaxData[this.search.key] = this.search.value;
        this.refreshTableData();
      } else {
        this.$message.error('Please enter the search content');
      }
    },

    // 重置搜索
    handleResetSearch: function handleResetSearch() {
      this.table.ajaxData = {};
      this.search.value = '';
      this.refreshTableData();
    },

    // 页码点击事件
    handleTableCurrentChange: function handleTableCurrentChange(val) {
      this.getTableData(val);
    },

    // 显示新增弹出层
    showAddPop: function showAddPop() {
      this.page.popShow = true;
      this.$nextTick(function () {
        this.$refs.popForm.resetValue();
      });
    },

    // 显示修改弹出层
    showUpdatePop: function showUpdatePop(idx, item) {
      this.page.popShow = true;
      this.$nextTick(function () {
        this.$refs.popForm.setValue(item);
      });
    },

    // 添加操作
    handleAdd: function handleAdd() {
      // 刷新表格数据
      this.refreshTableData();
      this.page.popShow = false;
    },

    // 修改操作
    handleUpdate: function handleUpdate() {
      // 刷新表格数据
      this.refreshTableData();
      this.page.popShow = false;
    },

    // 删除操作
    handleDel: function handleDel(idx, item) {
      var _this4 = this;

      this.$confirm('This operation will permanently delete the record, whether to continue?', 'Prompt', {
        confirmButtonText: 'Confirm',
        cancelButtonText: 'Cancel',
        type: 'warning'
      }).then(function () {
        _this4.delDataAjax(item.CtCode);
      });
    }
  }
});

/***/ }),
/* 321 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_common_mixin__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_common_tools__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_product_ProductMemberForm__ = __webpack_require__(674);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_product_ProductMemberForm___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_product_ProductMemberForm__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// import $ from 'jquery'




// 表格相关操作
var table = {
  methods: {
    getTableData: __WEBPACK_IMPORTED_MODULE_1__components_common_tools__["a" /* default */].commonTableDateFetch({
      url: '/Ajax/GetCustomListInAdmin',
      data: function data() {
        return {
          CtCode: this.tree.current ? this.tree.current.CtCode : ''
        };
      },
      success: function success(response) {
        var result = response.data;
        this.table.data = result;
      }
    }),
    refreshTableData: function refreshTableData() {
      this.getTableData(this.table.currentPage);
    }
  }

  // 请求相关操作
};var page = {
  methods: {
    // 获得分类数据
    getTypeDataAjax: function getTypeDataAjax() {
      var _this = this;

      __WEBPACK_IMPORTED_MODULE_1__components_common_tools__["a" /* default */].commonAjax.call(this, true, '/Ajax/GetCustomTypeListInAdmin', {
        All: 1,
        OrderName: 'SORT ASC'
      }).then(function (res) {
        var result = res.data;
        if (result.length > 0) {
          _this.tree.current = result[0];
          // 获得右侧表格数据
          _this.getTableData();
        }
        _this.tree.data = result;
      });
    },

    // 删除操作
    delDataAjax: function delDataAjax(CuCode) {
      var _this2 = this;

      __WEBPACK_IMPORTED_MODULE_1__components_common_tools__["a" /* default */].commonAjax.call(this, true, '/Ajax/DelCustomInAdmin', {
        CuCode: CuCode
      }).then(function () {
        _this2.$message.success('Deleted successfully!');
        // 重新获取列表数据
        _this2.refreshTableData();
      });
    }
  }
};

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'ProductMemberManagement',
  mixins: [table, page, __WEBPACK_IMPORTED_MODULE_0__components_common_mixin__["a" /* default */].filter],
  components: {
    ProductMemberForm: __WEBPACK_IMPORTED_MODULE_2__components_product_ProductMemberForm___default.a
  },
  created: function created() {
    // 获得分类数据
    this.getTypeDataAjax();
  },
  data: function data() {
    return {
      search: {
        key: '',
        value: ''
      },
      tree: {
        data: [],
        current: null,
        prop: {
          label: 'CtName',
          children: 'children'
        }
      },
      table: {
        isLoading: false, // 是否正在加载
        ajaxData: {}, // 额外请求参数
        data: [], // 表格当前数据
        currentPage: 1, // 当前页码
        pageSize: 15, // 每页条数
        pageTotal: 0 // 总页数
      },
      page: {
        popShow: false
      }
    };
  },

  methods: {
    // 树节点点击事件
    clickTypeTree: function clickTypeTree(item) {
      var current = this.tree.current;
      if (current.CtCode !== item.CtCode) {
        this.tree.current = item;
        // 重新获取列表数据
        this.getTableData();
      }
    },

    // 搜索事件
    handleSearch: function handleSearch() {
      if (this.search.value) {
        this.table.ajaxData = {};
        this.table.ajaxData[this.search.key] = this.search.value;
        this.refreshTableData();
      } else {
        this.$message.error('Please enter the search content');
      }
    },

    // 重置搜索
    handleResetSearch: function handleResetSearch() {
      this.table.ajaxData = {};
      this.search.value = '';
      this.refreshTableData();
    },

    // 页码点击事件
    handleTableCurrentChange: function handleTableCurrentChange(val) {
      this.getTableData(val);
    },

    // 显示新增弹出层
    showAddPop: function showAddPop() {
      if (this.tree.current) {
        this.page.popShow = true;
        this.$nextTick(function () {
          this.$refs.popForm.setValue({
            CtCode: this.tree.current.CtCode
          });
        });
      } else {
        this.$message.error('Please add the user type first');
      }
    },

    // 显示修改弹出层
    showUpdatePop: function showUpdatePop(idx, item) {
      this.page.popShow = true;
      this.$nextTick(function () {
        this.$refs.popForm.setValue(item);
      });
    },

    // 添加操作
    handleAdd: function handleAdd() {
      // 刷新表格数据
      this.refreshTableData();
      this.page.popShow = false;
    },

    // 修改操作
    handleUpdate: function handleUpdate() {
      // 刷新表格数据
      this.refreshTableData();
      this.page.popShow = false;
    },

    // 删除操作
    handleDel: function handleDel(idx, item) {
      var _this3 = this;

      this.$confirm('This operation will permanently delete the record, whether to continue?', 'Prompt', {
        confirmButtonText: 'Confirm',
        cancelButtonText: 'Cancel',
        type: 'warning'
      }).then(function () {
        _this3.delDataAjax(item.CuCode);
      });
    },

    // 跳转数量系数设置
    jumpNumberConfig: function jumpNumberConfig(idx, item) {
      this.$router.push('/product/ProductNumberConfigManagement?CuCode=' + item.CuCode);
    }
  }
});

/***/ }),
/* 322 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_common_mixin__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_common_tools__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_product_ProductMemberTypeForm__ = __webpack_require__(675);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_product_ProductMemberTypeForm___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_product_ProductMemberTypeForm__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// import $ from 'jquery'




// 表格相关操作
var table = {
  methods: {
    getTableData: __WEBPACK_IMPORTED_MODULE_1__components_common_tools__["a" /* default */].commonTableDateFetch({
      url: '/Ajax/GetCustomTypeListInAdmin',
      data: function data() {
        return {
          OrderName: 'SORT ASC'
        };
      },
      success: function success(response) {
        var result = response.data;
        this.table.data = result;
      }
    }),
    refreshTableData: function refreshTableData() {
      this.getTableData(this.table.currentPage);
    }
  }

  // 请求相关操作
};var page = {
  methods: {
    // 删除操作
    delDataAjax: function delDataAjax(CtCode) {
      var _this = this;

      __WEBPACK_IMPORTED_MODULE_1__components_common_tools__["a" /* default */].commonAjax.call(this, true, '/Ajax/DelCustomTypeInAdmin', {
        CtCode: CtCode
      }).then(function () {
        _this.$message.success('Deleted successfully!');
        // 重新获取列表数据
        _this.refreshTableData();
      });
    }
  }
};

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'ProductMemberTypeManagement',
  mixins: [table, page, __WEBPACK_IMPORTED_MODULE_0__components_common_mixin__["a" /* default */].filter],
  components: {
    ProductMemberTypeForm: __WEBPACK_IMPORTED_MODULE_2__components_product_ProductMemberTypeForm___default.a
  },
  created: function created() {
    this.getTableData();
  },
  data: function data() {
    return {
      search: {
        key: '',
        value: ''
      },
      table: {
        isLoading: false, // 是否正在加载
        ajaxData: {}, // 额外请求参数
        data: [], // 表格当前数据
        currentPage: 1, // 当前页码
        pageSize: 15, // 每页条数
        pageTotal: 0 // 总页数
      },
      page: {
        popShow: false
      }
    };
  },

  methods: {
    // 搜索事件
    handleSearch: function handleSearch() {
      if (this.search.value) {
        this.table.ajaxData = {};
        this.table.ajaxData[this.search.key] = this.search.value;
        this.refreshTableData();
      } else {
        this.$message.error('Please enter the search content');
      }
    },

    // 重置搜索
    handleResetSearch: function handleResetSearch() {
      this.table.ajaxData = {};
      this.search.value = '';
      this.refreshTableData();
    },

    // 页码点击事件
    handleTableCurrentChange: function handleTableCurrentChange(val) {
      this.getTableData(val);
    },

    // 显示新增弹出层
    showAddPop: function showAddPop() {
      this.page.popShow = true;
      this.$nextTick(function () {
        this.$refs.popForm.resetValue();
      });
    },

    // 显示修改弹出层
    showUpdatePop: function showUpdatePop(idx, item) {
      this.page.popShow = true;
      this.$nextTick(function () {
        this.$refs.popForm.setValue(item);
      });
    },

    // 添加操作
    handleAdd: function handleAdd() {
      // 刷新表格数据
      this.refreshTableData();
      this.page.popShow = false;
    },

    // 修改操作
    handleUpdate: function handleUpdate() {
      // 刷新表格数据
      this.refreshTableData();
      this.page.popShow = false;
    },

    // 删除操作
    handleDel: function handleDel(idx, item) {
      var _this2 = this;

      this.$confirm('This operation will permanently delete the record, whether to continue?', 'Prompt', {
        confirmButtonText: 'Confirm',
        cancelButtonText: 'Cancel',
        type: 'warning'
      }).then(function () {
        _this2.delDataAjax(item.CtCode);
      });
    }
  }
});

/***/ }),
/* 323 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_common_mixin__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_common_tools__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_product_ProductNumberConfigForm__ = __webpack_require__(676);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_product_ProductNumberConfigForm___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_product_ProductNumberConfigForm__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// import $ from 'jquery'




// 路径页面进入数据获取
var routeDataGet = {
  created: function created() {
    this.changeQuery();
  },

  watch: {
    // 如果路由有变化，会再次执行该方法
    '$route': 'changeQuery'
  },
  methods: {
    changeQuery: function changeQuery() {
      this.CuCode = this.$route.query.CuCode;
      this.getTableData();
    }
  }

  // 表格相关操作
};var table = {
  methods: {
    getTableData: __WEBPACK_IMPORTED_MODULE_1__components_common_tools__["a" /* default */].commonTableDateFetch({
      url: '/Ajax/GetProductNumberListInAdmin',
      data: function data() {
        return {
          CuCode: this.CuCode
        };
      },
      success: function success(response) {
        var result = response.data;
        this.table.data = result;
      }
    }),
    refreshTableData: function refreshTableData() {
      this.getTableData(this.table.currentPage);
    }
  }

  // 请求相关操作
};var page = {
  methods: {
    // 删除操作
    delDataAjax: function delDataAjax(Id) {
      var _this = this;

      __WEBPACK_IMPORTED_MODULE_1__components_common_tools__["a" /* default */].commonAjax.call(this, true, '/Ajax/DelProductNumberInAdmin', {
        Id: Id
      }).then(function () {
        _this.$message.success('Deleted successfully!');
        // 重新获取列表数据
        _this.refreshTableData();
      });
    }
  }
};

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'ProductNumberConfigManagement.1',
  mixins: [routeDataGet, table, page, __WEBPACK_IMPORTED_MODULE_0__components_common_mixin__["a" /* default */].filter],
  components: {
    ProductNumberConfigForm: __WEBPACK_IMPORTED_MODULE_2__components_product_ProductNumberConfigForm___default.a
  },
  created: function created() {},
  data: function data() {
    return {
      CuCode: '',
      search: {
        key: '',
        value: ''
      },
      table: {
        isLoading: false, // 是否正在加载
        ajaxData: {}, // 额外请求参数
        data: [], // 表格当前数据
        currentPage: 1, // 当前页码
        pageSize: 15, // 每页条数
        pageTotal: 0 // 总页数
      },
      page: {
        popShow: false
      }
    };
  },

  methods: {
    // 搜索事件
    handleSearch: function handleSearch() {
      if (this.search.value) {
        this.table.ajaxData = {};
        this.table.ajaxData[this.search.key] = this.search.value;
        this.refreshTableData();
      } else {
        this.$message.error('Please enter the search content');
      }
    },

    // 重置搜索
    handleResetSearch: function handleResetSearch() {
      this.table.ajaxData = {};
      this.search.value = '';
      this.refreshTableData();
    },

    // 页码点击事件
    handleTableCurrentChange: function handleTableCurrentChange(val) {
      this.getTableData(val);
    },

    // 显示新增弹出层
    showAddPop: function showAddPop() {
      this.page.popShow = true;
      this.$nextTick(function () {
        this.$refs.popForm.setValue({
          CuCode: this.CuCode
        });
      });
    },

    // 显示修改弹出层
    showUpdatePop: function showUpdatePop(idx, item) {
      this.page.popShow = true;
      this.$nextTick(function () {
        this.$refs.popForm.setValue(item);
      });
    },

    // 添加操作
    handleAdd: function handleAdd() {
      // 刷新表格数据
      this.refreshTableData();
      this.page.popShow = false;
    },

    // 修改操作
    handleUpdate: function handleUpdate() {
      // 刷新表格数据
      this.refreshTableData();
      this.page.popShow = false;
    },

    // 删除操作
    handleDel: function handleDel(idx, item) {
      var _this2 = this;

      this.$confirm('This operation will permanently delete the record, whether to continue?', 'Prompt', {
        confirmButtonText: 'Confirm',
        cancelButtonText: 'Cancel',
        type: 'warning'
      }).then(function () {
        _this2.delDataAjax(item.Id);
      });
    },
    goBack: function goBack() {
      this.$router.go(-1);
    }
  }
});

/***/ }),
/* 324 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_common_tools__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_product_ProductSSSGTForm__ = __webpack_require__(677);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_product_ProductSSSGTForm___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_product_ProductSSSGTForm__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_common_tree__ = __webpack_require__(36);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// import $ from 'jquery'
// import mixin from '@/components/common/mixin'




// 侧边树
var sideTree = new __WEBPACK_IMPORTED_MODULE_2__components_common_tree__["a" /* default */].TreeCreate(function (item) {
  for (var key in item) {
    if (item.hasOwnProperty(key)) {
      this[key] = item[key];
    }
  }
}, { FId: 'PsLastCode', Id: 'PsCode' });

// 表格相关操作
var table = {
  methods: {
    getTableData: __WEBPACK_IMPORTED_MODULE_0__components_common_tools__["a" /* default */].commonTableDateFetch({
      url: '/Ajax/GetProselectSsgtModelInAdmin',
      data: function data() {
        return {
          PsCode: this.tree.current ? this.tree.current.PsCode : '0'
        };
      },
      success: function success(response) {
        var result = response.data;
        this.table.data = result;
      }
    }),
    refreshTableData: function refreshTableData() {
      this.getTableData(this.table.currentPage);
    }
  }

  // 请求相关操作
};var page = {
  methods: {
    // 获得分类数据
    getTypeDataAjax: function getTypeDataAjax() {
      var _this = this;

      __WEBPACK_IMPORTED_MODULE_0__components_common_tools__["a" /* default */].commonAjax.call(this, true, '/Ajax/GetProselectSsgtListInAdmin', {
        All: 1
      }).then(function (res) {
        var result = res.data;
        // this.dataStore.commit(types.UPDATE_MODULE, result)
        sideTree.create(result);
        var treeData = sideTree.getTreeData();
        if (treeData[0]) {
          _this.tree.current = treeData[0];
          // 获得右侧表格数据
          _this.getTableData();
        }
        _this.tree.data = treeData;
      });
    },

    // 删除操作
    delDataAjax: function delDataAjax(id) {
      var _this2 = this;

      __WEBPACK_IMPORTED_MODULE_0__components_common_tools__["a" /* default */].commonAjax.call(this, true, '/Ajax/DeleteProselectSsgtModelInAdmin', {
        Id: id
      }).then(function () {
        _this2.$message.success('delete success!');
        // 重新获取列表数据
        _this2.refreshTableData();
      });
    }
  }
};

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'ProductSSGT',
  mixins: [table, page],
  components: {
    ProductSSSGTForm: __WEBPACK_IMPORTED_MODULE_1__components_product_ProductSSSGTForm___default.a
  },
  created: function created() {
    this.getTypeDataAjax();
  },
  data: function data() {
    return {
      tree: {
        data: [],
        current: null,
        prop: {
          label: 'PsName',
          children: 'children'
        }
      },
      table: {
        isLoading: false, // 是否正在加载
        ajaxData: { OrderName: 'PSM_SORT DESC' }, // 额外请求参数
        data: [], // 表格当前数据
        currentPage: 1, // 当前页码
        pageSize: 15, // 每页条数
        pageTotal: 0 // 总页数
      },
      page: {
        popShow: false
      }
    };
  },

  computed: {},
  methods: {
    // 树节点点击事件
    clickModuleTree: function clickModuleTree(item) {
      var current = this.tree.current;
      if (current.PsCode !== item.PsCode) {
        this.tree.current = item;
        // 重新获取列表数据
        this.getTableData();
      }
    },

    // 页码点击事件
    handleTableCurrentChange: function handleTableCurrentChange(val) {
      this.getTableData(val);
    },

    // 显示add弹出层
    showAddPop: function showAddPop() {
      this.page.popShow = true;
      this.$nextTick(function () {
        this.$refs.popForm.resetValue();
      });
    },

    // 显示修改弹出层
    showUpdatePop: function showUpdatePop(idx, item) {
      this.page.popShow = true;
      this.$nextTick(function () {
        this.$refs.popForm.setValue(item);
      });
    },

    // add操作
    handleAdd: function handleAdd() {
      // 重新获取列表数据
      this.refreshTableData();
      this.page.popShow = false;
    },

    // 修改操作
    handleUpdate: function handleUpdate() {
      // 重新获取列表数据
      this.refreshTableData();
      this.page.popShow = false;
    },

    // 删除操作
    handleDel: function handleDel(idx, item) {
      var _this3 = this;

      this.$confirm('This will permanently delete the record', 'prompt', {
        confirmButtonText: 'Confirm',
        cancelButtonText: 'Canel',
        type: 'warning'
      }).then(function () {
        _this3.delDataAjax(item.Id);
      });
    }
  }
});

/***/ }),
/* 325 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_common_tools__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_product_ProductTypeFormSSGT__ = __webpack_require__(678);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_product_ProductTypeFormSSGT___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_product_ProductTypeFormSSGT__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// import $ from 'jquery'
// import mixin from '@/components/common/mixin'



// 表格相关操作
var table = {
  methods: {
    getTableData: __WEBPACK_IMPORTED_MODULE_0__components_common_tools__["a" /* default */].commonTableDateFetch({
      url: '/Ajax/GetProselectSsgtListInAdmin',
      data: function data() {
        var PsLastCode = this.$route.query.code;
        return {
          PsLastCode: PsLastCode == null ? '0' : PsLastCode
        };
      },
      success: function success(response) {
        var result = response.data;
        this.table.data = result;
      }
    }),
    refreshTableData: function refreshTableData() {
      this.getTableData(this.table.currentPage);
    }
  }

  // 路径页面进入数据获取
};var routeDataGet = {
  watch: {
    // 如果路由有变化，会再次执行该方法
    '$route': 'fetchData'
  },
  methods: {
    fetchData: function fetchData() {
      this.getTableData();
    }
  }

  // 请求相关操作
};var page = {
  methods: {
    // 删除操作
    delDataAjax: function delDataAjax(id) {
      var _this = this;

      __WEBPACK_IMPORTED_MODULE_0__components_common_tools__["a" /* default */].commonAjax.call(this, true, '/Ajax/DeleteProselectSsgtInAdmin', {
        PsCode: id
      }).then(function () {
        _this.$message.success('delete success!');
        // 重新获取列表数据
        _this.refreshTableData();
      });
    }
  }
};

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'ProductTypeSSGT',
  mixins: [routeDataGet, table, page],
  components: {
    ProductTypeFormSSGT: __WEBPACK_IMPORTED_MODULE_1__components_product_ProductTypeFormSSGT___default.a
  },
  created: function created() {
    this.getTableData();
  },
  data: function data() {
    return {
      table: {
        isLoading: false, // 是否正在加载
        ajaxData: {
          OrderName: ''
        }, // 额外请求参数
        data: [], // 表格当前数据
        currentPage: 1, // 当前页码
        pageSize: 15, // 每页条数
        pageTotal: 0 // 总页数
      },
      page: {
        popShow: false
      }
    };
  },

  computed: {},
  methods: {
    // 页码点击事件
    handleTableCurrentChange: function handleTableCurrentChange(val) {
      this.getTableData(val);
    },

    // 显示add弹出层
    showAddPop: function showAddPop() {
      var PsLastCode = this.$route.query.code;
      this.page.popShow = true;
      this.$nextTick(function () {
        this.$refs.popForm.resetValue();
        this.$refs.popForm.setValue({
          PsLastCode: PsLastCode == null ? '0' : PsLastCode
        });
      });
    },

    // 显示修改弹出层
    showUpdatePop: function showUpdatePop(idx, item) {
      this.page.popShow = true;
      this.$nextTick(function () {
        this.$refs.popForm.setValue(item);
      });
    },

    // add操作
    handleAdd: function handleAdd() {
      // 刷新表格数据
      this.refreshTableData();
      this.page.popShow = false;
    },

    // 修改操作
    handleUpdate: function handleUpdate() {
      // 刷新表格数据
      this.refreshTableData();
      this.page.popShow = false;
    },

    // 删除操作
    handleDel: function handleDel(idx, item) {
      var _this2 = this;

      this.$confirm('This will permanently delete the record', 'prompt', {
        confirmButtonText: 'Confirm',
        cancelButtonText: 'Canel',
        type: 'warning'
      }).then(function () {
        _this2.delDataAjax(item.PsCode);
      });
    },

    // 跳转下一级
    SkipNextGrade: function SkipNextGrade(idx, item) {
      // this.refreshTableData()
      this.$router.push('ProductTypeSSGT?code=' + item.PsCode);
    },
    goBack: function goBack() {
      window.history.go(-1);
    }
  }
});

/***/ }),
/* 326 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_common_tools__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_common_tree__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__libcomponents_tree_select_tree__ = __webpack_require__(214);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__libcomponents_tree_select_tree___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__libcomponents_tree_select_tree__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_system_PowerForm__ = __webpack_require__(212);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_system_PowerForm___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_system_PowerForm__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_system_PasswordForm__ = __webpack_require__(681);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_system_PasswordForm___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_system_PasswordForm__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//









// 部门数据对象
var departmentDataStore = __WEBPACK_IMPORTED_MODULE_0__components_common_tools__["a" /* default */].createDataStore({
  // FaId
  FaId: '',
  // 部门名称
  OgName: ''
});

// 用户数据对象
var staffDataStore = __WEBPACK_IMPORTED_MODULE_0__components_common_tools__["a" /* default */].createDataStore({
  // 部门code
  OgCode: '',
  // 用户名称
  AuName: '',
  // 用户账号
  AuAccount: '',
  // 用户职务
  AuPost: '',
  // 用户手机
  AuMobile: '',
  // 用户密码
  AuPassword: '',
  // 所属用户组
  LbCodeList: []
});

// 部门相关操作
var department = {
  methods: {
    // 获得部门数据
    getDepartmentData: function getDepartmentData() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_0__components_common_tools__["a" /* default */].commonAjax.call(this, true, '/SystemManage/GetOrganizationChildRen', {
        Code: this.$store.state.user.memberInfo.OgCode
      }).then(function (res) {
        var result = __WEBPACK_IMPORTED_MODULE_1__components_common_tree__["a" /* default */].changeLRTreeToTreeData(res.data);
        if (result.length) {
          _this.tree.current = result[0];
          _this.tree.data = result;
          // 获得员工表格数据
          _this.getStaffTableData();
        }
      });
    },

    // add部门操作
    addDepartmentDataAjax: function addDepartmentDataAjax() {
      var _this2 = this;

      var data = __WEBPACK_IMPORTED_MODULE_0__components_common_tools__["a" /* default */].getModel(this.departmentPop.data);
      return __WEBPACK_IMPORTED_MODULE_0__components_common_tools__["a" /* default */].commonAjax.call(this, true, '/SystemManage/AddOrganization', data).then(function () {
        _this2.$message.success('Success!');
        // 重新获取部门数据
        _this2.getDepartmentData();
      });
    },

    // 修改部门操作
    updateDepartmentDataAjax: function updateDepartmentDataAjax() {
      var _this3 = this;

      var data = __WEBPACK_IMPORTED_MODULE_0__components_common_tools__["a" /* default */].getModel(this.departmentPop.data);
      return __WEBPACK_IMPORTED_MODULE_0__components_common_tools__["a" /* default */].commonAjax.call(this, true, '/SystemManage/UpdateOrganization', data).then(function () {
        _this3.$message.success('Fail!');
        // 重新获取部门数据
        _this3.getDepartmentData();
      });
    },

    // 删除部门操作
    delDepartmentDataAjax: function delDepartmentDataAjax(id) {
      var _this4 = this;

      return __WEBPACK_IMPORTED_MODULE_0__components_common_tools__["a" /* default */].commonAjax.call(this, true, '/SystemManage/DelOrganization', {
        Id: id
      }).then(function () {
        _this4.$message.success('delete success!');
        // 重新获取部门数据
        _this4.getDepartmentData();
      });
    }
  }

  // 员工相关操作
};var staff = {
  methods: {
    // 获得员工表格数据
    getStaffTableData: __WEBPACK_IMPORTED_MODULE_0__components_common_tools__["a" /* default */].commonTableDateFetch({
      url: '/SystemManage/GetAdminUserAllInfor',
      data: function data() {
        return {
          Code: this.tree.current.OgCode
        };
      },
      success: function success(response) {
        var result = response.data;
        this.table.data = result;
      }
    }),
    // 刷新员工表格数据
    refreshStaffTableData: function refreshStaffTableData() {
      this.getStaffTableData(this.table.currentPage);
    },

    // add员工操作
    addStaffDataAjax: function addStaffDataAjax() {
      var _this5 = this;

      var data = __WEBPACK_IMPORTED_MODULE_0__components_common_tools__["a" /* default */].getModel(this.staffPop.data);
      data.OgCode = this.tree.current.OgCode;
      data.UserLbCodeList = this.getCurrentUserLabel();
      return __WEBPACK_IMPORTED_MODULE_0__components_common_tools__["a" /* default */].commonAjax.call(this, true, '/SystemManage/AddAdminuser', data).then(function () {
        _this5.$message.success('add success!');
        // 重新获取列表数据
        _this5.refreshStaffTableData();
      });
    },

    // 更新员工操作
    updateStaffDataAjax: function updateStaffDataAjax() {
      var _this6 = this;

      var data = __WEBPACK_IMPORTED_MODULE_0__components_common_tools__["a" /* default */].getModel(this.staffPop.data);
      data.UserLbCodeList = this.getCurrentUserLabel();
      return __WEBPACK_IMPORTED_MODULE_0__components_common_tools__["a" /* default */].commonAjax.call(this, true, '/SystemManage/UpdateAdminuser', data).then(function () {
        _this6.$message.success('update success!');
        // 重新获取列表数据
        _this6.refreshStaffTableData();
        // 如果是[员工],且修改为当前用户 -> 重新获取用户信息
        if (data.AuCode === _this6.$store.state.user.memberInfo.AuCode) {
          _this6.$store.dispatch('getLoginMemberInfo', false);
        }
      });
    },

    // 删除员工操作
    delStaffDataAjax: function delStaffDataAjax(id) {
      var _this7 = this;

      return __WEBPACK_IMPORTED_MODULE_0__components_common_tools__["a" /* default */].commonAjax.call(this, true, '/SystemManage/DeleteAdminuser', {
        Id: id
      }).then(function () {
        _this7.$message.success('delete success!');
        // 重新获取列表数据
        _this7.refreshStaffTableData();
      });
    },

    // 禁用员工操作
    disableStaffDataAjax: function disableStaffDataAjax(id) {
      var _this8 = this;

      return __WEBPACK_IMPORTED_MODULE_0__components_common_tools__["a" /* default */].commonAjax.call(this, true, '/SystemManage/SetAdminuserIsUnUsed', {
        Id: id
      }).then(function () {
        _this8.$message.success('operating success!');
        // 重新获取列表数据
        _this8.refreshStaffTableData();
      });
    },

    // 启用员工操作
    enableStaffDataAjax: function enableStaffDataAjax(id) {
      var _this9 = this;

      return __WEBPACK_IMPORTED_MODULE_0__components_common_tools__["a" /* default */].commonAjax.call(this, true, '/SystemManage/SetAdminuserIsUsed', {
        Id: id
      }).then(function () {
        _this9.$message.success('operating success!');
        // 重新获取列表数据
        _this9.refreshStaffTableData();
      });
    },

    // 获取当前员工标签
    getCurrentUserLabel: function getCurrentUserLabel() {
      var _this10 = this;

      var LbCodeList = [];
      this.LabelList.forEach(function (item) {
        if (_this10.currentLbNameList.findIndex(function (el) {
          return el === item.LbName;
        }) > -1) {
          LbCodeList.push(item.LbCode);
        }
      });
      return LbCodeList.join(',');
    }
  }

  // 角色(标签)相关操作
};var label = {
  methods: {
    // 获得角色(标签)数据
    getLabelListDataAjax: function getLabelListDataAjax() {
      var _this11 = this;

      return __WEBPACK_IMPORTED_MODULE_0__components_common_tools__["a" /* default */].commonAjax.call(this, true, '/SystemManage/GetLabelList', {
        All: 1
      }).then(function (res) {
        _this11.LabelList = res.data;
      });
    },

    // 获得指定用户角色(标签)数据
    getUserLabelDataAjax: function getUserLabelDataAjax(code) {
      return __WEBPACK_IMPORTED_MODULE_0__components_common_tools__["a" /* default */].commonAjax.call(this, true, '/SystemManage/GetLableFromAucode', {
        AuCode: code
      });
    }
  }
};

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'DepartmentStaffManagement',
  mixins: [department, staff, label],
  components: {
    treeSelect: __WEBPACK_IMPORTED_MODULE_2__libcomponents_tree_select_tree___default.a, PowerForm: __WEBPACK_IMPORTED_MODULE_3__components_system_PowerForm___default.a, PasswordForm: __WEBPACK_IMPORTED_MODULE_4__components_system_PasswordForm___default.a
  },
  created: function created() {
    // 获得部门数据, 联动 -> 获取对应部门员工
    this.getDepartmentData();
    // 获得角色(标签)数据
    this.getLabelListDataAjax();
  },
  data: function data() {
    return {
      // 部门树
      tree: {
        data: [],
        prop: {
          id: 'Id',
          label: 'OgName',
          level: 'OrganizationLayer',
          children: 'children'
        },
        current: null,
        selected: ''
      },
      // 部门弹出层
      departmentPop: {
        show: false,
        data: departmentDataStore.getDefaultData()
      },
      // 员工表格
      table: {
        isLoading: false, // 是否正在加载
        ajaxData: {}, // 额外请求参数
        data: [], // 表格当前数据
        currentPage: 1, // 当前页码
        pageSize: 15, // 每页条数
        pageTotal: 0 // 总页数
      },
      // 员工弹出层
      staffPop: {
        show: false,
        data: staffDataStore.getDefaultData()
      },
      // 权限弹出层
      powerPop: {
        show: false
      },
      // 角色(标签)列表
      LabelList: [],
      // 角色(标签)名称
      currentLbNameList: [],
      // 重置密码弹出层
      passwordPop: {
        show: false
      }
    };
  },

  computed: {
    tableData: function tableData() {
      return this.table.data.map(function (item) {
        item._LbNamelist = item.LbNamelist ? item.LbNamelist.split(',') : [];
        item._AuIsused = !!item.AuIsused;
        return item;
      });
    }
  },
  methods: {
    showTreeError: function showTreeError(error) {
      this.$message.info(error.message);
    },
    setSelectedId: function setSelectedId(val) {
      this.departmentPop.data.FaId = val;
    },

    // 显示add部门弹框
    showAddDepartmentPop: function showAddDepartmentPop() {
      this.departmentPop.show = true;
      this.departmentPop.data = departmentDataStore.getDefaultData();
    },

    // add部门
    addDepartment: function addDepartment() {
      var _this12 = this;

      this.addDepartmentDataAjax().then(function () {
        _this12.departmentPop.show = false;
      });
    },

    // 显示修改部门弹框
    showUpdateDepartmentPop: function showUpdateDepartmentPop(store, item) {
      this.departmentPop.show = true;
      this.departmentPop.data = __WEBPACK_IMPORTED_MODULE_0__components_common_tools__["a" /* default */].getModel(item);
      console.log(this.departmentPop.data);
    },

    // 修改部门
    updateDepartment: function updateDepartment() {
      var _this13 = this;

      this.updateDepartmentDataAjax().then(function () {
        _this13.departmentPop.show = false;
      });
    },

    // 删除部门
    deleteDepartment: function deleteDepartment(store, data) {
      var _this14 = this;

      this.$confirm('This will permanently delete the record', 'prompt', {
        confirmButtonText: 'Confirm',
        cancelButtonText: 'Canel',
        type: 'warning'
      }).then(function () {
        _this14.delDepartmentDataAjax(data.Id);
      });
    },

    // 树节点点击事件
    clickmoduleTree: function clickmoduleTree(item) {
      var current = this.tree.current;
      if (current.OgCode !== item.OgCode) {
        this.tree.current = item;
        // 获得员工表格数据
        this.getStaffTableData();
      }
    },

    // 渲染树节点内容
    renderTreeItemContent: function renderTreeItemContent(h, _ref) {
      var _this15 = this;

      var node = _ref.node,
          data = _ref.data,
          store = _ref.store;

      return h('span', [h('span', [h('span', [node.label])]), h(
        'el-dropdown',
        { 'class': 'tree-tool-bar', on: {
            'command': function command(_command) {
              return _this15.handleTreeCommand(_command, store, data);
            }
          }
        },
        [h(
          'span',
          { 'class': 'el-dropdown-link' },
          ['Operate', h('i', { 'class': 'el-icon-caret-bottom el-icon--right' })]
        ), h(
          'el-dropdown-menu',
          { slot: 'dropdown' },
          [h(
            'el-dropdown-item',
            {
              attrs: { command: 'showUpdateDepartmentPop' }
            },
            ['edit']
          ), h(
            'el-dropdown-item',
            {
              attrs: { command: 'showAddPowerPop' }
            },
            ['Give permission']
          ), h(
            'el-dropdown-item',
            {
              attrs: { command: 'deleteDepartment' }
            },
            ['delete']
          )]
        )]
      )]);
    },

    // 显示add员工弹框
    showAddStaffPop: function showAddStaffPop() {
      this.currentLbNameList = [];
      this.staffPop.show = true;
      this.staffPop.data = staffDataStore.getDefaultData();
    },

    // add员工
    addStaff: function addStaff() {
      var _this16 = this;

      this.addStaffDataAjax().then(function () {
        _this16.staffPop.show = false;
      });
    },

    // 显示修改员工弹框
    showUpdateStaffPop: function showUpdateStaffPop(idx, item) {
      var _this17 = this;

      this.getUserLabelDataAjax(item.AuCode).then(function (res) {
        _this17.currentLbNameList = res.data.map(function (el) {
          return el.LbName;
        });
        _this17.staffPop.show = true;
        _this17.staffPop.data = __WEBPACK_IMPORTED_MODULE_0__components_common_tools__["a" /* default */].getModel(item);
      });
    },

    // 更新员工
    updateStaff: function updateStaff() {
      var _this18 = this;

      this.updateStaffDataAjax().then(function () {
        _this18.staffPop.show = false;
      });
    },

    // 删除员工
    delStaff: function delStaff(idx, item) {
      var _this19 = this;

      this.$confirm('This will permanently delete the record', 'prompt', {
        confirmButtonText: 'Confirm',
        cancelButtonText: 'Canel',
        type: 'warning'
      }).then(function () {
        _this19.delStaffDataAjax(item.Id);
      });
    },

    // 显示重置密码弹出层
    showResetPasswordPop: function showResetPasswordPop(idx, item) {
      this.passwordPop.show = true;
      this.$nextTick(function () {
        this.$refs.passwordForm.setValue({
          Id: item.Id
        });
      });
    },

    // 重置密码成功
    updatePasswordSuccess: function updatePasswordSuccess() {
      this.passwordPop.show = false;
    },

    // 显示add权限弹出层
    showAddPowerPop: function showAddPowerPop(type, code) {
      var _this20 = this;

      if (this.$refs.powerForm) {
        this.$refs.powerForm.getDefaultData(type, code).then(function () {
          _this20.powerPop.show = true;
        });
      } else {
        this.powerPop.show = true;
        this.$nextTick(function () {
          this.$refs.powerForm.getDefaultData(type, code, false);
        });
      }
    },

    // 权限修改成功
    updatePowerSuccess: function updatePowerSuccess() {
      this.powerPop.show = false;
    },

    // 树工具栏命令事件
    handleTreeCommand: function handleTreeCommand(command, store, data) {
      if (command === 'showAddPowerPop') {
        // 0 代表部门
        this[command](0, data.OgCode);
      } else {
        this[command](store, data);
      }
    },

    // 表格工具栏命令事件
    handleTableCommand: function handleTableCommand(command, idx, item) {
      if (command === 'showAddPowerPop') {
        // 1 代表用户
        this[command](1, item.AuCode);
      } else {
        this[command](idx, item);
      }
    },

    // 页码点击事件
    handleTableCurrentChange: function handleTableCurrentChange(val) {
      this.getStaffTableData(val);
    }
  }
});

/***/ }),
/* 327 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_common_tools__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_system_LabelForm__ = __webpack_require__(679);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_system_LabelForm___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_system_LabelForm__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_system_PowerForm__ = __webpack_require__(212);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_system_PowerForm___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_system_PowerForm__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// import $ from 'jquery'
// import mixin from '@/components/common/mixin'





// 表格相关操作
var table = {
  methods: {
    getTableData: __WEBPACK_IMPORTED_MODULE_0__components_common_tools__["a" /* default */].commonTableDateFetch({
      url: '/SystemManage/GetLabelList',
      data: function data() {
        return {
          OrderName: 'LB_SORT DESC'
        };
      },
      success: function success(response) {
        var result = response.data;
        this.table.data = result;
      }
    }),
    refreshTableData: function refreshTableData() {
      this.getTableData(this.table.currentPage);
    }
  }

  // 请求相关操作
};var page = {
  methods: {
    // 删除操作
    delDataAjax: function delDataAjax(id) {
      var _this = this;

      __WEBPACK_IMPORTED_MODULE_0__components_common_tools__["a" /* default */].commonAjax.call(this, true, '/SystemManage/DeleteLabel', {
        Id: id
      }).then(function () {
        _this.$message.success('delete success!');
        // 重新获取列表数据
        _this.refreshTableData();
      });
    }
  }
};

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'LabelManagement',
  mixins: [table, page],
  components: {
    LabelForm: __WEBPACK_IMPORTED_MODULE_1__components_system_LabelForm___default.a, PowerForm: __WEBPACK_IMPORTED_MODULE_2__components_system_PowerForm___default.a
  },
  created: function created() {
    this.getTableData();
  },
  data: function data() {
    return {
      table: {
        isLoading: false, // 是否正在加载
        ajaxData: {}, // 额外请求参数
        data: [], // 表格当前数据
        currentPage: 1, // 当前页码
        pageSize: 15, // 每页条数
        pageTotal: 0 // 总页数
      },
      page: {
        popShow: false
      },
      // 权限弹出层
      powerPop: {
        show: false
      }
    };
  },

  computed: {},
  methods: {
    // 页码点击事件
    handleTableCurrentChange: function handleTableCurrentChange(val) {
      this.getTableData(val);
    },

    // 显示add弹出层
    showAddPop: function showAddPop() {
      this.page.popShow = true;
      this.$nextTick(function () {
        this.$refs.popForm.resetValue();
      });
    },

    // 显示修改弹出层
    showUpdatePop: function showUpdatePop(idx, item) {
      this.page.popShow = true;
      this.$nextTick(function () {
        this.$refs.popForm.setValue(item);
      });
    },

    // add操作
    handleAdd: function handleAdd() {
      // 刷新表格数据
      this.refreshTableData();
      this.page.popShow = false;
    },

    // 修改操作
    handleUpdate: function handleUpdate() {
      // 刷新表格数据
      this.refreshTableData();
      this.page.popShow = false;
    },

    // 删除操作
    handleDel: function handleDel(idx, item) {
      var _this2 = this;

      this.$confirm('This will permanently delete the record', 'prompt', {
        confirmButtonText: 'Confirm',
        cancelButtonText: 'Canel',
        type: 'warning'
      }).then(function () {
        _this2.delDataAjax(item.Id);
      });
    },

    // 显示add权限弹出层
    showAddPowerPop: function showAddPowerPop(type, code) {
      var _this3 = this;

      if (this.$refs.powerForm) {
        this.$refs.powerForm.getDefaultData(type, code).then(function () {
          _this3.powerPop.show = true;
        });
      } else {
        this.powerPop.show = true;
        this.$nextTick(function () {
          this.$refs.powerForm.getDefaultData(type, code, false);
        });
      }
    },

    // 权限修改成功
    updatePowerSuccess: function updatePowerSuccess() {
      this.powerPop.show = false;
    },

    // 表格工具栏命令事件
    handleTableCommand: function handleTableCommand(command, idx, item) {
      if (command === 'showAddPowerPop') {
        // 2 代表角色(标签)
        this[command](2, item.LbCode);
      } else {
        this[command](idx, item);
      }
    }
  }
});

/***/ }),
/* 328 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_common_tools__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_system_ModuleForm__ = __webpack_require__(680);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_system_ModuleForm___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_system_ModuleForm__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_common_tree__ = __webpack_require__(36);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// import $ from 'jquery'
// import mixin from '@/components/common/mixin'




// import storeTools from '@/store/tools'
// import storeConfig from '@/store/system'
// import * as types from '@/store/mutation-types'

// 请求相关操作
var page = {
  methods: {
    // 获得菜单
    getModuleListDataAjax: function getModuleListDataAjax() {
      var _this = this;

      __WEBPACK_IMPORTED_MODULE_0__components_common_tools__["a" /* default */].commonAjax.call(this, true, '/SystemManage/GetModuleList', {
        All: 1,
        OrderName: 'MO_SORT'
      }).then(function (res) {
        var result = res.data;
        result.push({
          MoFacode: '-1',
          MoCode: '0',
          MoName: 'All'
        });
        result.push({
          MoFacode: '0',
          MoCode: '-100',
          MoName: 'Other'
        });
        _this.moduleData = result;
        // this.dataStore.commit(types.UPDATE_MODULE, result)
      });
    },

    // 删除操作
    delDataAjax: function delDataAjax(id) {
      var _this2 = this;

      __WEBPACK_IMPORTED_MODULE_0__components_common_tools__["a" /* default */].commonAjax.call(this, true, '/SystemManage/DeleteModule', {
        Id: id
      }).then(function () {
        _this2.$message.success('delete success!');
        // 重新获取数据
        _this2.getModuleListDataAjax();
        // 重新获取登录用户信息
        _this2.$store.dispatch('getLoginMemberInfo', false);
      });
    }
  }

  // 菜单树
};var moduleTree = new __WEBPACK_IMPORTED_MODULE_2__components_common_tree__["a" /* default */].TreeCreate(function (item) {
  for (var key in item) {
    if (item.hasOwnProperty(key)) {
      this[key] = item[key];
    }
  }
}, { FId: 'MoFacode', Id: 'MoCode' });

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'ModuleManagement',
  mixins: [page],
  components: {
    ModuleForm: __WEBPACK_IMPORTED_MODULE_1__components_system_ModuleForm___default.a
  },
  created: function created() {
    this.getModuleListDataAjax();
  },
  data: function data() {
    return {
      // dataStore: storeTools.create(storeConfig),
      moduleData: [],
      moduleProp: {
        id: 'MoCode',
        label: 'MoName',
        level: '_level',
        children: 'children'
      },
      tree: {
        current: null
      },
      page: {
        popShow: false
      }
    };
  },

  computed: {
    // moduleData() {
    //   return this.dataStore.state.moduleData
    // },
    // moduleProp() {
    //   return this.dataStore.state.moduleProp
    // },
    // 侧边树数据
    treeData: function treeData() {
      var treeFlatData = this.moduleData.filter(function (item) {
        return !item.IsLeaf;
      });
      moduleTree.create(treeFlatData);
      var treeData = moduleTree.getTreeData();
      if (treeData[0]) {
        this.tree.current = treeData[0];
      }
      return treeData;
    },

    // 表格数据
    tableData: function tableData() {
      var _this3 = this;

      return this.moduleData.filter(function (item) {
        if (_this3.tree.current) {
          if (_this3.tree.current.MoCode === '-100') {
            // 其他(直接挂在根节点的菜单)
            return !!item.IsLeaf && item.MoFacode === '0';
          } else {
            return !!item.IsLeaf && item.MoFacode === _this3.tree.current.MoCode;
          }
        } else {
          return false;
        }
      });
    }
  },
  methods: {
    // 树节点点击事件
    clickModuleTree: function clickModuleTree(item) {
      var current = this.tree.current;
      if (current.MoCode !== item.MoCode) {
        this.tree.current = item;
      }
    },

    // 渲染树节点内容
    renderTreeItemContent: function renderTreeItemContent(h, _ref) {
      var _this4 = this;

      var node = _ref.node,
          data = _ref.data,
          store = _ref.store;

      return h('span', [h('span', [h('span', [node.label])]), h(
        'span',
        { style: 'float: right; margin-right: 20px', directives: [{
            name: 'show',
            value: data.Id
          }]
        },
        [h(
          'el-button',
          {
            attrs: { size: 'mini' },
            on: {
              'click': function click() {
                return _this4.showUpdatePop(store, data);
              }
            }
          },
          ['edit']
        ), h(
          'el-button',
          {
            attrs: { size: 'mini' },
            on: {
              'click': function click() {
                return _this4.handleDel(store, data);
              }
            }
          },
          ['delete']
        )]
      )]);
    },

    // 显示add弹出层
    showAddPop: function showAddPop() {
      this.page.popShow = true;
      this.$nextTick(function () {
        this.$refs.popForm.resetValue();
      });
    },

    // 显示修改弹出层
    showUpdatePop: function showUpdatePop(idx, item) {
      this.page.popShow = true;
      this.$nextTick(function () {
        this.$refs.popForm.setValue(item);
      });
    },

    // add操作
    handleAdd: function handleAdd() {
      // 重新获取数据
      this.getModuleListDataAjax();
      this.page.popShow = false;
    },

    // 修改操作
    handleUpdate: function handleUpdate() {
      // 重新获取数据
      this.getModuleListDataAjax();
      this.page.popShow = false;
    },

    // 删除操作
    handleDel: function handleDel(idx, item) {
      var _this5 = this;

      this.$confirm('This will permanently delete the record', 'prompt', {
        confirmButtonText: 'Confirm',
        cancelButtonText: 'Canel',
        type: 'warning'
      }).then(function () {
        _this5.delDataAjax(item.Id);
      });
    }
  }
});

/***/ }),
/* 329 */,
/* 330 */,
/* 331 */,
/* 332 */,
/* 333 */,
/* 334 */,
/* 335 */,
/* 336 */,
/* 337 */,
/* 338 */,
/* 339 */,
/* 340 */,
/* 341 */,
/* 342 */,
/* 343 */,
/* 344 */,
/* 345 */,
/* 346 */,
/* 347 */,
/* 348 */,
/* 349 */,
/* 350 */,
/* 351 */,
/* 352 */,
/* 353 */,
/* 354 */,
/* 355 */,
/* 356 */,
/* 357 */,
/* 358 */,
/* 359 */,
/* 360 */,
/* 361 */,
/* 362 */,
/* 363 */,
/* 364 */,
/* 365 */,
/* 366 */,
/* 367 */,
/* 368 */,
/* 369 */,
/* 370 */,
/* 371 */,
/* 372 */,
/* 373 */,
/* 374 */,
/* 375 */,
/* 376 */,
/* 377 */,
/* 378 */,
/* 379 */,
/* 380 */,
/* 381 */,
/* 382 */,
/* 383 */,
/* 384 */,
/* 385 */,
/* 386 */,
/* 387 */,
/* 388 */,
/* 389 */,
/* 390 */,
/* 391 */,
/* 392 */,
/* 393 */,
/* 394 */,
/* 395 */,
/* 396 */,
/* 397 */,
/* 398 */,
/* 399 */,
/* 400 */,
/* 401 */,
/* 402 */,
/* 403 */,
/* 404 */,
/* 405 */,
/* 406 */,
/* 407 */,
/* 408 */,
/* 409 */,
/* 410 */,
/* 411 */,
/* 412 */,
/* 413 */,
/* 414 */,
/* 415 */,
/* 416 */,
/* 417 */,
/* 418 */,
/* 419 */,
/* 420 */,
/* 421 */,
/* 422 */,
/* 423 */,
/* 424 */,
/* 425 */,
/* 426 */,
/* 427 */,
/* 428 */,
/* 429 */,
/* 430 */,
/* 431 */,
/* 432 */,
/* 433 */,
/* 434 */,
/* 435 */,
/* 436 */,
/* 437 */,
/* 438 */,
/* 439 */,
/* 440 */,
/* 441 */,
/* 442 */,
/* 443 */,
/* 444 */,
/* 445 */,
/* 446 */,
/* 447 */,
/* 448 */,
/* 449 */,
/* 450 */,
/* 451 */,
/* 452 */,
/* 453 */,
/* 454 */,
/* 455 */,
/* 456 */,
/* 457 */,
/* 458 */,
/* 459 */,
/* 460 */,
/* 461 */,
/* 462 */,
/* 463 */,
/* 464 */,
/* 465 */,
/* 466 */,
/* 467 */,
/* 468 */,
/* 469 */,
/* 470 */,
/* 471 */,
/* 472 */,
/* 473 */,
/* 474 */,
/* 475 */,
/* 476 */,
/* 477 */,
/* 478 */,
/* 479 */,
/* 480 */,
/* 481 */,
/* 482 */,
/* 483 */,
/* 484 */,
/* 485 */,
/* 486 */,
/* 487 */,
/* 488 */,
/* 489 */,
/* 490 */,
/* 491 */,
/* 492 */,
/* 493 */,
/* 494 */,
/* 495 */,
/* 496 */,
/* 497 */,
/* 498 */,
/* 499 */,
/* 500 */,
/* 501 */,
/* 502 */,
/* 503 */,
/* 504 */,
/* 505 */,
/* 506 */,
/* 507 */,
/* 508 */,
/* 509 */,
/* 510 */,
/* 511 */,
/* 512 */,
/* 513 */,
/* 514 */,
/* 515 */,
/* 516 */,
/* 517 */,
/* 518 */,
/* 519 */,
/* 520 */,
/* 521 */,
/* 522 */,
/* 523 */,
/* 524 */,
/* 525 */,
/* 526 */,
/* 527 */,
/* 528 */,
/* 529 */,
/* 530 */,
/* 531 */,
/* 532 */,
/* 533 */,
/* 534 */,
/* 535 */,
/* 536 */,
/* 537 */,
/* 538 */,
/* 539 */,
/* 540 */,
/* 541 */,
/* 542 */,
/* 543 */,
/* 544 */,
/* 545 */,
/* 546 */,
/* 547 */,
/* 548 */,
/* 549 */,
/* 550 */,
/* 551 */,
/* 552 */,
/* 553 */,
/* 554 */,
/* 555 */,
/* 556 */,
/* 557 */,
/* 558 */,
/* 559 */,
/* 560 */,
/* 561 */,
/* 562 */,
/* 563 */,
/* 564 */,
/* 565 */,
/* 566 */,
/* 567 */,
/* 568 */,
/* 569 */,
/* 570 */,
/* 571 */,
/* 572 */,
/* 573 */,
/* 574 */,
/* 575 */,
/* 576 */,
/* 577 */,
/* 578 */,
/* 579 */,
/* 580 */,
/* 581 */,
/* 582 */,
/* 583 */,
/* 584 */,
/* 585 */,
/* 586 */,
/* 587 */,
/* 588 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 589 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 590 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 591 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 592 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 593 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 594 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 595 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 596 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 597 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 598 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 599 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 600 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 601 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 602 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 603 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 604 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 605 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 606 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 607 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 608 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 609 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 610 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 611 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 612 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 613 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 614 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 615 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 616 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 617 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 618 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 619 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 620 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 621 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 622 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 623 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 624 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 625 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 626 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 627 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 628 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 629 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 630 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 631 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 632 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 633 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 634 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 635 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 636 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 637 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 638 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 639 */,
/* 640 */,
/* 641 */,
/* 642 */,
/* 643 */,
/* 644 */,
/* 645 */,
/* 646 */,
/* 647 */,
/* 648 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(612)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(250),
  /* template */
  __webpack_require__(756),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 649 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(605)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(251),
  /* template */
  __webpack_require__(749),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 650 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(600)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(252),
  /* template */
  __webpack_require__(740),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 651 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(253),
  /* template */
  __webpack_require__(728),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 652 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(254),
  /* template */
  __webpack_require__(727),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 653 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(255),
  /* template */
  __webpack_require__(734),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 654 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(256),
  /* template */
  __webpack_require__(759),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 655 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(257),
  /* template */
  __webpack_require__(780),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 656 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(258),
  /* template */
  __webpack_require__(786),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 657 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(259),
  /* template */
  __webpack_require__(790),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 658 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(260),
  /* template */
  __webpack_require__(791),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 659 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(261),
  /* template */
  __webpack_require__(782),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 660 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(262),
  /* template */
  __webpack_require__(725),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 661 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(263),
  /* template */
  __webpack_require__(779),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 662 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(264),
  /* template */
  __webpack_require__(768),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 663 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(265),
  /* template */
  __webpack_require__(792),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 664 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(266),
  /* template */
  __webpack_require__(731),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 665 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(267),
  /* template */
  __webpack_require__(741),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 666 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(269),
  /* template */
  __webpack_require__(746),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 667 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(270),
  /* template */
  __webpack_require__(788),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 668 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(271),
  /* template */
  __webpack_require__(775),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 669 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(272),
  /* template */
  __webpack_require__(729),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 670 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(273),
  /* template */
  __webpack_require__(747),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 671 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(593)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(274),
  /* template */
  __webpack_require__(730),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 672 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(275),
  /* template */
  __webpack_require__(737),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 673 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(276),
  /* template */
  __webpack_require__(761),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 674 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(277),
  /* template */
  __webpack_require__(783),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 675 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(278),
  /* template */
  __webpack_require__(721),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 676 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(279),
  /* template */
  __webpack_require__(744),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 677 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(280),
  /* template */
  __webpack_require__(774),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 678 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(281),
  /* template */
  __webpack_require__(796),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 679 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(282),
  /* template */
  __webpack_require__(760),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 680 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(628)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(283),
  /* template */
  __webpack_require__(784),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 681 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(284),
  /* template */
  __webpack_require__(767),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 682 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(626)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(290),
  /* template */
  __webpack_require__(777),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 683 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(608)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(292),
  /* template */
  __webpack_require__(752),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 684 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(602)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(293),
  /* template */
  __webpack_require__(743),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 685 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(611)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(294),
  /* template */
  __webpack_require__(755),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 686 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(592)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(295),
  /* template */
  __webpack_require__(726),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 687 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(636)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(296),
  /* template */
  __webpack_require__(798),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 688 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(633)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(297),
  /* template */
  __webpack_require__(794),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 689 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(591)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(298),
  /* template */
  __webpack_require__(724),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 690 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(632)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(299),
  /* template */
  __webpack_require__(793),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 691 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(625)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(300),
  /* template */
  __webpack_require__(776),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 692 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(596)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(301),
  /* template */
  __webpack_require__(735),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 693 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(627)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(302),
  /* template */
  __webpack_require__(781),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 694 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(603)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(303),
  /* template */
  __webpack_require__(745),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 695 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(594)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(304),
  /* template */
  __webpack_require__(732),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 696 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(599)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(305),
  /* template */
  __webpack_require__(739),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 697 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(624)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(306),
  /* template */
  __webpack_require__(773),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 698 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(616)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(307),
  /* template */
  __webpack_require__(763),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 699 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(604)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(308),
  /* template */
  __webpack_require__(748),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 700 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(638)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(309),
  /* template */
  __webpack_require__(800),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 701 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(617)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(310),
  /* template */
  __webpack_require__(764),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 702 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(623)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(311),
  /* template */
  __webpack_require__(772),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 703 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(622)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(312),
  /* template */
  __webpack_require__(771),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 704 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(595)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(313),
  /* template */
  __webpack_require__(733),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 705 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(620)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(314),
  /* template */
  __webpack_require__(769),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 706 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(631)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(315),
  /* template */
  __webpack_require__(789),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 707 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(619)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(316),
  /* template */
  __webpack_require__(766),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 708 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(637)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(317),
  /* template */
  __webpack_require__(799),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 709 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(629)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(318),
  /* template */
  __webpack_require__(785),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 710 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(606)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(319),
  /* template */
  __webpack_require__(750),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 711 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(590)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(320),
  /* template */
  __webpack_require__(723),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 712 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(613)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(321),
  /* template */
  __webpack_require__(757),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 713 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(610)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(322),
  /* template */
  __webpack_require__(754),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 714 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(630)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(323),
  /* template */
  __webpack_require__(787),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 715 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(634)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(324),
  /* template */
  __webpack_require__(795),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 716 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(614)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(325),
  /* template */
  __webpack_require__(758),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 717 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(598)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(326),
  /* template */
  __webpack_require__(738),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 718 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(635)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(327),
  /* template */
  __webpack_require__(797),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 719 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(607)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(328),
  /* template */
  __webpack_require__(751),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 720 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(249),
  /* template */
  __webpack_require__(722),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 721 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "width-box w400"
  }, [(_vm.formData) ? _c('el-form', {
    ref: "commonForm",
    staticClass: "pop-form-wrap",
    attrs: {
      "label-width": "80px",
      "model": _vm.formData
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "name",
      "prop": "CtName"
    }
  }, [_c('el-input', {
    attrs: {
      "size": "small",
      "placeholder": "Please enter the content"
    },
    model: {
      value: (_vm.formData.CtName),
      callback: function($$v) {
        _vm.$set(_vm.formData, "CtName", $$v)
      },
      expression: "formData.CtName"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "sort",
      "prop": "Sort"
    }
  }, [_c('el-input', {
    attrs: {
      "size": "small",
      "placeholder": "Please enter the content"
    },
    model: {
      value: (_vm.formData.Sort),
      callback: function($$v) {
        _vm.$set(_vm.formData, "Sort", $$v)
      },
      expression: "formData.Sort"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "pop-center-btn-wrap"
  }, [(!_vm.formData.Id) ? _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.doAdd('commonForm')
      }
    }
  }, [_vm._v("Add")]) : _vm._e(), _vm._v(" "), (_vm.formData.Id) ? _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.doUpdate('commonForm')
      }
    }
  }, [_vm._v("Save")]) : _vm._e()], 1)], 1) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 722 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('script', {
    attrs: {
      "id": _vm.randomId,
      "name": "content",
      "type": "text/plain"
    }
  })
},staticRenderFns: []}

/***/ }),
/* 723 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "common-page-main main-page"
  }, [_c('div', {
    staticClass: "field-box scroll-cotar"
  }, [_c('div', {
    staticClass: "page-top-bar cfa"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "rfp"
  }, [_c('div', {
    directives: [{
      name: "fileuploadk3",
      rawName: "v-fileuploadk3"
    }],
    staticStyle: {
      "display": "inline-block"
    },
    on: {
      "upload-change": _vm.uploadSuccess
    }
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    }
  }, [_vm._v("Upload price Excel")])], 1), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.exportPopShow = true;
        _vm.selectUser = ''
      }
    }
  }, [_vm._v("Export")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "page-table table-wrap"
  }, [_c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.table.isLoading),
      expression: "table.isLoading"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.table.data,
      "element-loading-text": "Loading"
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": "Product code",
      "prop": "Model",
      "min-width": "120"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "W",
      "prop": "Width",
      "min-width": "70"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "L",
      "prop": "Length",
      "min-width": "70"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Quantity",
      "prop": "Num",
      "min-width": "90"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Delivery date",
      "prop": "SupplyDay",
      "min-width": "110"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Unit price    (tax free)",
      "width": "110"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n            " + _vm._s(_vm._f("priceHandle")(scope.row.PriceNoTax)) + "\n          ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Unit price    (tax included)",
      "width": "110"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n            " + _vm._s(_vm._f("priceHandle")(scope.row.Price)) + "\n          ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Total           (tax free)",
      "width": "100"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n            " + _vm._s(_vm._f("priceHandle")(scope.row.AllPriceNoTax)) + "\n          ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Total             (tax included)",
      "width": "120"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n            " + _vm._s(_vm._f("priceHandle")(scope.row.AllPrice)) + "\n          ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Submit account",
      "prop": "Account",
      "min-width": "130"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Submit date",
      "min-width": "110"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n            " + _vm._s(_vm._f("dateFormat")(scope.row.CreateTime)) + "\n          ")]
      }
    }])
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "page-wrap"
  }, [_c('el-pagination', {
    attrs: {
      "current-page": _vm.table.currentPage,
      "page-size": _vm.table.pageSize,
      "layout": "total, prev, pager, next",
      "total": _vm.table.pageTotal
    },
    on: {
      "current-change": _vm.handleTableCurrentChange
    }
  })], 1)]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "Export",
      "size": "tine"
    },
    model: {
      value: (_vm.exportPopShow),
      callback: function($$v) {
        _vm.exportPopShow = $$v
      },
      expression: "exportPopShow"
    }
  }, [_c('ExportForm', {
    attrs: {
      "url": "/Ajax/ProductListToExcelInAdmin",
      "extraData": {
        Account: _vm.selectUser,
        lang: 1
      }
    },
    on: {
      "FormClose": function($event) {
        _vm.exportPopShow = false
      }
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Account"
    }
  }, [_c('el-select', {
    attrs: {
      "filterable": "",
      "clearable": "",
      "placeholder": "Please select user account"
    },
    model: {
      value: (_vm.selectUser),
      callback: function($$v) {
        _vm.selectUser = $$v
      },
      expression: "selectUser"
    }
  }, _vm._l((_vm.userData), function(item, idx) {
    return _c('el-option', {
      key: idx,
      attrs: {
        "label": item.Account,
        "value": item.Account
      }
    })
  }), 1)], 1)], 1)], 1)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "headline lfp"
  }, [_c('span', [_vm._v("Online inquiry view")])])
}]}

/***/ }),
/* 724 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "common-page-main main-page"
  }, [_c('div', {
    staticClass: "field-box scroll-cotar"
  }, [_c('div', {
    staticClass: "page-top-bar cfa"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "rfp"
  }, [(_vm.$route.query.code) ? _c('el-button', {
    attrs: {
      "size": "small",
      "icon": "plus",
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.showAddPop()
      }
    }
  }, [_vm._v("add")]) : _vm._e(), _vm._v(" "), (_vm.$route.query.code != null) ? _c('el-button', {
    attrs: {
      "size": "small",
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.goBack()
      }
    }
  }, [_vm._v("back")]) : _vm._e()], 1)]), _vm._v(" "), _c('div', {
    staticClass: "table-wrap"
  }, [_c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.table.isLoading),
      expression: "table.isLoading"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.table.data,
      "element-loading-text": "LOADING"
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "NbName",
      "label": "Name"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "NbUrl",
      "label": "Skip Url"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "NbSort",
      "label": "Sort"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Operate"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "size": "small"
          },
          on: {
            "click": function($event) {
              return _vm.showUpdatePop(scope.$index, scope.row)
            }
          }
        }, [_vm._v("edit")]), _vm._v(" "), (_vm.$route.query.code == null) ? _c('el-button', {
          attrs: {
            "size": "small"
          },
          on: {
            "click": function($event) {
              return _vm.SkipNextGrade(scope.$index, scope.row)
            }
          }
        }, [_vm._v("next level")]) : _vm._e(), _vm._v(" "), (scope.row.NbUrl) ? _c('copy-btn', {
          attrs: {
            "text": scope.row.NbUrl
          }
        }, [_vm._v("copy link")]) : _vm._e()]
      }
    }])
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "page-wrap"
  }, [_c('el-pagination', {
    attrs: {
      "current-page": _vm.table.currentPage,
      "page-size": _vm.table.pageSize,
      "layout": "total, prev, pager, next",
      "total": _vm.table.pageTotal
    },
    on: {
      "current-change": _vm.handleTableCurrentChange
    }
  })], 1)]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "Navigateion Detail",
      "visible": _vm.page.popShow,
      "size": "tine"
    },
    on: {
      "update:visible": function($event) {
        return _vm.$set(_vm.page, "popShow", $event)
      }
    }
  }, [_c('NavigateionForm', {
    ref: "popForm",
    on: {
      "addSuccess": _vm.handleAdd,
      "updateSuccess": _vm.handleUpdate
    }
  })], 1)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "headline lfp"
  }, [_c('span', [_vm._v("Navigateion Manage")])])
}]}

/***/ }),
/* 725 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "width-box w600"
  }, [(_vm.formData) ? _c('el-form', {
    ref: "projectInfoForm",
    staticClass: "pop-form-wrap",
    attrs: {
      "label-width": "100px",
      "model": _vm.formData
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Name",
      "prop": "PtName"
    }
  }, [_c('el-input', {
    attrs: {
      "size": "small"
    },
    model: {
      value: (_vm.formData.PtName),
      callback: function($$v) {
        _vm.$set(_vm.formData, "PtName", $$v)
      },
      expression: "formData.PtName"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Describe",
      "prop": "PtDescribe"
    }
  }, [_c('el-input', {
    attrs: {
      "size": "small",
      "type": "textarea"
    },
    model: {
      value: (_vm.formData.PtDescribe),
      callback: function($$v) {
        _vm.$set(_vm.formData, "PtDescribe", $$v)
      },
      expression: "formData.PtDescribe"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Sort",
      "prop": "PtSort"
    }
  }, [_c('el-input', {
    attrs: {
      "size": "small"
    },
    model: {
      value: (_vm.formData.PtSort),
      callback: function($$v) {
        _vm.$set(_vm.formData, "PtSort", _vm._n($$v))
      },
      expression: "formData.PtSort"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Is Leaf",
      "prop": "IsLeaf"
    }
  }, [_c('el-switch', {
    attrs: {
      "on-text": "",
      "off-text": ""
    },
    model: {
      value: (_vm.formData.IsLeaf),
      callback: function($$v) {
        _vm.$set(_vm.formData, "IsLeaf", $$v)
      },
      expression: "formData.IsLeaf"
    }
  })], 1), _vm._v(" "), _c('el-form-item', [_c('div', {
    staticClass: "pop-center-btn-wrap"
  }, [(!_vm.formData.Id) ? _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.doAdd('projectInfoForm')
      }
    }
  }, [_vm._v("add")]) : _vm._e(), _vm._v(" "), (_vm.formData.Id) ? _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.doUpdate('projectInfoForm')
      }
    }
  }, [_vm._v("save")]) : _vm._e()], 1)])], 1) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 726 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "common-page-main main-page"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.page.popShow),
      expression: "!page.popShow"
    }],
    staticClass: "field-box scroll-cotar"
  }, [_c('div', {
    staticClass: "page-top-bar cfa"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.tree.current),
      expression: "tree.current"
    }],
    staticClass: "rfp"
  }, [(_vm.tree.current !== null && _vm.tree.current.IsLeaf === 1) ? _c('el-button', {
    attrs: {
      "size": "small",
      "icon": "plus",
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.showAddPop()
      }
    }
  }, [_vm._v("add")]) : _vm._e()], 1)]), _vm._v(" "), _c('div', {
    staticClass: "content-wrap"
  }, [_c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_c('div', {
    staticClass: "page-left-wrap"
  }, [_c('div', {
    staticClass: "sub-top-bar cfa"
  }, [_c('div', {
    staticClass: "title lfp"
  }, [_vm._v("Down file type")])]), _vm._v(" "), _c('el-tree', {
    attrs: {
      "data": _vm.tree.data,
      "props": _vm.tree.prop,
      "expand-on-click-node": false,
      "highlight-current": true
    },
    on: {
      "node-click": _vm.clickModuleTree
    }
  })], 1)]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 18
    }
  }, [_c('div', {
    staticClass: "page-right-wrap"
  }, [(_vm.tree.current) ? _c('div', {
    staticClass: "sub-top-bar cfa"
  }, [_c('div', {
    staticClass: "title lfp"
  }, [_vm._v(_vm._s(_vm.tree.current.DtName))])]) : _vm._e(), _vm._v(" "), _c('el-table', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.table.data,
      "element-loading-text": "LOADING"
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "DiTitle",
      "label": "Name"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "DiSort",
      "label": "Sort"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Operate"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "size": "small"
          },
          on: {
            "click": function($event) {
              return _vm.showUpdatePop(scope.$index, scope.row)
            }
          }
        }, [_vm._v("edit")]), _vm._v(" "), _c('el-button', {
          attrs: {
            "size": "small"
          },
          on: {
            "click": function($event) {
              return _vm.handleDel(scope.$index, scope.row)
            }
          }
        }, [_vm._v("delete")])]
      }
    }])
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "page-wrap"
  }, [_c('el-pagination', {
    attrs: {
      "current-page": _vm.table.currentPage,
      "page-size": _vm.table.pageSize,
      "layout": "total, prev, pager, next",
      "total": _vm.table.pageTotal
    },
    on: {
      "current-change": _vm.handleTableCurrentChange
    }
  })], 1)], 1)])], 1)], 1)]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.page.popShow),
      expression: "page.popShow"
    }],
    staticClass: "field-box scroll-cotar"
  }, [_c('div', {
    staticClass: "page-top-bar cfa"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "rfp"
  }, [_c('el-button', {
    attrs: {
      "size": "small",
      "type": "danger"
    },
    on: {
      "click": function($event) {
        _vm.page.popShow = false
      }
    }
  }, [_vm._v("Close")])], 1)]), _vm._v(" "), _c('DownfileForm', {
    ref: "popForm",
    attrs: {
      "sideCurrent": _vm.tree.current
    },
    on: {
      "addSuccess": _vm.handleAdd,
      "updateSuccess": _vm.handleUpdate
    }
  })], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "headline lfp"
  }, [_c('span', [_vm._v("Down File Management")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "headline lfp"
  }, [_c('span', [_vm._v("Down File Detail")])])
}]}

/***/ }),
/* 727 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "width-box w600"
  }, [(_vm.formData) ? _c('el-form', {
    ref: "projectInfoForm",
    staticClass: "pop-form-wrap",
    attrs: {
      "label-width": "100px",
      "model": _vm.formData
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Name",
      "prop": "CtName"
    }
  }, [_c('el-input', {
    attrs: {
      "size": "small"
    },
    model: {
      value: (_vm.formData.CtName),
      callback: function($$v) {
        _vm.$set(_vm.formData, "CtName", $$v)
      },
      expression: "formData.CtName"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Sort",
      "prop": "CtSort"
    }
  }, [_c('el-input', {
    attrs: {
      "size": "small"
    },
    model: {
      value: (_vm.formData.CtSort),
      callback: function($$v) {
        _vm.$set(_vm.formData, "CtSort", _vm._n($$v))
      },
      expression: "formData.CtSort"
    }
  })], 1), _vm._v(" "), _c('el-form-item', [_c('div', {
    staticClass: "pop-center-btn-wrap"
  }, [(!_vm.formData.Id) ? _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.doAdd('projectInfoForm')
      }
    }
  }, [_vm._v("add")]) : _vm._e(), _vm._v(" "), (_vm.formData.Id) ? _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.doUpdate('projectInfoForm')
      }
    }
  }, [_vm._v("save")]) : _vm._e()], 1)])], 1) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 728 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "width-box w1000"
  }, [(_vm.formData) ? _c('el-form', {
    ref: "commonForm",
    staticClass: "pop-form-wrap",
    attrs: {
      "label-width": "100px",
      "model": _vm.formData
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Name",
      "prop": "CiName"
    }
  }, [_c('el-input', {
    attrs: {
      "size": "small"
    },
    model: {
      value: (_vm.formData.CiName),
      callback: function($$v) {
        _vm.$set(_vm.formData, "CiName", $$v)
      },
      expression: "formData.CiName"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Author",
      "prop": "CiAuthor"
    }
  }, [_c('el-input', {
    attrs: {
      "size": "small"
    },
    model: {
      value: (_vm.formData.CiAuthor),
      callback: function($$v) {
        _vm.$set(_vm.formData, "CiAuthor", $$v)
      },
      expression: "formData.CiAuthor"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Img",
      "prop": "CiImg"
    }
  }, [_c('img-upload', {
    attrs: {
      "tip": "Image recommended size：400*240"
    },
    model: {
      value: (_vm.formData.CiImg),
      callback: function($$v) {
        _vm.$set(_vm.formData, "CiImg", $$v)
      },
      expression: "formData.CiImg"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Describe",
      "prop": "CiDescribe"
    }
  }, [_c('el-input', {
    attrs: {
      "size": "small",
      "type": "textarea"
    },
    model: {
      value: (_vm.formData.CiDescribe),
      callback: function($$v) {
        _vm.$set(_vm.formData, "CiDescribe", $$v)
      },
      expression: "formData.CiDescribe"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Sort",
      "prop": "CiSort"
    }
  }, [_c('el-input', {
    attrs: {
      "size": "small"
    },
    model: {
      value: (_vm.formData.CiSort),
      callback: function($$v) {
        _vm.$set(_vm.formData, "CiSort", _vm._n($$v))
      },
      expression: "formData.CiSort"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Is Release",
      "prop": "IsRelease"
    }
  }, [_c('el-switch', {
    attrs: {
      "on-text": "",
      "off-text": ""
    },
    model: {
      value: (_vm.formData.IsRelease),
      callback: function($$v) {
        _vm.$set(_vm.formData, "IsRelease", $$v)
      },
      expression: "formData.IsRelease"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Release Time",
      "prop": "ReleaseTime"
    }
  }, [_c('el-date-picker', {
    attrs: {
      "type": "date",
      "picker-options": _vm.pickerOptions0
    },
    model: {
      value: (_vm.formData.ReleaseTime),
      callback: function($$v) {
        _vm.$set(_vm.formData, "ReleaseTime", $$v)
      },
      expression: "formData.ReleaseTime"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Case Content",
      "prop": "CiContent"
    }
  }, [_c('mc-editor', {
    ref: "editCiContent",
    model: {
      value: (_vm.formData.CiContent),
      callback: function($$v) {
        _vm.$set(_vm.formData, "CiContent", $$v)
      },
      expression: "formData.CiContent"
    }
  })], 1), _vm._v(" "), _c('el-form-item', [_c('div', {
    staticClass: "pop-center-btn-wrap"
  }, [(!_vm.formData.Id) ? _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.doAdd('commonForm')
      }
    }
  }, [_vm._v("add")]) : _vm._e(), _vm._v(" "), (_vm.formData.Id) ? _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.doUpdate('commonForm')
      }
    }
  }, [_vm._v("save")]) : _vm._e()], 1)])], 1) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 729 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "width-box w1000"
  }, [(_vm.formData) ? _c('el-form', {
    ref: "projectInfoForm",
    staticClass: "pop-form-wrap",
    attrs: {
      "label-width": "100px",
      "model": _vm.formData
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Img",
      "prop": "CpImg"
    }
  }, [_c('img-upload', {
    attrs: {
      "tip": "Image recommended size：400*240"
    },
    model: {
      value: (_vm.formData.CpImg),
      callback: function($$v) {
        _vm.$set(_vm.formData, "CpImg", $$v)
      },
      expression: "formData.CpImg"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Name",
      "prop": "CpName"
    }
  }, [_c('el-input', {
    attrs: {
      "size": "small"
    },
    model: {
      value: (_vm.formData.CpName),
      callback: function($$v) {
        _vm.$set(_vm.formData, "CpName", $$v)
      },
      expression: "formData.CpName"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Describe",
      "prop": "CpDescribe"
    }
  }, [_c('el-input', {
    attrs: {
      "size": "small",
      "type": "textarea"
    },
    model: {
      value: (_vm.formData.CpDescribe),
      callback: function($$v) {
        _vm.$set(_vm.formData, "CpDescribe", $$v)
      },
      expression: "formData.CpDescribe"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Sort",
      "prop": "CpSort"
    }
  }, [_c('el-input', {
    attrs: {
      "size": "small"
    },
    model: {
      value: (_vm.formData.CpSort),
      callback: function($$v) {
        _vm.$set(_vm.formData, "CpSort", _vm._n($$v))
      },
      expression: "formData.CpSort"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Content",
      "prop": "CpContent"
    }
  }, [_c('mc-editor', {
    ref: "editContent",
    model: {
      value: (_vm.formData.CpContent),
      callback: function($$v) {
        _vm.$set(_vm.formData, "CpContent", $$v)
      },
      expression: "formData.CpContent"
    }
  })], 1), _vm._v(" "), _c('el-form-item', [_c('div', {
    staticClass: "pop-center-btn-wrap"
  }, [(!_vm.formData.Id) ? _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.doAdd('projectInfoForm')
      }
    }
  }, [_vm._v("add")]) : _vm._e(), _vm._v(" "), (_vm.formData.Id) ? _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.doUpdate('projectInfoForm')
      }
    }
  }, [_vm._v("save")]) : _vm._e()], 1)])], 1) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 730 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('el-tabs', [_c('el-tab-pane', {
    attrs: {
      "label": "BaseInfo Configuration"
    }
  }, [(_vm.formData) ? _c('el-form', {
    ref: "projectInfoForm",
    staticClass: "pop-form-wrap width-box w600",
    attrs: {
      "label-width": "100px",
      "model": _vm.formData
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Seo Title",
      "prop": "ScSeoTitle"
    }
  }, [_c('el-input', {
    attrs: {
      "size": "small"
    },
    model: {
      value: (_vm.formData.ScSeoTitle),
      callback: function($$v) {
        _vm.$set(_vm.formData, "ScSeoTitle", $$v)
      },
      expression: "formData.ScSeoTitle"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Seo Description",
      "prop": "ScSeoDescription"
    }
  }, [_c('el-input', {
    attrs: {
      "size": "small",
      "autosize": {
        minRows: 4
      },
      "type": "textarea"
    },
    model: {
      value: (_vm.formData.ScSeoDescription),
      callback: function($$v) {
        _vm.$set(_vm.formData, "ScSeoDescription", $$v)
      },
      expression: "formData.ScSeoDescription"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Seo Key",
      "prop": "ScSeoKey"
    }
  }, [_vm._l((_vm.dynamicTags), function(tag) {
    return _c('el-tag', {
      key: tag,
      attrs: {
        "closable": "",
        "disable-transitions": false
      },
      on: {
        "close": function($event) {
          return _vm.handleClose(tag)
        }
      }
    }, [_vm._v("\n            " + _vm._s(tag) + "\n          ")])
  }), _vm._v(" "), (_vm.inputVisible) ? _c('el-input', {
    ref: "saveTagInput",
    staticClass: "input-new-tag",
    attrs: {
      "size": "small"
    },
    on: {
      "blur": _vm.handleInputConfirm
    },
    nativeOn: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.handleInputConfirm($event)
      }
    },
    model: {
      value: (_vm.inputValue),
      callback: function($$v) {
        _vm.inputValue = $$v
      },
      expression: "inputValue"
    }
  }) : _c('el-button', {
    staticClass: "button-new-tag",
    attrs: {
      "size": "small"
    },
    on: {
      "click": _vm.showInput
    }
  }, [_vm._v("+ New Tag")])], 2), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Custom Telephone",
      "prop": "ScTelephone"
    }
  }, [_c('el-input', {
    attrs: {
      "size": "small"
    },
    model: {
      value: (_vm.formData.ScTelephone),
      callback: function($$v) {
        _vm.$set(_vm.formData, "ScTelephone", $$v)
      },
      expression: "formData.ScTelephone"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Company Email",
      "prop": "ScEmail"
    }
  }, [_c('el-input', {
    attrs: {
      "size": "small"
    },
    model: {
      value: (_vm.formData.ScEmail),
      callback: function($$v) {
        _vm.$set(_vm.formData, "ScEmail", $$v)
      },
      expression: "formData.ScEmail"
    }
  })], 1), _vm._v(" "), _c('el-form-item', [_c('div', {
    staticClass: "pop-center-btn-wrap"
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.doUpdate('projectInfoForm')
      }
    }
  }, [_vm._v("Save")])], 1)])], 1) : _vm._e()], 1), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": "Advanced Configuration"
    }
  }, [(_vm.formData) ? _c('el-form', {
    ref: "infoForm",
    staticClass: "pop-form-wrap width-box w600",
    attrs: {
      "label-width": "100px",
      "model": _vm.formData
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Statistical Code",
      "prop": "ScStatisticalcode"
    }
  }, [_c('el-input', {
    attrs: {
      "size": "small",
      "type": "textarea"
    },
    model: {
      value: (_vm.formData.ScStatisticalcode),
      callback: function($$v) {
        _vm.$set(_vm.formData, "ScStatisticalcode", $$v)
      },
      expression: "formData.ScStatisticalcode"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Js Code",
      "prop": "ScJscode"
    }
  }, [_c('el-input', {
    attrs: {
      "size": "small",
      "type": "textarea"
    },
    model: {
      value: (_vm.formData.ScJscode),
      callback: function($$v) {
        _vm.$set(_vm.formData, "ScJscode", $$v)
      },
      expression: "formData.ScJscode"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Business Code",
      "prop": "ScBusinesscode"
    }
  }, [_c('el-input', {
    attrs: {
      "size": "small",
      "type": "textarea"
    },
    model: {
      value: (_vm.formData.ScBusinesscode),
      callback: function($$v) {
        _vm.$set(_vm.formData, "ScBusinesscode", $$v)
      },
      expression: "formData.ScBusinesscode"
    }
  })], 1), _vm._v(" "), _c('el-form-item', [_c('div', {
    staticClass: "pop-center-btn-wrap"
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.update2DataAjax('infoForm')
      }
    }
  }, [_vm._v("Save")])], 1)])], 1) : _vm._e()], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 731 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "width-box w600"
  }, [(_vm.formData) ? _c('el-form', {
    ref: "projectInfoForm",
    staticClass: "pop-form-wrap",
    attrs: {
      "label-width": "100px",
      "model": _vm.formData
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Name",
      "prop": "StName"
    }
  }, [_c('el-input', {
    attrs: {
      "size": "small"
    },
    model: {
      value: (_vm.formData.StName),
      callback: function($$v) {
        _vm.$set(_vm.formData, "StName", $$v)
      },
      expression: "formData.StName"
    }
  })], 1), _vm._v(" "), _c('el-form-item', [_c('div', {
    staticClass: "pop-center-btn-wrap"
  }, [(!_vm.formData.Id) ? _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.doAdd('projectInfoForm')
      }
    }
  }, [_vm._v("add")]) : _vm._e(), _vm._v(" "), (_vm.formData.Id) ? _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.doUpdate('projectInfoForm')
      }
    }
  }, [_vm._v("save")]) : _vm._e()], 1)])], 1) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 732 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "common-page-main main-page"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.page.popShow),
      expression: "!page.popShow"
    }],
    staticClass: "field-box scroll-cotar"
  }, [_c('div', {
    staticClass: "page-top-bar cfa"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "rfp"
  }, [_c('el-button', {
    attrs: {
      "size": "small",
      "icon": "plus",
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.showAddPop()
      }
    }
  }, [_vm._v("add")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "table-wrap"
  }, [_c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.table.isLoading),
      expression: "table.isLoading"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.table.data,
      "element-loading-text": "LOADING"
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "SpName",
      "label": "Name"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "SpSort",
      "label": "Sort"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Operate"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "size": "small"
          },
          on: {
            "click": function($event) {
              return _vm.showUpdatePop(scope.$index, scope.row)
            }
          }
        }, [_vm._v("edit")]), _vm._v(" "), _c('copy-btn', {
          attrs: {
            "text": '/Cms/SinglePage/' + scope.row.SpCode
          }
        }, [_vm._v("copy link")]), _vm._v(" "), _c('el-button', {
          attrs: {
            "size": "small"
          },
          on: {
            "click": function($event) {
              return _vm.handleDel(scope.$index, scope.row)
            }
          }
        }, [_vm._v("delete")])]
      }
    }])
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "page-wrap"
  }, [_c('el-pagination', {
    attrs: {
      "current-page": _vm.table.currentPage,
      "page-size": _vm.table.pageSize,
      "layout": "total, prev, pager, next",
      "total": _vm.table.pageTotal
    },
    on: {
      "current-change": _vm.handleTableCurrentChange
    }
  })], 1)]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.page.popShow),
      expression: "page.popShow"
    }],
    staticClass: "field-box scroll-cotar"
  }, [_c('div', {
    staticClass: "page-top-bar cfa"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "rfp"
  }, [_c('el-button', {
    attrs: {
      "size": "small",
      "type": "danger"
    },
    on: {
      "click": function($event) {
        _vm.page.popShow = false
      }
    }
  }, [_vm._v("Close")])], 1)]), _vm._v(" "), _c('SinglePageForm', {
    ref: "popForm",
    on: {
      "addSuccess": _vm.handleAdd,
      "updateSuccess": _vm.handleUpdate
    }
  })], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "headline lfp"
  }, [_c('span', [_vm._v("SinglePage Management")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "headline lfp"
  }, [_c('span', [_vm._v("SinglePage Detail")])])
}]}

/***/ }),
/* 733 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "common-page-main main-page"
  }, [_c('div', {
    staticClass: "field-box scroll-cotar"
  }, [_c('div', {
    staticClass: "page-top-bar cfa"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "rfp"
  }, [_c('el-button', {
    attrs: {
      "size": "small",
      "icon": "plus",
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.showAddPop()
      }
    }
  }, [_vm._v("add")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "table-wrap"
  }, [_c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.table.isLoading),
      expression: "table.isLoading"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.table.data,
      "element-loading-text": "LOADING"
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": "Img"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('div', {
          staticClass: "common-table-row-img"
        }, [_c('img', {
          attrs: {
            "src": scope.row.PbImg
          }
        })])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "PbName",
      "label": "Name"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "PbSort",
      "label": "Sort"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Operate"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "size": "small"
          },
          on: {
            "click": function($event) {
              return _vm.showUpdatePop(scope.$index, scope.row)
            }
          }
        }, [_vm._v("edit")]), _vm._v(" "), _c('el-button', {
          attrs: {
            "size": "small"
          },
          on: {
            "click": function($event) {
              return _vm.handleDel(scope.$index, scope.row)
            }
          }
        }, [_vm._v("delete")])]
      }
    }])
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "page-wrap"
  }, [_c('el-pagination', {
    attrs: {
      "current-page": _vm.table.currentPage,
      "page-size": _vm.table.pageSize,
      "layout": "total, prev, pager, next",
      "total": _vm.table.pageTotal
    },
    on: {
      "current-change": _vm.handleTableCurrentChange
    }
  })], 1)]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "ProductionBase Detail",
      "visible": _vm.page.popShow,
      "size": "tine"
    },
    on: {
      "update:visible": function($event) {
        return _vm.$set(_vm.page, "popShow", $event)
      }
    }
  }, [_c('ProductionBaseForm', {
    ref: "popForm",
    on: {
      "addSuccess": _vm.handleAdd,
      "updateSuccess": _vm.handleUpdate
    }
  })], 1)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "headline lfp"
  }, [_c('span', [_vm._v("Production Base Manage")])])
}]}

/***/ }),
/* 734 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "width-box w800"
  }, [(_vm.formData) ? _c('el-form', {
    ref: "commonForm",
    staticClass: "pop-form-wrap",
    attrs: {
      "label-width": "100px",
      "model": _vm.formData
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Title",
      "prop": "DiTitle"
    }
  }, [_c('el-input', {
    attrs: {
      "size": "small"
    },
    model: {
      value: (_vm.formData.DiTitle),
      callback: function($$v) {
        _vm.$set(_vm.formData, "DiTitle", $$v)
      },
      expression: "formData.DiTitle"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Img",
      "prop": "DiImg"
    }
  }, [_c('img-upload', {
    attrs: {
      "tip": "Image recommended size：120*100"
    },
    model: {
      value: (_vm.formData.DiImg),
      callback: function($$v) {
        _vm.$set(_vm.formData, "DiImg", $$v)
      },
      expression: "formData.DiImg"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Sort",
      "prop": "DiSort"
    }
  }, [_c('el-input', {
    attrs: {
      "size": "small"
    },
    model: {
      value: (_vm.formData.DiSort),
      callback: function($$v) {
        _vm.$set(_vm.formData, "DiSort", _vm._n($$v))
      },
      expression: "formData.DiSort"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Attachment",
      "prop": "DiAttachment"
    }
  }, [_c('file-upload', {
    attrs: {
      "fileUrl": _vm.formData.DiAttachment,
      "workMode": "url"
    },
    on: {
      "update:fileUrl": function($event) {
        return _vm.$set(_vm.formData, "DiAttachment", $event)
      },
      "update:file-url": function($event) {
        return _vm.$set(_vm.formData, "DiAttachment", $event)
      }
    }
  })], 1), _vm._v(" "), _c('el-form-item', [_c('div', {
    staticClass: "pop-center-btn-wrap"
  }, [(!_vm.formData.Id) ? _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.doAdd('commonForm')
      }
    }
  }, [_vm._v("add")]) : _vm._e(), _vm._v(" "), (_vm.formData.Id) ? _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.doUpdate('commonForm')
      }
    }
  }, [_vm._v("save")]) : _vm._e()], 1)])], 1) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 735 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "common-page-main main-page"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.page.popShow),
      expression: "!page.popShow"
    }],
    staticClass: "field-box scroll-cotar"
  }, [_c('div', {
    staticClass: "page-top-bar cfa"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.tree.current),
      expression: "tree.current"
    }],
    staticClass: "rfp"
  }, [(_vm.tree.current !== null && _vm.tree.current.IsLeaf === 1) ? _c('el-button', {
    attrs: {
      "size": "small",
      "icon": "plus",
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.showAddPop()
      }
    }
  }, [_vm._v("add")]) : _vm._e()], 1)]), _vm._v(" "), _c('div', {
    staticClass: "content-wrap"
  }, [_c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 5
    }
  }, [_c('div', {
    staticClass: "page-left-wrap"
  }, [_c('div', {
    staticClass: "sub-top-bar cfa"
  }, [_c('div', {
    staticClass: "title lfp"
  }, [_vm._v("product type")])]), _vm._v(" "), _c('el-tree', {
    attrs: {
      "data": _vm.tree.data,
      "props": _vm.tree.prop,
      "expand-on-click-node": false,
      "highlight-current": true
    },
    on: {
      "node-click": _vm.clickModuleTree
    }
  })], 1)]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 19
    }
  }, [_c('div', {
    staticClass: "page-right-wrap"
  }, [(_vm.tree.current) ? _c('div', {
    staticClass: "sub-top-bar cfa"
  }, [_c('div', {
    staticClass: "title lfp"
  }, [_vm._v(_vm._s(_vm.tree.current.PtName))])]) : _vm._e(), _vm._v(" "), _c('el-table', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.table.data,
      "element-loading-text": "LOADING"
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "PiName",
      "label": "Name"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "PiSort",
      "label": "Sort"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Operate"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "size": "small"
          },
          on: {
            "click": function($event) {
              return _vm.showUpdatePop(scope.$index, scope.row)
            }
          }
        }, [_vm._v("edit")]), _vm._v(" "), _c('copy-btn', {
          attrs: {
            "text": '/Product/DeliveryRoller/' + scope.row.PiCode + '?pathId=201709075b3ab272'
          }
        }, [_vm._v("copy link")]), _vm._v(" "), _c('el-button', {
          attrs: {
            "size": "small"
          },
          on: {
            "click": function($event) {
              return _vm.handleDel(scope.$index, scope.row)
            }
          }
        }, [_vm._v("delete")])]
      }
    }])
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "page-wrap"
  }, [_c('el-pagination', {
    attrs: {
      "current-page": _vm.table.currentPage,
      "page-size": _vm.table.pageSize,
      "layout": "total, prev, pager, next",
      "total": _vm.table.pageTotal
    },
    on: {
      "current-change": _vm.handleTableCurrentChange
    }
  })], 1)], 1)])], 1)], 1)]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.page.popShow),
      expression: "page.popShow"
    }],
    staticClass: "field-box scroll-cotar"
  }, [_c('div', {
    staticClass: "page-top-bar cfa"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "rfp"
  }, [_c('el-button', {
    attrs: {
      "size": "small",
      "type": "danger"
    },
    on: {
      "click": function($event) {
        _vm.page.popShow = false
      }
    }
  }, [_vm._v("Close")])], 1)]), _vm._v(" "), _c('ProductForm', {
    ref: "popForm",
    attrs: {
      "sideCurrent": _vm.tree.current
    },
    on: {
      "addSuccess": _vm.handleAdd,
      "updateSuccess": _vm.handleUpdate
    }
  })], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "headline lfp"
  }, [_c('span', [_vm._v("Product Management")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "headline lfp"
  }, [_c('span', [_vm._v("product detail")])])
}]}

/***/ }),
/* 736 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.tip) ? _c('div', {
    staticClass: "upload-tip",
    class: {
      'small': _vm.size === 'small', 'tine': _vm.size === 'tine'
    }
  }, [_c('el-alert', {
    attrs: {
      "title": _vm.tip,
      "type": "info",
      "closable": false
    }
  })], 1) : _vm._e(), _vm._v(" "), (!_vm.mult) ? _c('div', {
    staticClass: "mc-upload-wrap"
  }, [_c('div', {
    directives: [{
      name: "imageupload",
      rawName: "v-imageupload",
      value: (_vm.img),
      expression: "img"
    }],
    staticClass: "upload-field",
    class: {
      'has-upload': _vm.img, 'small': _vm.size === 'small', 'tine': _vm.size === 'tine'
    },
    on: {
      "upload-change": _vm.singleImgUplad
    }
  }, [_c('div', {
    staticClass: "tip"
  }, [_vm._v("请上传图片")]), _vm._v(" "), _c('div', {
    staticClass: "pic-wrap"
  }, [_c('img', {
    attrs: {
      "src": _vm.img
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "upload-cover"
  }, [_vm._v("点击图片以修改")])])]) : _c('div', {
    staticClass: "mc-upload-wrap mult-wrap"
  }, _vm._l((_vm.multImgList), function(item, i) {
    return _c('div', {
      directives: [{
        name: "imageupload",
        rawName: "v-imageupload",
        value: (item),
        expression: "item"
      }],
      key: i,
      staticClass: "upload-field tine ftp",
      class: {
        'has-upload': item
      },
      on: {
        "upload-change": function($event) {
          return _vm.multImgUplad($event, i)
        }
      }
    }, [_c('div', {
      staticClass: "tip"
    }, [_vm._v("请上传图片")]), _vm._v(" "), _c('div', {
      staticClass: "pic-wrap"
    }, [_c('img', {
      attrs: {
        "src": item
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "upload-cover"
    }, [_vm._v("点击图片以修改")]), _vm._v(" "), (i !== _vm.multImgList.length - 1) ? _c('div', {
      staticClass: "del-btn ic-del",
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.delImg(i)
        }
      }
    }) : _vm._e()])
  }), 0)])
},staticRenderFns: []}

/***/ }),
/* 737 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "width-box w1000"
  }, [(_vm.formData) ? _c('el-form', {
    ref: "commonForm",
    staticClass: "pop-form-wrap",
    attrs: {
      "label-width": "200px",
      "model": _vm.formData
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "tax rate",
      "prop": "PrTax"
    }
  }, [_c('el-input', {
    attrs: {
      "size": "small"
    },
    model: {
      value: (_vm.formData.PrTax),
      callback: function($$v) {
        _vm.$set(_vm.formData, "PrTax", _vm._n($$v))
      },
      expression: "formData.PrTax"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "euro exchange rate",
      "prop": "PrEuroRate"
    }
  }, [_c('el-input', {
    attrs: {
      "size": "small"
    },
    model: {
      value: (_vm.formData.PrEuroRate),
      callback: function($$v) {
        _vm.$set(_vm.formData, "PrEuroRate", _vm._n($$v))
      },
      expression: "formData.PrEuroRate"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "dollar currency rate",
      "prop": "PrDollarRate"
    }
  }, [_c('el-input', {
    attrs: {
      "size": "small"
    },
    model: {
      value: (_vm.formData.PrDollarRate),
      callback: function($$v) {
        _vm.$set(_vm.formData, "PrDollarRate", _vm._n($$v))
      },
      expression: "formData.PrDollarRate"
    }
  })], 1), _vm._v(" "), _c('el-form-item', [_c('div', {
    staticClass: "pop-center-btn-wrap"
  }, [(_vm.formData.Id) ? _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.doUpdate('commonForm')
      }
    }
  }, [_vm._v("Save")]) : _vm._e()], 1)])], 1) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 738 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "common-page-main main-page department-staff-management"
  }, [_c('div', {
    staticClass: "field-box scroll-cotar"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "content-wrap"
  }, [_c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('div', {
    staticClass: "page-left-wrap"
  }, [_c('div', {
    staticClass: "sub-top-bar cfa"
  }, [_c('div', {
    staticClass: "title lfp"
  }, [_vm._v("Department Management")]), _vm._v(" "), _c('div', {
    staticClass: "rfp"
  }, [_c('el-button', {
    attrs: {
      "size": "small",
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.showAddDepartmentPop()
      }
    }
  }, [_vm._v("Add department")])], 1)]), _vm._v(" "), _c('el-tree', {
    attrs: {
      "data": _vm.tree.data,
      "props": _vm.tree.prop,
      "expand-on-click-node": false,
      "highlight-current": true,
      "default-expand-all": true,
      "render-content": _vm.renderTreeItemContent
    },
    on: {
      "node-click": _vm.clickmoduleTree
    }
  })], 1)]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 16
    }
  }, [_c('div', {
    staticClass: "page-right-wrap"
  }, [(_vm.tree.current) ? _c('div', {
    staticClass: "sub-top-bar cfa"
  }, [_c('div', {
    staticClass: "title lfp"
  }, [_vm._v(_vm._s(_vm.tree.current.OgName))]), _vm._v(" "), _c('div', {
    staticClass: "rfp"
  }, [_c('el-button', {
    attrs: {
      "size": "small",
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.showAddStaffPop()
      }
    }
  }, [_vm._v("Add Staff")])], 1)]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "result-table-wrap"
  }, [_c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.table.isLoading),
      expression: "table.isLoading"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.tableData,
      "element-loading-text": "LOADING"
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "AuName",
      "label": "Member Name"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "OrganizationName",
      "label": "Department"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Roll Group"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return _vm._l((scope.row._LbNamelist), function(item, idx) {
          return _c('el-tag', {
            key: idx,
            staticStyle: {
              "margin-right": "5px"
            },
            attrs: {
              "type": "primary"
            }
          }, [_vm._v(_vm._s(item))])
        })
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "AVAILABLE",
      "width": "140"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row._AuIsused) ? _c('el-tag', {
          attrs: {
            "type": "success"
          }
        }, [_vm._v("AVAILABLE")]) : _c('el-tag', {
          attrs: {
            "type": "danger"
          }
        }, [_vm._v("NO AVAILABLE")])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "OPERATE",
      "width": "110"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-dropdown', {
          attrs: {
            "split-button": "",
            "size": "small",
            "type": "primary"
          },
          on: {
            "command": function($event) {
              return _vm.handleTableCommand($event, scope.$index, scope.row)
            },
            "click": function($event) {
              return _vm.showUpdateStaffPop(scope.$index, scope.row)
            }
          }
        }, [_vm._v("\n                      Edit\n                      "), _c('el-dropdown-menu', {
          attrs: {
            "slot": "dropdown"
          },
          slot: "dropdown"
        }, [_c('el-dropdown-item', {
          attrs: {
            "command": "showAddPowerPop"
          }
        }, [_vm._v("Limit")]), _vm._v(" "), _c('el-dropdown-item', {
          attrs: {
            "command": "showResetPasswordPop"
          }
        }, [_vm._v("Reset Password")]), _vm._v(" "), _c('el-dropdown-item', {
          attrs: {
            "command": "delStaff"
          }
        }, [_vm._v("delete")])], 1)], 1)]
      }
    }])
  })], 1)], 1)])])], 1)], 1)]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "Department",
      "visible": _vm.departmentPop.show,
      "size": "tine"
    },
    on: {
      "update:visible": function($event) {
        return _vm.$set(_vm.departmentPop, "show", $event)
      }
    }
  }, [_c('el-form', {
    ref: "pageForm",
    staticClass: "pop-form-wrap w400",
    attrs: {
      "model": _vm.departmentPop.data,
      "label-width": "80px"
    }
  }, [(!_vm.departmentPop.data.Id) ? _c('el-form-item', {
    attrs: {
      "label": "Superior Department",
      "prop": "Id"
    }
  }, [_c('tree-select', {
    attrs: {
      "treeData": _vm.tree.data,
      "treeProps": _vm.tree.prop,
      "multiple": false,
      "placeholder": "Please Select Department"
    },
    on: {
      "errorCallback": _vm.showTreeError,
      "setSelectedId": _vm.setSelectedId
    },
    model: {
      value: (_vm.departmentPop.data.Id),
      callback: function($$v) {
        _vm.$set(_vm.departmentPop.data, "Id", $$v)
      },
      expression: "departmentPop.data.Id"
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Name",
      "prop": "OgName"
    }
  }, [_c('el-input', {
    attrs: {
      "auto-complete": "off"
    },
    model: {
      value: (_vm.departmentPop.data.OgName),
      callback: function($$v) {
        _vm.$set(_vm.departmentPop.data, "OgName", $$v)
      },
      expression: "departmentPop.data.OgName"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer pop-center-btn-wrap",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.departmentPop.show = false
      }
    }
  }, [_vm._v("Canel")]), _vm._v(" "), (!_vm.departmentPop.data.Id) ? _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.addDepartment
    }
  }, [_vm._v("Add")]) : _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.updateDepartment
    }
  }, [_vm._v("determine")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "Staff",
      "visible": _vm.staffPop.show,
      "size": "tine"
    },
    on: {
      "update:visible": function($event) {
        return _vm.$set(_vm.staffPop, "show", $event)
      }
    }
  }, [_c('el-form', {
    ref: "pageForm",
    staticClass: "pop-form-wrap w400",
    attrs: {
      "model": _vm.staffPop.data,
      "label-width": "100px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Name",
      "prop": "AuName"
    }
  }, [_c('el-input', {
    attrs: {
      "auto-complete": "off"
    },
    model: {
      value: (_vm.staffPop.data.AuName),
      callback: function($$v) {
        _vm.$set(_vm.staffPop.data, "AuName", $$v)
      },
      expression: "staffPop.data.AuName"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Account",
      "prop": "AuAccount"
    }
  }, [_c('el-input', {
    attrs: {
      "auto-complete": "off"
    },
    model: {
      value: (_vm.staffPop.data.AuAccount),
      callback: function($$v) {
        _vm.$set(_vm.staffPop.data, "AuAccount", $$v)
      },
      expression: "staffPop.data.AuAccount"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Post",
      "prop": "AuPost"
    }
  }, [_c('el-input', {
    attrs: {
      "auto-complete": "off"
    },
    model: {
      value: (_vm.staffPop.data.AuPost),
      callback: function($$v) {
        _vm.$set(_vm.staffPop.data, "AuPost", $$v)
      },
      expression: "staffPop.data.AuPost"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Mobile",
      "prop": "AuMobile"
    }
  }, [_c('el-input', {
    attrs: {
      "auto-complete": "off"
    },
    model: {
      value: (_vm.staffPop.data.AuMobile),
      callback: function($$v) {
        _vm.$set(_vm.staffPop.data, "AuMobile", $$v)
      },
      expression: "staffPop.data.AuMobile"
    }
  })], 1), _vm._v(" "), (!_vm.staffPop.data.Id) ? _c('el-form-item', {
    attrs: {
      "label": "Password",
      "prop": "AuPassword"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "password",
      "auto-complete": "off"
    },
    model: {
      value: (_vm.staffPop.data.AuPassword),
      callback: function($$v) {
        _vm.$set(_vm.staffPop.data, "AuPassword", $$v)
      },
      expression: "staffPop.data.AuPassword"
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Roll Group"
    }
  }, [_c('el-checkbox-group', {
    model: {
      value: (_vm.currentLbNameList),
      callback: function($$v) {
        _vm.currentLbNameList = $$v
      },
      expression: "currentLbNameList"
    }
  }, _vm._l((_vm.LabelList), function(item, idx) {
    return _c('el-checkbox', {
      key: idx,
      attrs: {
        "label": item.LbName
      }
    })
  }), 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer pop-center-btn-wrap",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.staffPop.show = false
      }
    }
  }, [_vm._v("Canel")]), _vm._v(" "), (!_vm.staffPop.data.Id) ? _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.addStaff
    }
  }, [_vm._v("Add")]) : _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.updateStaff
    }
  }, [_vm._v("determine")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "Give permission",
      "visible": _vm.powerPop.show,
      "size": "tine"
    },
    on: {
      "update:visible": function($event) {
        return _vm.$set(_vm.powerPop, "show", $event)
      }
    }
  }, [_c('PowerForm', {
    ref: "powerForm",
    on: {
      "updatePowerSuccess": _vm.updatePowerSuccess
    }
  })], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "ResetPassword",
      "visible": _vm.passwordPop.show,
      "size": "tine"
    },
    on: {
      "update:visible": function($event) {
        return _vm.$set(_vm.passwordPop, "show", $event)
      }
    }
  }, [_c('PasswordForm', {
    ref: "passwordForm",
    on: {
      "updateSuccess": _vm.updatePasswordSuccess
    }
  })], 1)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page-top-bar cfa"
  }, [_c('div', {
    staticClass: "headline lfp"
  }, [_c('span', [_vm._v("Department Staff Management")])])])
}]}

/***/ }),
/* 739 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "common-page-main main-page"
  }, [_c('div', {
    staticClass: "field-box scroll-cotar"
  }, [_c('div', {
    staticClass: "page-top-bar cfa"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "rfp"
  }, [_c('el-button', {
    attrs: {
      "size": "small",
      "icon": "plus",
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.showAddPop()
      }
    }
  }, [_vm._v("add")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "table-wrap"
  }, [_c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.table.isLoading),
      expression: "table.isLoading"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.table.data,
      "element-loading-text": "LOADING"
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": "Cover"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('div', {
          staticClass: "common-table-row-img"
        }, [_c('img', {
          attrs: {
            "src": scope.row.VdCover
          }
        })])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "VdName",
      "label": "Name"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "VdUrl",
      "label": "Skip Url"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "VdSort",
      "label": "Sort"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Operate"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "size": "small"
          },
          on: {
            "click": function($event) {
              return _vm.showUpdatePop(scope.$index, scope.row)
            }
          }
        }, [_vm._v("edit")]), _vm._v(" "), _c('el-button', {
          attrs: {
            "size": "small"
          },
          on: {
            "click": function($event) {
              return _vm.handleDel(scope.$index, scope.row)
            }
          }
        }, [_vm._v("delete")])]
      }
    }])
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "page-wrap"
  }, [_c('el-pagination', {
    attrs: {
      "current-page": _vm.table.currentPage,
      "page-size": _vm.table.pageSize,
      "layout": "total, prev, pager, next",
      "total": _vm.table.pageTotal
    },
    on: {
      "current-change": _vm.handleTableCurrentChange
    }
  })], 1)]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "Video Detail",
      "visible": _vm.page.popShow,
      "size": "tine"
    },
    on: {
      "update:visible": function($event) {
        return _vm.$set(_vm.page, "popShow", $event)
      }
    }
  }, [_c('VideoForm', {
    ref: "popForm",
    on: {
      "addSuccess": _vm.handleAdd,
      "updateSuccess": _vm.handleUpdate
    }
  })], 1)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "headline lfp"
  }, [_c('span', [_vm._v("Video Management")])])
}]}

/***/ }),
/* 740 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('header', {
    staticClass: "mc-main-header cfa"
  }, [_c('div', {
    staticClass: "lfp hf"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "mc-tool-bar ftp hf"
  }, [_c('div', {
    staticClass: "item ftp mc-sidebar-toggle-btn",
    on: {
      "click": _vm.toggleSidebar
    }
  }, [_c('i', {
    staticClass: "fa fa-bars"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "mc-top-nav ftp hf"
  }, _vm._l((_vm.config.navGroup), function(item, i) {
    return _c('div', {
      key: i,
      staticClass: "item ftp",
      class: {
        active: _vm.activeNavIdx === i
      },
      on: {
        "click": function($event) {
          return _vm.changeNav(item.href)
        }
      }
    }, [_vm._v(_vm._s(item.label))])
  }), 0)]), _vm._v(" "), _c('div', {
    staticClass: "mc-nav-bar rfp hf"
  }, [_c('div', {
    staticClass: "mc-user-info ftp"
  }, [_c('div', {
    staticClass: "mc-user-name"
  }, [_vm._v(_vm._s(_vm.memberInfo.AuName))]), _vm._v(" "), _c('div', {
    staticClass: "mc-pop-menu field-box"
  }, [_c('div', {
    staticClass: "mc-btn",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.loginOut($event)
      }
    }
  }, [_vm._v("Login Out")])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "mc-logo ftp"
  }, [_c('div', {
    staticClass: "mc-logo-large"
  }, [_c('img', {
    attrs: {
      "src": "/static/images/pic-logo.png"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "mc-logo-small"
  }, [_c('img', {
    attrs: {
      "src": "/static/images/pic-logo-s.png"
    }
  })])])
}]}

/***/ }),
/* 741 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "width-box w600"
  }, [(_vm.formData) ? _c('el-form', {
    ref: "projectInfoForm",
    staticClass: "pop-form-wrap fitem-w400",
    attrs: {
      "label-width": "100px",
      "model": _vm.formData
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Cover",
      "prop": "VdCover"
    }
  }, [_c('imgUpload', {
    attrs: {
      "tip": "Image recommended size：200*130"
    },
    model: {
      value: (_vm.formData.VdCover),
      callback: function($$v) {
        _vm.$set(_vm.formData, "VdCover", $$v)
      },
      expression: "formData.VdCover"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Upload",
      "prop": "VdUrl"
    }
  }, [_c('videoUpload', {
    attrs: {
      "IsOutlink": _vm.formData.IsOutlink,
      "url": _vm.formData.VdUrl
    },
    on: {
      "update:IsOutlink": function($event) {
        return _vm.$set(_vm.formData, "IsOutlink", $event)
      },
      "update:is-outlink": function($event) {
        return _vm.$set(_vm.formData, "IsOutlink", $event)
      },
      "update:url": function($event) {
        return _vm.$set(_vm.formData, "VdUrl", $event)
      }
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Name",
      "prop": "VdName"
    }
  }, [_c('el-input', {
    attrs: {
      "size": "small"
    },
    model: {
      value: (_vm.formData.VdName),
      callback: function($$v) {
        _vm.$set(_vm.formData, "VdName", $$v)
      },
      expression: "formData.VdName"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Sort",
      "prop": "VdSort"
    }
  }, [_c('el-input', {
    attrs: {
      "size": "small"
    },
    model: {
      value: (_vm.formData.VdSort),
      callback: function($$v) {
        _vm.$set(_vm.formData, "VdSort", _vm._n($$v))
      },
      expression: "formData.VdSort"
    }
  })], 1), _vm._v(" "), _c('el-form-item', [_c('div', {
    staticClass: "pop-center-btn-wrap"
  }, [(!_vm.formData.Id) ? _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.doAdd('projectInfoForm')
      }
    }
  }, [_vm._v("add")]) : _vm._e(), _vm._v(" "), (_vm.formData.Id) ? _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.doUpdate('projectInfoForm')
      }
    }
  }, [_vm._v("save")]) : _vm._e()], 1)])], 1) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 742 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "no-footer-pop-content w600"
  }, [_c('div', {
    staticClass: "pop-form-wrap"
  }, [_c('el-tree', {
    ref: "powerTree",
    attrs: {
      "data": _vm.moduleData,
      "props": _vm.moduleProp,
      "empty-text": "Loading..",
      "show-checkbox": "",
      "node-key": "MoCode",
      "expand-on-click-node": false,
      "default-expand-all": true
    },
    on: {
      "check-change": _vm.checkPowerTreeChange
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer pop-center-btn-wrap"
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.doConfirm
    }
  }, [_vm._v("Confirm")])], 1)])
},staticRenderFns: []}

/***/ }),
/* 743 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "common-page-main main-page"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.page.popShow),
      expression: "!page.popShow"
    }],
    staticClass: "field-box scroll-cotar"
  }, [_c('div', {
    staticClass: "page-top-bar cfa"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.tree.current),
      expression: "tree.current"
    }],
    staticClass: "rfp"
  }, [_c('el-button', {
    attrs: {
      "size": "small",
      "icon": "plus",
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.showAddPop()
      }
    }
  }, [_vm._v("add case")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "content-wrap"
  }, [_c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 4
    }
  }, [_c('div', {
    staticClass: "sub-top-bar cfa"
  }, [_c('div', {
    staticClass: "title lfp"
  }, [_vm._v("case type")])]), _vm._v(" "), _c('div', {
    staticClass: "page-left-wrap"
  }, [_c('el-tree', {
    attrs: {
      "data": _vm.tree.data,
      "props": _vm.tree.prop,
      "expand-on-click-node": false,
      "highlight-current": true,
      "default-expand-all": true
    },
    on: {
      "node-click": _vm.clickModuleTree
    }
  })], 1)]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 20
    }
  }, [_c('div', {
    staticClass: "page-right-wrap"
  }, [(_vm.tree.current) ? _c('div', {
    staticClass: "sub-top-bar cfa"
  }, [_c('div', {
    staticClass: "title lfp"
  }, [_vm._v(_vm._s(_vm.tree.current.CtName))])]) : _vm._e(), _vm._v(" "), _c('el-table', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.table.data,
      "element-loading-text": "LOADING"
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "CiName",
      "label": "Name"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "CiSort",
      "label": "Sort"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Operate"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "size": "small"
          },
          on: {
            "click": function($event) {
              return _vm.showUpdatePop(scope.$index, scope.row)
            }
          }
        }, [_vm._v("edit")]), _vm._v(" "), _c('copy-btn', {
          attrs: {
            "text": '/Cms/ApplianceExampleDetails/' + scope.row.CiCode + '?pathId=20170907e70f7223'
          }
        }, [_vm._v("copy link")]), _vm._v(" "), _c('el-button', {
          attrs: {
            "size": "small"
          },
          on: {
            "click": function($event) {
              return _vm.handleDel(scope.$index, scope.row)
            }
          }
        }, [_vm._v("delete")])]
      }
    }])
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "page-wrap"
  }, [_c('el-pagination', {
    attrs: {
      "current-page": _vm.table.currentPage,
      "page-size": _vm.table.pageSize,
      "layout": "total, prev, pager, next",
      "total": _vm.table.pageTotal
    },
    on: {
      "current-change": _vm.handleTableCurrentChange
    }
  })], 1)], 1)])], 1)], 1)]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.page.popShow),
      expression: "page.popShow"
    }],
    staticClass: "field-box scroll-cotar"
  }, [_c('div', {
    staticClass: "page-top-bar cfa"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "rfp"
  }, [_c('el-button', {
    attrs: {
      "size": "small",
      "type": "danger"
    },
    on: {
      "click": function($event) {
        _vm.page.popShow = false
      }
    }
  }, [_vm._v("close")])], 1)]), _vm._v(" "), _c('CaseForm', {
    ref: "popForm",
    attrs: {
      "sideCurrent": _vm.tree.current
    },
    on: {
      "addSuccess": _vm.handleAdd,
      "updateSuccess": _vm.handleUpdate
    }
  })], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "headline lfp"
  }, [_c('span', [_vm._v("Case Management")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "headline lfp"
  }, [_c('span', [_vm._v("case detail")])])
}]}

/***/ }),
/* 744 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "width-box w400"
  }, [(_vm.formData) ? _c('el-form', {
    ref: "commonForm",
    staticClass: "pop-form-wrap",
    attrs: {
      "label-width": "80px",
      "model": _vm.formData
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "quantity",
      "prop": "Num"
    }
  }, [_c('el-input', {
    attrs: {
      "size": "small",
      "placeholder": "Please enter the content"
    },
    model: {
      value: (_vm.formData.Num),
      callback: function($$v) {
        _vm.$set(_vm.formData, "Num", $$v)
      },
      expression: "formData.Num"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "coefficient",
      "prop": "Rate"
    }
  }, [_c('el-input', {
    attrs: {
      "size": "small",
      "placeholder": "Please enter the content"
    },
    model: {
      value: (_vm.formData.Rate),
      callback: function($$v) {
        _vm.$set(_vm.formData, "Rate", $$v)
      },
      expression: "formData.Rate"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "remark",
      "prop": "Reamrk"
    }
  }, [_c('el-input', {
    attrs: {
      "size": "small",
      "placeholder": "Please enter the content"
    },
    model: {
      value: (_vm.formData.Reamrk),
      callback: function($$v) {
        _vm.$set(_vm.formData, "Reamrk", $$v)
      },
      expression: "formData.Reamrk"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "pop-center-btn-wrap"
  }, [(!_vm.formData.Id) ? _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.doAdd('commonForm')
      }
    }
  }, [_vm._v("Add")]) : _vm._e(), _vm._v(" "), (_vm.formData.Id) ? _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.doUpdate('commonForm')
      }
    }
  }, [_vm._v("Save")]) : _vm._e()], 1)], 1) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 745 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "common-page-main main-page"
  }, [_c('div', {
    staticClass: "field-box scroll-cotar"
  }, [_c('div', {
    staticClass: "page-top-bar cfa"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "rfp"
  }, [_c('el-button', {
    attrs: {
      "size": "small",
      "icon": "plus",
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.showAddPop()
      }
    }
  }, [_vm._v("add")]), _vm._v(" "), (_vm.$route.query.code != null) ? _c('el-button', {
    attrs: {
      "size": "small",
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.goBack()
      }
    }
  }, [_vm._v("back")]) : _vm._e()], 1)]), _vm._v(" "), _c('div', {
    staticClass: "table-wrap"
  }, [_c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.table.isLoading),
      expression: "table.isLoading"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.table.data,
      "element-loading-text": "LOADING"
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "PtName",
      "label": "Name"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "PtSort",
      "label": "Sort"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Operate"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "size": "small"
          },
          on: {
            "click": function($event) {
              return _vm.showUpdatePop(scope.$index, scope.row)
            }
          }
        }, [_vm._v("edit")]), _vm._v(" "), _c('copy-btn', {
          attrs: {
            "text": '/Product/ElectricRoller/' + scope.row.PtCode
          }
        }, [_vm._v("copy link")]), _vm._v(" "), _c('el-button', {
          attrs: {
            "size": "small"
          },
          on: {
            "click": function($event) {
              return _vm.handleDel(scope.$index, scope.row)
            }
          }
        }, [_vm._v("delete")]), _vm._v(" "), (scope.row.IsLeaf == 0) ? _c('el-button', {
          attrs: {
            "size": "small"
          },
          on: {
            "click": function($event) {
              return _vm.SkipNextGrade(scope.$index, scope.row)
            }
          }
        }, [_vm._v("next level")]) : _vm._e()]
      }
    }])
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "page-wrap"
  }, [_c('el-pagination', {
    attrs: {
      "current-page": _vm.table.currentPage,
      "page-size": _vm.table.pageSize,
      "layout": "total, prev, pager, next",
      "total": _vm.table.pageTotal
    },
    on: {
      "current-change": _vm.handleTableCurrentChange
    }
  })], 1)]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "Product Type Detail",
      "visible": _vm.page.popShow,
      "size": "tine"
    },
    on: {
      "update:visible": function($event) {
        return _vm.$set(_vm.page, "popShow", $event)
      }
    }
  }, [_c('ProductTypeForm', {
    ref: "popForm",
    on: {
      "addSuccess": _vm.handleAdd,
      "updateSuccess": _vm.handleUpdate
    }
  })], 1)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "headline lfp"
  }, [_c('span', [_vm._v("Product TypeManagement")])])
}]}

/***/ }),
/* 746 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "width-box w1000"
  }, [(_vm.formData) ? _c('el-form', {
    ref: "commonForm",
    staticClass: "pop-form-wrap",
    attrs: {
      "label-width": "100px",
      "model": _vm.formData
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "History (Years)",
      "prop": "CfYear"
    }
  }, [_c('el-input', {
    attrs: {
      "size": "small"
    },
    model: {
      value: (_vm.formData.CfYear),
      callback: function($$v) {
        _vm.$set(_vm.formData, "CfYear", _vm._n($$v))
      },
      expression: "formData.CfYear"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Annual output",
      "prop": "CfNum"
    }
  }, [_c('el-input', {
    attrs: {
      "size": "small"
    },
    model: {
      value: (_vm.formData.CfNum),
      callback: function($$v) {
        _vm.$set(_vm.formData, "CfNum", _vm._n($$v))
      },
      expression: "formData.CfNum"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Market share",
      "prop": "CfPer"
    }
  }, [_c('el-input', {
    attrs: {
      "size": "small"
    },
    model: {
      value: (_vm.formData.CfPer),
      callback: function($$v) {
        _vm.$set(_vm.formData, "CfPer", _vm._n($$v))
      },
      expression: "formData.CfPer"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Number of tray experiments",
      "prop": "CfTest"
    }
  }, [_c('el-input', {
    attrs: {
      "size": "small"
    },
    model: {
      value: (_vm.formData.CfTest),
      callback: function($$v) {
        _vm.$set(_vm.formData, "CfTest", _vm._n($$v))
      },
      expression: "formData.CfTest"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Global contact information",
      "prop": "CfGlobalInfo"
    }
  }, [_c('el-input', {
    attrs: {
      "size": "small",
      "type": "textarea",
      "autosize": true
    },
    model: {
      value: (_vm.formData.CfGlobalInfo),
      callback: function($$v) {
        _vm.$set(_vm.formData, "CfGlobalInfo", _vm._n($$v))
      },
      expression: "formData.CfGlobalInfo"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Wechat QR Code",
      "prop": "CfWebQrcode"
    }
  }, [_c('img-upload', {
    attrs: {
      "size": "small",
      "tip": "Image recommended size：140*140"
    },
    model: {
      value: (_vm.formData.CfWebQrcode),
      callback: function($$v) {
        _vm.$set(_vm.formData, "CfWebQrcode", $$v)
      },
      expression: "formData.CfWebQrcode"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "APP QR Code",
      "prop": "CfAppQrcode"
    }
  }, [_c('img-upload', {
    attrs: {
      "size": "small",
      "tip": "Image recommended size：140*140"
    },
    model: {
      value: (_vm.formData.CfAppQrcode),
      callback: function($$v) {
        _vm.$set(_vm.formData, "CfAppQrcode", $$v)
      },
      expression: "formData.CfAppQrcode"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Rolling Guaranteed",
      "prop": "CfYouzhiCover"
    }
  }, [_c('img-upload', {
    attrs: {
      "size": "small",
      "tip": "Image recommended size：140*140"
    },
    model: {
      value: (_vm.formData.CfYouzhiCover),
      callback: function($$v) {
        _vm.$set(_vm.formData, "CfYouzhiCover", $$v)
      },
      expression: "formData.CfYouzhiCover"
    }
  })], 1), _vm._v(" "), _c('el-form-item', [_c('div', {
    staticClass: "pop-center-btn-wrap"
  }, [(_vm.formData.Id) ? _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.doUpdate('commonForm')
      }
    }
  }, [_vm._v("save")]) : _vm._e()], 1)])], 1) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 747 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "width-box w800"
  }, [(_vm.formData) ? _c('el-form', {
    ref: "projectInfoForm",
    staticClass: "pop-form-wrap",
    attrs: {
      "label-width": "100px",
      "model": _vm.formData
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Img",
      "prop": "PfImg"
    }
  }, [_c('img-upload', {
    attrs: {
      "tip": "Image recommended size：450*290"
    },
    model: {
      value: (_vm.formData.PfImg),
      callback: function($$v) {
        _vm.$set(_vm.formData, "PfImg", $$v)
      },
      expression: "formData.PfImg"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Name",
      "prop": "PfName"
    }
  }, [_c('el-input', {
    attrs: {
      "size": "small"
    },
    model: {
      value: (_vm.formData.PfName),
      callback: function($$v) {
        _vm.$set(_vm.formData, "PfName", $$v)
      },
      expression: "formData.PfName"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Skip Url",
      "prop": "PfUrl"
    }
  }, [_c('el-input', {
    attrs: {
      "size": "small"
    },
    model: {
      value: (_vm.formData.PfUrl),
      callback: function($$v) {
        _vm.$set(_vm.formData, "PfUrl", $$v)
      },
      expression: "formData.PfUrl"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Sort",
      "prop": "PfSort"
    }
  }, [_c('el-input', {
    attrs: {
      "size": "small"
    },
    model: {
      value: (_vm.formData.PfSort),
      callback: function($$v) {
        _vm.$set(_vm.formData, "PfSort", _vm._n($$v))
      },
      expression: "formData.PfSort"
    }
  })], 1), _vm._v(" "), _c('el-form-item', [_c('div', {
    staticClass: "pop-center-btn-wrap"
  }, [(!_vm.formData.Id) ? _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.doAdd('projectInfoForm')
      }
    }
  }, [_vm._v("add")]) : _vm._e(), _vm._v(" "), (_vm.formData.Id) ? _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.doUpdate('projectInfoForm')
      }
    }
  }, [_vm._v("save")]) : _vm._e()], 1)])], 1) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 748 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "user-center-main",
    class: {
      'collapsed': _vm.sidebarCollapsed, 'big-mode': !_vm.sidebarCollapsed, 'small-mode': _vm.sidebarCollapsed
    }
  }, [_c('top-bar', {
    attrs: {
      "activeNavIdx": _vm.activeNavIdx
    },
    on: {
      "update:activeNavIdx": function($event) {
        _vm.activeNavIdx = $event
      },
      "update:active-nav-idx": function($event) {
        _vm.activeNavIdx = $event
      },
      "toggleSideBar": _vm.toggleSideBar
    }
  }), _vm._v(" "), _c('side-bar', {
    ref: "sideBar",
    attrs: {
      "activeNavIdx": _vm.activeNavIdx,
      "text": "MoName",
      "href": "MoUrl",
      "isLeaf": "IsLeaf",
      "logo": "MoLogo",
      "groupKey": "MoType"
    },
    on: {
      "update:activeNavIdx": function($event) {
        _vm.activeNavIdx = $event
      },
      "update:active-nav-idx": function($event) {
        _vm.activeNavIdx = $event
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "page-content"
  }, [_c('div', {
    staticClass: "page-cover"
  }), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "router-fade",
      "mode": "out-in"
    }
  }, [_c('router-view')], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 749 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "mc-side-bar-main"
  }, [_c('div', {
    staticClass: "mc-scroll-cotar"
  }, [_c('div', {
    staticClass: "mc-sidebar"
  }, [_c('div', {
    staticClass: "sidebar-menu-list main-list"
  }, _vm._l((_vm.sideData), function(item, i) {
    return _c('div', {
      key: i,
      staticClass: "menu-item-wrap",
      class: {
        'no-sub-list': !(item.children && item.children.length > 0)
      }
    }, [(item.children && item.children.length > 0) ? _c('div', {
      staticClass: "menu-item menu-header",
      class: {
        expand: item.expand
      },
      on: {
        "click": function($event) {
          return _vm.toggleSubMenu(item)
        }
      }
    }, [_c('div', {
      staticClass: "menu-txt"
    }, [_c('i', {
      staticClass: "menu-icon fa",
      class: item[_vm.logo]
    }), _vm._v(" "), _c('span', [_vm._v(_vm._s(item[_vm.text]))])]), _vm._v(" "), _c('i', {
      staticClass: "menu-arrow fa fa-angle-right"
    })]) : _c('div', {
      staticClass: "menu-item",
      class: {
        active: _vm.txtEqual(_vm.$route.path, item[_vm.href])
      }
    }, [_c('router-link', {
      staticClass: "menu-txt",
      attrs: {
        "to": item[_vm.href]
      }
    }, [_c('i', {
      staticClass: "menu-icon fa",
      class: item[_vm.logo]
    }), _vm._v(" "), _c('span', [_vm._v(_vm._s(item[_vm.text]))])])], 1), _vm._v(" "), (item.children && item.children.length > 0) ? [_c('transition', {
      on: {
        "enter": function($event) {
          return _vm.slideDown($event, item.children.length)
        },
        "before-leave": function($event) {
          return _vm.beforeSlideUp($event, item.children.length)
        },
        "leave": _vm.slideUp
      }
    }, [_c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (item.expand),
        expression: "item.expand"
      }],
      staticClass: "sidebar-menu-list sub-list"
    }, _vm._l((item.children), function(el, j) {
      return _c('div', {
        key: j,
        staticClass: "menu-item-wrap"
      }, [_c('div', {
        staticClass: "menu-item",
        class: {
          active: _vm.txtEqual(_vm.$route.path, el[_vm.href])
        }
      }, [_c('router-link', {
        staticClass: "menu-txt",
        attrs: {
          "to": el[_vm.href]
        }
      }, [_c('span', [_vm._v(_vm._s(el[_vm.text]))])])], 1)])
    }), 0)])] : _vm._e()], 2)
  }), 0)])]), _vm._v(" "), _c('div', {
    staticClass: "side-bar-bg"
  })])
},staticRenderFns: []}

/***/ }),
/* 750 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "common-page-main main-page"
  }, [_c('div', {
    staticClass: "field-box scroll-cotar"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "table-wrap"
  }, [_c('EnquiryOnlineConfigForm', {
    ref: "popForm",
    on: {
      "updateSuccess": _vm.handleUpdate
    }
  })], 1)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page-top-bar cfa"
  }, [_c('div', {
    staticClass: "headline lfp"
  }, [_c('span', [_vm._v("Configuration management")])])])
}]}

/***/ }),
/* 751 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "common-page-main main-page"
  }, [_c('div', {
    staticClass: "field-box"
  }, [_c('div', {
    staticClass: "page-top-bar cfa"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "rfp"
  }, [_c('el-button', {
    attrs: {
      "size": "small",
      "icon": "plus",
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.showAddPop()
      }
    }
  }, [_vm._v("add")])], 1)]), _vm._v(" "), _c('el-row', {
    staticClass: "content-wrap",
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('div', {
    staticClass: "page-left-wrap"
  }, [_c('div', {
    staticClass: "sub-top-bar cfa"
  }, [_c('div', {
    staticClass: "title lfp"
  }, [_vm._v("menu group")]), _vm._v(" "), _c('div', {
    staticClass: "rfp"
  })]), _vm._v(" "), _c('el-tree', {
    attrs: {
      "data": _vm.treeData,
      "props": _vm.moduleProp,
      "expand-on-click-node": false,
      "highlight-current": true,
      "default-expand-all": true,
      "render-content": _vm.renderTreeItemContent
    },
    on: {
      "node-click": _vm.clickModuleTree
    }
  })], 1)]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 16
    }
  }, [_c('div', {
    staticClass: "page-right-wrap"
  }, [_c('div', {
    staticClass: "sub-top-bar cfa"
  }, [_c('div', {
    staticClass: "title lfp"
  }, [_vm._v("Menu")]), _vm._v(" "), _c('div', {
    staticClass: "rfp"
  })]), _vm._v(" "), _c('el-table', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.tableData,
      "element-loading-text": "LOADING"
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "MoName",
      "label": "Name"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "MoSort",
      "label": "Sort"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "operate"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "size": "small"
          },
          on: {
            "click": function($event) {
              return _vm.showUpdatePop(scope.$index, scope.row)
            }
          }
        }, [_vm._v("detail set")]), _vm._v(" "), _c('el-button', {
          attrs: {
            "size": "small"
          },
          on: {
            "click": function($event) {
              return _vm.handleDel(scope.$index, scope.row)
            }
          }
        }, [_vm._v("delete")])]
      }
    }])
  })], 1)], 1)])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "menu detail",
      "visible": _vm.page.popShow,
      "size": "tine"
    },
    on: {
      "update:visible": function($event) {
        return _vm.$set(_vm.page, "popShow", $event)
      }
    }
  }, [_c('ModuleForm', {
    ref: "popForm",
    attrs: {
      "moduleData": _vm.moduleData,
      "moduleProp": _vm.moduleProp
    },
    on: {
      "addSuccess": _vm.handleAdd,
      "updateSuccess": _vm.handleUpdate
    }
  })], 1)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "headline lfp"
  }, [_c('span', [_vm._v("Menu Management")])])
}]}

/***/ }),
/* 752 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "mc-upload-wrap video-upload-warp"
  }, [(_vm.workMode === 'upload-outer') ? _c('div', {
    staticClass: "isout-switch-wrap hf"
  }, [_c('div', {
    staticClass: "label ftp"
  }, [_vm._v("Is OutLink")]), _vm._v(" "), _c('div', {
    staticClass: "ftp"
  }, [_c('el-switch', {
    attrs: {
      "on-text": "",
      "off-text": ""
    },
    on: {
      "change": _vm.changeOuter
    },
    model: {
      value: (_vm.isOuterUrl),
      callback: function($$v) {
        _vm.isOuterUrl = $$v
      },
      expression: "isOuterUrl"
    }
  })], 1)]) : _vm._e(), _vm._v(" "), ((_vm.workMode === 'upload-outer' || _vm.workMode === 'outer') && _vm.isOuterUrl === true) ? [_c('el-input', {
    attrs: {
      "size": "small"
    },
    on: {
      "change": _vm.outerIptChange
    },
    model: {
      value: (_vm.videoUrl),
      callback: function($$v) {
        _vm.videoUrl = $$v
      },
      expression: "videoUrl"
    }
  })] : _vm._e(), _vm._v(" "), ((_vm.workMode === 'upload-outer' || _vm.workMode === 'upload') && _vm.isOuterUrl === false) ? [_c('div', {
    directives: [{
      name: "fileupload",
      rawName: "v-fileupload",
      value: (_vm.videoUrl),
      expression: "videoUrl"
    }],
    staticClass: "upload-field",
    class: {
      'has-upload': _vm.videoUrl
    },
    style: ({
      width: _vm.width + 'px'
    }),
    on: {
      "upload-change": _vm.videoUploadSuccess
    }
  }, [_c('div', {
    staticClass: "tip"
  }, [_vm._v("UPLOAD")]), _vm._v(" "), _c('div', {
    staticClass: "pic-wrap"
  }, [_c('video', {
    attrs: {
      "src": _vm.videoUrl
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "upload-cover"
  }, [_vm._v("Change")])])] : _vm._e()], 2)
},staticRenderFns: []}

/***/ }),
/* 753 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-button', {
    attrs: {
      "size": "small"
    },
    on: {
      "click": _vm.copyTxt
    }
  }, [_vm._t("default")], 2)
},staticRenderFns: []}

/***/ }),
/* 754 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "common-page-main main-page"
  }, [_c('div', {
    staticClass: "field-box scroll-cotar"
  }, [_c('div', {
    staticClass: "page-top-bar cfa"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "rfp"
  }, [_c('el-button', {
    attrs: {
      "size": "small",
      "icon": "plus",
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.showAddPop()
      }
    }
  }, [_vm._v("Add")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "table-wrap"
  }, [_c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.table.isLoading),
      expression: "table.isLoading"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.table.data,
      "element-loading-text": "Loading"
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": "Name",
      "prop": "CtName"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Sort",
      "prop": "Sort"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Operate",
      "width": "200"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "size": "small"
          },
          on: {
            "click": function($event) {
              return _vm.showUpdatePop(scope.$index, scope.row)
            }
          }
        }, [_vm._v("Edit")]), _vm._v(" "), _c('el-button', {
          attrs: {
            "size": "small"
          },
          on: {
            "click": function($event) {
              return _vm.handleDel(scope.$index, scope.row)
            }
          }
        }, [_vm._v("Delete")])]
      }
    }])
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "page-wrap"
  }, [_c('el-pagination', {
    attrs: {
      "current-page": _vm.table.currentPage,
      "page-size": _vm.table.pageSize,
      "layout": "total, prev, pager, next",
      "total": _vm.table.pageTotal
    },
    on: {
      "current-change": _vm.handleTableCurrentChange
    }
  })], 1)]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "Details",
      "visible": _vm.page.popShow,
      "size": "tine"
    },
    on: {
      "update:visible": function($event) {
        return _vm.$set(_vm.page, "popShow", $event)
      }
    }
  }, [_c('ProductMemberTypeForm', {
    ref: "popForm",
    on: {
      "addSuccess": _vm.handleAdd,
      "updateSuccess": _vm.handleUpdate
    }
  })], 1)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "headline lfp"
  }, [_c('span', [_vm._v("Agent classification")])])
}]}

/***/ }),
/* 755 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "common-page-main main-page"
  }, [_c('div', {
    staticClass: "field-box scroll-cotar"
  }, [_c('div', {
    staticClass: "page-top-bar cfa"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "rfp"
  }, [_c('el-button', {
    attrs: {
      "size": "small",
      "icon": "plus",
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.showAddPop()
      }
    }
  }, [_vm._v("add")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "table-wrap"
  }, [_c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.table.isLoading),
      expression: "table.isLoading"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.table.data,
      "element-loading-text": "LOADING"
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "CtName",
      "label": "Name"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "CtSort",
      "label": "Sort"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Operate"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "size": "small"
          },
          on: {
            "click": function($event) {
              return _vm.showUpdatePop(scope.$index, scope.row)
            }
          }
        }, [_vm._v("edit")]), _vm._v(" "), _c('el-button', {
          attrs: {
            "size": "small"
          },
          on: {
            "click": function($event) {
              return _vm.handleDel(scope.$index, scope.row)
            }
          }
        }, [_vm._v("delete")])]
      }
    }])
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "page-wrap"
  }, [_c('el-pagination', {
    attrs: {
      "current-page": _vm.table.currentPage,
      "page-size": _vm.table.pageSize,
      "layout": "total, prev, pager, next",
      "total": _vm.table.pageTotal
    },
    on: {
      "current-change": _vm.handleTableCurrentChange
    }
  })], 1)]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "case type detail",
      "visible": _vm.page.popShow,
      "size": "tine"
    },
    on: {
      "update:visible": function($event) {
        return _vm.$set(_vm.page, "popShow", $event)
      }
    }
  }, [_c('CaseTypeForm', {
    ref: "popForm",
    on: {
      "addSuccess": _vm.handleAdd,
      "updateSuccess": _vm.handleUpdate
    }
  })], 1)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "headline lfp"
  }, [_c('span', [_vm._v("Case Type Management")])])
}]}

/***/ }),
/* 756 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('div', {
    staticStyle: {
      "display": "none",
      "width": "0",
      "height": "0"
    },
    attrs: {
      "id": "common_upload_img"
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "none",
      "width": "0",
      "height": "0"
    },
    attrs: {
      "id": "common_upload_file"
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "none",
      "width": "0",
      "height": "0"
    },
    attrs: {
      "id": "common_upload_file_k3"
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "none",
      "width": "0",
      "height": "0"
    },
    attrs: {
      "id": "common_copy_btn"
    }
  }), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "router-fade",
      "mode": "out-in"
    }
  }, [_c('router-view')], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 757 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "common-page-main main-page"
  }, [_c('div', {
    staticClass: "field-box scroll-cotar"
  }, [_c('div', {
    staticClass: "page-top-bar cfa"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "rfp"
  }, [_c('el-button', {
    attrs: {
      "size": "small",
      "icon": "plus",
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.showAddPop()
      }
    }
  }, [_vm._v("新增")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "content-wrap"
  }, [_c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 4
    }
  }, [_c('div', {
    staticClass: "page-left-wrap"
  }, [_c('div', {
    staticClass: "sub-top-bar cfa"
  }, [_c('div', {
    staticClass: "title lfp"
  }, [_vm._v("User type")])]), _vm._v(" "), _c('el-tree', {
    attrs: {
      "data": _vm.tree.data,
      "props": _vm.tree.prop,
      "node-key": "CtCode",
      "current-node-key": _vm.tree.current ? _vm.tree.current.CtCode : '',
      "expand-on-click-node": false,
      "highlight-current": true,
      "default-expand-all": true
    },
    on: {
      "node-click": _vm.clickTypeTree
    }
  })], 1)]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 20
    }
  }, [_c('div', {
    staticClass: "table-wrap"
  }, [_c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.table.isLoading),
      expression: "table.isLoading"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.table.data,
      "element-loading-text": "Loading"
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": "Account",
      "prop": "Account"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Quotation coefficient",
      "prop": "Rate"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Name",
      "prop": "CuName"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Operate",
      "width": "300"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "size": "small"
          },
          on: {
            "click": function($event) {
              return _vm.showUpdatePop(scope.$index, scope.row)
            }
          }
        }, [_vm._v("Edit")]), _vm._v(" "), _c('el-button', {
          attrs: {
            "size": "small"
          },
          on: {
            "click": function($event) {
              return _vm.handleDel(scope.$index, scope.row)
            }
          }
        }, [_vm._v("Delete")]), _vm._v(" "), _c('el-button', {
          attrs: {
            "size": "small"
          },
          on: {
            "click": function($event) {
              return _vm.jumpNumberConfig(scope.$index, scope.row)
            }
          }
        }, [_vm._v("Quantity coefficient")])]
      }
    }])
  })], 1)], 1)])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "page-wrap"
  }, [_c('el-pagination', {
    attrs: {
      "current-page": _vm.table.currentPage,
      "page-size": _vm.table.pageSize,
      "layout": "total, prev, pager, next",
      "total": _vm.table.pageTotal
    },
    on: {
      "current-change": _vm.handleTableCurrentChange
    }
  })], 1)]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "Details",
      "visible": _vm.page.popShow,
      "size": "tine"
    },
    on: {
      "update:visible": function($event) {
        return _vm.$set(_vm.page, "popShow", $event)
      }
    }
  }, [_c('ProductMemberForm', {
    ref: "popForm",
    on: {
      "addSuccess": _vm.handleAdd,
      "updateSuccess": _vm.handleUpdate
    }
  })], 1)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "headline lfp"
  }, [_c('span', [_vm._v("User management")])])
}]}

/***/ }),
/* 758 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "common-page-main main-page"
  }, [_c('div', {
    staticClass: "field-box scroll-cotar"
  }, [_c('div', {
    staticClass: "page-top-bar cfa"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "rfp"
  }, [_c('el-button', {
    attrs: {
      "size": "small",
      "icon": "plus",
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.showAddPop()
      }
    }
  }, [_vm._v("add")]), _vm._v(" "), (_vm.$route.query.code != null) ? _c('el-button', {
    attrs: {
      "size": "small",
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.goBack()
      }
    }
  }, [_vm._v("back")]) : _vm._e()], 1)]), _vm._v(" "), _c('div', {
    staticClass: "table-wrap"
  }, [_c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.table.isLoading),
      expression: "table.isLoading"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.table.data,
      "element-loading-text": "LOADING"
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "PsName",
      "label": "type"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Operate"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "size": "small"
          },
          on: {
            "click": function($event) {
              return _vm.showUpdatePop(scope.$index, scope.row)
            }
          }
        }, [_vm._v("edit")]), _vm._v(" "), (scope.row.PsType < 3) ? _c('el-button', {
          attrs: {
            "size": "small"
          },
          on: {
            "click": function($event) {
              return _vm.SkipNextGrade(scope.$index, scope.row)
            }
          }
        }, [_vm._v("next level")]) : _vm._e(), _vm._v(" "), _c('el-button', {
          attrs: {
            "size": "small"
          },
          on: {
            "click": function($event) {
              return _vm.handleDel(scope.$index, scope.row)
            }
          }
        }, [_vm._v("delete")])]
      }
    }])
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "page-wrap"
  }, [_c('el-pagination', {
    attrs: {
      "current-page": _vm.table.currentPage,
      "page-size": _vm.table.pageSize,
      "layout": "total, prev, pager, next",
      "total": _vm.table.pageTotal
    },
    on: {
      "current-change": _vm.handleTableCurrentChange
    }
  })], 1)]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "product detail",
      "visible": _vm.page.popShow,
      "size": "tine"
    },
    on: {
      "update:visible": function($event) {
        return _vm.$set(_vm.page, "popShow", $event)
      }
    }
  }, [_c('ProductTypeFormSSGT', {
    ref: "popForm",
    on: {
      "addSuccess": _vm.handleAdd,
      "updateSuccess": _vm.handleUpdate
    }
  })], 1)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "headline lfp"
  }, [_c('span', [_vm._v("Transport Roller Classification Management")])])
}]}

/***/ }),
/* 759 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "width-box w600"
  }, [(_vm.formData) ? _c('el-form', {
    ref: "projectInfoForm",
    staticClass: "pop-form-wrap",
    attrs: {
      "label-width": "100px",
      "model": _vm.formData
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Name",
      "prop": "DtName"
    }
  }, [_c('el-input', {
    attrs: {
      "size": "small"
    },
    model: {
      value: (_vm.formData.DtName),
      callback: function($$v) {
        _vm.$set(_vm.formData, "DtName", $$v)
      },
      expression: "formData.DtName"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Sort",
      "prop": "DtSort"
    }
  }, [_c('el-input', {
    attrs: {
      "size": "small"
    },
    model: {
      value: (_vm.formData.DtSort),
      callback: function($$v) {
        _vm.$set(_vm.formData, "DtSort", _vm._n($$v))
      },
      expression: "formData.DtSort"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Is Leaf",
      "prop": "IsLeaf"
    }
  }, [_c('el-switch', {
    attrs: {
      "on-text": "",
      "off-text": ""
    },
    model: {
      value: (_vm.formData.IsLeaf),
      callback: function($$v) {
        _vm.$set(_vm.formData, "IsLeaf", $$v)
      },
      expression: "formData.IsLeaf"
    }
  })], 1), _vm._v(" "), _c('el-form-item', [_c('div', {
    staticClass: "pop-center-btn-wrap"
  }, [(!_vm.formData.Id) ? _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.doAdd('projectInfoForm')
      }
    }
  }, [_vm._v("add")]) : _vm._e(), _vm._v(" "), (_vm.formData.Id) ? _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.doUpdate('projectInfoForm')
      }
    }
  }, [_vm._v("save")]) : _vm._e()], 1)])], 1) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 760 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "w400"
  }, [(_vm.formData) ? _c('el-form', {
    ref: "commonForm",
    staticClass: "pop-form-wrap",
    attrs: {
      "label-width": "100px",
      "model": _vm.formData
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Name",
      "prop": "LbName"
    }
  }, [_c('el-input', {
    attrs: {
      "size": "small"
    },
    model: {
      value: (_vm.formData.LbName),
      callback: function($$v) {
        _vm.$set(_vm.formData, "LbName", $$v)
      },
      expression: "formData.LbName"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Sort",
      "prop": "LbSort"
    }
  }, [_c('el-input', {
    attrs: {
      "size": "small"
    },
    model: {
      value: (_vm.formData.LbSort),
      callback: function($$v) {
        _vm.$set(_vm.formData, "LbSort", _vm._n($$v))
      },
      expression: "formData.LbSort"
    }
  })], 1), _vm._v(" "), _c('el-form-item', [_c('div', {
    staticClass: "pop-center-btn-wrap"
  }, [(!_vm.formData.Id) ? _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.doAdd('commonForm')
      }
    }
  }, [_vm._v("add")]) : _vm._e(), _vm._v(" "), (_vm.formData.Id) ? _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.doUpdate('commonForm')
      }
    }
  }, [_vm._v("save")]) : _vm._e()], 1)])], 1) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 761 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "w400"
  }, [(_vm.formData) ? _c('el-form', {
    ref: "commonForm",
    staticClass: "pop-form-wrap",
    attrs: {
      "label-width": "90px",
      "model": _vm.formData
    }
  }, [_vm._t("default"), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Start time",
      "prop": "minTime"
    }
  }, [_c('el-date-picker', {
    attrs: {
      "type": "date"
    },
    model: {
      value: (_vm.formData.minTime),
      callback: function($$v) {
        _vm.$set(_vm.formData, "minTime", $$v)
      },
      expression: "formData.minTime"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "End time",
      "prop": "maxTime"
    }
  }, [_c('el-date-picker', {
    attrs: {
      "type": "date"
    },
    model: {
      value: (_vm.formData.maxTime),
      callback: function($$v) {
        _vm.$set(_vm.formData, "maxTime", $$v)
      },
      expression: "formData.maxTime"
    }
  })], 1), _vm._v(" "), _c('el-form-item', [_c('div', {
    staticClass: "pop-center-btn-wrap"
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.doExport('commonForm')
      }
    }
  }, [_vm._v("Confirm export")])], 1)])], 2) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 762 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: {
      'mc-editor-fullwidth': _vm.isFullWidth
    },
    attrs: {
      "id": _vm.vueUEditorId
    }
  }, [_c('VueUEditor', {
    staticClass: "editor-wrap",
    attrs: {
      "ueditorPath": _vm.config.AjaxUrl + '/Content/Plug-in-unit/utf8-net/'
    },
    on: {
      "ready": _vm.editorReady
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 763 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "user-login-main"
  }, [_c('div', {
    staticClass: "page-bg",
    attrs: {
      "id": "particles_bg"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "login-box"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "form-fill-wrap"
  }, [_c('div', {
    staticClass: "form-item hf"
  }, [_c('div', {
    staticClass: "ipt-wrap ftp"
  }, [_c('i', {
    staticClass: "icon-label fa fa-user ftp"
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.username),
      expression: "username"
    }],
    staticClass: "ipt",
    attrs: {
      "type": "text",
      "placeholder": "Please enter user name"
    },
    domProps: {
      "value": (_vm.username)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.username = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-item hf"
  }, [_c('div', {
    staticClass: "ipt-wrap ftp"
  }, [_c('i', {
    staticClass: "icon-label fa fa-lock ftp"
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.password),
      expression: "password"
    }],
    staticClass: "ipt",
    attrs: {
      "type": "password",
      "placeholder": "Please enter your password"
    },
    domProps: {
      "value": (_vm.password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.password = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "login-btn",
    on: {
      "click": _vm.doLogin
    }
  }, [_vm._v("Login")])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "login-title-wrap"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("Welcome to log in")])])
}]}

/***/ }),
/* 764 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "common-page-main main-page"
  }, [_c('div', {
    staticClass: "field-box scroll-cotar"
  }, [_c('div', {
    staticClass: "page-top-bar cfa"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "rfp"
  }, [_c('el-button', {
    attrs: {
      "size": "small",
      "icon": "plus",
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.showAddPop()
      }
    }
  }, [_vm._v("add")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "table-wrap"
  }, [_c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.table.isLoading),
      expression: "table.isLoading"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.table.data,
      "element-loading-text": "LOADING"
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": "Img"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('div', {
          staticClass: "common-table-row-img"
        }, [_c('img', {
          attrs: {
            "src": scope.row.BnImg
          }
        })])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "BnUrl",
      "label": "Skip Url"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "BnSort",
      "label": "Sort"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Operate"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "size": "small"
          },
          on: {
            "click": function($event) {
              return _vm.showUpdatePop(scope.$index, scope.row)
            }
          }
        }, [_vm._v("edit")]), _vm._v(" "), _c('el-button', {
          attrs: {
            "size": "small"
          },
          on: {
            "click": function($event) {
              return _vm.handleDel(scope.$index, scope.row)
            }
          }
        }, [_vm._v("delete")])]
      }
    }])
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "page-wrap"
  }, [_c('el-pagination', {
    attrs: {
      "current-page": _vm.table.currentPage,
      "page-size": _vm.table.pageSize,
      "layout": "total, prev, pager, next",
      "total": _vm.table.pageTotal
    },
    on: {
      "current-change": _vm.handleTableCurrentChange
    }
  })], 1)]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "Banner Manage",
      "visible": _vm.page.popShow,
      "size": "tine"
    },
    on: {
      "update:visible": function($event) {
        return _vm.$set(_vm.page, "popShow", $event)
      }
    }
  }, [_c('BannerForm', {
    ref: "popForm",
    on: {
      "addSuccess": _vm.handleAdd,
      "updateSuccess": _vm.handleUpdate
    }
  })], 1)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "headline lfp"
  }, [_c('span', [_vm._v("Banner Management")])])
}]}

/***/ }),
/* 765 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "mc-upload-wrap file-upload-warp"
  }, [_c('div', {
    directives: [{
      name: "fileupload",
      rawName: "v-fileupload",
      value: (_vm.fileUrl),
      expression: "fileUrl"
    }],
    staticClass: "upload-btn-wrap",
    on: {
      "upload-change": _vm.fileUploadSuccess
    }
  }, [_c('el-button', {
    attrs: {
      "size": "small",
      "icon": "upload2",
      "type": "primary"
    }
  }, [((_vm.workMode === 'url-name' && _vm.fileName) || (_vm.workMode === 'url' && _vm.fileUrl)) ? [_vm._v("re-upload file")] : [_vm._v("upload file")]], 2)], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: ((_vm.workMode === 'url-name' && _vm.fileName) || (_vm.workMode === 'url' && _vm.fileUrl)),
      expression: "(workMode === 'url-name' && fileName) || (workMode === 'url' && fileUrl)"
    }],
    staticClass: "file-info hf"
  }, [_c('div', {
    staticClass: "label ftp"
  }, [_vm._v("upload ready")]), _vm._v(" "), _c('i', {
    staticClass: "ftp el-icon-document"
  }), _vm._v(" "), (_vm.workMode === 'url-name') ? _c('div', {
    staticClass: "file-name ftp",
    style: ({
      width: _vm.width - 75 + 'px'
    })
  }, [_vm._v(_vm._s(_vm.fileName))]) : _vm._e(), _vm._v(" "), (_vm.workMode === 'url') ? _c('div', {
    staticClass: "file-name ftp",
    style: ({
      width: _vm.width - 75 + 'px'
    })
  }, [_vm._v(_vm._s(_vm.fileUrl))]) : _vm._e()])])
},staticRenderFns: []}

/***/ }),
/* 766 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "common-page-main main-page"
  }, [_c('div', {
    staticClass: "field-box scroll-cotar"
  }, [_c('div', {
    staticClass: "page-top-bar cfa"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "rfp"
  }, [_c('el-button', {
    attrs: {
      "size": "small",
      "icon": "plus",
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.showAddPop()
      }
    }
  }, [_vm._v("add")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "table-wrap"
  }, [_c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.table.isLoading),
      expression: "table.isLoading"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.table.data,
      "element-loading-text": "LOADING"
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": "Img"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('div', {
          staticClass: "common-table-row-img"
        }, [_c('img', {
          attrs: {
            "src": scope.row.PfImg
          }
        })])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "PfName",
      "label": "Name"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "PfSort",
      "label": "Sort"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Operate"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "size": "small"
          },
          on: {
            "click": function($event) {
              return _vm.showUpdatePop(scope.$index, scope.row)
            }
          }
        }, [_vm._v("edit")]), _vm._v(" "), _c('el-button', {
          attrs: {
            "size": "small"
          },
          on: {
            "click": function($event) {
              return _vm.handleDel(scope.$index, scope.row)
            }
          }
        }, [_vm._v("delete")])]
      }
    }])
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "page-wrap"
  }, [_c('el-pagination', {
    attrs: {
      "current-page": _vm.table.currentPage,
      "page-size": _vm.table.pageSize,
      "layout": "total, prev, pager, next",
      "total": _vm.table.pageTotal
    },
    on: {
      "current-change": _vm.handleTableCurrentChange
    }
  })], 1)]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "Problem Feedback Details",
      "visible": _vm.page.popShow,
      "size": "tine"
    },
    on: {
      "update:visible": function($event) {
        return _vm.$set(_vm.page, "popShow", $event)
      }
    }
  }, [_c('ProblemFeedBackForm', {
    ref: "popForm",
    on: {
      "addSuccess": _vm.handleAdd,
      "updateSuccess": _vm.handleUpdate
    }
  })], 1)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "headline lfp"
  }, [_c('span', [_vm._v("Problem feedback management")])])
}]}

/***/ }),
/* 767 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "w400"
  }, [(_vm.formData) ? _c('el-form', {
    ref: "commonForm",
    staticClass: "pop-form-wrap",
    attrs: {
      "label-width": "50px",
      "model": _vm.formData
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Password",
      "prop": "AuPassword"
    }
  }, [_c('el-input', {
    attrs: {
      "size": "small",
      "type": "password"
    },
    model: {
      value: (_vm.formData.AuPassword),
      callback: function($$v) {
        _vm.$set(_vm.formData, "AuPassword", $$v)
      },
      expression: "formData.AuPassword"
    }
  })], 1), _vm._v(" "), _c('el-form-item', [_c('div', {
    staticClass: "pop-center-btn-wrap"
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.doUpdate('commonForm')
      }
    }
  }, [_vm._v("save")])], 1)])], 1) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 768 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "width-box w600"
  }, [(_vm.formData) ? _c('el-form', {
    ref: "projectInfoForm",
    staticClass: "pop-form-wrap",
    attrs: {
      "label-width": "100px",
      "model": _vm.formData
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Name",
      "prop": "SpName"
    }
  }, [_c('el-input', {
    attrs: {
      "size": "small"
    },
    model: {
      value: (_vm.formData.SpName),
      callback: function($$v) {
        _vm.$set(_vm.formData, "SpName", $$v)
      },
      expression: "formData.SpName"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Sort",
      "prop": "SpSort"
    }
  }, [_c('el-input', {
    attrs: {
      "size": "small"
    },
    model: {
      value: (_vm.formData.SpSort),
      callback: function($$v) {
        _vm.$set(_vm.formData, "SpSort", _vm._n($$v))
      },
      expression: "formData.SpSort"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Content",
      "prop": "SpDescribe"
    }
  }, [_c('mc-editor', {
    ref: "editSpDescribe",
    model: {
      value: (_vm.formData.SpDescribe),
      callback: function($$v) {
        _vm.$set(_vm.formData, "SpDescribe", $$v)
      },
      expression: "formData.SpDescribe"
    }
  })], 1), _vm._v(" "), _c('el-form-item', [_c('div', {
    staticClass: "pop-center-btn-wrap"
  }, [(!_vm.formData.Id) ? _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.doAdd('projectInfoForm')
      }
    }
  }, [_vm._v("add")]) : _vm._e(), _vm._v(" "), (_vm.formData.Id) ? _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.doUpdate('projectInfoForm')
      }
    }
  }, [_vm._v("save")]) : _vm._e()], 1)])], 1) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 769 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "common-page-main main-page"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.page.popShow),
      expression: "!page.popShow"
    }],
    staticClass: "field-box scroll-cotar"
  }, [_c('div', {
    staticClass: "page-top-bar cfa"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "rfp"
  }, [_c('el-button', {
    attrs: {
      "size": "small",
      "icon": "plus",
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.showAddPop()
      }
    }
  }, [_vm._v("add")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "table-wrap"
  }, [_c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.table.isLoading),
      expression: "table.isLoading"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.table.data,
      "element-loading-text": "LOADING"
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": "Img"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('div', {
          staticClass: "common-table-row-img"
        }, [_c('img', {
          attrs: {
            "src": scope.row.CpImg
          }
        })])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "CpName",
      "label": "Skip Url"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "CpSort",
      "label": "Sort"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Operate"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "size": "small"
          },
          on: {
            "click": function($event) {
              return _vm.showUpdatePop(scope.$index, scope.row)
            }
          }
        }, [_vm._v("edit")]), _vm._v(" "), _c('el-button', {
          attrs: {
            "size": "small"
          },
          on: {
            "click": function($event) {
              return _vm.handleDel(scope.$index, scope.row)
            }
          }
        }, [_vm._v("delete")])]
      }
    }])
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "page-wrap"
  }, [_c('el-pagination', {
    attrs: {
      "current-page": _vm.table.currentPage,
      "page-size": _vm.table.pageSize,
      "layout": "total, prev, pager, next",
      "total": _vm.table.pageTotal
    },
    on: {
      "current-change": _vm.handleTableCurrentChange
    }
  })], 1)]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.page.popShow),
      expression: "page.popShow"
    }],
    staticClass: "field-box scroll-cotar"
  }, [_c('div', {
    staticClass: "page-top-bar cfa"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "rfp"
  }, [_c('el-button', {
    attrs: {
      "size": "small",
      "type": "danger"
    },
    on: {
      "click": function($event) {
        _vm.page.popShow = false
      }
    }
  }, [_vm._v("close")])], 1)]), _vm._v(" "), _c('CooperativeForm', {
    ref: "popForm",
    on: {
      "addSuccess": _vm.handleAdd,
      "updateSuccess": _vm.handleUpdate
    }
  })], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "headline lfp"
  }, [_c('span', [_vm._v("Cooperative Management")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "headline lfp"
  }, [_c('span', [_vm._v("Cooperative Manage")])])
}]}

/***/ }),
/* 770 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "clickoutside",
      rawName: "v-clickoutside",
      value: (_vm.handleCloseTree),
      expression: "handleCloseTree"
    }],
    ref: "atsTree",
    staticClass: "ats-tree"
  }, [_c('div', {
    staticClass: "ats-input",
    on: {
      "mouseenter": function($event) {
        _vm.hovering = true
      },
      "mouseleave": function($event) {
        _vm.hovering = false
      }
    }
  }, [(!this.multiple) ? _c('div', {
    staticClass: "ats-input-single"
  }, [_c('i', {
    staticClass: "el-input__icon el-icon-caret-bottom",
    class: {
      'is-reverse': _vm.treeVisible, 'el-icon-circle-close': _vm.showCloseIcon
    },
    on: {
      "click": function($event) {
        return _vm.handleCloseTree(!_vm.treeVisible)
      }
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.treeSelected),
      expression: "treeSelected"
    }],
    staticClass: "el-input__inner",
    attrs: {
      "type": "text",
      "placeholder": _vm.placetext
    },
    domProps: {
      "value": (_vm.treeSelected)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.treeSelected = $event.target.value
      }, _vm.handleFilter],
      "focus": function($event) {
        _vm.treeVisible = true
      },
      "blur": _vm.handleAutoComplete
    }
  })]) : _vm._e(), _vm._v(" "), (this.multiple) ? _c('div', {
    staticClass: "ats-input-multiple el-input__inner"
  }, [_c('i', {
    staticClass: "el-input__icon el-icon-caret-bottom",
    class: {
      'is-reverse': _vm.treeVisible
    },
    on: {
      "click": function($event) {
        return _vm.handleCloseTree(!_vm.treeVisible)
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "ats-labels"
  }, [_c('div', {
    staticClass: "el-select__tags",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.handleCloseTree(true)
      }
    }
  }, _vm._l((_vm.checkedItems), function(item) {
    return _c('el-tag', {
      key: item[_vm.treeProps.id],
      staticClass: "el-tag--primary",
      attrs: {
        "closable": true,
        "type": "primary",
        "title": _vm.handleTitleVisible(item[_vm.treeProps.label])
      },
      on: {
        "close": function($event) {
          return _vm.handleDelItem(item, $event)
        }
      }
    }, [_vm._v("\n            " + _vm._s(_vm._f("showEllips")(item[_vm.treeProps.label])) + "\n          ")])
  }), 1), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.treeSelected),
      expression: "treeSelected"
    }],
    ref: "multipleInput",
    attrs: {
      "type": "text",
      "placeholder": _vm.placetext
    },
    domProps: {
      "value": (_vm.treeSelected)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.treeSelected = $event.target.value
      }, _vm.handleFilter],
      "focus": function($event) {
        _vm.treeVisible = true
      },
      "blur": _vm.handleAutoComplete
    }
  })])]) : _vm._e()]), _vm._v(" "), _c('el-scrollbar', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.treeVisible),
      expression: "treeVisible"
    }],
    ref: "treeScrollbar",
    staticClass: "ats-tree-scrollbar"
  }, [_c('div', {
    staticClass: "ats-tree-wrapper"
  }, [_c('ul', {
    staticClass: "ats-tree-nodes"
  }, _vm._l((_vm.treeNodes[_vm.treeProps.children]), function(child) {
    return _c('tree-node', {
      key: child[_vm.treeProps.id],
      attrs: {
        "node": child,
        "multiple": _vm.multiple,
        "currentNodeId": _vm.currentNodeId,
        "treeProps": _vm.treeProps,
        "eventHub": _vm.eventHub,
        "query": _vm.query,
        "isQuering": _vm.isQuering
      }
    })
  }), 1)])])], 1)
},staticRenderFns: []}

/***/ }),
/* 771 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "common-page-main main-page"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.page.popShow),
      expression: "!page.popShow"
    }],
    staticClass: "field-box scroll-cotar"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "table-wrap"
  }, [_c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.table.isLoading),
      expression: "table.isLoading"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.table.data,
      "element-loading-text": "LOADING"
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "CaName",
      "label": "Name"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "CaSort",
      "label": "Sort"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Operate"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "size": "small"
          },
          on: {
            "click": function($event) {
              return _vm.showUpdatePop(scope.$index, scope.row)
            }
          }
        }, [_vm._v("edit")])]
      }
    }])
  })], 1)], 1)]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.page.popShow),
      expression: "page.popShow"
    }],
    staticClass: "field-box scroll-cotar"
  }, [_c('div', {
    staticClass: "page-top-bar cfa"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "rfp"
  }, [_c('el-button', {
    attrs: {
      "size": "small",
      "type": "danger"
    },
    on: {
      "click": function($event) {
        _vm.page.popShow = false
      }
    }
  }, [_vm._v("Close")])], 1)]), _vm._v(" "), _c('ContactForm', {
    ref: "popForm",
    on: {
      "updateSuccess": _vm.handleUpdate
    }
  })], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page-top-bar cfa"
  }, [_c('div', {
    staticClass: "headline lfp"
  }, [_c('span', [_vm._v("Contact Management")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "headline lfp"
  }, [_c('span', [_vm._v("Address Detail")])])
}]}

/***/ }),
/* 772 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "common-page-main main-page"
  }, [_c('div', {
    staticClass: "field-box scroll-cotar"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "table-wrap"
  }, [_c('ConfigForm', {
    ref: "popForm",
    on: {
      "updateSuccess": _vm.handleUpdate
    }
  })], 1)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page-top-bar cfa"
  }, [_c('div', {
    staticClass: "headline lfp"
  }, [_c('span', [_vm._v("Config Management")])])])
}]}

/***/ }),
/* 773 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "admin-user-info-page common-page-main main-page"
  }, [_c('div', {
    staticClass: "field-box scroll-cotar"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "content-wrap"
  }, [(_vm.formData) ? _c('el-form', {
    ref: "commonForm",
    staticClass: "pop-form-wrap w400",
    attrs: {
      "label-width": "80px",
      "model": _vm.formData
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Name",
      "prop": "AuName"
    }
  }, [_c('el-input', {
    attrs: {
      "size": "small"
    },
    model: {
      value: (_vm.formData.AuName),
      callback: function($$v) {
        _vm.$set(_vm.formData, "AuName", $$v)
      },
      expression: "formData.AuName"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Account",
      "prop": "AuAccount"
    }
  }, [_c('el-input', {
    attrs: {
      "size": "small",
      "disabled": true
    },
    model: {
      value: (_vm.formData.AuAccount),
      callback: function($$v) {
        _vm.$set(_vm.formData, "AuAccount", $$v)
      },
      expression: "formData.AuAccount"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Post",
      "prop": "AuPost"
    }
  }, [_c('el-input', {
    attrs: {
      "size": "small",
      "disabled": true
    },
    model: {
      value: (_vm.formData.AuPost),
      callback: function($$v) {
        _vm.$set(_vm.formData, "AuPost", $$v)
      },
      expression: "formData.AuPost"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Mobile",
      "prop": "AuMobile"
    }
  }, [_c('el-input', {
    attrs: {
      "size": "small"
    },
    model: {
      value: (_vm.formData.AuMobile),
      callback: function($$v) {
        _vm.$set(_vm.formData, "AuMobile", $$v)
      },
      expression: "formData.AuMobile"
    }
  })], 1), _vm._v(" "), _c('el-form-item', [_c('div', {
    staticClass: "pop-center-btn-wrap"
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.doUpdate('commonForm')
      }
    }
  }, [_vm._v("save")])], 1)])], 1) : _vm._e()], 1)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page-top-bar cfa"
  }, [_c('div', {
    staticClass: "headline lfp"
  }, [_c('span', [_vm._v("Member Manage")])])])
}]}

/***/ }),
/* 774 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "width-box w1000"
  }, [(_vm.formData) ? _c('el-form', {
    ref: "commonForm",
    staticClass: "pop-form-wrap",
    attrs: {
      "label-width": "100px",
      "model": _vm.formData
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "型号名称",
      "prop": "PsmName"
    }
  }, [_c('el-input', {
    attrs: {
      "size": "small"
    },
    model: {
      value: (_vm.formData.PsmName),
      callback: function($$v) {
        _vm.$set(_vm.formData, "PsmName", $$v)
      },
      expression: "formData.PsmName"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "型号Sort",
      "prop": "PsmSort"
    }
  }, [_c('el-input', {
    attrs: {
      "size": "small"
    },
    model: {
      value: (_vm.formData.PsmSort),
      callback: function($$v) {
        _vm.$set(_vm.formData, "PsmSort", $$v)
      },
      expression: "formData.PsmSort"
    }
  })], 1), _vm._v(" "), _c('el-form-item', [_c('div', {
    staticClass: "pop-center-btn-wrap"
  }, [(!_vm.formData.Id) ? _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.doAdd('commonForm')
      }
    }
  }, [_vm._v("add")]) : _vm._e(), _vm._v(" "), (_vm.formData.Id) ? _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.doUpdate('commonForm')
      }
    }
  }, [_vm._v("save")]) : _vm._e()], 1)])], 1) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 775 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "width-box w600"
  }, [(_vm.formData) ? _c('el-form', {
    ref: "projectInfoForm",
    staticClass: "pop-form-wrap",
    attrs: {
      "label-width": "100px",
      "model": _vm.formData
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Img",
      "prop": "PbImg"
    }
  }, [_c('img-upload', {
    attrs: {
      "tip": "Image recommended size：300*200"
    },
    model: {
      value: (_vm.formData.PbImg),
      callback: function($$v) {
        _vm.$set(_vm.formData, "PbImg", $$v)
      },
      expression: "formData.PbImg"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Name",
      "prop": "PbName"
    }
  }, [_c('el-input', {
    attrs: {
      "size": "small"
    },
    model: {
      value: (_vm.formData.PbName),
      callback: function($$v) {
        _vm.$set(_vm.formData, "PbName", $$v)
      },
      expression: "formData.PbName"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Describe",
      "prop": "PbDescribe"
    }
  }, [_c('el-input', {
    attrs: {
      "size": "small",
      "type": "textarea",
      "autosize": true
    },
    model: {
      value: (_vm.formData.PbDescribe),
      callback: function($$v) {
        _vm.$set(_vm.formData, "PbDescribe", $$v)
      },
      expression: "formData.PbDescribe"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Sort",
      "prop": "PbSort"
    }
  }, [_c('el-input', {
    attrs: {
      "size": "small"
    },
    model: {
      value: (_vm.formData.PbSort),
      callback: function($$v) {
        _vm.$set(_vm.formData, "PbSort", _vm._n($$v))
      },
      expression: "formData.PbSort"
    }
  })], 1), _vm._v(" "), _c('el-form-item', [_c('div', {
    staticClass: "pop-center-btn-wrap"
  }, [(!_vm.formData.Id) ? _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.doAdd('projectInfoForm')
      }
    }
  }, [_vm._v("add")]) : _vm._e(), _vm._v(" "), (_vm.formData.Id) ? _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.doUpdate('projectInfoForm')
      }
    }
  }, [_vm._v("save")]) : _vm._e()], 1)])], 1) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 776 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "common-page-main main-page"
  }, [_c('div', {
    staticClass: "field-box scroll-cotar"
  }, [_c('div', {
    staticClass: "page-top-bar cfa"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "rfp"
  }, [_c('el-button', {
    attrs: {
      "size": "small",
      "icon": "plus",
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.showAddPop()
      }
    }
  }, [_vm._v("add")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "table-wrap"
  }, [_c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.table.isLoading),
      expression: "table.isLoading"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.table.data,
      "element-loading-text": "LOADING"
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "NtName",
      "label": "Name"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "NtSort",
      "label": "Sort"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Operate"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "size": "small"
          },
          on: {
            "click": function($event) {
              return _vm.showUpdatePop(scope.$index, scope.row)
            }
          }
        }, [_vm._v("edit")]), _vm._v(" "), _c('copy-btn', {
          attrs: {
            "text": '/Cms/NewsCenter/' + scope.row.NtCode
          }
        }, [_vm._v("copy link")]), _vm._v(" "), _c('el-button', {
          attrs: {
            "size": "small"
          },
          on: {
            "click": function($event) {
              return _vm.handleDel(scope.$index, scope.row)
            }
          }
        }, [_vm._v("delete")])]
      }
    }])
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "page-wrap"
  }, [_c('el-pagination', {
    attrs: {
      "current-page": _vm.table.currentPage,
      "page-size": _vm.table.pageSize,
      "layout": "total, prev, pager, next",
      "total": _vm.table.pageTotal
    },
    on: {
      "current-change": _vm.handleTableCurrentChange
    }
  })], 1)]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "News Type Detail",
      "visible": _vm.page.popShow,
      "size": "tine"
    },
    on: {
      "update:visible": function($event) {
        return _vm.$set(_vm.page, "popShow", $event)
      }
    }
  }, [_c('NewsTypeForm', {
    ref: "popForm",
    on: {
      "addSuccess": _vm.handleAdd,
      "updateSuccess": _vm.handleUpdate
    }
  })], 1)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "headline lfp"
  }, [_c('span', [_vm._v("News Type Management")])])
}]}

/***/ }),
/* 777 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', {
    staticClass: "ats-tree-node",
    class: {
      'is-expanded': _vm.node.expanded
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.handleClick(_vm.node, $event)
      }
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.node.visible),
      expression: "node.visible"
    }],
    staticClass: "ats-tree-node__content",
    class: {
      'is-current': _vm.currentNodeId === _vm.node[_vm.treeProps.id], 'is-checked': _vm.node.checked
    },
    style: ({
      'padding-left': (_vm.node[_vm.treeProps.level] - 1) * 16 + 'px'
    })
  }, [_c('div', {
    staticClass: "ats-tree-node__icon icon"
  }, [(_vm.node[_vm.treeProps.children] && _vm.node[_vm.treeProps.children].length) ? _c('span', {
    staticClass: "ats-tree-node__expand-icon icon",
    class: {
      expanded: _vm.node.expanded
    }
  }) : _vm._e()]), _vm._v(" "), _c('span', {
    staticClass: "ats-tree-node__label",
    attrs: {
      "title": _vm.handleTitleVisible(_vm.node[_vm.treeProps.label])
    }
  }, [_vm._v(_vm._s(_vm.node[_vm.treeProps.label]))])]), _vm._v(" "), (_vm.node.expanded) ? _c('ul', {
    staticClass: "ats-tree-node__children"
  }, _vm._l((_vm.node[_vm.treeProps.children]), function(child) {
    return _c('tree-node', {
      key: child[_vm.treeProps.id],
      attrs: {
        "node": child,
        "treeProps": _vm.treeProps,
        "currentNodeId": _vm.currentNodeId,
        "eventHub": _vm.eventHub,
        "query": _vm.query,
        "isQuering": _vm.isQuering
      }
    })
  }), 1) : _vm._e()])
},staticRenderFns: []}

/***/ }),
/* 778 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "width-box w600"
  }, [(_vm.formData) ? _c('el-form', {
    ref: "projectInfoForm",
    staticClass: "pop-form-wrap fitem-w400",
    attrs: {
      "label-width": "100px",
      "model": _vm.formData
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Img",
      "prop": "BnImg"
    }
  }, [_c('img-upload', {
    attrs: {
      "tip": "Image recommended size：1920*400"
    },
    model: {
      value: (_vm.formData.BnImg),
      callback: function($$v) {
        _vm.$set(_vm.formData, "BnImg", $$v)
      },
      expression: "formData.BnImg"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Skip Url",
      "prop": "BnUrl"
    }
  }, [_c('el-input', {
    attrs: {
      "size": "small"
    },
    model: {
      value: (_vm.formData.BnUrl),
      callback: function($$v) {
        _vm.$set(_vm.formData, "BnUrl", $$v)
      },
      expression: "formData.BnUrl"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Sort",
      "prop": "BnSort"
    }
  }, [_c('el-input', {
    attrs: {
      "size": "small"
    },
    model: {
      value: (_vm.formData.BnSort),
      callback: function($$v) {
        _vm.$set(_vm.formData, "BnSort", _vm._n($$v))
      },
      expression: "formData.BnSort"
    }
  })], 1), _vm._v(" "), _c('el-form-item', [_c('div', {
    staticClass: "pop-center-btn-wrap"
  }, [(!_vm.formData.Id) ? _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.doAdd('projectInfoForm')
      }
    }
  }, [_vm._v("add")]) : _vm._e(), _vm._v(" "), (_vm.formData.Id) ? _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.doUpdate('projectInfoForm')
      }
    }
  }, [_vm._v("save")]) : _vm._e()], 1)])], 1) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 779 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "width-box w600"
  }, [(_vm.formData) ? _c('el-form', {
    ref: "projectInfoForm",
    staticClass: "pop-form-wrap",
    attrs: {
      "label-width": "100px",
      "model": _vm.formData
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Theme",
      "prop": "PsSubject"
    }
  }, [_c('el-input', {
    attrs: {
      "size": "small",
      "disabled": true
    },
    model: {
      value: (_vm.formData.PsSubject),
      callback: function($$v) {
        _vm.$set(_vm.formData, "PsSubject", $$v)
      },
      expression: "formData.PsSubject"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Leave Message",
      "prop": "PsMessage"
    }
  }, [_c('el-input', {
    attrs: {
      "size": "small",
      "disabled": true
    },
    model: {
      value: (_vm.formData.PsMessage),
      callback: function($$v) {
        _vm.$set(_vm.formData, "PsMessage", _vm._n($$v))
      },
      expression: "formData.PsMessage"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Reply Theme",
      "prop": "RpTheme"
    }
  }, [_c('el-input', {
    attrs: {
      "size": "small"
    },
    model: {
      value: (_vm.formData.RpTheme),
      callback: function($$v) {
        _vm.$set(_vm.formData, "RpTheme", _vm._n($$v))
      },
      expression: "formData.RpTheme"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Reply Content",
      "prop": "RpContent"
    }
  }, [_c('mc-editor', {
    ref: "editRpContent",
    model: {
      value: (_vm.formData.RpContent),
      callback: function($$v) {
        _vm.$set(_vm.formData, "RpContent", $$v)
      },
      expression: "formData.RpContent"
    }
  })], 1), _vm._v(" "), _c('el-form-item', [_c('div', {
    staticClass: "pop-center-btn-wrap"
  }, [(!_vm.formData.Id) ? _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.doAdd('projectInfoForm')
      }
    }
  }, [_vm._v("add")]) : _vm._e(), _vm._v(" "), (_vm.formData.Id) ? _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.doUpdate('projectInfoForm')
      }
    }
  }, [_vm._v("submit")]) : _vm._e()], 1)])], 1) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 780 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "width-box w600"
  }, [(_vm.formData) ? _c('el-form', {
    ref: "projectInfoForm",
    staticClass: "pop-form-wrap",
    attrs: {
      "label-width": "100px",
      "model": _vm.formData
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Img",
      "prop": "IsImg"
    }
  }, [_c('img-upload', {
    attrs: {
      "tip": "Image recommended size：313*180"
    },
    model: {
      value: (_vm.formData.IsImg),
      callback: function($$v) {
        _vm.$set(_vm.formData, "IsImg", $$v)
      },
      expression: "formData.IsImg"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Name",
      "prop": "IsName"
    }
  }, [_c('el-input', {
    attrs: {
      "size": "small"
    },
    model: {
      value: (_vm.formData.IsName),
      callback: function($$v) {
        _vm.$set(_vm.formData, "IsName", $$v)
      },
      expression: "formData.IsName"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Describe",
      "prop": "IsDes"
    }
  }, [_c('el-input', {
    attrs: {
      "size": "small",
      "type": "textarea",
      "autosize": true
    },
    model: {
      value: (_vm.formData.IsDes),
      callback: function($$v) {
        _vm.$set(_vm.formData, "IsDes", $$v)
      },
      expression: "formData.IsDes"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Skip Url",
      "prop": "IsUrl"
    }
  }, [_c('el-input', {
    attrs: {
      "size": "small"
    },
    model: {
      value: (_vm.formData.IsUrl),
      callback: function($$v) {
        _vm.$set(_vm.formData, "IsUrl", _vm._n($$v))
      },
      expression: "formData.IsUrl"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Sort",
      "prop": "IsSort"
    }
  }, [_c('el-input', {
    attrs: {
      "size": "small"
    },
    model: {
      value: (_vm.formData.IsSort),
      callback: function($$v) {
        _vm.$set(_vm.formData, "IsSort", _vm._n($$v))
      },
      expression: "formData.IsSort"
    }
  })], 1), _vm._v(" "), _c('el-form-item', [_c('div', {
    staticClass: "pop-center-btn-wrap"
  }, [(_vm.formData.Id) ? _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.doUpdate('projectInfoForm')
      }
    }
  }, [_vm._v("save")]) : _vm._e()], 1)])], 1) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 781 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "common-page-main main-page"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.page.popShow),
      expression: "!page.popShow"
    }],
    staticClass: "field-box scroll-cotar"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "table-wrap"
  }, [_c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.table.isLoading),
      expression: "table.isLoading"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.table.data,
      "element-loading-text": "LOADING"
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "PsUsername",
      "label": "Member Name"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "PsEmail",
      "label": "E-Mail"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "PsTelephone",
      "label": "Mobile"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "PsSubject",
      "label": "Theme"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "PsMessage",
      "label": "Leave Message"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Operate"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.PsState == 0) ? _c('el-button', {
          attrs: {
            "size": "small"
          },
          on: {
            "click": function($event) {
              return _vm.showUpdatePop(scope.$index, scope.row)
            }
          }
        }, [_vm._v("回复")]) : _vm._e(), _vm._v(" "), _c('el-button', {
          attrs: {
            "size": "small"
          },
          on: {
            "click": function($event) {
              return _vm.handleDel(scope.$index, scope.row)
            }
          }
        }, [_vm._v("delete")])]
      }
    }])
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "page-wrap"
  }, [_c('el-pagination', {
    attrs: {
      "current-page": _vm.table.currentPage,
      "page-size": _vm.table.pageSize,
      "layout": "total, prev, pager, next",
      "total": _vm.table.pageTotal
    },
    on: {
      "current-change": _vm.handleTableCurrentChange
    }
  })], 1)]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.page.popShow),
      expression: "page.popShow"
    }],
    staticClass: "field-box scroll-cotar"
  }, [_c('div', {
    staticClass: "page-top-bar cfa"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "rfp"
  }, [_c('el-button', {
    attrs: {
      "size": "small",
      "type": "danger"
    },
    on: {
      "click": function($event) {
        _vm.page.popShow = false
      }
    }
  }, [_vm._v("Close")])], 1)]), _vm._v(" "), _c('QuestionOne', {
    ref: "popForm",
    on: {
      "updateSuccess": _vm.handleUpdate
    }
  })], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page-top-bar cfa"
  }, [_c('div', {
    staticClass: "headline lfp"
  }, [_c('span', [_vm._v("Inquiry Management")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "headline lfp"
  }, [_c('span', [_vm._v("Reply To Inquiry")])])
}]}

/***/ }),
/* 782 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "width-box w1000"
  }, [(_vm.formData) ? _c('el-form', {
    ref: "commonForm",
    staticClass: "pop-form-wrap",
    attrs: {
      "label-width": "100px",
      "model": _vm.formData
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Cover",
      "prop": "PiCover"
    }
  }, [_c('img-upload', {
    attrs: {
      "tip": "Image recommended size：210*170"
    },
    model: {
      value: (_vm.formData.PiCover),
      callback: function($$v) {
        _vm.$set(_vm.formData, "PiCover", $$v)
      },
      expression: "formData.PiCover"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Img",
      "prop": "PiImg"
    }
  }, [_c('img-upload', {
    attrs: {
      "tip": "Image recommended size：700*400"
    },
    model: {
      value: (_vm.formData.PiImg),
      callback: function($$v) {
        _vm.$set(_vm.formData, "PiImg", $$v)
      },
      expression: "formData.PiImg"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Name",
      "prop": "PiName"
    }
  }, [_c('el-input', {
    attrs: {
      "size": "small"
    },
    model: {
      value: (_vm.formData.PiName),
      callback: function($$v) {
        _vm.$set(_vm.formData, "PiName", $$v)
      },
      expression: "formData.PiName"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Describe",
      "prop": "PiDescribe"
    }
  }, [_c('el-input', {
    attrs: {
      "size": "small",
      "type": "textarea"
    },
    model: {
      value: (_vm.formData.PiDescribe),
      callback: function($$v) {
        _vm.$set(_vm.formData, "PiDescribe", $$v)
      },
      expression: "formData.PiDescribe"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Sort",
      "prop": "PiSort"
    }
  }, [_c('el-input', {
    attrs: {
      "size": "small"
    },
    model: {
      value: (_vm.formData.PiSort),
      callback: function($$v) {
        _vm.$set(_vm.formData, "PiSort", _vm._n($$v))
      },
      expression: "formData.PiSort"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Attachment",
      "prop": "PiAttachment"
    }
  }, [_c('file-upload', {
    attrs: {
      "fileUrl": _vm.formData.PiAttachment,
      "workMode": "url"
    },
    on: {
      "update:fileUrl": function($event) {
        return _vm.$set(_vm.formData, "PiAttachment", $event)
      },
      "update:file-url": function($event) {
        return _vm.$set(_vm.formData, "PiAttachment", $event)
      }
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "UpdateTime",
      "prop": "UpdateTime"
    }
  }, [_c('el-date-picker', {
    attrs: {
      "type": "datetime",
      "disabled": "true"
    },
    model: {
      value: (_vm.formData.UpdateTime),
      callback: function($$v) {
        _vm.$set(_vm.formData, "UpdateTime", $$v)
      },
      expression: "formData.UpdateTime"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Content",
      "prop": "PiContent"
    }
  }, [_c('mc-editor', {
    ref: "editorPiContent",
    model: {
      value: (_vm.formData.PiContent),
      callback: function($$v) {
        _vm.$set(_vm.formData, "PiContent", $$v)
      },
      expression: "formData.PiContent"
    }
  })], 1), _vm._v(" "), _c('el-form-item', [_c('div', {
    staticClass: "pop-center-btn-wrap"
  }, [(!_vm.formData.Id) ? _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.doAdd('commonForm')
      }
    }
  }, [_vm._v("add")]) : _vm._e(), _vm._v(" "), (_vm.formData.Id) ? _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.doUpdate('commonForm')
      }
    }
  }, [_vm._v("save")]) : _vm._e()], 1)])], 1) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 783 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "width-box w400"
  }, [(_vm.formData) ? _c('el-form', {
    ref: "commonForm",
    staticClass: "pop-form-wrap",
    attrs: {
      "label-width": "80px",
      "model": _vm.formData
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Account",
      "prop": "Account"
    }
  }, [_c('el-input', {
    attrs: {
      "size": "small",
      "placeholder": "Please enter the content"
    },
    model: {
      value: (_vm.formData.Account),
      callback: function($$v) {
        _vm.$set(_vm.formData, "Account", $$v)
      },
      expression: "formData.Account"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Password",
      "prop": "Password"
    }
  }, [_c('el-input', {
    attrs: {
      "size": "small",
      "type": "password",
      "placeholder": "Please enter the content"
    },
    model: {
      value: (_vm.formData.Password),
      callback: function($$v) {
        _vm.$set(_vm.formData, "Password", $$v)
      },
      expression: "formData.Password"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Quotation coefficient",
      "prop": "Rate"
    }
  }, [_c('el-input', {
    attrs: {
      "size": "small",
      "placeholder": "Please enter the content"
    },
    model: {
      value: (_vm.formData.Rate),
      callback: function($$v) {
        _vm.$set(_vm.formData, "Rate", $$v)
      },
      expression: "formData.Rate"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Name",
      "prop": "CuName"
    }
  }, [_c('el-input', {
    attrs: {
      "size": "small",
      "placeholder": "Please enter the content"
    },
    model: {
      value: (_vm.formData.CuName),
      callback: function($$v) {
        _vm.$set(_vm.formData, "CuName", $$v)
      },
      expression: "formData.CuName"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "pop-center-btn-wrap"
  }, [(!_vm.formData.Id) ? _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.doAdd('commonForm')
      }
    }
  }, [_vm._v("Add")]) : _vm._e(), _vm._v(" "), (_vm.formData.Id) ? _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.doUpdate('commonForm')
      }
    }
  }, [_vm._v("Save")]) : _vm._e()], 1)], 1) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 784 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "w400"
  }, [(_vm.formData) ? _c('el-form', {
    ref: "commonForm",
    staticClass: "pop-form-wrap",
    attrs: {
      "label-width": "100px",
      "model": _vm.formData
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Menu Type",
      "prop": "MoType"
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "Please Select"
    },
    model: {
      value: (_vm.formData.MoType),
      callback: function($$v) {
        _vm.$set(_vm.formData, "MoType", $$v)
      },
      expression: "formData.MoType"
    }
  }, _vm._l((_vm.config.navGroup), function(item, i) {
    return _c('el-option', {
      key: i,
      attrs: {
        "label": item.label,
        "value": item.groupCode
      }
    })
  }), 1)], 1), _vm._v(" "), (!_vm.formData.Id) ? _c('el-form-item', {
    attrs: {
      "label": "Superior Menu",
      "prop": "MoFacode"
    }
  }, [_c('tree-select', {
    attrs: {
      "treeData": _vm.treeData,
      "treeProps": _vm.moduleProp,
      "multiple": false,
      "placeholder": "请选择"
    },
    on: {
      "errorCallback": _vm.showTreeError,
      "setSelectedId": _vm.setSelectedId
    },
    model: {
      value: (_vm.formData.MoFacode),
      callback: function($$v) {
        _vm.$set(_vm.formData, "MoFacode", $$v)
      },
      expression: "formData.MoFacode"
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Name",
      "prop": "MoName"
    }
  }, [_c('el-input', {
    attrs: {
      "size": "small"
    },
    model: {
      value: (_vm.formData.MoName),
      callback: function($$v) {
        _vm.$set(_vm.formData, "MoName", $$v)
      },
      expression: "formData.MoName"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Logo",
      "prop": "MoLogo"
    }
  }, [_c('div', {
    staticClass: "icon-select-wrap hf"
  }, [_c('el-row', _vm._l((_vm.iconList), function(item, i) {
    return _c('el-col', {
      key: i,
      attrs: {
        "span": 4
      }
    }, [_c('div', {
      staticClass: "item ftp",
      class: {
        active: item === _vm.formData.MoLogo
      },
      on: {
        "click": function($event) {
          return _vm.selectLogo(item)
        }
      }
    }, [_c('span', {
      staticClass: "fa",
      class: item
    })])])
  }), 1)], 1)]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Describe",
      "prop": "MoDescribe"
    }
  }, [_c('el-input', {
    attrs: {
      "size": "small"
    },
    model: {
      value: (_vm.formData.MoDescribe),
      callback: function($$v) {
        _vm.$set(_vm.formData, "MoDescribe", $$v)
      },
      expression: "formData.MoDescribe"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Sort",
      "prop": "MoSort"
    }
  }, [_c('el-input', {
    attrs: {
      "size": "small"
    },
    model: {
      value: (_vm.formData.MoSort),
      callback: function($$v) {
        _vm.$set(_vm.formData, "MoSort", _vm._n($$v))
      },
      expression: "formData.MoSort"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Is Leaf",
      "prop": "IsLeaf"
    }
  }, [_c('el-switch', {
    attrs: {
      "on-text": "",
      "off-text": ""
    },
    model: {
      value: (_vm.formData.IsLeaf),
      callback: function($$v) {
        _vm.$set(_vm.formData, "IsLeaf", $$v)
      },
      expression: "formData.IsLeaf"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.formData.IsLeaf),
      expression: "formData.IsLeaf"
    }],
    attrs: {
      "label": "URL",
      "prop": "MoUrl"
    }
  }, [_c('el-input', {
    attrs: {
      "size": "small"
    },
    model: {
      value: (_vm.formData.MoUrl),
      callback: function($$v) {
        _vm.$set(_vm.formData, "MoUrl", $$v)
      },
      expression: "formData.MoUrl"
    }
  })], 1), _vm._v(" "), _c('el-form-item', [_c('div', {
    staticClass: "pop-center-btn-wrap"
  }, [(!_vm.formData.Id) ? _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.doAdd('commonForm')
      }
    }
  }, [_vm._v("add")]) : _vm._e(), _vm._v(" "), (_vm.formData.Id) ? _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.doUpdate('commonForm')
      }
    }
  }, [_vm._v("save")]) : _vm._e()], 1)])], 1) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 785 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "common-page-main main-page"
  }, [_c('div', {
    staticClass: "field-box scroll-cotar"
  }, [_c('div', {
    staticClass: "page-top-bar cfa"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "rfp"
  }, [(false) ? _c('el-button', {
    attrs: {
      "size": "small",
      "icon": "plus",
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.showAddPop()
      }
    }
  }, [_vm._v("add")]) : _vm._e()], 1)]), _vm._v(" "), _c('div', {
    staticClass: "table-wrap"
  }, [_c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.table.isLoading),
      expression: "table.isLoading"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.table.data,
      "element-loading-text": "LOADING"
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "StName",
      "label": "Name"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Operate"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "size": "small"
          },
          on: {
            "click": function($event) {
              return _vm.showUpdatePop(scope.$index, scope.row)
            }
          }
        }, [_vm._v("edit")]), _vm._v(" "), _c('el-button', {
          attrs: {
            "size": "small"
          },
          on: {
            "click": function($event) {
              return _vm.handleDel(scope.$index, scope.row)
            }
          }
        }, [_vm._v("delete")])]
      }
    }])
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "page-wrap"
  }, [_c('el-pagination', {
    attrs: {
      "current-page": _vm.table.currentPage,
      "page-size": _vm.table.pageSize,
      "layout": "total, prev, pager, next",
      "total": _vm.table.pageTotal
    },
    on: {
      "current-change": _vm.handleTableCurrentChange
    }
  })], 1)]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "Staffmien Type Detail",
      "visible": _vm.page.popShow,
      "size": "tine"
    },
    on: {
      "update:visible": function($event) {
        return _vm.$set(_vm.page, "popShow", $event)
      }
    }
  }, [_c('StaffmienTypeForm', {
    ref: "popForm",
    on: {
      "addSuccess": _vm.handleAdd,
      "updateSuccess": _vm.handleUpdate
    }
  })], 1)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "headline lfp"
  }, [_c('span', [_vm._v("Staffmien Type Management")])])
}]}

/***/ }),
/* 786 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "width-box w600"
  }, [(_vm.formData) ? _c('el-form', {
    ref: "projectInfoForm",
    staticClass: "pop-form-wrap",
    attrs: {
      "label-width": "100px",
      "model": _vm.formData
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Cover",
      "prop": "NbImg"
    }
  }, [_c('img-upload', {
    attrs: {
      "tip": "Image recommended size：1920*225"
    },
    model: {
      value: (_vm.formData.NbImg),
      callback: function($$v) {
        _vm.$set(_vm.formData, "NbImg", $$v)
      },
      expression: "formData.NbImg"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Name",
      "prop": "NbName"
    }
  }, [_c('el-input', {
    attrs: {
      "size": "small"
    },
    model: {
      value: (_vm.formData.NbName),
      callback: function($$v) {
        _vm.$set(_vm.formData, "NbName", $$v)
      },
      expression: "formData.NbName"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Skip Url",
      "prop": "NbUrl"
    }
  }, [_c('el-input', {
    attrs: {
      "size": "small"
    },
    model: {
      value: (_vm.formData.NbUrl),
      callback: function($$v) {
        _vm.$set(_vm.formData, "NbUrl", $$v)
      },
      expression: "formData.NbUrl"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Sort",
      "prop": "NbSort"
    }
  }, [_c('el-input', {
    attrs: {
      "size": "small"
    },
    model: {
      value: (_vm.formData.NbSort),
      callback: function($$v) {
        _vm.$set(_vm.formData, "NbSort", _vm._n($$v))
      },
      expression: "formData.NbSort"
    }
  })], 1), _vm._v(" "), (_vm.formData.NbFacode === '0') ? _c('el-form-item', {
    attrs: {
      "label": "Is Leaf",
      "prop": "IsLeaf"
    }
  }, [_c('el-switch', {
    attrs: {
      "on-text": "",
      "off-text": ""
    },
    model: {
      value: (_vm.formData.IsLeaf),
      callback: function($$v) {
        _vm.$set(_vm.formData, "IsLeaf", $$v)
      },
      expression: "formData.IsLeaf"
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "SeoTitle",
      "prop": "SeoTitle"
    }
  }, [_c('el-input', {
    attrs: {
      "size": "small"
    },
    model: {
      value: (_vm.formData.SeoTitle),
      callback: function($$v) {
        _vm.$set(_vm.formData, "SeoTitle", $$v)
      },
      expression: "formData.SeoTitle"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "SeoDescribetion",
      "prop": "SeoDescribetion"
    }
  }, [_c('el-input', {
    attrs: {
      "size": "small",
      "autosize": {
        minRows: 4
      },
      "type": "textarea"
    },
    model: {
      value: (_vm.formData.SeoDescribetion),
      callback: function($$v) {
        _vm.$set(_vm.formData, "SeoDescribetion", $$v)
      },
      expression: "formData.SeoDescribetion"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "SeoKey",
      "prop": "SeoKey"
    }
  }, [_vm._l((_vm.dynamicTags), function(tag) {
    return _c('el-tag', {
      key: tag,
      attrs: {
        "closable": "",
        "disable-transitions": false
      },
      on: {
        "close": function($event) {
          return _vm.handleClose(tag)
        }
      }
    }, [_vm._v("\n        " + _vm._s(tag) + "\n      ")])
  }), _vm._v(" "), (_vm.inputVisible) ? _c('el-input', {
    ref: "saveTagInput",
    staticClass: "input-new-tag",
    attrs: {
      "size": "small"
    },
    on: {
      "blur": _vm.handleInputConfirm
    },
    nativeOn: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.handleInputConfirm($event)
      }
    },
    model: {
      value: (_vm.inputValue),
      callback: function($$v) {
        _vm.inputValue = $$v
      },
      expression: "inputValue"
    }
  }) : _c('el-button', {
    staticClass: "button-new-tag",
    attrs: {
      "size": "small"
    },
    on: {
      "click": _vm.showInput
    }
  }, [_vm._v("+ Add")])], 2), _vm._v(" "), _c('el-form-item', [_c('div', {
    staticClass: "pop-center-btn-wrap"
  }, [(!_vm.formData.Id) ? _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.doAdd('projectInfoForm')
      }
    }
  }, [_vm._v("add")]) : _vm._e(), _vm._v(" "), (_vm.formData.Id) ? _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.doUpdate('projectInfoForm')
      }
    }
  }, [_vm._v("save")]) : _vm._e()], 1)])], 1) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 787 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "common-page-main main-page"
  }, [_c('div', {
    staticClass: "field-box scroll-cotar"
  }, [_c('div', {
    staticClass: "page-top-bar cfa"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "rfp"
  }, [_c('el-button', {
    attrs: {
      "size": "small"
    },
    on: {
      "click": function($event) {
        return _vm.goBack()
      }
    }
  }, [_vm._v("Back")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "size": "small",
      "icon": "plus",
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.showAddPop()
      }
    }
  }, [_vm._v("新增")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "table-wrap"
  }, [_c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.table.isLoading),
      expression: "table.isLoading"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.table.data,
      "element-loading-text": "Loading"
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": "Quantity",
      "prop": "Num"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Coefficient",
      "prop": "Rate"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Remark",
      "prop": "Reamrk"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Operate",
      "width": "200"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "size": "small"
          },
          on: {
            "click": function($event) {
              return _vm.showUpdatePop(scope.$index, scope.row)
            }
          }
        }, [_vm._v("Edit")]), _vm._v(" "), _c('el-button', {
          attrs: {
            "size": "small"
          },
          on: {
            "click": function($event) {
              return _vm.handleDel(scope.$index, scope.row)
            }
          }
        }, [_vm._v("Delete")])]
      }
    }])
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "page-wrap"
  }, [_c('el-pagination', {
    attrs: {
      "current-page": _vm.table.currentPage,
      "page-size": _vm.table.pageSize,
      "layout": "total, prev, pager, next",
      "total": _vm.table.pageTotal
    },
    on: {
      "current-change": _vm.handleTableCurrentChange
    }
  })], 1)]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "Details",
      "visible": _vm.page.popShow,
      "size": "tine"
    },
    on: {
      "update:visible": function($event) {
        return _vm.$set(_vm.page, "popShow", $event)
      }
    }
  }, [_c('ProductNumberConfigForm', {
    ref: "popForm",
    on: {
      "addSuccess": _vm.handleAdd,
      "updateSuccess": _vm.handleUpdate
    }
  })], 1)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "headline lfp"
  }, [_c('span', [_vm._v("User quantity coefficient")])])
}]}

/***/ }),
/* 788 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "width-box w1000"
  }, [(_vm.formData) ? _c('el-form', {
    ref: "projectInfoForm",
    staticClass: "pop-form-wrap",
    attrs: {
      "label-width": "100px",
      "model": _vm.formData
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Name",
      "prop": "CaName"
    }
  }, [_c('el-input', {
    attrs: {
      "size": "small"
    },
    model: {
      value: (_vm.formData.CaName),
      callback: function($$v) {
        _vm.$set(_vm.formData, "CaName", $$v)
      },
      expression: "formData.CaName"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Sort",
      "prop": "CaSort"
    }
  }, [_c('el-input', {
    attrs: {
      "size": "small"
    },
    model: {
      value: (_vm.formData.CaSort),
      callback: function($$v) {
        _vm.$set(_vm.formData, "CaSort", _vm._n($$v))
      },
      expression: "formData.CaSort"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Content",
      "prop": "CaContent"
    }
  }, [_c('mc-editor', {
    ref: "editContent",
    model: {
      value: (_vm.formData.CaContent),
      callback: function($$v) {
        _vm.$set(_vm.formData, "CaContent", $$v)
      },
      expression: "formData.CaContent"
    }
  })], 1), _vm._v(" "), _c('el-form-item', [_c('div', {
    staticClass: "pop-center-btn-wrap"
  }, [(_vm.formData.Id) ? _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.doUpdate('projectInfoForm')
      }
    }
  }, [_vm._v("save")]) : _vm._e()], 1)])], 1) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 789 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "common-page-main main-page"
  }, [_c('div', {
    staticClass: "field-box scroll-cotar"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "table-wrap"
  }, [_c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.table.isLoading),
      expression: "table.isLoading"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.table.data,
      "element-loading-text": "LOADING"
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "FbName",
      "label": "Name"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "FbMobile",
      "label": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "FbEmail",
      "label": "Mail"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "FbAddress",
      "label": "Address"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "FbContent",
      "label": "Content"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Operate"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "size": "small"
          },
          on: {
            "click": function($event) {
              return _vm.handleDel(scope.$index, scope.row)
            }
          }
        }, [_vm._v("delete")])]
      }
    }])
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "page-wrap"
  }, [_c('el-pagination', {
    attrs: {
      "current-page": _vm.table.currentPage,
      "page-size": _vm.table.pageSize,
      "layout": "total, prev, pager, next",
      "total": _vm.table.pageTotal
    },
    on: {
      "current-change": _vm.handleTableCurrentChange
    }
  })], 1)]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "Feedback Manage",
      "visible": _vm.page.popShow,
      "size": "tine"
    },
    on: {
      "update:visible": function($event) {
        return _vm.$set(_vm.page, "popShow", $event)
      }
    }
  }, [_c('BannerForm', {
    ref: "popForm",
    on: {
      "addSuccess": _vm.handleAdd,
      "updateSuccess": _vm.handleUpdate
    }
  })], 1)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page-top-bar cfa"
  }, [_c('div', {
    staticClass: "headline lfp"
  }, [_c('span', [_vm._v("Feedback Manage")])])])
}]}

/***/ }),
/* 790 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "width-box w1000"
  }, [(_vm.formData) ? _c('el-form', {
    ref: "commonForm",
    staticClass: "pop-form-wrap",
    attrs: {
      "label-width": "100px",
      "model": _vm.formData
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Name",
      "prop": "NiName"
    }
  }, [_c('el-input', {
    attrs: {
      "size": "small"
    },
    model: {
      value: (_vm.formData.NiName),
      callback: function($$v) {
        _vm.$set(_vm.formData, "NiName", $$v)
      },
      expression: "formData.NiName"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Img",
      "prop": "NiImg"
    }
  }, [_c('img-upload', {
    attrs: {
      "tip": "Image recommended size：300*200"
    },
    model: {
      value: (_vm.formData.NiImg),
      callback: function($$v) {
        _vm.$set(_vm.formData, "NiImg", $$v)
      },
      expression: "formData.NiImg"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Describe",
      "prop": "NiDescribe"
    }
  }, [_c('el-input', {
    attrs: {
      "size": "small",
      "type": "textarea"
    },
    model: {
      value: (_vm.formData.NiDescribe),
      callback: function($$v) {
        _vm.$set(_vm.formData, "NiDescribe", $$v)
      },
      expression: "formData.NiDescribe"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Sort",
      "prop": "NiSort"
    }
  }, [_c('el-input', {
    attrs: {
      "size": "small"
    },
    model: {
      value: (_vm.formData.NiSort),
      callback: function($$v) {
        _vm.$set(_vm.formData, "NiSort", _vm._n($$v))
      },
      expression: "formData.NiSort"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Is Index",
      "prop": "IsIndex"
    }
  }, [_c('el-switch', {
    attrs: {
      "on-text": "",
      "off-text": ""
    },
    model: {
      value: (_vm.formData.IsIndex),
      callback: function($$v) {
        _vm.$set(_vm.formData, "IsIndex", $$v)
      },
      expression: "formData.IsIndex"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Is Hot",
      "prop": "IsHot"
    }
  }, [_c('el-switch', {
    attrs: {
      "on-text": "",
      "off-text": ""
    },
    model: {
      value: (_vm.formData.IsHot),
      callback: function($$v) {
        _vm.$set(_vm.formData, "IsHot", $$v)
      },
      expression: "formData.IsHot"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Is Release",
      "prop": "IsRelease"
    }
  }, [_c('el-switch', {
    attrs: {
      "on-text": "",
      "off-text": ""
    },
    model: {
      value: (_vm.formData.IsRelease),
      callback: function($$v) {
        _vm.$set(_vm.formData, "IsRelease", $$v)
      },
      expression: "formData.IsRelease"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Release Time",
      "prop": "ReleaseTime"
    }
  }, [_c('el-date-picker', {
    attrs: {
      "type": "date",
      "picker-options": _vm.pickerOptions0
    },
    model: {
      value: (_vm.formData.ReleaseTime),
      callback: function($$v) {
        _vm.$set(_vm.formData, "ReleaseTime", $$v)
      },
      expression: "formData.ReleaseTime"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "New Content",
      "prop": "NiContent"
    }
  }, [_c('mc-editor', {
    ref: "editNiContent",
    model: {
      value: (_vm.formData.NiContent),
      callback: function($$v) {
        _vm.$set(_vm.formData, "NiContent", $$v)
      },
      expression: "formData.NiContent"
    }
  })], 1), _vm._v(" "), _c('el-form-item', [_c('div', {
    staticClass: "pop-center-btn-wrap"
  }, [(!_vm.formData.Id) ? _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.doAdd('commonForm')
      }
    }
  }, [_vm._v("add")]) : _vm._e(), _vm._v(" "), (_vm.formData.Id) ? _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.doUpdate('commonForm')
      }
    }
  }, [_vm._v("save")]) : _vm._e()], 1)])], 1) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 791 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "width-box w600"
  }, [(_vm.formData) ? _c('el-form', {
    ref: "projectInfoForm",
    staticClass: "pop-form-wrap",
    attrs: {
      "label-width": "100px",
      "model": _vm.formData
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Name",
      "prop": "NtName"
    }
  }, [_c('el-input', {
    attrs: {
      "size": "small"
    },
    model: {
      value: (_vm.formData.NtName),
      callback: function($$v) {
        _vm.$set(_vm.formData, "NtName", $$v)
      },
      expression: "formData.NtName"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Sort",
      "prop": "NtSort"
    }
  }, [_c('el-input', {
    attrs: {
      "size": "small"
    },
    model: {
      value: (_vm.formData.NtSort),
      callback: function($$v) {
        _vm.$set(_vm.formData, "NtSort", _vm._n($$v))
      },
      expression: "formData.NtSort"
    }
  })], 1), _vm._v(" "), _c('el-form-item', [_c('div', {
    staticClass: "pop-center-btn-wrap"
  }, [(!_vm.formData.Id) ? _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.doAdd('projectInfoForm')
      }
    }
  }, [_vm._v("add")]) : _vm._e(), _vm._v(" "), (_vm.formData.Id) ? _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.doUpdate('projectInfoForm')
      }
    }
  }, [_vm._v("save")]) : _vm._e()], 1)])], 1) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 792 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "width-box w1000"
  }, [(_vm.formData) ? _c('el-form', {
    ref: "commonForm",
    staticClass: "pop-form-wrap",
    attrs: {
      "label-width": "100px",
      "model": _vm.formData
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Staff Name",
      "prop": "SiName"
    }
  }, [_c('el-input', {
    attrs: {
      "size": "small"
    },
    model: {
      value: (_vm.formData.SiName),
      callback: function($$v) {
        _vm.$set(_vm.formData, "SiName", $$v)
      },
      expression: "formData.SiName"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Img",
      "prop": "SiImg"
    }
  }, [(_vm.formData.StCode != '20170907aa8d0352') ? _c('img-upload', {
    attrs: {
      "tip": "Image recommended size：300*210"
    },
    model: {
      value: (_vm.formData.SiImg),
      callback: function($$v) {
        _vm.$set(_vm.formData, "SiImg", $$v)
      },
      expression: "formData.SiImg"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.formData.StCode == '20170907aa8d0352') ? _c('img-upload', {
    attrs: {
      "tip": "Image recommended size：220*150"
    },
    model: {
      value: (_vm.formData.SiImg),
      callback: function($$v) {
        _vm.$set(_vm.formData, "SiImg", $$v)
      },
      expression: "formData.SiImg"
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Describe",
      "prop": "SiDescribe"
    }
  }, [_c('el-input', {
    attrs: {
      "size": "small",
      "type": "textarea"
    },
    model: {
      value: (_vm.formData.SiDescribe),
      callback: function($$v) {
        _vm.$set(_vm.formData, "SiDescribe", $$v)
      },
      expression: "formData.SiDescribe"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Sort",
      "prop": "SiSort"
    }
  }, [_c('el-input', {
    attrs: {
      "size": "small"
    },
    model: {
      value: (_vm.formData.SiSort),
      callback: function($$v) {
        _vm.$set(_vm.formData, "SiSort", _vm._n($$v))
      },
      expression: "formData.SiSort"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Content",
      "prop": "SiContent"
    }
  }, [_c('mc-editor', {
    ref: "editContent",
    model: {
      value: (_vm.formData.SiContent),
      callback: function($$v) {
        _vm.$set(_vm.formData, "SiContent", $$v)
      },
      expression: "formData.SiContent"
    }
  })], 1), _vm._v(" "), _c('el-form-item', [_c('div', {
    staticClass: "pop-center-btn-wrap"
  }, [(!_vm.formData.Id) ? _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.doAdd('commonForm')
      }
    }
  }, [_vm._v("add")]) : _vm._e(), _vm._v(" "), (_vm.formData.Id) ? _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.doUpdate('commonForm')
      }
    }
  }, [_vm._v("save")]) : _vm._e()], 1)])], 1) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 793 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "common-page-main main-page"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.page.popShow),
      expression: "!page.popShow"
    }],
    staticClass: "field-box scroll-cotar"
  }, [_c('div', {
    staticClass: "page-top-bar cfa"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.tree.current),
      expression: "tree.current"
    }],
    staticClass: "rfp"
  }, [_c('el-button', {
    attrs: {
      "size": "small",
      "icon": "plus",
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.showAddPop()
      }
    }
  }, [_vm._v("add news")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "content-wrap"
  }, [_c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 4
    }
  }, [_c('div', {
    staticClass: "page-left-wrap"
  }, [_c('div', {
    staticClass: "sub-top-bar cfa"
  }, [_c('div', {
    staticClass: "title lfp"
  }, [_vm._v("news type")])]), _vm._v(" "), _c('el-tree', {
    attrs: {
      "data": _vm.tree.data,
      "props": _vm.tree.prop,
      "expand-on-click-node": false,
      "highlight-current": true,
      "default-expand-all": true
    },
    on: {
      "node-click": _vm.clickModuleTree
    }
  })], 1)]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 20
    }
  }, [_c('div', {
    staticClass: "page-right-wrap"
  }, [(_vm.tree.current) ? _c('div', {
    staticClass: "sub-top-bar cfa"
  }, [_c('div', {
    staticClass: "title lfp"
  }, [_vm._v(_vm._s(_vm.tree.current.NtName))])]) : _vm._e(), _vm._v(" "), _c('el-table', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.table.data,
      "element-loading-text": "LOADING"
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "NiName",
      "label": "Name"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "NiSort",
      "label": "Sort",
      "width": "120"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "NiRead",
      "label": "Read Volume",
      "width": "160"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Operate"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "size": "small"
          },
          on: {
            "click": function($event) {
              return _vm.showUpdatePop(scope.$index, scope.row)
            }
          }
        }, [_vm._v("edit")]), _vm._v(" "), _c('copy-btn', {
          attrs: {
            "text": '/Cms/NewsDetails/' + scope.row.NiCode + '?pathId=20170907c5c74e49'
          }
        }, [_vm._v("copy link")]), _vm._v(" "), _c('el-button', {
          attrs: {
            "size": "small"
          },
          on: {
            "click": function($event) {
              return _vm.handleDel(scope.$index, scope.row)
            }
          }
        }, [_vm._v("delete")])]
      }
    }])
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "page-wrap"
  }, [_c('el-pagination', {
    attrs: {
      "current-page": _vm.table.currentPage,
      "page-size": _vm.table.pageSize,
      "layout": "total, prev, pager, next",
      "total": _vm.table.pageTotal
    },
    on: {
      "current-change": _vm.handleTableCurrentChange
    }
  })], 1)], 1)])], 1)], 1)]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.page.popShow),
      expression: "page.popShow"
    }],
    staticClass: "field-box scroll-cotar"
  }, [_c('div', {
    staticClass: "page-top-bar cfa"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "rfp"
  }, [_c('el-button', {
    attrs: {
      "size": "small",
      "type": "danger"
    },
    on: {
      "click": function($event) {
        _vm.page.popShow = false
      }
    }
  }, [_vm._v("Close")])], 1)]), _vm._v(" "), _c('NewsForm', {
    ref: "popForm",
    attrs: {
      "sideCurrent": _vm.tree.current
    },
    on: {
      "addSuccess": _vm.handleAdd,
      "updateSuccess": _vm.handleUpdate
    }
  })], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "headline lfp"
  }, [_c('span', [_vm._v("News NewsManagement")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "headline lfp"
  }, [_c('span', [_vm._v("news detail")])])
}]}

/***/ }),
/* 794 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "common-page-main main-page"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.page.popShow),
      expression: "!page.popShow"
    }],
    staticClass: "field-box scroll-cotar"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "table-wrap"
  }, [_c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.table.isLoading),
      expression: "table.isLoading"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.table.data,
      "element-loading-text": "LOADING"
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "IsName",
      "label": "Name"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "IsDes",
      "label": "Describe"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "IsSort",
      "label": "Sort"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Operate"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "size": "small"
          },
          on: {
            "click": function($event) {
              return _vm.showUpdatePop(scope.$index, scope.row)
            }
          }
        }, [_vm._v("edit")])]
      }
    }])
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "page-wrap"
  }, [_c('el-pagination', {
    attrs: {
      "current-page": _vm.table.currentPage,
      "page-size": _vm.table.pageSize,
      "layout": "total, prev, pager, next",
      "total": _vm.table.pageTotal
    },
    on: {
      "current-change": _vm.handleTableCurrentChange
    }
  })], 1)]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.page.popShow),
      expression: "page.popShow"
    }],
    staticClass: "field-box scroll-cotar"
  }, [_c('div', {
    staticClass: "page-top-bar cfa"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "rfp"
  }, [_c('el-button', {
    attrs: {
      "size": "small",
      "type": "danger"
    },
    on: {
      "click": function($event) {
        _vm.page.popShow = false
      }
    }
  }, [_vm._v("Close")])], 1)]), _vm._v(" "), _c('IndexConfigSetForm', {
    ref: "popForm",
    on: {
      "addSuccess": _vm.handleAdd,
      "updateSuccess": _vm.handleUpdate
    }
  })], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page-top-bar cfa"
  }, [_c('div', {
    staticClass: "headline lfp"
  }, [_c('span', [_vm._v("Index Config Setting")])]), _vm._v(" "), _c('div', {
    staticClass: "rfp"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "headline lfp"
  }, [_c('span', [_vm._v("setting detail")])])
}]}

/***/ }),
/* 795 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "common-page-main main-page"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.page.popShow),
      expression: "!page.popShow"
    }],
    staticClass: "field-box scroll-cotar"
  }, [_c('div', {
    staticClass: "page-top-bar cfa"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.tree.current),
      expression: "tree.current"
    }],
    staticClass: "rfp"
  }, [(_vm.tree.current !== null && _vm.tree.current.PsType === 3) ? _c('el-button', {
    attrs: {
      "size": "small",
      "icon": "plus",
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.showAddPop()
      }
    }
  }, [_vm._v("add型号")]) : _vm._e()], 1)]), _vm._v(" "), _c('div', {
    staticClass: "content-wrap"
  }, [_c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 5
    }
  }, [_c('div', {
    staticClass: "page-left-wrap"
  }, [_c('div', {
    staticClass: "sub-top-bar cfa"
  }, [_c('div', {
    staticClass: "title lfp"
  }, [_vm._v("Product Type")])]), _vm._v(" "), _c('el-tree', {
    attrs: {
      "data": _vm.tree.data,
      "props": _vm.tree.prop,
      "expand-on-click-node": false,
      "highlight-current": true
    },
    on: {
      "node-click": _vm.clickModuleTree
    }
  })], 1)]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 19
    }
  }, [_c('div', {
    staticClass: "page-right-wrap"
  }, [(_vm.tree.current) ? _c('div', {
    staticClass: "sub-top-bar cfa"
  }, [_c('div', {
    staticClass: "title lfp"
  }, [_vm._v(_vm._s(_vm.tree.current.PsName))])]) : _vm._e(), _vm._v(" "), _c('el-table', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.table.data,
      "element-loading-text": "LOADING"
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "PsmName",
      "label": "type"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "PsmSort",
      "label": "Sort"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Operate"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "size": "small"
          },
          on: {
            "click": function($event) {
              return _vm.showUpdatePop(scope.$index, scope.row)
            }
          }
        }, [_vm._v("edit")]), _vm._v(" "), _c('el-button', {
          attrs: {
            "size": "small"
          },
          on: {
            "click": function($event) {
              return _vm.handleDel(scope.$index, scope.row)
            }
          }
        }, [_vm._v("delete")])]
      }
    }])
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "page-wrap"
  }, [_c('el-pagination', {
    attrs: {
      "current-page": _vm.table.currentPage,
      "page-size": _vm.table.pageSize,
      "layout": "total, prev, pager, next",
      "total": _vm.table.pageTotal
    },
    on: {
      "current-change": _vm.handleTableCurrentChange
    }
  })], 1)], 1)])], 1)], 1)]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "product detail",
      "visible": _vm.page.popShow,
      "size": "tine"
    },
    on: {
      "update:visible": function($event) {
        return _vm.$set(_vm.page, "popShow", $event)
      }
    }
  }, [_c('ProductSSSGTForm', {
    ref: "popForm",
    attrs: {
      "sideCurrent": _vm.tree.current
    },
    on: {
      "addSuccess": _vm.handleAdd,
      "updateSuccess": _vm.handleUpdate
    }
  })], 1)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "headline lfp"
  }, [_c('span', [_vm._v("Conveyor roller model management")])])
}]}

/***/ }),
/* 796 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "width-box w600"
  }, [(_vm.formData) ? _c('el-form', {
    ref: "projectInfoForm",
    staticClass: "pop-form-wrap",
    attrs: {
      "label-width": "100px",
      "model": _vm.formData
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "分类名称",
      "prop": "PtName"
    }
  }, [_c('el-input', {
    attrs: {
      "size": "small"
    },
    model: {
      value: (_vm.formData.PsName),
      callback: function($$v) {
        _vm.$set(_vm.formData, "PsName", $$v)
      },
      expression: "formData.PsName"
    }
  })], 1), _vm._v(" "), _c('el-form-item', [_c('div', {
    staticClass: "pop-center-btn-wrap"
  }, [(!_vm.formData.Id) ? _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.doAdd('projectInfoForm')
      }
    }
  }, [_vm._v("add")]) : _vm._e(), _vm._v(" "), (_vm.formData.Id) ? _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.doUpdate('projectInfoForm')
      }
    }
  }, [_vm._v("save")]) : _vm._e()], 1)])], 1) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 797 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "common-page-main main-page"
  }, [_c('div', {
    staticClass: "field-box"
  }, [_c('div', {
    staticClass: "page-top-bar cfa"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "rfp"
  }, [_c('el-button', {
    attrs: {
      "size": "small",
      "icon": "plus",
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.showAddPop()
      }
    }
  }, [_vm._v("add")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "table-wrap"
  }, [_c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.table.isLoading),
      expression: "table.isLoading"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.table.data,
      "element-loading-text": "LOADING"
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "LbName",
      "label": "Name"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "LbSort",
      "label": "Sort"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Operate"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-dropdown', {
          attrs: {
            "split-button": "",
            "size": "small",
            "type": "primary"
          },
          on: {
            "command": function($event) {
              return _vm.handleTableCommand($event, scope.$index, scope.row)
            },
            "click": function($event) {
              return _vm.showUpdatePop(scope.$index, scope.row)
            }
          }
        }, [_vm._v("\n              edit\n              "), _c('el-dropdown-menu', {
          attrs: {
            "slot": "dropdown"
          },
          slot: "dropdown"
        }, [_c('el-dropdown-item', {
          attrs: {
            "command": "showAddPowerPop"
          }
        }, [_vm._v("Give permission")]), _vm._v(" "), _c('el-dropdown-item', {
          attrs: {
            "command": "handleDel"
          }
        }, [_vm._v("delete")])], 1)], 1)]
      }
    }])
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "page-wrap"
  }, [_c('el-pagination', {
    attrs: {
      "current-page": _vm.table.currentPage,
      "page-size": _vm.table.pageSize,
      "layout": "total, prev, pager, next",
      "total": _vm.table.pageTotal
    },
    on: {
      "current-change": _vm.handleTableCurrentChange
    }
  })], 1)]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "Role Detail",
      "visible": _vm.page.popShow,
      "size": "tine"
    },
    on: {
      "update:visible": function($event) {
        return _vm.$set(_vm.page, "popShow", $event)
      }
    }
  }, [_c('LabelForm', {
    ref: "popForm",
    on: {
      "addSuccess": _vm.handleAdd,
      "updateSuccess": _vm.handleUpdate
    }
  })], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "Permission Setting",
      "visible": _vm.powerPop.show,
      "size": "tine"
    },
    on: {
      "update:visible": function($event) {
        return _vm.$set(_vm.powerPop, "show", $event)
      }
    }
  }, [_c('PowerForm', {
    ref: "powerForm",
    on: {
      "updatePowerSuccess": _vm.updatePowerSuccess
    }
  })], 1)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "headline lfp"
  }, [_c('span', [_vm._v("Role Management")])])
}]}

/***/ }),
/* 798 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "common-page-main main-page"
  }, [_c('div', {
    staticClass: "field-box scroll-cotar"
  }, [_c('div', {
    staticClass: "page-top-bar cfa"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "rfp"
  }, [_c('el-button', {
    attrs: {
      "size": "small",
      "icon": "plus",
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.showAddPop()
      }
    }
  }, [_vm._v("add")]), _vm._v(" "), (_vm.$route.query.code != null) ? _c('el-button', {
    attrs: {
      "size": "small",
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.goBack()
      }
    }
  }, [_vm._v("back")]) : _vm._e()], 1)]), _vm._v(" "), _c('div', {
    staticClass: "table-wrap"
  }, [_c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.table.isLoading),
      expression: "table.isLoading"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.table.data,
      "element-loading-text": "LOADING"
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "DtName",
      "label": "Name"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "DtSort",
      "label": "Sort"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Operate"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "size": "small"
          },
          on: {
            "click": function($event) {
              return _vm.showUpdatePop(scope.$index, scope.row)
            }
          }
        }, [_vm._v("edit")]), _vm._v(" "), _c('el-button', {
          attrs: {
            "size": "small"
          },
          on: {
            "click": function($event) {
              return _vm.SkipNextGrade(scope.$index, scope.row)
            }
          }
        }, [_vm._v("next level")]), _vm._v(" "), _c('copy-btn', {
          attrs: {
            "text": '/Product/ProductDownload/' + scope.row.DtCode
          }
        }, [_vm._v("copy link")]), _vm._v(" "), _c('el-button', {
          attrs: {
            "size": "small"
          },
          on: {
            "click": function($event) {
              return _vm.handleDel(scope.$index, scope.row)
            }
          }
        }, [_vm._v("delete")])]
      }
    }])
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "page-wrap"
  }, [_c('el-pagination', {
    attrs: {
      "current-page": _vm.table.currentPage,
      "page-size": _vm.table.pageSize,
      "layout": "total, prev, pager, next",
      "total": _vm.table.pageTotal
    },
    on: {
      "current-change": _vm.handleTableCurrentChange
    }
  })], 1)]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "Downfile Type Detail",
      "visible": _vm.page.popShow,
      "size": "tine"
    },
    on: {
      "update:visible": function($event) {
        return _vm.$set(_vm.page, "popShow", $event)
      }
    }
  }, [_c('DownfileTypeForm', {
    ref: "popForm",
    on: {
      "addSuccess": _vm.handleAdd,
      "updateSuccess": _vm.handleUpdate
    }
  })], 1)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "headline lfp"
  }, [_c('span', [_vm._v("Down File Type Manage")])])
}]}

/***/ }),
/* 799 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "common-page-main main-page"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.page.popShow),
      expression: "!page.popShow"
    }],
    staticClass: "field-box scroll-cotar"
  }, [_c('div', {
    staticClass: "page-top-bar cfa"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.tree.current),
      expression: "tree.current"
    }],
    staticClass: "rfp"
  }, [_c('el-button', {
    attrs: {
      "size": "small",
      "icon": "plus",
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.showAddPop()
      }
    }
  }, [_vm._v("Add Staffmien")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "content-wrap"
  }, [_c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 4
    }
  }, [_c('div', {
    staticClass: "sub-top-bar cfa"
  }, [_c('div', {
    staticClass: "title lfp"
  }, [_vm._v("Staffmien Type")])]), _vm._v(" "), _c('div', {
    staticClass: "page-left-wrap"
  }, [_c('el-tree', {
    attrs: {
      "data": _vm.tree.data,
      "props": _vm.tree.prop,
      "expand-on-click-node": false,
      "highlight-current": true,
      "default-expand-all": true
    },
    on: {
      "node-click": _vm.clickModuleTree
    }
  })], 1)]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 20
    }
  }, [_c('div', {
    staticClass: "page-right-wrap"
  }, [(_vm.tree.current) ? _c('div', {
    staticClass: "sub-top-bar cfa"
  }, [_c('div', {
    staticClass: "title lfp"
  }, [_vm._v(_vm._s(_vm.tree.current.StName))])]) : _vm._e(), _vm._v(" "), _c('el-table', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.table.data,
      "element-loading-text": "LOADING"
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "SiName",
      "label": "Name"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "SiSort",
      "label": "Sort"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "SiRead",
      "label": "ReadNum"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Operate"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "size": "small"
          },
          on: {
            "click": function($event) {
              return _vm.showUpdatePop(scope.$index, scope.row)
            }
          }
        }, [_vm._v("edit")]), _vm._v(" "), _c('el-button', {
          attrs: {
            "size": "small"
          },
          on: {
            "click": function($event) {
              return _vm.handleDel(scope.$index, scope.row)
            }
          }
        }, [_vm._v("delete")])]
      }
    }])
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "page-wrap"
  }, [_c('el-pagination', {
    attrs: {
      "current-page": _vm.table.currentPage,
      "page-size": _vm.table.pageSize,
      "layout": "total, prev, pager, next",
      "total": _vm.table.pageTotal
    },
    on: {
      "current-change": _vm.handleTableCurrentChange
    }
  })], 1)], 1)])], 1)], 1)]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.page.popShow),
      expression: "page.popShow"
    }],
    staticClass: "field-box scroll-cotar"
  }, [_c('div', {
    staticClass: "page-top-bar cfa"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "rfp"
  }, [_c('el-button', {
    attrs: {
      "size": "small",
      "type": "danger"
    },
    on: {
      "click": function($event) {
        _vm.page.popShow = false
      }
    }
  }, [_vm._v("Close")])], 1)]), _vm._v(" "), _c('StaffmienForm', {
    ref: "popForm",
    attrs: {
      "sideCurrent": _vm.tree.current
    },
    on: {
      "addSuccess": _vm.handleAdd,
      "updateSuccess": _vm.handleUpdate
    }
  })], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "headline lfp"
  }, [_c('span', [_vm._v("Staffmien Management")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "headline lfp"
  }, [_c('span', [_vm._v("Staffmien Detail")])])
}]}

/***/ }),
/* 800 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "welcome-page common-page-main main-page"
  }, [_c('div', {
    staticClass: "field-box content-wrap scroll-cotar"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "quick-nav"
  }, [_c('div', {
    staticClass: "nav-list"
  }, [_c('el-row', {
    attrs: {
      "gutter": 10
    }
  }, _vm._l((_vm.menuNav), function(item, i) {
    return _c('el-col', {
      key: i,
      attrs: {
        "span": 4
      }
    }, [_c('router-link', {
      staticClass: "item",
      attrs: {
        "to": item.MoUrl
      }
    }, [_c('div', {
      staticClass: "vm-cotar"
    }, [_vm._v(_vm._s(item.MoName))])])], 1)
  }), 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "contact-info-wrap"
  }, [_c('table', {
    staticClass: "contact-info-tab"
  }, [_c('tbody', {
    staticClass: "contact-info"
  }, [_c('WelcomeForm', {
    ref: "popForm",
    on: {
      "updateSuccess": _vm.handleUpdate
    }
  })], 1)])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "top-bar"
  }, [_vm._v("\n      Note! The system browser is recommended to run: IE9 or more:\n      "), _c('a', {
    staticClass: "down-link",
    attrs: {
      "href": "https://www.baidu.com/link?url=4eO8r116y7VARgZMmtD5BCAEp06bHehAK4a9m2l_BDgmyJxkTfv8NEDDwhN797O4CE86SCEJwoYmOrHIhVTSi359id0geXzoDsPdRuVe09C&wd=&eqid=d3c069f80002a6d9000000035719f91e",
      "target": "_blank"
    }
  }, [_vm._v("Google Chrome ,")]), _vm._v(" "), _c('a', {
    staticClass: "down-link",
    attrs: {
      "href": "https://www.baidu.com/link?url=dUrZ_7TO3Aw0T7Li31vES6hcLmjkP7DxhF3pKLSxClhR7R4FX16LLdPqaR6wGCjugB_EgBgh5Pfh8UPreifyDBgi-LB3JBr5n4yH1vaS9ty&wd=&eqid=e3103e1b00001f250000000359bfca00",
      "target": "_blank"
    }
  }, [_vm._v("Firefox browser")]), _vm._v("\n      In order to achieve the best operating results\n    ")])
}]}

/***/ }),
/* 801 */,
/* 802 */,
/* 803 */,
/* 804 */,
/* 805 */,
/* 806 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./index.js": 151,
	"./user.js": 248
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 806;

/***/ }),
/* 807 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(216);
module.exports = __webpack_require__(215);


/***/ })
],[807]);


// WEBPACK FOOTER //
// static/js/app.2e449ce3e6529f98974b.js